/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	__webpack_require__.p = typeof window !== 'undefined' && window.__STATICS_BASE_URL__ || __webpack_require__.p;
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 413);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = React;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(17);
var isBuffer = __webpack_require__(40);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object' && !isArray(obj)) {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(5);

Object.defineProperty(exports, 'utils', {
  enumerable: true,
  get: function get() {
    return _utils.utils;
  }
});

var _biLogger = __webpack_require__(30);

Object.defineProperty(exports, 'logger', {
  enumerable: true,
  get: function get() {
    return _biLogger.logger;
  }
});

var _itemActions = __webpack_require__(57);

Object.defineProperty(exports, 'itemActions', {
  enumerable: true,
  get: function get() {
    return _itemActions.itemActions;
  }
});

var _sampleImages = __webpack_require__(66);

Object.defineProperty(exports, 'sampleImages', {
  enumerable: true,
  get: function get() {
    return _sampleImages.sampleImages;
  }
});
Object.defineProperty(exports, 'emptyImages', {
  enumerable: true,
  get: function get() {
    return _sampleImages.emptyImages;
  }
});

var _translationUtils = __webpack_require__(31);

Object.defineProperty(exports, 'TranslationUtil', {
  enumerable: true,
  get: function get() {
    return _translationUtils.TranslationUtil;
  }
});

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(34);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  typeof document.createElement -> undefined
 */
function isStandardBrowserEnv() {
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined' &&
    typeof document.createElement === 'function'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object' && !isArray(obj)) {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = _;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.utils = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(4);

var _ = _interopRequireWildcard(_lodash);

var _urijs = __webpack_require__(25);

var _urijs2 = _interopRequireDefault(_urijs);

var _axios = __webpack_require__(16);

var _axios2 = _interopRequireDefault(_axios);

var _watermarkApi = __webpack_require__(12);

var _watermarkApi2 = _interopRequireDefault(_watermarkApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Utils = function () {
  /* @ngInject */
  function Utils() {
    var _this = this;

    _classCallCheck(this, Utils);

    this.data = {
      set: function set(key, value) {
        var dataKey = _this.dataPublicKey(key);
        return new Promise(function (resolve, reject) {
          return Wix.Data.Public.set(dataKey, value, { scope: 'APP' }, function (data) {
            return resolve(data.dataKey);
          }, function (err) {
            return reject(err);
          });
        });
      },
      get: function get(key) {
        var dataKey = _this.dataPublicKey(key);
        return new Promise(function (resolve, reject) {
          return Wix.Data.Public.get(dataKey, { scope: 'APP' }, function (data) {
            return resolve(data.dataKey);
          }, function (err) {
            return reject(err);
          });
        });
      }
    };

    this.gallerySettings = function () {
      var baseUrl = window.location.protocol + '//progallery.wix.com/_api/pro-gallery-editor-webapp/v1/gallery/';
      var getGallerySettingsApi = function getGallerySettingsApi() {
        return '' + baseUrl + window['galleryId'] + '?instance=' + window['instance'] + '&isStore=' + _this.isStoreGallery();
      };

      return {
        get: function get(key) {
          return _axios2.default.get(getGallerySettingsApi(), { withCredentials: true, xsrfCookieName: null }).then(function (_ref) {
            var data = _ref.data;

            return key ? data.settings[key] : data.settings;
          });
        },
        set: function set(key, value) {
          return _this.gallerySettings.get().then(function (data) {
            data = data || {};
            var settings = Object.assign(data, _defineProperty({}, key, value));
            return _axios2.default.put(getGallerySettingsApi(), { settings: settings }, { withCredentials: true, xsrfCookieName: null }).then(function () {
              return _this.setExternalId();
            });
          });
        }
      };
    }();

    this._cache = {};
    this._refs = {};
    this._params = {};
    this.CONST_ADI_SUPPORT_WIDGET_CODE = '63ff21be-9556-4f52-9ac9-4d441bd3dae4';
    this.CONST_EDITOR_WIDGET_CODE = 'cb6480f3-768b-4737-ab8f-10fe2e4fa2ab';

    this.openManagePhotos = this.openManagePhotos.bind(this);

    try {
      document.domain = 'wix.com';
    } catch (e) {
      // console.warn('failed to set domain');
    }
  }

  _createClass(Utils, [{
    key: 'getOrPutFromCache',
    value: function getOrPutFromCache(fld, func) {
      if (this._cache[fld] !== undefined) {
        return this._cache[fld];
      }
      this._cache[fld] = func();
      return this._cache[fld];
    }
  }, {
    key: 'isInWix',
    value: function isInWix() {
      if (this.isSemiNative()) {
        return false;
      }
      return this.getOrPutFromCache('isInWix', function () {
        return top !== self && document.location.search.indexOf('instance=') >= 0;
      });
    }
  }, {
    key: 'hashToInt',
    value: function hashToInt(str) {
      var hash = 0;

      if (_.isUndefined(str) || str.length === 0) {
        return hash;
      }
      for (var i = 0; i < str.length; i++) {
        hash += str.charCodeAt(i);
      }
      return hash;
    }
  }, {
    key: 'isDemo',
    value: function isDemo() {
      return this.parseGetParam('demo') === '1';
    }
  }, {
    key: 'addItemHashParam',
    value: function addItemHashParam(baseUrl, photoId) {

      var curParamsIndex = baseUrl.indexOf('pro-gallery-item=');
      if (curParamsIndex > 0) {
        baseUrl = baseUrl.substr(0, baseUrl.indexOf('pro-gallery-item=') - 1);
      }

      var prefix = '';

      var hashPart = baseUrl.split('#')[1];
      if (hashPart || hashPart == '') {
        var hasQuestionMark = hashPart.split('?')[1];
        if (hasQuestionMark) {
          prefix = '&';
        } else {
          prefix = '?';
        }
      } else {
        prefix = '#?';
      }

      return baseUrl + prefix + 'pro-gallery-item=' + photoId;
    }
  }, {
    key: 'removeItemHashParam',
    value: function removeItemHashParam(baseUrl) {
      var itemPart = baseUrl.indexOf('pro-gallery-item=');
      //remove anything after the hash
      var newUrl = baseUrl.substr(0, itemPart > 0 ? itemPart - 1 : baseUrl.length);
      newUrl += newUrl.indexOf('#') > 0 ? '' : '#';
      return newUrl;
    }
  }, {
    key: 'parsePathParam',
    value: function parsePathParam(val) {
      var path = location.pathname;
      var pathArr = path.split('/');
      for (var i = 0; i < pathArr.length; i++) {
        var param = pathArr[i];
        if (param.indexOf(val) >= 0) {
          return param;
        }
      }
      return '';
    }
  }, {
    key: 'parseGetParam',
    value: function parseGetParam(val, url) {

      if (!_.isUndefined(this._params[val])) {
        return this._params[val];
      }

      var result = '',
          tmp = [];

      var _location = location;

      if (url) {
        _location = {
          search: '?' + (url.split('?')[1] || ''),
          pathname: (url.split('?')[0] || '').split('/')[1] || ''
        };
      }

      _location.search
      //.replace ( "?", "" )
      // this is better, there might be a question mark inside
      .substr(1).split('&').forEach(function (item) {
        tmp = item.split('=');
        if (tmp[0] === val) {
          result = decodeURIComponent(tmp[1]);
        }
      });

      if (!result) {

        //if the param was not found in the search, try decoding the path
        var query = decodeURIComponent(_location.pathname).split('?')[1];
        if (!query) {
          return '';
        }

        query.split('&').forEach(function (item) {
          tmp = item.split('=');
          if (tmp[0] === val) {
            result = decodeURIComponent(tmp[1]);
          }
        });
      }

      this._params[val] = result;

      return result;
    }
  }, {
    key: 'parseHashParam',
    value: function parseHashParam(val) {
      var result = '';
      var tmp = [];
      var hashPart = location.href.split('#')[1] || '';

      if (!hashPart) {
        return '';
      }

      hashPart
      //.replace ( "?", "" )
      // this is better, there might be a question mark inside
      .substr(1).split('&').forEach(function (item) {
        tmp = item.split('=');
        if (tmp[0] === val) {
          result = decodeURIComponent(tmp[1]);
        }
      });
      return result;
    }
  }, {
    key: 'stripSlashes',
    value: function stripSlashes(str) {
      var newStr = '';
      if (typeof str == 'string') {
        newStr = str.replace(/\\\//g, '/').replace(/\\'/g, '\'').replace(/\\"/g, '"').replace(/\\0/g, '\0').replace(/\\\\/g, '\\');
      }
      return newStr;
    }
  }, {
    key: 'isSmallScreen',
    value: function isSmallScreen() {
      return window.innerWidth < 640 || this.isMobile();
    }
  }, {
    key: 'isVerticalScreen',
    value: function isVerticalScreen() {
      return window.innerWidth < window.innerHeight;
    }
  }, {
    key: 'getDevicePixelRatio',
    value: function getDevicePixelRatio() {
      return window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI; // Support for IE10
    }
  }, {
    key: 'isWixMobile',
    value: function isWixMobile() {
      var _this2 = this;

      var _isWixMobile = function _isWixMobile() {
        var deviceType = _this2.parseGetParam('deviceType');
        if (deviceType) {
          return String(deviceType).indexOf('mobile') >= 0;
        } else {
          return undefined;
        }
      };

      if (!this.isSite()) {
        return _isWixMobile();
      } else {
        return this.getOrPutFromCache('isWixMobile', _isWixMobile);
      }
    }
  }, {
    key: 'getDeviceType',
    value: function getDeviceType() {
      return this.isWixMobile() ? 'mobile' : 'desktop';
    }
  }, {
    key: 'isUserAgentMobile',
    value: function isUserAgentMobile() {

      var _isUserAgentMobile = function _isUserAgentMobile() {
        var check = false;
        (function (a) {
          if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|pixel|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
            check = true;
          }
        })(navigator.userAgent || navigator.vendor || window['opera']);
        return check;
      };

      if (!this.isSite()) {
        return _isUserAgentMobile();
      } else {
        return this.getOrPutFromCache('isUserAgentMobile', _isUserAgentMobile);
      }
    }
  }, {
    key: 'isMobile',
    value: function isMobile() {
      var _this3 = this;

      if (this.isSemiNative()) {
        return false;
      }

      var _isMobile = function _isMobile() {
        var isWixMobile = _this3.isWixMobile();
        var isUserAgentMobile = _this3.isUserAgentMobile();

        return _.isUndefined(isWixMobile) ? isUserAgentMobile : isWixMobile;
      };

      if (!this.isSite()) {
        return _isMobile();
      } else {
        return this.getOrPutFromCache('isMobile', _isMobile);
      }
    }
  }, {
    key: 'isMobileViewer',
    value: function isMobileViewer() {
      if (this.isSite() && !_.isUndefined(this._cache.isMobileViewer)) {
        return this._cache.isMobileViewer;
      }

      var isWixMobile = this.isWixMobile();
      var isUserAgentMobile = this.isUserAgentMobile();

      this._cache.isMobileViewer = isWixMobile && !isUserAgentMobile;
      return this._cache.isMobileViewer;
    }
  }, {
    key: 'isiOS',
    value: function isiOS() {
      return this.getOrPutFromCache('isiOS', function () {
        return (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window['MSStream']
        );
      });
    }
  }, {
    key: 'isiPhone',
    value: function isiPhone() {
      return this.getOrPutFromCache('isiPhone', function () {
        return (/iPhone/.test(navigator.userAgent) && !window['MSStream']
        );
      });
    }
  }, {
    key: 'isTouch',
    value: function isTouch() {
      return this.getOrPutFromCache('isTouch', function () {
        return 'ontouchstart' in document.documentElement;
      });
    }
  }, {
    key: 'browserIs',
    value: function browserIs(browserName) {

      if (_.isUndefined(this._cache.browsers)) {

        var browsers = {
          chrome: false,
          chromeIos: false,
          explorer: false,
          firefox: false,
          safari: false,
          opera: false
        };

        browsers.chrome = navigator.userAgent.indexOf('Chrome') > -1;
        browsers.chromeIos = navigator.userAgent.indexOf('CriOS') > -1;
        browsers.explorer = navigator.userAgent.indexOf('MSIE') > -1 || !!navigator.userAgent.match(/Trident.*rv\:11\./); // support for edge
        browsers.firefox = navigator.userAgent.indexOf('Firefox') > -1;
        browsers.safari = navigator.userAgent.indexOf('Safari') > -1;
        browsers.opera = navigator.userAgent.toLowerCase().indexOf('op') > -1;

        if (browsers.chrome && browsers.safari) {
          browsers.safari = false;
        }

        if (browsers.chrome && browsers.opera) {
          browsers.chrome = false;
        }

        this._cache.browsers = browsers;
      }

      return this._cache.browsers[browserName];
    }
  }, {
    key: 'deviceHasMemoryIssues',
    value: function deviceHasMemoryIssues() {
      return this.isiOS();
    }
  }, {
    key: 'getUrlPrefix',
    value: function getUrlPrefix(forceProduction) {
      return window.location.protocol + '//' + (!forceProduction && this.isLocal() ? 'local.wix.com:3001' : 'progallery.wix.com') + '/';
    }
  }, {
    key: 'getFullscreenSectionId',
    value: function getFullscreenSectionId() {
      var isStore = this.isStoreGallery();
      return isStore ? 'fullscreen_store_page' : 'fullscreen_page';
    }
  }, {
    key: 'getApiUrlPrefix',
    value: function getApiUrlPrefix() {
      return this.getUrlPrefix(true) + 'api/v1/';
    }
  }, {
    key: 'generateUrl',
    value: function generateUrl(endpointFile, params) {
      params = params || {};
      var isStore = this.isStoreGallery();
      var url = this.getUrlPrefix() + endpointFile;
      var uri = new _urijs2.default(url);

      if (isStore) {
        params['isStore'] = true;
      }

      uri.search(params);
      return uri.toString();
    }
  }, {
    key: 'getManageMediaUrl',
    value: function getManageMediaUrl() {
      return this.generateUrl('photos.html');
    }
  }, {
    key: 'getExpandSettingsUrl',
    value: function getExpandSettingsUrl() {
      return this.generateUrl('settings-expand.html');
    }
  }, {
    key: 'getSettingsWatermarkDisableUrl',
    value: function getSettingsWatermarkDisableUrl() {
      return this.generateUrl('settings-watermark-disable.html');
    }
  }, {
    key: 'getSettingsAddonsUrl',
    value: function getSettingsAddonsUrl() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return this.generateUrl('settings-addons.html', params);
    }
  }, {
    key: 'getProviderModalUrl',
    value: function getProviderModalUrl() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return this.generateUrl('provider-modal.html', params);
    }
  }, {
    key: 'isTest',
    value: function isTest() {
      //the test driver will override this method to set it to true;
      return false;
    }
  }, {
    key: 'isSemiNative',
    value: function isSemiNative() {
      return window['semiNative'];
    }
  }, {
    key: 'isDev',
    value: function isDev() {
      if (this.isSemiNative()) {
        return true;
      }

      var ipRegex = /([0-9]{1,3}\.){3}[0-9]{1,3}:[0-9]{1,5}/; //matches 111.222.333.444:9999
      var isDev = this.isLocal();

      if (!_.isUndefined(this._cache.isDev)) {
        return this._cache.isDev;
      }

      isDev = isDev || this.shouldDebug('ph_local');
      isDev = isDev || this.parseGetParam('debug') == 'true';
      isDev = isDev || (this.safeLocalStorage() || {})['forceDevMode'] == 'true';
      this._cache.isDev = isDev;
      return isDev;
    }
  }, {
    key: 'isVerbose',
    value: function isVerbose() {
      return (this.safeLocalStorage() || {})['forceDevMode'] == 'true';
    }
  }, {
    key: 'isLocal',
    value: function isLocal() {
      var ipRegex = /([0-9]{1,3}\.){3}[0-9]{1,3}:[0-9]{1,5}/; //matches 111.222.333.444:9999
      var isLocal = false;

      if (!_.isUndefined(this._cache.isLocal)) {
        return this._cache.isLocal;
      }
      var host = window.location.hostname;
      isLocal = isLocal || host == 'local.wix.com';
      isLocal = isLocal || host.indexOf('localhost') >= 0;
      isLocal = isLocal || ipRegex.exec(host) !== null;
      this._cache.isLocal = isLocal;
      return isLocal;
    }
  }, {
    key: 'getViewModeFromCache',
    value: function getViewModeFromCache() {
      return this.getOrPutFromCache('viewMode', function () {
        try {
          return Wix && Wix.Utils && Wix.Utils.getViewMode();
        } catch (e) {
          return false;
        }
      });
    }
  }, {
    key: 'updateViewMode',
    value: function updateViewMode() {
      //NOTICE: this method must be called after each EDIT_MODE_CHANGED event to clear the cache
      if (Wix.Utils) {
        this._cache.viewMode = Wix.Utils.getViewMode();
        return this._cache.viewMode;
      }
    }
  }, {
    key: 'isEditor',
    value: function isEditor() {
      if (!this.isInWix()) {
        return false;
      }
      return this.getViewModeFromCache() == 'editor';
    }
  }, {
    key: 'isPreview',
    value: function isPreview() {
      if (!this.isInWix()) {
        return false;
      }
      return this.getViewModeFromCache() == 'preview';
    }
  }, {
    key: 'isPlayground',
    value: function isPlayground() {
      if (this.isInWix()) {
        return false;
      }

      var isPlayground = false;
      try {
        isPlayground = top.location.href.indexOf('playground.html') > 0;
      } catch (e) {
        isPlayground = false;
      }

      return isPlayground;
    }
  }, {
    key: 'isSite',
    value: function isSite() {
      return !this.isPlayground() && !this.isEditor() && !this.isPreview();
    }

    //isWixDomain() {
    //  return window.location.href.indexOf('wix.com') >= 0;
    //}

  }, {
    key: 'getUUID',
    value: function getUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
    }
  }, {
    key: 'setExternalId',
    value: function setExternalId() {
      var _this4 = this;

      var uuid = this.getUUID();
      Wix.Settings.setExternalId(uuid, function (success) {
        _this4.isDev() && console.log('Utils setExternalId - success', uuid, success);
      }, function (error) {
        _this4.isDev() && console.log('Utils setExternalId - fail', uuid, error);
      });
    }
  }, {
    key: 'hexToRgba',
    value: function hexToRgba(hex, opacity) {
      hex = hex.replace('#', '');
      var r = parseInt(hex.substring(0, 2), 16);
      var g = parseInt(hex.substring(2, 4), 16);
      var b = parseInt(hex.substring(4, 6), 16);

      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + opacity + ')';
    }
  }, {
    key: 'setStateAndLog',
    value: function setStateAndLog(that, caller, state, callback) {
      var _this5 = this;

      if (this.isVerbose()) {
        //todo yoshi
        console.log('State Change Called (' + caller + ')', state);
        var oldState = _.clone(that.state);
        that['setState'](state, function () {
          var newState = _.clone(that.state);
          var change = _this5.printableObjectsDiff(oldState, newState, 'state');
          if (_.keys(change).length > 0) {
            console.log('State Change Completed (' + caller + ')', change);
          }
          if (_.isFunction(callback)) {
            callback.bind(that)();
          }
        });
      } else {
        that['setState'](state, function () {
          if (_.isFunction(callback)) {
            callback.bind(that)();
          }
        });
      }
    }
  }, {
    key: 'printableObjectsDiff',
    value: function printableObjectsDiff(obj1, obj2) {
      var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';


      var toString = function toString(v) {
        if (v == '') {
          v = '\'\'';
        } else if (_.isUndefined(v)) {
          v = 'undefined';
        }
        return _.toString(v);
      };

      var getInnerDiff = function getInnerDiff(obj1, obj2, prefix) {
        var innerDiff = _.reduce(obj1, function (res, v, k) {
          if (!_.isEqual(v, obj2[k])) {
            if (_.isArray(obj2[k])) {
              if (v.length != obj2[k].length) {
                res[k + '.length'] = '[' + v.length + '] => [' + obj2[k].length + ']';
              }
              res = _.merge(res, getInnerDiff(v, obj2[k], (prefix ? prefix + '.' : '') + k));
            } else if (_.isObject(obj2[k])) {
              res = _.merge(res, getInnerDiff(v, obj2[k], (prefix ? prefix + '.' : '') + k));
            } else {
              res[(prefix ? prefix + '.' : '') + k] = toString(v) + ' => ' + toString(obj2[k]);
            }
          }
          return res;
        }, {});
        return innerDiff;
      };

      return getInnerDiff(obj1, obj2, prefix);
    }
  }, {
    key: 'getWindow',
    value: function getWindow(windowName, verifyParam, compId, instanceId) {
      if (!_.isUndefined(this._refs[windowName])) {
        var cacheWindow = this._refs[windowName];
        if (cacheWindow && cacheWindow.location && cacheWindow.location.href) {
          return this._refs[windowName];
        } else {
          this._refs[windowName] = null;
        }
      }

      for (var d = 0; d < window.parent.frames.length; d++) {
        var frame = window.parent.frames[d];
        try {
          var found = false;
          try {
            if (frame[verifyParam]) {
              found = true;
            }
          } catch (e) {
            // console.warn('couldn\'t access frame', windowName, {d, e});
          }
          if (found) {
            //check if this is the window
            this._refs[windowName] = frame;
            break;
          } else {
            //check if one of this window's children is the one (e.g. when accessing the worker from the settings, the worker is inside the editor's iframe)
            var frames = [];
            if (compId) {
              if (frame.document.getElementById(compId)) {
                frames = frame.document.getElementById(compId).getElementsByTagName('iframe');
              }
            } else {
              frames = frame.document.getElementsByTagName('iframe');
            }

            for (var f = 0; f < frames.length; f++) {
              try {
                var subFrame = frames[f]['contentWindow'];
                if (subFrame[verifyParam]) {
                  // console.log('comparing ', instanceId, subFrame.instanceId);
                  if (!instanceId || subFrame.instanceId === instanceId) {
                    //check if this is the window
                    this._refs[windowName] = subFrame;
                    break;
                  }
                }
              } catch (e) {
                // console.warn('catch frame ', windowName, {d, f, e});
              }
            }
            if (this._refs[windowName]) {
              break;
            }
          }
        } catch (e) {
          // console.warn('catch frame ', windowName, {d, e});
        }
      }

      if (_.isUndefined(this._refs[windowName])) {
        if (this.isVerbose()) {
          console.log('Window ' + windowName + ' not found - using sessionStorage');
        }
        return this.safeSessionStorage();
      }

      return this._refs[windowName];
    }
  }, {
    key: 'getWorkerWindow',
    value: function getWorkerWindow() {
      if (this.isSemiNative()) {
        return [];
      }
      return this.getWindow('worker', 'isWorker');
    }
  }, {
    key: 'getMultishareWindow',
    value: function getMultishareWindow() {
      return this.getWindow('multishare', 'isMultishare');
    }
  }, {
    key: 'getGalleryWindow',
    value: function getGalleryWindow(compId, instanceId) {
      return this.getWindow('gallery', 'isGallery', compId, instanceId);
    }
  }, {
    key: 'getGalleryByCompId',
    value: function getGalleryByCompId(compId) {
      if (_.isUndefined(this._cache.galleries)) {
        this._cache.galleries = {};
      }

      //todo - caching of galleries removed because in some cases it made the window stay at a old version
      //e.g. - adding an image to the gallery (after fullscreen was already opened) and reopening it

      //if (!_.isUndefined(this._cache.galleries[compId])) {
      //  return this._cache.galleries[compId];
      //}

      for (var d = 0; d < window.parent.frames.length; d++) {
        try {
          var frame = window.parent.frames[d];
          if (frame['isGallery'] === true || frame.document.location.href.indexOf(this.getUrlPrefix() + 'gallery') >= 0) {
            if (frame.document.location.href.indexOf('compId=' + compId) >= 0) {
              // console.warn('got gallery by compId', compId, frame, frame['proGalleryWidget']);
              this._cache.galleries[compId] = frame;
            }
          }
        } catch (e) {
          //console.log('catch frame'+ d);
        }
      }
      return this._cache.galleries[compId];
    }
  }, {
    key: 'safeLocalStorage',
    value: function safeLocalStorage() {
      try {
        return localStorage;
      } catch (e) {
        return window;
      }
    }
  }, {
    key: 'safeSessionStorage',
    value: function safeSessionStorage() {
      try {
        return sessionStorage;
      } catch (e) {
        return window;
      }
    }
  }, {
    key: 'getLocalStorage',
    value: function getLocalStorage() {
      if (this.isDev()) {
        return this.getWorkerWindow();
      } else {
        var _localStorage = this.safeLocalStorage();
        return _localStorage || this.getWorkerWindow();
      }
    }
  }, {
    key: 'getViewportScaleRatio',
    value: function getViewportScaleRatio() {
      //320 is a hack for wix - they have fixed viewport of 320 pixels regardlessof phone type
      if (this.isMobile() && !this.isMobileViewer() && this.isSite()) {
        return 320 / this.getScreenWidth();
      } else {
        return 1;
      }
    }
  }, {
    key: 'isLandscape',
    value: function isLandscape() {
      if (this.isSemiNative()) {
        return false;
      }
      if (!_.isUndefined(this._cache.isLandscape)) {
        return this._cache.isLandscape;
      }
      if (!this.isMobile()) {
        this._cache.isLandscape = false;
      }
      if (!_.isUndefined(window.orientation)) {
        this._cache.isLandscape = window.orientation == 90 || window.orientation == -90;
      } else {
        var mql = window.matchMedia('(orientation: landscape)');
        if (mql && mql.matches == true) {
          this._cache.isLandscape = true;
        } else {
          this._cache.isLandscape = false;
        }
      }
      return this._cache.isLandscape;
    }
  }, {
    key: 'getScreenWidth',
    value: function getScreenWidth() {
      if (this.isSemiNative()) {
        return 1920;
      }
      if (this.isLandscape()) {
        return Math.max(window.screen.width, window.screen.height);
      } else {
        return window.screen.width;
      }
    }
  }, {
    key: 'getScreenHeight',
    value: function getScreenHeight() {
      if (this.isSemiNative()) {
        return 1200;
      }
      if (this.isLandscape()) {
        return Math.min(window.screen.width, window.screen.height);
      } else {
        return window.screen.height;
      }
    }
  }, {
    key: 'fixViewport',
    value: function fixViewport(pageName) {
      if (this.isSemiNative()) {
        return;
      }
      this._cache.isLandscape = undefined;
      if (this.isSite() && this.isMobile() && !this.isMobileViewer()) {
        //using isUserAgentMobile creates a bug in mobile view when configured to show desktop on mobile (so isWixMobile is false)
        if (this.isDev()) {
          console.log(pageName + ' BEFORE: Screen width: ' + window.screen.width);
          console.log(pageName + ' BEFORE: window.innerWidth: ' + window.innerWidth);
          console.log(pageName + ' BEFORE: document.body.clientWidth: ' + document.body.clientWidth);
        }

        var viewportAspectRatio = 320 / this.getScreenWidth();
        document.body.style.transform = 'scale(' + viewportAspectRatio + ')';
        document.body.style.transformOrigin = '0 0';
        document.body.style.width = 100 / viewportAspectRatio + '%';
        document.body.style.height = 100 / viewportAspectRatio + '%';
        //(<any>document.getElementsByTagName('html')[0]).style.transform = 'scale(' + viewportAspectRatio + ')';
        //(<any>document.getElementsByTagName('html')[0]).style.transformOrigin = '0 0';
        //(<any>document.getElementsByTagName('html')[0]).style.width = Math.round(100 / viewportAspectRatio) + '%';
        //(<any>document.getElementsByTagName('html')[0]).style.height = Math.round(100 / viewportAspectRatio) + '%';

        if (this.isDev()) {
          console.log(pageName + ' AFTER: Screen width: ' + window.screen.width);
          console.log(pageName + ' AFTER: window.innerWidth: ' + window.innerWidth);
          console.log(pageName + ' AFTER: document.body.clientWidth: ' + document.body.clientWidth);
        }
      }
    }
  }, {
    key: 'getTopUrlParam',
    value: function getTopUrlParam(name) {
      if (_.isUndefined(this._cache.params)) {
        this._cache.params = {};
      }
      if (_.isUndefined(this._cache.params[name])) {
        try {
          this._cache.params[name] = top.location.search.replace('?', '').split('&').map(function (ele) {
            var arr = ele.split('=');
            return arr[0] == name ? arr[1] || '' : '';
          }).join('');
        } catch (e) {
          this._cache.params[name] = false;
          // console.log('caught cross origin error');
          //comment to avoid 'block is empty' from linter
        }
      }
      return this._cache.params[name];
    }
  }, {
    key: 'debounceWithContext',
    value: function debounceWithContext(context, debouncedFunction) {
      var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;

      return _.bind(_.debounce(debouncedFunction, delay), context);
    }
  }, {
    key: 'openModalImp',
    value: function openModalImp(url) {
      var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '100%';
      var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '100%';
      var onClose = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _.noop;

      return new Promise(function (resolve, reject) {
        Wix.Settings.openModal(url, width, height, undefined, function () {
          onClose();
          resolve();
        }, true, { overlay: 'rgba(0,0,0,0)', background: 'rgba(0,0,0,0)', margin: false });
      });
    }
  }, {
    key: 'isStoreGallery',
    value: function isStoreGallery() {
      var _this6 = this;

      return this.getOrPutFromCache('isStoreGallery', function () {
        if (_this6.isSemiNative()) {
          return false;
        }

        try {
          return window.location.search.toLowerCase().indexOf('isstore') > -1;
        } catch (e) {
          if (_this6.isDev()) {
            console.error('cant find window', e);
          }
          return false;
        }
      });
    }
  }, {
    key: 'openManagePhotos',
    value: function openManagePhotos() {
      return this.openModalImp(this.getManageMediaUrl());
    }
  }, {
    key: 'openExpandSettings',
    value: function openExpandSettings() {
      this.openModalImp(this.getExpandSettingsUrl());
    }
  }, {
    key: 'openSettingsWatermarkDisableDialog',
    value: function openSettingsWatermarkDisableDialog(callback) {
      Wix.Settings.openModal(this.getSettingsWatermarkDisableUrl(), 612, 281, undefined, callback, true);
    }
  }, {
    key: 'openSettingsAddonsUrl',
    value: function openSettingsAddonsUrl(params, callback) {
      Wix.Settings.openModal(this.getSettingsAddonsUrl(params), 736, 281, undefined, callback, true);
    }
  }, {
    key: 'findFontsHrefs',
    value: function findFontsHrefs() {
      try {
        var isFontHref = function isFontHref(x) {
          return x.toLowerCase().includes('font');
        };

        return Array.from(top.document.styleSheets).map(function (styleSheet) {
          return styleSheet.href;
        }).filter(function (href) {
          return href != null;
        }).filter(isFontHref);
      } catch (e) {
        // console.warn('could not find fonts hrefs', e);
        return [];
      }
    }
  }, {
    key: 'isOnBoarding',
    value: function isOnBoarding() {
      var isOnBoarding = false;

      if (_urijs2.default) {
        var params = new _urijs2.default(window.location.href).query(true);
        isOnBoarding = params.viewMode && params.viewMode.toLowerCase() === 'onboarding';
      }

      return isOnBoarding;
    }
  }, {
    key: 'getSupportLink',
    value: function getSupportLink(progalleryLinks, storeLinks) {
      var editorArticleId = void 0,
          onBoardingArticleId = void 0;
      editorArticleId = this.isStoreGallery() ? storeLinks ? storeLinks[0] : progalleryLinks[0] : progalleryLinks[0];
      onBoardingArticleId = this.isStoreGallery() ? storeLinks ? storeLinks[1] : progalleryLinks[1] : progalleryLinks[1];
      var articleUrl = '';
      var isOnboarding = this.isOnBoarding() || !editorArticleId;
      if (editorArticleId || onBoardingArticleId) {
        var widgetCode = '';
        var articleId = '';
        var subDomain = 'support';

        var isOnBoardingReallyExists = isOnboarding && onBoardingArticleId;
        var hasOnBoardingOnly = !editorArticleId && onBoardingArticleId;

        if (isOnBoardingReallyExists || hasOnBoardingOnly) {
          widgetCode = this.CONST_ADI_SUPPORT_WIDGET_CODE;
          articleId = onBoardingArticleId;
        } else if (editorArticleId) {
          widgetCode = this.CONST_EDITOR_WIDGET_CODE;
          articleId = editorArticleId;
        }

        if (_.isUndefined(window['locale'])) {
          window['locale'] = 'en';
        }

        var locale = window['locale'];
        var path = '/' + locale + '/widget/' + widgetCode + '/article/' + articleId;
        var url = new _urijs2.default('https://wix.com/').path(path).subdomain(subDomain);
        articleUrl = url.toString();
      }

      return articleUrl;
    }
  }, {
    key: 'mergeDeep',
    value: function mergeDeep() {

      var _mergeDeep = function _mergeDeep(dstObj, srcObj) {
        var mergeId = void 0;

        // const clonedDstVal = _.cloneDeep(dstObj);
        var res = _.mergeWith(dstObj, srcObj, function (dstVal, srcVal) {
          if (_.isObject(dstVal) && !_.isFunction(dstVal)) {
            //isObject return true for functions too
            return _mergeDeep(dstVal, srcVal);
          } else {
            return srcVal;
          }
        });

        return res;
      };

      var merged = {};
      for (var i = 0; i < arguments.length; i++) {
        if (arguments[i]) {
          merged = _mergeDeep(merged, arguments[i]);
        }
      }

      return merged;
    }
  }, {
    key: 'getImageUrl',
    value: function getImageUrl(fileName) {
      return (window['staticsUrl'] || '') + fileName;
    }
  }, {
    key: 'markWidgetInSite',
    value: function markWidgetInSite(widgetId) {
      var instanceId = window['instanceId'];
      this.getLocalStorage()[instanceId + '|has-widget|' + widgetId] = true;
    }
  }, {
    key: 'isWidgetInSite',
    value: function isWidgetInSite(widgetId) {
      var instanceId = window['instanceId'];
      return !_.isUndefined(this.getLocalStorage()[instanceId + '|has-widget|' + widgetId]);
    }
  }, {
    key: 'getMobileEnabledClick',
    value: function getMobileEnabledClick(action) {
      //todo: bring back this line before pushing to master
      return this.isMobile() ? { onTouchEnd: action } : { onClick: action };
      // return {onClick: action};
    }
  }, {
    key: 'uploadImageFromUrl',
    value: function uploadImageFromUrl(imageUrl) {
      var imageUrlTemplateBase64 = window.btoa(imageUrl);
      var updloadMediaUrlTemplate = 'http://files.wix.com/files/upload/external?media_type=picture&ns=campaign&name=_.jpg&url=' + encodeURIComponent(imageUrl);

      return this.getUploadMediaRequest(updloadMediaUrlTemplate, 10000);
    }
  }, {
    key: 'getUploadMediaRequest',
    value: function getUploadMediaRequest(uploadMediaUrl, timeout) {
      return $.ajax(uploadMediaUrl, {
        method: 'GET',
        dataType: 'json',
        timeout: timeout,
        xhrFields: {
          withCredentials: true
        }
      });
    }
  }, {
    key: 'isInExpendSettings',
    value: function isInExpendSettings() {
      return this.parseGetParam('expandsettingsmode') === '1';
    }
  }, {
    key: 'isStoreDemoImages',
    value: function isStoreDemoImages() {
      var _this7 = this;

      if (this.isDev()) {
        //development mode cannot upload images so is is default false
        return Promise.resolve(false);
      }
      if (this.isInExpendSettings()) {
        //expend settings uses default images
        return Promise.resolve(true);
      }

      return this.gallerySettings.get('isStoreDemoImages').then(function (isDemo) {
        if (isDemo === undefined) {
          throw 'not in gallerySettings, fallback to dataPublic';
        }
        return isDemo;
      }).catch(function (e) {
        return _this7.dataPublic.get('isStoreDemoImages').then(function () {
          return false;
        }).catch(function (e) {
          if (_this7.isDev()) {
            console.log('error fetching store default images', e);
          }
          return !!(e && e.error && e.error.message && e.error.message.indexOf('not found in APP scope') > 0);
        });
      });
    }
  }, {
    key: 'isInSettings',
    value: function isInSettings() {
      return this.parseGetParam('expandsettingsmode') == '1';
    }
  }, {
    key: 'createUniqueUuidFromString',
    value: function createUniqueUuidFromString(str) {
      var num = this.hashToInt(str);

      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c, i) {
        var r = num * i % 16,
            v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
    }
  }, {
    key: 'shouldDebug',
    value: function shouldDebug(str) {
      try {
        return !!this.safeLocalStorage()[str] || (window['debugApp'] || '').indexOf(str) >= 0 || (this.parseGetParam('debugApp') || '').indexOf(str) >= 0;
      } catch (e) {
        return false;
      }
    }
  }, {
    key: 'isAccessibilityEnabled',
    value: function isAccessibilityEnabled() {
      return this.shouldDebug('accessibility') || this.isDev();
    }
  }, {
    key: 'getTabIndex',
    value: function getTabIndex(elementName) {
      var elementsArr = ['currentGalleryItem', 'loadMoreButton', 'slideshowNext', 'slideshowPrev', 'currentThumbnail', 'slideshowLove', 'slideshowShare', 'cartIcon', 'cartClose', 'cartFrame', 'fullscreenClose', 'fullscreenNext', 'fullscreenPrev', 'fullscreenInfo',
      // 'fullscreenTitle',
      // 'fullscreenDesc',
      'fullscreenLink', 'fullscreenProvider', 'fullscreenCartButton', 'fullscreenCheckout', 'fullscreenExpand', 'fullscreenVideoPlay', 'fullscreenVideoBar', 'fullscreenVideoMute', 'fullscreenVideoVolume', 'fullscreenDownload', 'fullscreenLove', 'fullscreenShare'];

      var elementIdx = elementsArr.indexOf(elementName) + 1;
      return elementIdx || -1; //no tabIndex (tab will not focus on this item)
    }
  }, {
    key: 'dataPublicKey',
    value: function dataPublicKey(key) {
      try {
        var compId = Wix.Utils.getOrigCompId() || Wix.Utils.getCompId();
        return key + '-' + compId;
      } catch (e) {
        // console.error('Cannot get compId', e);
        return key + '-no-comp-id';
      }
    }
  }, {
    key: 'openMediaDialogAndApplyWatermark',
    value: function openMediaDialogAndApplyWatermark(callback) {
      Wix.Dashboard.openMediaDialog(Wix.Settings.MediaType.IMAGE_PRO, true, function (result) {
        var galleryId = window['galleryId'];
        var instance = window['instance'];
        _watermarkApi2.default.applyWatermarkOnMediaDialogResult(result, galleryId, instance).then(function (watermarkData) {
          callback(result);
        });
      });
    }
  }, {
    key: 'timingMark',
    value: function timingMark(name) {
      try {
        window.performance && performance.mark && performance.mark(name);
      } catch (e) {
        console.error('Error in timingMark', e);
      }
    }
  }, {
    key: 'timingMeasure',
    value: function timingMeasure(measureName, startMarkName, endMarkName) {
      try {
        if (window.performance && performance.measure) {
          if (endMarkName) {
            //performance.measure can't get undefined in ie
            performance.measure(measureName, startMarkName, endMarkName);
          } else if (startMarkName) {
            performance.measure(measureName, startMarkName);
          } else {
            performance.measure(measureName);
          }
        }
      } catch (e) {
        console.error('Error in timingMeasure', e);
      }
    }
  }, {
    key: 'itemLoadStart',
    value: function itemLoadStart() {
      if (!window['itemLoadStart']) {
        window['itemLoadStart'] = true;
        this.timingMark('itemLoadStart');
      }
    }
  }, {
    key: 'colorStringToObject',
    value: function colorStringToObject(colorString) {
      // https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
      try {
        var returnValue = null;
        if (typeof colorString === 'string') {

          if (colorString.trim().indexOf('rgb') === 0) {
            // rgb(1,2,3) | rgba(4,5,6,0.7)
            var values = colorString.match(/\d+/g);
            if (values && Array.isArray(values) && values.length >= 3) {
              returnValue = {
                r: values[0],
                g: values[1],
                b: values[2]
              };
            }
          } else {
            // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
            var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
            colorString = colorString.replace(shorthandRegex, function (m, r, g, b) {
              return r + r + g + g + b + b;
            });

            var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(colorString);
            returnValue = result ? {
              r: parseInt(result[1], 16),
              g: parseInt(result[2], 16),
              b: parseInt(result[3], 16)
            } : null;
          }
        }

        return returnValue;
      } catch (error) {
        console.error('Error converting color string to object', error);
      }
    }
  }, {
    key: 'itemLoaded',
    value: function itemLoaded() {
      if (!window['firstItemLoaded']) {
        this.timingMeasure('firstItemLoaded', 'itemLoadStart');
        window['firstItemLoaded'] = true;
        try {
          // fedopsLogger.appLoaded()
          var _performance$getEntri = performance.getEntriesByName('firstItemLoaded')[0],
              startTime = _performance$getEntri.startTime,
              duration = _performance$getEntri.duration;

          logger.trackBi(logger.biEvents.pro_gallery_load_uou, { endpoint: 'itemLoadStart', loading_time: Math.round(startTime) });
          logger.trackBi(logger.biEvents.pro_gallery_load_uou, { endpoint: 'firstItemLoadDuration', loading_time: Math.round(duration + startTime) });
        } catch (e) {
          //
        }
      }
    }
  }, {
    key: 'getExperimentValue',
    value: function getExperimentValue(experimentName) {
      return _.get(window, ['petri', 'specs.pro-gallery.' + experimentName]);
    }
  }]);

  return Utils;
}();

var utils = exports.utils = new Utils();

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BaseStorage = function () {
  function BaseStorage() {
    var _this = this;

    _classCallCheck(this, BaseStorage);

    ['setItem', 'getItem', 'removeItem', 'getAllItems'].forEach(function (method) {
      if (_this[method] === BaseStorage.prototype[method]) {
        throw new Error('BaseStorage method [' + method + '] must be overriden!');
      }
    });
  }

  _createClass(BaseStorage, [{
    key: 'setItem',
    value: function setItem(key, value, options) {
      throw options;
    }
  }, {
    key: 'getItem',
    value: function getItem(key, options) {
      throw options;
    }
  }, {
    key: 'removeItem',
    value: function removeItem(key, options) {
      throw options;
    }
  }, {
    key: 'getAllItems',
    value: function getAllItems(options) {
      throw options;
    }
  }], [{
    key: 'verify',
    value: function verify(strategy) {
      if (strategy instanceof BaseStorage) {
        return strategy;
      } else {
        throw new Error('This class must extend BaseStorage!');
      }
    }
  }]);

  return BaseStorage;
}();

module.exports = BaseStorage;
//# sourceMappingURL=base-storage.js.map


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var errors = {
  NOT_FOUND: new Error('Key was not found in capsule'),
  SERVER_ERROR: new Error('Failed to perform operarion on server')
};

function toError(str) {
  return Object.values(errors).find(function (err) {
    return err.message === str;
  }) || str;
}

module.exports = {
  PREFIX_SEPARATOR: '|',
  KEY_SEPARATOR: '#',
  STORAGE_PREFIX: 'capsule',
  NOT_FOUND: errors.NOT_FOUND,
  SERVER_ERROR: errors.SERVER_ERROR,
  toError: toError
};
//# sourceMappingURL=constants.js.map


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(42);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(18);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(18);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 9 */,
/* 10 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var providerIntents = exports.providerIntents = {
  configuration: 'configuration',
  shop: 'shop',
  pricing: 'pricing',
  manage: 'manage',
  checkout: 'checkout',
  thankyou: 'thankyou'
};

var storePubSub = exports.storePubSub = {
  refreshCart: 'REFRESH_CART',
  checkoutState: 'CHECKOUT_STATE',
  checkout: 'STORE_CHECKOUT'
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _axios = __webpack_require__(16);

var _axios2 = _interopRequireDefault(_axios);

var _utils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var watermarkDataKey = 'watermarkData';
var apiBase = window.location.protocol + '//progallery.wix.com/_api/pro-gallery-editor-webapp/v1/gallery/';

var WatermarkApi = function () {
  function WatermarkApi(dataKey) {
    _classCallCheck(this, WatermarkApi);

    this.dataKey = dataKey;
    this.defaultWatermarkData = {
      position: 9,
      size: 40,
      opacity: 40,
      imageUrl: '8bb438_9ad16b69fd1b4ab29324f97f1323b05a~mv2.png',
      imageRatio: 1.42517815
    };
    this.origOpacity = 40;

    this.emptyWatermarkData = {
      position: 1,
      size: 1,
      opacity: 1,
      imageUrl: '8bb438_39a78b46d4fe47069da63da9348b4ee5~mv2.png',
      imageRatio: 1
    };

    this.cachedWatermark = {
      default: this.defaultWatermarkData
    };

    this.disableWatermark = this.disableWatermark.bind(this);
    this.enableWatermark = this.enableWatermark.bind(this);
  }

  _createClass(WatermarkApi, [{
    key: 'generateApiUrl',
    value: function generateApiUrl(galleryId, instance) {
      return apiBase + galleryId + '?isStore=true&instance=' + instance;
    }
  }, {
    key: 'applyWatermarkOnMediaDialogResult',
    value: function applyWatermarkOnMediaDialogResult(mediaResult, galleryId, instance) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        if (mediaResult && mediaResult.length) {
          var watermarSave = null;
          _this.getWatermarkData().then(function (watermarkData) {
            var imageUrl = watermarkData.imageUrl,
                position = watermarkData.position,
                size = watermarkData.size,
                opacity = watermarkData.opacity;

            watermarSave = watermarkData;
            var payload = {
              wm: 'media/' + imageUrl,
              wmop: opacity,
              wmpos: position,
              wmscl: size,
              files: mediaResult.map(function (item) {
                return { file_name: item.fileName };
              })
            };
            return _axios2.default.post(window.location.protocol + '//progallery.wix.com/editor/api/v1/watermark/gallery/' + galleryId + '?instance=' + instance + '&isStore=true', payload, {
              withCredentials: true,
              xsrfCookieName: null
            });
          }).then(function (response) {
            resolve(watermarSave);
          });
        } else {
          reject();
        }
      });
    }
  }, {
    key: 'getCompId',
    value: function getCompId() {
      return new Promise(function (resolve, reject) {
        var compId = null;
        if (window.isFullscreen) {
          compId = _utils.utils.getWorkerWindow()['pro-gallery-fullscreen-comp-id'];
        } else {
          compId = Wix.Utils.getOrigCompId() || Wix.Utils.getCompId() || 'default';
        }
        resolve(compId);
      });
    }
  }, {
    key: 'getDataKey',
    value: function getDataKey() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        _this2.getCompId().then(function (compId) {
          var dataKey = _this2.dataKey + '-' + compId;
          resolve(dataKey);
        });
      });
    }
  }, {
    key: 'saveWatermark',
    value: function saveWatermark(_ref, galleryId, instance) {
      var position = _ref.position,
          opacity = _ref.opacity,
          size = _ref.size,
          imageUrl = _ref.imageUrl,
          imageRatio = _ref.imageRatio;

      var _this3 = this;

      //save watermark to store api
      return _axios2.default.put(this.generateApiUrl(galleryId, instance), {
        settings: {
          watermark: { position: position, opacity: opacity, size: size, imageUrl: imageUrl, imageRatio: imageRatio }
        }
      }, {
        withCredentials: true,
        xsrfCookieName: null
      }).then(function (data) {
        return _this3._updateMediaWatermark(imageUrl, opacity, position, size, galleryId, instance);
      });
    }
  }, {
    key: 'getCachedWatermark',
    value: function getCachedWatermark(compId) {
      return this.cachedWatermark[compId] || this.defaultWatermarkData;
    }
  }, {
    key: 'disableWatermark',
    value: function disableWatermark(galleryId, instance) {
      var _this4 = this;

      if (_utils.utils.isDev()) console.log("Disabling watermark");
      this.getCompId().then(function (compId) {
        var _getCachedWatermark = _this4.getCachedWatermark(compId),
            position = _getCachedWatermark.position,
            size = _getCachedWatermark.size,
            opacity = _getCachedWatermark.opacity,
            imageUrl = _getCachedWatermark.imageUrl,
            imageRatio = _getCachedWatermark.imageRatio;

        _this4.origOpacity = opacity; //save original opacity of the watermark
        opacity = 0;
        return _this4.saveWatermark({ position: position, size: size, opacity: opacity, imageUrl: imageUrl, imageRatio: imageRatio }, galleryId, instance);
      });
    }
  }, {
    key: 'enableWatermark',
    value: function enableWatermark(galleryId, instance) {
      var _this5 = this;

      if (_utils.utils.isDev()) console.log("Enabling watermark");
      this.getCompId().then(function (compId) {
        var _getCachedWatermark2 = _this5.getCachedWatermark(compId),
            position = _getCachedWatermark2.position,
            size = _getCachedWatermark2.size,
            imageUrl = _getCachedWatermark2.imageUrl,
            imageRatio = _getCachedWatermark2.imageRatio;

        var opacity = _this5.origOpacity; //retrieve original opacity of the watermark
        return _this5.saveWatermark({ position: position, size: size, opacity: opacity, imageUrl: imageUrl, imageRatio: imageRatio }, galleryId, instance);
      });
    }
  }, {
    key: '_updateMediaWatermark',
    value: function _updateMediaWatermark(imageUrl, opacity, position, size, galleryId, instance) {
      return new Promise(function (resolve, reject) {
        var payload = {
          wm: 'media/' + imageUrl,
          wmop: opacity,
          wmpos: position,
          wmscl: size
        };
        return _axios2.default.post(window.location.protocol + '//progallery.wix.com/editor/api/v1/watermark/gallery/' + galleryId + '?instance=' + instance + '&isStore=true', payload, {
          withCredentials: true,
          xsrfCookieName: null
        }).then(function () {
          resolve();
        });
      });
    }
  }, {
    key: 'getWatermarkDataFromGallerySettingsSync',
    value: function getWatermarkDataFromGallerySettingsSync() {
      var watermarkData = null;
      if (window.prerenderedGallery && prerenderedGallery.gallerySettings) {
        var objGallerySettings = null;
        if (typeof prerenderedGallery.gallerySettings === 'string') {
          try {
            objGallerySettings = JSON.parse(_utils.utils.stripSlashes(prerenderedGallery.gallerySettings));
          } catch (error) {}
        } else if (_typeof(prerenderedGallery.gallerySettings) === 'object') {
          objGallerySettings = prerenderedGallery.gallerySettings;
        }

        if (objGallerySettings) {
          watermarkData = objGallerySettings.watermark;
          if (watermarkData) {
            if (typeof watermarkData === 'string') {
              try {
                watermarkData = JSON.parse(watermarkData);
              } catch (error) {
                console.error('watermarkApi - watermark from gallery settings (' + watermarkData + ') is invalid', error);
              }
            }
          }
        }
      }

      return watermarkData;
    }
  }, {
    key: 'getWatermarkDataFromServerAsync',
    value: function getWatermarkDataFromServerAsync(galleryId) {
      galleryId = galleryId || window.galleryId;
      var instance = window.instance;
      return new Promise(function (resolve, reject) {
        if (instance && galleryId) {
          _axios2.default.get(window.location.protocol + '//progallery.wix.com/_api/pro-gallery-editor-webapp/v1/gallery/' + galleryId + '?instance=' + instance + '&isStore=true', {
            withCredentials: true,
            xsrfCookieName: null
          }).then(function (response) {
            var data = response.data;

            if (data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' && data.settings && data.settings.watermark) {
              resolve(data.settings.watermark);
            } else {
              reject('watermarkApi - getWatermarkDataFromServerAsync - returned data from server is corrupt');
            }
          }).catch(function (e) {
            reject('watermarkApi - getWatermarkDataFromServerAsync - request error');
          });
        } else {
          reject('watermarkApi - getWatermarkDataFromServerAsync - no galleryId (' + galleryId + ') or instance (' + instance + ')');
        }
      });
    }
  }, {
    key: 'getWatermarkData',
    value: function getWatermarkData(galleryId) {
      var _this6 = this;

      return new Promise(function (resolve, reject) {
        _this6.getCompId().then(function (compId) {
          if (_this6.cachedWatermark[compId] && !_utils.utils.isEditor()) {
            // if (utils.isDev()) console.log('Getting cached watermark');
            resolve(_this6.cachedWatermark[compId]);
          } else {
            _this6.cachedWatermark[compId] = _this6.getWatermarkDataFromGallerySettingsSync();
            // this.cachedWatermark = this.defaultWatermarkData; //set the default watermark until the Promise will resolve
            _utils.utils.isDev() && console.log('Getting public watermark');
            if (_this6.cachedWatermark[compId]) {
              resolve(_this6.cachedWatermark[compId]);
            } else {
              // fall back to data.public
              _this6.getWatermarkDataFromServerAsync(galleryId).then(function (watermarkData) {
                _this6.cachedWatermark[compId] = watermarkData;
                resolve(_this6.cachedWatermark[compId]);
              }).catch(function (e) {
                _utils.utils.isDev() && console.log('Getting watermark from server failed - ', e);
                _this6.cachedWatermark[compId] = new Promise(function () {
                  _this6.getDataKey().then(function (dataKey) {
                    if (Wix && Wix.Data && Wix.Data.Public) {
                      Wix.Data.Public.get(dataKey, { scope: Wix.Data.SCOPE.APP }, function (data) {
                        if (_utils.utils.isDev()) console.log('Got watermark from Data.Public', data);
                        var parsedData = JSON.parse(data[dataKey]);
                        _this6.cachedWatermark[compId] = parsedData;
                        resolve(parsedData);
                      }, function (e) {
                        if (_utils.utils.isDev()) console.log('cannot fetch watermark from Data.Public', e);

                        _this6.cachedWatermark[compId] = _this6.defaultWatermarkData;
                        resolve(_this6.cachedWatermark[compId]);
                      });
                    } else {
                      if (_utils.utils.isDev()) console.log('Cannot get watermark from Data.Public (wix not found)');
                      reject('Wix not found');
                    }
                  });
                });
              });
            }
          }
        });
      });
    }
  }]);

  return WatermarkApi;
}();

var api = new WatermarkApi(watermarkDataKey);
window['watermarkApi'] = api;
module.exports = api;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.0 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.3.2',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return punycode;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)(module), __webpack_require__(10)))

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * URI.js - Mutating URLs
 * IPv6 Support
 *
 * Version: 1.18.12
 *
 * Author: Rodney Rehm
 * Web: http://medialize.github.io/URI.js/
 *
 * Licensed under
 *   MIT License http://www.opensource.org/licenses/mit-license
 *
 */

(function (root, factory) {
  'use strict';
  // https://github.com/umdjs/umd/blob/master/returnExports.js
  if (typeof module === 'object' && module.exports) {
    // Node
    module.exports = factory();
  } else if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {
    // Browser globals (root is window)
    root.IPv6 = factory(root);
  }
}(this, function (root) {
  'use strict';

  /*
  var _in = "fe80:0000:0000:0000:0204:61ff:fe9d:f156";
  var _out = IPv6.best(_in);
  var _expected = "fe80::204:61ff:fe9d:f156";

  console.log(_in, _out, _expected, _out === _expected);
  */

  // save current IPv6 variable, if any
  var _IPv6 = root && root.IPv6;

  function bestPresentation(address) {
    // based on:
    // Javascript to test an IPv6 address for proper format, and to
    // present the "best text representation" according to IETF Draft RFC at
    // http://tools.ietf.org/html/draft-ietf-6man-text-addr-representation-04
    // 8 Feb 2010 Rich Brown, Dartware, LLC
    // Please feel free to use this code as long as you provide a link to
    // http://www.intermapper.com
    // http://intermapper.com/support/tools/IPV6-Validator.aspx
    // http://download.dartware.com/thirdparty/ipv6validator.js

    var _address = address.toLowerCase();
    var segments = _address.split(':');
    var length = segments.length;
    var total = 8;

    // trim colons (:: or ::a:b:c… or …a:b:c::)
    if (segments[0] === '' && segments[1] === '' && segments[2] === '') {
      // must have been ::
      // remove first two items
      segments.shift();
      segments.shift();
    } else if (segments[0] === '' && segments[1] === '') {
      // must have been ::xxxx
      // remove the first item
      segments.shift();
    } else if (segments[length - 1] === '' && segments[length - 2] === '') {
      // must have been xxxx::
      segments.pop();
    }

    length = segments.length;

    // adjust total segments for IPv4 trailer
    if (segments[length - 1].indexOf('.') !== -1) {
      // found a "." which means IPv4
      total = 7;
    }

    // fill empty segments them with "0000"
    var pos;
    for (pos = 0; pos < length; pos++) {
      if (segments[pos] === '') {
        break;
      }
    }

    if (pos < total) {
      segments.splice(pos, 1, '0000');
      while (segments.length < total) {
        segments.splice(pos, 0, '0000');
      }
    }

    // strip leading zeros
    var _segments;
    for (var i = 0; i < total; i++) {
      _segments = segments[i].split('');
      for (var j = 0; j < 3 ; j++) {
        if (_segments[0] === '0' && _segments.length > 1) {
          _segments.splice(0,1);
        } else {
          break;
        }
      }

      segments[i] = _segments.join('');
    }

    // find longest sequence of zeroes and coalesce them into one segment
    var best = -1;
    var _best = 0;
    var _current = 0;
    var current = -1;
    var inzeroes = false;
    // i; already declared

    for (i = 0; i < total; i++) {
      if (inzeroes) {
        if (segments[i] === '0') {
          _current += 1;
        } else {
          inzeroes = false;
          if (_current > _best) {
            best = current;
            _best = _current;
          }
        }
      } else {
        if (segments[i] === '0') {
          inzeroes = true;
          current = i;
          _current = 1;
        }
      }
    }

    if (_current > _best) {
      best = current;
      _best = _current;
    }

    if (_best > 1) {
      segments.splice(best, _best, '');
    }

    length = segments.length;

    // assemble remaining segments
    var result = '';
    if (segments[0] === '')  {
      result = ':';
    }

    for (i = 0; i < length; i++) {
      result += segments[i];
      if (i === length - 1) {
        break;
      }

      result += ':';
    }

    if (segments[length - 1] === '') {
      result += ':';
    }

    return result;
  }

  function noConflict() {
    /*jshint validthis: true */
    if (root.IPv6 === this) {
      root.IPv6 = _IPv6;
    }

    return this;
  }

  return {
    best: bestPresentation,
    noConflict: noConflict
  };
}));


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * URI.js - Mutating URLs
 * Second Level Domain (SLD) Support
 *
 * Version: 1.18.12
 *
 * Author: Rodney Rehm
 * Web: http://medialize.github.io/URI.js/
 *
 * Licensed under
 *   MIT License http://www.opensource.org/licenses/mit-license
 *
 */

(function (root, factory) {
  'use strict';
  // https://github.com/umdjs/umd/blob/master/returnExports.js
  if (typeof module === 'object' && module.exports) {
    // Node
    module.exports = factory();
  } else if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {
    // Browser globals (root is window)
    root.SecondLevelDomains = factory(root);
  }
}(this, function (root) {
  'use strict';

  // save current SecondLevelDomains variable, if any
  var _SecondLevelDomains = root && root.SecondLevelDomains;

  var SLD = {
    // list of known Second Level Domains
    // converted list of SLDs from https://github.com/gavingmiller/second-level-domains
    // ----
    // publicsuffix.org is more current and actually used by a couple of browsers internally.
    // downside is it also contains domains like "dyndns.org" - which is fine for the security
    // issues browser have to deal with (SOP for cookies, etc) - but is way overboard for URI.js
    // ----
    list: {
      'ac':' com gov mil net org ',
      'ae':' ac co gov mil name net org pro sch ',
      'af':' com edu gov net org ',
      'al':' com edu gov mil net org ',
      'ao':' co ed gv it og pb ',
      'ar':' com edu gob gov int mil net org tur ',
      'at':' ac co gv or ',
      'au':' asn com csiro edu gov id net org ',
      'ba':' co com edu gov mil net org rs unbi unmo unsa untz unze ',
      'bb':' biz co com edu gov info net org store tv ',
      'bh':' biz cc com edu gov info net org ',
      'bn':' com edu gov net org ',
      'bo':' com edu gob gov int mil net org tv ',
      'br':' adm adv agr am arq art ato b bio blog bmd cim cng cnt com coop ecn edu eng esp etc eti far flog fm fnd fot fst g12 ggf gov imb ind inf jor jus lel mat med mil mus net nom not ntr odo org ppg pro psc psi qsl rec slg srv tmp trd tur tv vet vlog wiki zlg ',
      'bs':' com edu gov net org ',
      'bz':' du et om ov rg ',
      'ca':' ab bc mb nb nf nl ns nt nu on pe qc sk yk ',
      'ck':' biz co edu gen gov info net org ',
      'cn':' ac ah bj com cq edu fj gd gov gs gx gz ha hb he hi hl hn jl js jx ln mil net nm nx org qh sc sd sh sn sx tj tw xj xz yn zj ',
      'co':' com edu gov mil net nom org ',
      'cr':' ac c co ed fi go or sa ',
      'cy':' ac biz com ekloges gov ltd name net org parliament press pro tm ',
      'do':' art com edu gob gov mil net org sld web ',
      'dz':' art asso com edu gov net org pol ',
      'ec':' com edu fin gov info med mil net org pro ',
      'eg':' com edu eun gov mil name net org sci ',
      'er':' com edu gov ind mil net org rochest w ',
      'es':' com edu gob nom org ',
      'et':' biz com edu gov info name net org ',
      'fj':' ac biz com info mil name net org pro ',
      'fk':' ac co gov net nom org ',
      'fr':' asso com f gouv nom prd presse tm ',
      'gg':' co net org ',
      'gh':' com edu gov mil org ',
      'gn':' ac com gov net org ',
      'gr':' com edu gov mil net org ',
      'gt':' com edu gob ind mil net org ',
      'gu':' com edu gov net org ',
      'hk':' com edu gov idv net org ',
      'hu':' 2000 agrar bolt casino city co erotica erotika film forum games hotel info ingatlan jogasz konyvelo lakas media news org priv reklam sex shop sport suli szex tm tozsde utazas video ',
      'id':' ac co go mil net or sch web ',
      'il':' ac co gov idf k12 muni net org ',
      'in':' ac co edu ernet firm gen gov i ind mil net nic org res ',
      'iq':' com edu gov i mil net org ',
      'ir':' ac co dnssec gov i id net org sch ',
      'it':' edu gov ',
      'je':' co net org ',
      'jo':' com edu gov mil name net org sch ',
      'jp':' ac ad co ed go gr lg ne or ',
      'ke':' ac co go info me mobi ne or sc ',
      'kh':' com edu gov mil net org per ',
      'ki':' biz com de edu gov info mob net org tel ',
      'km':' asso com coop edu gouv k medecin mil nom notaires pharmaciens presse tm veterinaire ',
      'kn':' edu gov net org ',
      'kr':' ac busan chungbuk chungnam co daegu daejeon es gangwon go gwangju gyeongbuk gyeonggi gyeongnam hs incheon jeju jeonbuk jeonnam k kg mil ms ne or pe re sc seoul ulsan ',
      'kw':' com edu gov net org ',
      'ky':' com edu gov net org ',
      'kz':' com edu gov mil net org ',
      'lb':' com edu gov net org ',
      'lk':' assn com edu gov grp hotel int ltd net ngo org sch soc web ',
      'lr':' com edu gov net org ',
      'lv':' asn com conf edu gov id mil net org ',
      'ly':' com edu gov id med net org plc sch ',
      'ma':' ac co gov m net org press ',
      'mc':' asso tm ',
      'me':' ac co edu gov its net org priv ',
      'mg':' com edu gov mil nom org prd tm ',
      'mk':' com edu gov inf name net org pro ',
      'ml':' com edu gov net org presse ',
      'mn':' edu gov org ',
      'mo':' com edu gov net org ',
      'mt':' com edu gov net org ',
      'mv':' aero biz com coop edu gov info int mil museum name net org pro ',
      'mw':' ac co com coop edu gov int museum net org ',
      'mx':' com edu gob net org ',
      'my':' com edu gov mil name net org sch ',
      'nf':' arts com firm info net other per rec store web ',
      'ng':' biz com edu gov mil mobi name net org sch ',
      'ni':' ac co com edu gob mil net nom org ',
      'np':' com edu gov mil net org ',
      'nr':' biz com edu gov info net org ',
      'om':' ac biz co com edu gov med mil museum net org pro sch ',
      'pe':' com edu gob mil net nom org sld ',
      'ph':' com edu gov i mil net ngo org ',
      'pk':' biz com edu fam gob gok gon gop gos gov net org web ',
      'pl':' art bialystok biz com edu gda gdansk gorzow gov info katowice krakow lodz lublin mil net ngo olsztyn org poznan pwr radom slupsk szczecin torun warszawa waw wroc wroclaw zgora ',
      'pr':' ac biz com edu est gov info isla name net org pro prof ',
      'ps':' com edu gov net org plo sec ',
      'pw':' belau co ed go ne or ',
      'ro':' arts com firm info nom nt org rec store tm www ',
      'rs':' ac co edu gov in org ',
      'sb':' com edu gov net org ',
      'sc':' com edu gov net org ',
      'sh':' co com edu gov net nom org ',
      'sl':' com edu gov net org ',
      'st':' co com consulado edu embaixada gov mil net org principe saotome store ',
      'sv':' com edu gob org red ',
      'sz':' ac co org ',
      'tr':' av bbs bel biz com dr edu gen gov info k12 name net org pol tel tsk tv web ',
      'tt':' aero biz cat co com coop edu gov info int jobs mil mobi museum name net org pro tel travel ',
      'tw':' club com ebiz edu game gov idv mil net org ',
      'mu':' ac co com gov net or org ',
      'mz':' ac co edu gov org ',
      'na':' co com ',
      'nz':' ac co cri geek gen govt health iwi maori mil net org parliament school ',
      'pa':' abo ac com edu gob ing med net nom org sld ',
      'pt':' com edu gov int net nome org publ ',
      'py':' com edu gov mil net org ',
      'qa':' com edu gov mil net org ',
      're':' asso com nom ',
      'ru':' ac adygeya altai amur arkhangelsk astrakhan bashkiria belgorod bir bryansk buryatia cbg chel chelyabinsk chita chukotka chuvashia com dagestan e-burg edu gov grozny int irkutsk ivanovo izhevsk jar joshkar-ola kalmykia kaluga kamchatka karelia kazan kchr kemerovo khabarovsk khakassia khv kirov koenig komi kostroma kranoyarsk kuban kurgan kursk lipetsk magadan mari mari-el marine mil mordovia mosreg msk murmansk nalchik net nnov nov novosibirsk nsk omsk orenburg org oryol penza perm pp pskov ptz rnd ryazan sakhalin samara saratov simbirsk smolensk spb stavropol stv surgut tambov tatarstan tom tomsk tsaritsyn tsk tula tuva tver tyumen udm udmurtia ulan-ude vladikavkaz vladimir vladivostok volgograd vologda voronezh vrn vyatka yakutia yamal yekaterinburg yuzhno-sakhalinsk ',
      'rw':' ac co com edu gouv gov int mil net ',
      'sa':' com edu gov med net org pub sch ',
      'sd':' com edu gov info med net org tv ',
      'se':' a ac b bd c d e f g h i k l m n o org p parti pp press r s t tm u w x y z ',
      'sg':' com edu gov idn net org per ',
      'sn':' art com edu gouv org perso univ ',
      'sy':' com edu gov mil net news org ',
      'th':' ac co go in mi net or ',
      'tj':' ac biz co com edu go gov info int mil name net nic org test web ',
      'tn':' agrinet com defense edunet ens fin gov ind info intl mincom nat net org perso rnrt rns rnu tourism ',
      'tz':' ac co go ne or ',
      'ua':' biz cherkassy chernigov chernovtsy ck cn co com crimea cv dn dnepropetrovsk donetsk dp edu gov if in ivano-frankivsk kh kharkov kherson khmelnitskiy kiev kirovograd km kr ks kv lg lugansk lutsk lviv me mk net nikolaev od odessa org pl poltava pp rovno rv sebastopol sumy te ternopil uzhgorod vinnica vn zaporizhzhe zhitomir zp zt ',
      'ug':' ac co go ne or org sc ',
      'uk':' ac bl british-library co cym gov govt icnet jet lea ltd me mil mod national-library-scotland nel net nhs nic nls org orgn parliament plc police sch scot soc ',
      'us':' dni fed isa kids nsn ',
      'uy':' com edu gub mil net org ',
      've':' co com edu gob info mil net org web ',
      'vi':' co com k12 net org ',
      'vn':' ac biz com edu gov health info int name net org pro ',
      'ye':' co com gov ltd me net org plc ',
      'yu':' ac co edu gov org ',
      'za':' ac agric alt bourse city co cybernet db edu gov grondar iaccess imt inca landesign law mil net ngo nis nom olivetti org pix school tm web ',
      'zm':' ac co com edu gov net org sch ',
      // https://en.wikipedia.org/wiki/CentralNic#Second-level_domains
      'com': 'ar br cn de eu gb gr hu jpn kr no qc ru sa se uk us uy za ',
      'net': 'gb jp se uk ',
      'org': 'ae',
      'de': 'com '
    },
    // gorhill 2013-10-25: Using indexOf() instead Regexp(). Significant boost
    // in both performance and memory footprint. No initialization required.
    // http://jsperf.com/uri-js-sld-regex-vs-binary-search/4
    // Following methods use lastIndexOf() rather than array.split() in order
    // to avoid any memory allocations.
    has: function(domain) {
      var tldOffset = domain.lastIndexOf('.');
      if (tldOffset <= 0 || tldOffset >= (domain.length-1)) {
        return false;
      }
      var sldOffset = domain.lastIndexOf('.', tldOffset-1);
      if (sldOffset <= 0 || sldOffset >= (tldOffset-1)) {
        return false;
      }
      var sldList = SLD.list[domain.slice(tldOffset+1)];
      if (!sldList) {
        return false;
      }
      return sldList.indexOf(' ' + domain.slice(sldOffset+1, tldOffset) + ' ') >= 0;
    },
    is: function(domain) {
      var tldOffset = domain.lastIndexOf('.');
      if (tldOffset <= 0 || tldOffset >= (domain.length-1)) {
        return false;
      }
      var sldOffset = domain.lastIndexOf('.', tldOffset-1);
      if (sldOffset >= 0) {
        return false;
      }
      var sldList = SLD.list[domain.slice(tldOffset+1)];
      if (!sldList) {
        return false;
      }
      return sldList.indexOf(' ' + domain.slice(0, tldOffset) + ' ') >= 0;
    },
    get: function(domain) {
      var tldOffset = domain.lastIndexOf('.');
      if (tldOffset <= 0 || tldOffset >= (domain.length-1)) {
        return null;
      }
      var sldOffset = domain.lastIndexOf('.', tldOffset-1);
      if (sldOffset <= 0 || sldOffset >= (tldOffset-1)) {
        return null;
      }
      var sldList = SLD.list[domain.slice(tldOffset+1)];
      if (!sldList) {
        return null;
      }
      if (sldList.indexOf(' ' + domain.slice(sldOffset+1, tldOffset) + ' ') < 0) {
        return null;
      }
      return domain.slice(sldOffset+1);
    },
    noConflict: function(){
      if (root.SecondLevelDomains === this) {
        root.SecondLevelDomains = _SecondLevelDomains;
      }
      return this;
    }
  };

  return SLD;
}));


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(39);

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(43);
var buildURL = __webpack_require__(45);
var parseHeaders = __webpack_require__(46);
var isURLSameOrigin = __webpack_require__(47);
var createError = __webpack_require__(19);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(48);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(49);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(44);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 22 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global localStorage */


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseStorage = __webpack_require__(6);
var localStorageCleaner = __webpack_require__(70);

var _require = __webpack_require__(7),
    STORAGE_PREFIX = _require.STORAGE_PREFIX,
    PREFIX_SEPARATOR = _require.PREFIX_SEPARATOR,
    KEY_SEPARATOR = _require.KEY_SEPARATOR,
    NOT_FOUND = _require.NOT_FOUND;

var _require2 = __webpack_require__(33),
    getCacheRecords = _require2.getCacheRecords,
    deserializeData = _require2.deserializeData,
    isExpired = _require2.isExpired;

function getCacheKey(key, options) {
  return getCachePrefix(options) + key;
}

function getCachePrefix(options) {
  return [STORAGE_PREFIX, options.namespace, options.scope && JSON.stringify(options.scope)].filter(function (x) {
    return x;
  }).join(PREFIX_SEPARATOR) + KEY_SEPARATOR;
}

function serializeData(value, options) {
  return JSON.stringify({
    lastUsed: Date.now(),
    createdAt: options.createdAt || Date.now(),
    expiration: options.expiration,
    value: value
  });
}

function updateAccessTime(fullKey, data) {
  var expiration = data.expiration,
      createdAt = data.createdAt;

  localStorage.setItem(fullKey, serializeData(data.value, { expiration: expiration, createdAt: createdAt }));
}

var LocalStorageStrategy = function (_BaseStorage) {
  _inherits(LocalStorageStrategy, _BaseStorage);

  function LocalStorageStrategy() {
    _classCallCheck(this, LocalStorageStrategy);

    return _possibleConstructorReturn(this, (LocalStorageStrategy.__proto__ || Object.getPrototypeOf(LocalStorageStrategy)).apply(this, arguments));
  }

  _createClass(LocalStorageStrategy, [{
    key: 'setItem',
    value: function setItem(key, value, options) {
      key = getCacheKey(key, options);
      value = serializeData(value, options);
      try {
        localStorage.setItem(key, value);
      } catch (e) {
        localStorageCleaner(key.length + value.length);
        localStorage.setItem(key, value);
      }
      return Promise.resolve();
    }
  }, {
    key: 'getItem',
    value: function getItem(key, options) {
      var fullKey = getCacheKey(key, options);
      var data = localStorage.getItem(fullKey);
      data = data && deserializeData(data);
      if (data && !isExpired(data)) {
        updateAccessTime(fullKey, data);
        return Promise.resolve(data.value);
      } else {
        return Promise.reject(NOT_FOUND);
      }
    }
  }, {
    key: 'removeItem',
    value: function removeItem(key, options) {
      key = getCacheKey(key, options);
      localStorage.removeItem(key);
      return Promise.resolve();
    }
  }, {
    key: 'getAllItems',
    value: function getAllItems(options) {
      var prefix = getCachePrefix(options);
      var items = {};
      getCacheRecords(prefix).forEach(function (record) {
        if (!isExpired(record)) {
          items[record.key] = record.value;
        }
      });
      return Promise.resolve(items);
    }
  }]);

  return LocalStorageStrategy;
}(BaseStorage);

module.exports = LocalStorageStrategy;
//# sourceMappingURL=local-storage.js.map


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(3);
var normalizeHeaderName = __webpack_require__(76);

var PROTECTION_PREFIX = /^\)\]\}',?\n/;
var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(35);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(35);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      data = data.replace(PROTECTION_PREFIX, '');
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMehtodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * URI.js - Mutating URLs
 *
 * Version: 1.18.12
 *
 * Author: Rodney Rehm
 * Web: http://medialize.github.io/URI.js/
 *
 * Licensed under
 *   MIT License http://www.opensource.org/licenses/mit-license
 *
 */
(function (root, factory) {
  'use strict';
  // https://github.com/umdjs/umd/blob/master/returnExports.js
  if (typeof module === 'object' && module.exports) {
    // Node
    module.exports = factory(__webpack_require__(13), __webpack_require__(14), __webpack_require__(15));
  } else if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(13), __webpack_require__(14), __webpack_require__(15)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {
    // Browser globals (root is window)
    root.URI = factory(root.punycode, root.IPv6, root.SecondLevelDomains, root);
  }
}(this, function (punycode, IPv6, SLD, root) {
  'use strict';
  /*global location, escape, unescape */
  // FIXME: v2.0.0 renamce non-camelCase properties to uppercase
  /*jshint camelcase: false */

  // save current URI variable, if any
  var _URI = root && root.URI;

  function URI(url, base) {
    var _urlSupplied = arguments.length >= 1;
    var _baseSupplied = arguments.length >= 2;

    // Allow instantiation without the 'new' keyword
    if (!(this instanceof URI)) {
      if (_urlSupplied) {
        if (_baseSupplied) {
          return new URI(url, base);
        }

        return new URI(url);
      }

      return new URI();
    }

    if (url === undefined) {
      if (_urlSupplied) {
        throw new TypeError('undefined is not a valid argument for URI');
      }

      if (typeof location !== 'undefined') {
        url = location.href + '';
      } else {
        url = '';
      }
    }

    if (url === null) {
      if (_urlSupplied) {
        throw new TypeError('null is not a valid argument for URI');
      }
    }

    this.href(url);

    // resolve to base according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#constructor
    if (base !== undefined) {
      return this.absoluteTo(base);
    }

    return this;
  }

  function isInteger(value) {
    return /^[0-9]+$/.test(value);
  }

  URI.version = '1.18.12';

  var p = URI.prototype;
  var hasOwn = Object.prototype.hasOwnProperty;

  function escapeRegEx(string) {
    // https://github.com/medialize/URI.js/commit/85ac21783c11f8ccab06106dba9735a31a86924d#commitcomment-821963
    return string.replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
  }

  function getType(value) {
    // IE8 doesn't return [Object Undefined] but [Object Object] for undefined value
    if (value === undefined) {
      return 'Undefined';
    }

    return String(Object.prototype.toString.call(value)).slice(8, -1);
  }

  function isArray(obj) {
    return getType(obj) === 'Array';
  }

  function filterArrayValues(data, value) {
    var lookup = {};
    var i, length;

    if (getType(value) === 'RegExp') {
      lookup = null;
    } else if (isArray(value)) {
      for (i = 0, length = value.length; i < length; i++) {
        lookup[value[i]] = true;
      }
    } else {
      lookup[value] = true;
    }

    for (i = 0, length = data.length; i < length; i++) {
      /*jshint laxbreak: true */
      var _match = lookup && lookup[data[i]] !== undefined
        || !lookup && value.test(data[i]);
      /*jshint laxbreak: false */
      if (_match) {
        data.splice(i, 1);
        length--;
        i--;
      }
    }

    return data;
  }

  function arrayContains(list, value) {
    var i, length;

    // value may be string, number, array, regexp
    if (isArray(value)) {
      // Note: this can be optimized to O(n) (instead of current O(m * n))
      for (i = 0, length = value.length; i < length; i++) {
        if (!arrayContains(list, value[i])) {
          return false;
        }
      }

      return true;
    }

    var _type = getType(value);
    for (i = 0, length = list.length; i < length; i++) {
      if (_type === 'RegExp') {
        if (typeof list[i] === 'string' && list[i].match(value)) {
          return true;
        }
      } else if (list[i] === value) {
        return true;
      }
    }

    return false;
  }

  function arraysEqual(one, two) {
    if (!isArray(one) || !isArray(two)) {
      return false;
    }

    // arrays can't be equal if they have different amount of content
    if (one.length !== two.length) {
      return false;
    }

    one.sort();
    two.sort();

    for (var i = 0, l = one.length; i < l; i++) {
      if (one[i] !== two[i]) {
        return false;
      }
    }

    return true;
  }

  function trimSlashes(text) {
    var trim_expression = /^\/+|\/+$/g;
    return text.replace(trim_expression, '');
  }

  URI._parts = function() {
    return {
      protocol: null,
      username: null,
      password: null,
      hostname: null,
      urn: null,
      port: null,
      path: null,
      query: null,
      fragment: null,
      // state
      duplicateQueryParameters: URI.duplicateQueryParameters,
      escapeQuerySpace: URI.escapeQuerySpace
    };
  };
  // state: allow duplicate query parameters (a=1&a=1)
  URI.duplicateQueryParameters = false;
  // state: replaces + with %20 (space in query strings)
  URI.escapeQuerySpace = true;
  // static properties
  URI.protocol_expression = /^[a-z][a-z0-9.+-]*$/i;
  URI.idn_expression = /[^a-z0-9\._-]/i;
  URI.punycode_expression = /(xn--)/i;
  // well, 333.444.555.666 matches, but it sure ain't no IPv4 - do we care?
  URI.ip4_expression = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
  // credits to Rich Brown
  // source: http://forums.intermapper.com/viewtopic.php?p=1096#1096
  // specification: http://www.ietf.org/rfc/rfc4291.txt
  URI.ip6_expression = /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/;
  // expression used is "gruber revised" (@gruber v2) determined to be the
  // best solution in a regex-golf we did a couple of ages ago at
  // * http://mathiasbynens.be/demo/url-regex
  // * http://rodneyrehm.de/t/url-regex.html
  URI.find_uri_expression = /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))/ig;
  URI.findUri = {
    // valid "scheme://" or "www."
    start: /\b(?:([a-z][a-z0-9.+-]*:\/\/)|www\.)/gi,
    // everything up to the next whitespace
    end: /[\s\r\n]|$/,
    // trim trailing punctuation captured by end RegExp
    trim: /[`!()\[\]{};:'".,<>?«»“”„‘’]+$/,
    // balanced parens inclusion (), [], {}, <>
    parens: /(\([^\)]*\)|\[[^\]]*\]|\{[^}]*\}|<[^>]*>)/g,
  };
  // http://www.iana.org/assignments/uri-schemes.html
  // http://en.wikipedia.org/wiki/List_of_TCP_and_UDP_port_numbers#Well-known_ports
  URI.defaultPorts = {
    http: '80',
    https: '443',
    ftp: '21',
    gopher: '70',
    ws: '80',
    wss: '443'
  };
  // list of protocols which always require a hostname
  URI.hostProtocols = [
    'http',
    'https'
  ];

  // allowed hostname characters according to RFC 3986
  // ALPHA DIGIT "-" "." "_" "~" "!" "$" "&" "'" "(" ")" "*" "+" "," ";" "=" %encoded
  // I've never seen a (non-IDN) hostname other than: ALPHA DIGIT . - _
  URI.invalid_hostname_characters = /[^a-zA-Z0-9\.\-:_]/;
  // map DOM Elements to their URI attribute
  URI.domAttributes = {
    'a': 'href',
    'blockquote': 'cite',
    'link': 'href',
    'base': 'href',
    'script': 'src',
    'form': 'action',
    'img': 'src',
    'area': 'href',
    'iframe': 'src',
    'embed': 'src',
    'source': 'src',
    'track': 'src',
    'input': 'src', // but only if type="image"
    'audio': 'src',
    'video': 'src'
  };
  URI.getDomAttribute = function(node) {
    if (!node || !node.nodeName) {
      return undefined;
    }

    var nodeName = node.nodeName.toLowerCase();
    // <input> should only expose src for type="image"
    if (nodeName === 'input' && node.type !== 'image') {
      return undefined;
    }

    return URI.domAttributes[nodeName];
  };

  function escapeForDumbFirefox36(value) {
    // https://github.com/medialize/URI.js/issues/91
    return escape(value);
  }

  // encoding / decoding according to RFC3986
  function strictEncodeURIComponent(string) {
    // see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/encodeURIComponent
    return encodeURIComponent(string)
      .replace(/[!'()*]/g, escapeForDumbFirefox36)
      .replace(/\*/g, '%2A');
  }
  URI.encode = strictEncodeURIComponent;
  URI.decode = decodeURIComponent;
  URI.iso8859 = function() {
    URI.encode = escape;
    URI.decode = unescape;
  };
  URI.unicode = function() {
    URI.encode = strictEncodeURIComponent;
    URI.decode = decodeURIComponent;
  };
  URI.characters = {
    pathname: {
      encode: {
        // RFC3986 2.1: For consistency, URI producers and normalizers should
        // use uppercase hexadecimal digits for all percent-encodings.
        expression: /%(24|26|2B|2C|3B|3D|3A|40)/ig,
        map: {
          // -._~!'()*
          '%24': '$',
          '%26': '&',
          '%2B': '+',
          '%2C': ',',
          '%3B': ';',
          '%3D': '=',
          '%3A': ':',
          '%40': '@'
        }
      },
      decode: {
        expression: /[\/\?#]/g,
        map: {
          '/': '%2F',
          '?': '%3F',
          '#': '%23'
        }
      }
    },
    reserved: {
      encode: {
        // RFC3986 2.1: For consistency, URI producers and normalizers should
        // use uppercase hexadecimal digits for all percent-encodings.
        expression: /%(21|23|24|26|27|28|29|2A|2B|2C|2F|3A|3B|3D|3F|40|5B|5D)/ig,
        map: {
          // gen-delims
          '%3A': ':',
          '%2F': '/',
          '%3F': '?',
          '%23': '#',
          '%5B': '[',
          '%5D': ']',
          '%40': '@',
          // sub-delims
          '%21': '!',
          '%24': '$',
          '%26': '&',
          '%27': '\'',
          '%28': '(',
          '%29': ')',
          '%2A': '*',
          '%2B': '+',
          '%2C': ',',
          '%3B': ';',
          '%3D': '='
        }
      }
    },
    urnpath: {
      // The characters under `encode` are the characters called out by RFC 2141 as being acceptable
      // for usage in a URN. RFC2141 also calls out "-", ".", and "_" as acceptable characters, but
      // these aren't encoded by encodeURIComponent, so we don't have to call them out here. Also
      // note that the colon character is not featured in the encoding map; this is because URI.js
      // gives the colons in URNs semantic meaning as the delimiters of path segements, and so it
      // should not appear unencoded in a segment itself.
      // See also the note above about RFC3986 and capitalalized hex digits.
      encode: {
        expression: /%(21|24|27|28|29|2A|2B|2C|3B|3D|40)/ig,
        map: {
          '%21': '!',
          '%24': '$',
          '%27': '\'',
          '%28': '(',
          '%29': ')',
          '%2A': '*',
          '%2B': '+',
          '%2C': ',',
          '%3B': ';',
          '%3D': '=',
          '%40': '@'
        }
      },
      // These characters are the characters called out by RFC2141 as "reserved" characters that
      // should never appear in a URN, plus the colon character (see note above).
      decode: {
        expression: /[\/\?#:]/g,
        map: {
          '/': '%2F',
          '?': '%3F',
          '#': '%23',
          ':': '%3A'
        }
      }
    }
  };
  URI.encodeQuery = function(string, escapeQuerySpace) {
    var escaped = URI.encode(string + '');
    if (escapeQuerySpace === undefined) {
      escapeQuerySpace = URI.escapeQuerySpace;
    }

    return escapeQuerySpace ? escaped.replace(/%20/g, '+') : escaped;
  };
  URI.decodeQuery = function(string, escapeQuerySpace) {
    string += '';
    if (escapeQuerySpace === undefined) {
      escapeQuerySpace = URI.escapeQuerySpace;
    }

    try {
      return URI.decode(escapeQuerySpace ? string.replace(/\+/g, '%20') : string);
    } catch(e) {
      // we're not going to mess with weird encodings,
      // give up and return the undecoded original string
      // see https://github.com/medialize/URI.js/issues/87
      // see https://github.com/medialize/URI.js/issues/92
      return string;
    }
  };
  // generate encode/decode path functions
  var _parts = {'encode':'encode', 'decode':'decode'};
  var _part;
  var generateAccessor = function(_group, _part) {
    return function(string) {
      try {
        return URI[_part](string + '').replace(URI.characters[_group][_part].expression, function(c) {
          return URI.characters[_group][_part].map[c];
        });
      } catch (e) {
        // we're not going to mess with weird encodings,
        // give up and return the undecoded original string
        // see https://github.com/medialize/URI.js/issues/87
        // see https://github.com/medialize/URI.js/issues/92
        return string;
      }
    };
  };

  for (_part in _parts) {
    URI[_part + 'PathSegment'] = generateAccessor('pathname', _parts[_part]);
    URI[_part + 'UrnPathSegment'] = generateAccessor('urnpath', _parts[_part]);
  }

  var generateSegmentedPathFunction = function(_sep, _codingFuncName, _innerCodingFuncName) {
    return function(string) {
      // Why pass in names of functions, rather than the function objects themselves? The
      // definitions of some functions (but in particular, URI.decode) will occasionally change due
      // to URI.js having ISO8859 and Unicode modes. Passing in the name and getting it will ensure
      // that the functions we use here are "fresh".
      var actualCodingFunc;
      if (!_innerCodingFuncName) {
        actualCodingFunc = URI[_codingFuncName];
      } else {
        actualCodingFunc = function(string) {
          return URI[_codingFuncName](URI[_innerCodingFuncName](string));
        };
      }

      var segments = (string + '').split(_sep);

      for (var i = 0, length = segments.length; i < length; i++) {
        segments[i] = actualCodingFunc(segments[i]);
      }

      return segments.join(_sep);
    };
  };

  // This takes place outside the above loop because we don't want, e.g., encodeUrnPath functions.
  URI.decodePath = generateSegmentedPathFunction('/', 'decodePathSegment');
  URI.decodeUrnPath = generateSegmentedPathFunction(':', 'decodeUrnPathSegment');
  URI.recodePath = generateSegmentedPathFunction('/', 'encodePathSegment', 'decode');
  URI.recodeUrnPath = generateSegmentedPathFunction(':', 'encodeUrnPathSegment', 'decode');

  URI.encodeReserved = generateAccessor('reserved', 'encode');

  URI.parse = function(string, parts) {
    var pos;
    if (!parts) {
      parts = {};
    }
    // [protocol"://"[username[":"password]"@"]hostname[":"port]"/"?][path]["?"querystring]["#"fragment]

    // extract fragment
    pos = string.indexOf('#');
    if (pos > -1) {
      // escaping?
      parts.fragment = string.substring(pos + 1) || null;
      string = string.substring(0, pos);
    }

    // extract query
    pos = string.indexOf('?');
    if (pos > -1) {
      // escaping?
      parts.query = string.substring(pos + 1) || null;
      string = string.substring(0, pos);
    }

    // extract protocol
    if (string.substring(0, 2) === '//') {
      // relative-scheme
      parts.protocol = null;
      string = string.substring(2);
      // extract "user:pass@host:port"
      string = URI.parseAuthority(string, parts);
    } else {
      pos = string.indexOf(':');
      if (pos > -1) {
        parts.protocol = string.substring(0, pos) || null;
        if (parts.protocol && !parts.protocol.match(URI.protocol_expression)) {
          // : may be within the path
          parts.protocol = undefined;
        } else if (string.substring(pos + 1, pos + 3) === '//') {
          string = string.substring(pos + 3);

          // extract "user:pass@host:port"
          string = URI.parseAuthority(string, parts);
        } else {
          string = string.substring(pos + 1);
          parts.urn = true;
        }
      }
    }

    // what's left must be the path
    parts.path = string;

    // and we're done
    return parts;
  };
  URI.parseHost = function(string, parts) {
    // Copy chrome, IE, opera backslash-handling behavior.
    // Back slashes before the query string get converted to forward slashes
    // See: https://github.com/joyent/node/blob/386fd24f49b0e9d1a8a076592a404168faeecc34/lib/url.js#L115-L124
    // See: https://code.google.com/p/chromium/issues/detail?id=25916
    // https://github.com/medialize/URI.js/pull/233
    string = string.replace(/\\/g, '/');

    // extract host:port
    var pos = string.indexOf('/');
    var bracketPos;
    var t;

    if (pos === -1) {
      pos = string.length;
    }

    if (string.charAt(0) === '[') {
      // IPv6 host - http://tools.ietf.org/html/draft-ietf-6man-text-addr-representation-04#section-6
      // I claim most client software breaks on IPv6 anyways. To simplify things, URI only accepts
      // IPv6+port in the format [2001:db8::1]:80 (for the time being)
      bracketPos = string.indexOf(']');
      parts.hostname = string.substring(1, bracketPos) || null;
      parts.port = string.substring(bracketPos + 2, pos) || null;
      if (parts.port === '/') {
        parts.port = null;
      }
    } else {
      var firstColon = string.indexOf(':');
      var firstSlash = string.indexOf('/');
      var nextColon = string.indexOf(':', firstColon + 1);
      if (nextColon !== -1 && (firstSlash === -1 || nextColon < firstSlash)) {
        // IPv6 host contains multiple colons - but no port
        // this notation is actually not allowed by RFC 3986, but we're a liberal parser
        parts.hostname = string.substring(0, pos) || null;
        parts.port = null;
      } else {
        t = string.substring(0, pos).split(':');
        parts.hostname = t[0] || null;
        parts.port = t[1] || null;
      }
    }

    if (parts.hostname && string.substring(pos).charAt(0) !== '/') {
      pos++;
      string = '/' + string;
    }

    URI.ensureValidHostname(parts.hostname, parts.protocol);

    if (parts.port) {
      URI.ensureValidPort(parts.port);
    }

    return string.substring(pos) || '/';
  };
  URI.parseAuthority = function(string, parts) {
    string = URI.parseUserinfo(string, parts);
    return URI.parseHost(string, parts);
  };
  URI.parseUserinfo = function(string, parts) {
    // extract username:password
    var firstSlash = string.indexOf('/');
    var pos = string.lastIndexOf('@', firstSlash > -1 ? firstSlash : string.length - 1);
    var t;

    // authority@ must come before /path
    if (pos > -1 && (firstSlash === -1 || pos < firstSlash)) {
      t = string.substring(0, pos).split(':');
      parts.username = t[0] ? URI.decode(t[0]) : null;
      t.shift();
      parts.password = t[0] ? URI.decode(t.join(':')) : null;
      string = string.substring(pos + 1);
    } else {
      parts.username = null;
      parts.password = null;
    }

    return string;
  };
  URI.parseQuery = function(string, escapeQuerySpace) {
    if (!string) {
      return {};
    }

    // throw out the funky business - "?"[name"="value"&"]+
    string = string.replace(/&+/g, '&').replace(/^\?*&*|&+$/g, '');

    if (!string) {
      return {};
    }

    var items = {};
    var splits = string.split('&');
    var length = splits.length;
    var v, name, value;

    for (var i = 0; i < length; i++) {
      v = splits[i].split('=');
      name = URI.decodeQuery(v.shift(), escapeQuerySpace);
      // no "=" is null according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#collect-url-parameters
      value = v.length ? URI.decodeQuery(v.join('='), escapeQuerySpace) : null;

      if (hasOwn.call(items, name)) {
        if (typeof items[name] === 'string' || items[name] === null) {
          items[name] = [items[name]];
        }

        items[name].push(value);
      } else {
        items[name] = value;
      }
    }

    return items;
  };

  URI.build = function(parts) {
    var t = '';

    if (parts.protocol) {
      t += parts.protocol + ':';
    }

    if (!parts.urn && (t || parts.hostname)) {
      t += '//';
    }

    t += (URI.buildAuthority(parts) || '');

    if (typeof parts.path === 'string') {
      if (parts.path.charAt(0) !== '/' && typeof parts.hostname === 'string') {
        t += '/';
      }

      t += parts.path;
    }

    if (typeof parts.query === 'string' && parts.query) {
      t += '?' + parts.query;
    }

    if (typeof parts.fragment === 'string' && parts.fragment) {
      t += '#' + parts.fragment;
    }
    return t;
  };
  URI.buildHost = function(parts) {
    var t = '';

    if (!parts.hostname) {
      return '';
    } else if (URI.ip6_expression.test(parts.hostname)) {
      t += '[' + parts.hostname + ']';
    } else {
      t += parts.hostname;
    }

    if (parts.port) {
      t += ':' + parts.port;
    }

    return t;
  };
  URI.buildAuthority = function(parts) {
    return URI.buildUserinfo(parts) + URI.buildHost(parts);
  };
  URI.buildUserinfo = function(parts) {
    var t = '';

    if (parts.username) {
      t += URI.encode(parts.username);
    }

    if (parts.password) {
      t += ':' + URI.encode(parts.password);
    }

    if (t) {
      t += '@';
    }

    return t;
  };
  URI.buildQuery = function(data, duplicateQueryParameters, escapeQuerySpace) {
    // according to http://tools.ietf.org/html/rfc3986 or http://labs.apache.org/webarch/uri/rfc/rfc3986.html
    // being »-._~!$&'()*+,;=:@/?« %HEX and alnum are allowed
    // the RFC explicitly states ?/foo being a valid use case, no mention of parameter syntax!
    // URI.js treats the query string as being application/x-www-form-urlencoded
    // see http://www.w3.org/TR/REC-html40/interact/forms.html#form-content-type

    var t = '';
    var unique, key, i, length;
    for (key in data) {
      if (hasOwn.call(data, key) && key) {
        if (isArray(data[key])) {
          unique = {};
          for (i = 0, length = data[key].length; i < length; i++) {
            if (data[key][i] !== undefined && unique[data[key][i] + ''] === undefined) {
              t += '&' + URI.buildQueryParameter(key, data[key][i], escapeQuerySpace);
              if (duplicateQueryParameters !== true) {
                unique[data[key][i] + ''] = true;
              }
            }
          }
        } else if (data[key] !== undefined) {
          t += '&' + URI.buildQueryParameter(key, data[key], escapeQuerySpace);
        }
      }
    }

    return t.substring(1);
  };
  URI.buildQueryParameter = function(name, value, escapeQuerySpace) {
    // http://www.w3.org/TR/REC-html40/interact/forms.html#form-content-type -- application/x-www-form-urlencoded
    // don't append "=" for null values, according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#url-parameter-serialization
    return URI.encodeQuery(name, escapeQuerySpace) + (value !== null ? '=' + URI.encodeQuery(value, escapeQuerySpace) : '');
  };

  URI.addQuery = function(data, name, value) {
    if (typeof name === 'object') {
      for (var key in name) {
        if (hasOwn.call(name, key)) {
          URI.addQuery(data, key, name[key]);
        }
      }
    } else if (typeof name === 'string') {
      if (data[name] === undefined) {
        data[name] = value;
        return;
      } else if (typeof data[name] === 'string') {
        data[name] = [data[name]];
      }

      if (!isArray(value)) {
        value = [value];
      }

      data[name] = (data[name] || []).concat(value);
    } else {
      throw new TypeError('URI.addQuery() accepts an object, string as the name parameter');
    }
  };
  URI.removeQuery = function(data, name, value) {
    var i, length, key;

    if (isArray(name)) {
      for (i = 0, length = name.length; i < length; i++) {
        data[name[i]] = undefined;
      }
    } else if (getType(name) === 'RegExp') {
      for (key in data) {
        if (name.test(key)) {
          data[key] = undefined;
        }
      }
    } else if (typeof name === 'object') {
      for (key in name) {
        if (hasOwn.call(name, key)) {
          URI.removeQuery(data, key, name[key]);
        }
      }
    } else if (typeof name === 'string') {
      if (value !== undefined) {
        if (getType(value) === 'RegExp') {
          if (!isArray(data[name]) && value.test(data[name])) {
            data[name] = undefined;
          } else {
            data[name] = filterArrayValues(data[name], value);
          }
        } else if (data[name] === String(value) && (!isArray(value) || value.length === 1)) {
          data[name] = undefined;
        } else if (isArray(data[name])) {
          data[name] = filterArrayValues(data[name], value);
        }
      } else {
        data[name] = undefined;
      }
    } else {
      throw new TypeError('URI.removeQuery() accepts an object, string, RegExp as the first parameter');
    }
  };
  URI.hasQuery = function(data, name, value, withinArray) {
    switch (getType(name)) {
      case 'String':
        // Nothing to do here
        break;

      case 'RegExp':
        for (var key in data) {
          if (hasOwn.call(data, key)) {
            if (name.test(key) && (value === undefined || URI.hasQuery(data, key, value))) {
              return true;
            }
          }
        }

        return false;

      case 'Object':
        for (var _key in name) {
          if (hasOwn.call(name, _key)) {
            if (!URI.hasQuery(data, _key, name[_key])) {
              return false;
            }
          }
        }

        return true;

      default:
        throw new TypeError('URI.hasQuery() accepts a string, regular expression or object as the name parameter');
    }

    switch (getType(value)) {
      case 'Undefined':
        // true if exists (but may be empty)
        return name in data; // data[name] !== undefined;

      case 'Boolean':
        // true if exists and non-empty
        var _booly = Boolean(isArray(data[name]) ? data[name].length : data[name]);
        return value === _booly;

      case 'Function':
        // allow complex comparison
        return !!value(data[name], name, data);

      case 'Array':
        if (!isArray(data[name])) {
          return false;
        }

        var op = withinArray ? arrayContains : arraysEqual;
        return op(data[name], value);

      case 'RegExp':
        if (!isArray(data[name])) {
          return Boolean(data[name] && data[name].match(value));
        }

        if (!withinArray) {
          return false;
        }

        return arrayContains(data[name], value);

      case 'Number':
        value = String(value);
        /* falls through */
      case 'String':
        if (!isArray(data[name])) {
          return data[name] === value;
        }

        if (!withinArray) {
          return false;
        }

        return arrayContains(data[name], value);

      default:
        throw new TypeError('URI.hasQuery() accepts undefined, boolean, string, number, RegExp, Function as the value parameter');
    }
  };


  URI.joinPaths = function() {
    var input = [];
    var segments = [];
    var nonEmptySegments = 0;

    for (var i = 0; i < arguments.length; i++) {
      var url = new URI(arguments[i]);
      input.push(url);
      var _segments = url.segment();
      for (var s = 0; s < _segments.length; s++) {
        if (typeof _segments[s] === 'string') {
          segments.push(_segments[s]);
        }

        if (_segments[s]) {
          nonEmptySegments++;
        }
      }
    }

    if (!segments.length || !nonEmptySegments) {
      return new URI('');
    }

    var uri = new URI('').segment(segments);

    if (input[0].path() === '' || input[0].path().slice(0, 1) === '/') {
      uri.path('/' + uri.path());
    }

    return uri.normalize();
  };

  URI.commonPath = function(one, two) {
    var length = Math.min(one.length, two.length);
    var pos;

    // find first non-matching character
    for (pos = 0; pos < length; pos++) {
      if (one.charAt(pos) !== two.charAt(pos)) {
        pos--;
        break;
      }
    }

    if (pos < 1) {
      return one.charAt(0) === two.charAt(0) && one.charAt(0) === '/' ? '/' : '';
    }

    // revert to last /
    if (one.charAt(pos) !== '/' || two.charAt(pos) !== '/') {
      pos = one.substring(0, pos).lastIndexOf('/');
    }

    return one.substring(0, pos + 1);
  };

  URI.withinString = function(string, callback, options) {
    options || (options = {});
    var _start = options.start || URI.findUri.start;
    var _end = options.end || URI.findUri.end;
    var _trim = options.trim || URI.findUri.trim;
    var _parens = options.parens || URI.findUri.parens;
    var _attributeOpen = /[a-z0-9-]=["']?$/i;

    _start.lastIndex = 0;
    while (true) {
      var match = _start.exec(string);
      if (!match) {
        break;
      }

      var start = match.index;
      if (options.ignoreHtml) {
        // attribut(e=["']?$)
        var attributeOpen = string.slice(Math.max(start - 3, 0), start);
        if (attributeOpen && _attributeOpen.test(attributeOpen)) {
          continue;
        }
      }

      var end = start + string.slice(start).search(_end);
      var slice = string.slice(start, end);
      // make sure we include well balanced parens
      var parensEnd = -1;
      while (true) {
        var parensMatch = _parens.exec(slice);
        if (!parensMatch) {
          break;
        }

        var parensMatchEnd = parensMatch.index + parensMatch[0].length;
        parensEnd = Math.max(parensEnd, parensMatchEnd);
      }

      if (parensEnd > -1) {
        slice = slice.slice(0, parensEnd) + slice.slice(parensEnd).replace(_trim, '');
      } else {
        slice = slice.replace(_trim, '');
      }

      if (slice.length <= match[0].length) {
        // the extract only contains the starting marker of a URI,
        // e.g. "www" or "http://"
        continue;
      }

      if (options.ignore && options.ignore.test(slice)) {
        continue;
      }

      end = start + slice.length;
      var result = callback(slice, start, end, string);
      if (result === undefined) {
        _start.lastIndex = end;
        continue;
      }

      result = String(result);
      string = string.slice(0, start) + result + string.slice(end);
      _start.lastIndex = start + result.length;
    }

    _start.lastIndex = 0;
    return string;
  };

  URI.ensureValidHostname = function(v, protocol) {
    // Theoretically URIs allow percent-encoding in Hostnames (according to RFC 3986)
    // they are not part of DNS and therefore ignored by URI.js

    var hasHostname = !!v; // not null and not an empty string
    var hasProtocol = !!protocol;
    var rejectEmptyHostname = false;

    if (hasProtocol) {
      rejectEmptyHostname = arrayContains(URI.hostProtocols, protocol);
    }

    if (rejectEmptyHostname && !hasHostname) {
      throw new TypeError('Hostname cannot be empty, if protocol is ' + protocol);
    } else if (v && v.match(URI.invalid_hostname_characters)) {
      // test punycode
      if (!punycode) {
        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-:_] and Punycode.js is not available');
      }
      if (punycode.toASCII(v).match(URI.invalid_hostname_characters)) {
        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-:_]');
      }
    }
  };

  URI.ensureValidPort = function (v) {
    if (!v) {
      return;
    }

    var port = Number(v);
    if (isInteger(port) && (port > 0) && (port < 65536)) {
      return;
    }

    throw new TypeError('Port "' + v + '" is not a valid port');
  };

  // noConflict
  URI.noConflict = function(removeAll) {
    if (removeAll) {
      var unconflicted = {
        URI: this.noConflict()
      };

      if (root.URITemplate && typeof root.URITemplate.noConflict === 'function') {
        unconflicted.URITemplate = root.URITemplate.noConflict();
      }

      if (root.IPv6 && typeof root.IPv6.noConflict === 'function') {
        unconflicted.IPv6 = root.IPv6.noConflict();
      }

      if (root.SecondLevelDomains && typeof root.SecondLevelDomains.noConflict === 'function') {
        unconflicted.SecondLevelDomains = root.SecondLevelDomains.noConflict();
      }

      return unconflicted;
    } else if (root.URI === this) {
      root.URI = _URI;
    }

    return this;
  };

  p.build = function(deferBuild) {
    if (deferBuild === true) {
      this._deferred_build = true;
    } else if (deferBuild === undefined || this._deferred_build) {
      this._string = URI.build(this._parts);
      this._deferred_build = false;
    }

    return this;
  };

  p.clone = function() {
    return new URI(this);
  };

  p.valueOf = p.toString = function() {
    return this.build(false)._string;
  };


  function generateSimpleAccessor(_part){
    return function(v, build) {
      if (v === undefined) {
        return this._parts[_part] || '';
      } else {
        this._parts[_part] = v || null;
        this.build(!build);
        return this;
      }
    };
  }

  function generatePrefixAccessor(_part, _key){
    return function(v, build) {
      if (v === undefined) {
        return this._parts[_part] || '';
      } else {
        if (v !== null) {
          v = v + '';
          if (v.charAt(0) === _key) {
            v = v.substring(1);
          }
        }

        this._parts[_part] = v;
        this.build(!build);
        return this;
      }
    };
  }

  p.protocol = generateSimpleAccessor('protocol');
  p.username = generateSimpleAccessor('username');
  p.password = generateSimpleAccessor('password');
  p.hostname = generateSimpleAccessor('hostname');
  p.port = generateSimpleAccessor('port');
  p.query = generatePrefixAccessor('query', '?');
  p.fragment = generatePrefixAccessor('fragment', '#');

  p.search = function(v, build) {
    var t = this.query(v, build);
    return typeof t === 'string' && t.length ? ('?' + t) : t;
  };
  p.hash = function(v, build) {
    var t = this.fragment(v, build);
    return typeof t === 'string' && t.length ? ('#' + t) : t;
  };

  p.pathname = function(v, build) {
    if (v === undefined || v === true) {
      var res = this._parts.path || (this._parts.hostname ? '/' : '');
      return v ? (this._parts.urn ? URI.decodeUrnPath : URI.decodePath)(res) : res;
    } else {
      if (this._parts.urn) {
        this._parts.path = v ? URI.recodeUrnPath(v) : '';
      } else {
        this._parts.path = v ? URI.recodePath(v) : '/';
      }
      this.build(!build);
      return this;
    }
  };
  p.path = p.pathname;
  p.href = function(href, build) {
    var key;

    if (href === undefined) {
      return this.toString();
    }

    this._string = '';
    this._parts = URI._parts();

    var _URI = href instanceof URI;
    var _object = typeof href === 'object' && (href.hostname || href.path || href.pathname);
    if (href.nodeName) {
      var attribute = URI.getDomAttribute(href);
      href = href[attribute] || '';
      _object = false;
    }

    // window.location is reported to be an object, but it's not the sort
    // of object we're looking for:
    // * location.protocol ends with a colon
    // * location.query != object.search
    // * location.hash != object.fragment
    // simply serializing the unknown object should do the trick
    // (for location, not for everything...)
    if (!_URI && _object && href.pathname !== undefined) {
      href = href.toString();
    }

    if (typeof href === 'string' || href instanceof String) {
      this._parts = URI.parse(String(href), this._parts);
    } else if (_URI || _object) {
      var src = _URI ? href._parts : href;
      for (key in src) {
        if (hasOwn.call(this._parts, key)) {
          this._parts[key] = src[key];
        }
      }
    } else {
      throw new TypeError('invalid input');
    }

    this.build(!build);
    return this;
  };

  // identification accessors
  p.is = function(what) {
    var ip = false;
    var ip4 = false;
    var ip6 = false;
    var name = false;
    var sld = false;
    var idn = false;
    var punycode = false;
    var relative = !this._parts.urn;

    if (this._parts.hostname) {
      relative = false;
      ip4 = URI.ip4_expression.test(this._parts.hostname);
      ip6 = URI.ip6_expression.test(this._parts.hostname);
      ip = ip4 || ip6;
      name = !ip;
      sld = name && SLD && SLD.has(this._parts.hostname);
      idn = name && URI.idn_expression.test(this._parts.hostname);
      punycode = name && URI.punycode_expression.test(this._parts.hostname);
    }

    switch (what.toLowerCase()) {
      case 'relative':
        return relative;

      case 'absolute':
        return !relative;

      // hostname identification
      case 'domain':
      case 'name':
        return name;

      case 'sld':
        return sld;

      case 'ip':
        return ip;

      case 'ip4':
      case 'ipv4':
      case 'inet4':
        return ip4;

      case 'ip6':
      case 'ipv6':
      case 'inet6':
        return ip6;

      case 'idn':
        return idn;

      case 'url':
        return !this._parts.urn;

      case 'urn':
        return !!this._parts.urn;

      case 'punycode':
        return punycode;
    }

    return null;
  };

  // component specific input validation
  var _protocol = p.protocol;
  var _port = p.port;
  var _hostname = p.hostname;

  p.protocol = function(v, build) {
    if (v !== undefined) {
      if (v) {
        // accept trailing ://
        v = v.replace(/:(\/\/)?$/, '');

        if (!v.match(URI.protocol_expression)) {
          throw new TypeError('Protocol "' + v + '" contains characters other than [A-Z0-9.+-] or doesn\'t start with [A-Z]');
        }
      }
    }
    return _protocol.call(this, v, build);
  };
  p.scheme = p.protocol;
  p.port = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v !== undefined) {
      if (v === 0) {
        v = null;
      }

      if (v) {
        v += '';
        if (v.charAt(0) === ':') {
          v = v.substring(1);
        }

        URI.ensureValidPort(v);
      }
    }
    return _port.call(this, v, build);
  };
  p.hostname = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v !== undefined) {
      var x = {};
      var res = URI.parseHost(v, x);
      if (res !== '/') {
        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
      }

      v = x.hostname;
      URI.ensureValidHostname(v, this._parts.protocol);
    }
    return _hostname.call(this, v, build);
  };

  // compound accessors
  p.origin = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined) {
      var protocol = this.protocol();
      var authority = this.authority();
      if (!authority) {
        return '';
      }

      return (protocol ? protocol + '://' : '') + this.authority();
    } else {
      var origin = URI(v);
      this
        .protocol(origin.protocol())
        .authority(origin.authority())
        .build(!build);
      return this;
    }
  };
  p.host = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined) {
      return this._parts.hostname ? URI.buildHost(this._parts) : '';
    } else {
      var res = URI.parseHost(v, this._parts);
      if (res !== '/') {
        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
      }

      this.build(!build);
      return this;
    }
  };
  p.authority = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined) {
      return this._parts.hostname ? URI.buildAuthority(this._parts) : '';
    } else {
      var res = URI.parseAuthority(v, this._parts);
      if (res !== '/') {
        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
      }

      this.build(!build);
      return this;
    }
  };
  p.userinfo = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined) {
      var t = URI.buildUserinfo(this._parts);
      return t ? t.substring(0, t.length -1) : t;
    } else {
      if (v[v.length-1] !== '@') {
        v += '@';
      }

      URI.parseUserinfo(v, this._parts);
      this.build(!build);
      return this;
    }
  };
  p.resource = function(v, build) {
    var parts;

    if (v === undefined) {
      return this.path() + this.search() + this.hash();
    }

    parts = URI.parse(v);
    this._parts.path = parts.path;
    this._parts.query = parts.query;
    this._parts.fragment = parts.fragment;
    this.build(!build);
    return this;
  };

  // fraction accessors
  p.subdomain = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    // convenience, return "www" from "www.example.org"
    if (v === undefined) {
      if (!this._parts.hostname || this.is('IP')) {
        return '';
      }

      // grab domain and add another segment
      var end = this._parts.hostname.length - this.domain().length - 1;
      return this._parts.hostname.substring(0, end) || '';
    } else {
      var e = this._parts.hostname.length - this.domain().length;
      var sub = this._parts.hostname.substring(0, e);
      var replace = new RegExp('^' + escapeRegEx(sub));

      if (v && v.charAt(v.length - 1) !== '.') {
        v += '.';
      }

      if (v.indexOf(':') !== -1) {
        throw new TypeError('Domains cannot contain colons');
      }

      if (v) {
        URI.ensureValidHostname(v, this._parts.protocol);
      }

      this._parts.hostname = this._parts.hostname.replace(replace, v);
      this.build(!build);
      return this;
    }
  };
  p.domain = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (typeof v === 'boolean') {
      build = v;
      v = undefined;
    }

    // convenience, return "example.org" from "www.example.org"
    if (v === undefined) {
      if (!this._parts.hostname || this.is('IP')) {
        return '';
      }

      // if hostname consists of 1 or 2 segments, it must be the domain
      var t = this._parts.hostname.match(/\./g);
      if (t && t.length < 2) {
        return this._parts.hostname;
      }

      // grab tld and add another segment
      var end = this._parts.hostname.length - this.tld(build).length - 1;
      end = this._parts.hostname.lastIndexOf('.', end -1) + 1;
      return this._parts.hostname.substring(end) || '';
    } else {
      if (!v) {
        throw new TypeError('cannot set domain empty');
      }

      if (v.indexOf(':') !== -1) {
        throw new TypeError('Domains cannot contain colons');
      }

      URI.ensureValidHostname(v, this._parts.protocol);

      if (!this._parts.hostname || this.is('IP')) {
        this._parts.hostname = v;
      } else {
        var replace = new RegExp(escapeRegEx(this.domain()) + '$');
        this._parts.hostname = this._parts.hostname.replace(replace, v);
      }

      this.build(!build);
      return this;
    }
  };
  p.tld = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (typeof v === 'boolean') {
      build = v;
      v = undefined;
    }

    // return "org" from "www.example.org"
    if (v === undefined) {
      if (!this._parts.hostname || this.is('IP')) {
        return '';
      }

      var pos = this._parts.hostname.lastIndexOf('.');
      var tld = this._parts.hostname.substring(pos + 1);

      if (build !== true && SLD && SLD.list[tld.toLowerCase()]) {
        return SLD.get(this._parts.hostname) || tld;
      }

      return tld;
    } else {
      var replace;

      if (!v) {
        throw new TypeError('cannot set TLD empty');
      } else if (v.match(/[^a-zA-Z0-9-]/)) {
        if (SLD && SLD.is(v)) {
          replace = new RegExp(escapeRegEx(this.tld()) + '$');
          this._parts.hostname = this._parts.hostname.replace(replace, v);
        } else {
          throw new TypeError('TLD "' + v + '" contains characters other than [A-Z0-9]');
        }
      } else if (!this._parts.hostname || this.is('IP')) {
        throw new ReferenceError('cannot set TLD on non-domain host');
      } else {
        replace = new RegExp(escapeRegEx(this.tld()) + '$');
        this._parts.hostname = this._parts.hostname.replace(replace, v);
      }

      this.build(!build);
      return this;
    }
  };
  p.directory = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined || v === true) {
      if (!this._parts.path && !this._parts.hostname) {
        return '';
      }

      if (this._parts.path === '/') {
        return '/';
      }

      var end = this._parts.path.length - this.filename().length - 1;
      var res = this._parts.path.substring(0, end) || (this._parts.hostname ? '/' : '');

      return v ? URI.decodePath(res) : res;

    } else {
      var e = this._parts.path.length - this.filename().length;
      var directory = this._parts.path.substring(0, e);
      var replace = new RegExp('^' + escapeRegEx(directory));

      // fully qualifier directories begin with a slash
      if (!this.is('relative')) {
        if (!v) {
          v = '/';
        }

        if (v.charAt(0) !== '/') {
          v = '/' + v;
        }
      }

      // directories always end with a slash
      if (v && v.charAt(v.length - 1) !== '/') {
        v += '/';
      }

      v = URI.recodePath(v);
      this._parts.path = this._parts.path.replace(replace, v);
      this.build(!build);
      return this;
    }
  };
  p.filename = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (typeof v !== 'string') {
      if (!this._parts.path || this._parts.path === '/') {
        return '';
      }

      var pos = this._parts.path.lastIndexOf('/');
      var res = this._parts.path.substring(pos+1);

      return v ? URI.decodePathSegment(res) : res;
    } else {
      var mutatedDirectory = false;

      if (v.charAt(0) === '/') {
        v = v.substring(1);
      }

      if (v.match(/\.?\//)) {
        mutatedDirectory = true;
      }

      var replace = new RegExp(escapeRegEx(this.filename()) + '$');
      v = URI.recodePath(v);
      this._parts.path = this._parts.path.replace(replace, v);

      if (mutatedDirectory) {
        this.normalizePath(build);
      } else {
        this.build(!build);
      }

      return this;
    }
  };
  p.suffix = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined || v === true) {
      if (!this._parts.path || this._parts.path === '/') {
        return '';
      }

      var filename = this.filename();
      var pos = filename.lastIndexOf('.');
      var s, res;

      if (pos === -1) {
        return '';
      }

      // suffix may only contain alnum characters (yup, I made this up.)
      s = filename.substring(pos+1);
      res = (/^[a-z0-9%]+$/i).test(s) ? s : '';
      return v ? URI.decodePathSegment(res) : res;
    } else {
      if (v.charAt(0) === '.') {
        v = v.substring(1);
      }

      var suffix = this.suffix();
      var replace;

      if (!suffix) {
        if (!v) {
          return this;
        }

        this._parts.path += '.' + URI.recodePath(v);
      } else if (!v) {
        replace = new RegExp(escapeRegEx('.' + suffix) + '$');
      } else {
        replace = new RegExp(escapeRegEx(suffix) + '$');
      }

      if (replace) {
        v = URI.recodePath(v);
        this._parts.path = this._parts.path.replace(replace, v);
      }

      this.build(!build);
      return this;
    }
  };
  p.segment = function(segment, v, build) {
    var separator = this._parts.urn ? ':' : '/';
    var path = this.path();
    var absolute = path.substring(0, 1) === '/';
    var segments = path.split(separator);

    if (segment !== undefined && typeof segment !== 'number') {
      build = v;
      v = segment;
      segment = undefined;
    }

    if (segment !== undefined && typeof segment !== 'number') {
      throw new Error('Bad segment "' + segment + '", must be 0-based integer');
    }

    if (absolute) {
      segments.shift();
    }

    if (segment < 0) {
      // allow negative indexes to address from the end
      segment = Math.max(segments.length + segment, 0);
    }

    if (v === undefined) {
      /*jshint laxbreak: true */
      return segment === undefined
        ? segments
        : segments[segment];
      /*jshint laxbreak: false */
    } else if (segment === null || segments[segment] === undefined) {
      if (isArray(v)) {
        segments = [];
        // collapse empty elements within array
        for (var i=0, l=v.length; i < l; i++) {
          if (!v[i].length && (!segments.length || !segments[segments.length -1].length)) {
            continue;
          }

          if (segments.length && !segments[segments.length -1].length) {
            segments.pop();
          }

          segments.push(trimSlashes(v[i]));
        }
      } else if (v || typeof v === 'string') {
        v = trimSlashes(v);
        if (segments[segments.length -1] === '') {
          // empty trailing elements have to be overwritten
          // to prevent results such as /foo//bar
          segments[segments.length -1] = v;
        } else {
          segments.push(v);
        }
      }
    } else {
      if (v) {
        segments[segment] = trimSlashes(v);
      } else {
        segments.splice(segment, 1);
      }
    }

    if (absolute) {
      segments.unshift('');
    }

    return this.path(segments.join(separator), build);
  };
  p.segmentCoded = function(segment, v, build) {
    var segments, i, l;

    if (typeof segment !== 'number') {
      build = v;
      v = segment;
      segment = undefined;
    }

    if (v === undefined) {
      segments = this.segment(segment, v, build);
      if (!isArray(segments)) {
        segments = segments !== undefined ? URI.decode(segments) : undefined;
      } else {
        for (i = 0, l = segments.length; i < l; i++) {
          segments[i] = URI.decode(segments[i]);
        }
      }

      return segments;
    }

    if (!isArray(v)) {
      v = (typeof v === 'string' || v instanceof String) ? URI.encode(v) : v;
    } else {
      for (i = 0, l = v.length; i < l; i++) {
        v[i] = URI.encode(v[i]);
      }
    }

    return this.segment(segment, v, build);
  };

  // mutating query string
  var q = p.query;
  p.query = function(v, build) {
    if (v === true) {
      return URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
    } else if (typeof v === 'function') {
      var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
      var result = v.call(this, data);
      this._parts.query = URI.buildQuery(result || data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
      this.build(!build);
      return this;
    } else if (v !== undefined && typeof v !== 'string') {
      this._parts.query = URI.buildQuery(v, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
      this.build(!build);
      return this;
    } else {
      return q.call(this, v, build);
    }
  };
  p.setQuery = function(name, value, build) {
    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);

    if (typeof name === 'string' || name instanceof String) {
      data[name] = value !== undefined ? value : null;
    } else if (typeof name === 'object') {
      for (var key in name) {
        if (hasOwn.call(name, key)) {
          data[key] = name[key];
        }
      }
    } else {
      throw new TypeError('URI.addQuery() accepts an object, string as the name parameter');
    }

    this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
    if (typeof name !== 'string') {
      build = value;
    }

    this.build(!build);
    return this;
  };
  p.addQuery = function(name, value, build) {
    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
    URI.addQuery(data, name, value === undefined ? null : value);
    this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
    if (typeof name !== 'string') {
      build = value;
    }

    this.build(!build);
    return this;
  };
  p.removeQuery = function(name, value, build) {
    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
    URI.removeQuery(data, name, value);
    this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
    if (typeof name !== 'string') {
      build = value;
    }

    this.build(!build);
    return this;
  };
  p.hasQuery = function(name, value, withinArray) {
    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
    return URI.hasQuery(data, name, value, withinArray);
  };
  p.setSearch = p.setQuery;
  p.addSearch = p.addQuery;
  p.removeSearch = p.removeQuery;
  p.hasSearch = p.hasQuery;

  // sanitizing URLs
  p.normalize = function() {
    if (this._parts.urn) {
      return this
        .normalizeProtocol(false)
        .normalizePath(false)
        .normalizeQuery(false)
        .normalizeFragment(false)
        .build();
    }

    return this
      .normalizeProtocol(false)
      .normalizeHostname(false)
      .normalizePort(false)
      .normalizePath(false)
      .normalizeQuery(false)
      .normalizeFragment(false)
      .build();
  };
  p.normalizeProtocol = function(build) {
    if (typeof this._parts.protocol === 'string') {
      this._parts.protocol = this._parts.protocol.toLowerCase();
      this.build(!build);
    }

    return this;
  };
  p.normalizeHostname = function(build) {
    if (this._parts.hostname) {
      if (this.is('IDN') && punycode) {
        this._parts.hostname = punycode.toASCII(this._parts.hostname);
      } else if (this.is('IPv6') && IPv6) {
        this._parts.hostname = IPv6.best(this._parts.hostname);
      }

      this._parts.hostname = this._parts.hostname.toLowerCase();
      this.build(!build);
    }

    return this;
  };
  p.normalizePort = function(build) {
    // remove port of it's the protocol's default
    if (typeof this._parts.protocol === 'string' && this._parts.port === URI.defaultPorts[this._parts.protocol]) {
      this._parts.port = null;
      this.build(!build);
    }

    return this;
  };
  p.normalizePath = function(build) {
    var _path = this._parts.path;
    if (!_path) {
      return this;
    }

    if (this._parts.urn) {
      this._parts.path = URI.recodeUrnPath(this._parts.path);
      this.build(!build);
      return this;
    }

    if (this._parts.path === '/') {
      return this;
    }

    _path = URI.recodePath(_path);

    var _was_relative;
    var _leadingParents = '';
    var _parent, _pos;

    // handle relative paths
    if (_path.charAt(0) !== '/') {
      _was_relative = true;
      _path = '/' + _path;
    }

    // handle relative files (as opposed to directories)
    if (_path.slice(-3) === '/..' || _path.slice(-2) === '/.') {
      _path += '/';
    }

    // resolve simples
    _path = _path
      .replace(/(\/(\.\/)+)|(\/\.$)/g, '/')
      .replace(/\/{2,}/g, '/');

    // remember leading parents
    if (_was_relative) {
      _leadingParents = _path.substring(1).match(/^(\.\.\/)+/) || '';
      if (_leadingParents) {
        _leadingParents = _leadingParents[0];
      }
    }

    // resolve parents
    while (true) {
      _parent = _path.search(/\/\.\.(\/|$)/);
      if (_parent === -1) {
        // no more ../ to resolve
        break;
      } else if (_parent === 0) {
        // top level cannot be relative, skip it
        _path = _path.substring(3);
        continue;
      }

      _pos = _path.substring(0, _parent).lastIndexOf('/');
      if (_pos === -1) {
        _pos = _parent;
      }
      _path = _path.substring(0, _pos) + _path.substring(_parent + 3);
    }

    // revert to relative
    if (_was_relative && this.is('relative')) {
      _path = _leadingParents + _path.substring(1);
    }

    this._parts.path = _path;
    this.build(!build);
    return this;
  };
  p.normalizePathname = p.normalizePath;
  p.normalizeQuery = function(build) {
    if (typeof this._parts.query === 'string') {
      if (!this._parts.query.length) {
        this._parts.query = null;
      } else {
        this.query(URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace));
      }

      this.build(!build);
    }

    return this;
  };
  p.normalizeFragment = function(build) {
    if (!this._parts.fragment) {
      this._parts.fragment = null;
      this.build(!build);
    }

    return this;
  };
  p.normalizeSearch = p.normalizeQuery;
  p.normalizeHash = p.normalizeFragment;

  p.iso8859 = function() {
    // expect unicode input, iso8859 output
    var e = URI.encode;
    var d = URI.decode;

    URI.encode = escape;
    URI.decode = decodeURIComponent;
    try {
      this.normalize();
    } finally {
      URI.encode = e;
      URI.decode = d;
    }
    return this;
  };

  p.unicode = function() {
    // expect iso8859 input, unicode output
    var e = URI.encode;
    var d = URI.decode;

    URI.encode = strictEncodeURIComponent;
    URI.decode = unescape;
    try {
      this.normalize();
    } finally {
      URI.encode = e;
      URI.decode = d;
    }
    return this;
  };

  p.readable = function() {
    var uri = this.clone();
    // removing username, password, because they shouldn't be displayed according to RFC 3986
    uri.username('').password('').normalize();
    var t = '';
    if (uri._parts.protocol) {
      t += uri._parts.protocol + '://';
    }

    if (uri._parts.hostname) {
      if (uri.is('punycode') && punycode) {
        t += punycode.toUnicode(uri._parts.hostname);
        if (uri._parts.port) {
          t += ':' + uri._parts.port;
        }
      } else {
        t += uri.host();
      }
    }

    if (uri._parts.hostname && uri._parts.path && uri._parts.path.charAt(0) !== '/') {
      t += '/';
    }

    t += uri.path(true);
    if (uri._parts.query) {
      var q = '';
      for (var i = 0, qp = uri._parts.query.split('&'), l = qp.length; i < l; i++) {
        var kv = (qp[i] || '').split('=');
        q += '&' + URI.decodeQuery(kv[0], this._parts.escapeQuerySpace)
          .replace(/&/g, '%26');

        if (kv[1] !== undefined) {
          q += '=' + URI.decodeQuery(kv[1], this._parts.escapeQuerySpace)
            .replace(/&/g, '%26');
        }
      }
      t += '?' + q.substring(1);
    }

    t += URI.decodeQuery(uri.hash(), true);
    return t;
  };

  // resolving relative and absolute URLs
  p.absoluteTo = function(base) {
    var resolved = this.clone();
    var properties = ['protocol', 'username', 'password', 'hostname', 'port'];
    var basedir, i, p;

    if (this._parts.urn) {
      throw new Error('URNs do not have any generally defined hierarchical components');
    }

    if (!(base instanceof URI)) {
      base = new URI(base);
    }

    if (resolved._parts.protocol) {
      // Directly returns even if this._parts.hostname is empty.
      return resolved;
    } else {
      resolved._parts.protocol = base._parts.protocol;
    }

    if (this._parts.hostname) {
      return resolved;
    }

    for (i = 0; (p = properties[i]); i++) {
      resolved._parts[p] = base._parts[p];
    }

    if (!resolved._parts.path) {
      resolved._parts.path = base._parts.path;
      if (!resolved._parts.query) {
        resolved._parts.query = base._parts.query;
      }
    } else {
      if (resolved._parts.path.substring(-2) === '..') {
        resolved._parts.path += '/';
      }

      if (resolved.path().charAt(0) !== '/') {
        basedir = base.directory();
        basedir = basedir ? basedir : base.path().indexOf('/') === 0 ? '/' : '';
        resolved._parts.path = (basedir ? (basedir + '/') : '') + resolved._parts.path;
        resolved.normalizePath();
      }
    }

    resolved.build();
    return resolved;
  };
  p.relativeTo = function(base) {
    var relative = this.clone().normalize();
    var relativeParts, baseParts, common, relativePath, basePath;

    if (relative._parts.urn) {
      throw new Error('URNs do not have any generally defined hierarchical components');
    }

    base = new URI(base).normalize();
    relativeParts = relative._parts;
    baseParts = base._parts;
    relativePath = relative.path();
    basePath = base.path();

    if (relativePath.charAt(0) !== '/') {
      throw new Error('URI is already relative');
    }

    if (basePath.charAt(0) !== '/') {
      throw new Error('Cannot calculate a URI relative to another relative URI');
    }

    if (relativeParts.protocol === baseParts.protocol) {
      relativeParts.protocol = null;
    }

    if (relativeParts.username !== baseParts.username || relativeParts.password !== baseParts.password) {
      return relative.build();
    }

    if (relativeParts.protocol !== null || relativeParts.username !== null || relativeParts.password !== null) {
      return relative.build();
    }

    if (relativeParts.hostname === baseParts.hostname && relativeParts.port === baseParts.port) {
      relativeParts.hostname = null;
      relativeParts.port = null;
    } else {
      return relative.build();
    }

    if (relativePath === basePath) {
      relativeParts.path = '';
      return relative.build();
    }

    // determine common sub path
    common = URI.commonPath(relativePath, basePath);

    // If the paths have nothing in common, return a relative URL with the absolute path.
    if (!common) {
      return relative.build();
    }

    var parents = baseParts.path
      .substring(common.length)
      .replace(/[^\/]*$/, '')
      .replace(/.*?\//g, '../');

    relativeParts.path = (parents + relativeParts.path.substring(common.length)) || './';

    return relative.build();
  };

  // comparing URIs
  p.equals = function(uri) {
    var one = this.clone();
    var two = new URI(uri);
    var one_map = {};
    var two_map = {};
    var checked = {};
    var one_query, two_query, key;

    one.normalize();
    two.normalize();

    // exact match
    if (one.toString() === two.toString()) {
      return true;
    }

    // extract query string
    one_query = one.query();
    two_query = two.query();
    one.query('');
    two.query('');

    // definitely not equal if not even non-query parts match
    if (one.toString() !== two.toString()) {
      return false;
    }

    // query parameters have the same length, even if they're permuted
    if (one_query.length !== two_query.length) {
      return false;
    }

    one_map = URI.parseQuery(one_query, this._parts.escapeQuerySpace);
    two_map = URI.parseQuery(two_query, this._parts.escapeQuerySpace);

    for (key in one_map) {
      if (hasOwn.call(one_map, key)) {
        if (!isArray(one_map[key])) {
          if (one_map[key] !== two_map[key]) {
            return false;
          }
        } else if (!arraysEqual(one_map[key], two_map[key])) {
          return false;
        }

        checked[key] = true;
      }
    }

    for (key in two_map) {
      if (hasOwn.call(two_map, key)) {
        if (!checked[key]) {
          // two contains a parameter not present in one
          return false;
        }
      }
    }

    return true;
  };

  // state
  p.duplicateQueryParameters = function(v) {
    this._parts.duplicateQueryParameters = !!v;
    return this;
  };

  p.escapeQuerySpace = function(v) {
    this._parts.escapeQuerySpace = !!v;
    return this;
  };

  return URI;
}));


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dataCapsule = __webpack_require__(68);

var _consts = __webpack_require__(11);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CartApi = function () {
  function CartApi(namespace) {
    _classCallCheck(this, CartApi);

    this.namespace = namespace;
    // if (utils.isDev()) {
    this.dataStorage = new _dataCapsule.DataCapsule({
      strategy: new _dataCapsule.LocalStorageStrategy(),
      namespace: namespace
    });
    // } else {
    //   this.dataStorage = new DataCapsule({
    //     strategy: new CachedStorageStrategy({
    //       remoteStrategy: new WixStorageStrategy(),
    //       localStrategy: new LocalStorageStrategy()
    //     }),
    //     namespace
    //   });
    // }
  }

  _createClass(CartApi, [{
    key: 'addToCart',
    value: function addToCart(uuid, itemId, galleryId, providerId, quantity, isDemo, metadata) {
      var _this = this;

      var newItem = {
        uuid: uuid,
        itemId: itemId,
        galleryId: galleryId,
        providerId: providerId,
        quantity: quantity,
        isDemo: isDemo,
        metadata: metadata
      };
      return this.setItem(uuid, newItem).then(function () {
        _this.notifyCartChange();
      });
    }
  }, {
    key: 'removeFromCart',
    value: function removeFromCart(uuid) {
      var _this2 = this;

      return this.dataStorage.removeItem(uuid).then(function () {
        _this2.notifyCartChange();
      });
    }
  }, {
    key: 'notifyCartChange',
    value: function notifyCartChange() {
      if (window.Wix) {
        Wix.PubSub.publish(_consts.storePubSub.refreshCart, {}, true);
      }
    }
  }, {
    key: 'clearCart',
    value: function clearCart() {
      var _this3 = this;

      return this.getCartItems('*').then(function (arrItems) {
        var arrPromises = [];
        arrItems.forEach(function (item) {
          var uuid = item.uuid;

          arrPromises.push(_this3.dataStorage.removeItem(uuid));
        });

        return Promise.all(arrPromises);
      }).then(function () {
        _this3.notifyCartChange();
      });
    }
  }, {
    key: 'setItem',
    value: function setItem(uuid, item) /* 24 hours */{
      var expiration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 86400;

      return this.dataStorage.setItem(uuid, item, {
        expiration: expiration
      });
    }
  }, {
    key: 'updateCartItem',
    value: function updateCartItem(uuid, metadata, quantity) {
      var _this4 = this;

      return this.dataStorage.getItem(uuid).then(function (cartItem) {
        var returnPromise = null;
        if (cartItem) {
          cartItem.metadata = metadata || cartItem.metadata;
          cartItem.quantity = quantity || cartItem.quantity;
          returnPromise = _this4.setItem(uuid, cartItem).then(function () {
            _this4.notifyCartChange();
          });
        } else {
          returnPromise = Promise.reject('Item not found');
        }
        return returnPromise;
      });
    }
  }, {
    key: 'getCartItems',
    value: function getCartItems(connectedProviderId) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!connectedProviderId) {
        var message = 'Can\'t get cart items without providerId';
        console.error(message);
        throw message;
      }

      try {
        return this.dataStorage.getAllItems().then(function (objCartItems) {
          var cartItems = [];
          var itemUUID = options.uuid;
          for (var cartItemUuid in objCartItems) {
            var cartItemCandidate = objCartItems[cartItemUuid];
            var uuid = cartItemCandidate.uuid,
                providerId = cartItemCandidate.providerId;

            var isUUIDValid = !itemUUID || itemUUID === uuid;
            var isSameProviderId = !connectedProviderId || connectedProviderId === providerId || connectedProviderId === '*';
            var shouldAddItem = isUUIDValid && isSameProviderId;

            if (shouldAddItem) {
              var cartItem = objCartItems[uuid];
              cartItems.push(cartItem);
            }
          }

          return cartItems;
        });
      } catch (error) {
        console.error('CartApi - getCartItems - ERROR:', error);
      }
    }
  }, {
    key: 'containsDemoItems',
    value: function containsDemoItems(connectedProviderId) {
      return this.getCartItems(connectedProviderId).then(function (items) {
        return items.filter(function (item) {
          return item.isDemo;
        });
      }).then(function (demoItems) {
        return demoItems.length > 0;
      });
    }
  }, {
    key: 'createCartForm',
    value: function createCartForm() {
      this.hideCart();
      if (Wix.Utils.getViewMode() == 'site' || Wix.Utils.getViewMode() == 'preview') {
        Wix.openPopup(window.location.origin + '/cart-form.html?isStore=true', '0%', '100%', {
          origin: Wix.WindowOrigin.FIXED,
          placement: Wix.WindowPlacement.CENTER
        }, null, Wix.Theme.BARE);
      }
    }
  }, {
    key: 'showCart',
    value: function showCart() {
      Wix.PubSub.publish("showCart", {}, false);
    }
  }, {
    key: 'hideCart',
    value: function hideCart() {
      Wix.PubSub.publish("closeCartForm", {}, false);
    }
  }, {
    key: 'publishAddToCart',
    value: function publishAddToCart(dataToSend) {
      Wix.PubSub.publish('ADD_TO_CART', dataToSend, true);
    }
  }]);

  return CartApi;
}();

var domain = '';
if (window.instanceId) {
  domain = window.instanceId;
} else {
  try {
    if (window.Wix) {
      domain = Wix.Utils.getInstanceId();
    } else {
      // We're in a test
      domain = 'test';
    }
  } catch (error) {
    console.log('error domain', error);
  }
}
module.exports = new CartApi(domain);

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(116)();
}


/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = ReactDOM;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logger = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _wixBiLogger = __webpack_require__(63);

var W = _interopRequireWildcard(_wixBiLogger);

var _utils = __webpack_require__(5);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// var W;

var BiLogger = function () {
  function BiLogger(wixBiArgs, biParams, paramsVerifier) {
    var _this = this;

    _classCallCheck(this, BiLogger);

    this.trackBi = function (biEvent) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var callback = arguments[2];


      if (!biEvent) {
        console.error('TRACK EVENT ERROR - No such bi event');
        return false;
      }

      // if (utils && utils.isDev()) {
      //   // comment the following line to send biEvents in development
      //   console.log('Not tracking bi events in dev', biEvent, additionalParams);
      //   return;
      //   // console.log('logger.track', biEvent.evid, additionalParams);
      //   // console.warn('Sending logger events in dev');
      // }

      if (!_this.paramsVerifier(_this.biParams)) {
        console.error('TRACK EVENT ERROR - Missing biParams', _this.biParams);
        return false;
      }

      var evid = biEvent.evid;

      if (_this.isUserOfUserEvent(evid)) {
        if (_utils.utils.getViewModeFromCache() !== 'site') {
          //console.log('Not tracking UoU events in', Wix.Utils.getViewMode(), 'mode');
          return;
        }

        if (_this.visitorId == null) {
          var errorMsg = 'visitor id is undefined. It is needed for user of user events. evid:' + biEvent.evid;
          console.error(errorMsg);
          return;
        }
        params['visitor_id'] = _this.visitorId;
      }

      if (_this.needsGalleryType(evid)) {
        params['galleryType'] = _this.getGalleryType();
      }

      try {
        var defParams = biEvent.defaultParams || {};
        var logData = $.extend({}, defParams, params, _this.biParams);
        _this.biLog(evid, logData, callback);
      } catch (e) {
        console.warn('BI LOGGER ERROR!', e);
      }
    };

    this.biParams = biParams;
    this.needsGalleryType = function (evid) {
      return [401, 403, 406, 500, 501, 502, 700, 703, 704].indexOf(evid) > -1;
    };
    this.initVisitorId();
    // predefine events
    this.biLogger = W && W.BI ? new W.BI.Logger(wixBiArgs) : false;
    this.paramsVerifier = paramsVerifier || function (biEvents) {
      console.log('Default BI validator', biEvents);
      return true;
    };

    this.biEvents = {
      sample: {
        evid: 1
      },
      add_pro_gallery: {
        evid: 400
      },
      change_settings: {
        evid: 401
      },
      mange_media_upper_panel_open: {
        evid: 402
      },
      pro_gallery_settings_load: {
        evid: 403
      },
      manage_media_set: {
        evid: 404
      },
      manage_media_text_editor_customize: {
        evid: 405
      },
      upload_media: {
        evid: 406
      },
      upload_media_error: {
        evid: 407
      },
      remove_media_from_gallery: {
        evid: 408
      },
      layouts_select: {
        evid: 409
      },
      gallery_performance: {
        evid: 410
      },
      // choose_provider: {
      //   evid: 420
      // },
      // activate_store_click: {
      //   evid: 421
      // },
      // media_sell_wizard_started: {
      //   evid: 422
      // },
      // set_pricing: {
      //   evid: 423
      // },
      // set_pricing_add_product_click: {
      //   evid: 424
      // },
      // set_pricing_ass_product_success: {
      //   evid: 425
      // },
      // manage_store_connect_paypal_success: {
      //   evid: 426
      // },
      // manage_store_connect_paypal_error: {
      //   evid: 427
      // },
      // manage_store_stats_click: {
      //   evid: 428
      // },
      // manage_store_my_profile_set: {
      //   evid: 429
      // },
      share: {
        evid: 500
      },
      love: {
        evid: 501
      },
      download: {
        evid: 502
      },
      info: {
        evid: 503
      },
      expand: {
        evid: 504
      },
      payment_excepted: {
        evid: 506
      },
      payment_error: {
        evid: 507
      },
      pro_gallery_load_error: {
        evid: 509
      },
      pro_gallery_loaded: {
        evid: 510
      },
      pro_gallery_error: {
        evid: 512
      },
      pro_gallery_load_users: {
        evid: 177
      },
      pro_gallery_load_uou: {
        evid: 304
      },
      select_photo: {
        evid: 600
      },
      share_group: {
        evid: 601
      },
      log_reach_level: {
        evid: 602
      },
      manageMediaClick: {
        evid: 700
      },
      storeSetUpTab: {
        evid: 702
      },
      expandSettings: {
        evid: 703
      },
      expandSettingsDone: {
        evid: 704
      },
      watermarkSettings: {
        evid: 705
      },
      watermarkEnable: {
        evid: 706
      },
      cartSettings: {
        evid: 708
      },
      cartSettingsDesignTab: {
        evid: 709
      },
      buyNowClick: {
        evid: 800
      }
    };

    this.paramsVerifier(this.biParams);
  }

  _createClass(BiLogger, [{
    key: 'getGalleryType',
    value: function getGalleryType() {
      return _utils.utils.isStoreGallery() ? 'store' : 'progallery';
    }
  }, {
    key: 'track',
    value: function track(eventName, params, callback) {
      var biEvent = this.biEvents[eventName];
      if (!biEvent) {
        console.error('TRACK EVENT ERROR - No such bi event ' + eventName);
        return false;
      } else {
        return this.trackBi(biEvent, params, callback);
      }
    }
  }, {
    key: 'stats',
    value: function stats(stats_token, instance_id, album_id, action) {
      var value = 1;
      if (action === 'unlove') {
        value = -1;
        action = 'love';
      }

      var uniqueUUID = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });

      $.ajax({
        url: window.location.protocol + '//photographers-counters.wix.com/collector/rest/collect-js?ctToken=' + stats_token,
        type: 'post',
        data: JSON.stringify({
          'messageId': uniqueUUID,
          'metrics': [{
            'type': 'album',
            'reportMetrics': [{
              'name': action,
              'value': value
            }],
            properties: {
              'instance_id': instance_id,
              'album_id': album_id
            }
          }]
        }),
        contentType: 'application/json',
        dataType: 'json',
        success: function success(data) {
          console.log('yeeee');
        }
      });
    }
  }, {
    key: 'biLog',
    value: function biLog(evid, params, callback) {

      if (!this.biLogger) {
        console.warn('no biLogger, cannot log event');
        return;
      }
      if (typeof evid == 'undefined') {
        console.warn('evid is missing, cannot log event', evid, params);
        return;
      }
      if (typeof params == 'undefined') {
        console.warn('params are missing, cannot log event', evid, params);
        return;
      }

      var logData = $.extend({ evid: evid }, params);

      var adapter = this.getAdapter(evid);
      if (adapter != null) {
        $.extend(logData, { adapter: adapter });
      }
      this.biLogger.log(logData, callback);
    }
  }, {
    key: 'isBot',
    value: function isBot() {
      return (/bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent)
      );
    }
  }, {
    key: 'trackLoadBi',
    value: function trackLoadBi(endpoint) {
      var _this2 = this;

      var eventType = _utils.utils.getViewModeFromCache() == 'site' ? this.biEvents.pro_gallery_load_uou : this.biEvents.pro_gallery_load_users;
      try {
        if (!this.isBot()) {
          if (eventType == this.biEvents.pro_gallery_load_users || this.visitorId) {
            this.trackBi(eventType, { endpoint: endpoint, loading_time: window.performance.timing.domContentLoadedEventEnd - window.performance.timing.navigationStart });
          } else {
            this.onInitVisitorId = function () {
              return _this2.trackLoadBi(endpoint);
            };
          }
        }
      } catch (e) {
        console.error('track load event error', e);
      }
    }
  }, {
    key: 'initBiLoadedEventListener',
    value: function initBiLoadedEventListener(endpoint) {
      var _this3 = this;

      window.addEventListener('load', function () {
        _this3.trackLoadBi(endpoint);
      });
    }
  }, {
    key: 'initVisitorId',
    value: function initVisitorId() {
      var _this4 = this;

      if (_utils.utils.getViewModeFromCache() !== 'site') {
        return;
      }
      if (typeof Promise == 'undefined') {
        console.error('promise is undefined in initVisitorId. Cant init visitor id');
        return;
      }
      var timeOut = 9000;
      var beginTime = Date.now();
      // const sessionTokenToVisitorId = s => [[0, 8], [8, 12], [12, 16], [16, 20], [20, 32]].map(i => s.slice(...i)).join('-');
      // new Promise(resolve => Wix.Activities.getUserSessionToken(resolve))
      //   .then(sessionTokenToVisitorId)
      //   .then(val => {
      new Promise(function (resolve) {
        return resolve(Wix.Utils.getInstanceValue('aid') || Wix.Utils.getInstanceValue('uid'));
      }).then(function (val) {
        _this4.visitorId = val;
        _this4.onInitVisitorId && _this4.onInitVisitorId();
        var interval = Date.now() - beginTime;
        if (interval > timeOut) {
          console.error('took over ' + timeOut + 'ms to get the visitor id', interval + 'ms');
        }
      }).catch(function (err) {
        return console.error('cant get visitorID/sessionToken', err);
      });

      setTimeout(function () {
        if (!_this4.visitorId) {
          console.error('waiting ' + timeOut + 'ms for visitorID/sessionToken');
        }
      }, timeOut);
    }
  }, {
    key: 'isInRange',
    value: function isInRange(val, min, max) {
      return val >= min && val < max;
    }
  }, {
    key: 'isUserEvent',
    value: function isUserEvent(evid) {
      return !this.isUserOfUserEvent(evid);
    }
  }, {
    key: 'isUserOfUserEvent',
    value: function isUserOfUserEvent(evid) {
      return this.isInRange(evid, 500, 605) || evid === 304 || evid === 800;
    }
  }, {
    key: 'getAdapter',
    value: function getAdapter(evid) {
      var adapter = void 0;
      if (this.isUserEvent(evid)) {
        adapter = 'photo-users';
      } else if (this.isUserOfUserEvent(evid)) {
        adapter = 'photo-ugc';
      } else {
        console.error('evid', evid, 'is not user, or uou event (???)');
      }
      return adapter;
    }
  }], [{
    key: 'getParam',
    value: function getParam(val) {

      var vmDefaultStringRegex = /^\$\{.*\}$/; //e.g. "${instance}" or "${some_variable}"
      var windowVal = String(window[val]);

      if (windowVal && vmDefaultStringRegex.exec(windowVal) == null) {
        return windowVal;
      } else {
        var result = '',
            tmp = [];
        location.search
        //.replace ( "?", "" )
        // this is better, there might be a question mark inside
        .substr(1).split('&').forEach(function (item) {
          tmp = item.split('=');
          if (tmp[0] === val) {
            result = decodeURIComponent(tmp[1]);
          }
        });
        return result;
      }
    }
  }]);

  return BiLogger;
}();

var wixBiArgs = {
  defaultEventArgs: {},
  defaultErrorArgs: {},
  adapter: 'photo-users'
};

var biParamsObj = {
  instance_id: BiLogger.getParam('instanceId'),
  gallery_id: BiLogger.getParam('galleryId'),
  src: 65 //predefined wix-albums source
};

var paramsVerifier = function paramsVerifier(biParams) {
  var isValid = false;
  if (biParams['biToken']) {
    isValid = true;
  } else {
    try {
      biParams['biToken'] = Wix.Utils.getInstanceValue('biToken');
      isValid = true;
    } catch (e) {
      if (_utils.utils && _utils.utils.isDev()) {
        isValid = true;
      } else {
        console.warn('Error parsing biToken from instance!', e);
        isValid = false;
      }
    }
  }

  if (_utils.utils.isDev()) {
    console.log('Verify BI params:', biParams, 'is valid:', isValid);
  }

  return isValid;
};
var logger = exports.logger = window['logger'] = new BiLogger(wixBiArgs, biParamsObj, paramsVerifier);

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var TranslationUtil = exports.TranslationUtil = {
  getByKey: function getByKey(strKey) {
    var strValue = null;
    if (window.translations) {
      strValue = window.translations[strKey];
    }

    if ( /*utils.isDev() && */!strValue) {
      strValue = strKey;
    }

    var showKey = false;

    if (window) {
      if (window.isClientDev) {
        strValue = strKey;
      }
      if (window.unescape) {
        strValue = window.unescape(strValue); // for chars that come from babel like &#39;
      }
    }

    return strValue;
  }
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function greedySplit(str, separator, limit) {
  var result = str.split(separator, limit);
  if (result.length === limit) {
    var length = 0;
    if (typeof separator === 'string') {
      length = result.join(separator).length;
    } else {
      length = result.reduce(function (l, x, i) {
        var separatorLength = 0;
        if (i + 1 < limit) {
          separatorLength = str.slice(l).match(separator).shift().length;
        }
        return l + x.length + separatorLength;
      }, 0);
    }
    result[limit - 1] += str.slice(length);
  }
  return result;
}

module.exports = greedySplit;
//# sourceMappingURL=index.js.map


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global localStorage */


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _require = __webpack_require__(7),
    STORAGE_PREFIX = _require.STORAGE_PREFIX,
    PREFIX_SEPARATOR = _require.PREFIX_SEPARATOR,
    KEY_SEPARATOR = _require.KEY_SEPARATOR;

function parseCacheKey(cacheKey) {
  var _cacheKey$split = cacheKey.split(KEY_SEPARATOR),
      _cacheKey$split2 = _slicedToArray(_cacheKey$split, 2),
      prefix = _cacheKey$split2[0],
      key = _cacheKey$split2[1];

  var _prefix$split = prefix.split(PREFIX_SEPARATOR),
      _prefix$split2 = _slicedToArray(_prefix$split, 3),
      namespace = _prefix$split2[1],
      scope = _prefix$split2[2];

  if (scope === undefined) {
    return { namespace: namespace, key: key };
  } else {
    return { namespace: namespace, scope: scope, key: key };
  }
}

function deserializeData(data) {
  return JSON.parse(data);
}

function getCacheRecords() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : STORAGE_PREFIX + PREFIX_SEPARATOR;

  var items = [];
  for (var i = 0; i < localStorage.length; i++) {
    var key = localStorage.key(i);
    if (key.startsWith(prefix)) {
      var data = localStorage.getItem(key);
      items.push(Object.assign({
        size: key.length + data.length,
        originalKey: key
      }, deserializeData(data), parseCacheKey(key)));
    }
  }
  return items;
}

function isExpired(data) {
  if (data.expiration) {
    return data.createdAt + data.expiration * 1000 <= Date.now();
  } else {
    return false;
  }
}

module.exports = {
  deserializeData: deserializeData,
  getCacheRecords: getCacheRecords,
  isExpired: isExpired
};
//# sourceMappingURL=record-utils.js.map


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3);
var settle = __webpack_require__(77);
var buildURL = __webpack_require__(79);
var parseHeaders = __webpack_require__(80);
var isURLSameOrigin = __webpack_require__(81);
var createError = __webpack_require__(36);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(82);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED'));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(83);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        if (request.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(78);

/**
 * Create an Error with the specified message, config, error code, and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 @ @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, response);
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(17);
var Axios = __webpack_require__(41);
var defaults = __webpack_require__(8);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(21);
axios.CancelToken = __webpack_require__(55);
axios.isCancel = __webpack_require__(20);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(56);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 40 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(8);
var utils = __webpack_require__(1);
var InterceptorManager = __webpack_require__(50);
var dispatchRequest = __webpack_require__(51);
var isAbsoluteURL = __webpack_require__(53);
var combineURLs = __webpack_require__(54);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
  config.method = config.method.toLowerCase();

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(19);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(52);
var isCancel = __webpack_require__(20);
var defaults = __webpack_require__(8);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(21);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.itemActions = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(4);

var _ = _interopRequireWildcard(_lodash);

var _utils = __webpack_require__(2);

var _biLogger = __webpack_require__(30);

var _translationUtils = __webpack_require__(31);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ItemActions = function () {
  function ItemActions() {
    _classCallCheck(this, ItemActions);

    this.isMultisharing = _.noop;
    this.wasInit = false;
    this.loveCounts = {};
    this.fetchSiteInfo();
  }

  _createClass(ItemActions, [{
    key: 'initWidgetData',
    value: function initWidgetData(config) {

      this.config = config;

      if (config.compId) {
        this.compId = config.compId;
      }
      if (config.pageId) {
        this.pageId = config.pageId;
      }
      if (config.styleId) {
        this.styleId = config.styleId;
      }
      if (config.galleryId) {
        this.galleryId = config.galleryId;
      }
      if (config.fullscreenUrl) {
        this.siteUrl = this.fullscreenUrl = this.normalizeFullscreenUrl(config.fullscreenUrl);
        try {
          this.siteUrl = this.fullscreenUrl.match(/.*\..*\//g)[0];
        } catch (e) {
          //
        }
      }

      if (config.reachLevel) {
        this.setReachLevel(config.reachLevel);
      }

      if (this.galleryId && this.galleryId !== '') {
        this.loveCountFetched = document.createEvent('CustomEvent'); // MUST be 'CustomEvent'
        this.loveCountFetched.initCustomEvent('love_count_fetched', false, false, null);
        this.getStats();
      }

      this.wasInit = config;

      return Date.now();
      // console.log('itemActions initiated', config, window['proGalleryWidget']);
    }

    /**
     * Sometimes we may get a full screen url with some additional parameters (like we get right after the user logs in. We need to remove them)
     */

  }, {
    key: 'normalizeFullscreenUrl',
    value: function normalizeFullscreenUrl(fullscreenUrl) {
      var querylessUrl = fullscreenUrl;
      if (fullscreenUrl) {
        querylessUrl = fullscreenUrl.split('?')[0];
      }
      return querylessUrl;
    }
  }, {
    key: 'fetchSiteInfo',
    value: function fetchSiteInfo() {
      var _this = this;

      if (_utils.utils.isInWix()) {
        this.siteInfo = {};
        Wix.getSiteInfo(function (res) {
          _this.siteInfo = res;
        });
      } else {
        this.siteInfo = {
          url: _utils.utils.isSemiNative() ? '' : window.location.href,
          baseUrl: _utils.utils.isSemiNative() ? '' : window.location.href,
          siteTitle: 'Wix Pro Gallery',
          siteDescription: 'The best gallery any Wix user has ever seen!',
          siteKeywords: 'gallery,photos,photographer,professional'
        };
      }
    }
  }, {
    key: 'getSiteUrl',
    value: function getSiteUrl() {
      return this.siteInfo.url;
    }
  }, {
    key: 'getStats',
    value: function getStats() {
      var _this2 = this;

      if (_utils.utils.isDev()) {
        return;
      }
      if (!this.galleryId || this.galleryId == '' || this.galleryId.length < 10) {
        console.log('galleryId id', this.galleryId, _typeof(this.galleryId));
        console.error('get stats error - no galleryId');
        return;
      }
      $.get('//progallery.wix.com/_api/pro-gallery-webapp/v1/gallery/' + this.galleryId + '/stats/properties').success(function (res) {
        try {
          _this2.statsProps = JSON.parse(res.properties);
          _this2.statsToken = res.statsToken;
        } catch (e) {
          console.error('Failed getting stats props', e);
        }
      });

      if (!window['instanceId']) {
        console.warn('cannot report love counter - no instance id');
      } else {

        $.get('//progallery.wix.com/_api/pro-gallery-webapp/v1/gallery/' + this.galleryId + '/' + window['instanceId'] + '/stats').success(function (res) {
          try {
            _this2.loveCounts = res.photoId2Love;
            window.dispatchEvent(_this2.loveCountFetched);
          } catch (e) {
            console.error('Failed getting love counts', e);
          }
        });
      }
    }
  }, {
    key: 'getLoveCount',
    value: function getLoveCount(photoId) {
      return Math.max(0, this.loveCounts[photoId]) || 0;
    }
  }, {
    key: 'html2img',
    value: function html2img(itemDto, callback) {

      var div = $(itemDto.html).addClass('html-element').prependTo('body');

      html2canvas(div[div.length - 1], {
        onrendered: function onrendered(canvas) {
          // canvas is the final rendered <canvas> element
          //$(canvas).prependTo('body');
          div.remove();
          var url = canvas.toDataURL();
          //url = url.replace(/^data:image\/[^;]/, 'data:application/octet-stream');
          //window.open(url);
          //console.log('Got Image from html', );
          if (typeof callback == 'function') {
            callback(url);
          }
        }
      });
    }
  }, {
    key: 'share',
    value: function share(type, itemDto, origin, numOfItems) {
      if (_utils.utils.isDemo()) {
        return;
      }
      _biLogger.logger.trackBi(_biLogger.logger.biEvents.share, { origin: origin, platform: type });
      itemDto.numOfItems = numOfItems;
      this.shareImp(type, itemDto);
    }
  }, {
    key: 'downloadTextItem',
    value: function downloadTextItem(itemDto, origin) {
      _biLogger.logger.trackBi(_biLogger.logger.biEvents.download, { origin: origin });
      this.html2img(itemDto, function (url) {
        url = url.replace(/^data:image\/[^;]/, 'data:application/octet-stream');
        window.open(url);
      });
    }
  }, {
    key: 'getReachLevel',
    value: function getReachLevel(increment) {
      var inc = Number(increment || 0);
      var rl;
      if (_.isUndefined(this.reachLevel)) {
        var ls = _utils.utils.getLocalStorage();
        rl = Number(ls[this.siteUrl + '|reach-level'] || 0) + inc;
      } else {
        rl = this.reachLevel + inc;
      }
      return rl;
    }
  }, {
    key: 'setReachLevel',
    value: function setReachLevel(rl, hashtag) {
      if (!(rl > 0)) {
        rl = 0;
      }
      try {
        var origRl = this.getReachLevel(0); //if this user already registered a reach-level for this site (already saw it) don't register again
        if (rl > 0 && origRl == 0 && _.isUndefined(this.reachLevel)) {
          _biLogger.logger.track('log_reach_level', {
            hashtag: hashtag,
            reach_level: rl
          });
          var ls = _utils.utils.getLocalStorage();
          ls[this.siteUrl + '|reach-level'] = rl;
          this.reachLevel = rl;
        }
      } catch (e) {
        console.warn('set reach level error', e);
      }
    }
  }, {
    key: 'getShareUrl',
    value: function getShareUrl(item) {
      return this.fullscreenUrl + '/' + this.compId + '/' + (item.id || item.photoId || item.itemId) + '/' + item.idx + '/' + encodeURIComponent('?i=' + item.idx + '&p=' + this.pageId + '&s=' + this.styleId + '&rl=' + this.getReachLevel(1) + (item.hashtag ? '&ht=' + item.hashtag : ''));
    }
  }, {
    key: 'shareImp',
    value: function shareImp(type, itemDto, callback) {

      function openWindow(url, source) {
        if (_utils.utils.isiOS() && source == 'Email') {
          window.location.href = url;
        } else {
          var windowRef = window.open(url, source + ' Share', 'height=640,width=960,toolbar=no,menubar=no,scrollbars=no,location=no,status=no');
          setTimeout(
          // When the mailto url opens. In some configurations the new window redirects to the configured mail client (e.g. gmail).
          // In other instances a desktop client is opened (e.g. Outlook) and the new window is blank. This tests for that situation and closes the window if it happens.
          function () {
            try {
              if (source == 'Email' && windowRef.location.hasOwnProperty('pathname') && windowRef.location.pathname == 'blank') {
                windowRef.close();
              }
            } catch (e) {
              console.warn('Could not close mailto window');
            }
          }, 5000);
        }
      }

      var item = {
        id: itemDto.id || itemDto.photoId || itemDto.itemId,
        idx: itemDto.idx || 0,
        url: itemDto.full_url && itemDto.full_url['img'],
        title: itemDto.title || itemDto.description || this.siteInfo.siteTitle,
        hashtag: itemDto.hashtag
      };

      // console.log('itemActions init data', this.config, window['proGalleryWidget']);

      var shareUrl = encodeURIComponent(this.getShareUrl(item));
      var shareTitle = encodeURIComponent(item.title);
      var shareImageUrl = encodeURIComponent(item.url);

      var shareKeywords = encodeURIComponent(this.siteInfo.siteKeywords);

      var shareMessage = encodeURIComponent('' + this.getShareUrl(item));

      if (!_.isFunction(callback)) {
        callback = openWindow;
      }

      switch (type) {
        case 'facebook':
          callback('http://www.facebook.com/sharer/sharer.php?u=' + shareUrl + '&t=' + shareTitle, 'Facebook');
          break;
        case 'twitter':
          var twitterMaxLength = 110;
          var shareUrlExtraData = '&amp;text=' + shareTitle;
          if (shareUrlExtraData.length > twitterMaxLength) {
            shareUrlExtraData = shareUrlExtraData.slice(0, twitterMaxLength - 3) + '...';
          } else {
            var shareKeywordsUrlComponent = '&amp;hashtags=' + shareKeywords;
            if ((shareUrlExtraData + shareKeywordsUrlComponent).length <= twitterMaxLength) {
              shareUrlExtraData += shareKeywordsUrlComponent;
            }
          }
          callback('https://twitter.com/share?url=' + shareUrl + shareUrlExtraData, 'Twitter');
          break;
        case 'pinterest':
          callback('https://pinterest.com/pin/create/button/?url=' + shareUrl + '&media=' + shareImageUrl + '&description=' + shareTitle, 'Pinterest');
          break;
        case 'google':
          callback('https://plus.google.com/share?url=' + shareUrl, 'Google Plus');
          break;
        case 'tumblr':
          callback('http://www.tumblr.com/share/link?url=' + shareUrl, 'Tumblr');
          break;
        case 'email':
          callback('mailto:?Subject=' + shareTitle + '&body=' + shareMessage, 'Email');
          break;
      }
    }
  }, {
    key: 'reportLoveToStats',
    value: function reportLoveToStats(photoId, value) {
      try {

        if (!this.statsProps || !this.statsProps.instance_id) {
          this.getStats();
          return;
        }

        var statsProps = _.merge(this.statsProps, { photo_id: photoId });
        var statsToken = this.statsToken || window['statsToken'];

        var uniqueUUID = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = Math.random() * 16 | 0,
              v = c == 'x' ? r : r & 0x3 | 0x8;
          return v.toString(16);
        });

        $.ajax({
          url: window.location.protocol + '//photographers-counters.wix.com/collector/rest/collect-js?ctToken=' + statsToken,
          type: 'post',
          data: JSON.stringify({
            messageId: uniqueUUID,
            metrics: [{
              type: 'photo',
              reportMetrics: [{
                name: 'love',
                value: String(value)
              }],
              properties: statsProps
            }]
          }),
          contentType: 'application/json',
          dataType: 'json',
          success: function success(data) {
            console.log('Success report love', data);
          }
        });
      } catch (e) {
        console.error('Error reporting love to stats', e);
      }
    }
  }, {
    key: 'getLoveStorageKey',
    value: function getLoveStorageKey(photoId) {
      return 'pro-gallery-item-love-' + photoId;
    }
  }, {
    key: 'isLoved',
    value: function isLoved(photoId) {
      try {
        if (typeof localStorage === 'undefined') {
          return false;
        }
        return !!localStorage[this.getLoveStorageKey(photoId)] || false;
      } catch (e) {
        console.warn('isLoved failed', e);
      }
    }
  }, {
    key: 'toggleLove',
    value: function toggleLove(photoId, origin, forceVal) {
      try {
        if (!localStorage) {
          return false;
        }
        var inc = void 0;
        if (this.isLoved(photoId) && forceVal !== true || forceVal === false) {
          // unlove
          localStorage[this.getLoveStorageKey(photoId)] = '';
          inc = -1;
        } else {
          //love
          _biLogger.logger.trackBi(_biLogger.logger.biEvents.love, { origin: origin });
          localStorage[this.getLoveStorageKey(photoId)] = true;
          inc = 1;
        }
        this.reportLoveToStats(photoId, inc);
      } catch (e) {
        console.warn('toggleLove failed', e);
      }
    }
  }, {
    key: 'isFirstLoveClick',
    value: function isFirstLoveClick(photoId) {
      try {
        return localStorage && localStorage[this.getLoveStorageKey(photoId)] === undefined;
      } catch (e) {
        console.warn('isFirstLoveClick failed', e);
      }
    }
  }, {
    key: 'postLoveActivity',
    value: function postLoveActivity(item) {

      var postSocialTrackActivity = function postSocialTrackActivity(data) {
        try {
          var activity = {
            type: Wix.Activities.Type.SOCIAL_TRACK,
            info: {
              type: data.activityType,
              channel: data.activityNetwork,
              itemInfo: {
                itemUrl: data.url,
                itemId: data.id,
                itemType: data.type.toUpperCase()
              }
            },
            details: {
              additionalInfoUrl: data.url,
              summary: ''
            },
            contactUpdate: null
          };

          var onSuccess = function onSuccess(d) {
            console.log('Activity ID: ' + d.activityId + ', Contact ID: ' + d.contactId);
          };
          var onFailure = function onFailure(d) {
            console.log('Failure message:', d);
          };

          Wix.Activities.postActivity(activity, onSuccess, onFailure);
        } catch (e) {
          console.log('error posting activity.', e);
        }
      };

      if (this.isFirstLoveClick(item.photoId)) {
        postSocialTrackActivity({
          activityType: 'LOVE',
          activityNetwork: 'SITE',
          id: item.photoId,
          url: this.getShareUrl(item),
          type: item.type
        });
      }
    }
  }, {
    key: 'showTooltip',
    value: function showTooltip(e, key, pos) {

      if ($('.pro-tooltip').length >= 1) {
        return;
      }

      var target = $(e.currentTarget);

      if (!target) {
        return;
      }

      var offset = target.offset();
      var top = offset.top;
      var left = offset.left;

      var css;

      if (typeof pos == 'undefined') {
        pos = left > window.innerWidth / 2 ? 'right' : 'left';
      }

      switch (pos) {
        case 'top':
          css = {
            top: top - 30,
            left: left + 28,
            opacity: 1
          };
          break;
        case 'right':
          css = {
            top: top - 4,
            left: left - 20,
            opacity: 1
          };

          break;
        case 'left':
          css = {
            top: top - 4,
            left: left + 40,
            opacity: 1
          };
          break;
      }
      css['pointer-events'] = 'none';

      $('<div></div>').html(_translationUtils.TranslationUtil.getByKey(key)).addClass('pro-tooltip').appendTo('body').css(css).addClass(pos);
    }
  }, {
    key: 'hideTooltip',
    value: function hideTooltip() {
      $('.pro-tooltip').remove();
    }
  }, {
    key: 'toggleTooltip',
    value: function toggleTooltip(e, key, pos) {
      var hasTooltip = $('.pro-tooltip').length == 1;
      if (hasTooltip) {
        this.hideTooltip();
      } else {
        this.showTooltip(e, key, pos);
      }
    }
  }, {
    key: 'viewClassName',
    value: function viewClassName(layout, device) {
      if (layout == 'fullscreen') {
        return device == 'desktop' ? 'fullscreen-icon' : '';
      } else {
        return '';
      }
    }
  }]);

  return ItemActions;
}();

var itemActions = exports.itemActions = new ItemActions();

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(5);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WixStoreApi = function () {
  function WixStoreApi() {
    _classCallCheck(this, WixStoreApi);

    this.connectedProvidersCache = null;
    this.galleryDataPromise = null;
  }

  _createClass(WixStoreApi, [{
    key: 'initializePromises',
    value: function initializePromises() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        var gallerySettingsPromise = _this.sendRequest('GET', 'gallery/' + window['galleryId'], null);
        var storeGalleryDataPromise = _this.getStoreGalleryData();
        var storeProvidersPromise = _this.getProviders();

        Promise.all([gallerySettingsPromise, storeGalleryDataPromise, storeProvidersPromise]).then(function (results) {
          resolve({
            gallerySettings: results[0],
            storeGalleryData: results[1],
            storeProviders: results[2].providers
          });
        });
      });
    }
  }, {
    key: 'getStoreGalleryData',
    value: function getStoreGalleryData() {
      var _this2 = this;

      var returnPromise = null;
      var connectedProviders = window['connectedProviders'];
      if (!this.connectedProvidersCache && this.galleryDataPromise) {
        return this.galleryDataPromise;
      } else if (this.connectedProvidersCache) {
        this.galleryDataPromise = Promise.resolve(this.connectedProvidersCache);
      } else if (connectedProviders && (typeof connectedProviders === 'undefined' ? 'undefined' : _typeof(connectedProviders)) === 'object' && Object.keys(connectedProviders).length) {
        this.connectedProvidersCache = { connectedProviders: connectedProviders };
        this.galleryDataPromise = Promise.resolve(this.connectedProvidersCache);
      } else {
        this.galleryDataPromise = new Promise(function (resolve, reject) {
          _this2.sendRequest('GET', 'gallery/' + window['instanceId'] + '/providers', null).then(function (response) {
            _this2.connectedProvidersCache = response;
            resolve(_this2.connectedProvidersCache);
          }).fail(reject);
        });
      }

      return this.galleryDataPromise;
    }
  }, {
    key: 'connectProvider',
    value: function connectProvider(providerId) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        _this3.sendRequest('POST', 'providers/' + providerId + '/connect', null).then(function (result) {
          _this3.getProviders().then(function (providersData) {
            if (providersData && Array.isArray(providersData.providers)) {
              var providersList = providersData.providers;
              var connectedProvider = providersList.find(function (providerData) {
                return providerData.providerId === providerId;
              });
              if (connectedProvider) {
                resolve({ result: result, providers: providersData });
              } else {
                reject();
              }
            } else {
              reject();
            }
          });
        });
      });
    }
  }, {
    key: 'getProviders',
    value: function getProviders() {
      return this.sendRequest('GET', 'providers', null).then(function (response) {
        window['providers'] = response.providers;
        return response;
      });
    }
  }, {
    key: 'sendRequest',
    value: function sendRequest(type, endpoint, data) {
      var url = new window['URI'](window.location.protocol + '//progallery.wix.com/editor/api/v1/' + endpoint).search({
        instance: window['instance'],
        locale: window['locale'],
        deviceType: 'desktop',
        cachekiller: new Date().getTime(),
        isStore: true
      });

      return $.ajax({
        type: type,
        url: url.toString(),
        data: data,
        contentType: 'application/json',
        xhrFields: {
          withCredentials: true
        }
      });
    }
  }, {
    key: 'openDashboard',
    value: function openDashboard() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var title = options.title;

      var objAdditionalParams = this.getProviderUrlOptions(options);
      var url = _utils.utils.generateUrl('store-dashboard.html', objAdditionalParams);
      Wix.Settings.openModal(url, '100%', '100%', title, _.noop, false, { overlay: 'rgba(0,0,0,0)', background: 'rgba(0,0,0,0)', margin: '0px 0px 0px 0px', padding: false });
    }
  }, {
    key: 'openProviderModal',
    value: function openProviderModal(name) {
      var _this4 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var containerParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return new Promise(function (resolve, reject) {
        if (name) {
          _this4.getStoreGalleryData().then(function (_ref) {
            var connectedProviders = _ref.connectedProviders;

            var providerData = connectedProviders[Object.keys(connectedProviders)[0]];
            var widgets = providerData.widgets;


            if (widgets[name]) {
              var objAdditionalParams = _this4.getProviderUrlOptions(options);

              var finalParams = Object.assign({ name: name }, objAdditionalParams, containerParams);
              var providerModalUrl = _utils.utils.getProviderModalUrl(finalParams);
              Wix.openPopup(providerModalUrl, '100%', '100%', {
                origin: Wix.WindowOrigin.FIXED,
                placement: Wix.WindowPlacement.CENTER
              }, function onProviderModalClose() {
                console.log('Provider modal closed');
              }, Wix.Theme.BARE);
              resolve();
            } else {
              reject('Name does not exist in widgets');
            }
          }).catch(reject);
        } else {
          reject('Name not defined');
        }
      });
    }
  }, {
    key: 'getProviderUrlOptions',
    value: function getProviderUrlOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var urlParams = options.urlParams,
          urlPath = options.urlPath;

      var objAdditionalParams = { urlParams: '{}', urlPath: '/' };
      if (urlParams && (typeof urlParams === 'undefined' ? 'undefined' : _typeof(urlParams)) === 'object') {
        var encodedParams = JSON.stringify(urlParams);
        objAdditionalParams.urlParams = encodedParams;
      }
      if (urlPath && typeof urlPath === 'string') {
        objAdditionalParams.urlPath = urlPath;
      }

      return objAdditionalParams;
    }
  }]);

  return WixStoreApi;
}();

var storeApi = new WixStoreApi();

window.WixStoreApi = storeApi;

exports.default = storeApi;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
  if (true) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(60)], __WEBPACK_AMD_DEFINE_RESULT__ = function (a0) {
      return (root['W'] = factory(a0));
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory(require("./wix-bi-parsers"));
  } else {
    root['W'] = factory(root["W"]);
  }
}(this, function (W) {

/* global Image, setTimeout */
'use strict';

var W = W || {};
W.BI = W.BI || {};

W.BI.ErrorSeverity = {
  RECOVERABLE: 10,
  WARNING: 20,
  ERROR: 30,
  FATAL: 40
};

W.BI.Categories = {
  EDITOR: 1,
  VIEWER: 2,
  TIMEOUTS: 3,
  SERVER: 4
};

W.BI.initialLoadIsReported = false;

W.BI.Logger = (function () {
  function now() {
    return new Date().getTime();
  }

  function cacheKiller() {
    return '' + now() + cacheKillerCounter++;
  }

  function performanceInMs() {
    var res = window.performance && window.performance.now ? window.performance.now() : -1;

    return Math.round(res);
  }

  var cacheKillerCounter = 0;

  var startTime = now();

  var defaultEventArgs = {
    _: cacheKiller,
    ms: performanceInMs
  };

  var defaultErrorArgs = {
    _: cacheKiller,
    ts: function () {
      return now() - startTime;
    },
    cat: W.BI.Categories.VIEWER,
    sev: W.BI.ErrorSeverity.WARNING,
    iss: 1,
    ver: '1'
  };

  var _initOptions = {
    // The BI server's hostname
    hostName: 'frog.wix.com',

    // The default event args that will be sent with each BI log call (src, time?)
    defaultEventArgs: {},

    // The default event args that will be sent with each error log (src, cat, iss, ver)
    defaultErrorArgs: {},

    // The BI server URL
    biUrl: '//frog.wix.com/',

    // Schemas validators, should look like this:
    // {match: () => true, execute: () => undefined}
    schemaValidators: [],

    // The BI adapter (maps to a path in the url)
    adapter: '',

    // error output stream
    error: function (str) {
      throw str;
    }
  };

  var EVENT_IDS = {
    ERROR: 10,
    ON_READY: 302,
    ROUTE_CHANGE: 300
  };

  function _extend(dst) {
    for (var i = 1; i < arguments.length; i++) {
      var extending = arguments[i];
      if (extending) {
        for (var key in extending) {
          dst[key] = extending[key];
        }
      }
    }
    return dst;
  }

  function biLogger(args) {
    var _lastBiUrl = {
      url: undefined,
      assertEmpty: function () {
        if (this.url !== undefined) {
          throw 'last bi is not empty!!!';
        }
      },
      resolve: function () {
        this.callback();
      },
      clear: function () {
        this.url = undefined;
      }
    };

    var _options;
    var fieldParsers = new W.BI.FieldParsers(args.injector);

    if (args.hostName) {
      args.biUrl = '//' + args.hostName + '/';
    }
    _options = _extend({}, _initOptions, args);

    function _log(eventArgs, callback) {
      var _biFieldsRestrictions = {
        src: { type: 'number' },
        evid: { type: 'number' }
      };

      var eventParams = _extend({}, defaultEventArgs, _options.defaultEventArgs, eventArgs);

      var schemaValidators = _options.schemaValidators || [];
      var validatorsResult = schemaValidators.length > 0 ?
                                schemaValidators.some(function (validator) {
                                  return validator.match(eventParams) && (validator.execute(eventParams) || true);
                                }) : true;

      if (!validatorsResult) {
        throw new Error('No validator accepted the event');
      }

      if (_validateBiEventArgs(eventParams, ['evid'], _biFieldsRestrictions)) {
        _sendBiEvent(eventParams, callback);
      }
    }

    function _error(errorArgs, callback) {
      var _requiredErrorFields = ['evid', 'cat', 'iss',  'sev', 'errc', 'ver'];
      var _errorFieldsRestrictions = {
        src: { type: 'number' },
        evid: { type: 'number', values: [EVENT_IDS.ERROR] },
        cat: { type: 'number', values: [W.BI.Categories.EDITOR, W.BI.Categories.VIEWER, W.BI.Categories.TIMEOUTS, W.BI.Categories.SERVER] },
        iss: { type: 'number' },
        sev: { type: 'number', values: [W.BI.ErrorSeverity.RECOVERABLE, W.BI.ErrorSeverity.WARNING, W.BI.ErrorSeverity.ERROR, W.BI.ErrorSeverity.FATAL] },
        errc: { type: 'number' },
        httpc: { type: 'number' },
        ver: { type: 'string', maxLength: 16 },
        errscp: { type: 'string', subStr: 64 },
        trgt: { type: 'string', subStr: 64 },
        gsi: { type: 'string', length: 36 },
        ts: { type: 'number' },
        uid: { type: 'number' },
        ut: { type: 'string', maxLength: 16 },
        did: { type: 'string', maxLength: 36 },
        cid: { type: 'string', length: 36 },
        lng: { type: 'string', maxLength: 5 },
        dsc: { type: 'string', subStr: 512 }
      };

      var errorParams = _extend({}, defaultErrorArgs, _options.defaultErrorArgs, errorArgs, {evid: EVENT_IDS.ERROR});

      if (_validateBiEventArgs(errorParams, _requiredErrorFields, _errorFieldsRestrictions)) {
        _sendBiEvent(errorParams, callback);
      }
    }

    function _reportOnReady(viewName, eventArgs, callback) {
      var _onReadyFieldsRestrictions =  {
        view: { type: 'string' }
      };

      var eventParams = _extend({}, eventArgs, {evid: EVENT_IDS.ON_READY, view: viewName});
      if (_validateBiEventArgs(eventParams, ['view'], _onReadyFieldsRestrictions)) {
        _log(eventParams, callback);
      }
    }

    function _reportRouteChange(viewName, eventArgs, callback) {
      var _routeChangeFieldsRestrictions =  {
        view: { type: 'string' }
      };

      var eventParams = _extend({}, eventArgs, {evid: EVENT_IDS.ROUTE_CHANGE, view: viewName});
      if (_validateBiEventArgs(eventParams, ['view'], _routeChangeFieldsRestrictions)) {
        _log(eventParams, callback);
      }
    }

    function _validateBiEventArgs(eventArgs, requiredArgs, restrictions) {
      var missingRequiredArgs = requiredArgs.slice(0);
      for (var key in eventArgs) {
        // validate & parse the key
        var currentRestrictions = restrictions[key] || {};

        eventArgs[key] = fieldParsers.parse(eventArgs[key], currentRestrictions);
        if (!fieldParsers.valid(eventArgs[key], currentRestrictions)) {
          _options.error('Bad event param (key: ' + key + ', value: ' + eventArgs[key] + ')');
          return;
        }

        // remove the key from the required fields
        var missingIndex;
        if ((missingIndex = missingRequiredArgs.indexOf(key)) > -1) {
          missingRequiredArgs.splice(missingIndex, 1);
        }
      }

      if (missingRequiredArgs.length > 0) {
        _options.error('Missing required params: ' + missingRequiredArgs.join(', '));
        return false;
      }

      return true;
    }

    function _addUrlParams(url, params) {
      var delimiter = url.match(/\?./) ? '&' : '?';
      return url.replace(/\?$/, '') + delimiter + Object.keys(params).filter(function (key) {
        return !_options.removeUndefinedValues || params[key] !== undefined;
      }).map(function (key) {
        return [encodeURIComponent(key), '=', encodeURIComponent(params[key])].join('');
      }).join('&');
    }

    function _sendBiEvent(eventArgs, callback) {
      // set the adapter
      var frogAdapter = eventArgs.adapter || _options.adapter;
      delete eventArgs.adapter;

      var url = _addUrlParams(_options.biUrl + frogAdapter, eventArgs);
      var onComplete = callback || function () {};

      if (!W.BI.DryRun) {
        // The magic line
        var biImage = new Image(0, 0);
        biImage.onload = onComplete;
        biImage.onerror = onComplete;
        biImage.src = url;
      } else {
        setTimeout(onComplete, 0);
      }

      // for UT purpose
      _lastBiUrl.url = url;
      _lastBiUrl.callback = callback;
    }

    return {
      log: _log,
      reportOnReady: _reportOnReady,
      reportRouteChange: _reportRouteChange,
      error: _error,

      getLastBiUrl: function () {
        return _lastBiUrl; // for UT purpose
      }
    };
  }

  return biLogger;
}());

return W;

}));


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
  if (true) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(61)], __WEBPACK_AMD_DEFINE_RESULT__ = function (a0) {
      return (root['W'] = factory(a0));
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory(require("./wix-bi-event-handler"));
  } else {
    root['W'] = factory(root["W"]);
  }
}(this, function (W) {

'use strict';

var W = W || {};
W.BI = W.BI || {};
W.BI.FieldParsers = function ($injector) {
  var validators = {
    length: function (val, length) {
      return val && val.length !== undefined && val.length === length;
    },
    maxLength: function (val, maxLength) {
      return val && val.length !== undefined && val.length <= maxLength;
    },
    values: function (val, values) {
      return values && values.indexOf(val) !== -1;
    },
    type: function (val, type) {
      return val && typeof val === type;
    }
  };

  var parsers = {
    subStr: function (val, length) {
      if (val && val.substr) {
        return val.substr(0, Math.min(val.length, length));
      }
      return val;
    }
  };

  this.valid = function (value, restrictions) {
    for (var key in restrictions) {
      if (validators[key] && !validators[key](value, restrictions[key])) {
        return false;
      }
    }
    return true;
  };

  this.parse = function (value, restrictions) {
    if (typeof value === 'function') {
      value = $injector ? $injector.invoke(value) : value();
    }
    for (var key in restrictions) {
      value = parsers[key] ? parsers[key](value, restrictions[key]) : value;
    }
    return value;
  };
};

return W;

}));


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
  if (true) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
      return (root['W'] = factory());
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    root['W'] = factory();
  }
}(this, function (W) {

/* global document */
'use strict';

var W = W || {};
W.BI = W.BI || {};

W.BI.DomEventHandler = (function () {
  var _wixBiAttributeSelector = 'wix-bi',
    _wixBiArgsAttribute = 'wix-bi-args',
    _initOptions = {
      // A dictionary containing event names and event args
      // The key is the event name that should match the parameter passed to the log() function.
      // The value is a parameter map: parameter name to value (value could be a parameterless delegate to be evaluated)
      // Sample:
      // { EVENT_1: { param1: 'value1', param2: W.Functions.func1, param3: 3 } }
      eventMap: {},

      // A dictionary containing error names and error args. Same structure as eventMap.
      errorMap: {},

      // error output stream
      error: function (str) {
        throw str;
      }
    };

  function _extend(dst) {
    for (var i = 1; i < arguments.length; i++) {
      var extending = arguments[i];
      if (extending) {
        for (var key in extending) {
          dst[key] = extending[key];
        }
      }
    }
    return dst;
  }

  function eventHandler(biLogger, args) {
    var _options;
    var _biLogger = biLogger;

    _options = _extend({}, _initOptions, args);

    function _safeGetEventParams(eventName, eventMap, explicitParams) {
      var params;

      // get the event params
      if (!eventMap || !eventMap[eventName]) {
        _options.error('Invalid event name');
        params = {};
      } else {
        params = eventMap[eventName];
      }

      // extend the specific params with the event params
      return _extend({}, params, explicitParams);
    }

    function _log(eventName, eventArgs, callback) {
      var eventParams = _safeGetEventParams(eventName, _options.eventMap, eventArgs);
      _biLogger.log(eventParams, callback);
    }

    function _error(errorName, errorArgs, callback) {
      var errorParams = _safeGetEventParams(errorName, _options.errorMap, errorArgs);
      _biLogger.error(errorParams, callback);
    }

    function _getAttr(element, name) {
      for (var i = 0; i < element.attributes.length; i++) {
        if (element.attributes[i].name === name) {
          return element.attributes[i].value;
        }
      }
    }

    function _handleTriggeredBiEvent(event) {
      var eventName = _getAttr(event.target, _wixBiAttributeSelector);
      if (eventName) {
        var eventArgsStr = _getAttr(event.target, _wixBiArgsAttribute);
        /* jshint -W061 */
        var eventArgs = eventArgsStr ? eval('eventArgs = ' + eventArgsStr) : {};
        /* jshint +W061 */
        _log(eventName, eventArgs);
      }
    }

    function _bind() {
      document.body.addEventListener('click', _handleTriggeredBiEvent);
    }

    function _unbind() {
      document.body.removeEventListener('click', _handleTriggeredBiEvent);
    }

    return {
      bind: _bind,
      unbind: _unbind,
      log: _log,
      error: _error
    };
  }

  return eventHandler;
}());

return W;

}));


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ../node_modules/lodash-es/_root.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(122);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ var _root_defaultExport = (root);

// CONCATENATED MODULE: ../node_modules/lodash-es/_Symbol.js


/** Built-in value references. */
var Symbol = _root_defaultExport.Symbol;

/* harmony default export */ var _Symbol_defaultExport = (Symbol);

// CONCATENATED MODULE: ../node_modules/lodash-es/_getRawTag.js


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol_defaultExport ? _Symbol_defaultExport.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ var _getRawTag_defaultExport = (getRawTag);

// CONCATENATED MODULE: ../node_modules/lodash-es/_objectToString.js
/** Used for built-in method references. */
var _objectToString_objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var _objectToString_nativeObjectToString = _objectToString_objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return _objectToString_nativeObjectToString.call(value);
}

/* harmony default export */ var _objectToString_defaultExport = (objectToString);

// CONCATENATED MODULE: ../node_modules/lodash-es/_baseGetTag.js




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var _baseGetTag_symToStringTag = _Symbol_defaultExport ? _Symbol_defaultExport.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (_baseGetTag_symToStringTag && _baseGetTag_symToStringTag in Object(value))
    ? _getRawTag_defaultExport(value)
    : _objectToString_defaultExport(value);
}

/* harmony default export */ var _baseGetTag_defaultExport = (baseGetTag);

// CONCATENATED MODULE: ../node_modules/lodash-es/_overArg.js
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ var _overArg_defaultExport = (overArg);

// CONCATENATED MODULE: ../node_modules/lodash-es/_getPrototype.js


/** Built-in value references. */
var getPrototype = _overArg_defaultExport(Object.getPrototypeOf, Object);

/* harmony default export */ var _getPrototype_defaultExport = (getPrototype);

// CONCATENATED MODULE: ../node_modules/lodash-es/isObjectLike.js
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ var isObjectLike_defaultExport = (isObjectLike);

// CONCATENATED MODULE: ../node_modules/lodash-es/isPlainObject.js




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    isPlainObject_objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var isPlainObject_hasOwnProperty = isPlainObject_objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike_defaultExport(value) || _baseGetTag_defaultExport(value) != objectTag) {
    return false;
  }
  var proto = _getPrototype_defaultExport(value);
  if (proto === null) {
    return true;
  }
  var Ctor = isPlainObject_hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ var isPlainObject_defaultExport = (isPlainObject);

// CONCATENATED MODULE: ../node_modules/redux/es/createStore.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_symbol_observable__);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore_createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore_createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!isPlainObject_defaultExport(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = observable, _ref2;
}
// CONCATENATED MODULE: ../node_modules/redux/es/utils/warning.js
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning_warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}
// CONCATENATED MODULE: ../node_modules/redux/es/combineReducers.js




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject_defaultExport(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: ActionTypes.INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}
// CONCATENATED MODULE: ../node_modules/redux/es/bindActionCreators.js
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}
// CONCATENATED MODULE: ../node_modules/redux/es/compose.js
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}
// CONCATENATED MODULE: ../node_modules/redux/es/applyMiddleware.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}
// CONCATENATED MODULE: ../node_modules/redux/es/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "createStore", function() { return createStore_createStore; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "combineReducers", function() { return combineReducers; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return bindActionCreators; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return applyMiddleware; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var W = __webpack_require__(59);
module.exports = W;

/***/ }),
/* 64 */,
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  addToCart: 'PROVIDER_ADD_TO_CART',
  refreshCart: 'PROVIDER_REFRESH_CART',
  updateCartItem: 'PROVIDER_UPDATE_CART_ITEM',
  clearCart: 'PROVIDER_CLEAR_CART',
  css: 'PROVIDER_CSS',
  sdkReady: 'PROVIDER_LOADED',
  goToCheckout: 'PROVIDER_GO_TO_CHECK_OUT',
  removeFromCart: 'PROVIDER_REMOVE_FROM_CART',
  backHome: 'PROVIDER_BACK_HOME',
  navigateToUrl: 'PROVIDER_NAVIGATE_TO_URL',
  setHeight: 'SET_HEIGHT',
  callback: 'PROVIDER_CALLBACK',
  selectPhoto: 'PROVIDER_SELECT_PHOTO',
  selectFile: 'PROVIDER_SELECT_FILE',
  close: 'PROVIDER_CLOSE',
  getSiteUrls: 'PROVIDER_GET_SITE_URLS',
  changeCheckoutState: 'PROVIDER_CHANGE_CHECKOUT_STATE',
  checkout: 'PROVIDER_CHECKOUT',
  openManege: 'PROVIDER_OPEN_MANAGE',
  openPricing: 'PROVIDER_OPEN_PRICING',
  setDefaultPrice: 'PROVIDER_SET_DEFAULT_PRICE',
  itemChanged: 'PROVIDER_ITEM_CHANGED',
  addToCartRequest: 'PROVIDER_ADD_TO_CART_REQUEST',
  openModal: 'PROVIDER_OPEN_MODAL',
  getCartItems: 'PROVIDER_GET_CART_ITEMS',
  getStyles: 'PROVIDER_GET_STYLES',
  setMobileProductData: 'PROVIDER_SET_MOBILE_INITIAL_DATA',
  mobileItemClicked: 'PROVIDER_MOBILE_ITEM_CLICKED'
};
//# sourceMappingURL=providerEvents.js.map


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// import '../_translationUtils'

var storeSampleImages = {
  setId: "01d9d4c0-5bc2-43c9-9e26-fae31bedaed9",
  name: "Sample Images",
  photos: [{
    metaData: {
      height: 2688,
      lastModified: 1445860855,
      name: "8b72558253b2502b401bb46e5599f22a",
      size: 1100727,
      width: 4542,
      title: "Image Title",
      description: "Add a description to your item so visitors can know more about your image or video. Tell them where it was taken or the story behind it.",
      isDemo: true
    },
    orderIndex: 0,
    itemId: "8b72558253b2502b401bb46e5599f22a",
    url: "8bb438_24ff508f6df24a8ba03e327a3f22025f~mv2.jpg"
  }, {
    metaData: {
      height: 2688,
      lastModified: 1445857830,
      name: "2d3b675ea857dc41158bad3b28300824",
      size: 8128464,
      width: 4000,
      title: "Image Title",
      description: "Add a description to your item so visitors can know more about your image or video. Tell them where it was taken or the story behind it.",
      isDemo: true
    },
    orderIndex: 1,
    itemId: "2d3b675ea857dc41158bad3b28300824",
    url: "8bb438_fb2fd260e89d496db0fae52dd9bf59ac~mv2.jpg"
  }, {
    metaData: {
      height: 2240,
      lastModified: 1445857821,
      name: "860df034014674abd7a2e73abe0b851b",
      size: 5655675,
      width: 4000,
      title: "Image Title",
      description: "Add a description to your item so visitors can know more about your image or video. Tell them where it was taken or the story behind it.",
      isDemo: true
    },
    orderIndex: 2,
    itemId: "860df034014674abd7a2e73abe0b851b",
    url: "8bb438_4325793cbfa84314a54604f95704bdfc~mv2.jpg"
  }, {
    metaData: {
      height: 2240,
      lastModified: 1445857821,
      name: "860df034014674abd7a2e73abe0b851b",
      size: 5655675,
      width: 4000,
      title: "Image Title",
      description: "Add a description to your item so visitors can know more about your image or video. Tell them where it was taken or the story behind it.",
      isDemo: true
    },
    orderIndex: 2,
    itemId: "860df034014674abd7a2e73abe0b851b",
    url: "8bb438_23f0285a13f84debbd76e29751bc8e85~mv2.jpg"
  }, {
    metaData: {
      height: 2240,
      lastModified: 1445857821,
      name: "860df034014674abd7a2e73abe0b851b",
      size: 5655675,
      width: 4000,
      title: "Image Title",
      description: "Add a description to your item so visitors can know more about your image or video. Tell them where it was taken or the story behind it.",
      isDemo: true
    },
    orderIndex: 2,
    itemId: "860df034014674abd7a2e73abe0b851b",
    url: "8bb438_ec230ad0882e4b5197af9f62f4609162~mv2.jpg"
  }, {
    metaData: {
      height: 2240,
      lastModified: 1445857821,
      name: "860df034014674abd7a2e73abe0b851b",
      size: 5655675,
      width: 4000,
      title: "Image Title",
      description: "Add a description to your item so visitors can know more about your image or video. Tell them where it was taken or the story behind it.",
      isDemo: true
    },
    orderIndex: 2,
    itemId: "860df034014674abd7a2e73abe0b851b",
    url: "8bb438_a5545f9151db4619a97e54bfe3c120bb~mv2.jpg"
  }, {
    metaData: {
      height: 2240,
      lastModified: 1445857821,
      name: "860df034014674abd7a2e73abe0b851b",
      size: 5655675,
      width: 4000,
      title: "Image Title",
      description: "Add a description to your item so visitors can know more about your image or video. Tell them where it was taken or the story behind it.",
      isDemo: true
    },
    orderIndex: 2,
    itemId: "860df034014674abd7a2e73abe0b851b",
    url: "8bb438_613040019a2448359560f99f8e3ce0cd~mv2.jpg"
  }, {
    metaData: {
      height: 2240,
      lastModified: 1445857821,
      name: "860df034014674abd7a2e73abe0b851b",
      size: 5655675,
      width: 4000,
      title: "Image Title",
      description: "Add a description to your item so visitors can know more about your image or video. Tell them where it was taken or the story behind it.",
      isDemo: true
    },
    orderIndex: 2,
    itemId: "860df034014674abd7a2e73abe0b851b",
    url: "8bb438_c7d2ea0b829b4a7e9f4b25dc9e456682~mv2.jpg"
  }, {
    metaData: {
      height: 2240,
      lastModified: 1445857821,
      name: "860df034014674abd7a2e73abe0b851b",
      size: 5655675,
      width: 4000,
      title: "Image Title",
      description: "Add a description to your item so visitors can know more about your image or video. Tell them where it was taken or the story behind it.",
      isDemo: true
    },
    orderIndex: 2,
    itemId: "860df034014674abd7a2e73abe0b851b",
    url: "8bb438_49ba3224ba794c5e970d5aac14e0f803~mv2.jpg"
  }]
};

var allVideos = {

  "setId": "c9b126c9-3f2c-4705-8c7e-bcfd99f2a685",
  "name": "Page",
  "photos": [{
    "itemId": "d19570fa-e97f-4b3d-b8ad-4e24b3a9a3ec",
    "url": "0d72ac_31569a98fd8d436f98ae9c827c216443",
    "orderIndex": 1.447790730099E8,
    "metadata": {
      "name": "342278662.mp4",
      "size": 8941842,
      "lastModified": 1431352380000,
      "width": 1920,
      "height": 1080,
      "type": "video",
      "posters": [{
        "url": "0d72ac_31569a98fd8d436f98ae9c827c216443f000.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_31569a98fd8d436f98ae9c827c216443f001.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_31569a98fd8d436f98ae9c827c216443f002.jpg",
        "height": 1080,
        "width": 1920
      }, { "url": "0d72ac_31569a98fd8d436f98ae9c827c216443f003.jpg", "height": 1080, "width": 1920 }],
      "duration": 14914,
      "qualities": [{
        "formats": ["mp4", "webm"],
        "height": 480,
        "quality": "480p",
        "width": 854
      }, { "formats": ["mp4", "webm"], "height": 720, "quality": "720p", "width": 1280 }, {
        "formats": ["mp4", "webm"],
        "height": 1080,
        "quality": "1080p",
        "width": 1920
      }]
    }
  }, {
    "itemId": "5f51db65-4104-447b-b675-94657671a73f",
    "url": "0d72ac_3e5c5b13a90749a6a02c845e8d1fa4dc",
    "orderIndex": 1.447790760099E8,
    "metadata": {
      "name": "343014810.mp4",
      "size": 23225503,
      "lastModified": 1435064726000,
      "width": 1920,
      "height": 1080,
      "type": "video",
      "posters": [{
        "url": "0d72ac_3e5c5b13a90749a6a02c845e8d1fa4dcf000.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_3e5c5b13a90749a6a02c845e8d1fa4dcf001.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_3e5c5b13a90749a6a02c845e8d1fa4dcf002.jpg",
        "height": 1080,
        "width": 1920
      }, { "url": "0d72ac_3e5c5b13a90749a6a02c845e8d1fa4dcf003.jpg", "height": 1080, "width": 1920 }],
      "duration": 44878,
      "qualities": [{
        "formats": ["mp4", "webm"],
        "height": 480,
        "quality": "480p",
        "width": 854
      }, { "formats": ["mp4", "webm"], "height": 720, "quality": "720p", "width": 1280 }, {
        "formats": ["mp4", "webm"],
        "height": 1080,
        "quality": "1080p",
        "width": 1920
      }]
    }
  }, {
    "itemId": "98c5601c-3486-452b-933c-49cb451d676f",
    "url": "0d72ac_8cebf3ded81a496cb5a1dde4d3ebf0db",
    "orderIndex": 1.447790830099E8,
    "metadata": {
      "name": "Loop_NightRide1 (1).mp4",
      "size": 50631228,
      "lastModified": 1441172756000,
      "width": 1920,
      "height": 1080,
      "type": "video",
      "posters": [{
        "url": "0d72ac_8cebf3ded81a496cb5a1dde4d3ebf0dbf000.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_8cebf3ded81a496cb5a1dde4d3ebf0dbf001.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_8cebf3ded81a496cb5a1dde4d3ebf0dbf002.jpg",
        "height": 1080,
        "width": 1920
      }, { "url": "0d72ac_8cebf3ded81a496cb5a1dde4d3ebf0dbf003.jpg", "height": 1080, "width": 1920 }],
      "duration": 24290,
      "qualities": [{
        "formats": ["mp4", "webm"],
        "height": 480,
        "quality": "480p",
        "width": 854
      }, { "formats": ["mp4", "webm"], "height": 720, "quality": "720p", "width": 1280 }, {
        "formats": ["mp4", "webm"],
        "height": 1080,
        "quality": "1080p",
        "width": 1920
      }]
    }
  }, {
    "itemId": "8dc4f30b-85cc-4795-9aa5-5ccb1bdb4ef1",
    "url": "0d72ac_11bbc686975e49caa89013d03e05d554",
    "orderIndex": 1.447790870099E8,
    "metadata": {
      "name": "file (2).mp4",
      "size": 408855,
      "lastModified": 1456217552000,
      "width": 1920,
      "height": 1080,
      "type": "video",
      "posters": [{
        "url": "0d72ac_11bbc686975e49caa89013d03e05d554f000.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_11bbc686975e49caa89013d03e05d554f001.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_11bbc686975e49caa89013d03e05d554f002.jpg",
        "height": 1080,
        "width": 1920
      }, { "url": "0d72ac_11bbc686975e49caa89013d03e05d554f003.jpg", "height": 1080, "width": 1920 }],
      "duration": 767,
      "qualities": [{
        "formats": ["mp4", "webm"],
        "height": 480,
        "quality": "480p",
        "width": 854
      }, { "formats": ["mp4", "webm"], "height": 720, "quality": "720p", "width": 1280 }, {
        "formats": ["mp4", "webm"],
        "height": 1080,
        "quality": "1080p",
        "width": 1920
      }]
    }
  }, {
    "itemId": "1fc26b40-8e53-4de2-afa7-eefa8be40a01",
    "url": "0d72ac_ec7acce34f9a48e4adcca80aa7f46827",
    "orderIndex": 1.447790890099E8,
    "metadata": {
      "name": "343287604.mp4",
      "size": 6873451,
      "lastModified": 1435063896000,
      "width": 1920,
      "height": 1080,
      "type": "video",
      "posters": [{
        "url": "0d72ac_ec7acce34f9a48e4adcca80aa7f46827f000.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_ec7acce34f9a48e4adcca80aa7f46827f001.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_ec7acce34f9a48e4adcca80aa7f46827f002.jpg",
        "height": 1080,
        "width": 1920
      }, { "url": "0d72ac_ec7acce34f9a48e4adcca80aa7f46827f003.jpg", "height": 1080, "width": 1920 }],
      "duration": 15048,
      "qualities": [{
        "formats": ["mp4", "webm"],
        "height": 480,
        "quality": "480p",
        "width": 854
      }, { "formats": ["mp4", "webm"], "height": 720, "quality": "720p", "width": 1280 }, {
        "formats": ["mp4", "webm"],
        "height": 1080,
        "quality": "1080p",
        "width": 1920
      }]
    }
  }, {
    "itemId": "97143d61-94ef-42af-83b2-dc91ade1b5ed",
    "url": "0d72ac_8473aaf089cf4f78ad4e037c9340db47",
    "orderIndex": 1.447790960099E8,
    "metadata": {
      "name": "343806063.mp4",
      "size": 33711266,
      "lastModified": 1435064606000,
      "width": 1920,
      "height": 1080,
      "type": "video",
      "posters": [{
        "url": "0d72ac_8473aaf089cf4f78ad4e037c9340db47f000.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_8473aaf089cf4f78ad4e037c9340db47f001.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_8473aaf089cf4f78ad4e037c9340db47f002.jpg",
        "height": 1080,
        "width": 1920
      }, { "url": "0d72ac_8473aaf089cf4f78ad4e037c9340db47f003.jpg", "height": 1080, "width": 1920 }],
      "duration": 56656,
      "qualities": [{
        "formats": ["mp4", "webm"],
        "height": 480,
        "quality": "480p",
        "width": 854
      }, { "formats": ["mp4", "webm"], "height": 720, "quality": "720p", "width": 1280 }, {
        "formats": ["mp4", "webm"],
        "height": 1080,
        "quality": "1080p",
        "width": 1920
      }]
    }
  }, {
    "itemId": "b801aac0-90d0-439e-9bdf-ad01491f75ae",
    "url": "0d72ac_648a202922414ffa836f639dee9ef389",
    "orderIndex": 1.447791000099E8,
    "metadata": {
      "name": "343287517.mp4",
      "size": 32830839,
      "lastModified": 1435064406000,
      "width": 1920,
      "height": 1080,
      "type": "video",
      "posters": [{
        "url": "0d72ac_648a202922414ffa836f639dee9ef389f000.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_648a202922414ffa836f639dee9ef389f001.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_648a202922414ffa836f639dee9ef389f002.jpg",
        "height": 1080,
        "width": 1920
      }, { "url": "0d72ac_648a202922414ffa836f639dee9ef389f003.jpg", "height": 1080, "width": 1920 }],
      "duration": 55221,
      "qualities": [{
        "formats": ["mp4", "webm"],
        "height": 480,
        "quality": "480p",
        "width": 854
      }, { "formats": ["mp4", "webm"], "height": 720, "quality": "720p", "width": 1280 }, {
        "formats": ["mp4", "webm"],
        "height": 1080,
        "quality": "1080p",
        "width": 1920
      }]
    }
  }, {
    "itemId": "b83065cf-fe90-40be-951e-f5ceef8bb4c2",
    "url": "0d72ac_c7b0d48d722642cfa03bb2bab58bd1c4",
    "orderIndex": 1.447791040099E8,
    "metadata": {
      "name": "file (1).mp4",
      "size": 18347300,
      "lastModified": 1456217585000,
      "width": 1920,
      "height": 1080,
      "type": "video",
      "posters": [{
        "url": "0d72ac_c7b0d48d722642cfa03bb2bab58bd1c4f000.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_c7b0d48d722642cfa03bb2bab58bd1c4f001.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_c7b0d48d722642cfa03bb2bab58bd1c4f002.jpg",
        "height": 1080,
        "width": 1920
      }, { "url": "0d72ac_c7b0d48d722642cfa03bb2bab58bd1c4f003.jpg", "height": 1080, "width": 1920 }],
      "duration": 25480,
      "qualities": [{
        "formats": ["mp4", "webm"],
        "height": 480,
        "quality": "480p",
        "width": 854
      }, { "formats": ["mp4", "webm"], "height": 720, "quality": "720p", "width": 1280 }, {
        "formats": ["mp4", "webm"],
        "height": 1080,
        "quality": "1080p",
        "width": 1920
      }]
    }
  }, {
    "itemId": "bb20159b-49da-4615-9582-063f701bc830",
    "url": "0d72ac_5a0019a04722461aa11b9aaad3b68ce0",
    "orderIndex": 1.447791050099E8,
    "metadata": {
      "name": "343639902.mp4",
      "size": 8768252,
      "lastModified": 1435064070000,
      "width": 1920,
      "height": 1080,
      "type": "video",
      "posters": [{
        "url": "0d72ac_5a0019a04722461aa11b9aaad3b68ce0f000.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_5a0019a04722461aa11b9aaad3b68ce0f001.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_5a0019a04722461aa11b9aaad3b68ce0f002.jpg",
        "height": 1080,
        "width": 1920
      }, { "url": "0d72ac_5a0019a04722461aa11b9aaad3b68ce0f003.jpg", "height": 1080, "width": 1920 }],
      "duration": 15415,
      "qualities": [{
        "formats": ["mp4", "webm"],
        "height": 480,
        "quality": "480p",
        "width": 854
      }, { "formats": ["mp4", "webm"], "height": 720, "quality": "720p", "width": 1280 }, {
        "formats": ["mp4", "webm"],
        "height": 1080,
        "quality": "1080p",
        "width": 1920
      }]
    }
  }, {
    "itemId": "c661ca80-5ba7-4961-be5d-2fbbe945913d",
    "url": "0d72ac_f70ffc53e8a147dcbe2acebb2a5f1021",
    "orderIndex": 1.447791120099E8,
    "metadata": {
      "name": "342933669.mp4",
      "size": 15939625,
      "lastModified": 1435064682000,
      "width": 1920,
      "height": 1080,
      "type": "video",
      "posters": [{
        "url": "0d72ac_f70ffc53e8a147dcbe2acebb2a5f1021f000.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_f70ffc53e8a147dcbe2acebb2a5f1021f001.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_f70ffc53e8a147dcbe2acebb2a5f1021f002.jpg",
        "height": 1080,
        "width": 1920
      }, { "url": "0d72ac_f70ffc53e8a147dcbe2acebb2a5f1021f003.jpg", "height": 1080, "width": 1920 }],
      "duration": 26993,
      "qualities": [{
        "formats": ["mp4", "webm"],
        "height": 480,
        "quality": "480p",
        "width": 854
      }, { "formats": ["mp4", "webm"], "height": 720, "quality": "720p", "width": 1280 }, {
        "formats": ["mp4", "webm"],
        "height": 1080,
        "quality": "1080p",
        "width": 1920
      }]
    }
  }, {
    "itemId": "f192d527-0781-4ef1-89f8-d2dde4e6a563",
    "url": "0d72ac_f60ba42798594ad09b4fa5207967a4cc",
    "orderIndex": 1.447791150099E8,
    "metadata": {
      "name": "343380914.mp4",
      "size": 15311752,
      "lastModified": 1435064172000,
      "width": 1920,
      "height": 1080,
      "type": "video",
      "posters": [{
        "url": "0d72ac_f60ba42798594ad09b4fa5207967a4ccf000.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_f60ba42798594ad09b4fa5207967a4ccf001.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_f60ba42798594ad09b4fa5207967a4ccf002.jpg",
        "height": 1080,
        "width": 1920
      }, { "url": "0d72ac_f60ba42798594ad09b4fa5207967a4ccf003.jpg", "height": 1080, "width": 1920 }],
      "duration": 25959,
      "qualities": [{
        "formats": ["mp4", "webm"],
        "height": 480,
        "quality": "480p",
        "width": 854
      }, { "formats": ["mp4", "webm"], "height": 720, "quality": "720p", "width": 1280 }, {
        "formats": ["mp4", "webm"],
        "height": 1080,
        "quality": "1080p",
        "width": 1920
      }]
    }
  }, {
    "itemId": "0f541da5-8557-48b0-b2c2-c5c34b33d125",
    "url": "0d72ac_7c7a5b89485a4062ba36ed97b6ac9615",
    "orderIndex": 1.447791180099E8,
    "metadata": {
      "name": "343503620.mp4",
      "size": 7199287,
      "lastModified": 1435064196000,
      "width": 1920,
      "height": 1080,
      "type": "video",
      "posters": [{
        "url": "0d72ac_7c7a5b89485a4062ba36ed97b6ac9615f000.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_7c7a5b89485a4062ba36ed97b6ac9615f001.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_7c7a5b89485a4062ba36ed97b6ac9615f002.jpg",
        "height": 1080,
        "width": 1920
      }, { "url": "0d72ac_7c7a5b89485a4062ba36ed97b6ac9615f003.jpg", "height": 1080, "width": 1920 }],
      "duration": 16766,
      "qualities": [{
        "formats": ["mp4", "webm"],
        "height": 480,
        "quality": "480p",
        "width": 854
      }, { "formats": ["mp4", "webm"], "height": 720, "quality": "720p", "width": 1280 }, {
        "formats": ["mp4", "webm"],
        "height": 1080,
        "quality": "1080p",
        "width": 1920
      }]
    }
  }, {
    "itemId": "96858c16-1f77-4d88-a622-6a24442259df",
    "url": "0d72ac_3ba52f5159984d78935ad4f950e9aef8",
    "orderIndex": 1.447791280099E8,
    "metadata": {
      "name": "343635634.mp4",
      "size": 2537847,
      "lastModified": 1435064458000,
      "width": 1920,
      "height": 1080,
      "type": "video",
      "posters": [{
        "url": "0d72ac_3ba52f5159984d78935ad4f950e9aef8f000.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_3ba52f5159984d78935ad4f950e9aef8f001.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_3ba52f5159984d78935ad4f950e9aef8f002.jpg",
        "height": 1080,
        "width": 1920
      }, { "url": "0d72ac_3ba52f5159984d78935ad4f950e9aef8f003.jpg", "height": 1080, "width": 1920 }],
      "duration": 7974,
      "qualities": [{
        "formats": ["mp4", "webm"],
        "height": 480,
        "quality": "480p",
        "width": 854
      }, { "formats": ["mp4", "webm"], "height": 720, "quality": "720p", "width": 1280 }, {
        "formats": ["mp4", "webm"],
        "height": 1080,
        "quality": "1080p",
        "width": 1920
      }]
    }
  }],
  "orderIndex": 1.4562416457639998E8,
  "setType": "original_set",
  "settings": {
    "filesFolders": {
      "picture": "ab1697fd19cd48bd88d92d7bc5c566e0",
      "video": "d0a7e49bc156499fa100b12e79601c74"
    },
    "isPublic": true,
    "isVisible": true,
    "allowDownload": false
  },
  "photosCount": 69
};

var allImages = {
  setId: "01d9d4c0-5bc2-43c9-9e26-fae31bedaed9",
  name: "Sample Images",
  photos: [{
    metadata: {
      height: 1000,
      lastModified: 1445860855,
      name: "8b72558253b2502b401bb46e5599f22a",
      size: 1100727,
      width: 1920
    },
    orderIndex: 0,
    itemId: "8b72558253b2502b401bb46e5599f22a",
    url: "8bb438_1b73a6b067b24175bd087e86613bd00c.jpg"
  }, {
    metadata: {
      height: 5600,
      lastModified: 1445857830,
      name: "2d3b675ea857dc41158bad3b28300824",
      size: 8128464,
      width: 3737
    },
    orderIndex: 1,
    itemId: "2d3b675ea857dc41158bad3b28300824",
    url: "8bb438_78ff5e32500d48cdaa22a3f446d68216.jpg"
  }, {
    metadata: {
      height: 3737,
      lastModified: 1445857821,
      name: "860df034014674abd7a2e73abe0b851b",
      size: 5655675,
      width: 5600
    },
    orderIndex: 2,
    itemId: "860df034014674abd7a2e73abe0b851b",
    url: "8bb438_ff062a651e174cf5926fe5c088be1099.jpg"
  }, {
    metadata: {
      height: 3737,
      lastModified: 1445857814,
      name: "a898a24fe0d2c60a348eac9e38cae265",
      size: 11697590,
      width: 5600
    },
    orderIndex: 3,
    itemId: "a898a24fe0d2c60a348eac9e38cae265",
    url: "8bb438_5ec836c505f445dfab711a56e67fc502.jpg"
  }, {
    metadata: {
      height: 3737,
      lastModified: 1445857800,
      name: "5dd5a6e757c702b2856a3a2f4bb00154",
      size: 6528300,
      width: 5600
    },
    orderIndex: 4,
    itemId: "5dd5a6e757c702b2856a3a2f4bb00154",
    url: "8bb438_2798f080526a4d3f8cb89d93e305a0b8.jpg"
  }, {
    metadata: {
      height: 3737,
      lastModified: 1445857785,
      name: "e8b32772f67865aedb3b12115eaf19a4",
      size: 4931341,
      width: 5600
    },
    orderIndex: 5,
    itemId: "e8b32772f67865aedb3b12115eaf19a4",
    url: "8bb438_9a335dcb8c884086b8ffdf1ea44ca7e9.jpg"
  }, {
    metadata: {
      height: 3737,
      lastModified: 1445857778,
      name: "90e376fcd4b801bed0f22cb5bd7d0045",
      size: 11051393,
      width: 5600
    },
    orderIndex: 6,
    itemId: "90e376fcd4b801bed0f22cb5bd7d0045",
    url: "8bb438_6e9b65f5c9e343c6bc3344b2def0df11.jpg"
  }, {
    metadata: {
      height: 3737,
      lastModified: 1445857763,
      name: "0db65a80624a2e0b8c71e553b6f4b3f6",
      size: 9294683,
      width: 5600
    },
    orderIndex: 7,
    itemId: "0db65a80624a2e0b8c71e553b6f4b3f6",
    url: "8bb438_f4f7fa31c5364557af0da7c4fd543cc9.jpg"
  }, {
    metadata: {
      height: 3737,
      lastModified: 1445857751,
      name: "1f02dcba84a9b73b40d25e59280a9580",
      size: 9048422,
      width: 5600
    },
    orderIndex: 8,
    itemId: "1f02dcba84a9b73b40d25e59280a9580",
    url: "8bb438_0e26eb36903c40558d3e9a3dc088b791.jpg"
  }, {
    metadata: {
      height: 3737,
      lastModified: 1445857742,
      name: "70cf2b13f9bde8f8c33768260f25050a",
      size: 6486671,
      width: 5600
    },
    orderIndex: 9,
    itemId: "70cf2b13f9bde8f8c33768260f25050a",
    url: "8bb438_1d81fe98c5cc433a9651fc24e7ce2617.jpg"
  }, {
    metadata: {
      height: 3737,
      lastModified: 1445857734,
      name: "8e0bf32b6fade59dcfd7757ead8a0478",
      size: 9556027,
      width: 5600
    },
    orderIndex: 10,
    itemId: "8e0bf32b6fade59dcfd7757ead8a0478",
    url: "8bb438_2ecb6a1a9d5b4e148bd83a1ea3920860.jpg"
  }, {
    metadata: {
      height: 3737,
      lastModified: 1445857722,
      name: "027af4a640930155cd68f72b3236842d",
      size: 6526471,
      width: 5600
    },
    orderIndex: 11,
    itemId: "027af4a640930155cd68f72b3236842d",
    url: "8bb438_7927e7c1e0ac4420b603ddfa02cba6c9.jpg"
  }, {
    metadata: {
      height: 3737,
      lastModified: 1445857703,
      name: "5fb9385c24ba5972991a2da94fe5b550",
      size: 11226275,
      width: 5600
    },
    orderIndex: 12,
    itemId: "5fb9385c24ba5972991a2da94fe5b550",
    url: "8bb438_37f441d6939f4c1eb8e335b231afb7b9.jpg"
  }, {
    metadata: {
      height: 3737,
      lastModified: 1445857691,
      name: "34fb0d724c5d3921d22b997a8c1705ef",
      size: 7257722,
      width: 5600
    },
    orderIndex: 13,
    itemId: "34fb0d724c5d3921d22b997a8c1705ef",
    url: "8bb438_f8233d1de49442169c3bd47e3dce2780.jpg"
  }, {
    metadata: {
      height: 3737,
      lastModified: 1445857683,
      name: "984bf3ca8432e2da6e65601d7cec1104",
      size: 8525833,
      width: 5600
    },
    orderIndex: 14,
    itemId: "984bf3ca8432e2da6e65601d7cec1104",
    url: "8bb438_a60117ec179b4390bbc50af20f34f144.jpg"
  }, {
    metadata: {
      height: 5600,
      lastModified: 1445857674,
      name: "0a1f3af15dc764fd08e5c83a9febb30e",
      size: 12994265,
      width: 3737
    },
    orderIndex: 16,
    itemId: "0a1f3af15dc764fd08e5c83a9febb30e",
    url: "8bb438_a59d1b89bd074b75b62a8838034f72f6.jpg"
  }, {
    metadata: {
      height: 5600,
      lastModified: 1445857660,
      name: "ab9e2fa37f6355328860bdf52d1f2088",
      size: 9074907,
      width: 3737
    },
    orderIndex: 17,
    itemId: "ab9e2fa37f6355328860bdf52d1f2088",
    url: "8bb438_6bf791d3442746a7996b1b343549c845.jpg"
  }, {
    metadata: {
      height: 3737,
      lastModified: 1445857651,
      name: "8f3f93f90a846f70fc897755f70525a7",
      size: 6893842,
      width: 5600
    },
    orderIndex: 18,
    itemId: "8f3f93f90a846f70fc897755f70525a7",
    url: "8bb438_6ea01262e7a94b2490ab1c6d8b889122.jpg"
  }, {
    metadata: {
      height: 3737,
      lastModified: 1445857640,
      name: "d1168a52496bc3a7b5e0025212a76e2c",
      size: 10155312,
      width: 5600
    },
    orderIndex: 19,
    itemId: "d1168a52496bc3a7b5e0025212a76e2c",
    url: "8bb438_760699a583514efca897ee37d95e9c76.jpg"
  }, {
    metadata: {
      height: 3056,
      lastModified: 1445858468,
      name: "46247b1df460eb0e8272053a9a079ab1",
      size: 9930627,
      width: 4400
    },
    orderIndex: 20,
    itemId: "46247b1df460eb0e8272053a9a079ab1",
    url: "8bb438_e725684e4a1841859668483efd0f9509.jpg"
  }, {
    metadata: {
      height: 2829,
      lastModified: 1445858458,
      name: "ea8ec1609e052b7f196935318316299d",
      size: 9812260,
      width: 4200
    },
    orderIndex: 21,
    itemId: "ea8ec1609e052b7f196935318316299d",
    url: "8bb438_149b418b9bfb47e0adafc569ca55c5e9.jpg"
  }, {
    metadata: {
      height: 4200,
      lastModified: 1445858438,
      name: "098281dfb9701c0068f786bc8aab0390",
      size: 8707214,
      width: 2799
    },
    orderIndex: 22,
    itemId: "098281dfb9701c0068f786bc8aab0390",
    url: "8bb438_0d738ee5a4a04f54891e08488fd7c7bc.jpg"
  }, {
    metadata: {
      height: 3228,
      lastModified: 1445858429,
      name: "1ea8c429c3fbbc7b507b45b756c8499f",
      size: 9487361,
      width: 4500
    },
    orderIndex: 23,
    itemId: "1ea8c429c3fbbc7b507b45b756c8499f",
    url: "8bb438_1ab1a6e5d0bf4edeb847d15d821a76d8.jpg"
  }, {
    metadata: {
      height: 3840,
      lastModified: 1445858419,
      name: "a466b258c6b5e2096fa546c86aae8fa2",
      size: 15444132,
      width: 5494
    },
    orderIndex: 24,
    itemId: "a466b258c6b5e2096fa546c86aae8fa2",
    url: "8bb438_eeef61d83253480ab7bbdb07692b4c90.jpg"
  }, {
    metadata: {
      height: 2800,
      lastModified: 1445858401,
      name: "a081f588eff30a9f8b6fcd0f4889eac3",
      size: 8885483,
      width: 4200
    },
    orderIndex: 25,
    itemId: "a081f588eff30a9f8b6fcd0f4889eac3",
    url: "8bb438_2ff4f1995c0e40d49158d5225eeb465e.jpg"
  }, {
    metadata: {
      height: 2800,
      lastModified: 1445858391,
      name: "9c0c752ebc1b7b27dc3b02b98f2a4181",
      size: 7486333,
      width: 4200
    },
    orderIndex: 26,
    itemId: "9c0c752ebc1b7b27dc3b02b98f2a4181",
    url: "8bb438_e78b371c75ce42de8719dccfc97298a4.jpg"
  }, {
    metadata: {
      height: 3000,
      lastModified: 1445858374,
      name: "5c64c68f0efda76c3cfbf83f569a8e2e",
      size: 10375299,
      width: 4500
    },
    orderIndex: 27,
    itemId: "5c64c68f0efda76c3cfbf83f569a8e2e",
    url: "8bb438_a2049532d1b7487ba542f55efbc55c7c.jpg"
  }, {
    metadata: {
      height: 3282,
      lastModified: 1445858362,
      name: "87dc373b35ff17641e86a23b58635f89",
      size: 10610316,
      width: 5000
    },
    orderIndex: 28,
    itemId: "87dc373b35ff17641e86a23b58635f89",
    url: "8bb438_e8735e0102554d6ead385a48e2b9e69a.jpg"
  }, {
    metadata: {
      height: 2966,
      lastModified: 1445858349,
      name: "d432d617a9f508cf404d64d8c489e1f1",
      size: 6443941,
      width: 4400
    },
    orderIndex: 29,
    itemId: "d432d617a9f508cf404d64d8c489e1f1",
    url: "8bb438_ea26cc9ae0ce440bbc4cfaaa8864c5e6.jpg"
  }, {
    metadata: {
      height: 3066,
      lastModified: 1445858340,
      name: "7a5e2e30ec277ada8e1715ed520e6b38",
      size: 8182325,
      width: 4600
    },
    orderIndex: 30,
    itemId: "7a5e2e30ec277ada8e1715ed520e6b38",
    url: "8bb438_4fe0d8e3dee641559dffc604be287e32.jpg"
  }, {
    metadata: {
      height: 3467,
      lastModified: 1445858331,
      name: "c6b5cd1f1316311ec3560d6fb7d50958",
      size: 8925756,
      width: 5200
    },
    orderIndex: 31,
    itemId: "c6b5cd1f1316311ec3560d6fb7d50958",
    url: "8bb438_17a7e143ea0148959ef6c5663158ade0.jpg"
  }, {
    metadata: {
      height: 2800,
      lastModified: 1445861402,
      name: "d63281682aa9881794bd301d06f37dba",
      size: 5345028,
      width: 4200
    },
    orderIndex: 32,
    itemId: "d63281682aa9881794bd301d06f37dba",
    url: "8bb438_c79f9e778d474b18a9f980595caf57f3.jpg"
  }, {
    metadata: {
      height: 4200,
      lastModified: 1445861394,
      name: "0bd4f007cef66bf47fbb936fb3ea2336",
      size: 8207276,
      width: 2800
    },
    orderIndex: 33,
    itemId: "0bd4f007cef66bf47fbb936fb3ea2336",
    url: "8bb438_026dd01a64a646958298f535f037c627.jpg"
  }, {
    metadata: {
      height: 1280,
      lastModified: 1445859025,
      name: "759c83479429d725f03367897235a8b5",
      size: 2039710,
      width: 1920
    },
    orderIndex: 34,
    itemId: "759c83479429d725f03367897235a8b5",
    url: "8bb438_4af301c080294224b6b5e15cd38a035f.jpg"
  }, {
    metadata: {
      height: 3727,
      lastModified: 1445860434,
      name: "0ee95e519c2e1274c30f56e3c098ec86",
      size: 2051821,
      width: 5600
    },
    orderIndex: 35,
    itemId: "0ee95e519c2e1274c30f56e3c098ec86",
    url: "8bb438_a132b18dea524d48a68a37f0075fcc1e.jpg"
  }, {
    metadata: {
      height: 5600,
      lastModified: 1445860430,
      name: "262e38d72080e92600c9df018a4f4f1e",
      size: 2445274,
      width: 3727
    },
    orderIndex: 36,
    itemId: "262e38d72080e92600c9df018a4f4f1e",
    url: "8bb438_4fa0352201a1431395c3c4d4b21e3481.jpg"
  }, {
    metadata: {
      height: 3727,
      lastModified: 1445860420,
      name: "3dff88af7694728e13d6ca4ff03fc6cf",
      size: 3904313,
      width: 5600
    },
    orderIndex: 37,
    itemId: "3dff88af7694728e13d6ca4ff03fc6cf",
    url: "8bb438_d6bfaf940d05421cb6bc7a8c867fb4b5.jpg"
  }, {
    metadata: {
      height: 3727,
      lastModified: 1445860407,
      name: "83d9e931839e66e00faf1df41cbc7349",
      size: 2816020,
      width: 5600
    },
    orderIndex: 38,
    itemId: "83d9e931839e66e00faf1df41cbc7349",
    url: "8bb438_71edafe6d54d457484285e61a1f75d17.jpg"
  }, {
    metadata: {
      height: 3728,
      lastModified: 1445860396,
      name: "678c48f759062c8e8146a70043ad7823",
      size: 2626295,
      width: 5600
    },
    orderIndex: 39,
    itemId: "678c48f759062c8e8146a70043ad7823",
    url: "8bb438_ced2a19af5cf448e91413099f4c422fa.jpg"
  }, {
    metadata: {
      height: 3727,
      lastModified: 1445860392,
      name: "f6db1b532552aa00e9549b5c97e6770a",
      size: 3807639,
      width: 5600
    },
    orderIndex: 40,
    itemId: "f6db1b532552aa00e9549b5c97e6770a",
    url: "8bb438_cabd67053eae45e7ab273832504717ff.jpg"
  }, {
    metadata: {
      height: 5600,
      lastModified: 1445860384,
      name: "69102794801438efee46af8202c76b81",
      size: 2671950,
      width: 3727
    },
    orderIndex: 41,
    itemId: "69102794801438efee46af8202c76b81",
    url: "8bb438_66a1bb26f7f64497be343d886fe2197a.jpg"
  }, {
    metadata: {
      height: 3727,
      lastModified: 1445860380,
      name: "61d3f0c021fd47d92a4e7395ab107e48",
      size: 3471762,
      width: 5600
    },
    orderIndex: 42,
    itemId: "61d3f0c021fd47d92a4e7395ab107e48",
    url: "8bb438_cdbf2bdff4864d2094370a3051812409.jpg"
  }, {
    metadata: {
      height: 3728,
      lastModified: 1445860375,
      name: "22883fe4ca22b25b5b19c8640d21d524",
      size: 4229177,
      width: 5600
    },
    orderIndex: 43,
    itemId: "22883fe4ca22b25b5b19c8640d21d524",
    url: "8bb438_2a22b3e85bb1434e81f6fbd4878fb4ae.jpg"
  }, {
    metadata: {
      height: 3727,
      lastModified: 1445860369,
      name: "cf6787a4653057bd8af8cb05888dc9b1",
      size: 2936592,
      width: 5600
    },
    orderIndex: 44,
    itemId: "cf6787a4653057bd8af8cb05888dc9b1",
    url: "8bb438_f7612090677241d1a5b8fee6752954e9.jpg"
  }, {
    metadata: {
      height: 3727,
      lastModified: 1445860365,
      name: "fdda4e9e700d4208640b78d5c035d88a",
      size: 3756606,
      width: 5600
    },
    orderIndex: 45,
    itemId: "fdda4e9e700d4208640b78d5c035d88a",
    url: "8bb438_d849ef374eb64dd287e53d27797a764f.jpg"
  }, {
    metadata: {
      height: 3727,
      lastModified: 1445860360,
      name: "74f7bad48d543460fb949cc406fb70e7",
      size: 2877705,
      width: 5600
    },
    orderIndex: 46,
    itemId: "74f7bad48d543460fb949cc406fb70e7",
    url: "8bb438_8583414cdf6544a191e2b8f678ce7b63.jpg"
  }, {
    metadata: {
      height: 3728,
      lastModified: 1445860354,
      name: "a005c2daaa8b7c8cf1c53f589e64a860",
      size: 3953647,
      width: 5600
    },
    orderIndex: 47,
    itemId: "a005c2daaa8b7c8cf1c53f589e64a860",
    url: "8bb438_c64d6dc2b5e74058bba77f616146a4cf.jpg"
  }, {
    metadata: {
      height: 3727,
      lastModified: 1445860346,
      name: "b091d8ac038d07476546bef2475a7b03",
      size: 2913404,
      width: 5600
    },
    orderIndex: 48,
    itemId: "b091d8ac038d07476546bef2475a7b03",
    url: "8bb438_e353d9a6ec324041a17a28d10e21819d.jpg"
  }, {
    metadata: {
      height: 3727,
      lastModified: 1445860335,
      name: "2b5c5f752b1c931b2351bee50aa939f0",
      size: 3010614,
      width: 5600
    },
    orderIndex: 49,
    itemId: "2b5c5f752b1c931b2351bee50aa939f0",
    url: "8bb438_402a161778db429e8ef3423788b9a7b6.jpg"
  }, {
    metadata: {
      height: 3727,
      lastModified: 1445860450,
      name: "7968928dd556638214cf26be7ea2a592",
      size: 2704408,
      width: 5600
    },
    orderIndex: 50,
    itemId: "7968928dd556638214cf26be7ea2a592",
    url: "8bb438_525271503ee64479925f13cfa2f312c8.jpg"
  }, {
    metadata: {
      height: 3727,
      lastModified: 1445860437,
      name: "eb2349c8379074578a5ac7ca97aec2e4",
      size: 2049626,
      width: 5600
    },
    orderIndex: 51,
    itemId: "eb2349c8379074578a5ac7ca97aec2e4",
    url: "8bb438_2e22ca8b422e44c5a6fb723392a747b5.jpg"
  }, {
    metadata: {
      height: 4930,
      lastModified: 1445852211,
      name: "4f431d8f88a3e5d3842df5a906fd536f",
      size: 1603869,
      width: 3287
    },
    orderIndex: 52,
    itemId: "4f431d8f88a3e5d3842df5a906fd536f",
    url: "8bb438_4afd60c9c97d44c8bcd61f1b6080d7e5.jpg"
  }, {
    metadata: {
      height: 4645,
      lastModified: 1445852211,
      name: "3337a427b2e877ab39bf116fcb3f01ea",
      size: 2057775,
      width: 3484
    },
    orderIndex: 53,
    itemId: "3337a427b2e877ab39bf116fcb3f01ea",
    url: "8bb438_a74f09cd4425418296d417ce91f589cd.jpg"
  }, {
    metadata: {
      height: 5580,
      lastModified: 1445852211,
      name: "7474d69be9754f2f5012a08ab9e5c283",
      size: 1862011,
      width: 3720
    },
    orderIndex: 54,
    itemId: "7474d69be9754f2f5012a08ab9e5c283",
    url: "8bb438_5a7139bf3b91452ea725151ffb285335.jpg"
  }, {
    metadata: {
      height: 5258,
      lastModified: 1445852211,
      name: "befba01503f77c9dc77df88419290c01",
      size: 2157963,
      width: 3946
    },
    orderIndex: 55,
    itemId: "befba01503f77c9dc77df88419290c01",
    url: "8bb438_fe7a4cc39e624bd09cb48510d6d46056.jpg"
  }, {
    metadata: {
      height: 4645,
      lastModified: 1445852211,
      name: "2f493d2be5d47bd89b016ba46a0f66f4",
      size: 1679662,
      width: 3484
    },
    orderIndex: 56,
    itemId: "2f493d2be5d47bd89b016ba46a0f66f4",
    url: "8bb438_8bc1731cedd84dc7846ebd434e305c8a.jpg"
  }, {
    metadata: {
      height: 5260,
      lastModified: 1445852211,
      name: "2d6bee6fe2a726f213599508722bcb27",
      size: 2462629,
      width: 3945
    },
    orderIndex: 57,
    itemId: "2d6bee6fe2a726f213599508722bcb27",
    url: "8bb438_4eb7f81b49a64578bf5775417c4c2c9a.jpg"
  }, {
    metadata: {
      height: 3710,
      lastModified: 1445852211,
      name: "9e6bb2d0c554dcd559a32ab89c9092f0",
      size: 1423161,
      width: 3180
    },
    orderIndex: 58,
    itemId: "9e6bb2d0c554dcd559a32ab89c9092f0",
    url: "8bb438_cbe02f139b8e479387eb7f5f9e8424c9.jpg"
  }, {
    metadata: {
      height: 4645,
      lastModified: 1445852211,
      name: "315e6213ce778d43f5580b2caf347556",
      size: 1683368,
      width: 3484
    },
    orderIndex: 59,
    itemId: "315e6213ce778d43f5580b2caf347556",
    url: "8bb438_af22f17274944bea9026107bf670bf7f.jpg"
  }, {
    metadata: {
      height: 4722,
      lastModified: 1445852211,
      name: "338f76721bc5a127ebf0b01306abf35e",
      size: 1904181,
      width: 3542
    },
    orderIndex: 60,
    itemId: "338f76721bc5a127ebf0b01306abf35e",
    url: "8bb438_a8a7ff22738445faa74cf7f68866f4d8.jpg"
  }, {
    metadata: {
      height: 5310,
      lastModified: 1445852211,
      name: "d4c8670400a3bf9d7c8cba7e5f133454",
      size: 2095199,
      width: 3540
    },
    orderIndex: 61,
    itemId: "d4c8670400a3bf9d7c8cba7e5f133454",
    url: "8bb438_c87dd238be8d4a15a57eecbefda4495b.jpg"
  }, {
    metadata: {
      height: 5580,
      lastModified: 1445852211,
      name: "5e106a5d4a0b7709f8938194d4778ff4",
      size: 1521731,
      width: 3720
    },
    orderIndex: 62,
    itemId: "5e106a5d4a0b7709f8938194d4778ff4",
    url: "8bb438_ae4f2ce0cfab47859d294f36b2d87cd7.jpg"
  }, {
    metadata: {
      height: 5580,
      lastModified: 1445852211,
      name: "e8f7b815b395981a5285c2bd8b90b1a6",
      size: 1213695,
      width: 3720
    },
    orderIndex: 63,
    itemId: "e8f7b815b395981a5285c2bd8b90b1a6",
    url: "8bb438_144de0d90d5d4476829c870a38ad8151.jpg"
  }, {
    metadata: {
      height: 4930,
      lastModified: 1445852211,
      name: "ab9df5eb2b706bd06a6e8bab622beba4",
      size: 1376745,
      width: 3286
    },
    orderIndex: 64,
    itemId: "ab9df5eb2b706bd06a6e8bab622beba4",
    url: "8bb438_105a7f98d458406eadb5b99069e05e66.jpg"
  }, {
    metadata: {
      height: 5577,
      lastModified: 1445852211,
      name: "4eb593cdb6d13eb99c7a18d2de79b181",
      size: 2762647,
      width: 3718
    },
    orderIndex: 65,
    itemId: "4eb593cdb6d13eb99c7a18d2de79b181",
    url: "8bb438_d675baa15a344a72b357197c11478240.jpg"
  }, {
    metadata: {
      height: 4645,
      lastModified: 1445852211,
      name: "175fa38b92269154b6673618477160de",
      size: 2117640,
      width: 3483
    },
    orderIndex: 66,
    itemId: "175fa38b92269154b6673618477160de",
    url: "8bb438_4b9b9acb8d6c45deadbeeb0029b4bf5e.jpg"
  }, {
    metadata: {
      height: 2561,
      lastModified: 1445852211,
      name: "5b65c635c3ca09f2badf2aeb6d84ed99",
      size: 1499154,
      width: 1922
    },
    orderIndex: 67,
    itemId: "5b65c635c3ca09f2badf2aeb6d84ed99",
    url: "8bb438_b9926ba84cc548df9011d6227d3e20b1.jpg"
  }, {
    metadata: {
      height: 5577,
      lastModified: 1445861516,
      name: "00a063e26be177d3c6a4a2b41cc15be6",
      size: 2746325,
      width: 3718
    },
    orderIndex: 68,
    itemId: "00a063e26be177d3c6a4a2b41cc15be6",
    url: "8bb438_ff1da0eb6547419fbac324f3a7e6a16c.jpg"
  }, {
    metadata: {
      height: 4930,
      lastModified: 1445861511,
      name: "ad45c7343a2ecf89982122c4097a054d",
      size: 1375916,
      width: 3286
    },
    orderIndex: 69,
    itemId: "ad45c7343a2ecf89982122c4097a054d",
    url: "8bb438_263b45a6faeb49e887b71d10a728516d.jpg"
  }, {
    metadata: {
      height: 1000,
      lastModified: 1445852211,
      name: "066c5c3fafab90ecbef3f32736dac3c8",
      size: 561146,
      width: 1920
    },
    orderIndex: 70,
    itemId: "066c5c3fafab90ecbef3f32736dac3c8",
    url: "8bb438_51948835adb84e0dbcca54ce99b48999.jpg"
  }, {
    metadata: {
      height: 1000,
      lastModified: 1445860813,
      name: "7dc09ef29834aea2ae4d1948d60426c1",
      size: 404456,
      width: 1920
    },
    orderIndex: 71,
    itemId: "7dc09ef29834aea2ae4d1948d60426c1",
    url: "8bb438_ff7d47098495432baa3b80bb14930909.jpg"
  }, {
    metadata: {
      height: 5472,
      lastModified: 1445852219,
      name: "53e606d52c7ac88ab77dce9595eb57c5",
      size: 1108341,
      width: 2947
    },
    orderIndex: 72,
    itemId: "53e606d52c7ac88ab77dce9595eb57c5",
    url: "8bb438_ebbc9ec6c20049f490a06f729e4c79cb.jpg"
  }, {
    metadata: {
      height: 2912,
      lastModified: 1445852219,
      name: "37d29273821f8404ed4832dd0872f8f3",
      size: 775953,
      width: 3648
    },
    orderIndex: 73,
    itemId: "37d29273821f8404ed4832dd0872f8f3",
    url: "8bb438_5aba95641dcd4711863dd7e6954082bd.jpg"
  }, {
    metadata: {
      height: 2213,
      lastModified: 1445852219,
      name: "fc1b98985d634845d9eb5eef2878f327",
      size: 334330,
      width: 3192
    },
    orderIndex: 74,
    itemId: "fc1b98985d634845d9eb5eef2878f327",
    url: "8bb438_47f19e10a9924d56b4a7f51e292cb509.jpg"
  }, {
    metadata: {
      height: 5472,
      lastModified: 1445852219,
      name: "47f5e94bc11c22a66fcbd44aff73241c",
      size: 4217344,
      width: 3648
    },
    orderIndex: 75,
    itemId: "47f5e94bc11c22a66fcbd44aff73241c",
    url: "8bb438_36726a2d14ec44ee9edc5693bade1092.jpg"
  }, {
    metadata: {
      height: 5472,
      lastModified: 1445852219,
      name: "5862a30656b6e61705dfbe5505faf867",
      size: 4609929,
      width: 3648
    },
    orderIndex: 76,
    itemId: "5862a30656b6e61705dfbe5505faf867",
    url: "8bb438_be12adcc05bb45eab12f52f03aebb9f8.jpg"
  }, {
    metadata: {
      height: 3648,
      lastModified: 1445852219,
      name: "bc261174203a17b59d870ccf26a01597",
      size: 5736096,
      width: 5472
    },
    orderIndex: 77,
    itemId: "bc261174203a17b59d870ccf26a01597",
    url: "8bb438_94ba2f2573aa431aaef5be76d1cd887d.jpg"
  }, {
    metadata: {
      height: 5472,
      lastModified: 1445852219,
      name: "279757098541cffc5689b7bbe39a88b2",
      size: 5959189,
      width: 3648
    },
    orderIndex: 78,
    itemId: "279757098541cffc5689b7bbe39a88b2",
    url: "8bb438_730e9548a4ae4fe4b717e28c53e89410.jpg"
  }, {
    metadata: {
      height: 3648,
      lastModified: 1445852219,
      name: "ea3c344c388002acfe4f67fac5c8c400",
      size: 3871502,
      width: 5472
    },
    orderIndex: 79,
    itemId: "ea3c344c388002acfe4f67fac5c8c400",
    url: "8bb438_b73a93e4b07c4dbc9e78614a20b33750.jpg"
  }, {
    metadata: {
      height: 5472,
      lastModified: 1445852219,
      name: "3152ccf507b8ff1662385fa6a67311f8",
      size: 2410359,
      width: 3648
    },
    orderIndex: 80,
    itemId: "3152ccf507b8ff1662385fa6a67311f8",
    url: "8bb438_5e257ac6c0634c439066b944ec38fbd7.jpg"
  }, {
    metadata: {
      height: 5472,
      lastModified: 1445852219,
      name: "4faa8030d46fdf8fbb787c1b66f395e3",
      size: 2259034,
      width: 3648
    },
    orderIndex: 81,
    itemId: "4faa8030d46fdf8fbb787c1b66f395e3",
    url: "8bb438_32189edd0d0c44428d3a1305dd7be397.jpg"
  }, {
    metadata: {
      height: 5472,
      lastModified: 1445852219,
      name: "2a37fa063861660e7850eb82d62914ee",
      size: 6866865,
      width: 3648
    },
    orderIndex: 82,
    itemId: "2a37fa063861660e7850eb82d62914ee",
    url: "8bb438_13b27c8ed9084ae6a7526be845547661.jpg"
  }, {
    metadata: {
      height: 3648,
      lastModified: 1445852219,
      name: "2103f7d2c4be85e4467d2f9cba4aeded",
      size: 5509488,
      width: 5472
    },
    orderIndex: 83,
    itemId: "2103f7d2c4be85e4467d2f9cba4aeded",
    url: "8bb438_e1c242b87eb74abab740e5af5104a520.jpg"
  }, {
    metadata: {
      height: 3648,
      lastModified: 1445852219,
      name: "d15b37f375ea80bda4f2c37b64fdf7e8",
      size: 3202506,
      width: 5472
    },
    orderIndex: 84,
    itemId: "d15b37f375ea80bda4f2c37b64fdf7e8",
    url: "8bb438_aab736569612405a8381d4965c769f51.jpg"
  }, {
    metadata: {
      height: 5472,
      lastModified: 1445852219,
      name: "cedc4449d88b491aca7d452fcdf0b3da",
      size: 4278078,
      width: 3648
    },
    orderIndex: 85,
    itemId: "cedc4449d88b491aca7d452fcdf0b3da",
    url: "8bb438_f1f608a67abc4590821f83b4120f6131.jpg"
  }, {
    metadata: {
      height: 3648,
      lastModified: 1445852219,
      name: "d375541f5888e55ac32a5142ed85c3bc",
      size: 5327873,
      width: 5472
    },
    orderIndex: 86,
    itemId: "d375541f5888e55ac32a5142ed85c3bc",
    url: "8bb438_730583b0bebf475086ff40e07898e3e0.jpg"
  }, {
    metadata: {
      height: 3526,
      lastModified: 1445852219,
      name: "b12907da5fbb55a31a760e49fb0bb4e6",
      size: 3941332,
      width: 5177
    },
    orderIndex: 87,
    itemId: "b12907da5fbb55a31a760e49fb0bb4e6",
    url: "8bb438_83e03311e53a47ce9ba8bda910fdad88.jpg"
  }, {
    metadata: {
      height: 3648,
      lastModified: 1445852219,
      name: "1cfbc70e8a351916a2dd29c63e5a2100",
      size: 7240707,
      width: 5472
    },
    orderIndex: 88,
    itemId: "1cfbc70e8a351916a2dd29c63e5a2100",
    url: "8bb438_ac9e77e718404844adeec4677879e617.jpg"
  }, {
    metadata: {
      height: 2126,
      lastModified: 1445861579,
      name: "0d134f293b71f7c0a9638c5f1a8435e5",
      size: 285522,
      width: 1695
    },
    orderIndex: 89,
    itemId: "0d134f293b71f7c0a9638c5f1a8435e5",
    url: "8bb438_5b9f0c9151f24ba8a8ebdba378e260b7.jpg"
  }, {
    metadata: {
      height: 1081,
      lastModified: 1445852215,
      name: "8a719c372d21ebb4b9d2a8373734bf52",
      size: 829742,
      width: 1621
    },
    orderIndex: 90,
    itemId: "8a719c372d21ebb4b9d2a8373734bf52",
    url: "8bb438_209feb1fb8944a18b6b619e105746cd0.jpg"
  }, {
    metadata: {
      height: 1081,
      lastModified: 1445852215,
      name: "d201d3aea92d4fb08635d281a3909180",
      size: 920207,
      width: 1621
    },
    orderIndex: 91,
    itemId: "d201d3aea92d4fb08635d281a3909180",
    url: "8bb438_9a392473159c472c835ed9c657464bea.jpg"
  }, {
    metadata: {
      height: 1081,
      lastModified: 1445852215,
      name: "4f8cf05deeb154bda3b878e68656e4c5",
      size: 848528,
      width: 1621
    },
    orderIndex: 92,
    itemId: "4f8cf05deeb154bda3b878e68656e4c5",
    url: "8bb438_9f28a805bac543feb934a831a6636e03.jpg"
  }, {
    metadata: {
      height: 1081,
      lastModified: 1445852215,
      name: "ab64fd1362015d405181f8b82d14e029",
      size: 258698,
      width: 1621
    },
    orderIndex: 93,
    itemId: "ab64fd1362015d405181f8b82d14e029",
    url: "8bb438_8c0a8aa18b9c456a94d67cd58c104135.jpg"
  }, {
    metadata: {
      height: 1081,
      lastModified: 1445852215,
      name: "9d652929eb67d0ae370494dcb2709871",
      size: 719331,
      width: 1621
    },
    orderIndex: 94,
    itemId: "9d652929eb67d0ae370494dcb2709871",
    url: "8bb438_18a34be7a3834da88a55e30c4dae3e96.jpg"
  }, {
    metadata: {
      height: 1081,
      lastModified: 1445852215,
      name: "7e411b039d55fc0d86266697a51172d8",
      size: 873130,
      width: 1621
    },
    orderIndex: 95,
    itemId: "7e411b039d55fc0d86266697a51172d8",
    url: "8bb438_eed704a5a8d74b40aeb5a11914eb4dc5.jpg"
  }, {
    metadata: {
      height: 1081,
      lastModified: 1445852215,
      name: "75318326db54174bea73594c3c25873a",
      size: 490692,
      width: 1621
    },
    orderIndex: 96,
    itemId: "75318326db54174bea73594c3c25873a",
    url: "8bb438_0795e40ac4db438a8a723ea98dbeda10.jpg"
  }, {
    metadata: {
      height: 1081,
      lastModified: 1445852215,
      name: "90ee6549ab33042ab1206b0a925b10bd",
      size: 516058,
      width: 1621
    },
    orderIndex: 97,
    itemId: "90ee6549ab33042ab1206b0a925b10bd",
    url: "8bb438_4413d1782f904f9a89a47837c03bf276.jpg"
  }, {
    metadata: {
      height: 1081,
      lastModified: 1445852215,
      name: "d052fe7e6db2fd246708f8e56ddc3684",
      size: 566152,
      width: 1621
    },
    orderIndex: 98,
    itemId: "d052fe7e6db2fd246708f8e56ddc3684",
    url: "8bb438_4a6550d4df364f9890180f52243fb396.jpg"
  }, {
    metadata: {
      height: 1081,
      lastModified: 1445852215,
      name: "8310d26374ed948918b9914ea076e411",
      size: 545677,
      width: 1621
    },
    orderIndex: 99,
    itemId: "8310d26374ed948918b9914ea076e411",
    url: "8bb438_b5957febd0ed45d3be9a0e91669c65b4.jpg"
  }, {
    metadata: {
      height: 1081,
      lastModified: 1445852215,
      name: "ed9a2febb12a8dc9c4e193efa170612c",
      size: 908947,
      width: 1621
    },
    orderIndex: 100,
    itemId: "ed9a2febb12a8dc9c4e193efa170612c",
    url: "8bb438_4ce63dbf08904e42af4d6e5846e6e0c1.jpg"
  }, {
    metadata: {
      height: 1081,
      lastModified: 1445852215,
      name: "8f49fa63016a85ffe986e76575f39215",
      size: 795828,
      width: 1621
    },
    orderIndex: 101,
    itemId: "8f49fa63016a85ffe986e76575f39215",
    url: "8bb438_c0e5f47b25b741cb9d1fd068904d2f9f.jpg"
  }, {
    metadata: {
      height: 1081,
      lastModified: 1445852215,
      name: "121febfbe44585889f8eb12e7d69f2e7",
      size: 703263,
      width: 1621
    },
    orderIndex: 102,
    itemId: "121febfbe44585889f8eb12e7d69f2e7",
    url: "8bb438_f0c9e43919a74e65a73bea3416af4471.jpg"
  }, {
    metadata: {
      height: 1081,
      lastModified: 1445852215,
      name: "a0e02006d6dc458260f4652aa9c5e1bd",
      size: 766186,
      width: 1621
    },
    orderIndex: 103,
    itemId: "a0e02006d6dc458260f4652aa9c5e1bd",
    url: "8bb438_131e9bbd900c42a29ed2db01d18256e5.jpg"
  }, {
    metadata: {
      height: 1081,
      lastModified: 1445852215,
      name: "f6f6b6f3e060eebf7b69b5b6e841c376",
      size: 512822,
      width: 1621
    },
    orderIndex: 104,
    itemId: "f6f6b6f3e060eebf7b69b5b6e841c376",
    url: "8bb438_adaebc27d1a64579b73a95f8ed556555.jpg"
  }, {
    metadata: {
      height: 1081,
      lastModified: 1445852215,
      name: "d3d6e36e2bcf4c8be952b02b9c15b5c7",
      size: 619353,
      width: 1621
    },
    orderIndex: 105,
    itemId: "d3d6e36e2bcf4c8be952b02b9c15b5c7",
    url: "8bb438_0118d2e35a6d4ff494ad3f826db485a3.jpg"
  }, {
    metadata: {
      height: 1646,
      lastModified: 1445862635,
      name: "9c881f7561932df3c0ed3656884c1513",
      size: 2163648,
      width: 2388
    },
    orderIndex: 106,
    itemId: "9c881f7561932df3c0ed3656884c1513",
    url: "8bb438_c92634232f52455c8046d67606ab6e5f.jpg"
  }, {
    metadata: {
      height: 3840,
      lastModified: 1445861729,
      name: "6cca5ee645eb3b97ad853b6b4a3608a2",
      size: 6223945,
      width: 5760
    },
    orderIndex: 107,
    itemId: "6cca5ee645eb3b97ad853b6b4a3608a2",
    url: "8bb438_5ee105c6c702414aac05ad7850cb2017.jpg"
  }, {
    metadata: {
      height: 1081,
      lastModified: 1445860798,
      name: "b62eff103da697f3bf5db0438155fe8b",
      size: 1611878,
      width: 1920
    },
    orderIndex: 108,
    itemId: "b62eff103da697f3bf5db0438155fe8b",
    url: "8bb438_8c10a45d18ca42839188a74dd2ff355b.jpg"
  }, {
    metadata: {
      height: 1700,
      lastModified: 1445850236,
      name: "72cc585fbac8ac3a0ec2a9cebd06a226",
      size: 1314310,
      width: 2557
    },
    orderIndex: 109,
    itemId: "72cc585fbac8ac3a0ec2a9cebd06a226",
    url: "8bb438_095b661d7d2549efbde6b6e981eeb90b.jpg"
  }, {
    metadata: {
      height: 3044,
      lastModified: 1445850236,
      name: "1dcb3c6098ce8c0253fe118f2b244b72",
      size: 1169419,
      width: 2016
    },
    orderIndex: 110,
    itemId: "1dcb3c6098ce8c0253fe118f2b244b72",
    url: "8bb438_2b31b324f130433685c160fdba0a66e9.jpg"
  }, {
    metadata: {
      height: 2659,
      lastModified: 1445850236,
      name: "903d28251994fd64178d1d4377bf3023",
      size: 848883,
      width: 4003
    },
    orderIndex: 111,
    itemId: "903d28251994fd64178d1d4377bf3023",
    url: "8bb438_bbaecccf378a4aa5bc7720e3c98467a4.jpg"
  }, {
    metadata: {
      height: 2174,
      lastModified: 1445850236,
      name: "4b40980afebc1eac87b0f063736ec1e5",
      size: 2162407,
      width: 2206
    },
    orderIndex: 112,
    itemId: "4b40980afebc1eac87b0f063736ec1e5",
    url: "8bb438_4d6211d590e24dbbac7bacf97f7574ff.jpg"
  }, {
    metadata: {
      height: 1700,
      lastModified: 1445850236,
      name: "fcd572fa2437b3e69206e79bf265b6fd",
      size: 437158,
      width: 2557
    },
    orderIndex: 113,
    itemId: "fcd572fa2437b3e69206e79bf265b6fd",
    url: "8bb438_fbc283ff726241b1bb4b3d1ed1e72725.jpg"
  }, {
    metadata: {
      height: 1700,
      lastModified: 1445850236,
      name: "6509b32f7c1622dd6782123a9cf7393f",
      size: 1265527,
      width: 2557
    },
    orderIndex: 114,
    itemId: "6509b32f7c1622dd6782123a9cf7393f",
    url: "8bb438_712f1d006c544c8c9bc8f0f9ed3b6f48.jpg"
  }, {
    metadata: {
      height: 1700,
      lastModified: 1445850236,
      name: "2fdcee25fd3d3343fa42546bc11c3039",
      size: 1039422,
      width: 2557
    },
    orderIndex: 115,
    itemId: "2fdcee25fd3d3343fa42546bc11c3039",
    url: "8bb438_62bdc3abc8b34e468778bbdc2deadae7.jpg"
  }, {
    metadata: {
      height: 2124,
      lastModified: 1445850236,
      name: "a78c2fa4a7c95115ca0c6674d07ec937",
      size: 1009319,
      width: 3192
    },
    orderIndex: 116,
    itemId: "a78c2fa4a7c95115ca0c6674d07ec937",
    url: "8bb438_67a68c0652d740bab508f68662acc882.jpg"
  }, {
    metadata: {
      height: 1982,
      lastModified: 1445850236,
      name: "cddd50a0c038c29943165a68306f9d4b",
      size: 1187891,
      width: 2979
    },
    orderIndex: 117,
    itemId: "cddd50a0c038c29943165a68306f9d4b",
    url: "8bb438_4b202c052db94979a5e7c7f834d1918a.jpg"
  }, {
    metadata: {
      height: 1081,
      lastModified: 1445850236,
      name: "896ee4ed5714ce72f88390e7ecccc109",
      size: 250343,
      width: 1621
    },
    orderIndex: 118,
    itemId: "896ee4ed5714ce72f88390e7ecccc109",
    url: "8bb438_93b5cba24df3427e8c4554b4df38ae3d.jpg"
  }, {
    metadata: {
      height: 1280,
      lastModified: 1445850236,
      name: "711b734cd45cfb65becf32d557b6f980",
      size: 124076,
      width: 1920
    },
    orderIndex: 119,
    itemId: "711b734cd45cfb65becf32d557b6f980",
    url: "8bb438_281af3d3281f4584a5a864c6c60f3a00.jpg"
  }, {
    metadata: {
      height: 1893,
      lastModified: 1445850223,
      name: "65a6266ba23a8a55da3f469157f15237",
      size: 2322621,
      width: 2839
    },
    orderIndex: 120,
    itemId: "65a6266ba23a8a55da3f469157f15237",
    url: "8bb438_2d651ff17f644d0db766521a18bf888b.jpg"
  }, {
    metadata: {
      height: 3354,
      lastModified: 1445850223,
      name: "036c6bf6cef5e4409848eb4eb6f80de1",
      size: 638520,
      width: 2898
    },
    orderIndex: 121,
    itemId: "036c6bf6cef5e4409848eb4eb6f80de1",
    url: "8bb438_131a7e1872bc45ec827bb61e56b840fe.jpg"
  }, {
    metadata: {
      height: 2185,
      lastModified: 1445850223,
      name: "db24f305bb6d8e75830afbfaae4afb1b",
      size: 473022,
      width: 1460
    },
    orderIndex: 122,
    itemId: "db24f305bb6d8e75830afbfaae4afb1b",
    url: "8bb438_7fa357f6eb764ff49af23d3155506941.jpg"
  }, {
    metadata: {
      height: 1600,
      lastModified: 1445850223,
      name: "1aec072cb78efb4a8787dcd242bf7684",
      size: 967228,
      width: 2406
    },
    orderIndex: 123,
    itemId: "1aec072cb78efb4a8787dcd242bf7684",
    url: "8bb438_b815379fb0254ca6b009f6cc45f49afb.jpg"
  }, {
    metadata: {
      height: 1700,
      lastModified: 1445850223,
      name: "b86f277fb5fb7ba5a1e698458d4e23c7",
      size: 1475125,
      width: 2557
    },
    orderIndex: 124,
    itemId: "b86f277fb5fb7ba5a1e698458d4e23c7",
    url: "8bb438_9db65bcf6aef45cb8a0eb107602ef85a.jpg"
  }, {
    metadata: {
      height: 2000,
      lastModified: 1445861802,
      name: "768bbc938232a95ad99d22b1e82d6910",
      size: 2570170,
      width: 3008
    },
    orderIndex: 125,
    itemId: "768bbc938232a95ad99d22b1e82d6910",
    url: "8bb438_e83aae17a492425a991049d53269cfeb.jpg"
  }, {
    metadata: {
      height: 2000,
      lastModified: 1445861792,
      name: "c29a7f3f315db44bda7adb46dba70969",
      size: 2235833,
      width: 3008
    },
    orderIndex: 126,
    itemId: "c29a7f3f315db44bda7adb46dba70969",
    url: "8bb438_1779ae771a734ff2b8600511c272389f.jpg"
  }, {
    metadata: {
      height: 1280,
      lastModified: 1445860983,
      name: "5172248b57a96f7c30bc23b2faea99ce",
      size: 801017,
      width: 1920
    },
    orderIndex: 127,
    itemId: "5172248b57a96f7c30bc23b2faea99ce",
    url: "8bb438_06c1495cace048508cf7ad6db10918a8.jpg"
  }, {
    metadata: {
      height: 1280,
      lastModified: 1445850223,
      name: "0213ffc875ad1ed9910acdd34a2fbccc",
      size: 882451,
      width: 1920
    },
    orderIndex: 128,
    itemId: "0213ffc875ad1ed9910acdd34a2fbccc",
    url: "8bb438_6637a364aa0b44358f12de8a8b234ebb.jpg"
  }, {
    metadata: {
      height: 1280,
      lastModified: 1445850223,
      name: "f9ea9d58030b0910fc33cb5ec994ccfe",
      size: 1241614,
      width: 1920
    },
    orderIndex: 129,
    itemId: "f9ea9d58030b0910fc33cb5ec994ccfe",
    url: "8bb438_923730e8751f42aa9f75de92bd4ae77c.jpg"
  }, {
    metadata: {
      height: 1280,
      lastModified: 1445850223,
      name: "bdf64d603f3a5a822d8197f97e4a1dd0",
      size: 495701,
      width: 1920
    },
    orderIndex: 130,
    itemId: "bdf64d603f3a5a822d8197f97e4a1dd0",
    url: "8bb438_8ba11077006942a2b685027502fb91c8.jpg"
  }, {
    metadata: {
      height: 1280,
      lastModified: 1445850223,
      name: "91ff5a615e0235157dc1a7e5f66607bf",
      size: 1117958,
      width: 1920
    },
    orderIndex: 131,
    itemId: "91ff5a615e0235157dc1a7e5f66607bf",
    url: "8bb438_35ed730d87524b1a88179adc18ed9cd4.jpg"
  }, {
    metadata: {
      height: 1280,
      lastModified: 1445850223,
      name: "b5a1eb472c11ff6aa8bc232102e44115",
      size: 1186010,
      width: 1920
    },
    orderIndex: 132,
    itemId: "b5a1eb472c11ff6aa8bc232102e44115",
    url: "8bb438_df62913570ee4b23bcf2e5b38c85be0f.jpg"
  }, {
    metadata: {
      height: 1280,
      lastModified: 1445850223,
      name: "be138fdc7f94fcbfc74f791c187de19f",
      size: 835339,
      width: 1920
    },
    orderIndex: 133,
    itemId: "be138fdc7f94fcbfc74f791c187de19f",
    url: "8bb438_e5dca6ff051f4903bec85ac25ae1c790.jpg"
  }, {
    metadata: {
      height: 1280,
      lastModified: 1445850223,
      name: "15f407e0947a3680a2261a41cb6abbb6",
      size: 1025277,
      width: 1920
    },
    orderIndex: 134,
    itemId: "15f407e0947a3680a2261a41cb6abbb6",
    url: "8bb438_b2d862605f684658926e6ee05e954880.jpg"
  }, {
    metadata: {
      height: 1920,
      lastModified: 1445850223,
      name: "980dd6e0a5fc59853b6caf447f9c73ce",
      size: 235529,
      width: 1920
    },
    orderIndex: 135,
    itemId: "980dd6e0a5fc59853b6caf447f9c73ce",
    url: "8bb438_c1089eafb4ab405ba328b528e3ecc63e.jpg"
  }, {
    metadata: {
      height: 1280,
      lastModified: 1445850223,
      name: "cc3b069a94f4acb4a22050efc44c2585",
      size: 1625320,
      width: 1920
    },
    orderIndex: 136,
    itemId: "cc3b069a94f4acb4a22050efc44c2585",
    url: "8bb438_8c22bd50b08a481a9722ecdf5be4ecb3.jpg"
  }, {
    metadata: {
      height: 1280,
      lastModified: 1445850223,
      name: "cd35fcdad78edbf27525b3ac18a89cde",
      size: 936115,
      width: 1920
    },
    orderIndex: 137,
    itemId: "cd35fcdad78edbf27525b3ac18a89cde",
    url: "8bb438_6bbf8e82fe8f4b79b6e03ee79b66fd6a.jpg"
  }, {
    metadata: {
      height: 1280,
      lastModified: 1445850223,
      name: "17ef104520dd9a0711f1cc900d970b79",
      size: 484241,
      width: 1920
    },
    orderIndex: 138,
    itemId: "17ef104520dd9a0711f1cc900d970b79",
    url: "8bb438_277609c27d9346c38d480b6da8237820.jpg"
  }, {
    metadata: {
      height: 1280,
      lastModified: 1445850223,
      name: "6c8d09f016947a79def3a31b53415efd",
      size: 447393,
      width: 1920
    },
    orderIndex: 139,
    itemId: "6c8d09f016947a79def3a31b53415efd",
    url: "8bb438_1da83d5d8fcd481ba6bf60b40db869c6.jpg"
  }, {
    metadata: {
      height: 1280,
      lastModified: 1445850223,
      name: "319ccc6f69d553ca14cdb454bcec9dab",
      size: 830740,
      width: 1920
    },
    orderIndex: 140,
    itemId: "319ccc6f69d553ca14cdb454bcec9dab",
    url: "8bb438_9de712c571824273a103a07a08897065.jpg"
  }, {
    metadata: {
      height: 1922,
      lastModified: 1445850223,
      name: "a327950f89cc4994f34a0cd0d4a71473",
      size: 2022993,
      width: 1920
    },
    orderIndex: 141,
    itemId: "a327950f89cc4994f34a0cd0d4a71473",
    url: "8bb438_6a7159be0f944dde9098fe566bf22831.jpg"
  }, {
    metadata: {
      height: 1280,
      lastModified: 1445862012,
      name: "0213ffc875ad1ed9910acdd34a2fbccc",
      size: 882451,
      width: 1920
    },
    orderIndex: 142,
    itemId: "0213ffc875ad1ed9910acdd34a2fbccc",
    url: "8bb438_e070e924df8347c38083a247764ff4e7.jpg"
  }, {
    metadata: {
      height: 1280,
      lastModified: 1445862009,
      name: "cd35fcdad78edbf27525b3ac18a89cde",
      size: 936115,
      width: 1920
    },
    orderIndex: 143,
    itemId: "cd35fcdad78edbf27525b3ac18a89cde",
    url: "8bb438_a63b03b9b4d64b258cdb01d1f3133fb7.jpg"
  }, {
    metadata: {
      height: 1280,
      lastModified: 1445861980,
      name: "be138fdc7f94fcbfc74f791c187de19f",
      size: 835339,
      width: 1920
    },
    orderIndex: 144,
    itemId: "be138fdc7f94fcbfc74f791c187de19f",
    url: "8bb438_c69ce4f9e2a2474586da85b85bfac20b.jpg"
  }, {
    metadata: {
      height: 3733,
      lastModified: 1445862204,
      name: "e2d2410eb29222a9fc16d2c040a26eb8",
      size: 11108904,
      width: 5600
    },
    orderIndex: 145,
    itemId: "e2d2410eb29222a9fc16d2c040a26eb8",
    url: "8bb438_3dc227cbb499488b9d2e25747a9d259c.jpg"
  }, {
    metadata: {
      height: 3700,
      lastModified: 1445862193,
      name: "054aecc86193cbe527f5b89412df77b1",
      size: 8400169,
      width: 5550
    },
    orderIndex: 146,
    itemId: "054aecc86193cbe527f5b89412df77b1",
    url: "8bb438_c11370e0db6042ab96903aa5e60a0504.jpg"
  }, {
    metadata: {
      height: 3733,
      lastModified: 1445862182,
      name: "682b2132c2697fb0e467e21977beeaa2",
      size: 7948606,
      width: 5600
    },
    orderIndex: 147,
    itemId: "682b2132c2697fb0e467e21977beeaa2",
    url: "8bb438_f89f7e8aac574a0f962437d4f369b37a.jpg"
  }, {
    metadata: {
      height: 3733,
      lastModified: 1445862173,
      name: "b41768470b13fb3492105a741395b8b1",
      size: 8571144,
      width: 5600
    },
    orderIndex: 148,
    itemId: "b41768470b13fb3492105a741395b8b1",
    url: "8bb438_c1ec02dbd02c4e39bbc38dc67c9d5a81.jpg"
  }, {
    metadata: {
      height: 3733,
      lastModified: 1445862165,
      name: "edc43a24d3fab2e3bdf157a17229b8ff",
      size: 8408029,
      width: 5600
    },
    orderIndex: 149,
    itemId: "edc43a24d3fab2e3bdf157a17229b8ff",
    url: "8bb438_8307fc32bdf4455ab3033c542da4c6c7.jpg"
  }, {
    metadata: {
      height: 3733,
      lastModified: 1445862156,
      name: "d74eca93bd9936c9bea55ed35b65d868",
      size: 9335685,
      width: 5598
    },
    orderIndex: 150,
    itemId: "d74eca93bd9936c9bea55ed35b65d868",
    url: "8bb438_adc3fc099d9e455b9226ed1610a03746.jpg"
  }, {
    metadata: {
      height: 3733,
      lastModified: 1445862146,
      name: "7040c8ccf29829086eb304bd5463cd7a",
      size: 10652550,
      width: 5600
    },
    orderIndex: 151,
    itemId: "7040c8ccf29829086eb304bd5463cd7a",
    url: "8bb438_02853320b2fa488991490b23def60425.jpg"
  }, {
    metadata: {
      height: 3733,
      lastModified: 1445862135,
      name: "a85171218ed414df18aab4578f9d5205",
      size: 6504584,
      width: 5600
    },
    orderIndex: 152,
    itemId: "a85171218ed414df18aab4578f9d5205",
    url: "8bb438_9d663d62dd494ff393583bd396cbdd09.jpg"
  }, {
    metadata: {
      height: 3733,
      lastModified: 1445862127,
      name: "6b23e7ccdce02a5fa9a719ed0e08f335",
      size: 8530032,
      width: 5600
    },
    orderIndex: 153,
    itemId: "6b23e7ccdce02a5fa9a719ed0e08f335",
    url: "8bb438_ac190df97cfe4c6d8bcd9ca8b6b3c100.jpg"
  }, {
    metadata: {
      height: 3733,
      lastModified: 1445862118,
      name: "c28d48f6383e8b3a71b218ad25bd4bb9",
      size: 8089948,
      width: 5600
    },
    orderIndex: 154,
    itemId: "c28d48f6383e8b3a71b218ad25bd4bb9",
    url: "8bb438_603549efcb714170bb71fe0757f37561.jpg"
  }, {
    metadata: {
      height: 3733,
      lastModified: 1445862110,
      name: "2c2698b83ba64574db5e28ed54064081",
      size: 6172448,
      width: 5600
    },
    orderIndex: 155,
    itemId: "2c2698b83ba64574db5e28ed54064081",
    url: "8bb438_0ab44689f626435c94b9a5b996524aba.jpg"
  }, {
    metadata: {
      height: 3733,
      lastModified: 1445862104,
      name: "d0098df1517b57f7ba1702e8ee94df97",
      size: 9722456,
      width: 5600
    },
    orderIndex: 156,
    itemId: "d0098df1517b57f7ba1702e8ee94df97",
    url: "8bb438_7dde2abf38e24163b80c11619c357bf1.jpg"
  }, {
    metadata: {
      height: 3733,
      lastModified: 1445862094,
      name: "7a8b1821964090c8d76e2fda7b98a5c3",
      size: 10881820,
      width: 5600
    },
    orderIndex: 157,
    itemId: "7a8b1821964090c8d76e2fda7b98a5c3",
    url: "8bb438_05e34d9e622b486089a6c516d4442e1a.jpg"
  }, {
    metadata: {
      height: 3733,
      lastModified: 1445862082,
      name: "a767882abaa73788a858cfd654a33382",
      size: 7680053,
      width: 5600
    },
    orderIndex: 158,
    itemId: "a767882abaa73788a858cfd654a33382",
    url: "8bb438_a030bf17f1f64eb2a8c76e9529639c6a.jpg"
  }, {
    metadata: {
      height: 3733,
      lastModified: 1445862073,
      name: "6eb6658578bad86c8031e823e4d1f848",
      size: 7361479,
      width: 5600
    },
    orderIndex: 159,
    itemId: "6eb6658578bad86c8031e823e4d1f848",
    url: "8bb438_bc43580d2f36408f87cf8302a86e5ad4.jpg"
  }, {
    metadata: {
      height: 3733,
      lastModified: 1445862237,
      name: "c28d48f6383e8b3a71b218ad25bd4bb9",
      size: 8089948,
      width: 5600
    },
    orderIndex: 160,
    itemId: "c28d48f6383e8b3a71b218ad25bd4bb9",
    url: "8bb438_040d8045a99d42089340ef644987431d.jpg"
  }, {
    metadata: {
      height: 3733,
      lastModified: 1445862228,
      name: "d74eca93bd9936c9bea55ed35b65d868",
      size: 9335685,
      width: 5598
    },
    orderIndex: 161,
    itemId: "d74eca93bd9936c9bea55ed35b65d868",
    url: "8bb438_738bb5f8a2be4021ae79cef00814347b.jpg"
  }, {
    metadata: {
      height: 3733,
      lastModified: 1445862216,
      name: "e2d2410eb29222a9fc16d2c040a26eb8",
      size: 11108904,
      width: 5600
    },
    orderIndex: 162,
    itemId: "e2d2410eb29222a9fc16d2c040a26eb8",
    url: "8bb438_3ff588618aa2433faec50a49cd48fef5.jpg"
  }, {
    metadata: {
      height: 5120,
      lastModified: 1445862411,
      name: "2bf5de49dea7723cf5ef00f2ef1e1769",
      size: 8285375,
      width: 3413
    },
    orderIndex: 163,
    itemId: "2bf5de49dea7723cf5ef00f2ef1e1769",
    url: "8bb438_d6bbc480e6654b27a025172c0a283aee.jpg"
  }, {
    metadata: {
      height: 3464,
      lastModified: 1445862401,
      name: "0031cb2181ba343e518a03538d23cd03",
      size: 10319255,
      width: 5050
    },
    orderIndex: 164,
    itemId: "0031cb2181ba343e518a03538d23cd03",
    url: "8bb438_8c32b918adbe45abb9dbc8caa74266e1.jpg"
  }, {
    metadata: {
      height: 3497,
      lastModified: 1445862387,
      name: "be4312f031f9850a825b2064b9c92d72",
      size: 8397577,
      width: 5000
    },
    orderIndex: 165,
    itemId: "be4312f031f9850a825b2064b9c92d72",
    url: "8bb438_a3a11b05e3f54f77ba1c04dfba22c99c.jpg"
  }, {
    metadata: {
      height: 3499,
      lastModified: 1445862374,
      name: "4e330a74571e319e127ce0e149361786",
      size: 7567572,
      width: 5070
    },
    orderIndex: 166,
    itemId: "4e330a74571e319e127ce0e149361786",
    url: "8bb438_0ac4a971c0384ec7827d055c12d2c6c6.jpg"
  }, {
    metadata: {
      height: 3413,
      lastModified: 1445862361,
      name: "2819312078a2b5c522b9214012a3cba7",
      size: 8926323,
      width: 5120
    },
    orderIndex: 167,
    itemId: "2819312078a2b5c522b9214012a3cba7",
    url: "8bb438_33bf909c99a3434ebe90fa7f83f1f312.jpg"
  }, {
    metadata: {
      height: 3413,
      lastModified: 1445862348,
      name: "110077937cb8c30dba417fcf466966f5",
      size: 8829929,
      width: 5120
    },
    orderIndex: 168,
    itemId: "110077937cb8c30dba417fcf466966f5",
    url: "8bb438_c13c33d29e2945ea91393d1b99a717aa.jpg"
  }, {
    metadata: {
      height: 3413,
      lastModified: 1445862337,
      name: "bcb5bc2f8a914694b8dc0c9ff2575f79",
      size: 8638758,
      width: 5120
    },
    orderIndex: 169,
    itemId: "bcb5bc2f8a914694b8dc0c9ff2575f79",
    url: "8bb438_53cc82c7bc8a4b41baf4db640e8b5641.jpg"
  }, {
    metadata: {
      height: 3413,
      lastModified: 1445862326,
      name: "d0937b58b7daaf0a22d3aee9998e4f67",
      size: 6696056,
      width: 5120
    },
    orderIndex: 170,
    itemId: "d0937b58b7daaf0a22d3aee9998e4f67",
    url: "8bb438_a7798c60ea794083b42e0e2ee60ee0b1.jpg"
  }, {
    metadata: {
      height: 3413,
      lastModified: 1445862318,
      name: "ebb0a9e8b18951efc9f756ba80803a59",
      size: 3924525,
      width: 5120
    },
    orderIndex: 171,
    itemId: "ebb0a9e8b18951efc9f756ba80803a59",
    url: "8bb438_374e915d500e4bb5a1360fcd825c618b.jpg"
  }, {
    metadata: {
      height: 5120,
      lastModified: 1445862313,
      name: "84860c43010aeaccadda0ec16643f73e",
      size: 8013460,
      width: 3413
    },
    orderIndex: 172,
    itemId: "84860c43010aeaccadda0ec16643f73e",
    url: "8bb438_2115a73ee3ef443393c02e6ecf84e187.jpg"
  }, {
    metadata: {
      height: 3413,
      lastModified: 1445862302,
      name: "1a6b0b36b56890901bd8d2fdba973389",
      size: 6374834,
      width: 5120
    },
    orderIndex: 173,
    itemId: "1a6b0b36b56890901bd8d2fdba973389",
    url: "8bb438_08bfa26f67af4d79b965196586251831.jpg"
  }, {
    metadata: {
      height: 3413,
      lastModified: 1445862294,
      name: "482299c977636db0d6e6d7c91642478e",
      size: 8337358,
      width: 5120
    },
    orderIndex: 174,
    itemId: "482299c977636db0d6e6d7c91642478e",
    url: "8bb438_0a2865bde9ab4fa5bc6b1cea232cf197.jpg"
  }, {
    metadata: {
      height: 3413,
      lastModified: 1445862284,
      name: "bbafa01c54087e7003f10c2c2a06a524",
      size: 8944322,
      width: 5120
    },
    orderIndex: 175,
    itemId: "bbafa01c54087e7003f10c2c2a06a524",
    url: "8bb438_8d139a5df3aa4f709c66b8cdd28ac307.jpg"
  }, {
    metadata: {
      height: 3413,
      lastModified: 1445862272,
      name: "823b108473f355dd77fbeb897c3344dc",
      size: 8002002,
      width: 5120
    },
    orderIndex: 176,
    itemId: "823b108473f355dd77fbeb897c3344dc",
    url: "8bb438_625e05135c9444a390e5a1628512259f.jpg"
  }, {
    metadata: {
      height: 3413,
      lastModified: 1445862260,
      name: "53defddc48f1fed38b715b4eda295c7d",
      size: 5316281,
      width: 5120
    },
    orderIndex: 177,
    itemId: "53defddc48f1fed38b715b4eda295c7d",
    url: "8bb438_2cbc963a95134edfa8c974ef1b931f32.jpg"
  }, {
    metadata: {
      height: 5120,
      lastModified: 1445862253,
      name: "1137cfdadf8d5a40e8db107f3bfc6fe7",
      size: 4317430,
      width: 3413
    },
    orderIndex: 178,
    itemId: "1137cfdadf8d5a40e8db107f3bfc6fe7",
    url: "8bb438_177fd19d40ed4f40ac2a65c00ed0ce40.jpg"
  }, {
    metadata: {
      height: 3413,
      lastModified: 1445862245,
      name: "bc1243ce59ebe679f463d6a9dfbd1068",
      size: 4800839,
      width: 5120
    },
    orderIndex: 179,
    itemId: "bc1243ce59ebe679f463d6a9dfbd1068",
    url: "8bb438_215d5a60549f49fdb8fe2afe5ae2019e.jpg"
  }, {
    metadata: {
      height: 1274,
      lastModified: 1445850223,
      name: "582d370b47e0a23e545d65980aa51df9",
      size: 1422896,
      width: 2137
    },
    orderIndex: 180,
    itemId: "582d370b47e0a23e545d65980aa51df9",
    url: "8bb438_04d98bcd69f74d3db4c13c949fa87f86.jpg"
  }, {
    metadata: {
      height: 1274,
      lastModified: 1445850223,
      name: "391e019d2106dcce1e4f858071bfd2a8",
      size: 836132,
      width: 956
    },
    orderIndex: 181,
    itemId: "391e019d2106dcce1e4f858071bfd2a8",
    url: "8bb438_7bc5865449064cd08784dbeee3bb37d6.jpg"
  }, {
    metadata: {
      height: 3413,
      lastModified: 1445862433,
      name: "53defddc48f1fed38b715b4eda295c7d",
      size: 5316281,
      width: 5120
    },
    orderIndex: 182,
    itemId: "53defddc48f1fed38b715b4eda295c7d",
    url: "8bb438_a5ad0a96b999457f863d8fbcb9a88947.jpg"
  }, {
    metadata: {
      height: 3413,
      lastModified: 1445862426,
      name: "bcb5bc2f8a914694b8dc0c9ff2575f79",
      size: 8638758,
      width: 5120
    },
    orderIndex: 183,
    itemId: "bcb5bc2f8a914694b8dc0c9ff2575f79",
    url: "8bb438_b2847057eba64e22b9d75c777a3c5145.jpg"
  }, {
    metadata: {
      height: 1274,
      lastModified: 1445862416,
      name: "582d370b47e0a23e545d65980aa51df9",
      size: 1422896,
      width: 2137
    },
    orderIndex: 184,
    itemId: "582d370b47e0a23e545d65980aa51df9",
    url: "8bb438_b439a0605af64888ac78f0038fdc4bf7.jpg"
  }, {
    metadata: {
      height: 1274,
      lastModified: 1445850223,
      name: "0e57197c6a6888a29eee9f0cf8c4c00c",
      size: 338036,
      width: 2137
    },
    orderIndex: 185,
    itemId: "0e57197c6a6888a29eee9f0cf8c4c00c",
    url: "8bb438_31726e057dbf4fdb9b59a3aa4d3c8846.jpg"
  }, {
    metadata: {
      height: 3032,
      lastModified: 1445850223,
      name: "aa0c3adcc23504ac822d5c3ed5f3b6a1",
      size: 3271224,
      width: 2021
    },
    orderIndex: 186,
    itemId: "aa0c3adcc23504ac822d5c3ed5f3b6a1",
    url: "8bb438_6ad0d6b1ab9b4f8ea4f93389a3d68a4d.jpg"
  }, {
    metadata: {
      height: 2247,
      lastModified: 1445850223,
      name: "22bd08049c2170953944eb0647327544",
      size: 3442245,
      width: 3370
    },
    orderIndex: 187,
    itemId: "22bd08049c2170953944eb0647327544",
    url: "8bb438_138ba4f7bc6a479daac72b6a59aba09c.jpg"
  }, {
    metadata: {
      height: 2247,
      lastModified: 1445850223,
      name: "fe369948e3807c3c684593b5fcc81900",
      size: 3720207,
      width: 3370
    },
    orderIndex: 188,
    itemId: "fe369948e3807c3c684593b5fcc81900",
    url: "8bb438_e531721f616b4b2ba7485c9d218214b7.jpg"
  }, {
    metadata: {
      height: 2247,
      lastModified: 1445850223,
      name: "d6e203711c6fedd1a68db345cbd807dc",
      size: 3517379,
      width: 3370
    },
    orderIndex: 189,
    itemId: "d6e203711c6fedd1a68db345cbd807dc",
    url: "8bb438_7feae75f85e24f6d849d921fb169c91b.jpg"
  }, {
    metadata: {
      height: 2247,
      lastModified: 1445850223,
      name: "0d2ad7a4819f0ed012d3953853070be8",
      size: 3432102,
      width: 3370
    },
    orderIndex: 190,
    itemId: "0d2ad7a4819f0ed012d3953853070be8",
    url: "8bb438_0d6efcfc699344a2822fec577f398973.jpg"
  }, {
    metadata: {
      height: 2022,
      lastModified: 1445850223,
      name: "6cc0bfdd8ddf3065b57266a0a92c262b",
      size: 3302202,
      width: 3033
    },
    orderIndex: 191,
    itemId: "6cc0bfdd8ddf3065b57266a0a92c262b",
    url: "8bb438_3db34f4c4d6745859c6a53626a90ea9b.jpg"
  }, {
    metadata: {
      height: 2247,
      lastModified: 1445850223,
      name: "3b99fd57189241f69534dc4bb0528ffb",
      size: 3226747,
      width: 3370
    },
    orderIndex: 192,
    itemId: "3b99fd57189241f69534dc4bb0528ffb",
    url: "8bb438_b9d7f38696d84e288f0cd37d2fd472ac.jpg"
  }, {
    metadata: {
      height: 2503,
      lastModified: 1445850223,
      name: "621d1311fd54c3c83976cb2d53dbbc51",
      size: 1394279,
      width: 1877
    },
    orderIndex: 193,
    itemId: "621d1311fd54c3c83976cb2d53dbbc51",
    url: "8bb438_4bee2fba456341c3afb0cfe47754f9c7.jpg"
  }, {
    metadata: {
      height: 1068,
      lastModified: 1445850223,
      name: "2f64886b1998251a4a5e47d25fff5ffa",
      size: 245970,
      width: 1600
    },
    orderIndex: 194,
    itemId: "2f64886b1998251a4a5e47d25fff5ffa",
    url: "8bb438_92b217c36c98400a82e5c59bf131d957.jpg"
  }, {
    metadata: {
      height: 2188,
      lastModified: 1445850223,
      name: "c510bc190e80f21f1e958b0dbe9e1a57",
      size: 3663436,
      width: 3266
    },
    orderIndex: 195,
    itemId: "c510bc190e80f21f1e958b0dbe9e1a57",
    url: "8bb438_6cc9007ec5c349f3b56044aab154860f.jpg"
  }, {
    metadata: {
      height: 2247,
      lastModified: 1445850223,
      name: "ae91d01147f241ed8e9b1b7425c11380",
      size: 3702518,
      width: 3370
    },
    orderIndex: 196,
    itemId: "ae91d01147f241ed8e9b1b7425c11380",
    url: "8bb438_94a4e8c055d84430af593cb3d31fd67a.jpg"
  }, {
    metadata: {
      height: 2124,
      lastModified: 1445850223,
      name: "0e44a5c7c0c10166dbc1664c1018b9ea",
      size: 1654253,
      width: 3148
    },
    orderIndex: 197,
    itemId: "0e44a5c7c0c10166dbc1664c1018b9ea",
    url: "8bb438_0660e79effa64f8ea139c4fc03e0b773.jpg"
  }, {
    metadata: {
      height: 1274,
      lastModified: 1445862695,
      name: "0e57197c6a6888a29eee9f0cf8c4c00c",
      size: 338036,
      width: 2137
    },
    orderIndex: 198,
    itemId: "0e57197c6a6888a29eee9f0cf8c4c00c",
    url: "8bb438_b9c5099c147749589c82abffa3b957b8.jpg"
  }, {
    metadata: {
      height: 3744,
      lastModified: 1445862472,
      name: "fdc7334a437c6d0a889a7e4520b49baf",
      size: 17262169,
      width: 5616
    },
    orderIndex: 199,
    itemId: "fdc7334a437c6d0a889a7e4520b49baf",
    url: "8bb438_d843f0485fcb4791b160a03e5906bd29.jpg"
  }, {
    metadata: {
      height: 3744,
      lastModified: 1445862454,
      name: "31ebbd58a30a082b0b2a2e64af2d5483",
      size: 19242697,
      width: 5616
    },
    orderIndex: 200,
    itemId: "31ebbd58a30a082b0b2a2e64af2d5483",
    url: "8bb438_e1d1af8cd51a452b9b24dcebdc665805.jpg"
  }]
};

var modelImages = {
  setId: "01d9d4c0-5bc2-43c9-9e26-fae31bedaed9",
  name: "Sample Images",
  photos: [{
    metadata: {
      height: 4930,
      lastModified: 1445852211,
      name: "4f431d8f88a3e5d3842df5a906fd536f",
      size: 1603869,
      width: 3287
    },
    orderIndex: 52,
    itemId: "4f431d8f88a3e5d3842df5a906fd536f",
    url: "8bb438_4afd60c9c97d44c8bcd61f1b6080d7e5.jpg"
  }, {
    metadata: {
      height: 4645,
      lastModified: 1445852211,
      name: "3337a427b2e877ab39bf116fcb3f01ea",
      size: 2057775,
      width: 3484
    },
    orderIndex: 53,
    itemId: "3337a427b2e877ab39bf116fcb3f01ea",
    url: "8bb438_a74f09cd4425418296d417ce91f589cd.jpg"
  }, {
    metadata: {
      height: 5580,
      lastModified: 1445852211,
      name: "7474d69be9754f2f5012a08ab9e5c283",
      size: 1862011,
      width: 3720
    },
    orderIndex: 54,
    itemId: "7474d69be9754f2f5012a08ab9e5c283",
    url: "8bb438_5a7139bf3b91452ea725151ffb285335.jpg"
  }, {
    metadata: {
      height: 5258,
      lastModified: 1445852211,
      name: "befba01503f77c9dc77df88419290c01",
      size: 2157963,
      width: 3946
    },
    orderIndex: 55,
    itemId: "befba01503f77c9dc77df88419290c01",
    url: "8bb438_fe7a4cc39e624bd09cb48510d6d46056.jpg"
  }, {
    metadata: {
      height: 4645,
      lastModified: 1445852211,
      name: "2f493d2be5d47bd89b016ba46a0f66f4",
      size: 1679662,
      width: 3484
    },
    orderIndex: 56,
    itemId: "2f493d2be5d47bd89b016ba46a0f66f4",
    url: "8bb438_8bc1731cedd84dc7846ebd434e305c8a.jpg"
  }, {
    metadata: {
      height: 5260,
      lastModified: 1445852211,
      name: "2d6bee6fe2a726f213599508722bcb27",
      size: 2462629,
      width: 3945
    },
    orderIndex: 57,
    itemId: "2d6bee6fe2a726f213599508722bcb27",
    url: "8bb438_4eb7f81b49a64578bf5775417c4c2c9a.jpg"
  }, {
    metadata: {
      height: 3710,
      lastModified: 1445852211,
      name: "9e6bb2d0c554dcd559a32ab89c9092f0",
      size: 1423161,
      width: 3180
    },
    orderIndex: 58,
    itemId: "9e6bb2d0c554dcd559a32ab89c9092f0",
    url: "8bb438_cbe02f139b8e479387eb7f5f9e8424c9.jpg"
  }, {
    metadata: {
      height: 4645,
      lastModified: 1445852211,
      name: "315e6213ce778d43f5580b2caf347556",
      size: 1683368,
      width: 3484
    },
    orderIndex: 59,
    itemId: "315e6213ce778d43f5580b2caf347556",
    url: "8bb438_af22f17274944bea9026107bf670bf7f.jpg"
  }, {
    metadata: {
      height: 4722,
      lastModified: 1445852211,
      name: "338f76721bc5a127ebf0b01306abf35e",
      size: 1904181,
      width: 3542
    },
    orderIndex: 60,
    itemId: "338f76721bc5a127ebf0b01306abf35e",
    url: "8bb438_a8a7ff22738445faa74cf7f68866f4d8.jpg"
  }, {
    metadata: {
      height: 5310,
      lastModified: 1445852211,
      name: "d4c8670400a3bf9d7c8cba7e5f133454",
      size: 2095199,
      width: 3540
    },
    orderIndex: 61,
    itemId: "d4c8670400a3bf9d7c8cba7e5f133454",
    url: "8bb438_c87dd238be8d4a15a57eecbefda4495b.jpg"
  }, {
    metadata: {
      height: 5580,
      lastModified: 1445852211,
      name: "5e106a5d4a0b7709f8938194d4778ff4",
      size: 1521731,
      width: 3720
    },
    orderIndex: 62,
    itemId: "5e106a5d4a0b7709f8938194d4778ff4",
    url: "8bb438_ae4f2ce0cfab47859d294f36b2d87cd7.jpg"
  }, {
    metadata: {
      height: 5580,
      lastModified: 1445852211,
      name: "e8f7b815b395981a5285c2bd8b90b1a6",
      size: 1213695,
      width: 3720
    },
    orderIndex: 63,
    itemId: "e8f7b815b395981a5285c2bd8b90b1a6",
    url: "8bb438_144de0d90d5d4476829c870a38ad8151.jpg"
  }, {
    metadata: {
      height: 4930,
      lastModified: 1445852211,
      name: "ab9df5eb2b706bd06a6e8bab622beba4",
      size: 1376745,
      width: 3286
    },
    orderIndex: 64,
    itemId: "ab9df5eb2b706bd06a6e8bab622beba4",
    url: "8bb438_105a7f98d458406eadb5b99069e05e66.jpg"
  }, {
    metadata: {
      height: 5577,
      lastModified: 1445852211,
      name: "4eb593cdb6d13eb99c7a18d2de79b181",
      size: 2762647,
      width: 3718
    },
    orderIndex: 65,
    itemId: "4eb593cdb6d13eb99c7a18d2de79b181",
    url: "8bb438_d675baa15a344a72b357197c11478240.jpg"
  }, {
    metadata: {
      height: 4645,
      lastModified: 1445852211,
      name: "175fa38b92269154b6673618477160de",
      size: 2117640,
      width: 3483
    },
    orderIndex: 66,
    itemId: "175fa38b92269154b6673618477160de",
    url: "8bb438_4b9b9acb8d6c45deadbeeb0029b4bf5e.jpg"
  }, {
    metadata: {
      height: 2561,
      lastModified: 1445852211,
      name: "5b65c635c3ca09f2badf2aeb6d84ed99",
      size: 1499154,
      width: 1922
    },
    orderIndex: 67,
    itemId: "5b65c635c3ca09f2badf2aeb6d84ed99",
    url: "8bb438_b9926ba84cc548df9011d6227d3e20b1.jpg"
  }, {
    metadata: {
      height: 5577,
      lastModified: 1445861516,
      name: "00a063e26be177d3c6a4a2b41cc15be6",
      size: 2746325,
      width: 3718
    },
    orderIndex: 68,
    itemId: "00a063e26be177d3c6a4a2b41cc15be6",
    url: "8bb438_ff1da0eb6547419fbac324f3a7e6a16c.jpg"
  }, {
    metadata: {
      height: 4930,
      lastModified: 1445861511,
      name: "ad45c7343a2ecf89982122c4097a054d",
      size: 1375916,
      width: 3286
    },
    orderIndex: 69,
    itemId: "ad45c7343a2ecf89982122c4097a054d",
    url: "8bb438_263b45a6faeb49e887b71d10a728516d.jpg"
  }, {
    metadata: {
      height: 1000,
      lastModified: 1445852211,
      name: "066c5c3fafab90ecbef3f32736dac3c8",
      size: 561146,
      width: 1920
    },
    orderIndex: 70,
    itemId: "066c5c3fafab90ecbef3f32736dac3c8",
    url: "8bb438_51948835adb84e0dbcca54ce99b48999.jpg"
  }, {
    metadata: {
      height: 1000,
      lastModified: 1445860813,
      name: "7dc09ef29834aea2ae4d1948d60426c1",
      size: 404456,
      width: 1920
    },
    orderIndex: 71,
    itemId: "7dc09ef29834aea2ae4d1948d60426c1",
    url: "8bb438_ff7d47098495432baa3b80bb14930909.jpg"
  }, {
    metadata: {
      height: 5472,
      lastModified: 1445852219,
      name: "53e606d52c7ac88ab77dce9595eb57c5",
      size: 1108341,
      width: 2947
    },
    orderIndex: 72,
    itemId: "53e606d52c7ac88ab77dce9595eb57c5",
    url: "8bb438_ebbc9ec6c20049f490a06f729e4c79cb.jpg"
  }, {
    metadata: {
      height: 2912,
      lastModified: 1445852219,
      name: "37d29273821f8404ed4832dd0872f8f3",
      size: 775953,
      width: 3648
    },
    orderIndex: 73,
    itemId: "37d29273821f8404ed4832dd0872f8f3",
    url: "8bb438_5aba95641dcd4711863dd7e6954082bd.jpg"
  }, {
    metadata: {
      height: 2213,
      lastModified: 1445852219,
      name: "fc1b98985d634845d9eb5eef2878f327",
      size: 334330,
      width: 3192
    },
    orderIndex: 74,
    itemId: "fc1b98985d634845d9eb5eef2878f327",
    url: "8bb438_47f19e10a9924d56b4a7f51e292cb509.jpg"
  }, {
    metadata: {
      height: 5472,
      lastModified: 1445852219,
      name: "47f5e94bc11c22a66fcbd44aff73241c",
      size: 4217344,
      width: 3648
    },
    orderIndex: 75,
    itemId: "47f5e94bc11c22a66fcbd44aff73241c",
    url: "8bb438_36726a2d14ec44ee9edc5693bade1092.jpg"
  }, {
    metadata: {
      height: 5472,
      lastModified: 1445852219,
      name: "5862a30656b6e61705dfbe5505faf867",
      size: 4609929,
      width: 3648
    },
    orderIndex: 76,
    itemId: "5862a30656b6e61705dfbe5505faf867",
    url: "8bb438_be12adcc05bb45eab12f52f03aebb9f8.jpg"
  }, {
    metadata: {
      height: 3648,
      lastModified: 1445852219,
      name: "bc261174203a17b59d870ccf26a01597",
      size: 5736096,
      width: 5472
    },
    orderIndex: 77,
    itemId: "bc261174203a17b59d870ccf26a01597",
    url: "8bb438_94ba2f2573aa431aaef5be76d1cd887d.jpg"
  }, {
    metadata: {
      height: 5472,
      lastModified: 1445852219,
      name: "279757098541cffc5689b7bbe39a88b2",
      size: 5959189,
      width: 3648
    },
    orderIndex: 78,
    itemId: "279757098541cffc5689b7bbe39a88b2",
    url: "8bb438_730e9548a4ae4fe4b717e28c53e89410.jpg"
  }, {
    metadata: {
      height: 3648,
      lastModified: 1445852219,
      name: "ea3c344c388002acfe4f67fac5c8c400",
      size: 3871502,
      width: 5472
    },
    orderIndex: 79,
    itemId: "ea3c344c388002acfe4f67fac5c8c400",
    url: "8bb438_b73a93e4b07c4dbc9e78614a20b33750.jpg"
  }, {
    metadata: {
      height: 5472,
      lastModified: 1445852219,
      name: "3152ccf507b8ff1662385fa6a67311f8",
      size: 2410359,
      width: 3648
    },
    orderIndex: 80,
    itemId: "3152ccf507b8ff1662385fa6a67311f8",
    url: "8bb438_5e257ac6c0634c439066b944ec38fbd7.jpg"
  }, {
    metadata: {
      height: 5472,
      lastModified: 1445852219,
      name: "4faa8030d46fdf8fbb787c1b66f395e3",
      size: 2259034,
      width: 3648
    },
    orderIndex: 81,
    itemId: "4faa8030d46fdf8fbb787c1b66f395e3",
    url: "8bb438_32189edd0d0c44428d3a1305dd7be397.jpg"
  }, {
    metadata: {
      height: 5472,
      lastModified: 1445852219,
      name: "2a37fa063861660e7850eb82d62914ee",
      size: 6866865,
      width: 3648
    },
    orderIndex: 82,
    itemId: "2a37fa063861660e7850eb82d62914ee",
    url: "8bb438_13b27c8ed9084ae6a7526be845547661.jpg"
  }, {
    metadata: {
      height: 3648,
      lastModified: 1445852219,
      name: "2103f7d2c4be85e4467d2f9cba4aeded",
      size: 5509488,
      width: 5472
    },
    orderIndex: 83,
    itemId: "2103f7d2c4be85e4467d2f9cba4aeded",
    url: "8bb438_e1c242b87eb74abab740e5af5104a520.jpg"
  }, {
    metadata: {
      height: 3648,
      lastModified: 1445852219,
      name: "d15b37f375ea80bda4f2c37b64fdf7e8",
      size: 3202506,
      width: 5472
    },
    orderIndex: 84,
    itemId: "d15b37f375ea80bda4f2c37b64fdf7e8",
    url: "8bb438_aab736569612405a8381d4965c769f51.jpg"
  }, {
    metadata: {
      height: 5472,
      lastModified: 1445852219,
      name: "cedc4449d88b491aca7d452fcdf0b3da",
      size: 4278078,
      width: 3648
    },
    orderIndex: 85,
    itemId: "cedc4449d88b491aca7d452fcdf0b3da",
    url: "8bb438_f1f608a67abc4590821f83b4120f6131.jpg"
  }, {
    metadata: {
      height: 3648,
      lastModified: 1445852219,
      name: "d375541f5888e55ac32a5142ed85c3bc",
      size: 5327873,
      width: 5472
    },
    orderIndex: 86,
    itemId: "d375541f5888e55ac32a5142ed85c3bc",
    url: "8bb438_730583b0bebf475086ff40e07898e3e0.jpg"
  }, {
    metadata: {
      height: 3526,
      lastModified: 1445852219,
      name: "b12907da5fbb55a31a760e49fb0bb4e6",
      size: 3941332,
      width: 5177
    },
    orderIndex: 87,
    itemId: "b12907da5fbb55a31a760e49fb0bb4e6",
    url: "8bb438_83e03311e53a47ce9ba8bda910fdad88.jpg"
  }, {
    metadata: {
      height: 3648,
      lastModified: 1445852219,
      name: "1cfbc70e8a351916a2dd29c63e5a2100",
      size: 7240707,
      width: 5472
    },
    orderIndex: 88,
    itemId: "1cfbc70e8a351916a2dd29c63e5a2100",
    url: "8bb438_ac9e77e718404844adeec4677879e617.jpg"
  }, {
    metadata: {
      height: 2126,
      lastModified: 1445861579,
      name: "0d134f293b71f7c0a9638c5f1a8435e5",
      size: 285522,
      width: 1695
    },
    orderIndex: 89,
    itemId: "0d134f293b71f7c0a9638c5f1a8435e5",
    url: "8bb438_5b9f0c9151f24ba8a8ebdba378e260b7.jpg"
  }]
};

var sceneImages = {
  setId: "01d9d4c0-5bc2-43c9-9e26-fae31bedaed9",
  name: "Sample Images",
  photos: [{
    metadata: {
      height: 1280,
      lastModified: 1445850223,
      name: "0213ffc875ad1ed9910acdd34a2fbccc",
      size: 882451,
      width: 1920
    },
    orderIndex: 128,
    itemId: "0213ffc875ad1ed9910acdd34a2fbccc",
    url: "8bb438_6637a364aa0b44358f12de8a8b234ebb.jpg"
  }, {
    metadata: {
      height: 1280,
      lastModified: 1445850223,
      name: "f9ea9d58030b0910fc33cb5ec994ccfe",
      size: 1241614,
      width: 1920
    },
    orderIndex: 129,
    itemId: "f9ea9d58030b0910fc33cb5ec994ccfe",
    url: "8bb438_923730e8751f42aa9f75de92bd4ae77c.jpg"
  }, {
    metadata: {
      height: 1280,
      lastModified: 1445850223,
      name: "bdf64d603f3a5a822d8197f97e4a1dd0",
      size: 495701,
      width: 1920
    },
    orderIndex: 130,
    itemId: "bdf64d603f3a5a822d8197f97e4a1dd0",
    url: "8bb438_8ba11077006942a2b685027502fb91c8.jpg"
  }, {
    metadata: {
      height: 1280,
      lastModified: 1445850223,
      name: "91ff5a615e0235157dc1a7e5f66607bf",
      size: 1117958,
      width: 1920
    },
    orderIndex: 131,
    itemId: "91ff5a615e0235157dc1a7e5f66607bf",
    url: "8bb438_35ed730d87524b1a88179adc18ed9cd4.jpg"
  }, {
    metadata: {
      height: 1280,
      lastModified: 1445850223,
      name: "b5a1eb472c11ff6aa8bc232102e44115",
      size: 1186010,
      width: 1920
    },
    orderIndex: 132,
    itemId: "b5a1eb472c11ff6aa8bc232102e44115",
    url: "8bb438_df62913570ee4b23bcf2e5b38c85be0f.jpg"
  }, {
    metadata: {
      height: 1280,
      lastModified: 1445850223,
      name: "be138fdc7f94fcbfc74f791c187de19f",
      size: 835339,
      width: 1920
    },
    orderIndex: 133,
    itemId: "be138fdc7f94fcbfc74f791c187de19f",
    url: "8bb438_e5dca6ff051f4903bec85ac25ae1c790.jpg"
  }, {
    metadata: {
      height: 1280,
      lastModified: 1445850223,
      name: "15f407e0947a3680a2261a41cb6abbb6",
      size: 1025277,
      width: 1920
    },
    orderIndex: 134,
    itemId: "15f407e0947a3680a2261a41cb6abbb6",
    url: "8bb438_b2d862605f684658926e6ee05e954880.jpg"
  }, {
    metadata: {
      height: 1920,
      lastModified: 1445850223,
      name: "980dd6e0a5fc59853b6caf447f9c73ce",
      size: 235529,
      width: 1920
    },
    orderIndex: 135,
    itemId: "980dd6e0a5fc59853b6caf447f9c73ce",
    url: "8bb438_c1089eafb4ab405ba328b528e3ecc63e.jpg"
  }, {
    metadata: {
      height: 1280,
      lastModified: 1445850223,
      name: "cc3b069a94f4acb4a22050efc44c2585",
      size: 1625320,
      width: 1920
    },
    orderIndex: 136,
    itemId: "cc3b069a94f4acb4a22050efc44c2585",
    url: "8bb438_8c22bd50b08a481a9722ecdf5be4ecb3.jpg"
  }, {
    metadata: {
      height: 1280,
      lastModified: 1445850223,
      name: "cd35fcdad78edbf27525b3ac18a89cde",
      size: 936115,
      width: 1920
    },
    orderIndex: 137,
    itemId: "cd35fcdad78edbf27525b3ac18a89cde",
    url: "8bb438_6bbf8e82fe8f4b79b6e03ee79b66fd6a.jpg"
  }, {
    metadata: {
      height: 1280,
      lastModified: 1445850223,
      name: "17ef104520dd9a0711f1cc900d970b79",
      size: 484241,
      width: 1920
    },
    orderIndex: 138,
    itemId: "17ef104520dd9a0711f1cc900d970b79",
    url: "8bb438_277609c27d9346c38d480b6da8237820.jpg"
  }, {
    metadata: {
      height: 1280,
      lastModified: 1445850223,
      name: "6c8d09f016947a79def3a31b53415efd",
      size: 447393,
      width: 1920
    },
    orderIndex: 139,
    itemId: "6c8d09f016947a79def3a31b53415efd",
    url: "8bb438_1da83d5d8fcd481ba6bf60b40db869c6.jpg"
  }, {
    metadata: {
      height: 1280,
      lastModified: 1445850223,
      name: "319ccc6f69d553ca14cdb454bcec9dab",
      size: 830740,
      width: 1920
    },
    orderIndex: 140,
    itemId: "319ccc6f69d553ca14cdb454bcec9dab",
    url: "8bb438_9de712c571824273a103a07a08897065.jpg"
  }, {
    metadata: {
      height: 1922,
      lastModified: 1445850223,
      name: "a327950f89cc4994f34a0cd0d4a71473",
      size: 2022993,
      width: 1920
    },
    orderIndex: 141,
    itemId: "a327950f89cc4994f34a0cd0d4a71473",
    url: "8bb438_6a7159be0f944dde9098fe566bf22831.jpg"
  }, {
    metadata: {
      height: 1280,
      lastModified: 1445862012,
      name: "0213ffc875ad1ed9910acdd34a2fbccc",
      size: 882451,
      width: 1920
    },
    orderIndex: 142,
    itemId: "0213ffc875ad1ed9910acdd34a2fbccc",
    url: "8bb438_e070e924df8347c38083a247764ff4e7.jpg"
  }, {
    metadata: {
      height: 1280,
      lastModified: 1445862009,
      name: "cd35fcdad78edbf27525b3ac18a89cde",
      size: 936115,
      width: 1920
    },
    orderIndex: 143,
    itemId: "cd35fcdad78edbf27525b3ac18a89cde",
    url: "8bb438_a63b03b9b4d64b258cdb01d1f3133fb7.jpg"
  }, {
    metadata: {
      height: 1280,
      lastModified: 1445861980,
      name: "be138fdc7f94fcbfc74f791c187de19f",
      size: 835339,
      width: 1920
    },
    orderIndex: 144,
    itemId: "be138fdc7f94fcbfc74f791c187de19f",
    url: "8bb438_c69ce4f9e2a2474586da85b85bfac20b.jpg"
  }]
};

var allFood = {
  "setId": "8e8c74c5-53a3-4490-b87c-635a76616013",
  "name": "Photos",
  "photos": [{
    "itemId": "050360fa-53dd-4155-bf91-a2dfb85b397d",
    "url": "0d72ac_3aaebe78739f402591b9c9cf4352dde6.jpg",
    "orderIndex": 9.78287242001E7,
    "metadata": {
      "name": "GettyImages-574092045.jpg",
      "size": 16114871,
      "lastModified": 1456677802000,
      "bg": { "0": 33, "1": 13, "2": 10, "3": 255 },
      "createDate": 978287242000,
      "width": 3840,
      "height": 5760,
      "exif": {
        "Make": "Canon",
        "Model": "Canon EOS 5D Mark III",
        "Orientation": "top-left",
        "XResolution": "300",
        "YResolution": "300",
        "ResolutionUnit": "2",
        "Software": "Adobe Photoshop CC 2015 (Macintosh)",
        "DateTime": "2015:08:08 16:35:55",
        "ExposureTime": "0.016666666666666666",
        "FNumber": "7.1",
        "ExifIFDPointer": "224",
        "ExposureProgram": "Aperture priority",
        "PhotographicSensitivity": "1600",
        "SensitivityType": "2",
        "RecommendedExposureIndex": "1600",
        "ExifVersion": "0230",
        "DateTimeOriginal": "2000:12:31 20:27:22",
        "DateTimeDigitized": "2000:12:31 20:27:22",
        "ShutterSpeedValue": "5.906891",
        "ApertureValue": "5.655638",
        "ExposureBias": "0.6666666666666666",
        "MaxApertureValue": "3",
        "MeteringMode": "Pattern",
        "Flash": "Flash did not fire, compulsory flash mode",
        "FocalLength": "38",
        "SubSecTime": "00",
        "SubSecTimeOriginal": "00",
        "SubSecTimeDigitized": "00",
        "ColorSpace": "65535",
        "PixelXDimension": "3840",
        "PixelYDimension": "5760",
        "FocalPlaneXResolution": "1600",
        "FocalPlaneYResolution": "1600",
        "FocalPlaneResolutionUnit": "3",
        "CustomRendered": "Normal process",
        "ExposureMode": "0",
        "WhiteBalance": "Auto white balance",
        "SceneCaptureType": "Standard",
        "BodySerialNumber": "082024013946",
        "LensSpecification": "24,70,NaN,NaN",
        "LensModel": "EF24-70mm f/2.8L USM",
        "LensSerialNumber": "0000000000"
      },
      "type": "image"
    }
  }, {
    "itemId": "36dac51e-89fc-4169-963b-727d7113a2be",
    "url": "0d72ac_8684a03ee3fc45dba698cd46626fee17.jpg",
    "orderIndex": 1.348145224074E8,
    "metadata": {
      "name": "Fresh Chicken Salad.jpg",
      "size": 17869325,
      "lastModified": 1445849908000,
      "bg": { "0": 151, "1": 192, "2": 121, "3": 255 },
      "createDate": 1348145224000,
      "width": 5170,
      "height": 6848,
      "exif": {
        "ImageDescription": "Johner Bildbyra AB\n+46 8 644 83 30\ninfo@johner.se\nsales@johner.se",
        "Make": "Hasselblad",
        "Model": "Hasselblad H3DII-31",
        "Orientation": "top-left",
        "XResolution": "300",
        "YResolution": "300",
        "ResolutionUnit": "2",
        "Software": "Adobe Photoshop CS Macintosh",
        "DateTime": "2015:03:03 14:31:10",
        "Artist": "Matilda Lindeblad",
        "Copyright": "Copyright (c) Johner Bildbyra AB",
        "ExposureTime": "0.008",
        "FNumber": "11",
        "ExifIFDPointer": "372",
        "ExposureProgram": "Manual",
        "PhotographicSensitivity": "100",
        "ExifVersion": "0210",
        "DateTimeOriginal": "2012:09:20 15:47:04",
        "DateTimeDigitized": "2012:06:28 20:48:41",
        "ShutterSpeedValue": "6.965784",
        "ApertureValue": "6.918863",
        "MaxApertureValue": "3",
        "SubjectDistance": "0.995",
        "MeteringMode": "CenterWeightedAverage",
        "Flash": "Flash did not fire",
        "FocalLength": "80",
        "ColorSpace": "65535",
        "PixelXDimension": "5170",
        "PixelYDimension": "6848",
        "FocalPlaneXResolution": "1470.59",
        "FocalPlaneYResolution": "1470.59",
        "FocalPlaneResolutionUnit": "3",
        "FocalLengthIn35mmFilm": "62",
        "ImageUniqueID": "0000000000000000038765AB00004D3A",
        "LensModel": "HC 80"
      },
      "type": "image"
    }
  }, {
    "itemId": "160e5501-649f-4168-bb91-8075b01a0b9d",
    "url": "0d72ac_e7fad8faf4ae4cda8ce01ed0bc777162.jpg",
    "orderIndex": 1.406378876063E8,
    "metadata": {
      "name": "GettyImages-526746805.jpg",
      "size": 14701543,
      "lastModified": 1454945043000,
      "bg": { "0": 59, "1": 37, "2": 20, "3": 255 },
      "createDate": 1406378876000,
      "width": 5506,
      "height": 3671,
      "exif": {
        "ImageDescription": "Pantry full of flavor for winter",
        "Make": "Canon",
        "Model": "Canon EOS 5D Mark III",
        "XResolution": "300",
        "YResolution": "300",
        "ResolutionUnit": "2",
        "Software": "Adobe Photoshop Lightroom 5.7 (Windows)",
        "DateTime": "2014:11:24 09:11:00",
        "Artist": "Shaiith",
        "Copyright": "Shaiith",
        "ExposureTime": "0.005",
        "FNumber": "8",
        "ExifIFDPointer": "300",
        "ExposureProgram": "Manual",
        "PhotographicSensitivity": "200",
        "SensitivityType": "2",
        "RecommendedExposureIndex": "200",
        "ExifVersion": "0230",
        "DateTimeOriginal": "2014:07:26 15:47:56",
        "DateTimeDigitized": "2014:07:26 15:47:56",
        "ShutterSpeedValue": "7.643856",
        "ApertureValue": "6",
        "ExposureBias": "0",
        "MaxApertureValue": "4",
        "MeteringMode": "Pattern",
        "Flash": "Flash fired, compulsory flash mode",
        "FocalLength": "40",
        "SubSecTimeOriginal": "00",
        "SubSecTimeDigitized": "00",
        "FocalPlaneXResolution": "1600",
        "FocalPlaneYResolution": "1600",
        "FocalPlaneResolutionUnit": "3",
        "CustomRendered": "Normal process",
        "ExposureMode": "1",
        "WhiteBalance": "Auto white balance",
        "SceneCaptureType": "Standard",
        "CameraOwnerName": "Shaiith",
        "BodySerialNumber": "193020000823",
        "LensSpecification": "24,105,NaN,NaN",
        "LensModel": "EF24-105mm f/4L IS USM",
        "LensSerialNumber": "00001adb6a"
      },
      "type": "image"
    }
  }, {
    "itemId": "d8597f46-15c3-4c6a-9bb9-a9cb7c2aa82b",
    "url": "0d72ac_9c9466f4fef44fdda7fe1024fd997c59.jpg",
    "orderIndex": 1.4112161270909998E8,
    "metadata": {
      "name": "Plum Cake.jpg",
      "size": 2834011,
      "lastModified": 1438178669000,
      "bg": { "0": 159, "1": 154, "2": 167, "3": 255 },
      "createDate": 1411216127000,
      "width": 1947,
      "height": 2921,
      "exif": {
        "GPSVersionID": "2.2.0.0",
        "GPSLatitudeRef": "N",
        "GPSLatitude": "50,5,27.53",
        "GPSLongitudeRef": "E",
        "GPSLongitude": "14,28,14.879",
        "GPSAltitudeRef": "1",
        "GPSAltitude": "0",
        "GPSTimeStamp": "13,28,38",
        "GPSImgDirectionRef": "M",
        "GPSImgDirection": "56",
        "GPSProcessingMethod": "65,83,67,73,73,0,0,0,102,117,115,101,100,0",
        "GPSDateStamp": "2014:09:20",
        "ImageDescription": "Processed with VSCOcam with hb1 preset",
        "Make": "LGE",
        "Model": "Nexus 5",
        "Orientation": "right-top",
        "XResolution": "72",
        "YResolution": "72",
        "ResolutionUnit": "2",
        "Software": "VSCOcam Android Version: v3.0.3 (129)",
        "DateTime": "2014:09:20 15:28:47",
        "YCbCrPositioning": "1",
        "Copyright": "Attribution-NoDerivs 3.0 Unported. @kapusnak. 2014.",
        "ExposureTime": "0.030748",
        "FNumber": "2.4",
        "ExifIFDPointer": "343",
        "ExposureProgram": "Normal program",
        "GPSInfoIFDPointer": "827",
        "PhotographicSensitivity": "364",
        "DateTimeOriginal": "2014:09:20 15:28:47",
        "DateTimeDigitized": "2014:09:20 15:28:47",
        "ComponentsConfiguration": "YCbCr",
        "ShutterSpeedValue": "5.02",
        "ApertureValue": "2.53",
        "MaxApertureValue": "2.53",
        "SubjectDistance": "0",
        "MeteringMode": "CenterWeightedAverage",
        "Flash": "Flash did not fire, compulsory flash mode",
        "FocalLength": "3.97",
        "UserComment": "80,114,111,99,101,115,115,101,100,32,119,105,116,104,32,86,83,67,79,99,97,109,32,119,105,116,104,32,104,98,49,32,112,114,101,115,101,116",
        "ColorSpace": "1",
        "PixelXDimension": "2368",
        "PixelYDimension": "3200",
        "SensingMethod": "One-chip color area sensor",
        "SceneType": "Directly photographed",
        "CustomRendered": "Custom process",
        "ExposureMode": "0",
        "DigitalZoomRatio": "1",
        "SceneCaptureType": "Standard",
        "Contrast": "Normal",
        "Saturation": "Normal",
        "Sharpness": "Normal",
        "SubjectDistanceRange": "Unknown"
      },
      "type": "image"
    }
  }, {
    "itemId": "a7f8c70f-ace1-455a-9129-49fe48d7dd06",
    "url": "0d72ac_5cd736713ad04ac4bd1499dbb826cbd2.jpg",
    "orderIndex": 1.414670112034E8,
    "metadata": {
      "name": "shutterstock_166613303.jpg",
      "size": 13747721,
      "lastModified": 1414670112000,
      "bg": { "0": 191, "1": 164, "2": 159, "3": 255 },
      "width": 3456,
      "height": 5184,
      "type": "image"
    }
  }, {
    "itemId": "c4e3a950-3c7b-417c-8f29-ec9540653345",
    "url": "0d72ac_2322079e86f9436fb5257c1b42ee2ecc.jpg",
    "orderIndex": 1.415527760003E8,
    "metadata": {
      "name": "GettyImages-471198870.jpg",
      "size": 4577482,
      "lastModified": 1455119049000,
      "bg": { "0": 140, "1": 93, "2": 86, "3": 255 },
      "createDate": 1415527760000,
      "width": 4201,
      "height": 2804,
      "exif": {
        "ImageWidth": "4201",
        "ImageHeight": "2804",
        "BitsPerSample": "8,8,8",
        "Compression": "1",
        "PhotometricInterpretation": "2",
        "Make": "NIKON CORPORATION",
        "Model": "NIKON D800E",
        "Orientation": "top-left",
        "SamplesPerPixel": "3",
        "XResolution": "300",
        "YResolution": "300",
        "PlanarConfiguration": "1",
        "ResolutionUnit": "2",
        "Software": "Adobe Photoshop CS6 (Macintosh)",
        "DateTime": "2014:11:09 12:09:20",
        "Artist": "Nicolas Hansen                 ",
        "Copyright": "Nicolas Hansen                                        ",
        "ExposureTime": "0.003125",
        "FNumber": "2.8",
        "ExifIFDPointer": "424",
        "ExposureProgram": "Manual",
        "PhotographicSensitivity": "640",
        "ExifVersion": "0220",
        "DateTimeOriginal": "2014:11:09 12:09:20",
        "DateTimeDigitized": "2014:11:09 12:09:20",
        "ShutterSpeedValue": "8.321928091663374",
        "ApertureValue": "2.9708536585365852",
        "ExposureBias": "0",
        "MaxApertureValue": "3",
        "MeteringMode": "Spot",
        "LightSource": "Unknown",
        "Flash": "Flash did not fire, compulsory flash mode",
        "FocalLength": "70",
        "UserComment": "65,83,67,73,73,0,0,0,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32",
        "ColorSpace": "1",
        "PixelXDimension": "4201",
        "PixelYDimension": "2804",
        "SensingMethod": "One-chip color area sensor",
        "FileSource": "DSC",
        "SceneType": "Directly photographed",
        "ExposureMode": "1",
        "WhiteBalance": "Auto white balance",
        "Contrast": "Normal",
        "Saturation": "Normal",
        "Sharpness": "Normal",
        "SubjectDistanceRange": "Unknown"
      },
      "type": "image"
    }
  }, {
    "itemId": "5b39efee-4cb2-4e27-a4f6-5208ca5e0217",
    "url": "0d72ac_90438fc3258e42b487947e51e91f27c2.jpg",
    "orderIndex": 1.418732444041E8,
    "metadata": {
      "name": "shutterstock_222003307.jpg",
      "size": 9110048,
      "lastModified": 1418732444000,
      "bg": { "0": 229, "1": 155, "2": 141, "3": 255 },
      "width": 5352,
      "height": 3648,
      "type": "image"
    }
  }, {
    "itemId": "2e97a709-1cbf-408c-937c-ea8674aa5399",
    "url": "0d72ac_efdcd1c1ac524951ada63357f7b1cc58.jpg",
    "orderIndex": 1.418732533014E8,
    "metadata": {
      "name": "shutterstock_135572054.jpg",
      "size": 12938036,
      "lastModified": 1418732533000,
      "bg": { "0": 205, "1": 232, "2": 218, "3": 255 },
      "width": 5616,
      "height": 3744,
      "type": "image"
    }
  }, {
    "itemId": "f3362c41-8823-41dc-bf37-ae455afb32f7",
    "url": "0d72ac_d19d0405221b4c94b73e867fdb0cb8b1.jpg",
    "orderIndex": 1.420986475056E8,
    "metadata": {
      "name": "Dinner Party.jpg",
      "size": 11115903,
      "lastModified": 1445849867000,
      "bg": { "0": 164, "1": 161, "2": 161, "3": 255 },
      "createDate": 1420986475000,
      "width": 5400,
      "height": 3600,
      "exif": {
        "ImageWidth": "5400",
        "ImageHeight": "3600",
        "BitsPerSample": "8,8,8",
        "Compression": "5",
        "PhotometricInterpretation": "2",
        "Make": "Canon",
        "Model": "Canon EOS 5D Mark III",
        "Orientation": "top-left",
        "SamplesPerPixel": "3",
        "XResolution": "300",
        "YResolution": "300",
        "PlanarConfiguration": "1",
        "ResolutionUnit": "2",
        "Software": "Adobe Photoshop CS6 (Macintosh)",
        "DateTime": "2015:02:04 14:05:00",
        "Artist": "Hero Images Inc.",
        "Copyright": "Copyright",
        "ExposureTime": "0.01",
        "FNumber": "2.8",
        "ExifIFDPointer": "360",
        "ExposureProgram": "Manual",
        "PhotographicSensitivity": "400",
        "SensitivityType": "2",
        "RecommendedExposureIndex": "400",
        "ExifVersion": "0230",
        "DateTimeOriginal": "2015:01:11 16:27:55",
        "DateTimeDigitized": "2015:01:11 16:27:55",
        "ShutterSpeedValue": "6.643856",
        "ApertureValue": "2.970854",
        "ExposureBias": "0",
        "MaxApertureValue": "3",
        "MeteringMode": "Spot",
        "Flash": "Flash did not fire, compulsory flash mode",
        "FocalLength": "24",
        "SubSecTimeOriginal": "78",
        "SubSecTimeDigitized": "78",
        "ColorSpace": "65535",
        "PixelXDimension": "5400",
        "PixelYDimension": "3600",
        "FocalPlaneXResolution": "1600",
        "FocalPlaneYResolution": "1600",
        "FocalPlaneResolutionUnit": "3",
        "CustomRendered": "Normal process",
        "ExposureMode": "1",
        "WhiteBalance": "Auto white balance",
        "SceneCaptureType": "Standard",
        "BodySerialNumber": "262121000778",
        "LensSpecification": "24,70,NaN,NaN",
        "LensModel": "EF24-70mm f/2.8L II USM",
        "LensSerialNumber": "9200000941"
      },
      "type": "image"
    }
  }, {
    "itemId": "0f4097be-75f1-497d-9e87-87aad08d0e70",
    "url": "0d72ac_8bb1b5151bb749969784e125be9b7148.jpg",
    "orderIndex": 1.422978995082E8,
    "metadata": {
      "name": "557476917.jpg",
      "size": 9972622,
      "lastModified": 1454859644000,
      "bg": { "0": 141, "1": 134, "2": 131, "3": 255 },
      "createDate": 1422978995000,
      "width": 5200,
      "height": 3467,
      "exif": {
        "ImageWidth": "5000",
        "ImageHeight": "3334",
        "BitsPerSample": "8,8,8",
        "PhotometricInterpretation": "2",
        "ImageDescription": "Refreshing mojito cocktail and lime.",
        "Make": "Canon",
        "Model": "Canon EOS 5D Mark III",
        "Orientation": "top-left",
        "SamplesPerPixel": "3",
        "XResolution": "300",
        "YResolution": "300",
        "ResolutionUnit": "2",
        "Software": "Adobe Photoshop CC 2014 (Macintosh)",
        "DateTime": "2015:05:13 11:41:35",
        "ExposureTime": "0.01",
        "FNumber": "2.8",
        "ExifIFDPointer": "340",
        "ExposureProgram": "Manual",
        "PhotographicSensitivity": "640",
        "SensitivityType": "2",
        "RecommendedExposureIndex": "640",
        "ExifVersion": "0230",
        "DateTimeOriginal": "2015:02:03 17:56:35",
        "DateTimeDigitized": "2015:02:03 17:56:35",
        "ShutterSpeedValue": "6.643856",
        "ApertureValue": "2.970854",
        "ExposureBias": "0",
        "MaxApertureValue": "3",
        "MeteringMode": "Pattern",
        "Flash": "Flash did not fire, compulsory flash mode",
        "FocalLength": "100",
        "ColorSpace": "65535",
        "PixelXDimension": "5200",
        "PixelYDimension": "3467",
        "FocalPlaneXResolution": "1600",
        "FocalPlaneYResolution": "1600",
        "FocalPlaneResolutionUnit": "3",
        "CustomRendered": "Normal process",
        "ExposureMode": "1",
        "WhiteBalance": "Manual white balance",
        "SceneCaptureType": "Standard",
        "BodySerialNumber": "048023006848",
        "LensSpecification": "100,100,NaN,NaN",
        "LensModel": "EF100mm f/2.8L Macro IS USM",
        "LensSerialNumber": "00000073bb"
      },
      "type": "image"
    }
  }, {
    "itemId": "0dae7187-1539-4786-bfec-c03a2692431c",
    "url": "0d72ac_87fcbc7bef454bdc9eb49e334d89db9a.jpg",
    "orderIndex": 1.423396404028E8,
    "metadata": {
      "name": "Popcorn Cake.jpg",
      "size": 2209264,
      "lastModified": 1423396404000,
      "bg": { "0": 207, "1": 202, "2": 187, "3": 255 },
      "width": 1920,
      "height": 1920,
      "exif": {
        "ImageWidth": "3648",
        "ImageHeight": "3648",
        "BitsPerSample": "8,8,8",
        "PhotometricInterpretation": "2",
        "Orientation": "top-left",
        "SamplesPerPixel": "3",
        "XResolution": "72",
        "YResolution": "72",
        "ResolutionUnit": "2",
        "Software": "Adobe Photoshop CC 2014 (Macintosh)",
        "DateTime": "2015:02:08 13:53:23",
        "ExifIFDPointer": "236",
        "ExifVersion": "0221",
        "ColorSpace": "65535",
        "PixelXDimension": "1920",
        "PixelYDimension": "1920"
      },
      "type": "image"
    }
  }, {
    "itemId": "77c9cfb6-bfa0-46b6-87cf-c14cb79c9a56",
    "url": "0d72ac_d0839c689761402caf7025ec4347063c.jpg",
    "orderIndex": 1.4233966010529998E8,
    "metadata": {
      "name": "Canapes.jpg",
      "size": 1261652,
      "lastModified": 1423396601000,
      "bg": { "0": 31, "1": 21, "2": 34, "3": 255 },
      "width": 1277,
      "height": 1920,
      "exif": {
        "ImageWidth": "2793",
        "ImageHeight": "4198",
        "BitsPerSample": "8,8,8",
        "PhotometricInterpretation": "2",
        "Orientation": "top-left",
        "SamplesPerPixel": "3",
        "XResolution": "72",
        "YResolution": "72",
        "ResolutionUnit": "2",
        "Software": "Adobe Photoshop CC 2014 (Macintosh)",
        "DateTime": "2015:02:08 13:56:39",
        "ExifIFDPointer": "236",
        "ExifVersion": "0221",
        "ColorSpace": "65535",
        "PixelXDimension": "1277",
        "PixelYDimension": "1920"
      },
      "type": "image"
    }
  }, {
    "itemId": "838c0a80-2b90-45ab-9ff2-bf11bc72434c",
    "url": "0d72ac_eb43c0fea0104fe2996e4308316157fa.jpg",
    "orderIndex": 1.423396780016E8,
    "metadata": {
      "name": "Mojitos.jpg",
      "size": 1525635,
      "lastModified": 1423396780000,
      "bg": { "0": 231, "1": 235, "2": 233, "3": 255 },
      "width": 1204,
      "height": 1920,
      "exif": {
        "ImageWidth": "2644",
        "ImageHeight": "4216",
        "BitsPerSample": "8,8,8",
        "PhotometricInterpretation": "2",
        "Orientation": "top-left",
        "SamplesPerPixel": "3",
        "XResolution": "72",
        "YResolution": "72",
        "ResolutionUnit": "2",
        "Software": "Adobe Photoshop CC 2014 (Macintosh)",
        "DateTime": "2015:02:08 13:59:39",
        "ExifIFDPointer": "236",
        "ExifVersion": "0221",
        "ColorSpace": "65535",
        "PixelXDimension": "1204",
        "PixelYDimension": "1920"
      },
      "type": "image"
    }
  }, {
    "itemId": "f732511b-4767-4e33-a4d7-51710b5a98e2",
    "url": "0d72ac_5a828f9ea5ee472ab77f9870fad8a159.jpg",
    "orderIndex": 1.423483791069E8,
    "metadata": {
      "name": "GettyImages-591407053.jpg",
      "size": 5793739,
      "lastModified": 1455119078000,
      "bg": { "0": 211, "1": 202, "2": 204, "3": 255 },
      "createDate": 1423483791000,
      "width": 5121,
      "height": 3414,
      "exif": {
        "ImageWidth": "5121",
        "ImageHeight": "3414",
        "BitsPerSample": "16,16,16",
        "Compression": "1",
        "PhotometricInterpretation": "2",
        "ImageDescription": "Caucasian barista pouring coffee drink in cafe",
        "Make": "Canon",
        "Model": "Canon EOS 5D Mark III",
        "Orientation": "top-left",
        "SamplesPerPixel": "3",
        "XResolution": "300",
        "YResolution": "300",
        "PlanarConfiguration": "1",
        "ResolutionUnit": "2",
        "Software": "Adobe Photoshop CC 2015 (Macintosh)",
        "DateTime": "2015:10:13 16:49:07",
        "Artist": "Inti St Clair/Blend Images",
        "Copyright": "Â©Inti St Clair/Blend Images LLC",
        "ExposureTime": "0.01",
        "FNumber": "2.8",
        "ExifIFDPointer": "456",
        "ExposureProgram": "Manual",
        "PhotographicSensitivity": "320",
        "SensitivityType": "2",
        "RecommendedExposureIndex": "320",
        "ExifVersion": "0230",
        "DateTimeOriginal": "2015:02:09 14:09:51",
        "DateTimeDigitized": "2015:02:09 14:09:51",
        "ShutterSpeedValue": "6.643856",
        "ApertureValue": "2.970854",
        "ExposureBias": "0",
        "MaxApertureValue": "3",
        "MeteringMode": "Pattern",
        "Flash": "Flash did not fire, compulsory flash mode",
        "FocalLength": "35",
        "SubSecTimeOriginal": "03",
        "ColorSpace": "65535",
        "PixelXDimension": "5121",
        "PixelYDimension": "3414",
        "FocalPlaneXResolution": "1600",
        "FocalPlaneYResolution": "1600",
        "FocalPlaneResolutionUnit": "3",
        "CustomRendered": "Normal process",
        "ExposureMode": "1",
        "WhiteBalance": "Manual white balance",
        "SceneCaptureType": "Standard",
        "BodySerialNumber": "132026002127",
        "LensSpecification": "24,70,NaN,NaN",
        "LensModel": "EF24-70mm f/2.8L II USM",
        "LensSerialNumber": "9515004573"
      },
      "type": "image"
    }
  }, {
    "itemId": "a27bc7c6-ec10-4c35-84a3-b71f031d48af",
    "url": "0d72ac_1cf896e6c81e4c3c9846e05b895e0fe7.jpg",
    "orderIndex": 1.424349441076E8,
    "metadata": {
      "name": "shutterstock_222361666.jpg",
      "size": 3267106,
      "lastModified": 1424349441000,
      "bg": { "0": 103, "1": 99, "2": 84, "3": 255 },
      "width": 3960,
      "height": 2640,
      "type": "image"
    }
  }, {
    "itemId": "ef8902fe-8178-4848-b269-2f4d1c917bdb",
    "url": "0d72ac_99cbdacf346e481c9ace9fbb1121efca.jpg",
    "orderIndex": 1.42486084907E8,
    "metadata": {
      "name": "GettyImages-556451905.jpg",
      "size": 9850021,
      "lastModified": 1456133015000,
      "bg": { "0": 75, "1": 40, "2": 67, "3": 255 },
      "createDate": 1424860849000,
      "width": 5490,
      "height": 3660,
      "exif": {
        "GPSVersionID": "2.3.0.0",
        "ImageDescription": "Flammkuchen with Red Cabbage, Pears and Non-Dairy Cheese",
        "Make": "NIKON CORPORATION",
        "Model": "NIKON D7100",
        "XResolution": "300",
        "YResolution": "300",
        "ResolutionUnit": "2",
        "Software": "Capture One 8 Macintosh",
        "DateTime": "2015:02:25 12:40:49",
        "Artist": "Harald Walker                  ",
        "Copyright": "Westend61 / Harald Walker",
        "ExposureTime": "0.06666666666666667",
        "FNumber": "4",
        "ExifIFDPointer": "364",
        "ExposureProgram": "Aperture priority",
        "GPSInfoIFDPointer": "866",
        "PhotographicSensitivity": "100",
        "ExifVersion": "0220",
        "DateTimeOriginal": "2015:02:25 12:40:49",
        "DateTimeDigitized": "2015:02:25 12:40:49",
        "ShutterSpeedValue": "3.906890590269202",
        "ApertureValue": "4",
        "ExposureBias": "0.3333333333333333",
        "MaxApertureValue": "1.6",
        "MeteringMode": "Pattern",
        "LightSource": "Unknown",
        "Flash": "Flash did not fire, compulsory flash mode",
        "FocalLength": "35",
        "UserComment": "65,83,67,73,73,0,0,0,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32",
        "PixelXDimension": "5490",
        "PixelYDimension": "3660",
        "SensingMethod": "One-chip color area sensor",
        "FileSource": "DSC",
        "SceneType": "Directly photographed",
        "ExposureMode": "0",
        "WhiteBalance": "Auto white balance",
        "Contrast": "Normal",
        "Saturation": "Normal",
        "Sharpness": "Normal",
        "SubjectDistanceRange": "Unknown"
      },
      "type": "image"
    }
  }, {
    "itemId": "ab9804ce-f9ae-4f31-b5c6-e35a3a2ffd05",
    "url": "0d72ac_334db1986ac04a32ae54e90b2a6f496a.jpg",
    "orderIndex": 1.429176512031E8,
    "metadata": {
      "name": "GettyImages-592232565.jpg",
      "size": 10845236,
      "lastModified": 1456133197000,
      "bg": { "0": 226, "1": 206, "2": 197, "3": 255 },
      "createDate": 1429176512000,
      "width": 5700,
      "height": 3800,
      "exif": {
        "Make": "Canon",
        "Model": "Canon EOS 5D Mark III",
        "Orientation": "top-left",
        "XResolution": "300",
        "YResolution": "300",
        "ResolutionUnit": "2",
        "Software": "Adobe Photoshop CS6 (Macintosh)",
        "DateTime": "2015:07:21 18:20:35",
        "Artist": "www.apeloga.se",
        "Copyright": "www.apeloga.se",
        "ExposureTime": "0.00625",
        "FNumber": "2",
        "ExifIFDPointer": "272",
        "ExposureProgram": "Manual",
        "PhotographicSensitivity": "200",
        "SensitivityType": "2",
        "RecommendedExposureIndex": "200",
        "ExifVersion": "0230",
        "DateTimeOriginal": "2015:04:16 12:28:32",
        "DateTimeDigitized": "2015:04:16 12:28:32",
        "ShutterSpeedValue": "7.321928",
        "ApertureValue": "2",
        "ExposureBias": "0",
        "MaxApertureValue": "2",
        "MeteringMode": "Pattern",
        "Flash": "Flash did not fire, compulsory flash mode",
        "FocalLength": "35",
        "SubSecTimeOriginal": "46",
        "SubSecTimeDigitized": "46",
        "ColorSpace": "65535",
        "PixelXDimension": "5700",
        "PixelYDimension": "3800",
        "FocalPlaneXResolution": "1600",
        "FocalPlaneYResolution": "1600",
        "FocalPlaneResolutionUnit": "3",
        "CustomRendered": "Normal process",
        "ExposureMode": "1",
        "WhiteBalance": "Auto white balance",
        "SceneCaptureType": "Standard",
        "CameraOwnerName": "www.apeloga.se",
        "BodySerialNumber": "253020000166",
        "LensSpecification": "35,35,NaN,NaN",
        "LensModel": "EF35mm f/2",
        "LensSerialNumber": "0000000000"
      },
      "type": "image"
    }
  }, {
    "itemId": "576dcd44-b53d-4855-9dce-f2bd3572d692",
    "url": "0d72ac_5878e29dcf3d42649ad88b7d974421f6.jpg",
    "orderIndex": 1.433082880032E8,
    "metadata": {
      "name": "GettyImages-476695758.jpg",
      "size": 3879799,
      "lastModified": 1454945092000,
      "bg": { "0": 222, "1": 228, "2": 217, "3": 255 },
      "createDate": 1433082880000,
      "width": 3600,
      "height": 2403,
      "exif": {
        "GPSVersionID": "2.3.0.0",
        "ImageWidth": "3600",
        "ImageHeight": "2403",
        "BitsPerSample": "8,8,8",
        "Compression": "1",
        "PhotometricInterpretation": "2",
        "ImageDescription": "cheese and meat plate with olives and walnuts",
        "Make": "NIKON CORPORATION",
        "Model": "NIKON D600",
        "Orientation": "top-left",
        "SamplesPerPixel": "3",
        "XResolution": "300",
        "YResolution": "300",
        "PlanarConfiguration": "1",
        "ResolutionUnit": "2",
        "Software": "Adobe Photoshop CS6 (Windows)",
        "DateTime": "2015:05:31 17:34:40",
        "Artist": "                               ",
        "Copyright": "                                                      ",
        "ExposureTime": "0.005",
        "FNumber": "5",
        "ExifIFDPointer": "488",
        "ExposureProgram": "Manual",
        "GPSInfoIFDPointer": "1004",
        "PhotographicSensitivity": "500",
        "ExifVersion": "0220",
        "DateTimeOriginal": "2015:05:31 17:34:40",
        "DateTimeDigitized": "2015:05:31 17:34:40",
        "ShutterSpeedValue": "7.643856190744391",
        "ApertureValue": "4.643856190744391",
        "ExposureBias": "0",
        "MaxApertureValue": "3.3",
        "MeteringMode": "Pattern",
        "LightSource": "Unknown",
        "Flash": "Flash did not fire, compulsory flash mode",
        "FocalLength": "60",
        "UserComment": "65,83,67,73,73,0,0,0,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32,32",
        "ColorSpace": "1",
        "PixelXDimension": "3600",
        "PixelYDimension": "2403",
        "SensingMethod": "One-chip color area sensor",
        "FileSource": "DSC",
        "SceneType": "Directly photographed",
        "ExposureMode": "1",
        "WhiteBalance": "Manual white balance",
        "Contrast": "Normal",
        "Saturation": "Normal",
        "Sharpness": "Normal",
        "SubjectDistanceRange": "Unknown"
      },
      "type": "image"
    }
  }, {
    "itemId": "3886129f-24f0-497f-b2c1-7dcb4f7f640f",
    "url": "0d72ac_2ab45bf4128b49329a8e3cbfb524df88.jpg",
    "orderIndex": 1.4340917870299998E8,
    "metadata": {
      "name": "GettyImages-578189905.jpg",
      "size": 5779789,
      "lastModified": 1455198913000,
      "bg": { "0": 231, "1": 237, "2": 243, "3": 255 },
      "createDate": 1434091787000,
      "width": 5282,
      "height": 3521,
      "exif": {
        "ImageDescription": "Vanilleeis mit rosa Fruchtswirls in Kastenform, Eiskugelausstecher, Eiswaffeln in Emailletasse mit Eiskugeln",
        "Make": "Canon",
        "Model": "Canon EOS 5D Mark II",
        "XResolution": "300",
        "YResolution": "300",
        "ResolutionUnit": "2",
        "Software": "Adobe Photoshop Lightroom 4.4 (Windows)",
        "DateTime": "2015:06:15 12:43:45",
        "Copyright": "Westend61 / Susan Brooks-Dammann",
        "ExposureTime": "0.4",
        "FNumber": "6.3",
        "ExifIFDPointer": "382",
        "ExposureProgram": "Manual",
        "PhotographicSensitivity": "100",
        "ExifVersion": "0230",
        "DateTimeOriginal": "2015:06:12 09:49:47",
        "DateTimeDigitized": "2015:06:12 09:49:47",
        "ShutterSpeedValue": "1.321928",
        "ApertureValue": "5.310704",
        "ExposureBias": "0",
        "MaxApertureValue": "3",
        "MeteringMode": "Pattern",
        "Flash": "Flash did not fire, compulsory flash mode",
        "FocalLength": "90",
        "SubSecTimeOriginal": "25",
        "SubSecTimeDigitized": "25",
        "FocalPlaneXResolution": "3849.2117888965045",
        "FocalPlaneYResolution": "3908.141962421712",
        "FocalPlaneResolutionUnit": "2",
        "CustomRendered": "Normal process",
        "ExposureMode": "1",
        "WhiteBalance": "Auto white balance",
        "SceneCaptureType": "Standard",
        "BodySerialNumber": "330118785",
        "LensSpecification": "90,90,NaN,NaN",
        "LensModel": "TS-E90mm f/2.8"
      },
      "type": "image"
    }
  }, {
    "itemId": "afd457df-b998-4c67-9713-e4c77321b590",
    "url": "0d72ac_a6b6e78f169e444186f7749a7d6e0464.jpg",
    "orderIndex": 1.43479905109E8,
    "metadata": {
      "name": "GettyImages-566323721.jpg",
      "size": 11505191,
      "lastModified": 1456214328000,
      "bg": { "0": 51, "1": 74, "2": 12, "3": 255 },
      "createDate": 1434799051000,
      "width": 5472,
      "height": 3648,
      "exif": {
        "ImageDescription": "Mojito ingredients,  white rum, lime, mint, and ice,  refreshing summer drink, top view with copy space",
        "Make": "Canon",
        "Model": "Canon EOS 6D",
        "XResolution": "300",
        "YResolution": "300",
        "ResolutionUnit": "2",
        "Software": "Adobe Photoshop Lightroom 5.3 (Windows)",
        "DateTime": "2015:07:03 23:01:04",
        "ExposureTime": "0.16666666666666666",
        "FNumber": "10",
        "ExifIFDPointer": "322",
        "ExposureProgram": "Manual",
        "PhotographicSensitivity": "125",
        "SensitivityType": "2",
        "RecommendedExposureIndex": "125",
        "ExifVersion": "0230",
        "DateTimeOriginal": "2015:06:20 14:17:31",
        "DateTimeDigitized": "2015:06:20 14:17:31",
        "ShutterSpeedValue": "2.584963",
        "ApertureValue": "6.643856",
        "ExposureBias": "0",
        "MaxApertureValue": "3",
        "MeteringMode": "Spot",
        "Flash": "Flash did not fire, compulsory flash mode",
        "FocalLength": "100",
        "SubSecTimeOriginal": "53",
        "SubSecTimeDigitized": "53",
        "FocalPlaneXResolution": "1520",
        "FocalPlaneYResolution": "1520",
        "FocalPlaneResolutionUnit": "3",
        "CustomRendered": "Normal process",
        "ExposureMode": "1",
        "WhiteBalance": "Auto white balance",
        "SceneCaptureType": "Standard",
        "BodySerialNumber": "033024009756",
        "LensSpecification": "100,100,NaN,NaN",
        "LensModel": "EF100mm f/2.8 Macro USM",
        "LensSerialNumber": "0000000000"
      },
      "type": "image"
    }
  }, {
    "itemId": "2bd561c8-77b9-45e8-b782-7470b30c5638",
    "url": "0d72ac_20c43a36ae3f43da8264557d8baf8600.jpg",
    "orderIndex": 1.434799828088E8,
    "metadata": {
      "name": "GettyImages-566323727.jpg",
      "size": 14694421,
      "lastModified": 1456214370000,
      "bg": { "0": 224, "1": 184, "2": 153, "3": 255 },
      "createDate": 1434799828000,
      "width": 3648,
      "height": 5472,
      "exif": {
        "ImageDescription": "Mojito ingredients,  white rum, lime, mint, and ice,  refreshing summer drink, top view with copy space",
        "Make": "Canon",
        "Model": "Canon EOS 6D",
        "XResolution": "300",
        "YResolution": "300",
        "ResolutionUnit": "2",
        "Software": "Adobe Photoshop Lightroom 5.3 (Windows)",
        "DateTime": "2015:07:03 23:28:01",
        "ExposureTime": "0.16666666666666666",
        "FNumber": "10",
        "ExifIFDPointer": "322",
        "ExposureProgram": "Manual",
        "PhotographicSensitivity": "125",
        "SensitivityType": "2",
        "RecommendedExposureIndex": "125",
        "ExifVersion": "0230",
        "DateTimeOriginal": "2015:06:20 14:30:28",
        "DateTimeDigitized": "2015:06:20 14:30:28",
        "ShutterSpeedValue": "2.584963",
        "ApertureValue": "6.643856",
        "ExposureBias": "0",
        "MaxApertureValue": "3",
        "MeteringMode": "Spot",
        "Flash": "Flash did not fire, compulsory flash mode",
        "FocalLength": "100",
        "SubSecTimeOriginal": "00",
        "SubSecTimeDigitized": "00",
        "ColorSpace": "1",
        "FocalPlaneXResolution": "1520",
        "FocalPlaneYResolution": "1520",
        "FocalPlaneResolutionUnit": "3",
        "CustomRendered": "Normal process",
        "ExposureMode": "1",
        "WhiteBalance": "Auto white balance",
        "SceneCaptureType": "Standard",
        "BodySerialNumber": "033024009756",
        "LensSpecification": "100,100,NaN,NaN",
        "LensModel": "EF100mm f/2.8 Macro USM",
        "LensSerialNumber": "0000000000"
      },
      "type": "image"
    }
  }, {
    "itemId": "4abc9e13-4247-41cd-adfd-b9b79fdcac96",
    "url": "0d72ac_b906e595a4a84a69a33b0499c7fc9a65",
    "orderIndex": 1.4350448080810001E8,
    "metadata": {
      "name": "BBQ-Flames.cms.mp4",
      "size": 23445227,
      "lastModified": 1435044808000,
      "bg": { "0": 163, "1": 58, "2": 24, "3": 255 },
      "width": 1920,
      "height": 1080,
      "type": "video",
      "posters": [{
        "url": "0d72ac_b906e595a4a84a69a33b0499c7fc9a65f000.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_b906e595a4a84a69a33b0499c7fc9a65f001.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_b906e595a4a84a69a33b0499c7fc9a65f002.jpg",
        "height": 1080,
        "width": 1920
      }, { "url": "0d72ac_b906e595a4a84a69a33b0499c7fc9a65f003.jpg", "height": 1080, "width": 1920 }],
      "duration": 18885,
      "qualities": [{
        "formats": ["mp4", "webm"],
        "height": 480,
        "quality": "480p",
        "width": 854
      }, { "formats": ["mp4", "webm"], "height": 720, "quality": "720p", "width": 1280 }, {
        "formats": ["mp4", "webm"],
        "height": 1080,
        "quality": "1080p",
        "width": 1920
      }]
    }
  }, {
    "itemId": "73eeb1e8-7e82-4140-81d0-0200ee2a6713",
    "url": "0d72ac_14963a1596e9449e8416824bcb84ae7f",
    "orderIndex": 1.4350450220319998E8,
    "metadata": {
      "name": "Coffee-Machine.cms.mp4",
      "size": 7094716,
      "lastModified": 1435045022000,
      "bg": { "0": 168, "1": 6, "2": 30, "3": 255 },
      "width": 1920,
      "height": 1080,
      "type": "video",
      "posters": [{
        "url": "0d72ac_14963a1596e9449e8416824bcb84ae7ff000.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_14963a1596e9449e8416824bcb84ae7ff001.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_14963a1596e9449e8416824bcb84ae7ff002.jpg",
        "height": 1080,
        "width": 1920
      }, { "url": "0d72ac_14963a1596e9449e8416824bcb84ae7ff003.jpg", "height": 1080, "width": 1920 }],
      "duration": 5672,
      "qualities": [{
        "formats": ["mp4", "webm"],
        "height": 480,
        "quality": "480p",
        "width": 854
      }, { "formats": ["mp4", "webm"], "height": 720, "quality": "720p", "width": 1280 }, {
        "formats": ["mp4", "webm"],
        "height": 1080,
        "quality": "1080p",
        "width": 1920
      }]
    }
  }, {
    "itemId": "1fb29c16-de5a-4f60-821e-39e6cde0939e",
    "url": "0d72ac_a5fd8077f3a14c71954b00b1166d804d.jpg",
    "orderIndex": 1.435305750019E8,
    "metadata": {
      "name": "GettyImages-493550798.jpg",
      "size": 17058915,
      "lastModified": 1456319165000,
      "bg": { "0": 219, "1": 209, "2": 189, "3": 255 },
      "createDate": 1435305750000,
      "width": 5956,
      "height": 3933,
      "exif": {
        "ImageWidth": "5956",
        "ImageHeight": "3933",
        "BitsPerSample": "8,8,8",
        "PhotometricInterpretation": "2",
        "ImageDescription": "Pouring cream in cold brew coffee",
        "Orientation": "top-left",
        "SamplesPerPixel": "3",
        "XResolution": "72",
        "YResolution": "72",
        "ResolutionUnit": "2",
        "Software": "Adobe Photoshop CC 2015 (Macintosh)",
        "DateTime": "2016:02:24 15:05:31",
        "Artist": "coryz",
        "ExifIFDPointer": "300",
        "ExifVersion": "0230",
        "DateTimeOriginal": "2015:06:26 11:02:30",
        "DateTimeDigitized": "2015:06:26 11:02:30",
        "ColorSpace": "1",
        "PixelXDimension": "5956",
        "PixelYDimension": "3933"
      },
      "type": "image"
    }
  }, {
    "itemId": "adb0d2e9-abd5-4f3f-8ac2-b4a0f4d678e6",
    "url": "0d72ac_7a7ebab21a5a4e47ba00b8369447b067.jpg",
    "orderIndex": 1.435870800023E8,
    "metadata": {
      "name": "GettyImages-487123540.jpg",
      "size": 17456251,
      "lastModified": 1455004945000,
      "bg": { "0": 33, "1": 39, "2": 55, "3": 255 },
      "createDate": 1435870800000,
      "width": 6797,
      "height": 3897,
      "exif": {
        "ImageWidth": "7216",
        "ImageHeight": "5412",
        "BitsPerSample": "16,16,16",
        "Compression": "1",
        "PhotometricInterpretation": "2",
        "ImageDescription": "top down photo of two authentic mexican tacos",
        "Make": "Hasselblad",
        "Model": "Hasselblad H3DII-39",
        "Orientation": "top-left",
        "SamplesPerPixel": "3",
        "XResolution": "300",
        "YResolution": "300",
        "ResolutionUnit": "2",
        "Software": "Adobe Photoshop CS6 (Windows)",
        "DateTime": "2015:03:11 00:02:53",
        "ExposureTime": "0.002",
        "FNumber": "11",
        "ExifIFDPointer": "2452",
        "ExposureProgram": "Manual",
        "PhotographicSensitivity": "50",
        "ExifVersion": "0210",
        "DateTimeOriginal": "2015-03-09T14:07:03",
        "DateTimeDigitized": "2015-03-09T14:07:03",
        "ShutterSpeedValue": "8.965784281492233",
        "ApertureValue": "6.918863236904144",
        "MaxApertureValue": "3.169925",
        "SubjectDistance": "0.995",
        "MeteringMode": "CenterWeightedAverage",
        "Flash": "Flash did not fire",
        "FocalLength": "80",
        "ColorSpace": "1",
        "PixelXDimension": "6797",
        "PixelYDimension": "3897",
        "FocalPlaneXResolution": "1470.59",
        "FocalPlaneYResolution": "1470.59",
        "FocalPlaneResolutionUnit": "3",
        "FocalLengthIn35mmFilm": "56"
      },
      "type": "image"
    }
  }, {
    "itemId": "aa45e85e-71f7-49dc-9359-f58637bc4f79",
    "url": "0d72ac_3302c5d2314e4f25897dd598f8ff78c1.jpg",
    "orderIndex": 1.43706779508E8,
    "metadata": {
      "name": "GettyImages-583636387.jpg",
      "size": 6627421,
      "lastModified": 1456133157000,
      "bg": { "0": 147, "1": 147, "2": 159, "3": 255 },
      "createDate": 1437067795000,
      "width": 3872,
      "height": 2592,
      "exif": {
        "Make": "NIKON CORPORATION",
        "Model": "NIKON D40X",
        "XResolution": "300",
        "YResolution": "300",
        "ResolutionUnit": "2",
        "Software": "Ver.1.00",
        "DateTime": "2015:09:13 18:08:38",
        "ExposureTime": "0.03333333333333333",
        "FNumber": "2.8",
        "ExifIFDPointer": "186",
        "ExposureProgram": "Undefined",
        "PhotographicSensitivity": "800",
        "SensitivityType": "0",
        "ExifVersion": "0221",
        "DateTimeOriginal": "2015:07:16 20:29:55",
        "DateTimeDigitized": "2015:07:16 20:29:55",
        "ShutterSpeedValue": "4.906891",
        "ApertureValue": "2.970854",
        "ExposureBias": "0",
        "MaxApertureValue": "1",
        "SubjectDistance": "1.33",
        "MeteringMode": "Pattern",
        "LightSource": "Unknown",
        "Flash": "Flash did not fire, compulsory flash mode",
        "FocalLength": "50",
        "SubSecTimeOriginal": "90",
        "SubSecTimeDigitized": "90",
        "SensingMethod": "One-chip color area sensor",
        "FileSource": "DSC",
        "SceneType": "Directly photographed",
        "CFAPattern": "2,0,2,0,1,2,0,1",
        "CustomRendered": "Normal process",
        "ExposureMode": "0",
        "WhiteBalance": "Auto white balance",
        "DigitalZoomRatio": "1",
        "FocalLengthIn35mmFilm": "75",
        "SceneCaptureType": "Standard",
        "GainControl": "Low gain up",
        "Contrast": "Normal",
        "Saturation": "Normal",
        "Sharpness": "Normal",
        "SubjectDistanceRange": "Unknown",
        "BodySerialNumber": "6139445",
        "LensSpecification": "50,50,1.4,1.4",
        "LensModel": "50.0 mm f/1.4"
      },
      "type": "image"
    }
  }, {
    "itemId": "bedc91c8-799a-4994-ae73-e0a331391510",
    "url": "0d72ac_879025b2dc624bb4916df2c1b59ae064.jpg",
    "orderIndex": 1.439288413061E8,
    "metadata": {
      "name": "GettyImages-579536497.jpg",
      "size": 7854698,
      "lastModified": 1455010143000,
      "bg": { "0": 198, "1": 172, "2": 171, "3": 255 },
      "createDate": 1439288413000,
      "width": 6016,
      "height": 4000,
      "exif": {
        "Make": "NIKON CORPORATION",
        "Model": "NIKON D3200",
        "XResolution": "300",
        "YResolution": "300",
        "ResolutionUnit": "2",
        "Software": "Adobe DNG Converter 7.1 (Windows)",
        "DateTime": "2015:08:19 10:29:19",
        "ExposureTime": "0.004",
        "FNumber": "1.8",
        "ExifIFDPointer": "210",
        "ExposureProgram": "Manual",
        "PhotographicSensitivity": "100",
        "ExifVersion": "0230",
        "DateTimeOriginal": "2015:08:11 13:20:13",
        "DateTimeDigitized": "2015:08:11 13:20:13",
        "ShutterSpeedValue": "7.965784",
        "ApertureValue": "1.695994",
        "ExposureBias": "-1.3333333333333333",
        "MaxApertureValue": "1.6",
        "SubjectDistance": "8913",
        "MeteringMode": "CenterWeightedAverage",
        "LightSource": "Unknown",
        "Flash": "Flash did not fire",
        "FocalLength": "35",
        "SubSecTimeOriginal": "50",
        "SubSecTimeDigitized": "50",
        "FocalPlaneXResolution": "259.52520751953125",
        "FocalPlaneYResolution": "259.52520751953125",
        "FocalPlaneResolutionUnit": "4",
        "SensingMethod": "One-chip color area sensor",
        "FileSource": "DSC",
        "SceneType": "Directly photographed",
        "CFAPattern": "2,0,2,0,0,1,1,2",
        "CustomRendered": "Normal process",
        "ExposureMode": "1",
        "WhiteBalance": "Auto white balance",
        "DigitalZoomRatio": "1",
        "FocalLengthIn35mmFilm": "52",
        "SceneCaptureType": "Standard",
        "GainControl": "None",
        "Contrast": "Normal",
        "Saturation": "Normal",
        "Sharpness": "Normal",
        "SubjectDistanceRange": "Unknown"
      },
      "type": "image"
    }
  }, {
    "itemId": "9d28ba1b-b495-4c9f-ab27-df13d5f58608",
    "url": "0d72ac_8da433dd6ac14635aa35403e4b7a6a7b.jpg",
    "orderIndex": 1.4398238280560002E8,
    "metadata": {
      "name": "GettyImages-498692910.jpg",
      "size": 2259256,
      "lastModified": 1453812777000,
      "bg": { "0": 108, "1": 181, "2": 106, "3": 255 },
      "createDate": 1439823828000,
      "width": 3264,
      "height": 2448,
      "exif": {
        "ImageWidth": "3264",
        "ImageHeight": "2448",
        "BitsPerSample": "8,8,8",
        "PhotometricInterpretation": "2",
        "Make": "Apple",
        "Model": "iPhone 6",
        "Orientation": "top-left",
        "SamplesPerPixel": "3",
        "XResolution": "300",
        "YResolution": "300",
        "ResolutionUnit": "2",
        "Software": "Adobe Photoshop CC 2015 (Macintosh)",
        "DateTime": "2015:11:25 09:37:24",
        "YCbCrPositioning": "1",
        "ExposureTime": "0.03333333333333333",
        "FNumber": "2.2",
        "ExifIFDPointer": "288",
        "ExposureProgram": "Normal program",
        "PhotographicSensitivity": "50",
        "ExifVersion": "0221",
        "DateTimeOriginal": "2015:08:17 18:03:48",
        "DateTimeDigitized": "2015:08:17 18:03:48",
        "ComponentsConfiguration": "YCbCr",
        "ShutterSpeedValue": "4.9076406381192275",
        "ApertureValue": "2.2750071245369052",
        "BrightnessValue": "3.4315849486887116",
        "ExposureBias": "0",
        "MeteringMode": "Pattern",
        "Flash": "Flash did not fire, compulsory flash mode",
        "FocalLength": "4.15",
        "SubjectArea": "1631,1223,1795,1077",
        "SubSecTimeOriginal": "081",
        "SubSecTimeDigitized": "081",
        "FlashpixVersion": "0100",
        "ColorSpace": "65535",
        "PixelXDimension": "3264",
        "PixelYDimension": "2448",
        "SensingMethod": "One-chip color area sensor",
        "SceneType": "Directly photographed",
        "ExposureMode": "0",
        "WhiteBalance": "Auto white balance",
        "FocalLengthIn35mmFilm": "29",
        "SceneCaptureType": "Standard",
        "LensSpecification": "4.15,4.15,2.2,2.2",
        "LensMake": "Apple",
        "LensModel": "iPhone 6 back camera 4.15mm f/2.2"
      },
      "type": "image"
    }
  }, {
    "itemId": "f5e3553b-881c-4995-80c8-b29735feb3bc",
    "url": "0d72ac_fd38f57fca044849899eb6b1aff287bc.jpg",
    "orderIndex": 1.4403996510009998E8,
    "metadata": {
      "name": "Template Pizza7497.JPG",
      "size": 4516061,
      "lastModified": 1440403169000,
      "bg": { "0": 160, "1": 108, "2": 54, "3": 255 },
      "createDate": 1440399651000,
      "width": 5472,
      "height": 3648,
      "exif": {
        "GPSVersionID": "2.3.0.0",
        "Make": "Canon",
        "Model": "Canon EOS 6D",
        "Orientation": "top-left",
        "XResolution": "72",
        "YResolution": "72",
        "ResolutionUnit": "2",
        "DateTime": "2015:08:24 10:00:51",
        "Artist": "\0",
        "YCbCrPositioning": "2",
        "Copyright": "\0",
        "ExposureTime": "0.05",
        "FNumber": "9",
        "ExifIFDPointer": "360",
        "ExposureProgram": "Manual",
        "GPSInfoIFDPointer": "9186",
        "PhotographicSensitivity": "400",
        "SensitivityType": "2",
        "RecommendedExposureIndex": "400",
        "ExifVersion": "0230",
        "DateTimeOriginal": "2015:08:24 10:00:51",
        "DateTimeDigitized": "2015:08:24 10:00:51",
        "ComponentsConfiguration": "YCbCr",
        "ShutterSpeedValue": "4.375",
        "ApertureValue": "6.375",
        "ExposureBias": "0",
        "MeteringMode": "Pattern",
        "Flash": "Flash did not fire, compulsory flash mode",
        "FocalLength": "100",
        "UserComment": "0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0",
        "SubSecTime": "93",
        "SubSecTimeOriginal": "93",
        "SubSecTimeDigitized": "93",
        "FlashpixVersion": "0100",
        "ColorSpace": "1",
        "PixelXDimension": "5472",
        "PixelYDimension": "3648",
        "InteroperabilityIFDPointer": "8958",
        "FocalPlaneXResolution": "3810.58495821727",
        "FocalPlaneYResolution": "3815.899581589958",
        "FocalPlaneResolutionUnit": "2",
        "CustomRendered": "Normal process",
        "ExposureMode": "1",
        "WhiteBalance": "Manual white balance",
        "SceneCaptureType": "Standard",
        "CameraOwnerName": "\0",
        "BodySerialNumber": "138028001567",
        "LensSpecification": "100,100,0,0",
        "LensModel": "EF100mm f/2.8L Macro IS USM",
        "LensSerialNumber": "000005de4d"
      },
      "type": "image"
    }
  }, {
    "itemId": "98b7e332-2299-42df-8d92-46088f074b7a",
    "url": "0d72ac_34a11089ab284b2599229ee4b0fe0d35.jpg",
    "orderIndex": 1.4404034390670002E8,
    "metadata": {
      "name": "Template Pizza7585.JPG",
      "size": 4975196,
      "lastModified": 1440406957000,
      "bg": { "0": 187, "1": 151, "2": 131, "3": 255 },
      "createDate": 1440403439000,
      "width": 5472,
      "height": 3648,
      "exif": {
        "GPSVersionID": "2.3.0.0",
        "Make": "Canon",
        "Model": "Canon EOS 6D",
        "Orientation": "top-left",
        "XResolution": "72",
        "YResolution": "72",
        "ResolutionUnit": "2",
        "DateTime": "2015:08:24 11:03:59",
        "Artist": "\0",
        "YCbCrPositioning": "2",
        "Copyright": "\0",
        "ExposureTime": "0.04",
        "FNumber": "9",
        "ExifIFDPointer": "360",
        "ExposureProgram": "Manual",
        "GPSInfoIFDPointer": "9186",
        "PhotographicSensitivity": "400",
        "SensitivityType": "2",
        "RecommendedExposureIndex": "400",
        "ExifVersion": "0230",
        "DateTimeOriginal": "2015:08:24 11:03:59",
        "DateTimeDigitized": "2015:08:24 11:03:59",
        "ComponentsConfiguration": "YCbCr",
        "ShutterSpeedValue": "4.625",
        "ApertureValue": "6.375",
        "ExposureBias": "0",
        "MeteringMode": "Pattern",
        "Flash": "Flash did not fire, compulsory flash mode",
        "FocalLength": "100",
        "UserComment": "0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0",
        "SubSecTime": "80",
        "SubSecTimeOriginal": "80",
        "SubSecTimeDigitized": "80",
        "FlashpixVersion": "0100",
        "ColorSpace": "1",
        "PixelXDimension": "5472",
        "PixelYDimension": "3648",
        "InteroperabilityIFDPointer": "8958",
        "FocalPlaneXResolution": "3810.58495821727",
        "FocalPlaneYResolution": "3815.899581589958",
        "FocalPlaneResolutionUnit": "2",
        "CustomRendered": "Normal process",
        "ExposureMode": "1",
        "WhiteBalance": "Manual white balance",
        "SceneCaptureType": "Standard",
        "CameraOwnerName": "\0",
        "BodySerialNumber": "138028001567",
        "LensSpecification": "100,100,0,0",
        "LensModel": "EF100mm f/2.8L Macro IS USM",
        "LensSerialNumber": "000005de4d"
      },
      "type": "image"
    }
  }, {
    "itemId": "fe17fd8a-0c1f-4fab-8058-a0952ac88461",
    "url": "0d72ac_0cdfb8f9e85541e3b47225561411fbe4.jpg",
    "orderIndex": 1.440493265056E8,
    "metadata": {
      "name": "shutterstock_300135554.jpg",
      "size": 10657328,
      "lastModified": 1440493265000,
      "bg": { "0": 153, "1": 96, "2": 122, "3": 255 },
      "width": 3879,
      "height": 2751,
      "type": "image"
    }
  }, {
    "itemId": "fce14c76-e4ee-4ace-a3d6-20b0f7e69058",
    "url": "0d72ac_754c9459d9394abe874dcfd7eb721e56.jpg",
    "orderIndex": 1.444728611085E8,
    "metadata": {
      "name": "GettyImages-499149472.jpg",
      "size": 9169823,
      "lastModified": 1454945060000,
      "bg": { "0": 208, "1": 153, "2": 143, "3": 255 },
      "createDate": 1444728611000,
      "width": 4651,
      "height": 3101,
      "exif": {
        "Make": "Canon",
        "Model": "Canon EOS 6D",
        "Orientation": "top-left",
        "XResolution": "300",
        "YResolution": "300",
        "ResolutionUnit": "2",
        "Software": "Adobe Photoshop CC 2015 (Windows)",
        "DateTime": "2015:10:13 13:39:16",
        "ExposureTime": "0.008",
        "FNumber": "5.6",
        "ExifIFDPointer": "212",
        "ExposureProgram": "Manual",
        "PhotographicSensitivity": "50",
        "SensitivityType": "2",
        "RecommendedExposureIndex": "50",
        "ExifVersion": "0230",
        "DateTimeOriginal": "2015:10:13 12:30:11",
        "DateTimeDigitized": "2015:10:13 12:30:11",
        "ShutterSpeedValue": "6.965784",
        "ApertureValue": "4.970854",
        "ExposureBias": "0",
        "MaxApertureValue": "3",
        "MeteringMode": "Pattern",
        "Flash": "Flash did not fire, compulsory flash mode",
        "FocalLength": "100",
        "SubSecTimeOriginal": "00",
        "SubSecTimeDigitized": "00",
        "ColorSpace": "1",
        "PixelXDimension": "4651",
        "PixelYDimension": "3101",
        "FocalPlaneXResolution": "1520",
        "FocalPlaneYResolution": "1520",
        "FocalPlaneResolutionUnit": "3",
        "CustomRendered": "Normal process",
        "ExposureMode": "1",
        "WhiteBalance": "Manual white balance",
        "SceneCaptureType": "Standard",
        "BodySerialNumber": "223020001578",
        "LensSpecification": "100,100,NaN,NaN",
        "LensModel": "EF100mm f/2.8L Macro IS USM",
        "LensSerialNumber": "0000074351"
      },
      "type": "image"
    }
  }, {
    "itemId": "2d24b9a9-a281-459a-a816-cd19f33567cd",
    "url": "0d72ac_8d2f468e466a41c59b219a79e39dd665",
    "orderIndex": 1.445930260078E8,
    "metadata": {
      "name": "Baking-Bread.cms.mp4",
      "size": 982965,
      "lastModified": 1445930260000,
      "bg": { "0": 109, "1": 103, "2": 103, "3": 255 },
      "width": 1920,
      "height": 1080,
      "type": "video",
      "posters": [{
        "url": "0d72ac_8d2f468e466a41c59b219a79e39dd665f000.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_8d2f468e466a41c59b219a79e39dd665f001.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_8d2f468e466a41c59b219a79e39dd665f002.jpg",
        "height": 1080,
        "width": 1920
      }, { "url": "0d72ac_8d2f468e466a41c59b219a79e39dd665f003.jpg", "height": 1080, "width": 1920 }],
      "duration": 767,
      "qualities": [{
        "formats": ["mp4", "webm"],
        "height": 480,
        "quality": "480p",
        "width": 854
      }, { "formats": ["mp4", "webm"], "height": 720, "quality": "720p", "width": 1280 }, {
        "formats": ["mp4", "webm"],
        "height": 1080,
        "quality": "1080p",
        "width": 1920
      }]
    }
  }, {
    "itemId": "13040230-3006-421d-a89f-1cee46589b54",
    "url": "0d72ac_d3f774b142ed4c4fb24b8d588e82c837.jpg",
    "orderIndex": 1.445953607067E8,
    "metadata": {
      "name": "shutterstock_324620414.jpg",
      "size": 6633125,
      "lastModified": 1445953607000,
      "bg": { "0": 202, "1": 190, "2": 191, "3": 255 },
      "width": 3744,
      "height": 5273,
      "type": "image"
    }
  }, {
    "itemId": "4a882e42-8e63-4496-aa6e-bb23a0483222",
    "url": "0d72ac_d56e56ed87cc45f2a60be0a073ac1701.jpg",
    "orderIndex": 1.44603254805E8,
    "metadata": {
      "name": "shutterstock_326513501.jpg",
      "size": 10420709,
      "lastModified": 1446032548000,
      "bg": { "0": 155, "1": 161, "2": 161, "3": 255 },
      "width": 3648,
      "height": 5472,
      "type": "image"
    }
  }, {
    "itemId": "f4aa7ecf-28cd-4d73-9499-1262658c30ae",
    "url": "0d72ac_ef150a919cf945308c14f19e546cde60.jpg",
    "orderIndex": 1.446032666051E8,
    "metadata": {
      "name": "shutterstock_313893746.jpg",
      "size": 16013935,
      "lastModified": 1446032666000,
      "bg": { "0": 4, "1": 0, "2": 1, "3": 255 },
      "width": 7360,
      "height": 4912,
      "type": "image"
    }
  }, {
    "itemId": "9be301ef-4ce6-44f4-9f4e-3eee996c172d",
    "url": "0d72ac_3d3d1bd0d42e449b8e270142c7223643.jpg",
    "orderIndex": 1.446033095094E8,
    "metadata": {
      "name": "shutterstock_214437607.jpg",
      "size": 10597959,
      "lastModified": 1446033095000,
      "bg": { "0": 197, "1": 102, "2": 96, "3": 255 },
      "width": 5760,
      "height": 3840,
      "type": "image"
    }
  }, {
    "itemId": "0353b153-5fa8-4648-a601-808a54f5e921",
    "url": "0d72ac_9e261f4caa6d480e9ed4e3ced4a5b6cf.jpg",
    "orderIndex": 1.44603446502E8,
    "metadata": {
      "name": "shutterstock_193541324.jpg",
      "size": 8685305,
      "lastModified": 1446034465000,
      "bg": { "0": 145, "1": 95, "2": 45, "3": 255 },
      "width": 4600,
      "height": 3070,
      "type": "image"
    }
  }, {
    "itemId": "179f946e-81bd-4e70-ba8f-e6d3628924a7",
    "url": "0d72ac_222052399f3243f995c1622f16c13686",
    "orderIndex": 1.446551938057E8,
    "metadata": {
      "name": "Serving_Coffee.cms.mp4",
      "size": 17951236,
      "lastModified": 1446551938000,
      "bg": { "0": 121, "1": 127, "2": 130, "3": 255 },
      "width": 1920,
      "height": 1080,
      "type": "video",
      "posters": [{
        "url": "0d72ac_222052399f3243f995c1622f16c13686f000.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_222052399f3243f995c1622f16c13686f001.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_222052399f3243f995c1622f16c13686f002.jpg",
        "height": 1080,
        "width": 1920
      }, { "url": "0d72ac_222052399f3243f995c1622f16c13686f003.jpg", "height": 1080, "width": 1920 }],
      "duration": 11760,
      "qualities": [{
        "formats": ["mp4", "webm"],
        "height": 480,
        "quality": "480p",
        "width": 854
      }, { "formats": ["mp4", "webm"], "height": 720, "quality": "720p", "width": 1280 }, {
        "formats": ["mp4", "webm"],
        "height": 1080,
        "quality": "1080p",
        "width": 1920
      }]
    }
  }, {
    "itemId": "d00b56ac-fd5b-4a02-b8ca-c5c61e46d9de",
    "url": "0d72ac_34127be927334e41870cfde09e4dcd8f",
    "orderIndex": 1.448175973009E8,
    "metadata": {
      "name": "Fresh_Coffee.cms.mp4",
      "size": 3613545,
      "lastModified": 1448175973000,
      "bg": { "0": 241, "1": 233, "2": 234, "3": 255 },
      "width": 1920,
      "height": 1080,
      "type": "video",
      "posters": [{
        "url": "0d72ac_34127be927334e41870cfde09e4dcd8ff000.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_34127be927334e41870cfde09e4dcd8ff001.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_34127be927334e41870cfde09e4dcd8ff002.jpg",
        "height": 1080,
        "width": 1920
      }, { "url": "0d72ac_34127be927334e41870cfde09e4dcd8ff003.jpg", "height": 1080, "width": 1920 }],
      "duration": 2235,
      "qualities": [{
        "formats": ["mp4", "webm"],
        "height": 480,
        "quality": "480p",
        "width": 854
      }, { "formats": ["mp4", "webm"], "height": 720, "quality": "720p", "width": 1280 }, {
        "formats": ["mp4", "webm"],
        "height": 1080,
        "quality": "1080p",
        "width": 1920
      }]
    }
  }, {
    "itemId": "2d343d28-c166-42d6-bb6c-2d8727b643cd",
    "url": "0d72ac_13e90945ef12450fa169fbbb5520bc9a",
    "orderIndex": 1.4484719170639998E8,
    "metadata": {
      "name": "italian pasta.mp4",
      "size": 30483051,
      "lastModified": 1448471917000,
      "bg": { "0": 158, "1": 148, "2": 145, "3": 255 },
      "width": 1280,
      "height": 720,
      "type": "video",
      "posters": [{
        "url": "0d72ac_13e90945ef12450fa169fbbb5520bc9af000.jpg",
        "height": 720,
        "width": 1280
      }, {
        "url": "0d72ac_13e90945ef12450fa169fbbb5520bc9af001.jpg",
        "height": 720,
        "width": 1280
      }, {
        "url": "0d72ac_13e90945ef12450fa169fbbb5520bc9af002.jpg",
        "height": 720,
        "width": 1280
      }, { "url": "0d72ac_13e90945ef12450fa169fbbb5520bc9af003.jpg", "height": 720, "width": 1280 }],
      "duration": 23160,
      "qualities": [{
        "formats": ["mp4", "webm"],
        "height": 480,
        "quality": "480p",
        "width": 854
      }, { "formats": ["mp4", "webm"], "height": 720, "quality": "720p", "width": 1280 }]
    }
  }, {
    "itemId": "30b6e2cc-678f-4e86-b3be-d028a86775df",
    "url": "0d72ac_4a871faec2e7496fba090839317e728e",
    "orderIndex": 1.4496708290240002E8,
    "metadata": {
      "name": "Private_Chef.cms.mp4",
      "size": 25917755,
      "lastModified": 1449670829000,
      "bg": { "0": 168, "1": 156, "2": 151, "3": 255 },
      "width": 1280,
      "height": 720,
      "type": "video",
      "posters": [{
        "url": "0d72ac_4a871faec2e7496fba090839317e728ef000.jpg",
        "height": 720,
        "width": 1280
      }, {
        "url": "0d72ac_4a871faec2e7496fba090839317e728ef001.jpg",
        "height": 720,
        "width": 1280
      }, {
        "url": "0d72ac_4a871faec2e7496fba090839317e728ef002.jpg",
        "height": 720,
        "width": 1280
      }, { "url": "0d72ac_4a871faec2e7496fba090839317e728ef003.jpg", "height": 720, "width": 1280 }],
      "duration": 17440,
      "qualities": [{
        "formats": ["mp4", "webm"],
        "height": 480,
        "quality": "480p",
        "width": 854
      }, { "formats": ["mp4", "webm"], "height": 720, "quality": "720p", "width": 1280 }]
    }
  }, {
    "itemId": "a470be37-7067-42bb-b4c8-b594bef9a300",
    "url": "0d72ac_79283126926c4ba8a9556857ea5f3d9e.jpg",
    "orderIndex": 1.4496751991E8,
    "metadata": {
      "name": "Chickpea Salad.jpg",
      "size": 4644495,
      "lastModified": 1449675199000,
      "bg": { "0": 222, "1": 223, "2": 189, "3": 255 },
      "width": 3000,
      "height": 2000,
      "type": "image"
    }
  }, {
    "itemId": "86352ba4-a1ab-43d2-80ff-d3aadb198089",
    "url": "0d72ac_98445994b0804009842e963049c166c2.jpg",
    "orderIndex": 1.449675213007E8,
    "metadata": {
      "name": "Fresh Spaghetti.jpg",
      "size": 7491354,
      "lastModified": 1449675213000,
      "bg": { "0": 86, "1": 62, "2": 119, "3": 255 },
      "width": 2196,
      "height": 3200,
      "type": "image"
    }
  }, {
    "itemId": "a46f352f-d354-4bbe-b9f4-fb34eca52f01",
    "url": "0d72ac_235dbce833d44a14abfc97f00c35593c.jpg",
    "orderIndex": 1.4496753970929998E8,
    "metadata": {
      "name": "Pasta Dish.jpg",
      "size": 16053255,
      "lastModified": 1449675397000,
      "bg": { "0": 205, "1": 189, "2": 161, "3": 255 },
      "width": 5616,
      "height": 3744,
      "type": "image"
    }
  }, {
    "itemId": "7228bfc1-cbb0-42c2-8333-43396fed542a",
    "url": "0d72ac_4cc2521d74044f979885011aeb049c2b.jpg",
    "orderIndex": 1.449677021041E8,
    "metadata": {
      "name": "Green Beans.jpg",
      "size": 2565381,
      "lastModified": 1449677021000,
      "bg": { "0": 165, "1": 170, "2": 133, "3": 255 },
      "width": 3744,
      "height": 5513,
      "type": "image"
    }
  }, {
    "itemId": "4d98bb2b-d0e2-429d-998a-a7ce938f91ab",
    "url": "0d72ac_aaef07a3ecfe40a8a97c6d4319ac0e43",
    "orderIndex": 1.450100995075E8,
    "metadata": {
      "name": "cupcake edited02.mp4",
      "size": 18351212,
      "lastModified": 1450100995000,
      "bg": { "0": 128, "1": 128, "2": 148, "3": 255 },
      "width": 1280,
      "height": 720,
      "type": "video",
      "posters": [{
        "url": "0d72ac_aaef07a3ecfe40a8a97c6d4319ac0e43f000.jpg",
        "height": 720,
        "width": 1280
      }, {
        "url": "0d72ac_aaef07a3ecfe40a8a97c6d4319ac0e43f001.jpg",
        "height": 720,
        "width": 1280
      }, {
        "url": "0d72ac_aaef07a3ecfe40a8a97c6d4319ac0e43f002.jpg",
        "height": 720,
        "width": 1280
      }, { "url": "0d72ac_aaef07a3ecfe40a8a97c6d4319ac0e43f003.jpg", "height": 720, "width": 1280 }],
      "duration": 12200,
      "qualities": [{
        "formats": ["mp4", "webm"],
        "height": 480,
        "quality": "480p",
        "width": 854
      }, { "formats": ["mp4", "webm"], "height": 720, "quality": "720p", "width": 1280 }]
    }
  }, {
    "itemId": "817a7b56-ee9e-4702-bdcb-6f08c7a277cf",
    "url": "0d72ac_0a6e90b765c94798844ac11041fbebd8",
    "orderIndex": 1.450101009097E8,
    "metadata": {
      "name": "cupcake cinemagram01.mp4",
      "size": 19948631,
      "lastModified": 1450101009000,
      "bg": { "0": 167, "1": 142, "2": 126, "3": 255 },
      "width": 1280,
      "height": 720,
      "type": "video",
      "posters": [{
        "url": "0d72ac_0a6e90b765c94798844ac11041fbebd8f000.jpg",
        "height": 720,
        "width": 1280
      }, {
        "url": "0d72ac_0a6e90b765c94798844ac11041fbebd8f001.jpg",
        "height": 720,
        "width": 1280
      }, {
        "url": "0d72ac_0a6e90b765c94798844ac11041fbebd8f002.jpg",
        "height": 720,
        "width": 1280
      }, { "url": "0d72ac_0a6e90b765c94798844ac11041fbebd8f003.jpg", "height": 720, "width": 1280 }],
      "duration": 13320,
      "qualities": [{
        "formats": ["mp4", "webm"],
        "height": 480,
        "quality": "480p",
        "width": 854
      }, { "formats": ["mp4", "webm"], "height": 720, "quality": "720p", "width": 1280 }]
    }
  }, {
    "itemId": "07fed99a-e933-4f83-a65c-ba0b258d762a",
    "url": "0d72ac_a7e08bab08484a64a65987e264022512",
    "orderIndex": 1.45248629403E8,
    "metadata": {
      "name": "Gourmet-Cheese.cms.mp4",
      "size": 10685288,
      "lastModified": 1452486294000,
      "bg": { "0": 11, "1": 9, "2": 11, "3": 255 },
      "width": 1920,
      "height": 1080,
      "type": "video",
      "posters": [{
        "url": "0d72ac_a7e08bab08484a64a65987e264022512f000.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_a7e08bab08484a64a65987e264022512f001.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_a7e08bab08484a64a65987e264022512f002.jpg",
        "height": 1080,
        "width": 1920
      }, { "url": "0d72ac_a7e08bab08484a64a65987e264022512f003.jpg", "height": 1080, "width": 1920 }],
      "duration": 8400,
      "qualities": [{
        "formats": ["mp4", "webm"],
        "height": 480,
        "quality": "480p",
        "width": 854
      }, { "formats": ["mp4", "webm"], "height": 720, "quality": "720p", "width": 1280 }, {
        "formats": ["mp4", "webm"],
        "height": 1080,
        "quality": "1080p",
        "width": 1920
      }]
    }
  }, {
    "itemId": "9dfb85fd-1619-4fe3-a441-12b9a76756b9",
    "url": "0d72ac_7a7108e1819245c5915f1a0a2869b5ac",
    "orderIndex": 1.4524863080810001E8,
    "metadata": {
      "name": "Ice Cream-with-Coconut Sprinkles- CinemaGraph.cms.mp4",
      "size": 12502649,
      "lastModified": 1452486308000,
      "bg": { "0": 119, "1": 82, "2": 69, "3": 255 },
      "width": 1920,
      "height": 1080,
      "type": "video",
      "posters": [{
        "url": "0d72ac_7a7108e1819245c5915f1a0a2869b5acf000.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_7a7108e1819245c5915f1a0a2869b5acf001.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_7a7108e1819245c5915f1a0a2869b5acf002.jpg",
        "height": 1080,
        "width": 1920
      }, { "url": "0d72ac_7a7108e1819245c5915f1a0a2869b5acf003.jpg", "height": 1080, "width": 1920 }],
      "duration": 10000,
      "qualities": [{
        "formats": ["mp4", "webm"],
        "height": 480,
        "quality": "480p",
        "width": 854
      }, { "formats": ["mp4", "webm"], "height": 720, "quality": "720p", "width": 1280 }, {
        "formats": ["mp4", "webm"],
        "height": 1080,
        "quality": "1080p",
        "width": 1920
      }]
    }
  }, {
    "itemId": "444c7363-c099-4915-b977-f4eef2e9fd83",
    "url": "0d72ac_64271a06b9c64662a2cba322baf638cf.jpg",
    "orderIndex": 1.4538001370069999E8,
    "metadata": {
      "name": "shutterstock_291498779.jpg",
      "size": 12070096,
      "lastModified": 1453800137000,
      "bg": { "0": 210, "1": 166, "2": 174, "3": 255 },
      "width": 7000,
      "height": 4666,
      "type": "image"
    }
  }, {
    "itemId": "d45c8691-1dac-442a-aa28-ff332cd27264",
    "url": "0d72ac_e3847b86efb540f38e949209d4cf84c2.jpg",
    "orderIndex": 1.453800287031E8,
    "metadata": {
      "name": "shutterstock_270787403.jpg",
      "size": 5681878,
      "lastModified": 1453800287000,
      "bg": { "0": 235, "1": 216, "2": 183, "3": 255 },
      "width": 4592,
      "height": 3062,
      "type": "image"
    }
  }, {
    "itemId": "0d4f98d0-9df3-4f4f-94d7-fab7e95a6d1a",
    "url": "0d72ac_92c8a0f7d5834e57849ec7741e2b08ec.jpg",
    "orderIndex": 1.45440648209E8,
    "metadata": {
      "name": "GettyImages-508273667.jpg",
      "size": 17276468,
      "lastModified": 1454406482000,
      "bg": { "0": 161, "1": 110, "2": 78, "3": 255 },
      "width": 7400,
      "height": 5772,
      "exif": {
        "ImageWidth": "10491",
        "ImageHeight": "7206",
        "BitsPerSample": "8,8,8",
        "Compression": "1",
        "PhotometricInterpretation": "2",
        "ImageDescription": "authentic mexican tacos with carnitas, cilantro and onion",
        "Make": "Hasselblad",
        "Model": "Hasselblad H4D-40",
        "Orientation": "top-left",
        "SamplesPerPixel": "3",
        "XResolution": "300",
        "YResolution": "300",
        "PlanarConfiguration": "1",
        "ResolutionUnit": "2",
        "Software": "Adobe Photoshop CS6 (Windows)",
        "DateTime": "2014:06:20 01:14:09",
        "ExposureTime": "30.007326007326007",
        "FNumber": "2",
        "ExifIFDPointer": "2474",
        "PhotographicSensitivity": "100",
        "ExifVersion": "0210",
        "DateTimeOriginal": "2014-06-19T21:51:29",
        "DateTimeDigitized": "2014-06-19T21:51:29",
        "ShutterSpeedValue": "-4.9072428569197655",
        "ApertureValue": "2",
        "MaxApertureValue": "2",
        "ColorSpace": "1",
        "PixelXDimension": "7400",
        "PixelYDimension": "5772"
      },
      "type": "image"
    }
  }, {
    "itemId": "75a0d5e5-34fd-4778-abc0-e5177dd5f200",
    "url": "0d72ac_ab7de48590834649b6162271b06c0519.jpg",
    "orderIndex": 1.454576600077E8,
    "metadata": {
      "name": "GettyImages-179595783.jpg",
      "size": 7807137,
      "lastModified": 1454576600000,
      "bg": { "0": 55, "1": 25, "2": 11, "3": 255 },
      "width": 4920,
      "height": 3693,
      "type": "image"
    }
  }, {
    "itemId": "5cbe6ab5-96ec-4939-bcbc-011f2589189b",
    "url": "0d72ac_b5dae0b94e53442b83428380d8b6289e.jpg",
    "orderIndex": 1.454859346067E8,
    "metadata": {
      "name": "147501913.jpg",
      "size": 5236230,
      "lastModified": 1454859346000,
      "bg": { "0": 234, "1": 225, "2": 182, "3": 255 },
      "width": 4106,
      "height": 2736,
      "type": "image"
    }
  }, {
    "itemId": "3a1b1925-64d5-4a59-8c68-6c79e7598df6",
    "url": "0d72ac_d4bd6ac424ad444aa7681617373f867e.jpg",
    "orderIndex": 1.454859527018E8,
    "metadata": {
      "name": "538311807.jpg",
      "size": 14801375,
      "lastModified": 1454859527000,
      "bg": { "0": 237, "1": 233, "2": 215, "3": 255 },
      "width": 5500,
      "height": 3667,
      "type": "image"
    }
  }, {
    "itemId": "379f7728-2ee0-4c0a-8e9c-1db8c42659c4",
    "url": "0d72ac_7ecf86dfad94446bbf5ba04569982ae4.jpg",
    "orderIndex": 1.454929527065E8,
    "metadata": {
      "name": "GettyImages-93337280.jpg",
      "size": 6623523,
      "lastModified": 1454929527000,
      "bg": { "0": 12, "1": 50, "2": 62, "3": 255 },
      "width": 4368,
      "height": 2912,
      "type": "image"
    }
  }, {
    "itemId": "293f7de7-4542-4a99-8f6c-a166be8138d6",
    "url": "0d72ac_d9302812a5094966ba577f1830b1547b.jpg",
    "orderIndex": 1.454946595011E8,
    "metadata": {
      "name": "Glasses of Water.jpg",
      "size": 1280955,
      "lastModified": 1454946595000,
      "bg": { "0": 186, "1": 204, "2": 205, "3": 255 },
      "width": 2048,
      "height": 1536,
      "exif": {
        "ImageWidth": "2048",
        "ImageHeight": "1536",
        "BitsPerSample": "8,8,8",
        "PhotometricInterpretation": "2",
        "ImageDescription": "Drinking Glasses On Wooden Table",
        "Make": "OLYMPUS IMAGING CORP.  ",
        "Model": "E-M1            ",
        "Orientation": "top-left",
        "SamplesPerPixel": "3",
        "XResolution": "70",
        "YResolution": "70",
        "ResolutionUnit": "2",
        "Software": "Adobe Photoshop CC 2015 (Macintosh)",
        "DateTime": "2016:02:08 17:49:44",
        "Artist": "Nawarit Rittiyotee / EyeEm",
        "JPEGInterchangeFormat": "310",
        "JPEGInterchangeFormatLength": "0",
        "ExposureTime": "0.0008",
        "FNumber": "2.8",
        "ExifIFDPointer": "508",
        "PhotographicSensitivity": "400",
        "ExifVersion": "0221",
        "ShutterSpeedValue": "10.287712",
        "ApertureValue": "2.970854",
        "LightSource": "Unknown",
        "Flash": "Flash did not fire, auto mode",
        "FocalLength": "40",
        "ColorSpace": "65535",
        "PixelXDimension": "2048",
        "PixelYDimension": "1536",
        "WhiteBalance": "Auto white balance"
      },
      "type": "image"
    }
  }, {
    "itemId": "193e57e7-33ea-47bf-9464-5f3a69dabf07",
    "url": "0d72ac_fa01bca4c3764ac69e0fb23a8fd30723.jpg",
    "orderIndex": 1.455003597015E8,
    "metadata": {
      "name": "GettyImages-459776887.jpg",
      "size": 6623496,
      "lastModified": 1455003597000,
      "bg": { "0": 180, "1": 193, "2": 203, "3": 255 },
      "width": 3600,
      "height": 2697,
      "type": "image"
    }
  }, {
    "itemId": "7244770b-1001-4d74-a71b-01f93ceac4cf",
    "url": "0d72ac_d7a832e091b243c7bd50b9cefb18b9c6.jpg",
    "orderIndex": 1.455010006026E8,
    "metadata": {
      "name": "GettyImages-564727099.jpg",
      "size": 3798175,
      "lastModified": 1455010006000,
      "bg": { "0": 203, "1": 207, "2": 202, "3": 255 },
      "width": 5600,
      "height": 3733,
      "type": "image"
    }
  }, {
    "itemId": "e6e6685e-4247-463f-9f50-1fce78f7ed35",
    "url": "0d72ac_f7c8606f692c412dbe2a8233e596cf42.jpg",
    "orderIndex": 1.455018304009E8,
    "metadata": {
      "name": "GettyImages-538685817.jpg",
      "size": 2076052,
      "lastModified": 1455018304000,
      "bg": { "0": 193, "1": 175, "2": 159, "3": 255 },
      "width": 2400,
      "height": 1600,
      "exif": {},
      "type": "image"
    }
  }, {
    "itemId": "0f304adb-5425-4c6c-9776-ff4cc4882f3f",
    "url": "0d72ac_ce5b91e14b2d4c7da4e5b72245637894.jpg",
    "orderIndex": 1.455018806099E8,
    "metadata": {
      "name": "GettyImages-139266432.jpg",
      "size": 4887819,
      "lastModified": 1455018806000,
      "bg": { "0": 207, "1": 134, "2": 81, "3": 255 },
      "width": 5200,
      "height": 3467,
      "type": "image"
    }
  }, {
    "itemId": "6a0aba18-a25a-404d-aa52-8743c3478a4d",
    "url": "0d72ac_c4296d9f416141a6b2f302b31d9d4f6e.jpg",
    "orderIndex": 1.4550236860639998E8,
    "metadata": {
      "name": "GettyImages-459161857.jpg",
      "size": 7622220,
      "lastModified": 1455023686000,
      "bg": { "0": 30, "1": 20, "2": 17, "3": 255 },
      "width": 5616,
      "height": 3744,
      "type": "image"
    }
  }, {
    "itemId": "6c1f35c4-9a8a-4512-a835-cfd5315af900",
    "url": "0d72ac_210ecd9771404cd0bd21a6d3356d8379.jpg",
    "orderIndex": 1.4551132180760002E8,
    "metadata": {
      "name": "GettyImages-120298351.jpg",
      "size": 5271175,
      "lastModified": 1455113218000,
      "bg": { "0": 145, "1": 152, "2": 151, "3": 255 },
      "width": 5320,
      "height": 3540,
      "type": "image"
    }
  }, {
    "itemId": "6d1ae3f7-c0da-4da9-82ec-895e9e5a145e",
    "url": "0d72ac_0c607021e75f44dbb74b941805c48b33.jpg",
    "orderIndex": 1.455211551039E8,
    "metadata": {
      "name": "GettyImages-459151653.jpg",
      "size": 14280239,
      "lastModified": 1455211551000,
      "bg": { "0": 238, "1": 242, "2": 237, "3": 255 },
      "width": 5760,
      "height": 3840,
      "type": "image"
    }
  }, {
    "itemId": "30860968-6f85-473b-893d-9af3f0f81e93",
    "url": "0d72ac_0d4fd11a3ce7471c9013a3e4a317641a",
    "orderIndex": 1.4554456380150002E8,
    "metadata": {
      "name": "Chocolate-Truffles.cms.mp4",
      "size": 21004591,
      "lastModified": 1455445638000,
      "bg": { "0": 21, "1": 9, "2": 9, "3": 255 },
      "width": 1920,
      "height": 1080,
      "type": "video",
      "posters": [{
        "url": "0d72ac_0d4fd11a3ce7471c9013a3e4a317641af000.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_0d4fd11a3ce7471c9013a3e4a317641af001.jpg",
        "height": 1080,
        "width": 1920
      }, {
        "url": "0d72ac_0d4fd11a3ce7471c9013a3e4a317641af002.jpg",
        "height": 1080,
        "width": 1920
      }, { "url": "0d72ac_0d4fd11a3ce7471c9013a3e4a317641af003.jpg", "height": 1080, "width": 1920 }],
      "duration": 14080,
      "qualities": [{
        "formats": ["mp4", "webm"],
        "height": 480,
        "quality": "480p",
        "width": 854
      }, { "formats": ["mp4", "webm"], "height": 720, "quality": "720p", "width": 1280 }, {
        "formats": ["mp4", "webm"],
        "height": 1080,
        "quality": "1080p",
        "width": 1920
      }]
    }
  }, {
    "itemId": "626b561b-cb93-4383-9c77-b63684b2520c",
    "url": "0d72ac_23d2a8c16ea84562a4c48e7ee0346e84.jpg",
    "orderIndex": 1.456132758054E8,
    "metadata": {
      "name": "GettyImages-187166773.jpg",
      "size": 14683743,
      "lastModified": 1456132758000,
      "bg": { "0": 215, "1": 205, "2": 197, "3": 255 },
      "width": 5395,
      "height": 3597,
      "type": "image"
    }
  }, {
    "itemId": "672c4402-c47c-4a79-89d7-c5775d477d0f",
    "url": "0d72ac_34a9581290bf40548645182194ab6ce8.jpg",
    "orderIndex": 1.4561328470099998E8,
    "metadata": {
      "name": "GettyImages-459151499.jpg",
      "size": 14903022,
      "lastModified": 1456132847000,
      "bg": { "0": 71, "1": 67, "2": 27, "3": 255 },
      "width": 5760,
      "height": 3840,
      "type": "image"
    }
  }, {
    "itemId": "cbfc0a84-337d-4e5a-ba70-e7fef1a2e73b",
    "url": "0d72ac_9763a6e34d4b4379be3bdff142c6462f.jpg",
    "orderIndex": 1.4563190770279998E8,
    "metadata": {
      "name": "GettyImages-152831480.jpg",
      "size": 5645463,
      "lastModified": 1456319077000,
      "bg": { "0": 188, "1": 108, "2": 53, "3": 255 },
      "width": 5616,
      "height": 3744,
      "exif": {
        "ImageWidth": "5616",
        "ImageHeight": "3744",
        "BitsPerSample": "8,8,8",
        "PhotometricInterpretation": "2",
        "ImageDescription": "Chef carrying tray of bread in kitchen",
        "Orientation": "top-left",
        "SamplesPerPixel": "3",
        "XResolution": "72",
        "YResolution": "72",
        "ResolutionUnit": "2",
        "Software": "Adobe Photoshop CC 2015 (Macintosh)",
        "DateTime": "2016:02:24 15:04:03",
        "Artist": "227904",
        "ExifIFDPointer": "308",
        "ExifVersion": "0221",
        "ColorSpace": "65535",
        "PixelXDimension": "5616",
        "PixelYDimension": "3744"
      },
      "type": "image"
    }
  }, {
    "itemId": "efd8e7a2-05c1-407b-91a3-aafbcb8f0da3",
    "url": "0d72ac_edb72be5e6584e3db39d8d638c4a8768.jpg",
    "orderIndex": 1.456319125001E8,
    "metadata": {
      "name": "GettyImages-110054957.jpg",
      "size": 11220632,
      "lastModified": 1456319125000,
      "bg": { "0": 213, "1": 210, "2": 198, "3": 255 },
      "width": 3346,
      "height": 5019,
      "exif": {
        "ImageWidth": "3346",
        "ImageHeight": "5019",
        "BitsPerSample": "8,8,8",
        "PhotometricInterpretation": "2",
        "ImageDescription": "Racks of freshly baked bread",
        "Orientation": "top-left",
        "SamplesPerPixel": "3",
        "XResolution": "72",
        "YResolution": "72",
        "ResolutionUnit": "2",
        "Software": "Adobe Photoshop CC 2015 (Macintosh)",
        "DateTime": "2016:02:24 15:04:52",
        "Artist": "Patrick Strattner",
        "ExifIFDPointer": "308",
        "ExifVersion": "0221",
        "ColorSpace": "65535",
        "PixelXDimension": "3346",
        "PixelYDimension": "5019"
      },
      "type": "image"
    }
  }, {
    "itemId": "38994774-d6fd-4982-9f7d-3e434de82c42",
    "url": "0d72ac_ee94c15620a24b4f8c440f32bdb40a0a.jpg",
    "orderIndex": 1.456319181052E8,
    "metadata": {
      "name": "GettyImages-500097535.jpg",
      "size": 6268783,
      "lastModified": 1456319181000,
      "bg": { "0": 129, "1": 109, "2": 82, "3": 255 },
      "width": 3656,
      "height": 5485,
      "exif": {
        "ImageWidth": "3656",
        "ImageHeight": "5485",
        "BitsPerSample": "8,8,8",
        "PhotometricInterpretation": "2",
        "ImageDescription": "Iced coffee with sweet condensed milk",
        "Orientation": "top-left",
        "SamplesPerPixel": "3",
        "XResolution": "72",
        "YResolution": "72",
        "ResolutionUnit": "2",
        "Software": "Adobe Photoshop CC 2015 (Macintosh)",
        "DateTime": "2016:02:24 15:05:48",
        "Artist": "Westend61",
        "ExifIFDPointer": "308",
        "ExifVersion": "0221",
        "ColorSpace": "65535",
        "PixelXDimension": "3656",
        "PixelYDimension": "5485"
      },
      "type": "image"
    }
  }],
  "orderIndex": 1.456827268895E8,
  "setType": "original_set",
  "settings": {
    "filesFolders": {
      "picture": "f0c2337fde1545fd9c8b50fec711cab7",
      "video": "bfe9605b058d489f8fd2855fc2da45a6"
    }
  },
  "photosCount": 0
};

var allTexts = [{
  metadata: {
    height: 200,
    lastModified: 1445852211,
    name: "3337a427b2e877ab39bf116fcb3f01ei",
    width: 300,
    "type": "text",
    backgroundColor: 'pink'
  },
  orderIndex: 53,
  itemId: "3337a427b2e877ab39bf116fcb3f01ei",
  html: "<div style='width: 300px; height: 200px; background:pink; font-family: Arial; padding: 32px; box-sizing: border-box;'><h1 style='font-size: 30px; line-height: 1.5; padding: 0; margin: 0; font-weight: bold;'>I am a text block</h1><p style='font-size: 17px; line-height: 1.5; padding: 0; margin: 0;'>Look how beautiful I am, love me, adore me, this is not the text block you see every day.</p></div>"
}];

var designedItems = {
  "setId": "8e8c74c5-53a3-4490-b87c-635a76616013",
  "name": "Sample Photos",
  "photos": [{
    "itemId": "b73de8b7-f01b-4410-b6fb-3fe0118f13e9",
    "mediaUrl": "1359d0df7c934f6e94a34a29ff4f599d.jpg",
    "orderIndex": 1463480494.628,
    "metaData": {
      "height": 1280,
      "width": 1920,
      "lastModified": 1463489494629,
      "name": "Mountain Lake",
      "link": {
        "url": getTranslation('Gallery_Item_DefaultLink_Label'),
        "text": getTranslation('Gallery_Item_DefaultLink_Label'),
        "type": "none",
        "target": "self"
      },
      "title": getTranslation('Gallery_Item_DefaultTitle_Long_Label'),
      "description": getTranslation('Gallery_Item_DefaultDescription_Long_Label')
      // },{
      //   "itemId": "b11de8b7-f01b-4410-b6fb-3fe0111f1339",
      //   "mediaUrl": "kuku.jpg",
      //   "orderIndex": 1463480494.628,
      //   "metaData": {
      //     "type": "youtube",
      //     "height": 720,
      //     "width": 1280,
      //     "lastModified": 1463489494639,
      //     "name": "My youtube item",
      //     "link": {"url": getTranslation('Gallery_Item_DefaultLink_Label'), "text":getTranslation('Gallery_Item_DefaultLink_Label'),"type": "none", "target": "self"},
      //     "title": getTranslation('Gallery_Item_DefaultTitle_Long_Label'),
      //     "description": getTranslation('Gallery_Item_DefaultDescription_Long_Label'),
      //     "videoId": "-wzeBUrPZ8A",
      //   }
      // }, {
    } }, {
    "itemId": "iNJdPyoqt8U",
    "mediaUrl": "https://img.youtube.com/vi/-aGJ30xMdFU/maxresdefault.jpg",
    "orderIndex": -1481036065.458,
    "metaData": {
      "name": "iNJdPyoqt8U",
      "lastModified": 1481036065458,
      "title": "Sample Youtube HD Video",
      "height": 1080,
      "width": 1920,
      "type": "video",
      "isExternal": true,
      "source": "youtube",
      "videoUrl": "https://youtu.be/iNJdPyoqt8U",
      "posters": [{ "url": "https://img.youtube.com/vi/iNJdPyoqt8U/maxresdefault.jpg", "height": 1080, "width": 1920 }],
      "link": {
        "type": "none",
        "target": "_blank"
      }
    }
  }, {
    "itemId": "26569110",
    "mediaUrl": "https://i.vimeocdn.com/video/176124102_1920x1080.webp",
    "orderIndex": -1481036065.458,
    "metaData": {
      "name": "26569110",
      "lastModified": 1481036065458,
      "title": "Sample Vimeo HD Video",
      "height": 1080,
      "width": 1920,
      "type": "video",
      "isExternal": true,
      "source": "vimeo",
      "videoUrl": "https://vimeo.com/26569110",
      "posters": [{ "url": "https://i.vimeocdn.com/video/176124102_1920x1080.webp", "height": 1080, "width": 1920 }],
      "link": {
        "type": "none",
        "target": "_blank"
      }
    }
  }, {
    "itemId": "a723f78d-ece5-41ac-9cf8-98c5bf83c42b",
    "mediaUrl": "157553_f8b3fc2cfea44748b673929e6ee8dea4",
    "orderIndex": 1463482494.628,
    "metaData": {
      "name": "Sunlight-on-the-Sea.cms.mp4",
      "lastModified": 1463490358936,
      "width": 1920,
      "height": 1080,
      "type": "video",
      "posters": [{
        "url": "157553_f8b3fc2cfea44748b673929e6ee8dea4f000.jpg",
        "width": 1920,
        "height": 1080
      }, {
        "url": "157553_f8b3fc2cfea44748b673929e6ee8dea4f001.jpg",
        "width": 1920,
        "height": 1080
      }, {
        "url": "157553_f8b3fc2cfea44748b673929e6ee8dea4f002.jpg",
        "width": 1920,
        "height": 1080
      }, { "url": "157553_f8b3fc2cfea44748b673929e6ee8dea4f003.jpg", "width": 1920, "height": 1080 }],
      "duration": 26133,
      "qualities": [{ "height": 480, "width": 854, "quality": "480p", "formats": ["mp4"] }, {
        "height": 720,
        "width": 1280,
        "quality": "720p",
        "formats": ["mp4"]
      }, { "height": 1080, "width": 1920, "quality": "1080p", "formats": ["mp4"] }],
      "title": getTranslation('Gallery_Item_DefaultTitle_Short_Label'),
      "description": getTranslation('Gallery_Item_DefaultDescription_Short_Label'),
      "link": { "url": getTranslation('Gallery_Item_DefaultLink_Label'), "text": getTranslation('Gallery_NewExpand_Item_Link_Label'), "type": "none", "target": "self" }
    }
  }, {
    "itemId": "6576a2f0-c8ca-4f06-b45a-f19ac85bc2a1",
    "mediaUrl": "c3adb8201ae64fa1bef80353d419840a.jpg",
    "orderIndex": 1463485369.628,
    "metaData": {
      "height": 1922,
      "width": 1920,
      "lastModified": 1463489494628,
      "name": "Beach Hut",
      "title": getTranslation('Gallery_Item_DefaultTitle_Long_Label'),
      "description": getTranslation('Gallery_Item_DefaultDescription_Short_Label'),
      "link": { "url": getTranslation('Gallery_Item_DefaultLink_Label'), "text": getTranslation('Gallery_Item_DefaultLink_Label'), "type": "none", "target": "self" }
    }
  }, {
    "itemId": "eefe19bb-6c82-45f6-b10e-42927173eef7",
    "mediaUrl": "3cd1de924697419088c1e033bb3384ef.jpg",
    "orderIndex": 1463488338.378,
    "metaData": {
      "height": 1280,
      "width": 1920,
      "lastModified": 1463489494629,
      "name": "Palm Trees",
      "title": getTranslation('Gallery_Item_DefaultTitle_Short_Label'),
      "description": getTranslation('Gallery_Item_DefaultDescription_Long_Label'),
      "link": { "url": getTranslation('Gallery_Item_DefaultLink_Label'), "text": getTranslation('Gallery_Item_DefaultLink_Label'), "type": "none", "target": "self" }
    }
  }, {
    "itemId": "8c8c5079-4af1-418e-975b-619d0bacf3ae",
    "mediaUrl": "",
    "orderIndex": 1463488344.237375,
    "metaData": {
      "height": 330,
      "width": 420,
      "lastModified": 1463496899566,
      "name": "8c8e7a82-1d65-4365-882b-577901b8bc7f",
      "type": "text",
      "title": getTranslation('Gallery_Item_DefaultTitle_Long_Label'),
      "description": getTranslation('Gallery_Item_DefaultDescription_Long_Label'),
      "link": { "url": getTranslation('Gallery_Item_DefaultLink_Label'), "text": getTranslation('Gallery_Item_DefaultLink_Label'), "type": "none", "target": "self" },
      "textStyle": {
        "height": 330,
        "width": 420,
        "padding": 30,
        "backgroundColor": "rgba(100, 154, 181, 0.85)",
        "canvasLayout": "horizontal",
        "textVerticalAlignment": "top"
      },
      "editorHtml": "<p style=\"font-size:40px; line-height:1.2\"><span style=\"font-size:40px\"><span style=\"font-family:raleway\"><span style=\"color:#FFFFFF\">Personalize your gallery, add your text here.</span></span></span></p>",
      "html": "<link href='https://fonts.googleapis.com/css?family=Raleway' rel='stylesheet' type='text/css'><div style=\"padding: 30px; width: 420px; height: 330px; background-color: rgba(100, 154, 181, 0.85); transform-style: preserve-3d; overflow: hidden;\">  <div style=\"position: relative; top: 0%; transform: translateY(0%);\"> <p style=\"font-size:40px; line-height:1.2\"><span style=\"font-size:40px\"><span style=\"font-family:raleway\"><span style=\"color:#FFFFFF\">Personalize your gallery, add your text here.</span></span></span></p> </div> </div>"
    }
  }, {
    "itemId": "4935ae3d-7da9-415c-86f0-09d8bc18039c",
    "mediaUrl": "157553_3d106bdeb49f4cfe8189587b3f57fbf5~mv1.jpg",
    "orderIndex": 1463488350.09675,
    "metaData": {
      "height": 700,
      "width": 1050,
      "lastModified": 1463489500435,
      "name": "a9ff3b_7125cf82b18841c2961ce0a241b78826.jpg",
      "title": getTranslation('Gallery_Item_DefaultTitle_Long_Label'),
      "description": getTranslation('Gallery_Item_DefaultDescription_Long_Label'),
      "link": { "url": getTranslation('Gallery_Item_DefaultLink_Label'), "text": getTranslation('Gallery_Item_DefaultLink_Label'), "type": "none", "target": "self" }
    }
  }, {
    "itemId": "0385d7ec-1b6a-4fa2-9466-e9d524d8a730",
    "mediaUrl": "99ec98fdb81945c29c25a3ad6c5606b1.jpg",
    "orderIndex": 1463488385.253,
    "metaData": {
      "height": 1280,
      "width": 1920,
      "lastModified": 1463489494629,
      "name": "Misty Slopes",
      "title": getTranslation('Gallery_Item_DefaultTitle_Short_Label'),
      "description": getTranslation('Gallery_Item_DefaultDescription_Short_Label'),
      "link": { "url": getTranslation('Gallery_Item_DefaultLink_Label'), "text": getTranslation('Gallery_Item_DefaultLink_Label'), "type": "none", "target": "self" }
    }
  }, {
    "itemId": "8e8387fb-2648-4c2a-a868-25b544e5204c",
    "mediaUrl": "57f4afdda0984f34bb43cec022bda1ec.jpg",
    "orderIndex": 1463488432.128,
    "metaData": {
      "height": 1280,
      "width": 1920,
      "lastModified": 1463489494629,
      "name": "City Cycle",
      "title": getTranslation('Gallery_Item_DefaultTitle_Long_Label'),
      "description": getTranslation('Gallery_Item_DefaultDescription_Long_Label'),
      "link": { "url": getTranslation('Gallery_Item_DefaultLink_Label'), "text": getTranslation('Gallery_Item_DefaultLink_Label'), "type": "none", "target": "self" }
    }
  }, {
    "itemId": "c7dc93a6-c8e0-4189-8c35-24744bc387b7",
    "mediaUrl": "164d15b9398c436dad4c43707e57dd4e.jpg",
    "orderIndex": 1463488994.6287498,
    "metaData": {
      "height": 1280,
      "width": 1920,
      "lastModified": 1463489494629,
      "name": "Fire Wood",
      "title": getTranslation('Gallery_Item_DefaultTitle_Short_Label'),
      "description": getTranslation('Gallery_Item_DefaultDescription_Long_Label'),
      "link": { "url": getTranslation('Gallery_Item_DefaultLink_Label'), "text": getTranslation('Gallery_Item_DefaultLink_Label'), "type": "none", "target": "self" }
    }
  }, {
    "itemId": "df3f6397-e169-4c28-bddb-cec36cb89834",
    "mediaUrl": "5a47467975164707be86bfeac844e3a2.jpg",
    "orderIndex": 1463489244.6291249,
    "metaData": {
      "height": 1920,
      "width": 1920,
      "lastModified": 1463489494629,
      "name": "Foggy Pier",
      "title": getTranslation('Gallery_Item_DefaultTitle_Long_Label'),
      "description": getTranslation('Gallery_Item_DefaultDescription_Short_Label'),
      "link": { "url": getTranslation('Gallery_Item_DefaultLink_Label'), "text": getTranslation('Gallery_Item_DefaultLink_Label'), "type": "none", "target": "self" }
    }
  }, {
    "itemId": "77551414-3539-47a8-a78e-df4d4e99009c",
    "mediaUrl": "dfcb76e4ef454dab8990a6d7f97bd8d8.jpg",
    "orderIndex": 1463489369.6293125,
    "metaData": {
      "height": 3744,
      "width": 3744,
      "lastModified": 1463489494629,
      "name": "Outdoor Chairs",
      "title": getTranslation('Gallery_Item_DefaultTitle_Short_Label'),
      "description": getTranslation('Gallery_Item_DefaultDescription_Long_Label'),
      "link": { "url": getTranslation('Gallery_Item_DefaultLink_Label'), "text": getTranslation('Gallery_Item_DefaultLink_Label'), "type": "none", "target": "self" }
    }
  }]
};

var emptyItems = {
  "setId": "8e8c74c5-53a3-4490-b87c-635a76616013",
  "name": "Empty Photos",
  "photos": [{
    "itemId": "b73de8b7-f01b-4410-b6fb-3fe0118f13e9",
    "mediaUrl": "8bb438_5e7dfbbf8e8f460e953674e6e2d307f7~mv2.jpg",
    "orderIndex": 1463480494.628,
    "metaData": {
      "height": 10,
      "width": 10,
      "lastModified": 1463489494629,
      "name": "Loading"
    }
  }, {
    "itemId": "b73de8b7-f01b-4410-b6fb-3fe0118f13e8",
    "mediaUrl": "8bb438_5e7dfbbf8e8f460e953674e6e2d307f7~mv2.jpg",
    "orderIndex": 1463480494.628,
    "metaData": {
      "height": 10,
      "width": 10,
      "lastModified": 1463489494629,
      "name": "Loading"
    }
  }, {
    "itemId": "b73de8b7-f01b-4410-b6fb-3fe0118f13e7",
    "mediaUrl": "8bb438_5e7dfbbf8e8f460e953674e6e2d307f7~mv2.jpg",
    "orderIndex": 1463480494.628,
    "metaData": {
      "height": 10,
      "width": 10,
      "lastModified": 1463489494629,
      "name": "Loading"
    }
  }, {
    "itemId": "b73de8b7-f01b-4410-b6fb-3fe0118f13e6",
    "mediaUrl": "8bb438_5e7dfbbf8e8f460e953674e6e2d307f7~mv2.jpg",
    "orderIndex": 1463480494.628,
    "metaData": {
      "height": 10,
      "width": 10,
      "lastModified": 1463489494629,
      "name": "Loading"
    }
  }, {
    "itemId": "b73de8b7-f01b-4410-b6fb-3fe0118f13e5",
    "mediaUrl": "8bb438_5e7dfbbf8e8f460e953674e6e2d307f7~mv2.jpg",
    "orderIndex": 1463480494.628,
    "metaData": {
      "height": 10,
      "width": 10,
      "lastModified": 1463489494629,
      "name": "Loading"
    }
  }, {
    "itemId": "b73de8b7-f01b-4410-b6fb-3fe0118f13e4",
    "mediaUrl": "8bb438_5e7dfbbf8e8f460e953674e6e2d307f7~mv2.jpg",
    "orderIndex": 1463480494.628,
    "metaData": {
      "height": 10,
      "width": 10,
      "lastModified": 1463489494629,
      "name": "Loading"
    }
  }, {
    "itemId": "b73de8b7-f01b-4410-b6fb-3fe0118f13e3",
    "mediaUrl": "8bb438_5e7dfbbf8e8f460e953674e6e2d307f7~mv2.jpg",
    "orderIndex": 1463480494.628,
    "metaData": {
      "height": 10,
      "width": 10,
      "lastModified": 1463489494629,
      "name": "Loading"
    }
  }, {
    "itemId": "b73de8b7-f01b-4410-b6fb-3fe0118f13e2",
    "mediaUrl": "8bb438_5e7dfbbf8e8f460e953674e6e2d307f7~mv2.jpg",
    "orderIndex": 1463480494.628,
    "metaData": {
      "height": 10,
      "width": 10,
      "lastModified": 1463489494629,
      "name": "Loading"
    }
  }, {
    "itemId": "b73de8b7-f01b-4410-b6fb-3fe0118f13e1",
    "mediaUrl": "8bb438_5e7dfbbf8e8f460e953674e6e2d307f7~mv2.jpg",
    "orderIndex": 1463480494.628,
    "metaData": {
      "height": 10,
      "width": 10,
      "lastModified": 1463489494629,
      "name": "Loading"
    }
  }, {
    "itemId": "b73de8b7-f01b-4410-b6fb-3fe0118f13e0",
    "mediaUrl": "8bb438_5e7dfbbf8e8f460e953674e6e2d307f7~mv2.jpg",
    "orderIndex": 1463480494.628,
    "metaData": {
      "height": 10,
      "width": 10,
      "lastModified": 1463489494629,
      "name": "Loading"
    }
  }]
};

function getTranslation(str) {
  if (window.translations) return window.translations[str];else return '';
}
//var allInner = allImages.photos.concat(allVideos.photos);
//var allItems = allImages;
//allItems.photos = allInner;

var emptyImages, sampleImages, allItems;
var sampleSize = parseGetParam('sampleSize');
var isStore = parseGetParam('isStore');

if (sampleSize) {

  if (isStore) {
    allItems = storeSampleImages;
  } else {
    allItems = allFood;
    allItems.photos = allItems.photos.concat(allTexts);
  }
  var numOfImages = Number(sampleSize);
  if (!(numOfImages > 0)) {
    numOfImages = 1000;
  }

  if (_) {
    var photos = [];
    for (var ii = 0; ii < numOfImages; ii++) {
      var item = _.clone(_.sample(allItems.photos));

      var uniqueUUID = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });

      item.orderIndex = ii;
      item.itemId = uniqueUUID;
      item.metadata.isDemo = true;
      item.key = ii + '_sample_photo';

      photos.push(item);
    }

    allItems.photos = photos;
    console.log('Generated sample items', photos.length);
  }
} else {
  if (isStore) {
    allItems = storeSampleImages;
  } else {
    allItems = designedItems;
  }
  var photos = [];
  for (var ii = 0; ii < allItems.photos.length; ii++) {
    var item = _.clone(allItems.photos[ii]);

    item.metaData.isDemo = true;
    item.key = ii + '_sample_photo';

    photos.push(item);
  }
  allItems.photos = photos;
}

if (window) {
  exports.sampleImages = sampleImages = window['sampleImages'] = allItems;
  exports.emptyImages = emptyImages = window['emptyImages'] = sampleSize > 0 ? allItems : emptyItems;
} else {
  exports.sampleImages = sampleImages = allItems;
  exports.emptyImages = emptyImages = emptyItems;
}

function parseGetParam(val) {
  var result = '',
      tmp = [];
  location.search
  //.replace ( "?", "" )
  // this is better, there might be a question mark inside
  .substr(1).split('&').forEach(function (item) {
    tmp = item.split('=');
    if (tmp[0] === val) {
      result = decodeURIComponent(tmp[1]);
    }
  });
  return result;
}

var sampleImages = exports.sampleImages = undefined;
var emptyImages = exports.emptyImages = undefined;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(2);

var _itemActions = __webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoveButton = function (_React$Component) {
  _inherits(LoveButton, _React$Component);

  function LoveButton(props) {
    _classCallCheck(this, LoveButton);

    var _this = _possibleConstructorReturn(this, (LoveButton.__proto__ || Object.getPrototypeOf(LoveButton)).call(this, props));

    _this.toggleLove = _this.toggleLove.bind(_this);
    _this.state = {
      animate: false
    };
    return _this;
  }

  _createClass(LoveButton, [{
    key: 'toggleLove',
    value: function toggleLove(e) {
      e.stopPropagation();
      this.props.toggleLove();
      this.setState({
        animate: this.props.isLoved ? false : true
      });
    }
  }, {
    key: 'isLovedClassName',
    value: function isLovedClassName() {
      return "progallery-svg-font-icons-" + (this.props.isLoved ? "love_full loved" : "love_empty");
    }
  }, {
    key: 'animatedClassName',
    value: function animatedClassName() {
      return this.state.animate ? ' love-animation' : ' ';
    }
  }, {
    key: 'containerClassName',
    value: function containerClassName() {
      return this.props.layout == 'fullscreen' ? '' : 'block-fullscreen gallery-item-social-love gallery-item-social-button';
    }
  }, {
    key: 'buttonClassName',
    value: function buttonClassName() {
      return (this.props.layout == 'fullscreen' ? 'fullscreen-social-love' : 'gallery-item-social-love') + (_utils.utils.isStoreGallery() ? _utils.utils.isMobile ? ' mobile-social-icon' : '' : this.props.layout == 'fullscreen' ? '' : ' block-fullscreen');
    }
  }, {
    key: 'counterClassName',
    value: function counterClassName() {
      return this.props.layout == 'fullscreen' ? 'fullscreen-social-love-count shown' : 'block-fullscreen gallery-item-social-love-count';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          layout = _props.layout,
          device = _props.device;


      var loveButtonClassName = [this.buttonClassName(), _itemActions.itemActions.viewClassName(layout, device), this.isLovedClassName(), this.animatedClassName()].join(' ');
      var counterClassName = [this.counterClassName(), _itemActions.itemActions.viewClassName(layout, device)].join(' ');

      var loveCounter = this.props.showCounter && this.props.count > 0 ? _react2.default.createElement(
        'i',
        {
          'data-hook': 'love-counter',
          style: this.props.counterStyle,
          className: counterClassName },
        this.props.count
      ) : '';

      var loveButton = _react2.default.createElement('button', {
        'data-hook': 'love-icon',
        className: loveButtonClassName,
        title: this.props.count,
        style: this.props.style,
        tabIndex: _utils.utils.getTabIndex(this.props.layout + 'Love'),
        'aria-label': (this.props.isLoved ? 'Unlike' : 'Like') + (', ' + this.props.count),
        'aria-checked': (!!this.props.isLoved).toString(),
        role: 'checkbox'
      });

      var clickAction = _utils.utils.getMobileEnabledClick(this.toggleLove);

      return _react2.default.createElement(
        'div',
        _extends({ 'data-hook': 'love-button',
          className: this.containerClassName() + ' show-tooltip ',
          onMouseOver: function onMouseOver(e) {
            if (_this2.props.isSettings) {
              _itemActions.itemActions.showTooltip(e, 'This option is not available in editor');
            }
          },
          onMouseOut: function onMouseOut() {
            if (_this2.props.isSettings) {
              _itemActions.itemActions.hideTooltip();
            }
          }
        }, clickAction),
        loveButton,
        loveCounter
      );
    }
  }]);

  return LoveButton;
}(_react2.default.Component);

exports.default = LoveButton;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var FrameStorageListener = __webpack_require__(69);
var LocalStorageStrategy = __webpack_require__(23);
var FrameStorageStrategy = __webpack_require__(71);
var WixStorageStrategy = __webpack_require__(72);
var CachedStorageStrategy = __webpack_require__(91);

var _require = __webpack_require__(7),
    NOT_FOUND = _require.NOT_FOUND;

var BaseStorage = __webpack_require__(6);
var DataCapsule = __webpack_require__(92);

function LocalStorageCapsule(options) {
  return new DataCapsule(Object.assign({}, options, { strategy: new LocalStorageStrategy() }));
}

function LocalStorageCachedCapsule(options) {
  return new DataCapsule(Object.assign({}, options, {
    strategy: new CachedStorageStrategy({ remoteStrategy: options.remoteStrategy })
  }));
}

module.exports = {
  NOT_FOUND: NOT_FOUND,
  BaseStorage: BaseStorage,
  DataCapsule: DataCapsule,
  FrameStorageListener: FrameStorageListener,
  FrameStorageStrategy: FrameStorageStrategy,
  LocalStorageStrategy: LocalStorageStrategy,
  LocalStorageCapsule: LocalStorageCapsule,
  WixStorageStrategy: WixStorageStrategy,
  CachedStorageStrategy: CachedStorageStrategy,
  LocalStorageCachedCapsule: LocalStorageCachedCapsule
};
//# sourceMappingURL=index.js.map


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global window */


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var greedySplit = __webpack_require__(32);
var BaseStorage = __webpack_require__(6);

var _require = __webpack_require__(7),
    STORAGE_PREFIX = _require.STORAGE_PREFIX;

var LocalStorageStrategy = __webpack_require__(23);

var FrameStorageListener = function () {
  function FrameStorageListener() {
    var strategy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new LocalStorageStrategy();

    _classCallCheck(this, FrameStorageListener);

    this.storageStrategy = BaseStorage.verify(strategy);
  }

  _createClass(FrameStorageListener, [{
    key: 'start',
    value: function start(verifier) {
      var storageStrategy = BaseStorage.verify(this.storageStrategy);
      this._listener = function (e) {
        var _greedySplit = greedySplit(e.data, '|', 5),
            _greedySplit2 = _slicedToArray(_greedySplit, 5),
            target = _greedySplit2[0],
            token = _greedySplit2[1],
            id = _greedySplit2[2],
            method = _greedySplit2[3],
            params = _greedySplit2[4];

        var respond = function respond(method, param) {
          var message = [target + 'Done', token, id, method, JSON.stringify(param)].join('|');
          (e.source || window).postMessage(message, e.origin || '*');
        };

        if (target === STORAGE_PREFIX && verifier(e.source, e.origin, token)) {
          var invoke = storageStrategy[method].bind(storageStrategy);
          invoke.apply(undefined, _toConsumableArray(JSON.parse(params))).then(function (result) {
            respond('resolve', result);
          }).catch(function (reason) {
            respond('reject', reason.message || reason);
          });
        }
      };

      window.addEventListener('message', this._listener);
    }
  }, {
    key: 'stop',
    value: function stop() {
      window.removeEventListener('message', this._listener);
      this._listener = undefined;
    }
  }]);

  return FrameStorageListener;
}();

module.exports = FrameStorageListener;
//# sourceMappingURL=frame-storage-listener.js.map


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global localStorage */


var _require = __webpack_require__(33),
    getCacheRecords = _require.getCacheRecords,
    isExpired = _require.isExpired;

function deleteRecord(cleaner) {
  var record = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : cleaner.records[0];

  localStorage.removeItem(record.originalKey);
  return {
    records: record === cleaner.records[0] ? cleaner.records.slice(1) : cleaner.records.filter(function (_ref) {
      var originalKey = _ref.originalKey;
      return originalKey !== record.originalKey;
    }),
    requiredSpace: cleaner.requiredSpace - record.size
  };
}

function deleteExpired(cleaner) {
  var expiredRecords = cleaner.records.filter(function (record) {
    return isExpired(record);
  });
  expiredRecords.forEach(function (record) {
    return cleaner = deleteRecord(cleaner, record);
  });
  return cleaner;
}

function lastUsedSort(a, b) {
  return a.lastUsed - b.lastUsed;
}

function canClean(cleaner) {
  return cleaner.records.length > 0 && cleaner.requiredSpace > 0;
}

function deleteOld(cleaner) {
  cleaner.records.sort(lastUsedSort);
  while (canClean(cleaner)) {
    cleaner = deleteRecord(cleaner);
  }
  return cleaner;
}

function localStorageCleaner(requiredSpace) {
  var cleaner = { records: getCacheRecords(), requiredSpace: requiredSpace };
  cleaner = deleteExpired(cleaner);
  deleteOld(cleaner);
}

module.exports = localStorageCleaner;
//# sourceMappingURL=local-storage-cleaner.js.map


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global window */


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var greedySplit = __webpack_require__(32);
var BaseStorage = __webpack_require__(6);

var _require = __webpack_require__(7),
    STORAGE_PREFIX = _require.STORAGE_PREFIX,
    toError = _require.toError;

var pending = {};

function sendCommand(method, params, options) {
  var id = Date.now() + '-' + Math.random();
  var message = [STORAGE_PREFIX, options.token, id, method, JSON.stringify(params)].join('|');
  options.target.postMessage(message, options.origin);
  return new Promise(function (resolve, _reject) {
    pending[id] = { resolve: resolve, reject: function reject(reason) {
        return _reject(toError(reason));
      } };
  });
}

function readCommands(options) {
  window.addEventListener('message', function (e) {
    var _greedySplit = greedySplit(e.data, '|', 5),
        _greedySplit2 = _slicedToArray(_greedySplit, 5),
        target = _greedySplit2[0],
        token = _greedySplit2[1],
        id = _greedySplit2[2],
        method = _greedySplit2[3],
        params = _greedySplit2[4];

    if (target === STORAGE_PREFIX + 'Done' && token === options.token) {
      pending[id][method](params ? JSON.parse(params) : undefined);
      delete pending[id];
    }
  }, true);
}

var FrameStorageStrategy = function (_BaseStorage) {
  _inherits(FrameStorageStrategy, _BaseStorage);

  function FrameStorageStrategy(target, origin, token) {
    _classCallCheck(this, FrameStorageStrategy);

    var _this = _possibleConstructorReturn(this, (FrameStorageStrategy.__proto__ || Object.getPrototypeOf(FrameStorageStrategy)).call(this));

    _this._options = { target: target, origin: origin, token: token };
    readCommands(_this._options);
    return _this;
  }

  _createClass(FrameStorageStrategy, [{
    key: 'setItem',
    value: function setItem() {
      for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
        params[_key] = arguments[_key];
      }

      return sendCommand('setItem', params, this._options);
    }
  }, {
    key: 'getItem',
    value: function getItem() {
      for (var _len2 = arguments.length, params = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        params[_key2] = arguments[_key2];
      }

      return sendCommand('getItem', params, this._options);
    }
  }, {
    key: 'removeItem',
    value: function removeItem() {
      for (var _len3 = arguments.length, params = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        params[_key3] = arguments[_key3];
      }

      return sendCommand('removeItem', params, this._options);
    }
  }, {
    key: 'getAllItems',
    value: function getAllItems() {
      for (var _len4 = arguments.length, params = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        params[_key4] = arguments[_key4];
      }

      return sendCommand('getAllItems', params, this._options);
    }
  }]);

  return FrameStorageStrategy;
}(BaseStorage);

module.exports = FrameStorageStrategy;
//# sourceMappingURL=frame-storage.js.map


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var axios = __webpack_require__(73);
var BaseStorage = __webpack_require__(6);

var _require = __webpack_require__(7),
    NOT_FOUND = _require.NOT_FOUND,
    SERVER_ERROR = _require.SERVER_ERROR;

var WixStorageStrategy = function (_BaseStorage) {
  _inherits(WixStorageStrategy, _BaseStorage);

  function WixStorageStrategy() {
    _classCallCheck(this, WixStorageStrategy);

    return _possibleConstructorReturn(this, (WixStorageStrategy.__proto__ || Object.getPrototypeOf(WixStorageStrategy)).apply(this, arguments));
  }

  _createClass(WixStorageStrategy, [{
    key: 'setItem',
    value: function setItem(key, value, options) {
      var payload = {
        nameSpace: options.namespace,
        key: key,
        blob: value
      };
      if (options.scope && options.scope.siteId) {
        payload.siteId = options.scope.siteId;
      }
      if (options.expiration) {
        payload.TTLInDays = Math.ceil(options.expiration / (60 * 60 * 24));
      }
      return axios.post('/_api/wix-user-preferences-webapp/set', payload).then(function () {
        return undefined;
      }).catch(function () {
        throw SERVER_ERROR;
      });
    }
  }, {
    key: 'removeItem',
    value: function removeItem(key, options) {
      var payload = {
        nameSpace: options.namespace,
        key: key
      };
      if (options.scope && options.scope.siteId) {
        payload.siteId = options.scope.siteId;
      }
      return axios.post('/_api/wix-user-preferences-webapp/delete', payload).then(function () {
        return undefined;
      }).catch(function () {
        throw SERVER_ERROR;
      });
    }
  }, {
    key: 'getItem',
    value: function getItem(key, options) {
      var siteId = options.scope && options.scope.siteId;
      var path = siteId ? 'getVolatilePrefForSite' : 'getVolatilePrefForKey';
      var url = ['/_api/wix-user-preferences-webapp', path, options.namespace, siteId, key].filter(function (x) {
        return x;
      }).join('/');

      return axios.get(url).then(function (res) {
        return res.data[key];
      }).catch(function (err) {
        throw err.response.status === 404 ? NOT_FOUND : SERVER_ERROR;
      });
    }
  }, {
    key: 'getAllItems',
    value: function getAllItems(options) {
      var siteId = options.scope && options.scope.siteId;
      var path = siteId ? 'getVolatilePrefsForSite' : 'getVolatilePrefs';
      var url = ['/_api/wix-user-preferences-webapp', path, options.namespace, siteId].filter(function (x) {
        return x;
      }).join('/');

      return axios.get(url).then(function (res) {
        return res.data;
      }).catch(function () {
        throw SERVER_ERROR;
      });
    }
  }]);

  return WixStorageStrategy;
}(BaseStorage);

module.exports = WixStorageStrategy;
//# sourceMappingURL=wix-storage.js.map


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(74);

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3);
var bind = __webpack_require__(34);
var Axios = __webpack_require__(75);
var defaults = __webpack_require__(24);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(38);
axios.CancelToken = __webpack_require__(89);
axios.isCancel = __webpack_require__(37);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(90);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(24);
var utils = __webpack_require__(3);
var InterceptorManager = __webpack_require__(84);
var dispatchRequest = __webpack_require__(85);
var isAbsoluteURL = __webpack_require__(87);
var combineURLs = __webpack_require__(88);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(36);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response
    ));
  }
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 @ @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.response = response;
  return error;
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3);
var transformData = __webpack_require__(86);
var isCancel = __webpack_require__(37);
var defaults = __webpack_require__(24);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '');
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(38);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = __webpack_require__(7),
    NOT_FOUND = _require.NOT_FOUND;

var BaseStorage = __webpack_require__(6);
var LocalStorageStrategy = __webpack_require__(23);
var DELETED = '___DELETED___';

var CachedStorageStrategy = function (_BaseStorage) {
  _inherits(CachedStorageStrategy, _BaseStorage);

  function CachedStorageStrategy(_ref) {
    var remoteStrategy = _ref.remoteStrategy,
        _ref$localStrategy = _ref.localStrategy,
        localStrategy = _ref$localStrategy === undefined ? new LocalStorageStrategy() : _ref$localStrategy;

    _classCallCheck(this, CachedStorageStrategy);

    var _this = _possibleConstructorReturn(this, (CachedStorageStrategy.__proto__ || Object.getPrototypeOf(CachedStorageStrategy)).call(this));

    _this.remoteStrategy = BaseStorage.verify(remoteStrategy);
    _this.localStrategy = BaseStorage.verify(localStrategy);
    return _this;
  }

  _createClass(CachedStorageStrategy, [{
    key: '_cacheItem',
    value: function _cacheItem(key, value, options) {
      return this.localStrategy.setItem(key, value, Object.assign(options, { expiration: 3600 }));
    }
  }, {
    key: 'setItem',
    value: function setItem(key, value, options) {
      var _this2 = this;

      return this.remoteStrategy.setItem(key, value, options).then(function () {
        return _this2._cacheItem(key, value, options);
      });
    }
  }, {
    key: 'removeItem',
    value: function removeItem(key, options) {
      var _this3 = this;

      return this.remoteStrategy.removeItem(key, options).then(function () {
        return _this3._cacheItem(key, DELETED, options);
      });
    }
  }, {
    key: '_getRemoteAndCache',
    value: function _getRemoteAndCache(key, options) {
      var _this4 = this;

      return this.remoteStrategy.getItem(key, options).then(function (value) {
        return _this4._cacheItem(key, value, options).then(function () {
          return value;
        });
      }).catch(function (e) {
        if (e === NOT_FOUND) {
          return _this4._cacheItem(key, DELETED, options).then(function () {
            throw e;
          });
        }
        throw e;
      });
    }
  }, {
    key: 'getItem',
    value: function getItem(key, options) {
      var _this5 = this;

      function throwIfDeletedOrReturn(value) {
        if (value === DELETED) {
          throw NOT_FOUND;
        }

        return value;
      }

      return this.localStrategy.getItem(key, options).catch(function () {
        return _this5._getRemoteAndCache(key, options);
      }).then(throwIfDeletedOrReturn);
    }
  }, {
    key: 'getAllItems',
    value: function getAllItems(options) {
      var _this6 = this;

      return this.remoteStrategy.getAllItems(options).then(function (items) {
        return Promise.all(Object.keys(items).map(function (key) {
          return _this6._cacheItem(key, items[key], options);
        })).then(function () {
          return items;
        });
      });
    }
  }]);

  return CachedStorageStrategy;
}(BaseStorage);

module.exports = CachedStorageStrategy;
//# sourceMappingURL=cached-storage.js.map


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseStorage = __webpack_require__(6);

function validateNamespace(options) {
  if (!options.namespace) {
    throw new Error('namespace is required');
  } else if (typeof options.namespace !== 'string') {
    throw new Error('namespace should be a string');
  }
}

function buildValidadateOptions(capsuleOptions, options) {
  options = Object.assign({}, capsuleOptions, options);
  validateNamespace(options);
  return options;
}

var DataCapsule = function (_BaseStorage) {
  _inherits(DataCapsule, _BaseStorage);

  function DataCapsule(_ref) {
    var strategy = _ref.strategy,
        namespace = _ref.namespace,
        scope = _ref.scope;

    _classCallCheck(this, DataCapsule);

    var _this = _possibleConstructorReturn(this, (DataCapsule.__proto__ || Object.getPrototypeOf(DataCapsule)).call(this));

    _this.storageStrategy = BaseStorage.verify(strategy);
    _this._options = { namespace: namespace, scope: scope };
    return _this;
  }

  _createClass(DataCapsule, [{
    key: 'setItem',
    value: function setItem(key, value, options) {
      options = buildValidadateOptions(this._options, options);
      return this.storageStrategy.setItem(key, value, options);
    }
  }, {
    key: 'getItem',
    value: function getItem(key, options) {
      options = buildValidadateOptions(this._options, options);
      return this.storageStrategy.getItem(key, options);
    }
  }, {
    key: 'removeItem',
    value: function removeItem(key, options) {
      options = buildValidadateOptions(this._options, options);
      return this.storageStrategy.removeItem(key, options);
    }
  }, {
    key: 'getAllItems',
    value: function getAllItems(options) {
      options = buildValidadateOptions(this._options, options);
      return this.storageStrategy.getAllItems(options);
    }
  }]);

  return DataCapsule;
}(BaseStorage);

module.exports = DataCapsule;
//# sourceMappingURL=data-capsule.js.map


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(2);

var _proGalleryVersionManager = __webpack_require__(94);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FullscreenShareButtons = function (_React$Component) {
  _inherits(FullscreenShareButtons, _React$Component);

  function FullscreenShareButtons(props) {
    _classCallCheck(this, FullscreenShareButtons);

    var _this = _possibleConstructorReturn(this, (FullscreenShareButtons.__proto__ || Object.getPrototypeOf(FullscreenShareButtons)).call(this, props));

    _this.buttons = [];
    return _this;
  }

  _createClass(FullscreenShareButtons, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {

      if (!_utils.utils.isAccessibilityEnabled()) {
        return;
      }

      try {
        var focusedButton = this.props.focus;
        if (focusedButton > 0) {
          // this.buttonsContainer.focus();
          this.buttons[focusedButton - 1].focus();
        }
      } catch (e) {
        console.warn('Cannot focus on share icon', this.props.focus, e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var isNewMobileFullscreenLayout = _proGalleryVersionManager.versionManager.useFullscreenNewMobileLayout() && _utils.utils.isMobile();
      var shareArr = ['facebook', 'twitter', 'pinterest', 'tumblr', 'email'];
      if (this.props.item.type == 'text') {
        shareArr.splice(2, 1);
      }

      var buttons = shareArr.map(function (network, idx) {
        // let networkName = network.capitalize()
        var networkName = network.charAt(0).toUpperCase() + network.slice(1).toLowerCase();
        return isNewMobileFullscreenLayout ? _react2.default.createElement(
          'div',
          { className: 'fullscreen-social-item-container' },
          _react2.default.createElement(
            'div',
            { className: 'fullscreen-social-item',
              onClick: function onClick() {
                return _utils.itemActions.share(network, _this2.props.item, 'fullscreen');
              } },
            _react2.default.createElement('div', { className: "fullscreen-social-" + network + " progallery-svg-font-icons-" + network,
              key: network + "-share-icon",
              'data-hook': network + "-share-hook" }),
            _react2.default.createElement(
              'div',
              { className: 'network-name' },
              networkName
            )
          )
        ) : _react2.default.createElement('button', {
          className: "fullscreen-social-" + network + " progallery-svg-font-icons-" + network,
          ref: function ref(button) {
            return _this2.buttons[idx] = button;
          },
          onClick: function onClick() {
            return _utils.itemActions.share(network, _this2.props.item, 'fullscreen');
          },
          key: network + "-share-icon",
          'data-hook': network + "-share-hook",
          title: 'Share on ' + network,
          'aria-label': 'Share on ' + network + ', ' + idx + ' of 5',
          'aria-live': 'assertive',
          role: 'button',
          tabIndex: -1
        });
      });

      return _react2.default.createElement(
        'div',
        { className: 'fullscreen-social-items-container',
          'aria-live': 'assertive',
          ref: function ref(ele) {
            return _this2.buttonsContainer = ele;
          },
          tabIndex: -1
        },
        buttons
      );
    }
  }]);

  return FullscreenShareButtons;
}(_react2.default.Component);

exports.default = FullscreenShareButtons;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _versionManager = __webpack_require__(217);

var _versionManager2 = _interopRequireDefault(_versionManager);

var _utils = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var minDate = -8640000000000000;
var featuresList = {
  "fullscreen": [{
    version: _versionManager2.default.Versions.min,
    dateFrom: minDate
  }, {
    version: "V2",
    dateFrom: new Date(2018, 1, 1).getTime()
  }]
};

var ProGalleryVersionManager = function () {
  function ProGalleryVersionManager(dateCreated, options) {
    _classCallCheck(this, ProGalleryVersionManager);

    var features = options && options.features ? options.features : featuresList;
    this.versionManager = new _versionManager2.default(features, dateCreated);
  }

  _createClass(ProGalleryVersionManager, [{
    key: 'getVersionFullscreenVersion',
    value: function getVersionFullscreenVersion() {
      var version = this.versionManager.getVersion('fullscreen');
      if (version == _versionManager2.default.Versions.min) {
        return _utils.utils.isStoreGallery() ? "V2" : version;
      }
      return version;
    }
  }, {
    key: 'useFullScreenWideSidebar',
    value: function useFullScreenWideSidebar() {
      return this.getVersionFullscreenVersion() != _versionManager2.default.Versions.min;
    }
  }, {
    key: 'useFullScreenMobilePadding',
    value: function useFullScreenMobilePadding() {
      return this.getVersionFullscreenVersion() != _versionManager2.default.Versions.min;
    }
  }, {
    key: 'useFullScreenMoreinfoButtonAlways',
    value: function useFullScreenMoreinfoButtonAlways() {
      return this.getVersionFullscreenVersion() == _versionManager2.default.Versions.min;
    }
  }, {
    key: 'useFullscreenNewDesktopNavbar',
    value: function useFullscreenNewDesktopNavbar() {
      return this.getVersionFullscreenVersion() != _versionManager2.default.Versions.min;
    }
  }, {
    key: 'useFullscreenNewSidebar',
    value: function useFullscreenNewSidebar() {
      return this.getVersionFullscreenVersion() != _versionManager2.default.Versions.min;
    }
  }, {
    key: 'useFullscreenNewSlider',
    value: function useFullscreenNewSlider() {
      return this.getVersionFullscreenVersion() != _versionManager2.default.Versions.min;
    }
  }, {
    key: 'useFullscreenNewMobileLayout',
    value: function useFullscreenNewMobileLayout() {
      return this.getVersionFullscreenVersion() != _versionManager2.default.Versions.min;
    }
  }]);

  return ProGalleryVersionManager;
}();

var dateCreatedTicks = null;
var isDateCreatedValid = isNaN(Date.parse(window.dateCreated)) === false;
if (window && window.petri && window.petri["specs.pro-gallery.StoreExpandMode"] === "true") {
  dateCreatedTicks = new Date(2018, 1, 2).getTime();
} else if (isDateCreatedValid) {
  dateCreatedTicks = Date.parse(window.dateCreated);
}

var versionManager = new ProGalleryVersionManager(dateCreatedTicks, featuresList);

module.exports = { ProGalleryVersionManager: ProGalleryVersionManager, versionManager: versionManager, VersionManagerCore: _versionManager2.default };

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 96 */,
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.connect = exports.Provider = undefined;

var _Provider = __webpack_require__(115);

var _Provider2 = _interopRequireDefault(_Provider);

var _connect = __webpack_require__(119);

var _connect2 = _interopRequireDefault(_connect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports.Provider = _Provider2["default"];
exports.connect = _connect2["default"];

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(27);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _propTypes2["default"].shape({
  subscribe: _propTypes2["default"].func.isRequired,
  dispatch: _propTypes2["default"].func.isRequired,
  getState: _propTypes2["default"].func.isRequired
});

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(128);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(2);

exports.default = {
  gallery: {
    wixInit: false,
    renderedItemsCount: 0,
    videoIndexPlay: -1,
    documentHeight: _utils.utils.getScreenHeight()
  },
  fullscreen: {},
  multishare: {}
};

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(5);

var _itemActions = __webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FullscreenSocialDownload = function (_React$Component) {
  _inherits(FullscreenSocialDownload, _React$Component);

  function FullscreenSocialDownload(props) {
    _classCallCheck(this, FullscreenSocialDownload);

    return _possibleConstructorReturn(this, (FullscreenSocialDownload.__proto__ || Object.getPrototypeOf(FullscreenSocialDownload)).call(this, props));
  }

  _createClass(FullscreenSocialDownload, [{
    key: 'render',
    value: function render() {
      var arrowImageClass = "progallery-svg-font-icons-download" + (_utils.utils.isStoreGallery() ? '-store' : '');
      var _props = this.props,
          layout = _props.layout,
          device = _props.device;

      var curItem = this.props.current.item;
      var downloadClassNames = ['fullscreen-social-download ' + arrowImageClass, _itemActions.itemActions.viewClassName(layout, device)].join(' ') + (_utils.utils.isMobile ? ' mobile-social-icon' : '');
      return this.props.styleParams.allowDownload && !curItem.isDemo ? curItem.isText ? _react2.default.createElement('a', { className: downloadClassNames,
        style: this.props.style,
        tabIndex: _utils.utils.getTabIndex('fullscreenDownload'),
        'aria-label': 'Download ' + curItem.type + ' to your device',
        role: 'button',
        onClick: function onClick(evt) {
          evt.stopPropagation();
          _itemActions.itemActions.downloadTextItem(allProps, 'fullscreen');
        }
      }) : _react2.default.createElement('a', { className: downloadClassNames,
        style: this.props.style,
        tabIndex: _utils.utils.getTabIndex('fullscreenDownload'),
        'aria-label': 'Download ' + curItem.type + ' to your device',
        role: 'button',
        href: curItem.download_url['mp4'] || curItem.download_url['webm'] || curItem.download_url['img'],
        download: 'download', target: '_blank',
        onClick: function onClick() {
          return logger.track('download', { origin: 'fullscreen' });
        } }) : _react2.default.createElement('i', null);
    }
  }]);

  return FullscreenSocialDownload;
}(_react2.default.Component);

exports.default = FullscreenSocialDownload;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemCore = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(4);

var _ = _interopRequireWildcard(_lodash);

var _utils = __webpack_require__(2);

var _dto = __webpack_require__(114);

var _watermarkApi = __webpack_require__(12);

var _watermarkApi2 = _interopRequireDefault(_watermarkApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ItemCore = exports.ItemCore = function () {
  function ItemCore(config) {
    var _this = this;

    _classCallCheck(this, ItemCore);

    this.style = {};
    this.isReadMoreOpen = false;

    //Item core can be initialized with:
    // {dto: ItemDto(..)}
    // or {wixVideo: ... }
    // or {wixImage: ...}

    //in addition - support of {sharpParam: {quality}}

    config = config || {};
    if (config.dto && config.dto.dto) {
      config.dto = config.dto.dto; //defence patch due to mis-use of item-core
      if (_utils.utils.isDev()) {
        console.warn('Item core is created with already existing item core');
      }
    }
    this.dto = _.merge({}, config.dto);

    if (config.wixImage && _.isNumber(config.orderIndex)) {
      this.createFromWixImage(config.wixImage, config.orderIndex, config.addWithTitles, config.isSecure);
    }

    if (config.wixVideo && _.isNumber(config.orderIndex)) {
      this.createFromWixVideo(config.wixVideo, config.orderIndex, config.addWithTitles, config.isSecure);
    }

    if (config.wixExternal && _.isNumber(config.orderIndex)) {
      this.createFromExternal(config.wixExternal, config.orderIndex, config.addWithTitles, config.isSecure);
    }

    if (this.dto) {
      var itemMetadata = this.dto.metaData || this.dto.metadata;
      if (itemMetadata) {
        //metadata is encoded encoded, parsed if needed
        this.dto.metaData = this.parseStringObject(itemMetadata);
      }
    }
    if (_.isEmpty(this.dto)) {
      throw new Error('Item core: no dto');
    }

    this.sharpParams = _.merge({}, config.sharpParams);
    if (!this.sharpParams.quality) {
      this.sharpParams.quality = 90;
    }
    if (!this.sharpParams.usm) {
      this.sharpParams.usm = {};
    }

    this.updateSharpParams();

    this.cubeType = config.cubeType || 'fill';
    this.cubeImages = config.cubeImages;
    this._cubeRatio = config.cubeRatio;
    this.smartCrop = config.smartCrop;
    this.cropOnlyFill = config.cropOnlyFill;
    if (_utils.utils.isStoreGallery() && !this.isVideo) {
      this.watermark = config.watermark;
      if (!this.watermark) {
        _watermarkApi2.default.getWatermarkData() //this request should be sync (the watermark should have been cached by the gallery or the fullscreen)
        .then(function (data) {
          _this.watermark = data;
          _this.watermarkStr = _this.watermark && _this.watermark.imageUrl ? ',wm_' + _this.watermark.imageUrl + '-' + _this.watermark.opacity + '-' + _this.watermark.position + '-' + _this.watermark.size : '';
        });
      } else {
        // protect against watermark being a string - it happens some times.
        if (typeof this.watermark === 'string') {
          try {
            this.watermark = JSON.parse(this.watermark);
          } catch (error) {
            console.error('item-core - given watermark (' + this.watermark + ') is not an object', error);
          }
        }
        this.watermarkStr = '';
        if (this.watermark.imageUrl) {
          this.watermarkStr = ',wm_' + this.watermark.imageUrl + '-' + this.watermark.opacity + '-' + this.watermark.position + '-' + this.watermark.size;
        }
      }
    }

    this.style = {
      bgColor: this.bgColor,
      maxWidth: this.maxWidth,
      maxHeight: this.maxHeight,
      ratio: this.ratio,
      orientation: this.orientation
    };
  }

  _createClass(ItemCore, [{
    key: 'updateSharpParams',
    value: function updateSharpParams() {
      //override sharpParams with item sharpParams
      if (this.dto.metaData && this.dto.metaData.sharpParams && this.dto.metaData.sharpParams['L']) {
        var sharpParams = this.dto.metaData.sharpParams['L'];
        if (sharpParams.quality && sharpParams.overrideQuality == true) {
          this.sharpParams.quality = sharpParams.quality;
        }

        if (sharpParams.usm && sharpParams.overrideUsm == true) {
          this.sharpParams.usm = sharpParams.usm;
        }
      }
    }
  }, {
    key: 'resize',
    value: function resize(scale) {

      this.width *= scale;
      this.height *= scale;

      this.resized = true;
      var devicePixelRatio = _utils.utils.getDevicePixelRatio();
      var maxWidth = this.maxWidth;
      var maxHeight = this.maxHeight;
      // var maxWidth = this.cubeImages ? Math.min(this.maxWidth, this.maxHeight) : this.maxWidth;
      // var maxHeight = this.cubeImages ? Math.min(this.maxWidth, this.maxHeight) : this.maxHeight;
      this.resizeWidth = Math.min(maxWidth, Math.ceil(this.width * devicePixelRatio));
      this.resizeHeight = Math.min(maxHeight, Math.ceil(this.height * devicePixelRatio));
      this.resized_url = this.resizedUrl(this.cubeType, this.resizeWidth, this.resizeHeight, this.sharpParams, false);

      this.pixel_url = this.resizedUrl('fill', 1, 1, { quality: 30 }, false);

      var maxDimension = 500;
      var thumbnailWidth = Math.min(maxWidth, this.width, _utils.utils.getScreenWidth(), maxDimension);
      var thumbnailHeight = Math.min(maxHeight, this.height, _utils.utils.getScreenHeight(), maxDimension);
      this.thumbnail_url = this.resizedUrl('fit', thumbnailWidth, thumbnailHeight, { quality: 30 }, false);

      this.square_url = this.resizedUrl('fill', 100, 100, { quality: 80 }, false);

      this.full_url = this.resizedUrl(this.cubeType, this.maxWidth, this.maxHeight, this.sharpParams, false);

      this.download_url = _utils.utils.isStoreGallery() ? this.resizedUrl('fit', 500, 500, this.sharpParams, false, true) : { img: this.getOriginalsUrl() };

      return this;
    }
  }, {
    key: 'getDataForShop',
    value: function getDataForShop() {
      var fp = this.focalPoint;
      var md = this.metadata;
      return {
        isDemo: md.isDemo,
        orderIndex: this.orderIndex,
        itemId: this.dto.itemId,
        originalUrl: this.getOriginalsUrl(),
        itemUrl: this.url,
        itemHeight: md.height,
        title: md.title,
        itemWidth: md.width,
        itemType: md.type || 'image',
        imageUrl: this.resizedUrl('fit', 200, 200, null, null)['img'],
        imagePurchasedUrl: this.dto.mediaUrl,
        fpX: fp[0],
        fpY: fp[1]
      };
    }
  }, {
    key: 'resizedUrl',
    value: function resizedUrl(resizeMethod, requiredWidth, requiredHeight, sharpParams, showFaces, noCrop) {
      requiredWidth = Math.round(requiredWidth);
      requiredHeight = Math.round(requiredHeight);
      var thumbSize = this.isVideo ? 180 : 90;

      var urls = {};

      if (this.isVideo || this.metadata.customPoster) {
        var maxHeight = 720;
        var qualities = this.metadata.qualities;
        var poster = this.metadata.customPoster || (this.metadata.posters ? this.metadata.posters[this.metadata.posters.length - 1] : null);

        if (poster) {
          if (qualities && qualities.length) {
            var suffix = '/';

            //search for the first quality bigger that the required one
            for (var quality, q = 0; quality = qualities[q]; q++) {
              if (quality.height >= requiredHeight || quality.height >= maxHeight || !qualities[q + 1]) {
                suffix += quality.quality; //e.g. 720p
                for (var format, i = 0; format = quality.formats[i]; i++) {
                  urls[format] = window.location.protocol + '//video.wixstatic.com/video/' + this.url + suffix + '/' + format + '/file.' + format;
                }
                break;
              }
            }
            var ratio = poster.width / poster.height;
            var isWider = ratio > 1;
            if (isWider) {
              requiredWidth = Math.ceil(requiredHeight * ratio);
            } else {
              requiredHeight = Math.ceil(requiredWidth / ratio);
            }
          }

          urls['img'] = this.resizeUrlImp(poster.url, resizeMethod, requiredWidth, requiredHeight, sharpParams, showFaces, false);
          urls['thumb'] = this.resizeUrlImp(poster.url, 'fit', thumbSize, thumbSize, sharpParams, false, false);
        }
      } else {
        urls['img'] = this.resizeUrlImp(this.url, resizeMethod, requiredWidth, requiredHeight, sharpParams, showFaces, true, noCrop !== true && this.isCropped && this.focalPoint);
        urls['thumb'] = this.resizeUrlImp(this.url, 'fit', thumbSize, thumbSize, sharpParams, false, true);
      }

      return urls;
    }
  }, {
    key: 'createFromWixImage',
    value: function createFromWixImage(wixData, orderIndex, addWithTitles, isSecure) {
      var url = wixData.uri || wixData.relativeUri || wixData.url;
      var itemId = url.slice(0, url.length - 4);
      var metadata = {
        height: wixData.height,
        width: wixData.width,
        lastModified: new Date().getTime(),
        name: wixData.fileName,
        type: wixData.type,
        link: this.initialLinkObject,
        sourceName: wixData.sourceName,
        tags: wixData.tags,
        wm: wixData.wm
        // title: wixData.title || '',
        // description: wixData.description || '',
      };

      if (addWithTitles) {
        metadata['title'] = wixData.title;
      }

      this.dto = { itemId: itemId, mediaUrl: url, orderIndex: orderIndex, metadata: metadata, isSecure: isSecure };
    }
  }, {
    key: 'createFromWixVideo',
    value: function createFromWixVideo(wixData, orderIndex, addWithTitles, isSecure) {

      var qualities = _.map(wixData.fileOutput.video, function (q) {
        return {
          height: q.height,
          width: q.width,
          quality: q.quality,
          formats: [q.format]
        };
      });

      var posters = _.map(wixData.fileOutput.image, _.partialRight(_.pick, ['url', 'width', 'height']));
      posters = _.map(posters, function (p) {
        p.url = p.url.replace('media/', '');
        return p;
      });

      var metaData = {
        name: wixData.title,
        lastModified: new Date().getTime(),
        width: wixData.fileInput.width,
        height: wixData.fileInput.height,
        type: 'video',
        posters: posters,
        customPoster: '',
        isExternal: false,
        duration: wixData.fileInput.duration,
        qualities: qualities,
        link: this.initialLinkObject
        // title: wixData.title,
        // description: wixData.description,
      };

      if (addWithTitles) {
        metaData['title'] = wixData.title;
      }

      this.dto = { itemId: wixData.id, mediaUrl: wixData.id, orderIndex: orderIndex, metaData: metaData, isSecure: isSecure };
    }
  }, {
    key: 'createFromExternal',
    value: function createFromExternal(wixData, orderIndex, addWithTitles, isSecure) {
      var metaData = {
        name: wixData.id,
        videoId: wixData.id,
        lastModified: new Date().getTime(),
        height: 1080,
        width: 1920,
        source: wixData.source || '',
        videoUrl: wixData.videoUrl || '',
        isExternal: true,
        type: 'video',
        posters: wixData.posters,
        customPoster: '',
        duration: 0,
        qualities: []
      };

      this.dto = { itemId: wixData.id, mediaUrl: metaData.posters[0].url, orderIndex: orderIndex, metaData: metaData, isSecure: isSecure };
    }
  }, {
    key: 'resizeUrlImp',
    value: function resizeUrlImp(originalUrl, resizeMethod, requiredWidth, requiredHeight, sharpParams) {
      var faces = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
      var allowWatermark = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
      var focalPoint = arguments[7];


      var requiredRatio = requiredWidth / requiredHeight;
      var showWatermark = allowWatermark && this.watermarkStr;

      if (!_utils.utils.isMobile()) {
        requiredWidth = Math.ceil(requiredWidth / 250) * 250;
        requiredHeight = Math.ceil(requiredWidth / requiredRatio);
      }

      // assign sharp default parameters
      sharpParams = sharpParams || {};

      // calc default quality
      if (!sharpParams.quality) {
        sharpParams.quality = 90;
      }

      //don't allow quality above 90 till we have proper UI indication
      sharpParams.quality = Math.min(90, sharpParams.quality);

      if (sharpParams.usm && sharpParams.usm.usm_r) {
        sharpParams.usm.usm_a = Math.min(5, Math.max(0, sharpParams.usm.usm_a || 0));
        sharpParams.usm.usm_r = Math.min(128, Math.max(0, sharpParams.usm.usm_r || 0)); //should be max 500 - but it's returning a 404
        sharpParams.usm.usm_t = Math.min(1, Math.max(0, sharpParams.usm.usm_t || 0));
      }

      if (isExternalUrl(originalUrl)) {
        return originalUrl;
      } else if (!focalPoint) {
        //todo remove when supporting focal point
        var retUrl = 'https://static.wixstatic.com/media/' + originalUrl + '/v1/' + resizeMethod + '/';
        retUrl += 'w_' + requiredWidth;
        retUrl += ',h_' + requiredHeight;
        retUrl += ',al_' + (faces ? 'fs' : 'c');
        retUrl += ',q_' + sharpParams.quality;

        retUrl += sharpParams.usm && sharpParams.usm.usm_r ? ',usm_' + sharpParams.usm.usm_r.toFixed(2) + '_' + sharpParams.usm.usm_a.toFixed(2) + '_' + sharpParams.usm.usm_t.toFixed(2) : '';
        // Important to use this as the last param
        if (showWatermark) {
          retUrl += this.watermarkStr;
        }
        retUrl += '/' + originalUrl;
        return retUrl;
      } else {

        var scale;
        var x;
        var y;
        var orgW;
        var orgH;

        //find the scale
        if (this.ratio > requiredRatio) {
          //wide image (relative to required ratio
          scale = requiredHeight / this.maxHeight;
          orgW = Math.floor(requiredHeight * this.ratio);
          y = 0;
          x = Math.round(orgW * focalPoint[0] - requiredWidth / 2);
          x = Math.min(orgW - requiredWidth, x);
          x = Math.max(0, x);
        } else {
          //narrow image

          scale = requiredWidth / this.maxWidth;
          orgH = Math.floor(requiredWidth / this.ratio);
          x = 0;
          y = Math.round(orgH * focalPoint[1] - requiredHeight / 2);
          y = Math.min(orgH - requiredHeight, y);
          y = Math.max(0, y);
        }

        //make sure scale is not lower than needed
        //scale must be higher to prevent cases that there will be white margins (or 404)
        scale = Math.ceil(scale * 100) / 100;

        var retUrl = 'https://static.wixstatic.com/media/' + originalUrl + '/v1/crop/';
        retUrl += 'w_' + requiredWidth;
        retUrl += ',h_' + requiredHeight;
        retUrl += ',x_' + x;
        retUrl += ',y_' + y;
        retUrl += ',scl_' + scale.toFixed(2);
        retUrl += ',q_' + sharpParams.quality;
        retUrl += sharpParams.usm && sharpParams.usm.usm_r ? ',usm_' + sharpParams.usm.usm_r.toFixed(2) + '_' + sharpParams.usm.usm_a.toFixed(2) + '_' + sharpParams.usm.usm_t.toFixed(2) : '';
        // Important to use this as the last param
        if (showWatermark) {
          retUrl += this.watermarkStr;
        }
        retUrl += '/' + originalUrl;
        return retUrl;
      }

      function isExternalUrl(url) {
        return (/(^https?)|(^data)|(^blob)/.test(url)
        );
      }
    }
  }, {
    key: 'getOriginalsUrl',
    value: function getOriginalsUrl() {
      return 'https://static.wixstatic.com/media/' + this.url;
    }
  }, {
    key: 'parseStringObject',
    value: function parseStringObject(sObj) {
      if (typeof sObj != 'string') {
        return sObj;
      }

      var stripedObj = _utils.utils.stripSlashes(sObj);
      if (typeof sObj == 'string' && /^[\],:{}\s]*$/.test(stripedObj.replace(/\\["\\\/bfnrtu]/g, '@').replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {
        //this is a json
        try {
          return JSON.parse(stripedObj);
        } catch (e) {
          console.error('Parse object error: Catched ', e);
        }
      }
      return stripedObj;
    }
  }, {
    key: 'getTranslatedValue',
    value: function getTranslatedValue(val) {
      if (window['TranslationUtil'] && val != '') {
        var translated = window['TranslationUtil'].getByKey(val);
        return translated;
      }
      return val;
    }
  }, {
    key: 'updateOrderIndex',
    value: function updateOrderIndex(value) {
      var ret = this.orderIndex !== value;
      this.orderIndex = value;
      return ret;
    }
  }, {
    key: 'id',
    get: function get() {
      return this.dto.photoId || this.dto.itemId;
    },
    set: function set(id) {
      this.dto.itemId = id;
    }
  }, {
    key: 'photoId',
    get: function get() {
      return this.id;
    }
  }, {
    key: 'itemId',
    get: function get() {
      return this.id;
    }
  }, {
    key: 'name',
    get: function get() {
      return this.metadata.fileName || '';
    }
  }, {
    key: 'url',
    get: function get() {
      //todo :change from mediaUrl
      return this.dto.file_url || this.dto.mediaUrl || this.dto.url;
    }
  }, {
    key: 'mediaUrl',
    get: function get() {
      return this.url;
    }
  }, {
    key: 'orderIndex',
    get: function get() {
      return this.dto.orderIndex || 0;
    },
    set: function set(value) {
      this.dto.orderIndex = value;
    }
  }, {
    key: 'maxWidth',
    get: function get() {
      return this.dto.width || this.dto.w || this.metadata.width;
    }
  }, {
    key: 'maxHeight',
    get: function get() {
      return this.dto.height || this.dto.h || this.metadata.height;
    }
  }, {
    key: 'lastModified',
    get: function get() {
      return this.metadata.lastModified;
    }
  }, {
    key: 'metadata',
    get: function get() {
      var md = this.dto.metaData || this.dto.metadata;
      if (_.isUndefined(md)) {
        console.error('Item with no metadata' + JSON.stringify(this.dto));
      }
      return md;
    }
  }, {
    key: 'metaData',
    get: function get() {
      return this.metadata;
    }
  }, {
    key: 'orgWidth',
    get: function get() {
      return this.style.width || this.dto.width || this.dto.w || this.metadata.width || 1; //make sure the width / height is not undefined (creashes the gallery)
    }
  }, {
    key: 'width',
    get: function get() {
      if (this.cubeImages && this.ratio >= this.cubeRatio) {
        return this.style.cubedWidth || this.orgHeight * this.cubeRatio;
      } else {
        return this.orgWidth;
      }
    },
    set: function set(w) {
      this.style.cubedWidth = this.style.width = w;
    }
  }, {
    key: 'orgHeight',
    get: function get() {
      return this.style.height || this.dto.height || this.dto.h || this.metadata.height || 1; //make sure the width / height is not undefined (creashes the gallery)
    }
  }, {
    key: 'height',
    get: function get() {
      if (this.cubeImages && this.ratio < this.cubeRatio) {
        return this.style.cubedHeight || this.orgWidth / this.cubeRatio;
      } else {
        return this.orgHeight;
      }
    },
    set: function set(h) {
      this.style.cubedHeight = this.style.height = h;
    }
  }, {
    key: 'cubeRatio',
    get: function get() {
      var ratio;
      if (_.isFunction(this._cubeRatio)) {
        ratio = this._cubeRatio();
      } else {
        if (this.cropOnlyFill && this.cubeType == 'fit') {
          ratio = this.ratio;
        } else {
          ratio = this._cubeRatio;
        }
      }

      if (this.smartCrop === true) {
        if (this.isPortrait) {
          return Math.min(ratio, 1 / ratio);
        } else {
          return Math.max(ratio, 1 / ratio);
        }
      } else {
        return ratio;
      }
    }
  }, {
    key: 'orientation',
    get: function get() {
      return this.ratio < 0.999 ? 'portrait' : 'landscape'; //make sure that almost square images get the same treatment
    }
  }, {
    key: 'isPortrait',
    get: function get() {
      return this.orientation == 'portrait';
    }
  }, {
    key: 'isLandscape',
    get: function get() {
      return this.orientation == 'landscape';
    }
  }, {
    key: 'bgColor',
    get: function get() {
      var bg = void 0;
      if (this.isText) {
        bg = this.metadata && this.metadata.textStyle && this.metadata.textStyle.backgroundColor;
        if (!bg && !_utils.utils.isSemiNative()) {
          bg = Wix.Styles.getColorByreference('color-5').value;
        }
      } else {
        bg = 'none';
      }
      return bg;
    }
  }, {
    key: 'ratio',
    get: function get() {
      if (!this.orgRatio) {
        this.orgRatio = this.orgWidth / this.orgHeight;
      }
      return this.orgRatio;
    }
  }, {
    key: 'isVideo',
    get: function get() {
      return this.type == 'video';
    }
  }, {
    key: 'isExternal',
    get: function get() {
      return this.metadata.isExternal === true;
    }
  }, {
    key: 'isCropped',
    get: function get() {
      return this.cubeImages && this.cubeType == 'fill';
    }
  }, {
    key: 'focalPoint',
    get: function get() {
      return this.metadata.focalPoint || [0.5, 0.5];
    },
    set: function set(value) {
      this.metadata.focalPoint = value;
    }
  }, {
    key: 'html',
    get: function get() {
      return this.dto.html || this.dto.text || this.metadata.html || this.metadata.text;
    }
  }, {
    key: 'type',
    set: function set(type) {
      this._type = type;
    },
    get: function get() {
      switch (this._type || this.dto.type || this.metadata.type || this.dto.media_type) {
        case 'dummy':
          return 'dummy';
        case 'v':
        case 'video':
          return 'video';
        case 'h':
        case 'html':
        case 'text':
          return 'text';
        case 'i':
        case 'image':
        default:
          return 'image';
      }
    }
  }, {
    key: 'alt',
    get: function get() {
      return this.metadata.alt || this.title || this.description;
    }
  }, {
    key: 'title',
    get: function get() {
      return this.metadata.title || '';
      // if (!this.metadata.isDemo) {
      //   return this.metadata.title || '';
      // }
      // return this.getTranslatedValue(this.metadata.title);
    },
    set: function set(value) {
      this.metadata.title = value;
    }
  }, {
    key: 'fileName',
    get: function get() {
      return this.metadata.fileName || '';
    },
    set: function set(value) {
      this.metadata.fileName = value;
    }
  }, {
    key: 'description',
    get: function get() {
      return this.metadata.description || '';
      // if (!this.metadata.isDemo) {
      //   return this.metadata.description || '';
      // }
      // return this.getTranslatedValue(this.metadata.description);
    },
    set: function set(value) {
      this.metadata.description = value;
    }
  }, {
    key: 'exif',
    get: function get() {
      return this.metadata.exif || '';
    }
  }, {
    key: 'hasLink',
    get: function get() {
      switch (this.linkType) {
        case 'wix':
          return !!this.linkData.type;
        default:
          return !!this.linkUrl;
      }
    }
  }, {
    key: 'link',
    get: function get() {
      return this.metadata.link || {};
    }
  }, {
    key: 'linkData',
    get: function get() {
      if (this.metadata.link) {
        return this.metadata.link.data || {};
      }
    },
    set: function set(value) {
      if (!this.metadata.link) {
        this.metadata.link = {};
      }
      this.metadata.link.data = value;
    }
  }, {
    key: 'linkType',
    get: function get() {
      if (this.metadata.link) {
        return this.metadata.link.type;
      }
    },
    set: function set(value) {
      if (!this.metadata.link) {
        this.metadata.link = {};
      }

      // reset metadata.link when 'none' is selected - that's the way wix galleries work
      this.metadata.link = {
        type: value,
        url: undefined,
        text: undefined,
        title: undefined,
        target: '_blank'
      };
    }
  }, {
    key: 'defaultLinkText',
    get: function get() {
      var linkData = this.linkData;

      switch (this.linkType) {
        case 'wix':
          switch (linkData.type) {
            case 'PageLink':
              return 'Go to Page ' + linkData.pageName;
            case 'AnchorLink':
              return 'Scroll to ' + linkData.anchorName;
            case 'ExternalLink':
              return '' + linkData.url;
            case 'EmailLink':
              return 'Email ' + linkData.recipient;
            case 'PhoneLink':
              return 'Call ' + linkData.phoneNumber;
            case 'DocumentLink':
              return 'Open ' + linkData.name;
            default:
              return 'Go To Link';
          }
        case 'web':
          return this.linkUrl;
        case 'page':
          return this.linkTitle;
        default:
          return '';
      }
      /*
          const wixLinkDataSamples = {
            page: {
              pageId: "#c1dmp",
              type: "PageLink"
            },
            anchor: {
              anchorDataId: "",
              anchorName: "Anchor 1",
              pageId: "#masterPage",
              type: "AnchorLink"
            },
            web: {
              target: "_self",
              type: "ExternalLink",
              url: "http://google.com"
            },
            email: {
              recipient: "guyso@wix.com",
              subject: "subject",
              type: "EmailLink"
            },
            phone: {
              phoneNumber: "0547787444",
              type: "PhoneLink"
            },
            document: {
              docId: "0d72ac_7395fddc29a84899a472b5fcf0dee3ed.doc",
              name: "חוזה-שכירות-משנה-בלתי-מוגנת.doc",
              type: "DocumentLink"
            },
            scroll: {
              anchorDataId: "SCROLL_TO_TOP",
              anchorName: "Top of Page",
              pageId: "#masterPage",
              type: "AnchorLink"
            },
            lightbox: {
              pageId: "#zwjzg",
              type: "PageLink"
            }
           }
      */
    }
  }, {
    key: 'defaultLinkValue',
    get: function get() {
      var linkData = this.linkData;

      switch (this.linkType) {
        case 'wix':
          switch (linkData.type) {
            case 'PageLink':
              if (linkData.pageName) {
                return 'PAGE - ' + linkData.pageName;
              } else {
                return 'PAGE';
              }
            case 'AnchorLink':
              return 'ANCHOR - ' + linkData.anchorName;
            case 'ExternalLink':
              return 'LINK - ' + linkData.url;
            case 'EmailLink':
              return 'EMAIL - ' + linkData.recipient;
            case 'PhoneLink':
              return 'PHONE - ' + linkData.phoneNumber;
            case 'DocumentLink':
              return 'DOCUMENT - ' + linkData.name;
            default:
              return 'Add a Link';
          }
        case 'web':
          return this.linkUrl;
        case 'page':
          return this.linkTitle;
        default:
          return '';
      }
    }
  }, {
    key: 'linkText',
    get: function get() {
      if (this.metadata.link) {
        return this.metadata.link.text || this.defaultLinkText;
      }
    },
    set: function set(value) {
      if (!this.metadata.link) {
        this.metadata.link = {};
      }
      this.metadata.link.text = value;
    }
  }, {
    key: 'linkTitle',
    get: function get() {
      if (this.metadata.link) {
        return this.metadata.link.title;
      }
    },
    set: function set(value) {
      if (!this.metadata.link) {
        this.metadata.link = {};
      }
      this.metadata.link.title = value;
    }
  }, {
    key: 'linkUrl',
    get: function get() {
      if (this.metadata.link) {
        return this.metadata.link.url;
      }
    },
    set: function set(value) {
      if (!this.metadata.link) {
        this.metadata.link = {};
      }
      this.metadata.link.url = value;
    }
  }, {
    key: 'unprotectedLinkOpenType',
    get: function get() {
      return _.get(this, 'metadata.link.target');
    }
  }, {
    key: 'linkOpenType',
    get: function get() {
      if (_utils.utils.isEditor() || _utils.utils.isPreview()) {
        //in preview never open link in current window (causes many errors)
        return '_blank';
      } else if (this.metadata.link) {
        return this.unprotectedLinkOpenType;
      }
    },
    set: function set(value) {
      if (!this.metadata.link) {
        this.metadata.link = {};
      }
      this.metadata.link.target = value;
    }
  }, {
    key: 'initialLinkObject',
    get: function get() {
      return {
        type: 'none',
        url: undefined,
        text: undefined,
        title: undefined,
        target: '_blank'
      };
    }
  }, {
    key: 'isDemo',
    get: function get() {
      return this.metadata.isDemo || this.dto.isDemo || this.metadata.sourceName === 'public' || this.metadata.sourceName === 'private' && _.includes(this.metadata.tags, '_bigstock');
    },
    set: function set(val) {
      this.metadata.isDemo = val;
    }
  }, {
    key: 'isText',
    get: function get() {
      return this.type == 'text';
    }
  }]);

  return ItemCore;
}();

/***/ }),
/* 104 */,
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BasePlayer2 = __webpack_require__(136);

var _BasePlayer3 = _interopRequireDefault(_BasePlayer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AUDIO_EXTENSIONS = /\.(m4a|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|ogg|spx)($|\?)/i;

var FilePlayer = function (_BasePlayer) {
  _inherits(FilePlayer, _BasePlayer);

  function FilePlayer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FilePlayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FilePlayer.__proto__ || Object.getPrototypeOf(FilePlayer)).call.apply(_ref, [this].concat(args))), _this), _this.ref = function (player) {
      _this.player = player;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FilePlayer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          onPause = _props.onPause,
          onEnded = _props.onEnded,
          onError = _props.onError;

      this.player.addEventListener('canplay', this.onReady);
      this.player.addEventListener('play', this.onPlay);
      this.player.addEventListener('pause', function () {
        if (_this2.mounted) {
          onPause();
        }
      });
      this.player.addEventListener('ended', onEnded);
      this.player.addEventListener('error', onError);
      this.player.setAttribute('webkit-playsinline', '');
      _get(FilePlayer.prototype.__proto__ || Object.getPrototypeOf(FilePlayer.prototype), 'componentDidMount', this).call(this);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _props2 = this.props,
          onPause = _props2.onPause,
          onEnded = _props2.onEnded,
          onError = _props2.onError;

      this.player.removeEventListener('canplay', this.onReady);
      this.player.removeEventListener('play', this.onPlay);
      this.player.removeEventListener('pause', onPause);
      this.player.removeEventListener('ended', onEnded);
      this.player.removeEventListener('error', onError);
      _get(FilePlayer.prototype.__proto__ || Object.getPrototypeOf(FilePlayer.prototype), 'componentWillUnmount', this).call(this);
    }
  }, {
    key: 'load',
    value: function load(url) {
      this.player.src = url;
    }
  }, {
    key: 'play',
    value: function play() {
      this.player.play();
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.player.pause();
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.player.removeAttribute('src');
    }
  }, {
    key: 'seekTo',
    value: function seekTo(fraction) {
      _get(FilePlayer.prototype.__proto__ || Object.getPrototypeOf(FilePlayer.prototype), 'seekTo', this).call(this, fraction);
      this.player.currentTime = this.getDuration() * fraction;
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.player.volume = fraction;
    }
  }, {
    key: 'setPlaybackRate',
    value: function setPlaybackRate(rate) {
      this.player.playbackRate = rate;
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      if (!this.isReady) return null;
      return this.player.duration;
    }
  }, {
    key: 'getFractionPlayed',
    value: function getFractionPlayed() {
      if (!this.isReady) return null;
      return this.player.currentTime / this.getDuration();
    }
  }, {
    key: 'getFractionLoaded',
    value: function getFractionLoaded() {
      if (!this.isReady || this.player.buffered.length === 0) return null;
      return this.player.buffered.end(0) / this.getDuration();
    }
  }, {
    key: 'stopBuffering',
    value: function stopBuffering() {
      var _this3 = this;

      this.player.pause();
      var time = this.player.currentTime;

      var setTime = function setTime() {
        _this3.player.currentTime = time;
        _this3.player.removeEventListener('loadedmetadata', setTime);
      };
      this.player.addEventListener('loadedmetadata', setTime);
      this.player.load();
      try {
        setTime(); // if it can't set player.currentTime, it will run in the event listener.
      } catch (e) {}
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          url = _props3.url,
          loop = _props3.loop,
          controls = _props3.controls,
          fileConfig = _props3.fileConfig;

      var Media = AUDIO_EXTENSIONS.test(url) ? 'audio' : 'video';
      var style = {
        width: '100%',
        height: '100%',
        display: url ? 'block' : 'none'
      };
      return _react2['default'].createElement(Media, _extends({
        ref: this.ref,
        style: style,
        preload: 'auto',
        controls: controls,
        loop: loop
      }, fileConfig.attributes));
    }
  }], [{
    key: 'canPlay',
    value: function canPlay(url) {
      return true;
    }
  }]);

  return FilePlayer;
}(_BasePlayer3['default']);

FilePlayer.displayName = 'FilePlayer';
exports['default'] = FilePlayer;
module.exports = exports['default'];

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var placements = {
  SHOW_ON_HOVER: 'SHOW_ON_HOVER',
  SHOW_ALWAYS: 'SHOW_ALWAYS',
  DONT_SHOW: 'DONT_SHOW'
};

exports.default = {
  placements: placements,
  SIDE_BAR_WIDTH: 430,
  STORE_SIDE_BAR_WIDTH: 560,
  MOBILE_PADDING: 120,
  NO_PADDING: 0
};

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _consts = __webpack_require__(11);

var _urijs = __webpack_require__(25);

var _urijs2 = _interopRequireDefault(_urijs);

var _cartApi = __webpack_require__(26);

var _cartApi2 = _interopRequireDefault(_cartApi);

var _providerEvents = __webpack_require__(65);

var _providerEvents2 = _interopRequireDefault(_providerEvents);

var _utils = __webpack_require__(5);

var _ProviderStyles = __webpack_require__(108);

var styles = _interopRequireWildcard(_ProviderStyles);

var _storeApi = __webpack_require__(58);

var _storeApi2 = _interopRequireDefault(_storeApi);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProviderIntent = function (_Component) {
  _inherits(ProviderIntent, _Component);

  function ProviderIntent(props) {
    _classCallCheck(this, ProviderIntent);

    var _this = _possibleConstructorReturn(this, (ProviderIntent.__proto__ || Object.getPrototypeOf(ProviderIntent)).call(this, props));

    _this.handleMessageReceived = _this.handleMessageReceived.bind(_this);
    _this.onBackToEditor = _this.onBackToEditor.bind(_this);
    _this.handleWixStyleChanged = _this.handleWixStyleChanged.bind(_this);
    _this.setTabIndex = _this.setTabIndex.bind(_this);

    var anonymousUserId = null;
    var providerData = null;
    var providerId = null;
    var debugApp = window.debugApp;
    var connectedProviders = props.connectedProviders;

    if (window.Wix) {
      anonymousUserId = Wix.Utils.getInstanceValue('aid');
    }

    if (connectedProviders) {
      var providerDataProps = _this.getProviderDataFromConnectedProviders(connectedProviders);
      providerData = providerDataProps.providerData;
      providerId = providerDataProps.providerId;
    }

    _this.state = {
      providerData: providerData,
      providerId: providerId,
      token: _utils.utils.getUUID(),
      anonymousUserId: anonymousUserId,
      isAccessible: _utils.utils.isAccessibilityEnabled(),
      providerReady: false,
      debugApp: debugApp
    };
    return _this;
  }

  _createClass(ProviderIntent, [{
    key: 'isDashboard',
    value: function isDashboard() {
      return Wix.Utils.getViewMode() === 'dashboard';
    }
  }, {
    key: 'isEditor',
    value: function isEditor() {
      return Wix.Utils.getViewMode() === 'editor';
    }
  }, {
    key: 'handleWixStyleChanged',
    value: function handleWixStyleChanged(e) {
      var _this2 = this;

      // This timeout will let the params a chance to be set
      setTimeout(function () {
        _this2.sendStylesToProvider();
      }, 1);
    }
  }, {
    key: 'getProviderDataFromConnectedProviders',
    value: function getProviderDataFromConnectedProviders(connectedProviders) {
      var providerData = null;
      var providerId = null;

      if (connectedProviders) {
        providerId = Object.keys(connectedProviders)[0];
        providerData = connectedProviders[providerId];
      }

      return { providerData: providerData, providerId: providerId };
    }

    // componentWillMount() {
    //   if (window.Wix) {
    //     if (!this.state.providerData) {
    //       window['WixStoreApi'].getStoreGalleryData()
    //         .then((storeGalleryData) => {
    //           const providerData = this.getProviderDataFromConnectedProviders(storeGalleryData.connectedProviders);
    //           this.setState(providerData);
    //           this.forceUpdate();
    //         });
    //     }
    //   }
    // }

  }, {
    key: 'raiseEvent',
    value: function raiseEvent(eventType, data, resolve, reject) {
      if (this.props.onMessageReceived) {
        this.props.onMessageReceived(eventType, data, resolve, reject, this.state.providerId);
      }
    }
  }, {
    key: 'setTabIndex',
    value: function setTabIndex(idx) {
      if (this.intentFrame) {
        this.intentFrame.tabIndex = idx;
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !this.intentFrame; //prevent iframe from refreshing
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('message', this.handleMessageReceived);
      Wix.addEventListener(Wix.Events.EDIT_MODE_CHANGE, this.onBackToEditor);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('message', this.handleMessageReceived);
      Wix.removeEventListener(Wix.Events.EDIT_MODE_CHANGE, this.onBackToEditor);
    }
  }, {
    key: 'addToCart',
    value: function addToCart(_ref) {
      var originalUrl = _ref.originalUrl,
          itemId = _ref.itemId,
          itemUrl = _ref.itemUrl,
          itemType = _ref.itemType,
          galleryId = _ref.galleryId;

      var dataToSend = {
        originalUrl: originalUrl,
        itemId: itemId,
        itemUrl: itemUrl,
        itemType: itemType,
        galleryId: galleryId
      };
      _cartApi2.default.publishAddToCart(dataToSend);
    }
  }, {
    key: 'onBackToEditor',
    value: function onBackToEditor() {
      var _this3 = this;

      if (this.props.hiddenFromEditor === true && !_utils.utils.isSite()) {

        // If we don't do the following checks then if the hidden page is not visible, the SDK will make a short jump to that page before navigating to home..
        // This way we make sure that the current pageId is not a hidden page - thus we should not navigate at all..
        Wix.getCurrentPageId(function (currentPageId) {
          Wix.getSitePages(function (arrPages) {
            var isInSitePages = arrPages.some(function (page) {
              return page.id === currentPageId;
            });
            if (!isInSitePages) {
              _this3.backHome();
            }
          });
        });
      }
    }
  }, {
    key: 'backHome',
    value: function backHome(payload) {
      if (!_utils.utils.isEditor()) {
        try {
          Wix.replaceSectionState('/');
        } catch (e) {
          console.error('failed replacing section state', e);
        }
      }
      Wix.getSitePages(function (arrPages) {
        var homepage = (arrPages || []).find(function (page) {
          return page.isHomepage;
        });
        if (homepage) {
          var homepageId = homepage.id;
          if (payload) {
            if (payload.openCart) {
              localStorage.setItem('openCart', true);
            }
          }

          Wix.navigateToPage(homepageId);
        }
      });
    }
  }, {
    key: 'getSiteUrlsBundle',
    value: function getSiteUrlsBundle() {
      var arrPromises = [];
      var returnPromise = null;
      if (!this.isDashboard()) {
        var dashboardPromise = Promise.resolve(null);

        arrPromises.push(new Promise(function (resolve, reject) {
          Wix.getSiteInfo(function (info) {
            resolve(info);
          });
        }));

        arrPromises.push(new Promise(function (resolve, reject) {
          Wix.Utils.getSectionUrl({ sectionId: 'checkout_page' }, function (data) {
            resolve(data);
          });
        }));

        arrPromises.push(new Promise(function (resolve, reject) {
          Wix.Utils.getSectionUrl({ sectionId: 'thank_you_page' }, function (data) {
            resolve(data);
          });
        }));

        if (this.isEditor()) {
          dashboardPromise = new Promise(function (resolve, reject) {
            Wix.Settings.getDashboardAppUrl(function (url) {
              // For some reason - the value does not have the protocol section ( http: ), so we add it ourselves..
              resolve((0, _urijs2.default)(url).protocol('http').search({ appState: '#' }).toString());
            });
          });
        }
        arrPromises.push(dashboardPromise);

        returnPromise = Promise.all(arrPromises).then(function (results) {
          var siteUrl = results[0].baseUrl;
          var url = results[0].url;
          var checkoutUrl = (0, _urijs2.default)(results[1].url).search({}).toString();
          var thankYouUrl = (0, _urijs2.default)(results[2].url).search({}).toString();
          var dashboardUrl = results[3];
          return {
            checkoutUrl: checkoutUrl,
            thankYouUrl: thankYouUrl,
            siteUrl: siteUrl,
            url: url,
            dashboardUrl: dashboardUrl
          };
        });
      } else {
        returnPromise = Promise.reject('Cannot get urls when viewMode is "dashboard"');
      }

      return returnPromise;
    }
  }, {
    key: 'sendStylesToProvider',
    value: function sendStylesToProvider() {
      var _this4 = this;

      styles.getStyles(this.props.styleParams).then(function (css) {
        _this4.postMessage(_providerEvents2.default.css, css);
      });
    }
  }, {
    key: 'handleMessageReceived',
    value: function handleMessageReceived(event) {
      var _this5 = this;

      var intent = this.props.intent;
      var providerData = this.state.providerData;


      if (event.data && event.data.type == Wix.Events.STYLE_PARAMS_CHANGE) {
        this.handleWixStyleChanged();
      }
      // This check is because the provider may get messages that did not originate from the provider.. So we might get messages before the provider is loaded.
      if (providerData) {
        var widgets = providerData.widgets;

        var origin = event.origin || event.originalEvent.origin; // For Chrome, the origin property is in the event.originalEvent object.
        var data = event.data;
        var intentUrl = widgets[intent].url;
        if (intentUrl.indexOf(origin) === 0) {
          var type = data.type,
              token = data.token,
              payload = data.payload,
              callbackId = data.callbackId;


          var resolve = function resolve() {};
          var reject = function reject() {};
          if (callbackId) {
            resolve = function resolve(payload) {
              _this5.postMessage(_providerEvents2.default.callback, { payload: payload, callbackId: callbackId, resolved: true });
            };
            reject = function reject(payload) {
              _this5.postMessage(_providerEvents2.default.callback, { payload: payload, callbackId: callbackId, resolved: false });
            };
          }
          try {
            if (this.state.token && token === this.state.token) {
              if (false) {
                console.log('taltaltal - Provider intent message received: type: ' + type + ' | intent ' + intent);
              }
              switch (type) {
                case _providerEvents2.default.sdkReady:
                  if (this.loader) {
                    $(this.loader).hide();
                  }
                  this.setState({ providerReady: true }, function () {
                    _this5.sendStylesToProvider();
                  });
                  break;
                case _providerEvents2.default.backHome:
                  this.backHome(payload);
                  break;
                case _providerEvents2.default.navigateToUrl:
                  var url = payload.url;

                  window.top.location.href = url;
                  break;
                case _providerEvents2.default.getSiteUrls:
                  this.getSiteUrlsBundle().then(function (urls) {
                    resolve(urls);
                  }).catch(function (err) {
                    reject(err);
                  });
                  break;
                case _providerEvents2.default.getStyles:
                  styles.getStyles(this.props.styleParams).then(function (data) {
                    return resolve(data);
                  });
                  break;
                default:
                  break;
              }

              this.raiseEvent(type, payload, resolve, reject, providerData.providerId);
            }
          } catch (error) {
            console.error('Error handling provider event. Type: ' + type + ' | payload: ' + payload, error);
            if (reject) {
              reject('Error');
            }
          }
        }
      } else {
        // TODO: do something smart
      }
    }
  }, {
    key: 'postMessage',
    value: function postMessage(type, payload) {
      var intent = this.props.intent;
      var _state = this.state,
          providerData = _state.providerData,
          token = _state.token;
      var widgets = providerData.widgets;

      var success = false;
      if (this.intentFrame && type && payload) {
        var obj = { type: type, token: token, payload: payload };
        var providerReady = this.state.providerReady;

        var _window = this.intentFrame.contentWindow;
        if (providerReady) {
          this.intentFrame.contentWindow.postMessage(obj, widgets[intent].url);
          success = true;
        } else {
          // console.error(`cannot send provider message - type: ${type} | intent: ${intent} | payload:`, payload);
        }
      }
      return success;
    }
  }, {
    key: 'onFrameCreated',
    value: function onFrameCreated(element) {
      this.intentFrame = element;
      if (this.props.onFrameCreated) {
        this.props.onFrameCreated();
      }
    }
  }, {
    key: 'getProviderBaseUrl',
    value: function getProviderBaseUrl() {
      var url = null;
      var providerData = this.state.providerData;
      var intent = this.props.intent;


      if (providerData && intent) {
        var widgets = providerData.widgets;

        if (widgets) {
          var baseUrl = widgets[intent];
          url = baseUrl.url;
        }
      }

      return url;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var _state2 = this.state,
          providerData = _state2.providerData,
          anonymousUserId = _state2.anonymousUserId,
          debugApp = _state2.debugApp;


      if (!providerData || !providerData.widgets) {
        return _react2.default.createElement('div', { className: 'circle-preloader' });
      }

      var _props = this.props,
          intent = _props.intent,
          locale = _props.locale,
          deviceType = _props.deviceType,
          viewMode = _props.viewMode,
          additionalParams = _props.additionalParams,
          additionalPath = _props.additionalPath,
          tabIndex = _props.tabIndex;


      if (!deviceType) {
        console.warn('no device type! TODO: take from url');
      }

      var providerId = providerData.providerId,
          signedInstance = providerData.signedInstance;


      var urlAdditionalParams = (0, _urijs2.default)(window.location.href).search(true).additionalParams;
      var objUrlAdditionalParams = {};
      if (urlAdditionalParams) {
        objUrlAdditionalParams = URI('/').search(urlAdditionalParams).search(true);
      }

      var realLocale = locale || Wix.Utils.getLocale();
      var realDeviceType = deviceType || Wix.Utils.getDeviceType();
      var cachekiller = Date.now();
      var url = this.getProviderBaseUrl();
      var realViewMode = viewMode || Wix.Utils.getViewMode();
      var realAdditionalParams = additionalParams || {};
      if (providerId === '147bec5f-d87e-d37b-b5cf-36f47c1815b4' || providerId === '14a0ee97-918b-2f0c-43f1-42e67948716b') {
        // This is specific to the Wix provider.
        realAdditionalParams.biToken = Wix.Utils.getInstanceValue('biToken');
      }
      if (debugApp) {
        realAdditionalParams.debugApp = debugApp;
      }
      var fullUrl = (0, _urijs2.default)(url).segment(additionalPath || '').search(Object.assign({
        pInstance: signedInstance,
        locale: realLocale,
        deviceType: realDeviceType,
        cachekiller: cachekiller,
        anonymousUserId: anonymousUserId,
        viewMode: realViewMode,
        a11y: this.state.isAccessible,
        token: this.state.token
      }, realAdditionalParams || {}, objUrlAdditionalParams));
      var id = intent + '-frame';
      var iframeIndex = tabIndex || -1;
      var renderComponent = _react2.default.createElement('iframe', {
        tabIndex: iframeIndex,
        src: fullUrl,
        id: id,
        ref: function ref(r) {
          return _this6.onFrameCreated(r);
        }
      });

      return _react2.default.createElement(
        'div',
        { className: 'provider-intent-wrapper' },
        _react2.default.createElement('div', { className: 'circle-preloader', ref: function ref(_ref2) {
            return _this6.loader = _ref2;
          } }),
        renderComponent
      );
    }
  }]);

  return ProviderIntent;
}(_react.Component);

ProviderIntent.defaultProps = {
  styleParams: {}
};

exports.default = ProviderIntent;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStyles = getStyles;

var _utils = __webpack_require__(5);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function getStyles(styleParams) {
  var wixSdk = Wix;
  try {
    if (_utils.utils.isInSettings()) {
      wixSdk = window.parent.Wix;
    }
  } catch (error) {}
  return new Promise(function (resolve) {
    return resolve();
  }).then(function () {
    var getColor = function getColor(name, _default) {
      return styleParams[name] ? styleParams[name].value : _default;
    };
    var getFont = function getFont(name, _default) {
      return styleParams[name] || wixSdk.Styles.getStyleFontByReference(_default);
    };

    var color1 = _utils.utils.hexToRgba(wixSdk.Styles.getColorByreference('color-1').value, 1);
    var color5 = _utils.utils.hexToRgba(wixSdk.Styles.getColorByreference('color-5').value, 1);
    var paragraph2 = wixSdk.Styles.getStyleFontByReference('Body-M');

    var background = getColor('bgColorExpand', color1);
    var titleColor = getColor('titleColorExpand', color5);
    var descriptionColor = getColor('descriptionColorExpand', color5);
    var buttonColor = getColor('addToCartColorExpand', color1);
    var buttonBackground = getColor('addToCartBackColorExpand', color5);

    var titleFont = getFont('titleFontExpand', 'Heading-M');
    var descriptionFont = getFont('descriptionFontExpand', 'Body-M');
    var buttonFont = getFont('style.addToCartFontExpand', 'Body-M');

    var styles = {
      title: {
        font: titleFont,
        color: titleColor
      },
      description: {
        font: descriptionFont,
        color: descriptionColor
      },
      button: {
        font: buttonFont,
        color: buttonColor,
        background: buttonBackground
      },
      background: {
        color: background
      }
    };

    return {
      hrefs: getFontsHrefs(titleFont, descriptionFont, paragraph2, buttonFont),
      styles: styles
    };
  });
}

function getFontsHrefs() {
  for (var _len = arguments.length, fonts = Array(_len), _key = 0; _key < _len; _key++) {
    fonts[_key] = arguments[_key];
  }

  var googleHrefs = fonts.map(function (font) {
    return font.fontFamily;
  }).map(function (fontFamily) {
    return getGoogleFontHref(fontFamily);
  }).filter(function (font) {
    return font;
  });
  return getWixFontsHrefs().concat(googleHrefs);
}

function getWixFontsHrefs() {
  var removeHttp = function removeHttp(href) {
    return href.replace('http:', '');
  };
  var removeHttps = function removeHttps(href) {
    return href.replace('https:', '');
  };
  return [].concat(_toConsumableArray(document.styleSheets)).map(function (_ref) {
    var href = _ref.href;
    return href;
  }).filter(function (href) {
    return href && href.toLowerCase().indexOf('font') >= 0;
  }).map(function (href) {
    return removeHttps(href);
  }).map(function (href) {
    return removeHttp(href);
  }).map(function (href) {
    return 'https:' + href;
  });
}

function getGoogleFontHref(fontFamily) {
  var font = getGoogleFonts().find(function (font) {
    return font.fontFamily === fontFamily;
  });
  return font ? 'https://fonts.googleapis.com/icon?family=' + font.cdnName : null;
}

function getGoogleFonts() {
  var _ref2;

  var editorFonts = Wix.Styles.getEditorFonts() || [];
  var wixFontsArrays = editorFonts.map(function (obj) {
    return obj.fonts;
  });
  var fonts = (_ref2 = []).concat.apply(_ref2, _toConsumableArray(wixFontsArrays));
  var googleFonts = fonts.filter(function (font) {
    return font.provider === 'google';
  });
  return googleFonts;
}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_WIX_DATA = exports.SET_WIX_DATA = 'SET_WIX_DATA';
var SET_ITEMS = exports.SET_ITEMS = 'SET_ITEMS';
var SET_RENDERED_ITEMS_COUNT = exports.SET_RENDERED_ITEMS_COUNT = 'SET_RENDERED_ITEMS_COUNT';

var VIDEO_PLAY_MODE = exports.VIDEO_PLAY_MODE = 'VIDEO_PLAY_MODE';
var GALLERY_WINDOW_LAYOUT_CHANGED = exports.GALLERY_WINDOW_LAYOUT_CHANGED = 'GALLERY_WINDOW_LAYOUT_CHANGED';
var VIDEO_ENDED = exports.VIDEO_ENDED = 'VIDEO_ENDED';
var VIDEO_ADDED = exports.VIDEO_ADDED = 'VIDEO_ADDED';
var NAVIGATION_IN = exports.NAVIGATION_IN = 'NAVIGATION_IN';
var EDITOR_MODE_CHANGED = exports.EDITOR_MODE_CHANGED = 'EDITOR_MODE_CHANGED';

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__(2);

var _itemCore = __webpack_require__(103);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } ////// <reference path="../../reference.ts" />


var ItemLayout = function (_ItemCore) {
  _inherits(ItemLayout, _ItemCore);

  function ItemLayout(config) {
    _classCallCheck(this, ItemLayout);

    var _this = _possibleConstructorReturn(this, (ItemLayout.__proto__ || Object.getPrototypeOf(ItemLayout)).call(this, config));

    _this.idx = config.idx;
    _this.smartCrop = config.smartCrop;
    _this.createdBy = config.createdBy;
    _this._offset = {};
    _this._group = {};

    _this.uniqueId = _index.utils.getUUID();
    if (!_index.utils.isSemiNative()) {
      _this.resize(1);
    }
    return _this;
  }

  _createClass(ItemLayout, [{
    key: 'getViewProps',
    value: function getViewProps(config) {

      return _.merge({
        className: 'image',
        key: this.key,
        idx: this.idx,
        photoId: this.photoId,
        id: this.id,
        hash: this.id,
        html: this.html,
        type: this.type,
        url: this.url,
        alt: this.alt,
        linkUrl: this.linkUrl,
        linkOpenType: this.linkOpenType,
        originalsUrl: this.getOriginalsUrl(),
        title: this.title,
        fileName: this.fileName,
        description: this.description,
        full_url: this.full_url,
        download_url: this.download_url,
        square_url: this.square_url,
        pixel_url: this.pixel_url,
        resized_url: this.resized_url,
        thumbnail_url: this.thumbnail_url,
        cubeImages: this.cubeImages,
        cubeType: this.cubeType,
        cubeRatio: this.cubeRatio,
        offset: this._offset,
        style: this.style,
        isDemo: this.isDemo,
        videoUrl: this.videoUrl,
        isExternalVideo: this.isExternalVideo,
        scroll: config.scroll,
        visible: config.visible,
        styleParams: config.styleParams,
        actions: config.actions,
        currentIdx: config.currentIdx
      }, config);
    }
  }, {
    key: 'pinToCorner',
    value: function pinToCorner(cornerName) {

      var isTop = cornerName.indexOf('top') >= 0;
      var isLeft = cornerName.indexOf('left') >= 0;

      this.style.top = isTop ? 0 : 'auto';
      this.style.bottom = isTop ? 'auto' : 0;
      this.style.left = isLeft ? 0 : 'auto';
      this.style.right = isLeft ? 'auto' : 0;

      this.pin = cornerName;
      this.isPinnedTop = isTop;
      this.isPinnedLeft = isLeft;
    }
  }, {
    key: 'setPosition',
    value: function setPosition(position) {
      this.style.position = position;
    }
  }, {
    key: 'getPosition',
    value: function getPosition(pos) {
      return parseInt(pos, 10) >= 0 ? pos : 'auto';
    }
  }, {
    key: 'hash',
    get: function get() {
      return this.id;
    }
  }, {
    key: 'seed',
    get: function get() {
      return _index.utils.hashToInt(this.url);
    }
  }, {
    key: 'key',
    get: function get() {
      if (!this._key) {
        this._key = (this.dto.key || this.id || this.dto.url || 'no_key_found').replace(/\W/g, '');
      }
      return this._key;
    }
  }, {
    key: 'demoTitle',
    get: function get() {
      return 'I am a title, only a sample title but still a title. ';
    }
  }, {
    key: 'demoDescription',
    get: function get() {
      return 'I am a description, the best description ever! Here is some lorem ipsum for you: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.';
    }
  }, {
    key: 'demoExif',
    get: function get() {
      return { "GPSVersionID": "2.2.0.0", "GPSAltitudeRef": "1.8", "GPSAltitude": "0", "Make": "LG Electronics", "Model": "LG-H815L", "Orientation": "right-top", "XResolution": "72", "YResolution": "72", "ResolutionUnit": "2", "Software": "Picasa", "DateTime": "2016:04:17 07:19:25", "YCbCrPositioning": "1", "ExposureTime": "0.041666666666666664", "FNumber": "1.8", "ExifIFDPointer": "214", "ExposureProgram": "Undefined", "GPSInfoIFDPointer": "1262", "PhotographicSensitivity": "200", "ExifVersion": "0220", "DateTimeOriginal": "2016:04:17 07:19:25", "DateTimeDigitized": "2016:04:17 07:19:25", "ComponentsConfiguration": "YCbCr", "ShutterSpeedValue": "4.585", "ApertureValue": "1.69", "BrightnessValue": "-0.88", "ExposureBias": "0", "MeteringMode": "CenterWeightedAverage", "Flash": "Flash did not fire, compulsory flash mode", "FocalLength": "4.42", "UserComment": "32,32,32,70,77,49,32,32,32,70,67,48,48,48,48,48,48,48,48,48,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0", "SubSecTime": "802528", "SubSecTimeOriginal": "802528", "SubSecTimeDigitized": "802528", "FlashpixVersion": "0100", "ColorSpace": "1", "PixelXDimension": "5312", "PixelYDimension": "2988", "InteroperabilityIFDPointer": "1320", "SensingMethod": "Undefined", "SceneType": "Directly photographed", "ExposureMode": "0", "WhiteBalance": "Auto white balance", "DigitalZoomRatio": "1", "SceneCaptureType": "Standard", "ImageUniqueID": "36f6e92221e27c830000000000000000" };
    }
  }, {
    key: 'isImage',
    get: function get() {
      return this.type == 'image';
    }
  }, {
    key: 'isImportant',
    get: function get() {
      return !!this.dto.i;
    }
  }, {
    key: 'videoUrl',
    get: function get() {
      return this.metadata.videoUrl;
    }
  }, {
    key: 'isExternalVideo',
    get: function get() {
      return this.metadata.isExternal;
    }
  }, {
    key: 'orderIndex',
    get: function get() {
      return this.dto.orderIndex || this.dto.o;
    }
  }, {
    key: 'top',
    get: function get() {
      return this.getPosition(this.style.top);
    }
  }, {
    key: 'left',
    get: function get() {
      return this.getPosition(this.style.left);
    }
  }, {
    key: 'right',
    get: function get() {
      return this.getPosition(this.style.right);
    }
  }, {
    key: 'bottom',
    get: function get() {
      return this.getPosition(this.style.bottom);
    }
  }, {
    key: 'group',
    set: function set(group) {
      _.merge(this._group, group);
    }
  }, {
    key: 'offset',
    set: function set(offset) {
      _.merge(this._offset, offset);
    },
    get: function get() {
      return {
        top: this._offset.top + (this.isPinnedTop ? 0 : this._group.height - this.height),
        left: this._offset.left + (this.isPinnedLeft ? 0 : this._group.width - this.width),
        right: this._offset.right - (this.isPinnedLeft ? this._group.width - this.width : 0),
        bottom: this._offset.bottom - (this.isPinnedTop ? this._group.height - this.height : 0)
      };
    }
  }]);

  return ItemLayout;
}(_itemCore.ItemCore);

/*
 <img onLoad={() => this.setItemLoaded()} className={'image' + (this.state.loaded ? '' : '-preload')}
 src={this.props.resized_url}/>
 */

exports.default = ItemLayout;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.itemViewAction = itemViewAction;
exports.playVideo = playVideo;
exports.pauseVideo = pauseVideo;
var ITEM_VIEW_ACTION = exports.ITEM_VIEW_ACTION = 'ITEM_VIEW_ACTION';
var PLAY_VIDEO = exports.PLAY_VIDEO = 'PLAY_VIDEO';
var PAUSE_VIDEO = exports.PAUSE_VIDEO = 'PAUSE_VIDEO';

function itemViewAction() {
  return {
    type: ITEM_VIEW_ACTION
  };
}

function playVideo(idx) {
  return {
    idx: idx,
    type: PLAY_VIDEO
  };
}

function pauseVideo() {
  return {
    type: PAUSE_VIDEO
  };
}

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// export {ItemDTO} from './item-dto';
// export {VideoDTO} from './video-dto';


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = undefined;

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(27);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _storeShape = __webpack_require__(98);

var _storeShape2 = _interopRequireDefault(_storeShape);

var _warning = __webpack_require__(99);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

var Provider = function (_Component) {
  _inherits(Provider, _Component);

  Provider.prototype.getChildContext = function getChildContext() {
    return { store: this.store };
  };

  function Provider(props, context) {
    _classCallCheck(this, Provider);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

    _this.store = props.store;
    return _this;
  }

  Provider.prototype.render = function render() {
    return _react.Children.only(this.props.children);
  };

  return Provider;
}(_react.Component);

exports["default"] = Provider;


if (false) {
  Provider.prototype.componentWillReceiveProps = function (nextProps) {
    var store = this.store;
    var nextStore = nextProps.store;


    if (store !== nextStore) {
      warnAboutReceivingStore();
    }
  };
}

Provider.propTypes = {
  store: _storeShape2["default"].isRequired,
  children: _propTypes2["default"].element.isRequired
};
Provider.childContextTypes = {
  store: _storeShape2["default"].isRequired
};

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(117);
var invariant = __webpack_require__(111);
var ReactPropTypesSecret = __webpack_require__(118);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports["default"] = connect;

var _react = __webpack_require__(0);

var _storeShape = __webpack_require__(98);

var _storeShape2 = _interopRequireDefault(_storeShape);

var _shallowEqual = __webpack_require__(120);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _wrapActionCreators = __webpack_require__(121);

var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);

var _warning = __webpack_require__(99);

var _warning2 = _interopRequireDefault(_warning);

var _isPlainObject = __webpack_require__(126);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _hoistNonReactStatics = __webpack_require__(112);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _invariant = __webpack_require__(95);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultMapStateToProps = function defaultMapStateToProps(state) {
  return {};
}; // eslint-disable-line no-unused-vars
var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
};
var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
  return _extends({}, parentProps, stateProps, dispatchProps);
};

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

var errorObject = { value: null };
function tryCatch(fn, ctx) {
  try {
    return fn.apply(ctx);
  } catch (e) {
    errorObject.value = e;
    return errorObject;
  }
}

// Helps track hot reloading.
var nextVersion = 0;

function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var shouldSubscribe = Boolean(mapStateToProps);
  var mapState = mapStateToProps || defaultMapStateToProps;

  var mapDispatch = void 0;
  if (typeof mapDispatchToProps === 'function') {
    mapDispatch = mapDispatchToProps;
  } else if (!mapDispatchToProps) {
    mapDispatch = defaultMapDispatchToProps;
  } else {
    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
  }

  var finalMergeProps = mergeProps || defaultMergeProps;
  var _options$pure = options.pure,
      pure = _options$pure === undefined ? true : _options$pure,
      _options$withRef = options.withRef,
      withRef = _options$withRef === undefined ? false : _options$withRef;

  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;

  // Helps track hot reloading.
  var version = nextVersion++;

  return function wrapWithConnect(WrappedComponent) {
    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';

    function checkStateShape(props, methodName) {
      if (!(0, _isPlainObject2["default"])(props)) {
        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
      }
    }

    function computeMergedProps(stateProps, dispatchProps, parentProps) {
      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
      if (false) {
        checkStateShape(mergedProps, 'mergeProps');
      }
      return mergedProps;
    }

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
      };

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.store = props.store || context.store;

        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));

        var storeState = _this.store.getState();
        _this.state = { storeState: storeState };
        _this.clearCache();
        return _this;
      }

      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
        if (!this.finalMapStateToProps) {
          return this.configureFinalMapState(store, props);
        }

        var state = store.getState();
        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);

        if (false) {
          checkStateShape(stateProps, 'mapStateToProps');
        }
        return stateProps;
      };

      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
        var mappedState = mapState(store.getState(), props);
        var isFactory = typeof mappedState === 'function';

        this.finalMapStateToProps = isFactory ? mappedState : mapState;
        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;

        if (isFactory) {
          return this.computeStateProps(store, props);
        }

        if (false) {
          checkStateShape(mappedState, 'mapStateToProps');
        }
        return mappedState;
      };

      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
        if (!this.finalMapDispatchToProps) {
          return this.configureFinalMapDispatch(store, props);
        }

        var dispatch = store.dispatch;

        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);

        if (false) {
          checkStateShape(dispatchProps, 'mapDispatchToProps');
        }
        return dispatchProps;
      };

      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
        var mappedDispatch = mapDispatch(store.dispatch, props);
        var isFactory = typeof mappedDispatch === 'function';

        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;

        if (isFactory) {
          return this.computeDispatchProps(store, props);
        }

        if (false) {
          checkStateShape(mappedDispatch, 'mapDispatchToProps');
        }
        return mappedDispatch;
      };

      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
        var nextStateProps = this.computeStateProps(this.store, this.props);
        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
          return false;
        }

        this.stateProps = nextStateProps;
        return true;
      };

      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
          return false;
        }

        this.dispatchProps = nextDispatchProps;
        return true;
      };

      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
          return false;
        }

        this.mergedProps = nextMergedProps;
        return true;
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return typeof this.unsubscribe === 'function';
      };

      Connect.prototype.trySubscribe = function trySubscribe() {
        if (shouldSubscribe && !this.unsubscribe) {
          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
          this.handleChange();
        }
      };

      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
        if (this.unsubscribe) {
          this.unsubscribe();
          this.unsubscribe = null;
        }
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        this.trySubscribe();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
          this.haveOwnPropsChanged = true;
        }
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        this.tryUnsubscribe();
        this.clearCache();
      };

      Connect.prototype.clearCache = function clearCache() {
        this.dispatchProps = null;
        this.stateProps = null;
        this.mergedProps = null;
        this.haveOwnPropsChanged = true;
        this.hasStoreStateChanged = true;
        this.haveStatePropsBeenPrecalculated = false;
        this.statePropsPrecalculationError = null;
        this.renderedElement = null;
        this.finalMapDispatchToProps = null;
        this.finalMapStateToProps = null;
      };

      Connect.prototype.handleChange = function handleChange() {
        if (!this.unsubscribe) {
          return;
        }

        var storeState = this.store.getState();
        var prevStoreState = this.state.storeState;
        if (pure && prevStoreState === storeState) {
          return;
        }

        if (pure && !this.doStatePropsDependOnOwnProps) {
          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
          if (!haveStatePropsChanged) {
            return;
          }
          if (haveStatePropsChanged === errorObject) {
            this.statePropsPrecalculationError = errorObject.value;
          }
          this.haveStatePropsBeenPrecalculated = true;
        }

        this.hasStoreStateChanged = true;
        this.setState({ storeState: storeState });
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');

        return this.refs.wrappedInstance;
      };

      Connect.prototype.render = function render() {
        var haveOwnPropsChanged = this.haveOwnPropsChanged,
            hasStoreStateChanged = this.hasStoreStateChanged,
            haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated,
            statePropsPrecalculationError = this.statePropsPrecalculationError,
            renderedElement = this.renderedElement;


        this.haveOwnPropsChanged = false;
        this.hasStoreStateChanged = false;
        this.haveStatePropsBeenPrecalculated = false;
        this.statePropsPrecalculationError = null;

        if (statePropsPrecalculationError) {
          throw statePropsPrecalculationError;
        }

        var shouldUpdateStateProps = true;
        var shouldUpdateDispatchProps = true;
        if (pure && renderedElement) {
          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
        }

        var haveStatePropsChanged = false;
        var haveDispatchPropsChanged = false;
        if (haveStatePropsBeenPrecalculated) {
          haveStatePropsChanged = true;
        } else if (shouldUpdateStateProps) {
          haveStatePropsChanged = this.updateStatePropsIfNeeded();
        }
        if (shouldUpdateDispatchProps) {
          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
        }

        var haveMergedPropsChanged = true;
        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
        } else {
          haveMergedPropsChanged = false;
        }

        if (!haveMergedPropsChanged && renderedElement) {
          return renderedElement;
        }

        if (withRef) {
          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
            ref: 'wrappedInstance'
          }));
        } else {
          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
        }

        return this.renderedElement;
      };

      return Connect;
    }(_react.Component);

    Connect.displayName = connectDisplayName;
    Connect.WrappedComponent = WrappedComponent;
    Connect.contextTypes = {
      store: _storeShape2["default"]
    };
    Connect.propTypes = {
      store: _storeShape2["default"]
    };

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        if (this.version === version) {
          return;
        }

        // We are hot reloading!
        this.version = version;
        this.trySubscribe();
        this.clearCache();
      };
    }

    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
  };
}

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = shallowEqual;
function shallowEqual(objA, objB) {
  if (objA === objB) {
    return true;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var hasOwn = Object.prototype.hasOwnProperty;
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = wrapActionCreators;

var _redux = __webpack_require__(62);

function wrapActionCreators(actionCreators) {
  return function (dispatch) {
    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
  };
}

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(10)))

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(124);


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = __webpack_require__(125);

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var root; /* global window */


if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10), __webpack_require__(28)(module)))

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(127),
    getPrototype = __webpack_require__(132),
    isObjectLike = __webpack_require__(134);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(100),
    getRawTag = __webpack_require__(130),
    objectToString = __webpack_require__(131);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(129);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(100);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 131 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(133);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 133 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 134 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.propTypes = undefined;

var _react = __webpack_require__(0);

var string = _react.PropTypes.string,
    bool = _react.PropTypes.bool,
    number = _react.PropTypes.number,
    oneOfType = _react.PropTypes.oneOfType,
    shape = _react.PropTypes.shape,
    object = _react.PropTypes.object,
    func = _react.PropTypes.func;
var propTypes = exports.propTypes = {
  url: string,
  playing: bool,
  loop: bool,
  controls: bool,
  volume: number,
  playbackRate: number,
  width: oneOfType([string, number]),
  height: oneOfType([string, number]),
  hidden: bool,
  className: string,
  style: object,
  progressFrequency: number,
  soundcloudConfig: shape({
    clientId: string,
    showArtwork: bool
  }),
  youtubeConfig: shape({
    playerVars: object,
    preload: bool
  }),
  vimeoConfig: shape({
    iframeParams: object,
    preload: bool
  }),
  fileConfig: shape({
    attributes: object
  }),
  onReady: func,
  onStart: func,
  onPlay: func,
  onPause: func,
  onBuffer: func,
  onEnded: func,
  onError: func,
  onDuration: func
};

var defaultProps = exports.defaultProps = {
  playing: false,
  loop: false,
  controls: false,
  volume: 0.8,
  playbackRate: 1,
  width: 640,
  height: 360,
  hidden: false,
  progressFrequency: 100,
  soundcloudConfig: {
    clientId: 'e8b6f84fbcad14c301ca1355cae1dea2',
    showArtwork: true
  },
  youtubeConfig: {
    playerVars: {},
    preload: false
  },
  vimeoConfig: {
    iframeParams: {},
    preload: false
  },
  fileConfig: {
    attributes: {}
  },
  onReady: function onReady() {},
  onStart: function onStart() {},
  onPlay: function onPlay() {},
  onPause: function onPause() {},
  onBuffer: function onBuffer() {},
  onEnded: function onEnded() {},
  onError: function onError() {},
  onDuration: function onDuration() {}
};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _props2 = __webpack_require__(135);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SEEK_ON_PLAY_EXPIRY = 5000;

var BasePlayer = function (_Component) {
  _inherits(BasePlayer, _Component);

  function BasePlayer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BasePlayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BasePlayer.__proto__ || Object.getPrototypeOf(BasePlayer)).call.apply(_ref, [this].concat(args))), _this), _this.isReady = false, _this.startOnPlay = true, _this.durationOnPlay = false, _this.seekOnPlay = null, _this.onPlay = function () {
      var _this$props = _this.props,
          volume = _this$props.volume,
          onStart = _this$props.onStart,
          onPlay = _this$props.onPlay,
          onDuration = _this$props.onDuration,
          playbackRate = _this$props.playbackRate;

      if (_this.startOnPlay) {
        _this.setPlaybackRate(playbackRate);
        _this.setVolume(volume);
        onStart();
        _this.startOnPlay = false;
      }
      onPlay();
      if (_this.seekOnPlay) {
        _this.seekTo(_this.seekOnPlay);
        _this.seekOnPlay = null;
      }
      if (_this.durationOnPlay) {
        onDuration(_this.getDuration());
        _this.durationOnPlay = false;
      }
    }, _this.onReady = function () {
      var _this$props2 = _this.props,
          onReady = _this$props2.onReady,
          playing = _this$props2.playing,
          onDuration = _this$props2.onDuration;

      _this.isReady = true;
      onReady();
      if (playing || _this.preloading) {
        _this.preloading = false;
        if (_this.loadOnReady) {
          _this.load(_this.loadOnReady);
          _this.loadOnReady = null;
        } else {
          _this.play();
        }
      }
      var duration = _this.getDuration();
      if (duration) {
        onDuration(duration);
      } else {
        _this.durationOnPlay = true;
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(BasePlayer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var url = this.props.url;

      this.mounted = true;
      if (url) {
        this.load(url);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
      this.mounted = false;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          url = _props.url,
          playing = _props.playing,
          volume = _props.volume,
          playbackRate = _props.playbackRate;
      // Invoke player methods based on incoming props

      if (url !== nextProps.url && nextProps.url) {
        this.seekOnPlay = null;
        this.startOnPlay = true;
        this.load(nextProps.url);
      } else if (url && !nextProps.url) {
        this.stop();
        clearTimeout(this.updateTimeout);
      } else if (!playing && nextProps.playing) {
        this.play();
      } else if (playing && !nextProps.playing) {
        this.pause();
      } else if (volume !== nextProps.volume) {
        this.setVolume(nextProps.volume);
      } else if (playbackRate !== nextProps.playbackRate) {
        this.setPlaybackRate(nextProps.playbackRate);
      }
    }
    // shouldComponentUpdate (nextProps) {
    //   return this.props.url !== nextProps.url
    // }

  }, {
    key: 'seekTo',
    value: function seekTo(fraction) {
      var _this2 = this;

      // When seeking before player is ready, store value and seek later
      if (!this.isReady && fraction !== 0) {
        this.seekOnPlay = fraction;
        setTimeout(function () {
          _this2.seekOnPlay = null;
        }, SEEK_ON_PLAY_EXPIRY);
      }
    }
  }]);

  return BasePlayer;
}(_react.Component);

BasePlayer.propTypes = _props2.propTypes;
BasePlayer.defaultProps = _props2.defaultProps;
exports['default'] = BasePlayer;
module.exports = exports['default'];

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  singleProduct: 'SINGLE_PRODUCT',
  productsList: 'PRODUCTS_LIST'
};
//# sourceMappingURL=mobileViewTypes.js.map


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dataItem = __webpack_require__(237);

var _dataItem2 = _interopRequireDefault(_dataItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Represents bi events from the "fed monitoring" source:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72
 */
var BiBaseDataItem = function (_DataItem) {
  _inherits(BiBaseDataItem, _DataItem);

  function BiBaseDataItem(evid, sessionId) {
    _classCallCheck(this, BiBaseDataItem);

    return _possibleConstructorReturn(this, (BiBaseDataItem.__proto__ || Object.getPrototypeOf(BiBaseDataItem)).call(this, {
      src: 72,
      evid: evid,
      session_id: sessionId, // eslint-disable-line
      _: new Date().getTime() // cache buster
    }));
  }

  return BiBaseDataItem;
}(_dataItem2.default);

exports.default = BiBaseDataItem;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var repeat = exports.repeat = function repeat(str, times) {
  return new Array(times + 1).join(str);
};

var pad = exports.pad = function pad(num, maxLength) {
  return repeat("0", maxLength - num.toString().length) + num;
};

var formatTime = exports.formatTime = function formatTime(time) {
  return pad(time.getHours(), 2) + ":" + pad(time.getMinutes(), 2) + ":" + pad(time.getSeconds(), 2) + "." + pad(time.getMilliseconds(), 3);
};

// Use performance API if it's available in order to get better precision
var timer = exports.timer = typeof performance !== "undefined" && performance !== null && typeof performance.now === "function" ? performance : Date;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initWixData = initWixData;
exports.navigationIn = navigationIn;
exports.videoPlayModeChanged = videoPlayModeChanged;
exports.videoEnded = videoEnded;
exports.videoAdded = videoAdded;
exports.galleryWindowLayoutChanged = galleryWindowLayoutChanged;
exports.editorModeChanged = editorModeChanged;

var _index = __webpack_require__(2);

var _galleryTypes = __webpack_require__(109);

function initWixData() {
  if (_index.utils.isInWix() && !_index.utils.isDemo()) {
    return function (dispatch) {
      Wix.getBoundingRectAndOffsets(function (res) {
        dispatch({
          type: _galleryTypes.SET_WIX_DATA,
          boundingRectAndOffsets: res
        });
      });
    };
  } else {
    return {
      type: _galleryTypes.SET_WIX_DATA
    };
  }
}

// export function setItems(items) {
//     return {
//         items: items,
//         type: SET_ITEMS
//     }
// }
//
//
// export function setRenderedItemsCount(count) {
//     return {
//         count: count,
//         type: SET_RENDERED_ITEMS_COUNT
//     }
// }

function navigationIn() {
  return {
    videoIndexAutoPlay: _index.utils.isEditor() ? -1 : window.videoQueue.next(),
    type: _galleryTypes.NAVIGATION_IN
  };
}

function videoPlayModeChanged(videoPlayMode) {
  return {
    videoPlayMode: videoPlayMode,
    type: _galleryTypes.VIDEO_PLAY_MODE
  };
}

function videoEnded(idx) {
  return {
    videoIndexAutoPlay: window.videoQueue.next(),
    type: _galleryTypes.VIDEO_ENDED
  };
}

function videoAdded(idx) {
  return {
    videoIndexAutoPlay: idx,
    type: _galleryTypes.VIDEO_ADDED
  };
}

function galleryWindowLayoutChanged(_ref) {
  var documentHeight = _ref.documentHeight;

  var q = window.videoQueue;
  var nextIdx = q.isCurrentVideoVisible() ? q.current() : q.next();
  return {
    documentHeight: documentHeight,
    videoIndexAutoPlay: nextIdx,
    type: _galleryTypes.GALLERY_WINDOW_LAYOUT_CHANGED
  };
}

function editorModeChanged() {
  var q = window.videoQueue;
  var nextIdx = _index.utils.isEditor() ? -1 : q.isCurrentVideoVisible() ? q.current() : q.next();
  return {
    videoIndexAutoPlay: nextIdx,
    type: _galleryTypes.EDITOR_MODE_CHANGED
  };
}

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VideoQueue = exports.VideoQueue = function () {
  function VideoQueue() {
    _classCallCheck(this, VideoQueue);

    this.que = [];
    this.dummyVideo = { idx: -1, isVisible: function isVisible() {
        return false;
      } };
    this.video = this.dummyVideo;
  }

  _createClass(VideoQueue, [{
    key: "current",
    value: function current() {
      return this.video.idx;
    }
  }, {
    key: "isCurrentVideoVisible",
    value: function isCurrentVideoVisible() {
      return this.video.isVisible();
    }
  }, {
    key: "next",
    value: function next() {
      if (this.que.length === 0) {
        return null;
      }
      var i = this.que.indexOf(this.video);
      var nextVideo = this.nextVisibleVideo(i + 1);

      this.video = nextVideo;
      return this.video.idx;
    }
  }, {
    key: "nextVisibleVideo",
    value: function nextVisibleVideo(j) {
      var len = this.que.length,
          queIndex = void 0;
      for (var i = 0; i < len; i++) {
        queIndex = (i + j) % len;
        if (this.que[queIndex].isVisible()) {
          break;
        }
      }
      return this.que[queIndex].isVisible() ? this.que[queIndex] : this.dummyVideo;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.que.length === 0;
    }
  }, {
    key: "addItem",
    value: function addItem(item) {
      if (this.isEmpty()) {
        this.video = item;
      }
      this.que.push(item);
    }
  }, {
    key: "removeItem",
    value: function removeItem(id) {
      this.que = this.que.filter(function (element) {
        return element.idx !== id;
      });
      if (this.isEmpty()) {
        this.video = this.dummyVideo;
      }
    }
  }]);

  return VideoQueue;
}();

/***/ }),
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(62);

var _loveButtonReducer = __webpack_require__(147);

var _loveButtonReducer2 = _interopRequireDefault(_loveButtonReducer);

var _galleryReducer = __webpack_require__(149);

var _galleryReducer2 = _interopRequireDefault(_galleryReducer);

var _fullscreenReducer = __webpack_require__(150);

var _fullscreenReducer2 = _interopRequireDefault(_fullscreenReducer);

var _multishareReducer = __webpack_require__(152);

var _multishareReducer2 = _interopRequireDefault(_multishareReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  loveButton: _loveButtonReducer2.default,
  gallery: _galleryReducer2.default,
  fullscreen: _fullscreenReducer2.default,
  multishare: _multishareReducer2.default
});

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = loveButtonReducer;

var _actionTypes = __webpack_require__(148);

var _lodash = __webpack_require__(4);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    isLoved: false,
    count: 0
};

function loveButtonReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _actionTypes.TOGGLE_LOVE:
            var newCount = action.isLoved ? state.count + 1 : state.count - 1;
            return _lodash2.default.merge({}, state, { isLoved: action.isLoved, count: newCount });
        default:
            return state;
    }
}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var TOGGLE_LOVE = exports.TOGGLE_LOVE = 'TOGGLE_LOVE';
var PROOF_ITEM_HOVER = exports.PROOF_ITEM_HOVER = 'PROOF_ITEM_HOVER';
var PROOF_ITEM_SELECT = exports.PROOF_ITEM_SELECT = 'PROOF_ITEM_SELECT';
var PROOF_MODE_CHANGE = exports.PROOF_MODE_CHANGE = 'PROOF_MODE_CHANGE';

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = galleryReducer;

var _galleryTypes = __webpack_require__(109);

var _itemViewActions = __webpack_require__(113);

var _initialState = __webpack_require__(101);

var _initialState2 = _interopRequireDefault(_initialState);

var _lodash = __webpack_require__(4);

var _lodash2 = _interopRequireDefault(_lodash);

var _utils = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function galleryReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.gallery;
  var action = arguments[1];

  var isAutoPlayMode = function isAutoPlayMode() {
    return state.videoPlayMode !== 'auto' || _utils.utils.isEditor();
  };

  switch (action.type) {
    case _galleryTypes.SET_WIX_DATA:
      if (action.boundingRectAndOffsets) {
        var res = action.boundingRectAndOffsets;
        var scrollBase = res.offsets.y;
        var scrollTop = -1 * res.rect.top / _utils.utils.getViewportScaleRatio();
        var maxGalleryWidth;
        if (res && res.rect && !_lodash2.default.isUndefined(res.rect.width)) {
          maxGalleryWidth = res.rect.width;
        }

        return _lodash2.default.merge({}, state, {
          wixInit: true,
          scrollBase: scrollBase,
          scrollTop: scrollTop,
          maxGalleryWidth: maxGalleryWidth
        });
      } else {
        return _lodash2.default.merge({}, state, {
          wixInit: true,
          scrollBase: 0
        });
      }

    case _galleryTypes.SET_ITEMS:
      return _lodash2.default.merge({}, state, { items: action.items });

    case _galleryTypes.SET_RENDERED_ITEMS_COUNT:
      return _lodash2.default.merge({}, state, { renderedItemsCount: action.count });

    case _galleryTypes.VIDEO_PLAY_MODE:
      return _lodash2.default.merge({}, state, { videoPlayMode: action.videoPlayMode });

    case _galleryTypes.VIDEO_ADDED:
      return isAutoPlayMode() || state.videoIndexPlay !== -1 ? state : _lodash2.default.merge({}, state, { videoIndexPlay: action.videoIndexAutoPlay });

    case _galleryTypes.GALLERY_WINDOW_LAYOUT_CHANGED:
      var documentHeight = { documentHeight: action.documentHeight };
    case _galleryTypes.NAVIGATION_IN:
    case _galleryTypes.VIDEO_ENDED:
      return isAutoPlayMode() ? state : _lodash2.default.merge({}, state, { videoIndexPlay: action.videoIndexAutoPlay }, documentHeight);

    case _galleryTypes.EDITOR_MODE_CHANGED:
      var videoIndexPlay = state.videoPlayMode == 'auto' ? action.videoIndexAutoPlay : -1;
      return _lodash2.default.merge({}, state, { videoIndexPlay: videoIndexPlay });

    case _itemViewActions.PLAY_VIDEO:
      return _lodash2.default.merge({}, state, { videoIndexPlay: action.idx });

    case _itemViewActions.PAUSE_VIDEO:
      return _lodash2.default.merge({}, state, { videoIndexPlay: -1 });

    default:
      return state;
  }
}

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fullscreenReducer;

var _fullscreenActions = __webpack_require__(151);

var _initialState = __webpack_require__(101);

var _initialState2 = _interopRequireDefault(_initialState);

var _lodash = __webpack_require__(4);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fullscreenReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.fullscreen;
  var action = arguments[1];


  switch (action.type) {
    case _fullscreenActions.SET_SLIDE:
      return _lodash2.default.merge({}, state, {
        slideIdx: action.slideIdx
      });

    default:
      return state;
  }
}

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setSlide = setSlide;
var SET_SLIDE = exports.SET_SLIDE = 'SET_SLIDE';

function setSlide(slideIdx) {

  return {
    type: SET_SLIDE,
    slideIdx: slideIdx
  };
}

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = multishareReducer;

var _initialState = __webpack_require__(101);

var _initialState2 = _interopRequireDefault(_initialState);

var _lodash = __webpack_require__(4);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import {} from '../actions/multishareActions.js';
function multishareReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.multishare;
  var action = arguments[1];


  switch (action.type) {
    default:
      return state;
  }
}

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _cartApi = __webpack_require__(26);

var _cartApi2 = _interopRequireDefault(_cartApi);

var _consts = __webpack_require__(11);

var _utils = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FullscreenCartButton = function (_React$Component) {
  _inherits(FullscreenCartButton, _React$Component);

  function FullscreenCartButton(props) {
    _classCallCheck(this, FullscreenCartButton);

    var _this = _possibleConstructorReturn(this, (FullscreenCartButton.__proto__ || Object.getPrototypeOf(FullscreenCartButton)).call(this, props));

    _this.addToCart = _this.addToCart.bind(_this);
    _this.state = {
      buttonClassNames: 'add-to-cart-button'
    };
    return _this;
  }

  _createClass(FullscreenCartButton, [{
    key: 'addToCart',
    value: function addToCart() {
      if (this.props.isSettings) {
        return;
      }

      if (this.props.onAddToCartRequest) {
        this.props.onAddToCartRequest();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var cartItems = this.props.cartItems || [];
      var buttonClassNames = cartItems.length ? 'add-to-cart-button checkout-link-appears' : 'add-to-cart-button';

      var buttonDefaultText = _utils.TranslationUtil ? _utils.TranslationUtil.getByKey('Gallery_ArtStore_UOU_Add_To_Cart_Button') : '';
      var buttonText = this.props.styleParams.addToCartButtonText || buttonDefaultText;

      return _react2.default.createElement(
        'button',
        {
          className: buttonClassNames,
          tabIndex: _utils.utils.getTabIndex('fullscreenCartButton'),
          'aria-label': buttonText,
          onClick: this.addToCart
        },
        _react2.default.createElement(
          'div',
          null,
          buttonText
        ),
        _react2.default.createElement('div', { className: 'overlay' })
      );
    }
  }]);

  return FullscreenCartButton;
}(_react2.default.Component);

exports.default = FullscreenCartButton;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _cartApi = __webpack_require__(26);

var _cartApi2 = _interopRequireDefault(_cartApi);

var _consts = __webpack_require__(11);

var _utils = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FullscreenCheckoutLink = function (_React$Component) {
  _inherits(FullscreenCheckoutLink, _React$Component);

  function FullscreenCheckoutLink() {
    _classCallCheck(this, FullscreenCheckoutLink);

    return _possibleConstructorReturn(this, (FullscreenCheckoutLink.__proto__ || Object.getPrototypeOf(FullscreenCheckoutLink)).apply(this, arguments));
  }

  _createClass(FullscreenCheckoutLink, [{
    key: 'render',
    value: function render() {
      var cartItems = this.props.cartItems || [];
      var renderComponent = null;
      var cartItemsCount = cartItems.length;
      if (cartItemsCount) {
        var linkText = _utils.TranslationUtil.getByKey('Gallery_ArtStore_UOU_Continue_Checkout_Label') + (' (' + cartItemsCount + ')');

        renderComponent = _react2.default.createElement(
          'button',
          {
            className: 'checkout-link',
            onClick: this.props.onClick,
            tabIndex: _utils.utils.getTabIndex('fullscreenCheckout'),
            'aria-label': linkText
          },
          linkText
        );
      }

      return renderComponent;
    }
  }]);

  return FullscreenCheckoutLink;
}(_react2.default.Component);

exports.default = FullscreenCheckoutLink;

/***/ }),
/* 155 */,
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _props3 = __webpack_require__(135);

var _YouTube = __webpack_require__(204);

var _YouTube2 = _interopRequireDefault(_YouTube);

var _SoundCloud = __webpack_require__(207);

var _SoundCloud2 = _interopRequireDefault(_SoundCloud);

var _Vimeo = __webpack_require__(209);

var _Vimeo2 = _interopRequireDefault(_Vimeo);

var _FilePlayer = __webpack_require__(105);

var _FilePlayer2 = _interopRequireDefault(_FilePlayer);

var _Streamable = __webpack_require__(210);

var _Streamable2 = _interopRequireDefault(_Streamable);

var _Vidme = __webpack_require__(211);

var _Vidme2 = _interopRequireDefault(_Vidme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReactPlayer = function (_Component) {
  _inherits(ReactPlayer, _Component);

  function ReactPlayer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReactPlayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReactPlayer.__proto__ || Object.getPrototypeOf(ReactPlayer)).call.apply(_ref, [this].concat(args))), _this), _this.seekTo = function (fraction) {
      if (_this.player) {
        _this.player.seekTo(fraction);
      }
    }, _this.stopBuffering = function () {
      if (_this.player && _this.player.stopBuffering) {
        _this.player.stopBuffering();
      }
    }, _this.progress = function () {
      if (_this.props.url && _this.player) {
        var loaded = _this.player.getFractionLoaded() || 0;
        var played = _this.player.getFractionPlayed() || 0;
        var progress = {};
        if (loaded !== _this.prevLoaded) {
          progress.loaded = loaded;
        }
        if (_this.props.playing) {
          if (played !== _this.prevPlayed) {
            progress.played = played;
          }
          var buffering = !progress.played;
          if (buffering !== _this.prevBuffering) {
            _this.props.onBuffer(buffering);
            _this.prevBuffering = buffering;
          }
        }
        if (progress.loaded || progress.played) {
          _this.props.onProgress(progress);
        }
        _this.prevLoaded = loaded;
        _this.prevPlayed = played;
      }
      _this.progressTimeout = setTimeout(_this.progress, _this.props.progressFrequency);
    }, _this.ref = function (player) {
      _this.player = player;
    }, _this.renderPlayer = function (Player) {
      var active = Player.canPlay(_this.props.url);

      var _this$props = _this.props,
          youtubeConfig = _this$props.youtubeConfig,
          soundcloudConfig = _this$props.soundcloudConfig,
          vimeoConfig = _this$props.vimeoConfig,
          fileConfig = _this$props.fileConfig,
          activeProps = _objectWithoutProperties(_this$props, ['youtubeConfig', 'soundcloudConfig', 'vimeoConfig', 'fileConfig']);

      var props = active ? _extends({}, activeProps, { ref: _this.ref }) : {};
      return _react2['default'].createElement(Player, _extends({
        key: Player.displayName,
        youtubeConfig: youtubeConfig,
        soundcloudConfig: soundcloudConfig,
        vimeoConfig: vimeoConfig,
        fileConfig: fileConfig
      }, props));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReactPlayer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.onProgress) {
        this.progress();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.progressTimeout);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props.url !== nextProps.url || this.props.playing !== nextProps.playing || this.props.volume !== nextProps.volume || this.props.playbackRate !== nextProps.playbackRate || this.props.height !== nextProps.height || this.props.width !== nextProps.width || this.props.hidden !== nextProps.hidden || this.props.fileConfig !== nextProps.fileConfig;
    }
  }, {
    key: 'renderPlayers',
    value: function renderPlayers() {
      // Build array of players to render based on URL and preload config
      var _props = this.props,
          url = _props.url,
          youtubeConfig = _props.youtubeConfig,
          vimeoConfig = _props.vimeoConfig;

      var players = [];
      if (_YouTube2['default'].canPlay(url)) {
        players.push(_YouTube2['default']);
      } else if (_SoundCloud2['default'].canPlay(url)) {
        players.push(_SoundCloud2['default']);
      } else if (_Vimeo2['default'].canPlay(url)) {
        players.push(_Vimeo2['default']);
      } else if (_Streamable2['default'].canPlay(url)) {
        players.push(_Streamable2['default']);
      } else if (_Vidme2['default'].canPlay(url)) {
        players.push(_Vidme2['default']);
      } else if (url) {
        // Fall back to FilePlayer if nothing else can play the URL
        players.push(_FilePlayer2['default']);
      }
      // Render additional players if preload config is set
      if (!_YouTube2['default'].canPlay(url) && youtubeConfig.preload) {
        players.push(_YouTube2['default']);
      }
      if (!_Vimeo2['default'].canPlay(url) && vimeoConfig.preload) {
        players.push(_Vimeo2['default']);
      }
      return players.map(this.renderPlayer);
    }
  }, {
    key: 'onWrapperClick',
    value: function onWrapperClick() {
      if (this.props.onWrapperClick) {
        this.props.onWrapperClick();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          style = _props2.style,
          width = _props2.width,
          height = _props2.height,
          className = _props2.className,
          hidden = _props2.hidden;

      var players = this.renderPlayers();
      // const isExternalPlayer = YouTube.canPlay(this.props.url) || Vimeo.canPlay(this.props.url)
      var thumbnail = _react2['default'].createElement('img', { src: this.props.poster, width: this.props.width + 'px', height: this.props.height + 'px', className: 'gallery--placeholder-item' });

      return _react2['default'].createElement(
        'div',
        { style: _extends({}, style, { width: width, height: height }), className: className, hidden: hidden, onClick: this.onWrapperClick.bind(this) },
        this.props.mockPlayer ? thumbnail : players
      );
    }
  }]);

  return ReactPlayer;
}(_react.Component);

ReactPlayer.displayName = 'ReactPlayer';
ReactPlayer.propTypes = _props3.propTypes;
ReactPlayer.defaultProps = _props3.defaultProps;
exports['default'] = ReactPlayer;
module.exports = exports['default'];

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommonItemContainer = exports.CommonItemContainerNotConnected = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _galleryActions = __webpack_require__(140);

var _itemViewActions = __webpack_require__(113);

var _reactRedux = __webpack_require__(97);

var _itemActions = __webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CommonItemContainerNotConnected = exports.CommonItemContainerNotConnected = function CommonItemContainerNotConnected(ComposedComponent) {
  var InnerComponent = function (_Component) {
    _inherits(InnerComponent, _Component);

    function InnerComponent(props, context) {
      _classCallCheck(this, InnerComponent);

      var _this = _possibleConstructorReturn(this, (InnerComponent.__proto__ || Object.getPrototypeOf(InnerComponent)).call(this, props, context));

      _this.updateLoveCount = _this.updateLoveCount.bind(_this);

      _this.state = {
        isLoved: _itemActions.itemActions.isLoved(props.photoId),
        loveCount: 0
      };
      return _this;
    }

    _createClass(InnerComponent, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        window.addEventListener('love_count_fetched', this.updateLoveCount);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        window.removeEventListener('love_count_fetched', this.updateLoveCount);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var photoId = nextProps.photoId;

        this.setState({
          isLoved: _itemActions.itemActions.isLoved(photoId),
          loveCount: _itemActions.itemActions.getLoveCount(photoId)
        });
      }
    }, {
      key: 'updateLoveCount',
      value: function updateLoveCount() {
        this.setState({
          loveCount: _itemActions.itemActions.getLoveCount(this.props.photoId)
        });
      }
    }, {
      key: 'toggleLove',
      value: function toggleLove() {
        _itemActions.itemActions.postLoveActivity(this.props);
        _itemActions.itemActions.toggleLove(this.props.photoId, 'gallery');
        this.setState({
          isLoved: !this.state.isLoved
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var photoId = this.props.photoId;
        var _state = this.state,
            isLoved = _state.isLoved,
            loveCount = _state.loveCount;

        return _react2.default.createElement(ComposedComponent, _extends({}, this.props, {
          love: {
            isLoved: isLoved,
            count: loveCount + (isLoved ? 1 : 0),
            toggleLove: this.toggleLove.bind(this)
          }
        }));
      }
    }]);

    return InnerComponent;
  }(_react.Component);

  ;

  return InnerComponent;
};

var CommonItemContainer = exports.CommonItemContainer = function CommonItemContainer(ComposedComponent) {
  var commonItemContainerNotConnected = CommonItemContainerNotConnected(ComposedComponent);

  var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {
      playing: state.gallery && state.gallery.videoIndexPlay === ownProps.idx,
      documentHeight: state.gallery && state.gallery.documentHeight
    };
  };

  return (0, _reactRedux.connect)(mapStateToProps, { videoEnded: _galleryActions.videoEnded, videoAdded: _galleryActions.videoAdded, playVideo: _itemViewActions.playVideo, pauseVideo: _itemViewActions.pauseVideo })(commonItemContainerNotConnected);
};

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logger = exports.defaults = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _core = __webpack_require__(162);

var _helpers = __webpack_require__(139);

var _defaults = __webpack_require__(165);

var _defaults2 = _interopRequireDefault(_defaults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates logger with following options
 *
 * @namespace
 * @param {object} options - options for logger
 * @param {string | function | object} options.level - console[level]
 * @param {boolean} options.duration - print duration of each action?
 * @param {boolean} options.timestamp - print timestamp with each action?
 * @param {object} options.colors - custom colors
 * @param {object} options.logger - implementation of the `console` API
 * @param {boolean} options.logErrors - should errors in action execution be caught, logged, and re-thrown?
 * @param {boolean} options.collapsed - is group collapsed?
 * @param {boolean} options.predicate - condition which resolves logger behavior
 * @param {function} options.stateTransformer - transform state before print
 * @param {function} options.actionTransformer - transform action before print
 * @param {function} options.errorTransformer - transform error before print
 *
 * @returns {function} logger middleware
 */
function createLogger() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var loggerOptions = _extends({}, _defaults2.default, options);

  var logger = loggerOptions.logger,
      transformer = loggerOptions.transformer,
      stateTransformer = loggerOptions.stateTransformer,
      errorTransformer = loggerOptions.errorTransformer,
      predicate = loggerOptions.predicate,
      logErrors = loggerOptions.logErrors,
      diffPredicate = loggerOptions.diffPredicate;

  // Return if 'console' object is not defined

  if (typeof logger === 'undefined') {
    return function () {
      return function (next) {
        return function (action) {
          return next(action);
        };
      };
    };
  }

  if (transformer) {
    console.error('Option \'transformer\' is deprecated, use \'stateTransformer\' instead!'); // eslint-disable-line no-console
  }

  // Detect if 'createLogger' was passed directly to 'applyMiddleware'.
  if (options.getState && options.dispatch) {
    // eslint-disable-next-line no-console
    console.error('[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n\n// Logger with default options\nimport { logger } from \'redux-logger\'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n\n\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from \'redux-logger\'\n\nconst logger = createLogger({\n  // ...options\n});\n\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n');

    return function () {
      return function (next) {
        return function (action) {
          return next(action);
        };
      };
    };
  }

  var logBuffer = [];

  return function (_ref) {
    var getState = _ref.getState;
    return function (next) {
      return function (action) {
        // Exit early if predicate function returns 'false'
        if (typeof predicate === 'function' && !predicate(getState, action)) {
          return next(action);
        }

        var logEntry = {};
        logBuffer.push(logEntry);

        logEntry.started = _helpers.timer.now();
        logEntry.startedTime = new Date();
        logEntry.prevState = stateTransformer(getState());
        logEntry.action = action;

        var returnedValue = void 0;
        if (logErrors) {
          try {
            returnedValue = next(action);
          } catch (e) {
            logEntry.error = errorTransformer(e);
          }
        } else {
          returnedValue = next(action);
        }

        logEntry.took = _helpers.timer.now() - logEntry.started;
        logEntry.nextState = stateTransformer(getState());

        var diff = loggerOptions.diff && typeof diffPredicate === 'function' ? diffPredicate(getState, action) : loggerOptions.diff;

        (0, _core.printBuffer)(logBuffer, _extends({}, loggerOptions, { diff: diff }));
        logBuffer.length = 0;

        if (logEntry.error) throw logEntry.error;
        return returnedValue;
      };
    };
  };
}

var defaultLogger = createLogger();

exports.defaults = _defaults2.default;
exports.logger = defaultLogger;
exports.default = createLogger;
module.exports = exports['default'];


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.printBuffer = printBuffer;

var _helpers = __webpack_require__(139);

var _diff = __webpack_require__(163);

var _diff2 = _interopRequireDefault(_diff);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Get log level string based on supplied params
 *
 * @param {string | function | object} level - console[level]
 * @param {object} action - selected action
 * @param {array} payload - selected payload
 * @param {string} type - log entry type
 *
 * @returns {string} level
 */
function getLogLevel(level, action, payload, type) {
  switch (typeof level === 'undefined' ? 'undefined' : _typeof(level)) {
    case 'object':
      return typeof level[type] === 'function' ? level[type].apply(level, _toConsumableArray(payload)) : level[type];
    case 'function':
      return level(action);
    default:
      return level;
  }
}

function defaultTitleFormatter(options) {
  var timestamp = options.timestamp,
      duration = options.duration;


  return function (action, time, took) {
    var parts = ['action'];

    parts.push('%c' + String(action.type));
    if (timestamp) parts.push('%c@ ' + time);
    if (duration) parts.push('%c(in ' + took.toFixed(2) + ' ms)');

    return parts.join(' ');
  };
}

function printBuffer(buffer, options) {
  var logger = options.logger,
      actionTransformer = options.actionTransformer,
      _options$titleFormatt = options.titleFormatter,
      titleFormatter = _options$titleFormatt === undefined ? defaultTitleFormatter(options) : _options$titleFormatt,
      collapsed = options.collapsed,
      colors = options.colors,
      level = options.level,
      diff = options.diff;


  buffer.forEach(function (logEntry, key) {
    var started = logEntry.started,
        startedTime = logEntry.startedTime,
        action = logEntry.action,
        prevState = logEntry.prevState,
        error = logEntry.error;
    var took = logEntry.took,
        nextState = logEntry.nextState;

    var nextEntry = buffer[key + 1];

    if (nextEntry) {
      nextState = nextEntry.prevState;
      took = nextEntry.started - started;
    }

    // Message
    var formattedAction = actionTransformer(action);
    var isCollapsed = typeof collapsed === 'function' ? collapsed(function () {
      return nextState;
    }, action, logEntry) : collapsed;

    var formattedTime = (0, _helpers.formatTime)(startedTime);
    var titleCSS = colors.title ? 'color: ' + colors.title(formattedAction) + ';' : '';
    var headerCSS = ['color: gray; font-weight: lighter;'];
    headerCSS.push(titleCSS);
    if (options.timestamp) headerCSS.push('color: gray; font-weight: lighter;');
    if (options.duration) headerCSS.push('color: gray; font-weight: lighter;');
    var title = titleFormatter(formattedAction, formattedTime, took);

    // Render
    try {
      if (isCollapsed) {
        if (colors.title) logger.groupCollapsed.apply(logger, ['%c ' + title].concat(headerCSS));else logger.groupCollapsed(title);
      } else {
        if (colors.title) logger.group.apply(logger, ['%c ' + title].concat(headerCSS));else logger.group(title);
      }
    } catch (e) {
      logger.log(title);
    }

    var prevStateLevel = getLogLevel(level, formattedAction, [prevState], 'prevState');
    var actionLevel = getLogLevel(level, formattedAction, [formattedAction], 'action');
    var errorLevel = getLogLevel(level, formattedAction, [error, prevState], 'error');
    var nextStateLevel = getLogLevel(level, formattedAction, [nextState], 'nextState');

    if (prevStateLevel) {
      if (colors.prevState) logger[prevStateLevel]('%c prev state', 'color: ' + colors.prevState(prevState) + '; font-weight: bold', prevState);else logger[prevStateLevel]('prev state', prevState);
    }

    if (actionLevel) {
      if (colors.action) logger[actionLevel]('%c action    ', 'color: ' + colors.action(formattedAction) + '; font-weight: bold', formattedAction);else logger[actionLevel]('action    ', formattedAction);
    }

    if (error && errorLevel) {
      if (colors.error) logger[errorLevel]('%c error     ', 'color: ' + colors.error(error, prevState) + '; font-weight: bold;', error);else logger[errorLevel]('error     ', error);
    }

    if (nextStateLevel) {
      if (colors.nextState) logger[nextStateLevel]('%c next state', 'color: ' + colors.nextState(nextState) + '; font-weight: bold', nextState);else logger[nextStateLevel]('next state', nextState);
    }

    if (diff) {
      (0, _diff2.default)(prevState, nextState, logger, isCollapsed);
    }

    try {
      logger.groupEnd();
    } catch (e) {
      logger.log('\u2014\u2014 log end \u2014\u2014');
    }
  });
}

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = diffLogger;

var _deepDiff = __webpack_require__(164);

var _deepDiff2 = _interopRequireDefault(_deepDiff);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// https://github.com/flitbit/diff#differences
var dictionary = {
  'E': {
    color: '#2196F3',
    text: 'CHANGED:'
  },
  'N': {
    color: '#4CAF50',
    text: 'ADDED:'
  },
  'D': {
    color: '#F44336',
    text: 'DELETED:'
  },
  'A': {
    color: '#2196F3',
    text: 'ARRAY:'
  }
};

function style(kind) {
  return 'color: ' + dictionary[kind].color + '; font-weight: bold';
}

function render(diff) {
  var kind = diff.kind,
      path = diff.path,
      lhs = diff.lhs,
      rhs = diff.rhs,
      index = diff.index,
      item = diff.item;


  switch (kind) {
    case 'E':
      return [path.join('.'), lhs, '\u2192', rhs];
    case 'N':
      return [path.join('.'), rhs];
    case 'D':
      return [path.join('.')];
    case 'A':
      return [path.join('.') + '[' + index + ']', item];
    default:
      return [];
  }
}

function diffLogger(prevState, newState, logger, isCollapsed) {
  var diff = (0, _deepDiff2.default)(prevState, newState);

  try {
    if (isCollapsed) {
      logger.groupCollapsed('diff');
    } else {
      logger.group('diff');
    }
  } catch (e) {
    logger.log('diff');
  }

  if (diff) {
    diff.forEach(function (elem) {
      var kind = elem.kind;

      var output = render(elem);

      logger.log.apply(logger, ['%c ' + dictionary[kind].text, style(kind)].concat(_toConsumableArray(output)));
    });
  } else {
    logger.log('\u2014\u2014 no diff \u2014\u2014');
  }

  try {
    logger.groupEnd();
  } catch (e) {
    logger.log('\u2014\u2014 diff end \u2014\u2014 ');
  }
}
module.exports = exports['default'];

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * deep-diff.
 * Licensed under the MIT License.
 */
;(function(root, factory) {
  'use strict';
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return factory();
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    // Browser globals (root is window)
    root.DeepDiff = factory();
  }
}(this, function(undefined) {
  'use strict';

  var $scope, conflict, conflictResolution = [];
  if (typeof global === 'object' && global) {
    $scope = global;
  } else if (typeof window !== 'undefined') {
    $scope = window;
  } else {
    $scope = {};
  }
  conflict = $scope.DeepDiff;
  if (conflict) {
    conflictResolution.push(
      function() {
        if ('undefined' !== typeof conflict && $scope.DeepDiff === accumulateDiff) {
          $scope.DeepDiff = conflict;
          conflict = undefined;
        }
      });
  }

  // nodejs compatible on server side and in the browser.
  function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  }

  function Diff(kind, path) {
    Object.defineProperty(this, 'kind', {
      value: kind,
      enumerable: true
    });
    if (path && path.length) {
      Object.defineProperty(this, 'path', {
        value: path,
        enumerable: true
      });
    }
  }

  function DiffEdit(path, origin, value) {
    DiffEdit.super_.call(this, 'E', path);
    Object.defineProperty(this, 'lhs', {
      value: origin,
      enumerable: true
    });
    Object.defineProperty(this, 'rhs', {
      value: value,
      enumerable: true
    });
  }
  inherits(DiffEdit, Diff);

  function DiffNew(path, value) {
    DiffNew.super_.call(this, 'N', path);
    Object.defineProperty(this, 'rhs', {
      value: value,
      enumerable: true
    });
  }
  inherits(DiffNew, Diff);

  function DiffDeleted(path, value) {
    DiffDeleted.super_.call(this, 'D', path);
    Object.defineProperty(this, 'lhs', {
      value: value,
      enumerable: true
    });
  }
  inherits(DiffDeleted, Diff);

  function DiffArray(path, index, item) {
    DiffArray.super_.call(this, 'A', path);
    Object.defineProperty(this, 'index', {
      value: index,
      enumerable: true
    });
    Object.defineProperty(this, 'item', {
      value: item,
      enumerable: true
    });
  }
  inherits(DiffArray, Diff);

  function arrayRemove(arr, from, to) {
    var rest = arr.slice((to || from) + 1 || arr.length);
    arr.length = from < 0 ? arr.length + from : from;
    arr.push.apply(arr, rest);
    return arr;
  }

  function realTypeOf(subject) {
    var type = typeof subject;
    if (type !== 'object') {
      return type;
    }

    if (subject === Math) {
      return 'math';
    } else if (subject === null) {
      return 'null';
    } else if (Array.isArray(subject)) {
      return 'array';
    } else if (Object.prototype.toString.call(subject) === '[object Date]') {
      return 'date';
    } else if (typeof subject.toString !== 'undefined' && /^\/.*\//.test(subject.toString())) {
      return 'regexp';
    }
    return 'object';
  }

  function deepDiff(lhs, rhs, changes, prefilter, path, key, stack) {
    path = path || [];
    var currentPath = path.slice(0);
    if (typeof key !== 'undefined') {
      if (prefilter) {
        if (typeof(prefilter) === 'function' && prefilter(currentPath, key)) { return; }
        else if (typeof(prefilter) === 'object') {
          if (prefilter.prefilter && prefilter.prefilter(currentPath, key)) { return; }
          if (prefilter.normalize) {
            var alt = prefilter.normalize(currentPath, key, lhs, rhs);
            if (alt) {
              lhs = alt[0];
              rhs = alt[1];
            }
          }
        }
      }
      currentPath.push(key);
    }

    // Use string comparison for regexes
    if (realTypeOf(lhs) === 'regexp' && realTypeOf(rhs) === 'regexp') {
      lhs = lhs.toString();
      rhs = rhs.toString();
    }

    var ltype = typeof lhs;
    var rtype = typeof rhs;
    if (ltype === 'undefined') {
      if (rtype !== 'undefined') {
        changes(new DiffNew(currentPath, rhs));
      }
    } else if (rtype === 'undefined') {
      changes(new DiffDeleted(currentPath, lhs));
    } else if (realTypeOf(lhs) !== realTypeOf(rhs)) {
      changes(new DiffEdit(currentPath, lhs, rhs));
    } else if (Object.prototype.toString.call(lhs) === '[object Date]' && Object.prototype.toString.call(rhs) === '[object Date]' && ((lhs - rhs) !== 0)) {
      changes(new DiffEdit(currentPath, lhs, rhs));
    } else if (ltype === 'object' && lhs !== null && rhs !== null) {
      stack = stack || [];
      if (stack.indexOf(lhs) < 0) {
        stack.push(lhs);
        if (Array.isArray(lhs)) {
          var i, len = lhs.length;
          for (i = 0; i < lhs.length; i++) {
            if (i >= rhs.length) {
              changes(new DiffArray(currentPath, i, new DiffDeleted(undefined, lhs[i])));
            } else {
              deepDiff(lhs[i], rhs[i], changes, prefilter, currentPath, i, stack);
            }
          }
          while (i < rhs.length) {
            changes(new DiffArray(currentPath, i, new DiffNew(undefined, rhs[i++])));
          }
        } else {
          var akeys = Object.keys(lhs);
          var pkeys = Object.keys(rhs);
          akeys.forEach(function(k, i) {
            var other = pkeys.indexOf(k);
            if (other >= 0) {
              deepDiff(lhs[k], rhs[k], changes, prefilter, currentPath, k, stack);
              pkeys = arrayRemove(pkeys, other);
            } else {
              deepDiff(lhs[k], undefined, changes, prefilter, currentPath, k, stack);
            }
          });
          pkeys.forEach(function(k) {
            deepDiff(undefined, rhs[k], changes, prefilter, currentPath, k, stack);
          });
        }
        stack.length = stack.length - 1;
      }
    } else if (lhs !== rhs) {
      if (!(ltype === 'number' && isNaN(lhs) && isNaN(rhs))) {
        changes(new DiffEdit(currentPath, lhs, rhs));
      }
    }
  }

  function accumulateDiff(lhs, rhs, prefilter, accum) {
    accum = accum || [];
    deepDiff(lhs, rhs,
      function(diff) {
        if (diff) {
          accum.push(diff);
        }
      },
      prefilter);
    return (accum.length) ? accum : undefined;
  }

  function applyArrayChange(arr, index, change) {
    if (change.path && change.path.length) {
      var it = arr[index],
          i, u = change.path.length - 1;
      for (i = 0; i < u; i++) {
        it = it[change.path[i]];
      }
      switch (change.kind) {
        case 'A':
          applyArrayChange(it[change.path[i]], change.index, change.item);
          break;
        case 'D':
          delete it[change.path[i]];
          break;
        case 'E':
        case 'N':
          it[change.path[i]] = change.rhs;
          break;
      }
    } else {
      switch (change.kind) {
        case 'A':
          applyArrayChange(arr[index], change.index, change.item);
          break;
        case 'D':
          arr = arrayRemove(arr, index);
          break;
        case 'E':
        case 'N':
          arr[index] = change.rhs;
          break;
      }
    }
    return arr;
  }

  function applyChange(target, source, change) {
    if (target && source && change && change.kind) {
      var it = target,
          i = -1,
          last = change.path ? change.path.length - 1 : 0;
      while (++i < last) {
        if (typeof it[change.path[i]] === 'undefined') {
          it[change.path[i]] = (typeof change.path[i] === 'number') ? [] : {};
        }
        it = it[change.path[i]];
      }
      switch (change.kind) {
        case 'A':
          applyArrayChange(change.path ? it[change.path[i]] : it, change.index, change.item);
          break;
        case 'D':
          delete it[change.path[i]];
          break;
        case 'E':
        case 'N':
          it[change.path[i]] = change.rhs;
          break;
      }
    }
  }

  function revertArrayChange(arr, index, change) {
    if (change.path && change.path.length) {
      // the structure of the object at the index has changed...
      var it = arr[index],
          i, u = change.path.length - 1;
      for (i = 0; i < u; i++) {
        it = it[change.path[i]];
      }
      switch (change.kind) {
        case 'A':
          revertArrayChange(it[change.path[i]], change.index, change.item);
          break;
        case 'D':
          it[change.path[i]] = change.lhs;
          break;
        case 'E':
          it[change.path[i]] = change.lhs;
          break;
        case 'N':
          delete it[change.path[i]];
          break;
      }
    } else {
      // the array item is different...
      switch (change.kind) {
        case 'A':
          revertArrayChange(arr[index], change.index, change.item);
          break;
        case 'D':
          arr[index] = change.lhs;
          break;
        case 'E':
          arr[index] = change.lhs;
          break;
        case 'N':
          arr = arrayRemove(arr, index);
          break;
      }
    }
    return arr;
  }

  function revertChange(target, source, change) {
    if (target && source && change && change.kind) {
      var it = target,
          i, u;
      u = change.path.length - 1;
      for (i = 0; i < u; i++) {
        if (typeof it[change.path[i]] === 'undefined') {
          it[change.path[i]] = {};
        }
        it = it[change.path[i]];
      }
      switch (change.kind) {
        case 'A':
          // Array was modified...
          // it will be an array...
          revertArrayChange(it[change.path[i]], change.index, change.item);
          break;
        case 'D':
          // Item was deleted...
          it[change.path[i]] = change.lhs;
          break;
        case 'E':
          // Item was edited...
          it[change.path[i]] = change.lhs;
          break;
        case 'N':
          // Item is new...
          delete it[change.path[i]];
          break;
      }
    }
  }

  function applyDiff(target, source, filter) {
    if (target && source) {
      var onChange = function(change) {
        if (!filter || filter(target, source, change)) {
          applyChange(target, source, change);
        }
      };
      deepDiff(target, source, onChange);
    }
  }

  Object.defineProperties(accumulateDiff, {

    diff: {
      value: accumulateDiff,
      enumerable: true
    },
    observableDiff: {
      value: deepDiff,
      enumerable: true
    },
    applyDiff: {
      value: applyDiff,
      enumerable: true
    },
    applyChange: {
      value: applyChange,
      enumerable: true
    },
    revertChange: {
      value: revertChange,
      enumerable: true
    },
    isConflict: {
      value: function() {
        return 'undefined' !== typeof conflict;
      },
      enumerable: true
    },
    noConflict: {
      value: function() {
        if (conflictResolution) {
          conflictResolution.forEach(function(it) {
            it();
          });
          conflictResolution = null;
        }
        return accumulateDiff;
      },
      enumerable: true
    }
  });

  return accumulateDiff;
}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  level: "log",
  logger: console,
  logErrors: true,
  collapsed: undefined,
  predicate: undefined,
  duration: false,
  timestamp: true,
  stateTransformer: function stateTransformer(state) {
    return state;
  },
  actionTransformer: function actionTransformer(action) {
    return action;
  },
  errorTransformer: function errorTransformer(error) {
    return error;
  },
  colors: {
    title: function title() {
      return "inherit";
    },
    prevState: function prevState() {
      return "#9E9E9E";
    },
    action: function action() {
      return "#03A9F4";
    },
    nextState: function nextState() {
      return "#4CAF50";
    },
    error: function error() {
      return "#F20404";
    }
  },
  diff: false,
  diffPredicate: undefined,

  // Deprecated options
  transformer: undefined
};
module.exports = exports["default"];

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(167);
var objectAssign = __webpack_require__(157);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 168 */,
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _itemContainer = __webpack_require__(242);

var _itemContainer2 = _interopRequireDefault(_itemContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /// <reference path="../../reference.ts" />

var GroupView = function (_React$Component) {
  _inherits(GroupView, _React$Component);

  function GroupView(props) {
    _classCallCheck(this, GroupView);

    var _this = _possibleConstructorReturn(this, (GroupView.__proto__ || Object.getPrototypeOf(GroupView)).call(this, props));

    _this.displayName = 'GroupView';
    _this.dom = [];
    _this.state = {};
    return _this;
  }

  _createClass(GroupView, [{
    key: 'render',
    value: function render() {
      var styleParams = this.props.galleryConfig.styleParams;

      this.dom = [];
      for (var item, i = 0; item = this.props.items[i]; i++) {
        this.dom.push(_react2.default.createElement(_itemContainer2.default, _.merge(item.getViewProps(_.merge(this.props.galleryConfig, { visible: this.props.visible, bottomInfoHeight: this.props.bottomInfoHeight })), { store: this.props.store })));
      }

      return _react2.default.createElement(
        'div',
        { className: " gallery-group gallery-group-" + (this.props.rendered ? this.props.visible ? 'visible' : 'hidden' : 'none'), 'data-group-idx': this.props.idx, 'data-group-type': this.props.type, 'data-group-ratios': this.props.ratios,
          style: { width: this.props.width, height: this.props.totalHeight }
        },
        this.dom
      );
    }
  }]);

  return GroupView;
}(_react2.default.Component);

/*
 idx: {this.props.idx} <br/>
 top: {this.props.top} <br/>
 {(this.props.rendered) ? 'Rendered' : 'Gone'} <br/>
 {(this.props.visible) ? 'Visible' : 'Hidden'} <br/>
 */

/*
 <img onLoad={() => this.setItemLoaded()} className={'image' + (this.state.loaded ? '' : '-preload')}
 src={this.props.resized_url}/>
 */

exports.default = GroupView;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _customButtonIcon = __webpack_require__(250);

var _customButtonIcon2 = _interopRequireDefault(_customButtonIcon);

var _index = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CustomButton = function (_React$Component) {
  _inherits(CustomButton, _React$Component);

  function CustomButton(props) {
    _classCallCheck(this, CustomButton);

    return _possibleConstructorReturn(this, (CustomButton.__proto__ || Object.getPrototypeOf(CustomButton)).call(this, props));
  }

  _createClass(CustomButton, [{
    key: 'render',
    value: function render() {
      var styleParams = this.props.styleParams;

      var defaultText = _index.utils.isStoreGallery() ? "Buy Now" : "Click here";
      var buttonText = styleParams.customButtonText || defaultText;
      return _react2.default.createElement(
        'div',
        { className: 'custom-button-wrapper', style: { justifyContent: styleParams.galleryHorizontalAlign } },
        this.props.small ? _react2.default.createElement(_customButtonIcon2.default, null) : _react2.default.createElement(
          'button',
          { onClick: function onClick() {
              return logger.trackBi(logger.biEvents.buyNowClick);
            },
            tabIndex: -1
          },
          buttonText,
          _react2.default.createElement('div', { className: 'overlay' })
        )
      );
    }
  }]);

  return CustomButton;
}(_react2.default.Component);

exports.default = CustomButton;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ItemTitle = function (_React$Component) {
  _inherits(ItemTitle, _React$Component);

  function ItemTitle(props) {
    _classCallCheck(this, ItemTitle);

    return _possibleConstructorReturn(this, (ItemTitle.__proto__ || Object.getPrototypeOf(ItemTitle)).call(this, props));
  }

  _createClass(ItemTitle, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          id = _props.id,
          title = _props.title,
          style = _props.style;

      return _react2.default.createElement(
        "div",
        { className: "gallery-item-title", "data-hook": "item-title", style: style },
        title
      );
    }
  }]);

  return ItemTitle;
}(_react2.default.Component);

exports.default = ItemTitle;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GalleryEmpty = function (_React$Component) {
  _inherits(GalleryEmpty, _React$Component);

  function GalleryEmpty(props) {
    _classCallCheck(this, GalleryEmpty);

    return _possibleConstructorReturn(this, (GalleryEmpty.__proto__ || Object.getPrototypeOf(GalleryEmpty)).call(this, props));
  }

  _createClass(GalleryEmpty, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.actions.setWixHeight(390, window.innerHeight);
    }
  }, {
    key: 'render',
    value: function render() {
      console.log('Not rendering - gallery is empty');

      var emptyContent = _utils.utils.isStoreGallery() ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'pro-gallery-empty-title' },
          _utils.TranslationUtil.getByKey('Gallery_ArtStore_Organize_Images_EmptyState_Header'),
          _react2.default.createElement('br', null),
          _utils.TranslationUtil.getByKey('Gallery_ArtStore_Organize_Images_EmptyState_Header2')
        ),
        _react2.default.createElement(
          'div',
          { className: 'pro-gallery-empty-info' },
          _utils.TranslationUtil.getByKey('Gallery_ArtStore_Organize_Images_EmptyState_Text'),
          _react2.default.createElement('br', null)
        )
      ) : _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'pro-gallery-empty-title' },
          _utils.TranslationUtil.getByKey('Gallery_Empty_Title'),
          _react2.default.createElement('br', null),
          _utils.TranslationUtil.getByKey('Gallery_Empty_Title2')
        ),
        _react2.default.createElement(
          'div',
          { className: 'pro-gallery-empty-info' },
          _utils.TranslationUtil.getByKey('Gallery_Empty_Description'),
          _react2.default.createElement('br', null),
          _utils.TranslationUtil.getByKey('Gallery_Empty_Description2')
        )
      );
      return _react2.default.createElement(
        'div',
        { className: 'pro-gallery-empty' },
        _react2.default.createElement(
          'div',
          { className: 'pro-gallery-empty-wrapper' },
          _react2.default.createElement('div', { className: 'pro-gallery-empty-image' }),
          emptyContent
        )
      );
    }
  }]);

  return GalleryEmpty;
}(_react2.default.Component);

exports.default = GalleryEmpty;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GalleryDebugMessage = function (_React$Component) {
  _inherits(GalleryDebugMessage, _React$Component);

  function GalleryDebugMessage(props) {
    _classCallCheck(this, GalleryDebugMessage);

    return _possibleConstructorReturn(this, (GalleryDebugMessage.__proto__ || Object.getPrototypeOf(GalleryDebugMessage)).call(this, props));
  }

  _createClass(GalleryDebugMessage, [{
    key: 'render',
    value: function render() {
      if (_index.utils.getTopUrlParam('pgdebug') !== 'true') {
        return false;
      }

      var version = _react2.default.createElement(
        'div',
        { className: 'version-header ' },
        'Pro Gallery Version #',
        window.staticsVersion
      );

      var parentSize = '';
      try {
        parentSize = ' psw' + top.screen.width + ' piw' + top.innerWidth + ' pbw' + top.document.body.clientWidth;
      } catch (e) {
        //not on the domain
      }

      var debugMsg = _react2.default.createElement(
        'div',
        { className: 'version-header ' },
        _index.utils.isLandscape() ? 'land' : 'port',
        ' sw',
        window.screen.width,
        'sh',
        window.screen.height,
        ' iw',
        window.innerWidth,
        ' bw',
        document.body.clientWidth,
        ' sr',
        _index.utils.getViewportScaleRatio(),
        'rc',
        this.props.resizeCount,
        ' oc',
        this.props.orientationCount,
        ' nh',
        this.props.newHeight,
        ' lh',
        this.props.lastHeight,
        parentSize,
        'www',
        this.props.maxGalleryWidth
      );

      return _react2.default.createElement(
        'div',
        null,
        version,
        debugMsg
      );
    }
  }]);

  return GalleryDebugMessage;
}(_react2.default.Component);

exports.default = GalleryDebugMessage;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(2);

var _itemLayout = __webpack_require__(110);

var _itemLayout2 = _interopRequireDefault(_itemLayout);

var _groupLayout = __webpack_require__(256);

var _groupLayout2 = _interopRequireDefault(_groupLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } ///// <reference path="../../reference.ts" />


var Strip = function Strip(lastIdx) {
  _classCallCheck(this, Strip);

  this.ratio = 0;
  this.groups = [];
  this.height = 0;
  this.idx = (lastIdx || 0) + 1;
};

var GalleryLayout = function () {
  function GalleryLayout(layoutParams) {
    _classCallCheck(this, GalleryLayout);

    this.ready = false;
    this.pointer = 0;
    this.layoutItems = [];

    this.findNeighborItem = this.findNeighborItem.bind(this);

    this.updateParams(layoutParams);
    this.prepareGallery();
  }

  _createClass(GalleryLayout, [{
    key: 'updateParams',
    value: function updateParams(layoutParams) {

      this.items = layoutParams.items;
      this.styleParams = layoutParams.styleParams;
      this.container = layoutParams.container;
      this.gotScrollEvent = layoutParams.gotScrollEvent;
      this.watermark = layoutParams.watermark;
      this.showAllItems = layoutParams.showAllItems;
    }
  }, {
    key: 'verifyGalleryState',
    value: function verifyGalleryState() {
      if (!this.container.galleryWidth) {
        this.ready = false;
        this.reason = 'galleryWidth is undefined or 0';
        return false;
      }

      if (!this.styleParams.gallerySize) {
        this.ready = false;
        this.reason = 'gallerySize is undefined or 0';
        return false;
      }

      return true;
    }
  }, {
    key: 'prepareGallery',
    value: function prepareGallery() {

      var gallerySize = Math.floor(this.styleParams.gallerySize);
      var galleryWidth = Math.floor(this.container.galleryWidth);
      var maxGroupSize = this.maxGroupSize;

      if (!this.verifyGalleryState()) {
        return false;
      }

      this.srcImages = this.items;

      this.pointer = 0;
      this.firstGroup = false;
      this.layoutItems = [];

      var groupIdx = 1;
      var inStripIdx = 1;
      var item = {};

      var groupItems = [];
      var group;
      var bounds = this.container.bounds;

      var strip = new Strip();

      var numOfCols = 1;
      var columns = [];
      var columnsH = [];

      var galleryHeight = 0;

      var safetyCounter = 1000000;

      if (this.styleParams.isVertical) {
        if (this.styleParams.fixedColumns > 0) {
          numOfCols = _utils.utils.isMobile() ? 1 : this.styleParams.fixedColumns;
        } else {
          numOfCols = Math.ceil(galleryWidth / gallerySize) || 1;
        }
        gallerySize = Math.floor(galleryWidth / numOfCols);
      } else {
        numOfCols = 1;
        gallerySize = Math.min(this.styleParams.gallerySize, galleryWidth);
      }

      while (this.srcImages[this.pointer]) {

        if (_.isArray(this.srcImages[this.pointer])) {
          console.error({ msg: 'no dto', pointer: this.pointer, allItems: this.srcImages });
        }

        //console.log('Creating item #' + this.pointer + ' / ' + this.srcImages.length, this.srcImages[this.pointer]);
        item = new _itemLayout2.default({
          idx: this.pointer,
          scrollTop: galleryHeight,
          dto: this.srcImages[this.pointer],
          watermark: this.watermark,
          cubeImages: this.styleParams.cubeImages,
          cubeType: this.styleParams.cubeType,
          cubeRatio: this.styleParams.cubeRatio,
          smartCrop: this.styleParams.smartCrop,
          cropOnlyFill: this.styleParams.cropOnlyFill,
          sharpParams: this.styleParams.sharpParams,
          createdBy: 'galleryLayout'
        });

        this.layoutItems[this.pointer] = item;

        //push the image to a group - until its full
        groupItems.push(item);
        if ( //conditions to wait for the next item
        !this.isLastImages //last images in gallery - do not group
        && groupItems.length < maxGroupSize //if the group is too small
        ) {
            //wait for more images
            this.pointer++;
            continue;
          }

        group = new _groupLayout2.default({
          idx: groupIdx,
          stripIdx: strip.idx,
          inStripIdx: inStripIdx,
          top: galleryHeight,
          items: groupItems,
          chooseBestGroup: this.styleParams.chooseBestGroup,
          groupTypes: this.styleParams.groupTypes,
          cubeImages: this.styleParams.cubeImages,
          cubeType: this.styleParams.cubeType,
          isVertical: this.styleParams.isVertical,
          minItemSize: this.styleParams.minItemSize,
          gallerySize: gallerySize,
          collageAmount: this.styleParams.collageAmount,
          collageDensity: this.styleParams.collageDensity,
          layoutsVersion: this.styleParams.layoutsVersion,
          titlePlacement: this.styleParams.titlePlacement,
          galleryLayout: this.styleParams.galleryLayout,
          allowTitle: this.styleParams.allowTitle,
          itemFont: this.styleParams.itemFont,
          itemFontSlideshow: this.styleParams.itemFontSlideshow
        });

        groupIdx++;
        inStripIdx++;

        //prepare the images in the group
        //group = this.wrapGroup(groupImages);
        if (group.items.length < maxGroupSize) {
          //console.warn(group.items.length, '<' ,maxGroupSize, 'waiting for more');
          //move the cursor back if the resulted group is smaller than 3
          if (safetyCounter > 0) {
            safetyCounter--;
            this.pointer += group.items.length - groupItems.length;
          } else {
            console.error('safetyCounter Reached!', this);
          }
        }

        groupItems = [];

        //resize and fit the group in the strip / column
        if (!this.styleParams.isVertical) {

          //STRIPS

          //open a new strip if needed
          var isStripSmallEnough;

          if (this.styleParams.oneRow) {
            isStripSmallEnough = false; //onerow layout is one long strip
          } else {
            var withNewGroup = galleryWidth / (strip.ratio + group.ratio) - gallerySize; //start a new strip BEFORE adding the current group
            var withoutNewGroup = galleryWidth / strip.ratio - gallerySize; //start a new strip AFTER adding the current group

            if (isNaN(withNewGroup) || isNaN(withoutNewGroup)) {
              isStripSmallEnough = false;
            } else if (withoutNewGroup < 0) {
              //the strip is already too small
              isStripSmallEnough = true;
            } else if (withNewGroup < 0) {
              //adding the new group makes is small enough
              // check if adding the new group makes the strip TOO small
              //so - without the new group, the strip is larger than the required size - but adding the new group might make it too small
              isStripSmallEnough = Math.abs(withoutNewGroup) < Math.abs(withNewGroup);
            } else {
              isStripSmallEnough = false;
            }

            /*
                      if (isStripSmallEnough && this.isLastImage) {
                        //if it is the last image - prefer adding it to the last strip rather putting it on a new strip
                        isStripSmallEnough = ((Math.abs(withoutNewGroup) * 1) < Math.abs(withNewGroup));
                      }
            */
          }

          var shouldStartNewStrip = false;
          shouldStartNewStrip = !strip.groups || //first image - restart a new strip
          strip.groups.length > 0 && //strip must have at least one group
          isStripSmallEnough;

          if (shouldStartNewStrip) {
            //close the current strip
            if (strip.groups) {
              strip.groups[strip.groups.length - 1].isLastGroup = true;
              strip.groups[strip.groups.length - 1].stripWidth = galleryWidth;
              this.resizeGroups(strip.groups, galleryWidth / strip.ratio);
              galleryHeight += galleryWidth / strip.ratio;
              columns[0] = (columns[0] || []).concat(strip.groups);
            }

            //open a new strip
            strip = new Strip(strip.idx);

            //reset the group (this group will be rebuilt)
            inStripIdx = 1;
            this.pointer -= group.items.length - 1;
            groupIdx--;
            continue;
          }

          //add the group to the (current/new) strip
          group.setTop(galleryHeight);
          group.stripIdx = strip.idx;
          strip.ratio += group.ratio;
          strip.height = Math.min(gallerySize, galleryWidth / strip.ratio);
          strip.groups.push(group);

          if (this.isLastImage && strip.groups) {
            if (this.styleParams.oneRow) {
              strip.height = this.container.galleryHeight;
            } else {
              if (gallerySize * 2 < galleryWidth / strip.ratio) {
                //stretching the strip to the full width will make it too high - so make it as high as the gallerySize and not stretch
                strip.height = gallerySize;
              } else {
                strip.height = galleryWidth / strip.ratio;
              }
            }

            strip.groups[strip.groups.length - 1].isLastGroup = true;
            strip.groups[strip.groups.length - 1].stripWidth = strip.height * strip.ratio;

            this.resizeGroups(strip.groups, strip.height);
            galleryHeight += strip.height;
            columns[0] = (columns[0] || []).concat(strip.groups);
          }
        } else {

          //find the shortest column
          var minCol = 0;
          var minColH = -1;
          for (var i = 0; i < numOfCols; i++) {
            var colH = columnsH[i];
            if (typeof colH == 'undefined') {
              colH = 0;
            }
            if (colH < minColH || minColH < 0) {
              minColH = colH;
              minCol = i;
            }
            if (galleryHeight < colH) {
              galleryHeight = colH;
            }
          }

          columns[minCol] = columns[minCol] || [];
          columnsH[minCol] = columnsH[minCol] || 0;

          //resize the gourp and images
          this.resizeGroups([group], gallerySize / group.ratio);

          //update the group's position
          group.setTop(columnsH[minCol]);
          group.setLeft(minCol * gallerySize);

          //add the image to the column
          columns[minCol].push(group);

          //add the image height to the column
          columnsH[minCol] += group.totalHeight;

          if (galleryHeight < columnsH[minCol]) {
            galleryHeight = columnsH[minCol];
          }
        }

        //set the group visibility
        //until the first scroll event, make sure the first 10 groups are displayed

        if (!this.gotScrollEvent && this.pointer < 10) {
          group.visible = group.rendered = group.required = true;
        } else {
          group = this.calcVisibilitiesForGroup(group, bounds);
        }

        if (!this.firstGroup) {
          this.firstGroup = group;
        }

        //advance the this.pointer
        this.pointer++;
      }

      //results
      this.lastGroup = group;
      this.strips = strip.idx || 0;
      this.columns = columns;
      this.colWidth = Math.floor(galleryWidth / numOfCols);
      this.height = galleryHeight;

      this.calcVisibilities(bounds);

      this.ready = true;
    }
  }, {
    key: 'lastVisibleItemIdx',
    value: function lastVisibleItemIdx() {
      for (var item, i = this.layoutItems.length - 1; item = this.layoutItems[i]; i--) {
        var isVisible = item.offset.top < this.container.galleryHeight - 100; //the item must be visible and about the show more button
        if (isVisible) {
          return i;
        }
      }
      return this.layoutItems.length - 1;
    }
  }, {
    key: 'findNeighborItem',
    value: function findNeighborItem(itemIdx, dir) {
      var _this = this;

      var currentItem = this.layoutItems[itemIdx];

      var neighborItem = void 0;

      var findClosestItem = function findClosestItem(currentItemX, currentItemY, condition) {

        var minDistance = null;
        var minDistanceItem = {};

        var itemY = void 0;
        var itemX = void 0;
        var distance = void 0;

        // _.each(_.slice(this.layoutItems, itemIdx - 50, itemIdx + 50), (item) => {
        _.each(_this.layoutItems, function (item) {
          itemY = item.offset.top + item.height / 2;
          itemX = item.offset.left + item.width / 2;
          distance = Math.sqrt(Math.pow(itemY - currentItemY, 2) + Math.pow(itemX - currentItemX, 2));
          if ((minDistance == null || distance > 0 && distance < minDistance) && condition(currentItemX, currentItemY, itemX, itemY)) {
            minDistance = distance;
            minDistanceItem = item;
          }
        });
        return minDistanceItem;
      };

      switch (dir) {
        case 'up':
          neighborItem = findClosestItem(currentItem.offset.left + currentItem.width / 2, currentItem.offset.top, function (curX, curY, itmX, itmY) {
            return itmY < curY;
          });
          break;

        case 'left':
          neighborItem = findClosestItem(currentItem.offset.left, currentItem.offset.top + currentItem.height / 2, function (curX, curY, itmX, itmY) {
            return itmX < curX;
          });
          break;

        case 'down':
          neighborItem = findClosestItem(currentItem.offset.left + currentItem.width / 2, currentItem.offset.bottom, function (curX, curY, itmX, itmY) {
            return itmY > curY;
          });
          break;

        case 'right':
          neighborItem = findClosestItem(currentItem.offset.right, currentItem.offset.top + currentItem.height / 2, function (curX, curY, itmX, itmY) {
            return itmX > curX;
          });
          break;

      }

      if (neighborItem.idx >= 0) {
        if (_utils.utils.isDev()) {
          console.log('found neighborItem #' + neighborItem.idx, neighborItem);
        }
        return neighborItem.idx;
      } else {
        console.warn('Could not find offset for itemIdx', itemIdx, dir);
        return itemIdx; //stay on the same item
      }
    }
  }, {
    key: 'calcVisibilities',
    value: function calcVisibilities(bounds) {
      if (_utils.utils.shouldDebug('ph_log_visibilities')) {
        console.log('Calculating Visibilities for groups', bounds, this.columns);
      }
      for (var column, c = 0; column = this.columns[c]; c++) {
        for (var group, g = 0; group = column[g]; g++) {
          column[g] = this.calcVisibilitiesForGroup(group, bounds);
          if (_utils.utils.shouldDebug('ph_log_visibilities')) {
            console.log('Calculating Visibilities - group #' + column[g].idx + ' is ' + (column[g].visible ? 'VISIBLE' : column[g].rendered ? 'RENDERED' : 'HIDDEN'), column[g], bounds);
          }
        }
      }
    }
  }, {
    key: 'calcVisibilitiesForGroup',
    value: function calcVisibilitiesForGroup(group, bounds) {
      if (this.showAllItems === true) {
        group.visible = group.rendered = group.required = true;
      } else if (this.styleParams.oneRow) {
        group.visible = group.right >= bounds.visibleTop && group.left <= bounds.visibleBottom;
        group.rendered = group.right >= bounds.renderedTop && group.left <= bounds.renderedBottom;
        group.required = group.right >= bounds.requiredTop && group.left <= bounds.requiredBottom;
      } else {
        group.visible = group.bottom >= bounds.visibleTop && group.top <= bounds.visibleBottom;
        group.rendered = group.bottom >= bounds.renderedTop && group.top <= bounds.renderedBottom;
        group.required = group.bottom >= bounds.requiredTop && group.top <= bounds.requiredBottom;
      }
      return group;
    }
  }, {
    key: 'resizeGroups',
    value: function resizeGroups(groups, height) {
      var left = 0;
      var remainder = 0;
      for (var group, g = 0; group = groups[g]; g++) {
        group.setLeft(left);
        // group.left = (left);
        group.width += remainder; //add the remainder from the last group round
        group.resizeByHeight(height);
        remainder = group.width;
        group.round();
        remainder -= group.width;
        left += group.width;
      }
    }
  }, {
    key: 'isLastImage',
    get: function get() {
      return !this.srcImages[this.pointer + 1];
    }
  }, {
    key: 'isLastImages',
    get: function get() {
      if (this.styleParams.layoutsVersion > 1) {
        //layouts version 2+
        return !this.srcImages[this.pointer + 1];
      } else {
        //Backwards compatibility
        return !this.srcImages[this.pointer + 3];
      }
    }
  }, {
    key: 'imagesLeft',
    get: function get() {
      return this.srcImages.length - this.pointer - 1;
    }
  }, {
    key: 'maxGroupSize',
    get: function get() {
      var _maxGroupSize = 1;
      try {
        var groupTypes = _.isString(this.styleParams.groupTypes) ? this.styleParams.groupTypes.split(',') : this.styleParams.groupTypes;
        _maxGroupSize = groupTypes.reduce(function (curSize, groupType) {
          return Math.max(curSize, parseInt(groupType));
        }, 1);
        _maxGroupSize = Math.min(_maxGroupSize, this.styleParams.groupSize);
      } catch (e) {
        console.error('couldn\'t calculate max group size - returing 3 (?)', e);
        _maxGroupSize = 3;
      }
      return _maxGroupSize;
    }
  }]);

  return GalleryLayout;
}();

exports.default = GalleryLayout;

/***/ }),
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _loadScript = __webpack_require__(205);

var _loadScript2 = _interopRequireDefault(_loadScript);

var _BasePlayer2 = __webpack_require__(136);

var _BasePlayer3 = _interopRequireDefault(_BasePlayer2);

var _utils = __webpack_require__(206);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = 'https://www.youtube.com/iframe_api';
var SDK_GLOBAL = 'YT';
var SDK_GLOBAL_READY = 'onYouTubeIframeAPIReady';
var MATCH_URL = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
var BLANK_VIDEO_URL = 'https://www.youtube.com/watch?v=GlCmAC4MHek';
var DEFAULT_PLAYER_VARS = {
  autoplay: 0,
  playsinline: 1,
  showinfo: 0,
  rel: 0,
  iv_load_policy: 3
};

var YouTube = function (_BasePlayer) {
  _inherits(YouTube, _BasePlayer);

  function YouTube() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, YouTube);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = YouTube.__proto__ || Object.getPrototypeOf(YouTube)).call.apply(_ref, [this].concat(args))), _this), _this.onStateChange = function (_ref2) {
      var data = _ref2.data;
      var _this$props = _this.props,
          onPause = _this$props.onPause,
          onBuffer = _this$props.onBuffer;
      var _window$SDK_GLOBAL$Pl = window[SDK_GLOBAL].PlayerState,
          PLAYING = _window$SDK_GLOBAL$Pl.PLAYING,
          PAUSED = _window$SDK_GLOBAL$Pl.PAUSED,
          BUFFERING = _window$SDK_GLOBAL$Pl.BUFFERING,
          ENDED = _window$SDK_GLOBAL$Pl.ENDED,
          CUED = _window$SDK_GLOBAL$Pl.CUED;

      if (data === PLAYING) _this.onPlay();
      if (data === PAUSED) onPause();
      if (data === BUFFERING) onBuffer();
      if (data === ENDED) _this.onEnded();
      if (data === CUED) _this.onReady();
    }, _this.onEnded = function () {
      var _this$props2 = _this.props,
          loop = _this$props2.loop,
          onEnded = _this$props2.onEnded;

      if (loop) {
        _this.seekTo(0);
      }
      onEnded();
    }, _this.ref = function (container) {
      _this.container = container;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(YouTube, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          url = _props.url,
          youtubeConfig = _props.youtubeConfig;

      if (!url && youtubeConfig.preload) {
        this.preloading = true;
        this.load(BLANK_VIDEO_URL);
      }
      _get(YouTube.prototype.__proto__ || Object.getPrototypeOf(YouTube.prototype), 'componentDidMount', this).call(this);
    }
  }, {
    key: 'getSDK',
    value: function getSDK() {
      if (window[SDK_GLOBAL] && window[SDK_GLOBAL].loaded) {
        return Promise.resolve(window[SDK_GLOBAL]);
      }
      return new Promise(function (resolve, reject) {
        var previousOnReady = window[SDK_GLOBAL_READY];
        window[SDK_GLOBAL_READY] = function () {
          if (previousOnReady) previousOnReady();
          resolve(window[SDK_GLOBAL]);
        };
        (0, _loadScript2['default'])(SDK_URL, function (err) {
          if (err) reject(err);
        });
      });
    }
  }, {
    key: 'load',
    value: function load(url) {
      var _this2 = this;

      var _props2 = this.props,
          controls = _props2.controls,
          youtubeConfig = _props2.youtubeConfig,
          _onError = _props2.onError;

      var id = url && url.match(MATCH_URL)[1];
      if (this.isReady) {
        this.player.cueVideoById({
          videoId: id,
          startSeconds: (0, _utils.parseStartTime)(url)
        });
        return;
      }
      if (this.loadingSDK) {
        this.loadOnReady = url;
        return;
      }
      this.loadingSDK = true;
      this.getSDK().then(function (YT) {
        _this2.player = new YT.Player(_this2.container, {
          width: '100%',
          height: '100%',
          videoId: id,
          playerVars: _extends({}, DEFAULT_PLAYER_VARS, {
            controls: controls ? 1 : 0
          }, youtubeConfig.playerVars, {
            start: (0, _utils.parseStartTime)(url),
            origin: window.location.origin
          }),
          events: {
            onReady: function onReady() {
              _this2.loadingSDK = false;
              _this2.onReady();
            },
            onStateChange: _this2.onStateChange,
            onError: function onError(event) {
              return _onError(event.data);
            }
          }
        });
      }, _onError);
    }
  }, {
    key: 'play',
    value: function play() {
      if (!this.isReady || !this.player.playVideo) return;
      this.player.playVideo();
    }
  }, {
    key: 'pause',
    value: function pause() {
      if (!this.isReady || !this.player.pauseVideo) return;
      this.player.pauseVideo();
    }
  }, {
    key: 'stop',
    value: function stop() {
      if (!this.isReady || !this.player.stopVideo) return;
      this.player.stopVideo();
    }
  }, {
    key: 'seekTo',
    value: function seekTo(fraction) {
      _get(YouTube.prototype.__proto__ || Object.getPrototypeOf(YouTube.prototype), 'seekTo', this).call(this, fraction);
      if (!this.isReady || !this.player.seekTo) return;
      this.player.seekTo(this.getDuration() * fraction);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      if (!this.isReady || !this.player.setVolume) return;
      this.player.setVolume(fraction * 100);
    }
  }, {
    key: 'setPlaybackRate',
    value: function setPlaybackRate(rate) {
      if (!this.isReady || !this.player.setPlaybackRate) return;
      this.player.setPlaybackRate(rate);
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      if (!this.isReady || !this.player.getDuration) return null;
      return this.player.getDuration();
    }
  }, {
    key: 'getFractionPlayed',
    value: function getFractionPlayed() {
      if (!this.isReady || !this.getDuration()) return null;
      return this.player.getCurrentTime() / this.getDuration();
    }
  }, {
    key: 'getFractionLoaded',
    value: function getFractionLoaded() {
      if (!this.isReady || !this.player.getVideoLoadedFraction) return null;
      return this.player.getVideoLoadedFraction();
    }
  }, {
    key: 'render',
    value: function render() {
      var style = {
        width: '100%',
        height: '100%',
        display: this.props.url ? 'block' : 'none'
      };
      return _react2['default'].createElement(
        'div',
        { style: style },
        _react2['default'].createElement('div', { ref: this.ref })
      );
    }
  }], [{
    key: 'canPlay',
    value: function canPlay(url) {
      return MATCH_URL.test(url);
    }
  }]);

  return YouTube;
}(_BasePlayer3['default']);

YouTube.displayName = 'YouTube';
exports['default'] = YouTube;
module.exports = exports['default'];

/***/ }),
/* 205 */
/***/ (function(module, exports) {


module.exports = function load (src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0]
  var script = document.createElement('script')

  if (typeof opts === 'function') {
    cb = opts
    opts = {}
  }

  opts = opts || {}
  cb = cb || function() {}

  script.type = opts.type || 'text/javascript'
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true
  script.src = src

  if (opts.attrs) {
    setAttributes(script, opts.attrs)
  }

  if (opts.text) {
    script.text = '' + opts.text
  }

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
  onend(script, cb)

  // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload
  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script)
}

function setAttributes(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}

function stdOnEnd (script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null
    cb(null, script)
  }
  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null
    cb(new Error('Failed to load ' + this.src), script)
  }
}

function ieOnEnd (script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return
    this.onreadystatechange = null
    cb(null, script) // there is no way to catch loading errors in IE8
  }
}


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.parseStartTime = parseStartTime;
var MATCH_START_QUERY = /[?&#](?:start|t)=([0-9hms]+)/;
var MATCH_START_STAMP = /(\d+)(h|m|s)/g;
var MATCH_NUMERIC = /^\d+$/;

// Parse YouTube URL for a start time param, ie ?t=1h14m30s
// and return the start time in seconds
function parseStartTime(url) {
  var match = url.match(MATCH_START_QUERY);
  if (match) {
    var stamp = match[1];
    if (stamp.match(MATCH_START_STAMP)) {
      return parseStartStamp(stamp);
    }
    if (MATCH_NUMERIC.test(stamp)) {
      return parseInt(stamp, 10);
    }
  }
  return 0;
}

function parseStartStamp(stamp) {
  var seconds = 0;
  var array = MATCH_START_STAMP.exec(stamp);
  while (array !== null) {
    var _array = array,
        _array2 = _slicedToArray(_array, 3),
        count = _array2[1],
        period = _array2[2];

    if (period === 'h') seconds += parseInt(count, 10) * 60 * 60;
    if (period === 'm') seconds += parseInt(count, 10) * 60;
    if (period === 's') seconds += parseInt(count, 10);
    array = MATCH_START_STAMP.exec(stamp);
  }
  return seconds;
}

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _fetchJsonp = __webpack_require__(208);

var _fetchJsonp2 = _interopRequireDefault(_fetchJsonp);

var _FilePlayer2 = __webpack_require__(105);

var _FilePlayer3 = _interopRequireDefault(_FilePlayer2);

var _props3 = __webpack_require__(135);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RESOLVE_URL = '//api.soundcloud.com/resolve.json';
var MATCH_URL = /^https?:\/\/(soundcloud.com|snd.sc)\/([a-z0-9-_]+\/[a-z0-9-_]+)$/;

var songData = {}; // Cache song data requests

var SoundCloud = function (_FilePlayer) {
  _inherits(SoundCloud, _FilePlayer);

  function SoundCloud() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SoundCloud);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SoundCloud.__proto__ || Object.getPrototypeOf(SoundCloud)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      image: null
    }, _this.clientId = _this.props.soundcloudConfig.clientId || _props3.defaultProps.soundcloudConfig.clientId, _this.ref = function (player) {
      _this.player = player;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SoundCloud, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return _get(SoundCloud.prototype.__proto__ || Object.getPrototypeOf(SoundCloud.prototype), 'shouldComponentUpdate', this).call(this, nextProps, nextState) || this.state.image !== nextState.image;
    }
  }, {
    key: 'getSongData',
    value: function getSongData(url) {
      var _this2 = this;

      if (songData[url]) {
        return Promise.resolve(songData[url]);
      }
      return (0, _fetchJsonp2['default'])(RESOLVE_URL + '?url=' + url + '&client_id=' + this.clientId).then(function (response) {
        if (response.ok) {
          songData[url] = response.json();
          return songData[url];
        } else {
          _this2.props.onError(new Error('SoundCloud track could not be resolved'));
        }
      });
    }
  }, {
    key: 'load',
    value: function load(url) {
      var _this3 = this;

      var _props = this.props,
          soundcloudConfig = _props.soundcloudConfig,
          onError = _props.onError;

      this.stop();
      this.getSongData(url).then(function (data) {
        if (!_this3.mounted) return;
        if (!data.streamable) {
          onError(new Error('SoundCloud track is not streamable'));
          return;
        }
        var image = data.artwork_url || data.user.avatar_url;
        if (image && soundcloudConfig.showArtwork) {
          _this3.setState({ image: image.replace('-large', '-t500x500') });
        }
        _this3.player.src = data.stream_url + '?client_id=' + _this3.clientId;
      }, onError);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          url = _props2.url,
          loop = _props2.loop,
          controls = _props2.controls;

      var style = {
        display: url ? 'block' : 'none',
        height: '100%',
        backgroundImage: this.state.image ? 'url(' + this.state.image + ')' : null,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      };
      return _react2['default'].createElement(
        'div',
        { style: style },
        _react2['default'].createElement('audio', {
          ref: this.ref,
          type: 'audio/mpeg',
          preload: 'auto',
          style: {
            width: '100%',
            height: '100%'
          },
          controls: controls,
          loop: loop
        })
      );
    }
  }], [{
    key: 'canPlay',
    value: function canPlay(url) {
      return MATCH_URL.test(url);
    }
  }]);

  return SoundCloud;
}(_FilePlayer3['default']);

SoundCloud.displayName = 'SoundCloud';
exports['default'] = SoundCloud;
module.exports = exports['default'];

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
    factory(exports, module);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, mod);
    global.fetchJsonp = mod.exports;
  }
})(this, function (exports, module) {
  'use strict';

  var defaultOptions = {
    timeout: 5000,
    jsonpCallback: 'callback',
    jsonpCallbackFunction: null
  };

  function generateCallbackFunction() {
    return 'jsonp_' + Date.now() + '_' + Math.ceil(Math.random() * 100000);
  }

  function clearFunction(functionName) {
    // IE8 throws an exception when you try to delete a property on window
    // http://stackoverflow.com/a/1824228/751089
    try {
      delete window[functionName];
    } catch (e) {
      window[functionName] = undefined;
    }
  }

  function removeScript(scriptId) {
    var script = document.getElementById(scriptId);
    if (script) {
      document.getElementsByTagName('head')[0].removeChild(script);
    }
  }

  function fetchJsonp(_url) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    // to avoid param reassign
    var url = _url;
    var timeout = options.timeout || defaultOptions.timeout;
    var jsonpCallback = options.jsonpCallback || defaultOptions.jsonpCallback;

    var timeoutId = undefined;

    return new Promise(function (resolve, reject) {
      var callbackFunction = options.jsonpCallbackFunction || generateCallbackFunction();
      var scriptId = jsonpCallback + '_' + callbackFunction;

      window[callbackFunction] = function (response) {
        resolve({
          ok: true,
          // keep consistent with fetch API
          json: function json() {
            return Promise.resolve(response);
          }
        });

        if (timeoutId) clearTimeout(timeoutId);

        removeScript(scriptId);

        clearFunction(callbackFunction);
      };

      // Check if the user set their own params, and if not add a ? to start a list of params
      url += url.indexOf('?') === -1 ? '?' : '&';

      var jsonpScript = document.createElement('script');
      jsonpScript.setAttribute('src', '' + url + jsonpCallback + '=' + callbackFunction);
      if (options.charset) {
        jsonpScript.setAttribute('charset', options.charset);
      }
      jsonpScript.id = scriptId;
      document.getElementsByTagName('head')[0].appendChild(jsonpScript);

      timeoutId = setTimeout(function () {
        reject(new Error('JSONP request to ' + _url + ' timed out'));

        clearFunction(callbackFunction);
        removeScript(scriptId);
      }, timeout);

      // Caught if got 404/500
      jsonpScript.onerror = function () {
        reject(new Error('JSONP request to ' + _url + ' failed'));

        clearFunction(callbackFunction);
        removeScript(scriptId);
        if (timeoutId) clearTimeout(timeoutId);
      };
    });
  }

  // export as global function
  /*
  let local;
  if (typeof global !== 'undefined') {
    local = global;
  } else if (typeof self !== 'undefined') {
    local = self;
  } else {
    try {
      local = Function('return this')();
    } catch (e) {
      throw new Error('polyfill failed because global object is unavailable in this environment');
    }
  }
  local.fetchJsonp = fetchJsonp;
  */

  module.exports = fetchJsonp;
});

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _queryString = __webpack_require__(166);

var _BasePlayer2 = __webpack_require__(136);

var _BasePlayer3 = _interopRequireDefault(_BasePlayer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IFRAME_SRC = 'https://player.vimeo.com/video/';
var MATCH_URL = /https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/;
var MATCH_MESSAGE_ORIGIN = /^https?:\/\/player.vimeo.com/;
var BLANK_VIDEO_URL = 'https://vimeo.com/127250231';
var DEFAULT_IFRAME_PARAMS = {
  api: 1,
  autoplay: 0,
  badge: 0,
  byline: 0,
  fullscreen: 1,
  portrait: 0,
  title: 0
};

var Vimeo = function (_BasePlayer) {
  _inherits(Vimeo, _BasePlayer);

  function Vimeo() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Vimeo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Vimeo.__proto__ || Object.getPrototypeOf(Vimeo)).call.apply(_ref, [this].concat(args))), _this), _this.onMessage = function (e) {
      if (!MATCH_MESSAGE_ORIGIN.test(e.origin)) return;
      _this.origin = _this.origin || e.origin;
      var data = JSON.parse(e.data);
      if (data.event === 'ready') {
        _this.postMessage('getDuration');
        _this.postMessage('addEventListener', 'playProgress');
        _this.postMessage('addEventListener', 'loadProgress');
        _this.postMessage('addEventListener', 'play');
        _this.postMessage('addEventListener', 'pause');
        _this.postMessage('addEventListener', 'finish');
      }
      if (data.event === 'playProgress') _this.fractionPlayed = data.data.percent;
      if (data.event === 'loadProgress') _this.fractionLoaded = data.data.percent;
      if (data.event === 'play') _this.onPlay();
      if (data.event === 'pause') _this.props.onPause();
      if (data.event === 'finish') _this.onEnded();
      if (data.method === 'getDuration') {
        _this.duration = data.value; // Store for use later
        _this.onReady();
      }
    }, _this.onEnded = function () {
      var _this$props = _this.props,
          loop = _this$props.loop,
          onEnded = _this$props.onEnded;

      if (loop) {
        _this.seekTo(0);
      }
      onEnded();
    }, _this.postMessage = function (method, value) {
      if (!_this.origin) return;
      var data = JSON.stringify({ method: method, value: value });
      return _this.iframe.contentWindow && _this.iframe.contentWindow.postMessage(data, _this.origin);
    }, _this.ref = function (iframe) {
      _this.iframe = iframe;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Vimeo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          url = _props.url,
          vimeoConfig = _props.vimeoConfig;

      window.addEventListener('message', this.onMessage, false);

      if (!url && vimeoConfig.preload) {
        this.preloading = true;
        this.load(BLANK_VIDEO_URL);
      }

      _get(Vimeo.prototype.__proto__ || Object.getPrototypeOf(Vimeo.prototype), 'componentDidMount', this).call(this);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('message', this.onMessage, false);
      _get(Vimeo.prototype.__proto__ || Object.getPrototypeOf(Vimeo.prototype), 'componentWillUnmount', this).call(this);
    }
  }, {
    key: 'getIframeParams',
    value: function getIframeParams() {
      return _extends({}, DEFAULT_IFRAME_PARAMS, this.props.vimeoConfig.iframeParams);
    }
  }, {
    key: 'load',
    value: function load(url) {
      var id = url.match(MATCH_URL)[3];
      this.iframe.src = IFRAME_SRC + id + '?' + (0, _queryString.stringify)(this.getIframeParams());
    }
  }, {
    key: 'play',
    value: function play() {
      this.postMessage('play');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.postMessage('pause');
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.iframe.src = '';
    }
  }, {
    key: 'seekTo',
    value: function seekTo(fraction) {
      _get(Vimeo.prototype.__proto__ || Object.getPrototypeOf(Vimeo.prototype), 'seekTo', this).call(this, fraction);
      this.postMessage('seekTo', this.duration * fraction);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.postMessage('setVolume', fraction);
    }
  }, {
    key: 'setPlaybackRate',
    value: function setPlaybackRate(rate) {
      return null;
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: 'getFractionPlayed',
    value: function getFractionPlayed() {
      return this.fractionPlayed || null;
    }
  }, {
    key: 'getFractionLoaded',
    value: function getFractionLoaded() {
      return this.fractionLoaded || null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _getIframeParams = this.getIframeParams(),
          fullscreen = _getIframeParams.fullscreen;

      var style = {
        display: this.props.url ? 'block' : 'none',
        width: '100%',
        height: '100%'
      };
      return _react2['default'].createElement('iframe', {
        ref: this.ref,
        frameBorder: '0',
        style: style,
        allowFullScreen: fullscreen
      });
    }
  }], [{
    key: 'canPlay',
    value: function canPlay(url) {
      return MATCH_URL.test(url);
    }
  }]);

  return Vimeo;
}(_BasePlayer3['default']);

Vimeo.displayName = 'Vimeo';
exports['default'] = Vimeo;
module.exports = exports['default'];

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _FilePlayer2 = __webpack_require__(105);

var _FilePlayer3 = _interopRequireDefault(_FilePlayer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RESOLVE_URL = 'https://api.streamable.com/videos/';
var MATCH_URL = /^https?:\/\/streamable.com\/([a-z0-9]+)$/;

var cache = {}; // Cache song data requests

var Streamable = function (_FilePlayer) {
  _inherits(Streamable, _FilePlayer);

  function Streamable() {
    _classCallCheck(this, Streamable);

    return _possibleConstructorReturn(this, (Streamable.__proto__ || Object.getPrototypeOf(Streamable)).apply(this, arguments));
  }

  _createClass(Streamable, [{
    key: 'getData',
    value: function getData(url) {
      var onError = this.props.onError;

      var id = url.match(MATCH_URL)[1];
      if (cache[id]) {
        return Promise.resolve(cache[id]);
      }
      return window.fetch(RESOLVE_URL + id).then(function (response) {
        if (response.status === 200) {
          cache[id] = response.json();
          return cache[id];
        } else {
          onError(new Error('Streamable track could not be resolved'));
        }
      });
    }
  }, {
    key: 'load',
    value: function load(url) {
      var _this2 = this;

      var onError = this.props.onError;

      this.stop();
      this.getData(url).then(function (data) {
        if (!_this2.mounted) return;
        _this2.player.src = data.files.mp4.url;
      }, onError);
    }
  }], [{
    key: 'canPlay',
    value: function canPlay(url) {
      return MATCH_URL.test(url);
    }
  }]);

  return Streamable;
}(_FilePlayer3['default']);

Streamable.displayName = 'Streamable';
exports['default'] = Streamable;
module.exports = exports['default'];

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _FilePlayer2 = __webpack_require__(105);

var _FilePlayer3 = _interopRequireDefault(_FilePlayer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RESOLVE_URL = 'https://api.vid.me/videoByUrl/';
var MATCH_URL = /^https?:\/\/vid.me\/([a-z0-9]+)$/;

var cache = {}; // Cache song data requests

var Vidme = function (_FilePlayer) {
  _inherits(Vidme, _FilePlayer);

  function Vidme() {
    _classCallCheck(this, Vidme);

    return _possibleConstructorReturn(this, (Vidme.__proto__ || Object.getPrototypeOf(Vidme)).apply(this, arguments));
  }

  _createClass(Vidme, [{
    key: 'getData',
    value: function getData(url) {
      var onError = this.props.onError;

      var id = url.match(MATCH_URL)[1];
      if (cache[id]) {
        return Promise.resolve(cache[id]);
      }
      return window.fetch(RESOLVE_URL + id).then(function (response) {
        if (response.status === 200) {
          cache[id] = response.json();
          return cache[id];
        } else {
          onError(new Error('Vidme track could not be resolved'));
        }
      });
    }
  }, {
    key: 'load',
    value: function load(url) {
      var _this2 = this;

      var onError = this.props.onError;

      this.stop();
      this.getData(url).then(function (data) {
        if (!_this2.mounted) return;
        _this2.player.src = data.video.complete_url;
      }, onError);
    }
  }], [{
    key: 'canPlay',
    value: function canPlay(url) {
      return MATCH_URL.test(url);
    }
  }]);

  return Vidme;
}(_FilePlayer3['default']);

Vidme.displayName = 'Vidme';
exports['default'] = Vidme;
module.exports = exports['default'];

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(4);

var _lodash2 = _interopRequireDefault(_lodash);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _fullscreenView = __webpack_require__(213);

var _fullscreenView2 = _interopRequireDefault(_fullscreenView);

var _itemLayout = __webpack_require__(110);

var _itemLayout2 = _interopRequireDefault(_itemLayout);

var _consts = __webpack_require__(106);

var _consts2 = _interopRequireDefault(_consts);

var _index = __webpack_require__(2);

var _proGalleryVersionManager = __webpack_require__(94);

var _utils = __webpack_require__(2);

var _watermarkApi = __webpack_require__(12);

var _watermarkApi2 = _interopRequireDefault(_watermarkApi);

var _storeApi = __webpack_require__(58);

var _storeApi2 = _interopRequireDefault(_storeApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FullscreenContainer = function (_React$Component) {
  _inherits(FullscreenContainer, _React$Component);

  function FullscreenContainer(props, context) {
    _classCallCheck(this, FullscreenContainer);

    var _this = _possibleConstructorReturn(this, (FullscreenContainer.__proto__ || Object.getPrototypeOf(FullscreenContainer)).call(this, props, context));

    _this.initDefaults();
    _this.initGalleryInfo();

    _this.resize = _this.resize.bind(_this);
    _this.orientationChange = _this.orientationChange.bind(_this);

    _this.state = _this.prepareInitialState();

    if (_index.utils.isDev()) console.log('FULLSCREEN - constructor');
    return _this;
  }

  //----------------------------------------| REACT |----------------------------------------//

  _createClass(FullscreenContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.initOnce();
      this.init();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.init();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.videoInterval);
    }

    //-----------------------------------------| INIT |----------------------------------------//

  }, {
    key: 'initDefaults',
    value: function initDefaults() {
      this.readyToRender = true;
      this.parseStyleParams({}); //set defaults (sync)
      this.navigatedInto = false;
      this.extraImages = _index.utils.isMobile() ? 2 : 5; //number of images to preload on each side of the fullscre
    }
  }, {
    key: 'initOnce',
    value: function initOnce() {

      if (_index.utils.isDev()) console.log('FULLSCREEN - initOnce');

      this.initNavigationEvents();
    }
  }, {
    key: 'init',
    value: function init() {

      if (this.isPreload()) return;

      if (_index.utils.isDev()) console.log('FULLSCREEN - init');

      this.isOpen = true;

      this.initEvents();
      this.initGalleryInfo();
      this.initStyleParams();
      this.initExpandSettingsMode();

      this.resize(); //set initial size

      this.setCurrentItem(); //set initial item
      // var isIE = utils.browserIs('explorer');
      // if (!isIE) {
      //this.cancelOpenHttpRequests(); //removed because it is causeing the fullscreen to be flaky
      // }

      this.handleMouseMove(); //show the icons (that will show on mouse move) on startup

      _index.utils.setStateAndLog(this, 'init', this.prepareInitialState());
      this.initWatermark();
    }
  }, {
    key: 'initStyleParams',
    value: function initStyleParams() {
      this.parseStyleParams({}); //set defaults (sync)
      this.getStyleParams(); //get real params (async)
    }
  }, {
    key: 'initGalleryInfo',
    value: function initGalleryInfo() {
      var _this2 = this;

      var compId = _index.utils.getWorkerWindow()['pro-gallery-fullscreen-comp-id'];
      if (compId === 'null') {
        compId = false;
      }

      try {
        if (_index.utils.isInWix()) {
          //this.galleryWindow = window.parent.document.getElementById(this.galleryInfo.compId).getElementsByTagName('iframe')[0].contentWindow;
          this.galleryWindow = _index.utils.getGalleryByCompId(compId) || window; //using || window is for cases where the fullscreen is loaded without a gallery (e.g. direct link)
          this.galleryData = _index.utils.getWorkerWindow()['pro-gallery-data-' + compId] || {};
        } else {
          this.galleryData = window['pro-gallery-data-' + compId] || {};
          this.galleryWindow = window;
        }
      } catch (e) {
        this.galleryData = {};
        this.galleryWindow = window;
      }

      if (this.galleryData.info) {
        //if the galleryWindow exist (fullscreen was open via click on item in gallery - use it to get the data
        this.galleryInfo = this.galleryData.info;
        this.navigatedInto = true;
      } else if (_index.utils.isInWix()) {
        //if the galleryWindow does not exist (fullscreen was open via direct URL)
        var watermarkData = null;
        var connectedProviders = null;
        if (_index.utils.isStoreGallery()) {
          connectedProviders = window.connectedProviders;

          if (!connectedProviders && _index.utils.isInSettings()) {
            _storeApi2.default.getStoreGalleryData().then(function (connectedProviders) {
              _this2.galleryInfo = Object.assign({}, _this2.galleryInfo, connectedProviders);
              _this2.setState({ connectedProviders: true }); // render
            });
          }
        }

        this.galleryInfo = {
          compId: compId || _index.utils.parsePathParam('comp-') || _index.utils.parseGetParam('c') || _index.utils.parseHashParam('c') || '',
          pageId: _index.utils.parseGetParam('p') || _index.utils.parseHashParam('p') || '',
          styleId: _index.utils.parseGetParam('s') || _index.utils.parseHashParam('s') || '',
          hashtag: _index.utils.parseGetParam('ht') || _index.utils.parseHashParam('ht') || '',
          reachLevel: _index.utils.parseGetParam('rl') || _index.utils.parseHashParam('rl') || 0,
          galleryId: window.galleryId,
          watermarkData: watermarkData,
          connectedProviders: connectedProviders
        };
      } else {
        this.galleryInfo = {
          compId: "none",
          pageId: "none",
          styleId: "none",
          hashtag: "none",
          galleryId: "none",
          reachLevel: 0,
          watermarkData: {},
          connectedProviders: {}
        };
      }

      if (_index.utils.isStoreGallery()) {
        if (!this.galleryInfo.galleryId && _index.utils.isInSettings()) {
          this.galleryInfo.galleryId = _index.utils.parseGetParam('galleryId');
        }
        this.setState({
          showShopFrame: this.galleryInfo.config && this.galleryInfo.config.openShop,
          showShareScreen: false
        });
      }

      //use the compId to find the gallery window

      Wix.Utils.getSectionUrl({ sectionId: _index.utils.getFullscreenSectionId() }, function (res) {
        _this2.fullscreenUrl = res.url;
        _utils.itemActions.initWidgetData({
          compId: _this2.galleryInfo.compId,
          pageId: _this2.galleryInfo.pageId,
          styleId: _this2.galleryInfo.styleId,
          galleryId: _this2.galleryInfo.galleryId,
          fullscreenUrl: _this2.fullscreenUrl
        });

        _utils.itemActions.setReachLevel(_this2.galleryInfo.reachLevel, _this2.galleryInfo.hashtag);
      });

      Wix.getSitePages(function (pages) {
        var page = _lodash2.default.find(pages, { title: 'Fullscreen Page' });
        _this2.pageId = page && page.id || '';
      });
    }
  }, {
    key: 'initNavigationEvents',
    value: function initNavigationEvents() {
      var _this3 = this;

      if (_index.utils.isDev()) console.log('FULLSCREEN - initNavigationEvents (start)');

      if (_index.utils.isInWix()) {

        if (_index.utils.isDev()) console.log('FULLSCREEN - initNavigationEvents (isInWix)');

        if (!_index.utils.isSite() || _index.utils.isInSettings()) {

          if (_index.utils.isDev()) console.log('FULLSCREEN - initNavigationEvents (!isSite)');

          window.addEventListener('message', function (e) {
            if (e.data.type == Wix.Events.STYLE_PARAMS_CHANGE) {
              _this3.onNewStyleParams(e.data.payload);
            }
          });

          Wix.addEventListener(Wix.Events.EDIT_MODE_CHANGE, function () {
            var viewMode = _index.utils.updateViewMode();

            //fullscreen should always be closed in editor mode
            if (_index.utils.isEditor()) {
              _this3.closeFullscreen();
            }

            Wix.getCurrentPageId(function (pageId) {
              if (_this3.navigatedInto || _this3.pageId === pageId) {
                _this3.closeFullscreen();
              }
            });
          });
        }

        Wix.addEventListener(Wix.Events.PAGE_NAVIGATION_IN, function (data) {
          if (_index.utils.isDev()) console.log('FULLSCREEN - PAGE_NAVIGATION_IN', data);
          if (data && data.isAppOnPage) {
            _this3.navigatedInto = true;
            Wix.getCurrentPageId(function (pageId) {
              _this3.pageId = pageId;
            });

            _this3.init();
          }
        });
        Wix.addEventListener(Wix.Events.PAGE_NAVIGATION_OUT, function (data) {
          if (_index.utils.isDev()) console.log('FULLSCREEN - PAGE_NAVIGATION_OUT', data);
          if (data && data.wasAppOnPage) {
            _this3.prepareToClose();
            if (_lodash2.default.isFunction(_this3.props.closeFullscreenCallback)) {
              _this3.props.closeFullscreenCallback(_this3.state.current.idx);
            } else if (_this3.galleryWindow) {
              _this3.galleryWindow.dispatchEvent(_this3.fullscreenClosedEvent);
            }
            _index.utils.setStateAndLog(_this3, 'PAGE_NAVIGATION_OUT', {
              readyToRender: false
            });
          }
        });
      } else {
        //close fullscreen on back button
        window.onpopstate = function () {
          return _this3.closeFullscreen();
        };
      }
    }
  }, {
    key: 'initEvents',
    value: function initEvents() {
      var _this4 = this;

      this.handleMouseMove = _lodash2.default.throttle(function () {
        $('.fullscreen-icon').show().css('opacity', '1');
        $('body').removeClass('no-cursor');
        clearTimeout(_this4.mouseMovedTimeout);

        if (_this4.isBrowserExpanded()) {
          if (!_this4.getItem().isDemo && !_index.utils.isTouch()) {
            _this4.mouseMovedTimeout = setTimeout(function () {
              $('body').addClass('no-cursor');
              $('.fullscreen-icon').css('opacity', '0');
            }, 3000);
          }
        }
      }, 100).bind(this);

      this.handleKeypress = _lodash2.default.throttle(function (e) {

        switch (e.keyCode || e.charCode) {
          case 38: //up
          case 37: //left
          case 33:
            //page up
            e.preventDefault();
            _this4.nextSlide(-1);
            return false;
          case 39: //right
          case 40: //down
          case 34:
            //page down
            e.preventDefault();
            _this4.nextSlide(1);
            return false;
          case 27:
            //esc
            e.preventDefault();
            _this4.handleMouseMove();
            _this4.closeFullscreen();
            return false;
        }
        _this4.handleMouseMove();
        return true; //continue handling the original keyboard event
      }, 100).bind(this);

      this.fullscreenClosedEvent = document.createEvent('CustomEvent'); // MUST be 'CustomEvent'
      this.fullscreenClosedEvent.initCustomEvent('fullscreen_closed', false, false, null);

      this.debouncedResizeEvent = _lodash2.default.debounce(this.resize, 100);

      window.addEventListener('keydown', this.handleKeypress);
      window.addEventListener('mousemove', this.handleMouseMove);
      window.addEventListener('mousedown', this.handleMouseMove);

      window.addEventListener('resize', this.debouncedResizeEvent);
      window.addEventListener('orientationchange', this.orientationChange);
    }
  }, {
    key: 'clearEvents',
    value: function clearEvents() {
      window.removeEventListener('keydown', this.handleKeypress);
      window.removeEventListener('mousemove', this.handleMouseMove);
      window.removeEventListener('mousedown', this.handleMouseMove);

      window.removeEventListener('resize', this.debouncedResizeEvent);
      window.removeEventListener('orientationchange', this.orientationChange);
    }
  }, {
    key: 'initExpandSettingsMode',
    value: function initExpandSettingsMode() {

      if (_index.utils.isInSettings()) {
        try {
          window.parent.postMessage({
            type: "FULLSCREEN_WINDOW_LOADED"
          }, _index.utils.getUrlPrefix());

          var stylesheets = _index.utils.findFontsHrefs(); //Adding stylesheets for fonts
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = stylesheets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var stylesheet = _step.value;

              $(document).find('head').append('<link href="' + stylesheet + '" rel="stylesheet" type="text/css" />');
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        } catch (e) {
          console.warn('Error initing expand settings mode', e);
        }
      }
    }
  }, {
    key: 'initWatermark',
    value: function initWatermark() {
      var _this5 = this;

      if (_index.utils.isStoreGallery()) {
        if (_index.utils.isInSettings()) {
          this.setState({
            watermarkReady: true,
            watermark: _watermarkApi2.default.defaultWatermarkData
          }, function () {
            _this5.setState({
              items: _this5.prepareFullscreenItems(_this5.state.items)
            });
          });
          return;
        }
        var galleryInfo = this.galleryInfo || {};
        var watermarkData = galleryInfo.watermarkData;
        if (watermarkData) {
          this.setState({
            watermarkReady: true,
            watermark: watermarkData
          }, function () {
            _this5.setState({
              items: _this5.prepareFullscreenItems(_this5.state.items)
            });
          });
        } else {
          this.setState({
            watermarkReady: true,
            watermark: _watermarkApi2.default.defaultWatermarkData
          });
        }
      }
    }
  }, {
    key: 'cancelOpenHttpRequests',
    value: function cancelOpenHttpRequests() {
      // this hack clears up any pending socket issues. damn it chrome.
      // be careful - it cancels any http requests
      console.warn('Open fullscreen - canceling all http requests!');
      if (window && typeof window['stop'] == 'function') {
        window['stop']();
      } else if (document.execCommand !== undefined) {
        document.execCommand('Stop', false);
      }
    }
  }, {
    key: 'prepareInitialState',
    value: function prepareInitialState() {
      var initialItems = this.getInitialItems();
      var initialIdx = Math.min(this.getInitialItemIdx(), initialItems.length - 1);
      return {
        readyToRender: this.readyToRender,
        watermarkReady: !_index.utils.isStoreGallery() || _index.utils.isInSettings(),
        showInfo: this.shouldShowInfo(initialIdx),
        showMobileShopFrame: false,
        showShareScreen: false,
        items: initialItems,
        swipperReady: false,
        showShare: false,
        isPlaying: false,
        isVideoLoading: false,
        current: this.getCurrentItemState(initialIdx),
        styleParams: this.styleParams,
        window: this.getWindowState(),
        watermark: {}
      };
    }

    //----------------------------------------| UTILS |----------------------------------------//

  }, {
    key: 'isPreload',
    value: function isPreload() {
      if (this.prerenderedItem) {
        //direct landing on fullscreen
        return false;
      }

      if (this.navigatedInto) {
        //click from gallery
        return false;
      }

      if (_index.utils.isInSettings()) {
        //In expand mode settings screen
        return false;
      }
      return true;

      // return !(this.galleryInfo && this.galleryInfo.compId && this.galleryInfo.pageId && this.galleryInfo.styleId);
    }
  }, {
    key: 'windowSize',
    value: function windowSize() {
      var w = $(window);
      var dim = {
        width: Math.round(w.width() / _index.utils.getViewportScaleRatio()),
        height: Math.round(w.height() / _index.utils.getViewportScaleRatio())
      };

      var isMobile = _index.utils.isMobile();
      var sidebarWidth = _proGalleryVersionManager.versionManager.useFullScreenWideSidebar() ? _consts2.default.STORE_SIDE_BAR_WIDTH : _consts2.default.SIDE_BAR_WIDTH;
      var mobilePadding = _proGalleryVersionManager.versionManager.useFullScreenMobilePadding() && isMobile ? _consts2.default.MOBILE_PADDING : _consts2.default.NO_PADDING;

      if (this.shouldShowInfo()) {
        return {
          width: dim.width - sidebarWidth,
          height: dim.height - mobilePadding
        };
      } else if (mobilePadding != 0) {
        return {
          width: dim.width,
          height: dim.height - mobilePadding
        };
      } else {
        return dim;
      }
    }
  }, {
    key: 'isBrowserExpanded',
    value: function isBrowserExpanded() {
      return document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
    }
  }, {
    key: 'getWindowScale',
    value: function getWindowScale() {
      var _this6 = this;

      var scale = {};
      if (this.isBrowserExpanded() || _index.utils.isSmallScreen()) {
        scale = {
          horizontal: 1,
          vertical: 1
        };
      } else {
        var w = this.windowSize();
        scale = {
          horizontal: (w.width - 100 * 2) / w.width,
          vertical: (w.height - 100 * 2) / w.height
        };
      }
      scale.min = function (item) {
        if (_this6.isBrowserExpanded() || _index.utils.isSmallScreen()) {
          return 1;
        } else {
          var w = _this6.windowSize();
          var horizontal = (w.width - 100 * 2) / item.width;
          var vertical = (w.height - 100 * 2) / item.height;
          return Math.min(horizontal, vertical);
        }
      };
      return scale;
    }
  }, {
    key: 'getWindowState',
    value: function getWindowState() {
      return {
        size: this.windowSize(),
        expanded: this.isBrowserExpanded(),
        scale: this.getWindowScale()
      };
    }
  }, {
    key: 'shouldShowInfo',
    value: function shouldShowInfo(idx) {
      if (_index.utils.isStoreGallery() && !_index.utils.isMobile()) {
        return true;
      } else if (this.isBrowserExpanded()) {
        return false;
      } else if (this.state) {
        return this.state.showInfo && this.hasInfo(idx);
      } else {
        return this.styleParams.defaultShowInfoExpand === 1 && !_index.utils.isSmallScreen();
      }
    }
  }, {
    key: 'hasInfo',
    value: function hasInfo(idx) {

      var curItem;

      if (!_lodash2.default.isUndefined(idx)) {
        curItem = this.getItem(idx);
      } else {
        curItem = this.getItem(_lodash2.default.get(this, 'state.current.idx') || 0);
      }

      return (curItem.title || curItem.fileName) && this.styleParams.allowTitleExpand || curItem.description && this.styleParams.allowDescriptionExpand || curItem.linkUrl && _index.utils.isMobile(); // curItem.isDemo);
    }

    //------------------------------------| ITEMS MANAGER |------------------------------------//

  }, {
    key: 'getItem',
    value: function getItem(idx) {
      var emptyItem = {
        id: '',
        full_url: {}
      };
      if (!this.state) {
        return emptyItem;
      } else if (!_lodash2.default.isUndefined(idx) && _lodash2.default.isArray(this.state.items)) {
        return this.state.items[idx] || emptyItem;
      } else {
        if (_lodash2.default.get(this, 'state.current.item.id')) {
          return this.state.current.item;
        } else if (this.state.items[_lodash2.default.get(this, 'state.current.idx')]) {
          return this.state.items[_lodash2.default.get(this, 'state.current.idx')];
        } else if (_lodash2.default.get(this, 'prerenderedItem.id')) {
          return this.prerenderedItem;
        } else {
          return emptyItem;
        }
      }
    }
  }, {
    key: 'getCurrentItemState',
    value: function getCurrentItemState(idx) {

      if (_lodash2.default.isUndefined(idx)) {
        idx = this.state.current.idx || 0;
      }

      var currentItemState = {
        idx: idx,
        item: this.getItem(idx),
        hasInfo: this.hasInfo(idx),
        pos: this.getItemsDisplayRange()
      };

      return currentItemState;
    }
  }, {
    key: 'setCurrentItem',
    value: function setCurrentItem(idx) {
      var _this7 = this;

      var currentItemState = this.getCurrentItemState(idx);
      _index.utils.setStateAndLog(this, 'setCurrentItem', { current: currentItemState }, function () {
        _this7.replaceCurrentUrl();
      });
    }
  }, {
    key: 'createItem',
    value: function createItem(itemDto, idx) {
      if (itemDto.dto) {
        //the item is already an object
        return itemDto;
      }
      return new _itemLayout2.default({
        idx: idx,
        dto: itemDto.dto || itemDto,
        cubeImages: false,
        createdBy: 'fullscreenCreateItem'
      });
    }
  }, {
    key: 'getInitialItemIdx',
    value: function getInitialItemIdx() {
      try {
        return Number(this.galleryInfo.itemIdx || _index.utils.parseGetParam('i') || _index.utils.parseHashParam('i') || this.props.demoModeParams.item || 0);
      } catch (e) {
        return 0;
      }
    }
  }, {
    key: 'getInitialItems',
    value: function getInitialItems() {
      var _this8 = this;

      console.time('Fullscreen Class - PREPARE ITEMS');

      var items = void 0;
      var prerenderedItem = window['prerenderedItem'];

      if (this.galleryData && this.galleryData.items) {
        try {
          this.galleryLayout = this.galleryData.items.galleryLayout;
          this.totalItemsCount = this.galleryData.items.totalItemsCount;
          this.currentGalleryItems = this.galleryData.items.currentGalleryItems;
        } catch (e) {
          console.warn('Could not find galleryWindow items', e);
          this.totalItemsCount = this.props.totalItemsCount || 1;
        }
      } else {
        this.totalItemsCount = this.props.totalItemsCount || 1;
      }

      if (this.currentGalleryItems && this.galleryLayout) {
        //Opened from the Gallery -> get the items from the gallery window

        items = this.currentGalleryItems;

        this.galleryItems = {};
        _lodash2.default.flattenDeep(this.galleryLayout.columns.map(function (column) {
          return column.map(function (group) {
            return group.items;
          });
        })).forEach(function (item) {
          _this8.galleryItems[item.photoId] = item;
        });

        for (var i = 0; items[i]; i++) {
          items[i] = this.createItem(items[i], i);
        }
      } else if (prerenderedItem && prerenderedItem.items) {
        //Opened directly via deep link -> get the first item from the prerendered gallery

        items = prerenderedItem.items;

        this.prerenderedItem = new _itemLayout2.default({
          dto: items[0],
          createdBy: 'fullscreenGetInitialItems'
        });

        this.totalItemsCount = 1; //keep count at 1 until more items arrive

        //use the infinite scroll url to get all the items up to this one
        this.prerenderedItems = [];
        this.completeMissingItems();
      } else if (window['emptyImages']) {
        //Not opened yet (preload) or some sort of error -> get the sample images

        var shouldShowSampleImages = _index.utils.isDev() || _index.utils.isInSettings();

        items = shouldShowSampleImages ? window['sampleImages'].photos : window['emptyImages'].photos;
        this.totalItemsCount = items.length;

        if (!this.isPreload()) {
          //displaying the sample images is just as placeholders - the fullscreen should be closed
          if (_index.utils.isDev()) console.log('Closing fullscreen automatically (emptyImages are displayed while not in preload)');
          this.closeFullscreen();
        } else {
          //check if the fullscreen is the current page viewed and it displays empty (gray) images - if it is, close it
          if (!shouldShowSampleImages) {
            Wix.getSiteInfo(function (siteInfo) {
              if (siteInfo && siteInfo.url && siteInfo.url.indexOf('fullscreen-page') > 0) {
                if (_index.utils.isDev()) console.log('Closing fullscreen automatically (emptyImages are displayed while page is displayed)');
                _this8.closeFullscreen();
              }
            });
          }
        }
      } else {

        items = [];
        this.totalItemsCount = 0;
        console.warn('No images to display on fullscreen');
      }

      items = this.prepareFullscreenItems(items);

      if (_index.utils.isDev()) {
        console.timeEnd('Fullscreen Class - PREPARE ITEMS');
      }

      return items;
    }
  }, {
    key: 'prepareFullscreenItems',
    value: function prepareFullscreenItems(srcItems) {

      if (_index.utils.isDev()) {
        console.count('Preparing fullscreen items');
        console.time('Prepare fullscreen items');
      }

      var items = [];
      var item;
      var pointer = 0;

      var w = this.windowSize();
      var window_width = w.width;
      var window_height = w.height;
      var window_ratio = window_width / window_height;

      while (item = srcItems[pointer]) {
        var stateWatermark = _lodash2.default.get(this, 'state.watermark');
        var isEmptyWatermarkInState = _lodash2.default.isEmpty(stateWatermark);
        var watermark = isEmptyWatermarkInState ? _watermarkApi2.default ? _watermarkApi2.default.defaultWatermarkData : null : stateWatermark;

        item = new _itemLayout2.default({
          idx: pointer,
          dto: srcItems[pointer].dto || srcItems[pointer], //if the item is an Item object - use the dto
          cubeImages: false,
          sharpParams: _lodash2.default.get(this, 'styleParams.sharpParams'),
          watermark: watermark,
          createdBy: 'prepareFullscreenItems'
        });

        var galleryItem = this.galleryItems && this.galleryItems[item.photoId];
        var useGalleryItem = galleryItem && !galleryItem.cubeImages && !(_index.utils.isMobile() && (galleryItem.resizeWidth > window_width || galleryItem.resizeHeight > window_height)); //on mobile, use the gallery image only if its smaller than the screen (must be a light image for smooth transitions

        item.preload_img = useGalleryItem ? galleryItem.resized_url['img'] : item.thumbnail_url['img'];

        var overScale = _index.utils.isTouch() && item.isImage ? 2 : 1; //bring overscaled images to make sure it remains sharp when pinching

        //calc the fullscreen sizes
        if (item.ratio > window_ratio) {
          item.resize(window_width / item.width * overScale);
        } else {
          item.resize(window_height / item.height * overScale);
        }

        item.width = Math.floor(item.width / overScale);
        item.height = Math.floor(item.height / overScale);

        //populate the items array
        items.push(item);

        //advance the pointer
        pointer++;
      }

      if (_index.utils.isDev()) {
        console.timeEnd('Prepare fullscreen items');
      }

      return items;
    }
  }, {
    key: 'concatNewItems',
    value: function concatNewItems(curItems, newItems) {

      if (!newItems || !newItems.length > 0) {
        return curItems;
      }

      curItems = curItems.concat(newItems);
      curItems = _lodash2.default.uniqBy(curItems, function (item) {
        return item.itemId || item.photoId || item.url;
      });
      curItems = _lodash2.default.sortBy(curItems, function (item) {
        return item.orderIndex;
      });
      curItems = curItems.slice(0, this.totalItemsCount);
      for (var item, i = 0; item = curItems[i]; i++) {
        item.idx = i;
      }
      return curItems;
    }
  }, {
    key: 'completeMissingItems',
    value: function completeMissingItems() {
      var _this9 = this;

      if (this.galleryInfo.hashtag) {
        //get items by hashtag
        $.get(_index.utils.getApiUrlPrefix() + 'gallery/' + window.galleryId + '/hashtags/' + this.galleryInfo.hashtag + '/items?instance=' + window.instance, function (res) {
          if (res && res.items && res.items.length > 0) {
            _this9.totalItemsCount = res.items.length;
            _this9.prerenderedItems = res.items;
            var requiredItemIdx = 0;
            _index.utils.setStateAndLog(_this9, 'completeMissingItems #1', {
              items: _this9.prepareFullscreenItems(_this9.prerenderedItems),
              current: _this9.getCurrentItemState(requiredItemIdx),
              isLoved: _utils.itemActions.isLoved(_this9.prerenderedItems[requiredItemIdx].id),
              readyToRender: false
            }, function () {
              _this9.replaceCurrentUrl();
              _index.utils.setStateAndLog(_this9, 'completeMissingItems #2', {
                readyToRender: true,
                isPlaying: false
              });
            });
          }
        });
      } else if (window.infiniteScrollUrl && window.instance) {
        //get items from gallery
        var batchSize = 500;
        var storeParameter = '';
        if (_index.utils.isStoreGallery()) {
          storeParameter = '&isStore=true';
        }
        $.get(window.infiniteScrollUrl + 'from/' + this.prerenderedItems.length + '/to/' + (this.prerenderedItems.length + batchSize) + '?instance=' + window.instance + storeParameter, function (res) {
          if (res && res.items && res.items.length > 0) {
            _this9.totalItemsCount = _this9.prerenderedItems.length + res.items.length;
            _this9.prerenderedItems = _this9.concatNewItems(_this9.prerenderedItems, res.items);
            var requiredItemIdx = _lodash2.default.findIndex(_this9.prerenderedItems, function (item) {
              return item.itemId == _this9.prerenderedItem.itemId;
            });
            if (requiredItemIdx >= 0 && requiredItemIdx < _this9.prerenderedItems.length - 1) {
              //search for the item and make sure more items exist after it
              console.log('The Item was found', requiredItemIdx);
              _this9.totalItemsCount = res.totalItemsCount; //now use the real total
              _index.utils.setStateAndLog(_this9, 'completeMissingItems #1', {
                items: _this9.prepareFullscreenItems(_this9.prerenderedItems),
                current: _this9.getCurrentItemState(requiredItemIdx),
                isLoved: _utils.itemActions.isLoved(_this9.prerenderedItems[requiredItemIdx].id),
                readyToRender: false
              }, function () {
                _this9.replaceCurrentUrl();
                _index.utils.setStateAndLog(_this9, 'completeMissingItems #2', {
                  readyToRender: true,
                  isPlaying: false
                });
              });
            } else {
              console.warn('The Item was not found! - retrying...');
              _this9.completeMissingItems();
            }
          }
        });
      } else {
        if (!window.infiniteScrollUrl) {
          console.warn('Could not get more items - missing infinite scroll url');
        }
        if (!window.instance) {
          console.warn('Could not get more items - missing instance');
        }
      }
    }
  }, {
    key: 'getMoreItems',
    value: function getMoreItems(idx) {
      var _this10 = this;

      var curTo = this.state.items.length || 0;

      var to = Math.min(this.totalItemsCount, idx + this.extraImages * 5);

      if (!this.fetchingMoreItems && to > curTo) {
        this.fetchingMoreItems = true;

        to += 50;
        //to = Math.min(this.totalItemsCount + 1, to + 50);

        console.time('Fetching items from DB');

        var storeParameter = '';
        if (_index.utils.isStoreGallery()) {
          storeParameter = '&isStore=true';
        }
        $.get((this.galleryData.window || window).infiniteScrollUrl + 'from/' + curTo + '/to/' + to + '?instance=' + (this.galleryData.window || window).instance + storeParameter, function (res) {
          console.timeEnd('Fetching items from DB');
          console.log('Fetched items from DB', res);
          if (res && res.items && res.items.length > 0) {
            _this10.totalItemsCount = res.totalItemsCount;
            var items = _this10.concatNewItems(_this10.state.items, _this10.prepareFullscreenItems(res.items));
            _index.utils.setStateAndLog(_this10, 'getMoreItems', {
              items: items
            });
            _this10.fetchingMoreItems = false;
          }
        });
      } else {
        // console.log('NOT Fetching items from DB', to, curTo); todo yoshi
      }
    }
  }, {
    key: 'getItemsDisplayRange',
    value: function getItemsDisplayRange() {
      return _index.utils.isTouch() ? 2 : 5;
    }
  }, {
    key: 'getItemsToDisplay',
    value: function getItemsToDisplay() {
      var range = this.getItemsDisplayRange();
      var startIdx = this.state.current.idx - range;
      var endIdx = this.state.current.idx + range;

      //create a fixed size items array (size = range * 2 + 1)
      var items = [];
      for (var i = startIdx; i <= endIdx; i++) {
        items.push(this.state.items[i]);
      }

      return items;
    }
  }, {
    key: 'getNextitem',
    value: function getNextitem(idx, direction) {
      var numOfitems = this.state.items.length;
      var next = idx + direction;
      return next < 0 || next >= numOfitems ? idx : next;
    }
  }, {
    key: 'nextSlide',
    value: function nextSlide(direction, nextIdx) {
      var _this11 = this;

      //this method should be called AFTER the animation is finished!

      //disable circling photos
      nextIdx = _lodash2.default.isUndefined(nextIdx) ? this.getNextitem(Number(this.state.current.idx), direction) : nextIdx;
      if (nextIdx === this.state.current.idx) {
        return;
      }

      var nextItem = this.getItem(nextIdx);

      if (nextIdx === false || !nextItem) {
        this.closeFullscreen();
      } else {

        this.setState({
          current: this.getCurrentItemState(nextIdx)
        }, function () {
          _this11.getMoreItems(nextIdx);
          _this11.replaceCurrentUrl();
        });
      }
    }

    //---------------------------------------| STYLES |----------------------------------------//

  }, {
    key: 'onNewStyleParams',
    value: function onNewStyleParams(wixStyles) {
      this.createFullscreenCss(wixStyles);
      var wixStylesParsed = _lodash2.default.merge({}, wixStyles.numbers, wixStyles.booleans, wixStyles.colors, wixStyles.fonts);
      this.parseStyleParams(wixStylesParsed);

      // Update according to new styles
      // (due to quality / usm params change)
      _index.utils.setStateAndLog(this, 'onNewStyleParams', {
        showInfo: this.styleParams.defaultShowInfoExpand == 1 && !_index.utils.isSmallScreen(),
        items: this.prepareFullscreenItems(this.state.items),
        styleParams: this.styleParams,
        readyToRender: true
      });
    }
  }, {
    key: 'getSiteColors',
    value: function getSiteColors() {
      var siteColors = null;
      var wixSkd = window.Wix;
      try {
        if (_index.utils.isInSettings()) {
          wixSkd = window.parent.Wix;
        }
        siteColors = wixSkd.Styles.getSiteColors();
      } catch (error) {
        console.error('fullscreen - error getting site colors');
      }

      return siteColors;
    }
  }, {
    key: 'createFullscreenCss',
    value: function createFullscreenCss(wixStyles) {
      var _this12 = this;

      var getSiteColor = function getSiteColor(strColor) {
        var siteColors = _this12.getSiteColors();
        var colorData = null;
        if (siteColors) {
          colorData = siteColors.find(function (colorData) {
            return colorData.reference === strColor;
          });
        }
        return colorData ? colorData.value : null;
      };

      try {
        this.fullScreenCssCreated = true;
        var formerCssElement = document.getElementById('inlineDynamicFullscreenWixParamsCss');
        if (formerCssElement) {
          var cssSheetParent = formerCssElement.parentNode;
          cssSheetParent.removeChild(formerCssElement);
        }
        var style = document.createElement('style');
        style.setAttribute('id', 'inlineDynamicFullscreenWixParamsCss');
        style.type = 'text/css';

        var color5 = getSiteColor('color-5');

        var bgColorExpand = wixStyles.colors && wixStyles.colors.bgColorExpand && wixStyles.colors.bgColorExpand.value || '';
        var titleColorExpand = wixStyles.colors && wixStyles.colors.titleColorExpand && wixStyles.colors.titleColorExpand.value || '';
        var descriptionColorExpand = wixStyles.colors && wixStyles.colors.descriptionColorExpand && wixStyles.colors.descriptionColorExpand.value || color5;
        var actionsColorExpand = wixStyles.colors && wixStyles.colors.actionsColorExpand && wixStyles.colors.actionsColorExpand.value || '';

        var addToCartColorExpand = wixStyles.colors && wixStyles.colors.addToCartColorExpand && wixStyles.colors.addToCartColorExpand.value || '';
        var addToCartBGColorExpand = wixStyles.colors && wixStyles.colors.addToCartBackColorExpand && wixStyles.colors.addToCartBackColorExpand.value || '';
        var addToCartBorderColorExpand = wixStyles.colors && wixStyles.colors.addToCartBorderColor && wixStyles.colors.addToCartBorderColor.value || '';
        var addToCartFontExpand = wixStyles.fonts && wixStyles.fonts.addToCartFontExpand && wixStyles.fonts.addToCartFontExpand.value || '';
        addToCartFontExpand = addToCartFontExpand.substr(5);
        var addToCartBorderWidthExpand = wixStyles.numbers && wixStyles.numbers.addToCartBorderWidth || 1;

        var titleFontExpand = wixStyles.fonts && wixStyles.fonts.titleFontExpand && wixStyles.fonts.titleFontExpand.value || '';
        titleFontExpand = titleFontExpand.substr(5);
        var descriptionFontExpand = wixStyles.fonts && wixStyles.fonts.descriptionFontExpand && wixStyles.fonts.descriptionFontExpand.value || '';
        descriptionFontExpand = descriptionFontExpand.substr(5);

        var stylePrefix = '#fullscreen #fullscreen-view.fullscreen.fullscreen-bright';

        var descriptionAsRGB = _index.utils.colorStringToObject(descriptionColorExpand);

        var customColors = null;
        var viewportAspectRatio = _index.utils.getScreenWidth() / 320;

        if (descriptionAsRGB) {
          customColors = '\n        ' + stylePrefix + ' .products-list-container {\n          border-bottom: 1px solid rgba(' + descriptionAsRGB.r + ', ' + descriptionAsRGB.g + ', ' + descriptionAsRGB.b + ', 0.2);\n        }\n        ' + stylePrefix + ' .products-list-container .table-cell {\n          border-top: 1px solid rgba(' + descriptionAsRGB.r + ', ' + descriptionAsRGB.g + ', ' + descriptionAsRGB.b + ', 0.2);\n          height: calc(100px * ' + viewportAspectRatio + ');\n        }\n        ' + stylePrefix + ' .products-list-container .table-cell .title {\n          font: ' + descriptionFontExpand + ';\n          color: ' + descriptionColorExpand + ';\n          line-height: 23px !important;\n          font-size: 15px !important;\n        }\n        ' + stylePrefix + ' .products-list-container .table-cell .description {\n          font: ' + descriptionFontExpand + ';\n          color: rgba(' + descriptionAsRGB.r + ', ' + descriptionAsRGB.g + ', ' + descriptionAsRGB.b + ', 0.6);\n          line-height: 23px !important;\n          font-size: 13px !important;\n        }\n        ';
        }

        style.innerHTML = '\n      ' + stylePrefix + ' {\n        background-color: ' + bgColorExpand + ' !important;\n      }\n\n      ' + customColors + '\n\n      ' + stylePrefix + ' .fullscreen-side-bar,\n      ' + stylePrefix + ' .fullscreen-bottom-mobile-info {\n        background-color: ' + bgColorExpand + ' !important;\n      }\n\n      ' + stylePrefix + ' .fullscreen-side-bar-title,\n      ' + stylePrefix + ' .fullscreen-side-bar .fullscreen-side-bar-title {\n        color: ' + titleColorExpand + ' !important;\n        font: ' + titleFontExpand + ' !important;\n      }\n\n      ' + stylePrefix + ' .fullscreen-side-bar-description,\n      ' + stylePrefix + ' .fullscreen-side-bar .fullscreen-side-bar-description,\n      ' + stylePrefix + ' .selected-license,\n      ' + stylePrefix + ' .checkout-link {\n        color: ' + descriptionColorExpand + ' !important;\n        font: ' + descriptionFontExpand + ';\n      }\n\n      ' + stylePrefix + ' .fullscreen-side-bar-description .fullscreen-side-bar-description-line,\n      ' + stylePrefix + ' .fullscreen-side-bar .fullscreen-side-bar-description .fullscreen-side-bar-description-line {\n        color: ' + descriptionColorExpand + ' !important;\n        font: ' + descriptionFontExpand + ' !important;\n      }\n\n      ' + stylePrefix + ' .fullscreen-side-bar-separator,\n      ' + stylePrefix + ' .fullscreen-side-bar .fullscreen-side-bar-separator {\n        border-color: ' + descriptionColorExpand + ' !important;\n      }\n\n      ' + stylePrefix + ' .fullscreen-side-bar-exif,\n      ' + stylePrefix + ' .fullscreen-side-bar .fullscreen-side-bar-exif {\n        color: ' + descriptionColorExpand + ' !important;\n      }\n\n      ' + stylePrefix + ' .fullscreen-side-bar-exif:after,\n      ' + stylePrefix + ' .fullscreen-side-bar .fullscreen-side-bar-exif:after {\n        border-color: ' + descriptionColorExpand + ' !important;\n      }\n\n      ' + stylePrefix + ' .fullscreen-side-bar-link,\n      ' + stylePrefix + ' .fullscreen-side-bar .fullscreen-side-bar-link {\n        color: ' + descriptionColorExpand + ' !important;\n      }\n\n      ' + stylePrefix + ' .fullscreen-side-bar-link:after,\n      ' + stylePrefix + ' .fullscreen-side-bar .fullscreen-side-bar-link:after {\n        border-color: ' + descriptionColorExpand + ' !important;\n      }\n\n      ' + stylePrefix + ' .fullscreen-bottom-link {\n        color: ' + actionsColorExpand + ' !important;\n      }\n\n      ' + stylePrefix + ' .fullscreen-side-bar-social i:not(.loved),\n      ' + stylePrefix + ' .fullscreen-side-bar-social a,\n      ' + stylePrefix + ' .fullscreen-side-bar-social button {\n        color: ' + descriptionColorExpand + ' !important;\n      }\n\n      ' + stylePrefix + ' .fullscreen-item i:not(.loved),\n      ' + stylePrefix + ' .fullscreen-nav i:not(.loved),\n      ' + stylePrefix + ' .fullscreen-nav a,\n      ' + stylePrefix + ' .fullscreen-nav button,\n      ' + stylePrefix + ' .fullscreen-mobile-bar i:not(.loved),\n      ' + stylePrefix + ' .fullscreen-mobile-bar a,\n      ' + stylePrefix + ' .fullscreen-mobile-bar button,\n      ' + stylePrefix + ' .fullscreen-social i:not(.loved),\n      ' + stylePrefix + ' .fullscreen-social a,\n      ' + stylePrefix + ' .fullscreen-social button {\n        color: ' + actionsColorExpand + ' !important;\n      }\n\n      ' + stylePrefix + ' i.fullscreen-item-video-play.progallery-svg-font-icons-play-triangle {\n        color: ' + descriptionColorExpand + ' !important;\n      }\n\n      ' + stylePrefix + ' i.fullscreen-item-video-play.progallery-svg-font-icons-play-background {\n        color: ' + bgColorExpand + ' !important;\n      }\n\n      ' + stylePrefix + ' .fullscreen-icon {\n        background: ' + bgColorExpand + ' !important;\n        color: ' + actionsColorExpand + ' !important;\n      }\n\n      ' + stylePrefix + ' .fullscreen-social-love-store {\n        color: ' + actionsColorExpand + ' !important;\n      }\n\n      ' + stylePrefix + ' .fullscreen-mobile-bar {\n        background-color: ' + bgColorExpand + ' !important;\n      }\n\n      ' + stylePrefix + ' .add-to-cart-button,\n      ' + stylePrefix + ' .fullscreen-side-bar .add-to-cart-button {\n        color: ' + addToCartColorExpand + ' !important;\n        font: ' + addToCartFontExpand + ';\n        background: ' + addToCartBGColorExpand + ' !important;\n        border-width: ' + addToCartBorderWidthExpand + 'px;\n        border-style: solid;\n        border-color: ' + addToCartBorderColorExpand + ';\n      }\n      ';

        document.getElementsByTagName('head')[0].appendChild(style);

        this.injectFonts(wixStyles.googleFontsCssUrl);
      } catch (e) {
        console.error('Could not create css', e);
      }
    }
  }, {
    key: 'injectFonts',
    value: function injectFonts(fontsUrl) {
      if (!fontsUrl) {
        return;
      }
      var formerFontElement = document.getElementById('inlineDynamicFullscreenWixParamsFont');
      if (formerFontElement) {
        formerFontElement.parentNode.removeChild(formerFontElement);
      }
      var font = document.createElement('link');
      font.setAttribute('id', 'inlineDynamicFullscreenWixParamsFont');
      font.setAttribute('rel', 'stylesheet');
      font.setAttribute('type', 'text/css');
      font.setAttribute('href', fontsUrl);

      document.getElementsByTagName('head')[0].appendChild(font);
    }
  }, {
    key: 'getStyleParams',
    value: function getStyleParams() {
      var _this13 = this;

      var wixStyles = {};

      if (_index.utils.isInWix() && !_index.utils.isInSettings()) {
        this.readyToRender = false;
        if (this.galleryInfo.styleId) {
          Wix.Styles.getStyleParamsByStyleId(this.galleryInfo.styleId, function (sp) {
            _this13.onNewStyleParams(sp);
          });
        } else {
          console.error('NO STYLE ID!!!!!', this.galleryInfo);
        }
      } else if (_typeof(window.styles) == 'object') {
        wixStyles = window.styles;
        this.onNewStyleParams(wixStyles);
      } else if (_index.utils.parseGetParam('galleryStyle')) {
        var galleryStyle = _index.utils.parseGetParam('galleryStyle');
        if (/^[\],:{}\s]*$/.test(galleryStyle.replace(/\\["\\\/bfnrtu]/g, '@').replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {
          //the json is ok
          wixStyles = JSON.parse(galleryStyle);
          this.onNewStyleParams(wixStyles);
        }
      } else {
        this.onNewStyleParams({});
      }
    }
  }, {
    key: 'parseStyleParams',
    value: function parseStyleParams(wixStyles) {

      var styleParams = {
        allowDownload: false,
        allowSocial: true,
        loveButton: true,
        loveCounter: true,
        allowTitle: true,
        allowTitleExpand: true,
        allowDescriptionExpand: true,
        allowLinkExpand: true,
        allowExifExpand: false,
        defaultShowInfoExpand: true,
        showInfoExpandButton: true,
        addToCartButtonText: '',
        galleryAlignExpand: 'left'
      };

      _lodash2.default.merge(styleParams, _lodash2.default.pick(wixStyles, ['bgColorExpand', 'titleColorExpand', 'descriptionColorExpand', 'titleFontExpand', 'descriptionFontExpand', 'allowDownload', 'allowSocial', 'loveButton', 'allowTitle', 'allowTitleExpand', 'allowDescriptionExpand', 'allowExifExpand', 'allowLinkExpand', 'addToCartButtonText']));

      if (!_lodash2.default.isUndefined(wixStyles.loveCounter)) {
        styleParams.loveCounter = wixStyles.loveCounter == 0;
      }

      if (!_lodash2.default.isUndefined(wixStyles.galleryAlignExpand)) {
        switch (wixStyles.galleryAlignExpand) {
          case 0:
          default:
            styleParams.galleryAlignExpand = 'left';
            styleParams.galleryAlignExpandIcons = {
              float: 'left'
            };
            break;
          case 1:
            styleParams.galleryAlignExpand = 'center';
            styleParams.galleryAlignExpandIcons = {
              margin: 'auto'
            };
            break;
          case 2:
            styleParams.galleryAlignExpand = 'right';
            styleParams.galleryAlignExpandIcons = {
              float: 'right'
            };
            break;
        }
      }

      if (!_lodash2.default.isUndefined(wixStyles.videoSpeed)) {
        styleParams.videoSpeed = wixStyles.videoSpeed;
      }
      if (!_lodash2.default.isUndefined(wixStyles.videoLoop)) {
        styleParams.videoLoop = wixStyles.videoLoop;
      }

      if (!_lodash2.default.isUndefined(wixStyles.defaultShowInfoExpand)) {
        styleParams.defaultShowInfoExpand = wixStyles.defaultShowInfoExpand === 1;
        styleParams.showInfoExpandButton = _proGalleryVersionManager.versionManager.useFullScreenMoreinfoButtonAlways() ? wixStyles.defaultShowInfoExpand != 2 : wixStyles.defaultShowInfoExpand === 0;
      } else {
        styleParams.showInfoExpandButton = _proGalleryVersionManager.versionManager.useFullScreenMoreinfoButtonAlways();
      }

      if (!_lodash2.default.isUndefined(wixStyles.addToCartButtonText)) {
        styleParams.addToCartButtonText = String(wixStyles.addToCartButtonText);
      }

      styleParams.sharpParams = {
        quality: 90,
        usm: {}
      };

      if (!_lodash2.default.isUndefined(wixStyles.usmToggle) && wixStyles.usmToggle == true) {

        if (!_lodash2.default.isUndefined(wixStyles.imageQuality)) {
          styleParams.sharpParams.quality = wixStyles.imageQuality;
        }
        if (!_lodash2.default.isUndefined(wixStyles.usm_a)) {
          styleParams.sharpParams.usm.usm_a = (wixStyles.usm_a || 0) / 100;
        }
        if (!_lodash2.default.isUndefined(wixStyles.usm_r)) {
          styleParams.sharpParams.usm.usm_r = wixStyles.usm_r;
        }
        if (!_lodash2.default.isUndefined(wixStyles.usm_t)) {
          styleParams.sharpParams.usm.usm_t = (wixStyles.usm_t || 0) / 255;
        }
      }

      this.styleParams = styleParams;

      return styleParams;
    }

    //--------------------------------------| BEHAVIOUR |--------------------------------------//

  }, {
    key: 'orientationChange',
    value: function orientationChange() {
      _index.utils.fixViewport('Fullscreen - oriantation change');
      this.resize();
    }
  }, {
    key: 'expandBrowser',
    value: function expandBrowser() {
      if (!this.isBrowserExpanded()) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.msRequestFullscreen) {
          document.documentElement.msRequestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        }
      }
    }
  }, {
    key: 'prepareToClose',
    value: function prepareToClose() {

      if (!this.isOpen) {
        return;
      }

      this.isOpen = false;

      this.clearEvents();

      this.navigatedInto = false;

      _index.utils.setStateAndLog(this, 'closeFullscreen', {
        showInfo: false,
        readyToRender: false
      });

      //save current items to the window
      try {
        var worker = _index.utils.getWorkerWindow();
        if (worker) {
          worker['pro-gallery-data-' + this.galleryInfo.compId].fullscreenData = {
            currentGalleryItems: this.state.items,
            currentGalleryItemIdx: this.state.current.idx,
            currentHashtag: this.galleryInfo.hashtag
          };
          worker['pro-gallery-hashtag-filter'] = this.galleryInfo.hashtag;
        }
      } catch (e) {
        //
      }
    }
  }, {
    key: 'closeFullscreen',
    value: function closeFullscreen() {

      if (this.isBrowserExpanded()) {

        this.expandBrowser();
      } else {

        this.prepareToClose();

        if (_index.utils.isInWix()) {

          if (this.galleryInfo.pageId) {
            Wix.navigateToPage(this.galleryInfo.pageId, { noTransition: true });
          } else if (this.galleryInfo.compId) {
            Wix.navigateToComponent(this.galleryInfo.compId);
          } else if (!this.isPreload() && !_index.utils.isInSettings()) {
            Wix.getSitePages(function (pages) {
              var homePage = _lodash2.default.find(pages, { 'isHomepage': true });
              if (homePage) {
                Wix.navigateToPage(homePage.id, { noTransition: true });
              }
            });
          }
        } else {
          _index.utils.removeItemHashParam(window.location.href);
          //ReactDOM.unmountComponentAtNode(document.getElementById('gallery-fullscreen'));
          $('#gallery-fullscreen').hide();
          $('#content').show();
        }
      }
    }
  }, {
    key: 'replaceCurrentUrl',
    value: function replaceCurrentUrl(idx, item) {

      if (!_index.utils.isInWix()) return;

      if (this.isPreload()) return;

      if (this.totalItemsCount <= 1) return; //when there is only one item (landing on the fullscreen) - do not change the url

      if (_lodash2.default.isUndefined(idx)) idx = this.state.current.idx;
      if (_lodash2.default.isUndefined(item)) item = this.state.current.item;

      var newUrl = this.galleryInfo.compId + '/' + item.id + '/' + idx + '/?i=' + idx + '&p=' + this.galleryInfo.pageId + '&s=' + this.galleryInfo.styleId;

      if (!_index.utils.isEditor()) {
        Wix.replaceSectionState(newUrl);
      }
    }
  }, {
    key: 'resize',
    value: function resize() {
      console.log('Fullscreen Class - RESIZE');
      _index.utils.setStateAndLog(this, 'resize', {
        items: this.prepareFullscreenItems(this.state.items),
        window: this.getWindowState()
      });
    }
  }, {
    key: 'toggleInfo',
    value: function toggleInfo(forceVal) {
      _index.utils.setStateAndLog(this, 'toggleInfo', {
        showInfo: _lodash2.default.isUndefined(forceVal) ? !this.state.showInfo : forceVal
      });
    }
  }, {
    key: 'toggleShopFrame',
    value: function toggleShopFrame() {
      this.setState({
        showShopFrame: !this.state.showShopFrame
      });
    }
  }, {
    key: 'toggleMobileShopFrame',
    value: function toggleMobileShopFrame() {
      this.setState({
        showMobileShopFrame: !this.state.showMobileShopFrame
      });
    }
  }, {
    key: 'toggleShareScreen',
    value: function toggleShareScreen() {
      this.setState({
        showShareScreen: !this.state.showShareScreen
      });
    }

    //---------------------------------------| RENDER |---------------------------------------//

  }, {
    key: 'render',
    value: function render() {

      if (!this.state.readyToRender) {
        if (_index.utils.isVerbose()) {
          //todo yoshi
          console.log('Not rendering Fullscreen - state not ready', this.state);
        }
        return false;
      }
      var fullscreenItemProps = _lodash2.default.merge({
        isNewEditor: this.props.isNewEditor,
        isSettings: _index.utils.isInSettings(),
        items: this.getItemsToDisplay(),
        totalItems: this.totalItemsCount,
        current: this.getCurrentItemState(),
        styleParams: this.styleParams,
        window: this.getWindowState(),
        showInfo: this.shouldShowInfo(),
        showMobileShopFrame: this.state.showMobileShopFrame,
        showShopFrame: _index.utils.isStoreGallery(),
        showShareScreen: this.state.showShareScreen,
        galleryInfo: this.galleryInfo,
        navigatedInto: this.navigatedInto,
        actions: {
          toggleInfo: this.toggleInfo.bind(this),
          expandBrowser: this.expandBrowser.bind(this),
          close: this.closeFullscreen.bind(this),
          next: this.nextSlide.bind(this),
          toggleShopFrame: this.toggleShopFrame.bind(this),
          toggleMobileShopFrame: this.toggleMobileShopFrame.bind(this),
          toggleShareScreen: this.toggleShareScreen.bind(this)
        }
      }, { demoMode: this.props.demoModeParams });

      if (this.props.store) {
        fullscreenItemProps.store = this.props.store;
      }

      if (_index.utils.isDev()) {
        // console.log("Render FullscreenContainer", fullscreenItemProps); todo yoshi
      }

      return this.state.watermarkReady && _react2.default.createElement(_fullscreenView2.default, _extends({
        photoId: this.state.current.item.itemId
      }, fullscreenItemProps));
    }
  }]);

  return FullscreenContainer;
}(_react2.default.Component);

exports.default = FullscreenContainer;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _commonItemContainer = __webpack_require__(159);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(29);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _loveButton = __webpack_require__(67);

var _loveButton2 = _interopRequireDefault(_loveButton);

var _itemLayout = __webpack_require__(110);

var _itemLayout2 = _interopRequireDefault(_itemLayout);

var _swipper = __webpack_require__(214);

var _swipper2 = _interopRequireDefault(_swipper);

var _bottomLink = __webpack_require__(215);

var _bottomLink2 = _interopRequireDefault(_bottomLink);

var _oldEditorNotice = __webpack_require__(216);

var _oldEditorNotice2 = _interopRequireDefault(_oldEditorNotice);

var _fullscreenShareButtons = __webpack_require__(93);

var _fullscreenShareButtons2 = _interopRequireDefault(_fullscreenShareButtons);

var _fullscreenSlider = __webpack_require__(218);

var _fullscreenSlider2 = _interopRequireDefault(_fullscreenSlider);

var _fullscreenSocialDownload = __webpack_require__(102);

var _fullscreenSocialDownload2 = _interopRequireDefault(_fullscreenSocialDownload);

var _fullscreenDesktopNavbar = __webpack_require__(224);

var _fullscreenDesktopNavbar2 = _interopRequireDefault(_fullscreenDesktopNavbar);

var _fullscreenMobileBar = __webpack_require__(227);

var _fullscreenMobileBar2 = _interopRequireDefault(_fullscreenMobileBar);

var _fullscreenSidebar = __webpack_require__(228);

var _fullscreenSidebar2 = _interopRequireDefault(_fullscreenSidebar);

var _fullscreenStoreBottomMobileBar = __webpack_require__(230);

var _fullscreenStoreBottomMobileBar2 = _interopRequireDefault(_fullscreenStoreBottomMobileBar);

var _fullscreenShareScreen = __webpack_require__(236);

var _fullscreenShareScreen2 = _interopRequireDefault(_fullscreenShareScreen);

var _utils = __webpack_require__(2);

var _proGalleryVersionManager = __webpack_require__(94);

var _cartApi = __webpack_require__(26);

var _cartApi2 = _interopRequireDefault(_cartApi);

var _consts = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //import template from './Gallery.rt';


_utils.utils.fixViewport('Fullscreen');

var FullscreenView = function (_React$Component) {
  _inherits(FullscreenView, _React$Component);

  function FullscreenView(props) {
    _classCallCheck(this, FullscreenView);

    var _this = _possibleConstructorReturn(this, (FullscreenView.__proto__ || Object.getPrototypeOf(FullscreenView)).call(this, props));

    _this.fullScreenCssCreated = false;
    _this.preloadeditems = [];

    _this.toggleMobileBars = _this.toggleMobileBars.bind(_this);
    _this.fadeToNextSlide = _this.fadeToNextSlide.bind(_this);
    _this.navigateToPageByItemLink = _this.navigateToPageByItemLink.bind(_this);
    _this.refreshCartItems = _this.refreshCartItems.bind(_this);

    _this.state = {
      animating: false,
      pricingData: null,
      providerView: null,
      cartItems: []
    };

    if (_utils.utils.isStoreGallery()) {
      _this.initializeCartItems();
    }
    return _this;
  }

  _createClass(FullscreenView, [{
    key: 'initializeCartItems',
    value: function initializeCartItems() {
      var _this2 = this;

      Wix.PubSub.subscribe(_consts.storePubSub.refreshCart, function () {
        _this2.refreshCartItems();
      }, true);

      this.refreshCartItems();
    }
  }, {
    key: 'refreshCartItems',
    value: function refreshCartItems() {
      var _this3 = this;

      var galleryInfo = this.props.galleryInfo;
      if (galleryInfo && galleryInfo.connectedProviders) {
        var connectedProviderId = Object.keys(galleryInfo.connectedProviders)[0];
        _cartApi2.default.getCartItems(connectedProviderId).then(function (items) {
          _this3.setState({ cartItems: items });
        });
      }
    }

    //----------------------------------------------| Utils |----------------------------------------------//

  }, {
    key: 'getItem',
    value: function getItem(idx) {
      return this.props.items[idx] || {};
    }
  }, {
    key: 'stopPropagation',
    value: function stopPropagation(event) {
      event.stopPropagation();
    }

    //--------------------------------------------| UI Actions |-------------------------------------------//

  }, {
    key: 'fadeToNextSlide',
    value: function fadeToNextSlide(direction) {
      var _this4 = this;

      if (direction != 0 && !this.state.animating) {
        _utils.utils.setStateAndLog(this, 'fadeToNextSlide animation start', {
          animating: true,
          direction: direction
        }, function () {
          setTimeout(function () {
            _this4.props.actions.next(direction); //triggers react after the animation is complete
            _this4.fixTransformForIos();
            _utils.utils.setStateAndLog(_this4, 'fadeToNextSlide animation complete', {
              animating: false,
              direction: 0
            }, _this4.fixTransformForIos);
          }, 400);
        });
      }
    }
  }, {
    key: 'navigateToPageByItemLink',
    value: function navigateToPageByItemLink(item) {
      if (item.linkType === 'wix') {
        Wix.navigateTo(item.linkData);
      } else {
        Wix.navigateToPage(item.linkUrl, { noTransition: true });
      }
    }
  }, {
    key: 'toggleMobileBars',
    value: function toggleMobileBars(forceValueOrEvent) {
      if (_proGalleryVersionManager.versionManager.useFullscreenNewMobileLayout()) {
        return;
      }

      if (forceValueOrEvent === false) {
        $('.fullscreen-mobile-bar').addClass('hidden');
      } else if (forceValueOrEvent === true) {
        $('.fullscreen-mobile-bar').removeClass('hidden');
      } else {
        var elem = $(forceValueOrEvent.target);
        if (!(elem.children('video').length || elem.is('video') || elem.is('i') || elem.is('a') || elem.is('button'))) {
          // do not toggle bars if clicking a video
          $('.fullscreen-mobile-bar').toggleClass('hidden');
        }
      }
    }

    //-----------------------------------------| DOM Manipulation |----------------------------------------//

  }, {
    key: 'fixLinkLineHeight',
    value: function fixLinkLineHeight() {

      var curItem = this.props.current.item;
      if (curItem.linkUrl && curItem.linkText) {

        //patch to limit link lines to 2

        var elem = $(_reactDom2.default.findDOMNode(this));
        if (!elem) return;

        var link = elem.find('.fullscreen-side-bar-exif.link');
        if (link.length != 1) {
          return;
        }
        var lineHeight = parseInt(link.css('line-height'));
        var numOfLines = 2;
        link.height(numOfLines * lineHeight);
        link.css({ '-webkit-line-clamp': numOfLines + '' });
      }
    }
  }, {
    key: 'fixTransformForIos',
    value: function fixTransformForIos() {
      if (_utils.utils.isiOS()) {
        $('.swipe-wrap .slide').css('will-change', 'transform');
      }
    }
  }, {
    key: 'fixSwiperContainerSizeIfNeeded',
    value: function fixSwiperContainerSizeIfNeeded(containerSize, prevContainerSize) {
      if (this.swipper && (containerSize.width !== prevContainerSize.width || containerSize.height !== prevContainerSize.height)) {
        this.swipper.setContainerSize(containerSize);
      }
    }

    //------------------------------------------| React methods |------------------------------------------//

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!_utils.utils.isStoreGallery() && _utils.utils.isTouch()) {
        this.swipper = new _swipper2.default(this.props.actions.next, this.props.window.size);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      this.fixLinkLineHeight();
      this.fixTransformForIos();
      this.fixSwiperContainerSizeIfNeeded(this.props.window.size, prevProps.window.size);
    }
  }, {
    key: 'handlePricingDataChganed',
    value: function handlePricingDataChganed(pricingData) {
      this.setState({ pricingData: pricingData });
    }
  }, {
    key: 'handleSetMobileData',
    value: function handleSetMobileData(type, data) {
      this.setState({ providerView: { type: type, data: data } });
    }
  }, {
    key: 'handleProviderAction',
    value: function handleProviderAction(type, data) {
      this.sidebar.postShopRequest(type, data);
    }
  }, {
    key: 'handleAddToCartRequest',
    value: function handleAddToCartRequest() {
      var sidebar = this.sidebar;
      if (sidebar && typeof sidebar.addToCartRequest === 'function') {
        this.sidebar.addToCartRequest();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var isStoreGallery = _utils.utils.isStoreGallery();
      var isMobile = _utils.utils.isMobile();

      if (this.props.isNewEditor == false) {
        return _react2.default.createElement(_oldEditorNotice2.default, null);
      }

      var curItem = this.props.current.item;

      var topMobileBar = _react2.default.createElement(_fullscreenMobileBar2.default, {
        current: this.props.current,
        styleParams: this.props.styleParams,
        actions: this.props.actions,
        showInfo: this.props.showInfo,
        love: this.props.love,
        isFirst: true,
        showShareScreen: this.props.showShareScreen
      });

      var bottomMobileBar = _proGalleryVersionManager.versionManager.useFullscreenNewMobileLayout() ? false : _react2.default.createElement(_fullscreenMobileBar2.default, {
        current: this.props.current,
        styleParams: this.props.styleParams,
        actions: this.props.actions,
        showInfo: this.props.showInfo,
        love: this.props.love,
        isFirst: false
      });

      var sidebar = _react2.default.createElement(_fullscreenSidebar2.default, {
        ref: function ref(element) {
          return _this5.sidebar = element;
        },
        current: this.props.current,
        isSettings: this.props.isSettings,
        styleParams: this.props.styleParams,
        showInfo: this.props.showInfo,
        showShopFrame: this.props.showShopFrame,
        showMobileShopFrame: this.props.showMobileShopFrame,
        galleryId: this.props.galleryInfo && this.props.galleryInfo.galleryId ? this.props.galleryInfo.galleryId : '',
        actions: _.merge(this.props.actions, {
          navigateToPageByItemLink: this.navigateToPageByItemLink
        }),
        onSetMobileData: function onSetMobileData(type, data) {
          return _this5.handleSetMobileData(type, data);
        },
        providerView: this.state.providerView,
        onAddToCartRequest: function onAddToCartRequest() {
          return _this5.handleAddToCartRequest();
        },
        connectedProviders: this.props.galleryInfo.connectedProviders,
        cartItems: this.state.cartItems
      });

      var smallScreenArrows = !_proGalleryVersionManager.versionManager.useFullscreenNewMobileLayout() && !this.props.showInfo && _utils.utils.isSmallScreen() && !_utils.utils.isTouch() && !this.props.showMobileShopFrame ? [_react2.default.createElement('i', {
        className: "fullscreen-prev small-screen progallery-svg-font-icons-arrow_left " + (this.props.current.idx <= 0 ? ' fullscreen-icon-disabled ' : ''),
        onClick: function onClick() {
          return _this5.fadeToNextSlide(-1);
        },
        key: 'small-screen-arrow-back'
      }), _react2.default.createElement('i', {
        className: "fullscreen-next small-screen progallery-svg-font-icons-arrow_right " + (this.props.current.idx >= this.props.totalItems - 1 ? ' fullscreen-icon-disabled ' : ''),
        onClick: function onClick() {
          return _this5.fadeToNextSlide(1);
        },
        key: 'small-screen-arrow-next'
      })] : '';

      var bottomLinkContainer = this.props.current.item.hasLink && this.props.styleParams.allowLinkExpand ? _react2.default.createElement(_bottomLink2.default, {
        current: this.props.current,
        actions: _.merge(this.props.actions, {
          navigateToPageByItemLink: this.navigateToPageByItemLink
        })
      }) : null;

      var slider = _react2.default.createElement(_fullscreenSlider2.default, {
        items: this.props.items,
        current: this.props.current,
        window: this.props.window,
        styleParams: this.props.styleParams,
        animating: this.state.animating,
        direction: this.state.direction,
        totalItems: this.props.totalItems,
        isSettings: this.props.isSettings,
        love: this.props.love,
        actions: {
          toggleMobileBars: this.toggleMobileBars,
          fadeToNextSlide: this.fadeToNextSlide
        }
      });

      var desktopNavbar = _react2.default.createElement(_fullscreenDesktopNavbar2.default, {
        items: this.props.items,
        totalItems: this.props.totalItems,
        current: this.props.current,
        window: this.props.window,
        isSettings: this.props.isSettings,
        styleParams: this.props.styleParams,
        love: this.props.love,
        showInfo: this.props.showInfo,
        navigatedInto: this.props.navigatedInto,
        actions: _.merge(this.props.actions, {
          fadeToNextSlide: this.fadeToNextSlide
        })
      });

      if (_utils.utils.isVerbose()) {
        //todo yoshi
        console.timeEnd('Time in React');
        console.log("Render FullscreenView", this.props, this.state);
      }
      var storeBottomMobileBar = _utils.utils.isMobile() && _utils.utils.isStoreGallery() ? _react2.default.createElement(_fullscreenStoreBottomMobileBar2.default, {
        current: this.props.current,
        styleParams: this.props.styleParams,
        love: this.props.love,
        showInfo: this.props.showInfo,
        actions: _.merge(this.props.actions, {
          navigateToPageByItemLink: this.navigateToPageByItemLink
        }),
        showShopFrame: this.props.showShopFrame,
        showMobileShopFrame: this.props.showMobileShopFrame,
        showShareScreen: this.props.showShareScreen,
        galleryId: this.props.galleryInfo && this.props.galleryInfo.galleryId ? this.props.galleryInfo.galleryId : '',
        providerView: this.state.providerView,
        onAddToCartRequest: function onAddToCartRequest() {
          return _this5.handleAddToCartRequest();
        },
        onProviderAction: function onProviderAction(type, data) {
          return _this5.handleProviderAction(type, data);
        },
        cartItems: this.state.cartItems

      }) : null;

      var fullscreenShareScreen = _react2.default.createElement(_fullscreenShareScreen2.default, {
        current: this.props.current,
        styleParams: this.props.styleParams,
        showShareScreen: this.props.showShareScreen
      });

      var clickAction = _utils.utils.getMobileEnabledClick(this.toggleMobileBars);
      var version = _proGalleryVersionManager.versionManager.getVersionFullscreenVersion();
      var versionClassName = version.toLowerCase();
      var expandedClassName = this.props.window.expanded ? ' expanded ' : '';
      var themeClassName = _utils.utils.parseGetParam('theme') == 'dark' ? ' fullscreen-dark' : ' fullscreen-bright';
      var accessibilityClassName = _utils.utils.isAccessibilityEnabled() ? ' accessible ' : '';
      var fullscreenClasses = 'fullscreen inline-styles ' + versionClassName + ' ' + expandedClassName + ' ' + themeClassName + ' ' + accessibilityClassName;
      return isStoreGallery && isMobile ? _react2.default.createElement(
        'div',
        {
          'data-hook': 'fullscreen-view',
          id: 'fullscreen-view',
          className: fullscreenClasses },
        desktopNavbar,
        topMobileBar,
        _react2.default.createElement(
          'div',
          { className: 'fullscreen-store-scroller' },
          sidebar,
          bottomLinkContainer,
          _react2.default.createElement(
            'div',
            { style: { width: this.props.window.size.width, height: this.props.current.item.height, marginTop: 60 } },
            slider
          ),
          fullscreenShareScreen,
          storeBottomMobileBar
        )
      ) : _react2.default.createElement(
        'div',
        _extends({}, clickAction, {
          'data-hook': 'fullscreen-view',
          id: 'fullscreen-view',
          className: fullscreenClasses }),
        desktopNavbar,
        topMobileBar,
        sidebar,
        bottomLinkContainer,
        slider,
        smallScreenArrows,
        bottomMobileBar,
        _proGalleryVersionManager.versionManager.useFullscreenNewMobileLayout() ? fullscreenShareScreen : false,
        storeBottomMobileBar
      );
    }
  }]);

  return FullscreenView;
}(_react2.default.Component);

exports.default = (0, _commonItemContainer.CommonItemContainer)(FullscreenView);

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(4);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Swipper = function () {
  function Swipper(callback, containerSize) {
    _classCallCheck(this, Swipper);

    this.onTouchStart = this.onTouchStart.bind(this);
    this.onTouchMove = this.onTouchMove.bind(this);
    this.onTouchEnd = this.onTouchEnd.bind(this);
    this.onTransitionEnd = this.onTransitionEnd.bind(this);

    this.setContainerSize(containerSize);
    this.initElements();
    this.initEvents();
    this.initDefaults();

    this.swipeCallback = _lodash2.default.isFunction(callback) ? callback : _lodash2.default.noop;
  }

  _createClass(Swipper, [{
    key: 'initElements',
    value: function initElements() {
      this.wrap = $('.swipe-wrap');
      this.container = $('#slider');
      this.slides = $('.slide');
      this.current = $('.swipe-current');
      this.currentItem = $('.current-slide .fullscreen-item').last();
      this.nextItem = $('.next-slide .fullscreen-item');
      this.prevItem = $('.prev-slide .fullscreen-item');

      this.isLastSlide = this.nextItem.length == 0;
      this.isFirstSlide = this.prevItem.length == 0;

      this.direction = 0;
    }
  }, {
    key: 'initEvents',
    value: function initEvents() {
      this.wrap[0] && this.wrap[0].addEventListener('touchstart', this.onTouchStart, false);
    }
  }, {
    key: 'initDefaults',
    value: function initDefaults() {

      this.scale = 1;

      this.pos = {
        x: 0,
        y: 0
      };

      this.pinchStart = {
        dist: 0,
        x: 0,
        y: 0
      };

      this.hiResShown = true;
      this.nonCurrentShown = true;
    }
  }, {
    key: 'turnTransitionOff',
    value: function turnTransitionOff() {
      if (this.transitionOn) {
        this.wrap.addClass('touching');
        this.transitionOn = false;
      }
    }
  }, {
    key: 'turnTransitionOn',
    value: function turnTransitionOn() {
      if (!this.transitionOn) {
        this.wrap.removeClass('touching');
        this.transitionOn = true;
      }
    }
  }, {
    key: 'hideHiResImages',
    value: function hideHiResImages() {
      if (this.hiResShown) {
        this.wrap.addClass('moving');
        this.hiResShown = false;
      }
    }
  }, {
    key: 'showHiResImages',
    value: function showHiResImages() {
      if (!this.hiResShown) {
        this.wrap.removeClass('moving');
        this.hiResShown = true;
      }
    }
  }, {
    key: 'hideNonCurrentImages',
    value: function hideNonCurrentImages() {
      if (this.nonCurrentShown) {
        this.wrap.addClass('pinching');
        this.nonCurrentShown = false;
      }
    }
  }, {
    key: 'showNonCurrentImages',
    value: function showNonCurrentImages() {
      if (!this.nonCurrentShown) {
        this.wrap.removeClass('pinching');
        this.nonCurrentShown = true;
      }
    }
  }, {
    key: 'onTouchStart',
    value: function onTouchStart(event) {
      this.startTouch = $.extend(true, {}, event); //the event object can change on some devices
      var touches = event.touches;

      this.turnTransitionOff();
      this.initElements();

      this.direction = 0;

      if (touches.length == 2) {
        this.handleStartPinching(event.touches);
      } else {
        var touch = event.touches[0];
        if (this.scale > 1) {
          this.handleStartDragging(touch);
        } else {
          this.handleStartSwiping(touch);
        }
      }

      this.wrap[0] && this.wrap[0].addEventListener('touchmove', this.onTouchMove, false);
      this.wrap[0] && this.wrap[0].addEventListener('touchend', this.onTouchEnd, false);
    }
  }, {
    key: 'isDoubleTap',
    value: function isDoubleTap(tapTime, lastTapTime) {
      return tapTime - lastTapTime < 300;
    }
  }, {
    key: 'handleStartSwiping',
    value: function handleStartSwiping(touch) {
      this.hideHiResImages();
      this.showNonCurrentImages();

      //on movement start - the slider is at 0
      this.pos = {
        x: 0,
        y: 0
      };

      // get initial touch coords
      this.touchStart = {
        x: touch.screenX,
        y: touch.screenY
      };
    }
  }, {
    key: 'calcBounds',
    value: function calcBounds() {
      //moving scaled image - set boundaries

      var rect = this.currentItem[0].getBoundingClientRect();

      var cur_w = rect.width;
      var cur_h = rect.height;

      var max_x = Math.abs(cur_w - this.containerSize.width) / 2;
      var max_y = Math.abs(cur_h - this.containerSize.height) / 2;

      this.bounds = {
        max_x: max_x,
        max_y: max_y,
        min_x: -1 * max_x,
        min_y: -1 * max_y
      };

      console.log("calculated bounds", this.bounds);
    }
  }, {
    key: 'handleStartDragging',
    value: function handleStartDragging(touch) {
      this.showHiResImages();
      this.hideNonCurrentImages();

      this.calcBounds();

      this.pinchStart = {
        dist: 0,
        x: touch.screenX,
        y: touch.screenY
      };

      // get initial touch coords
      this.touchStart = {
        x: touch.screenX - this.pos.x,
        y: touch.screenY - this.pos.y
      };
    }
  }, {
    key: 'handleStartPinching',
    value: function handleStartPinching(touches) {
      this.showHiResImages();
      this.hideNonCurrentImages();

      this.calcBounds();

      var rect = this.currentItem[0].getBoundingClientRect();

      var touch1clientX = touches[0].clientX;
      var touch1clientY = touches[0].clientY;
      var touch2clientX = touches[1].clientX;
      var touch2clientY = touches[1].clientY;

      var touchesX = (touch1clientX + touch2clientX) / 2;
      var touchesY = (touch1clientY + touch2clientY) / 2;

      var imageOffsetX = rect.left;
      var imageOffsetY = rect.top;
      var imageWidth = rect.width;
      var imageHeight = rect.height;

      //relative touch position in the image
      var touchX = ((touchesX - imageOffsetX) / imageWidth - 0.5) * imageWidth / this.scale;
      var touchY = ((touchesY - imageOffsetY) / imageHeight - 0.5) * imageHeight / this.scale;

      this.pinchStart = {
        dist: Math.sqrt(Math.pow(touches[0].screenX - touches[1].screenX, 2) + Math.pow(touches[0].screenY - touches[1].screenY, 2)) / this.scale,
        x: (touches[0].screenX + touches[1].screenX) / 2 - (this.pos.x || 0),
        y: (touches[0].screenY + touches[1].screenY) / 2 - (this.pos.y || 0),
        touchX: touchX,
        touchY: touchY,
        touchScale: this.scale
      };
    }
  }, {
    key: 'onTouchMove',
    value: function onTouchMove(event) {

      event.preventDefault(); //DISABLE SCROLL

      var touches = event.touches;

      if (touches.length == 2) {
        this.handlePinching(touches);
      } else if (touches.length == 1) {
        if (this.scale > 1) {
          this.handleDragging(touches);
        } else {
          var touch = touches[0];
          this.handleSwipeDragging(touch);
        }
      }
      this.move();
    }
  }, {
    key: 'handleSwipeDragging',
    value: function handleSwipeDragging(touch) {
      // console.log('Got touch events', touches.screenX, touches.screenY);
      var delta = {
        x: touch.screenX - this.touchStart.x,
        y: touch.screenY - this.touchStart.y
      };

      // console.log('Measured Delta', delta);

      // increase resistance if first or last slide
      if (this.isDraggingOutOfBounds(delta.x)) {
        delta.x /= Math.abs(delta.x) / this.containerSize.width + 1; // determine resistance level
      }

      //set the new slides position
      this.pos = {
        x: delta.x,
        y: this.pos.y //on regular swipe - do not change y position
      };
    }
  }, {
    key: 'isDraggingOutOfBounds',
    value: function isDraggingOutOfBounds(dirction) {
      return this.isLastSlide && dirction < 0 || // if last slide and sliding right
      this.isFirstSlide && dirction > 0; // if first slide and sliding left;
    }
  }, {
    key: 'handleDragging',
    value: function handleDragging(touches) {
      var deltaPinch = {
        x: touches[0].screenX - this.touchStart.x,
        y: touches[0].screenY - this.touchStart.y
      };

      var x = deltaPinch.x;
      if (this.bounds.min_x > x && this.bounds.min_x - x < 100) {
        //do not limit the drag - but snap within 150px
        x = this.bounds.min_x;
      }
      if (this.bounds.max_x < x && x - this.bounds.max_x < 100) {
        x = this.bounds.max_x;
      }

      var y = deltaPinch.y;
      if (this.bounds.min_y > y && this.bounds.min_y - y < 100) {
        //(500 > 10
        y = this.bounds.min_y;
      }
      if (this.bounds.max_y < y && y - this.bounds.max_y < 100) {
        y = this.bounds.max_y;
      }

      this.pos = { x: x, y: y };

      // this.pos = {
      //   x: Math.min(Math.max(this.bounds.min_x, deltaPinch.x), this.bounds.max_x),
      //   y: Math.min(Math.max(this.bounds.min_y, deltaPinch.y), this.bounds.max_y)
      // };
    }
  }, {
    key: 'handlePinching',
    value: function handlePinching(touches) {
      var deltaPinch = {
        scale: Math.sqrt(Math.pow(touches[0].screenX - touches[1].screenX, 2) + Math.pow(touches[0].screenY - touches[1].screenY, 2)) / this.pinchStart.dist,
        x: (touches[0].screenX + touches[1].screenX) / 2 - this.pinchStart.x,
        y: (touches[0].screenY + touches[1].screenY) / 2 - this.pinchStart.y
      };

      var newScale = Math.max(1, deltaPinch.scale);

      var pinchPositionFix = {
        x: (newScale - this.pinchStart.touchScale) * this.pinchStart.touchX,
        y: (newScale - this.pinchStart.touchScale) * this.pinchStart.touchY
      };

      this.pos = {
        x: deltaPinch.x - pinchPositionFix.x,
        y: deltaPinch.y - pinchPositionFix.y
      };

      this.scale = newScale;
    }
  }, {
    key: 'isTap',
    value: function isTap(startTouchEvent, endTouchEvent) {
      if (startTouchEvent.touches.length === 1 && endTouchEvent.touches.length === 0 && endTouchEvent.timeStamp - startTouchEvent.timeStamp < 250) {
        var startTouch = startTouchEvent.touches[0];
        var endTouch = endTouchEvent.changedTouches[0];
        var distanceX = Math.abs(startTouch.screenX - endTouch.screenX);
        var distanceY = Math.abs(startTouch.screenY - endTouch.screenY);
        return distanceX < 10 && distanceY < 10;
      }
      return false;
    }
  }, {
    key: 'onTouchEnd',
    value: function onTouchEnd(event) {

      this.turnTransitionOn();
      var endTouchTime = event.timeStamp;
      if (this.isTap(this.startTouch, event)) {
        if (this.isDoubleTap(endTouchTime, this.lastTapTime)) {
          this.handleDoubleTap();
        }
        this.lastTapTime = endTouchTime;
      }
      if (this.scale > 1) {
        this.hideNonCurrentImages();
        if (this.scale > 2) {

          //bounce back to max scale of x2

          //this.scale = 2; - removed because the just between scale > 2 to scale = 2 was annoying
        }
      } else {

        //regular release - animate slides
        var currentX = this.pos.x;
        var distance = Math.abs(currentX);
        var duration = endTouchTime - this.startTouch.timeStamp;

        if (this.isSwipe(distance, duration) && !this.isDraggingOutOfBounds(currentX)) {
          // determine direction of swipe
          this.direction = Math.sign(currentX);
          //set the new position of the slider
          this.pos.x = this.direction * this.containerSize.width;
        } else {
          this.pos.x = 0;
          this.direction = 0;
        }
        this.pos.y = 0;

        if (currentX - this.pos.x == 0) {
          //if there is not transition going to happen, trigger transitionEnd event manually
          this.onTransitionEnd();
        } else {
          //otherwise - register to event end
          var element = this.wrap[0];
          if (element) {
            element.addEventListener('webkitTransitionEnd', this.onTransitionEnd, false);
            element.addEventListener('msTransitionEnd', this.onTransitionEnd, false);
            element.addEventListener('oTransitionEnd', this.onTransitionEnd, false);
            element.addEventListener('otransitionend', this.onTransitionEnd, false);
            element.addEventListener('transitionend', this.onTransitionEnd, false);
          }
        }
      }
      this.showHiResImages();
      this.move();

      this.wrap[0] && this.wrap[0].removeEventListener('touchmove', this.onTouchMove, false);
      this.wrap[0] && this.wrap[0].removeEventListener('touchend', this.onTouchEnd, false);
    }
  }, {
    key: 'isSwipe',
    value: function isSwipe(distance, duration) {
      var velocity = distance / duration;
      // determine if slide attempt triggers next/prev slide
      return distance > 10 && velocity > 0.5 || // quick swipe
      distance > this.containerSize.width / 2; // large distance
    }
  }, {
    key: 'onTransitionEnd',
    value: function onTransitionEnd() {
      this.pos = { x: 0, y: 0 };
      this.showHiResImages();
      this.showNonCurrentImages();
      this.swipeCallback(-1 * this.direction);

      var element = this.wrap[0];
      if (element) {
        element.removeEventListener('webkitTransitionEnd', this.onTransitionEnd, false);
        element.removeEventListener('msTransitionEnd', this.onTransitionEnd, false);
        element.removeEventListener('oTransitionEnd', this.onTransitionEnd, false);
        element.removeEventListener('otransitionend', this.onTransitionEnd, false);
        element.removeEventListener('transitionend', this.onTransitionEnd, false);
      }
    }
  }, {
    key: 'handleDoubleTap',
    value: function handleDoubleTap() {
      if (this.scale > 1) {
        this.scale = 1;
        this.showNonCurrentImages();
      } else {
        this.scale = 2;
        this.hideNonCurrentImages();
      }

      this.pos = {
        x: 0,
        y: 0
      };

      this.turnTransitionOn();
      this.showHiResImages();
      this.move();
    }
  }, {
    key: 'move',
    value: function move() {
      var val = 'translate3d(' + this.pos.x + 'px ,' + this.pos.y + 'px ,0) scale(' + this.scale + ')';

      this.wrap.css({
        'transform': val,
        '-o-transform': val,
        '-ms-transform': val,
        '-webkit-transform': val
      }).removeClass('before-swipe');
    }
  }, {
    key: 'setContainerSize',
    value: function setContainerSize(_ref) {
      var width = _ref.width,
          height = _ref.height;

      this.containerSize = { width: width, height: height };
    }
  }]);

  return Swipper;
}();

exports.default = Swipper;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BottomLink = function (_React$Component) {
  _inherits(BottomLink, _React$Component);

  function BottomLink(props) {
    _classCallCheck(this, BottomLink);

    return _possibleConstructorReturn(this, (BottomLink.__proto__ || Object.getPrototypeOf(BottomLink)).call(this, props));
  }

  _createClass(BottomLink, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var curItem = this.props.current.item;

      var bottomLink = curItem.hasLink && !_utils.utils.isMobile() ? curItem.linkType === 'web' ? _react2.default.createElement(
        'a',
        { className: "fullscreen-bottom-link link",
          href: curItem.linkUrl,
          target: curItem.linkOpenType,
          tabIndex: _utils.utils.getTabIndex('fullscreenLink'),
          'aria-label': curItem.linkText
        },
        curItem.linkText ? curItem.linkText : curItem.linkUrl
      ) : _react2.default.createElement(
        'a',
        {
          className: "fullscreen-bottom-link link",
          onClick: function onClick() {
            return _this2.props.actions.navigateToPageByItemLink(curItem);
          },
          tabIndex: _utils.utils.getTabIndex('fullscreenLink'),
          'aria-label': curItem.linkText
        },
        curItem.linkText ? curItem.linkText : curItem.linkUrl
      ) : false;

      var bottomLinkContainer = !this.props.current.hasInfo && curItem.hasLink && !_utils.utils.isStoreGallery() ? _react2.default.createElement(
        'div',
        { className: "bottom-link" },
        bottomLink
      ) : false;

      return bottomLinkContainer;
    }
  }]);

  return BottomLink;
}(_react2.default.Component);

exports.default = BottomLink;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OldEditorNotice = function (_React$Component) {
  _inherits(OldEditorNotice, _React$Component);

  function OldEditorNotice(props) {
    _classCallCheck(this, OldEditorNotice);

    return _possibleConstructorReturn(this, (OldEditorNotice.__proto__ || Object.getPrototypeOf(OldEditorNotice)).call(this, props));
  }

  _createClass(OldEditorNotice, [{
    key: 'render',
    value: function render() {

      console.log('Not rendering - old editor');
      return _react2.default.createElement(
        'div',
        { className: 'old-editor' },
        _react2.default.createElement(
          'div',
          { className: 'old-editor-wrapper' },
          'Wix Pro Gallery is not available for the old Editor.',
          _react2.default.createElement('br', null),
          'Click ',
          _react2.default.createElement(
            'a',
            { href: 'https://support.wix.com/article/switching-to-the-new-wix-editor',
              target: '_blank' },
            'here'
          ),
          'to learn how to switch to the new Editor.'
        )
      );
    }
  }]);

  return OldEditorNotice;
}(_react2.default.Component);

exports.default = OldEditorNotice;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VersionManager = function () {
  function VersionManager() {
    var features = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var dateCreated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -8640000000000000;

    _classCallCheck(this, VersionManager);

    this.features = features;
    this.dateCreated = dateCreated;
  }

  _createClass(VersionManager, [{
    key: "getVersion",
    value: function getVersion(featureName) {
      var featureVersions = this.features[featureName];
      if (!featureVersions) {
        return VersionManager.Versions.min;
      }
      for (var i = featureVersions.length - 1; i >= 0; i--) {
        if (this.dateCreated >= featureVersions[i].dateFrom) {
          return featureVersions[i].version;
        }
      }
    }
  }]);

  return VersionManager;
}();

VersionManager.Versions = {
  min: "min"
};

module.exports = VersionManager;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _fullscreenVideo = __webpack_require__(219);

var _fullscreenVideo2 = _interopRequireDefault(_fullscreenVideo);

var _fullscreenImage = __webpack_require__(220);

var _fullscreenImage2 = _interopRequireDefault(_fullscreenImage);

var _fullscreenText = __webpack_require__(222);

var _fullscreenText2 = _interopRequireDefault(_fullscreenText);

var _fullscreenStoreSliderBottomBar = __webpack_require__(223);

var _fullscreenStoreSliderBottomBar2 = _interopRequireDefault(_fullscreenStoreSliderBottomBar);

var _utils = __webpack_require__(2);

var _proGalleryVersionManager = __webpack_require__(94);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FullscreenSlider = function (_React$Component) {
  _inherits(FullscreenSlider, _React$Component);

  function FullscreenSlider(props) {
    _classCallCheck(this, FullscreenSlider);

    var _this = _possibleConstructorReturn(this, (FullscreenSlider.__proto__ || Object.getPrototypeOf(FullscreenSlider)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(FullscreenSlider, [{
    key: 'isInDisplayRange',
    value: function isInDisplayRange(idx) {
      var range = _utils.utils.isTouch() ? 1 : 3;
      return Math.abs(this.props.current.idx - idx) <= range;
    }
  }, {
    key: 'prepareSlide',
    value: function prepareSlide(item) {

      var idx = item.idx;
      var inner;
      switch (item.type) {
        case 'video':
          inner = _react2.default.createElement(_fullscreenVideo2.default, {
            key: idx,
            item: item,
            isDisplayed: this.props.current.idx === idx,
            isDummy: !this.isInDisplayRange(idx),
            window: this.props.window,
            styleParams: this.props.styleParams,
            actions: {
              toggleMobileBars: this.props.actions.toggleMobileBars
            }

          });
          break;
        case 'text':
          inner = _react2.default.createElement(_fullscreenText2.default, {
            key: idx,
            item: item,
            isDummy: !this.isInDisplayRange(idx),
            window: this.props.window
          });
          break;
        case 'image':
        case 'picture':
        default:
          inner = _react2.default.createElement(_fullscreenImage2.default, {
            key: idx,
            item: item,
            isDummy: !this.isInDisplayRange(idx),
            window: this.props.window
          });
      }
      return inner;
    }
  }, {
    key: 'prepareSlides',
    value: function prepareSlides() {
      var slides = [];

      for (var i = 0; i < this.props.items.length; i++) {

        var animationType = _utils.utils.isTouch() ? 'swipe-' : 'fade-';

        var innerStyle = {
          width: this.props.window.size.width + 'px'
        };
        var transform = _utils.utils.browserIs('safari') ? 'none' : 'translate3d(0, 0, 0) scale(1)';

        if (_utils.utils.browserIs('safari') && !_utils.utils.isMobile()) {
          $.extend(innerStyle, {
            opacity: 1,
            transform: transform,
            'WebkitTransform': transform,
            'MozTransform': transform,
            'msTransform': transform,
            'OTransform': transform
          });
        } else {
          $.extend(innerStyle, {
            opacity: 1,
            willChange: 'transform'
          });
        }

        var itm = this.props.items[i];
        var slidePos = i;
        var isCurrent = false;
        var slideClasses = ['slide'];

        switch (slidePos - this.props.current.pos) {
          case 0:
            slideClasses.push(animationType + 'current current-slide fullscreen-current');
            isCurrent = true;
            break;
          case 1:
            slideClasses.push(animationType + 'adjacent next-slide');
            break;
          case -1:
            slideClasses.push(animationType + 'adjacent prev-slide');
            break;
          default:
            slideClasses.push(animationType + 'far-away');
        }

        if (this.props.animating) {

          slideClasses.push(animationType + 'animated');

          switch (slidePos - this.props.current.pos) {
            case 0:
              slideClasses.push(animationType + 'animated-current');
              break;
            case 1:
              if (this.props.direction == 1) {
                slideClasses.push(animationType + 'animated-next');
              }
              break;
            case -1:
              if (this.props.direction == -1) {
                slideClasses.push(animationType + 'animated-prev');
              }
              break;
          }
          ;
        }
        // console.log("Pushing item Pushing item #" + itm.idx, itm);

        slides.push(itm && itm.idx >= 0 ? _react2.default.createElement(
          'div',
          { key: "swipe-item-" + itm.idx, 'data-index': itm.idx,
            className: slideClasses.join(' '),
            style: innerStyle,
            'data-hook': isCurrent ? "fullscreen-current" : "fullscreen-away"
          },
          this.prepareSlide(itm)
        ) : _react2.default.createElement('div', { key: "swipe-item-placeholder-" + slidePos,
          className: slideClasses.join(' '),
          style: innerStyle
        }));
      }

      return slides;
    }
  }, {
    key: 'getLeftArrowSvg',
    value: function getLeftArrowSvg() {
      return _react2.default.createElement(
        'svg',
        { xmlns: 'http://www.w3.org/2000/svg', fill: 'currentColor', stroke: 'none', width: '15', height: '27', viewBox: '0 0 15 27' },
        _react2.default.createElement(
          'g',
          { fillRule: 'evenodd' },
          _react2.default.createElement('path', { fillRule: 'nonzero', d: 'M14.258 1.53L13.198.47-.061 13.728l13.259 13.258 1.06-1.06L2.061 13.728z' })
        )
      );
    }
  }, {
    key: 'getRightArrowSvg',
    value: function getRightArrowSvg() {
      return _react2.default.createElement(
        'svg',
        { fill: 'currentColor', stroke: 'none', width: '15', height: '27', viewBox: '0 0 15 27' },
        _react2.default.createElement(
          'g',
          { fillRule: 'evenodd' },
          _react2.default.createElement('path', { fillRule: 'nonzero', d: 'M.198 25.926l1.06 1.06 13.259-13.258L1.258.47.198 1.53l12.197 12.198z' })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var firstSlidePosition = this.props.current.pos * this.props.window.size.width;
      var shouldShowStoreArrows = _proGalleryVersionManager.versionManager.useFullscreenNewSlider() && !_utils.utils.isSmallScreen();

      var leftArrowLeftPos = firstSlidePosition + (this.props.window.expanded && _proGalleryVersionManager.versionManager.useFullscreenNewSlider() ? 10 : 0);
      var rightArrowLeftPos = firstSlidePosition + (this.props.window.size.width - (this.props.window.expanded && _proGalleryVersionManager.versionManager.useFullscreenNewSlider() ? 110 : 100));
      var transform = 'translate3d(0, 0, 0) scale(1)';
      return _react2.default.createElement(
        'div',
        { id: 'slider', className: 'swipe' },
        _react2.default.createElement(
          'div',
          { className: 'swipe-wrap before-swipe swipe-wrap-idx-' + this.props.current.idx,
            key: 'swipe-wrap',
            style: {
              width: (this.props.current.pos * 2 + 1) * this.props.window.size.width,
              marginLeft: -1 * firstSlidePosition,
              willChange: 'transform'
            }
          },
          shouldShowStoreArrows ? _react2.default.createElement(
            'button',
            { className: "arrow arrow-left fullscreen-icon " + (this.props.current.idx <= 0 ? ' fullscreen-icon-disabled ' : ''),
              onClick: function onClick() {
                return _this2.props.actions.fadeToNextSlide(-1);
              },
              tabIndex: this.props.current.idx <= 0 ? -1 : _utils.utils.getTabIndex('fullscreenPrev'),
              'aria-label': 'Previous Item',
              style: {
                left: leftArrowLeftPos
              } },
            this.getLeftArrowSvg()
          ) : '',
          ';',
          this.prepareSlides(),
          shouldShowStoreArrows ? _react2.default.createElement(
            'button',
            { className: "arrow arrow-right fullscreen-icon" + (this.props.current.idx >= this.props.totalItems - 1 ? ' fullscreen-icon-disabled ' : ''),
              onClick: function onClick() {
                return _this2.props.actions.fadeToNextSlide(1);
              },
              tabIndex: this.props.current.idx >= this.props.totalItems - 1 ? -1 : _utils.utils.getTabIndex('fullscreenNext'),
              'aria-label': 'Next Item',
              style: {
                left: rightArrowLeftPos
              } },
            this.getRightArrowSvg()
          ) : '',
          ';'
        )
      );
    }
  }]);

  return FullscreenSlider;
}(_react2.default.Component);

exports.default = FullscreenSlider;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactPlayerFork = __webpack_require__(156);

var _reactPlayerFork2 = _interopRequireDefault(_reactPlayerFork);

var _utils = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import ReactPlayer from '../../../../../react-player';


var FullscreenVideo = function (_React$Component) {
  _inherits(FullscreenVideo, _React$Component);

  function FullscreenVideo(props) {
    _classCallCheck(this, FullscreenVideo);

    var _this = _possibleConstructorReturn(this, (FullscreenVideo.__proto__ || Object.getPrototypeOf(FullscreenVideo)).call(this, props));

    _this.handleArrowKeys = _this.handleArrowKeys.bind(_this);

    _this.state = {
      buffering: false,
      duration: 0,
      volume: 0.8,
      playing: true,
      played: 0,
      loaded: 0,
      mute: false
    };
    return _this;
  }

  _createClass(FullscreenVideo, [{
    key: 'clickOffset',
    value: function clickOffset(e) {
      var element = e.currentTarget;
      var clickOffsetInElement = e.pageX - $(element).offset().left;
      var elementWidth = element.getBoundingClientRect().width;
      return clickOffsetInElement / elementWidth;
    }
  }, {
    key: 'seekTo',
    value: function seekTo(e) {
      var played = this.clickOffset(e);
      this.video.seekTo(played);
      this.setState({ played: played });
    }
  }, {
    key: 'changeVideoLocation',
    value: function changeVideoLocation(diff) {
      var played = this.state.played + diff;
      this.video.seekTo(played);
      this.setState({ played: played });
    }
  }, {
    key: 'setVolume',
    value: function setVolume(e) {
      this.setState({ volume: this.clickOffset(e), mute: false });
    }
  }, {
    key: 'changeVolume',
    value: function changeVolume(diff) {
      this.setState({ volume: this.state.volume + diff, mute: false });
    }
  }, {
    key: 'togglePlay',
    value: function togglePlay() {
      if (this.isUnplayedExternalMobileVideo()) {
        this.setState({ playing: false, playedOnce: true });
      } else {
        this.state.playing ? this.pause() : this.play();
      }
    }
  }, {
    key: 'isUnplayedExternalMobileVideo',
    value: function isUnplayedExternalMobileVideo() {
      return this.isExternalMobileVideo() && !this.state.playedOnce;
    }
  }, {
    key: 'isPlayedExternalMobileVideo',
    value: function isPlayedExternalMobileVideo() {
      return this.isExternalMobileVideo() && this.state.playedOnce;
    }
  }, {
    key: 'isExternalMobileVideo',
    value: function isExternalMobileVideo() {
      return _utils.utils.isMobile() && !this.props.isDummy && this.props.item.metadata.isExternal;
    }
  }, {
    key: 'secondsToTimeString',
    value: function secondsToTimeString(seconds) {
      if (!(seconds >= 0)) {
        //could also be NaN
        seconds = 0;
      }
      var hourFixer = seconds >= 3600 ? 3 : 0;
      return new Date(seconds * 1000).toISOString().substr(14 + hourFixer, 5 + hourFixer);
    }
  }, {
    key: 'onProgress',
    value: function onProgress(_ref) {
      var loaded = _ref.loaded,
          played = _ref.played;

      this.setState({ loaded: loaded, played: played });
    }
  }, {
    key: 'play',
    value: function play() {
      this.setState({ playing: true, playedOnce: true });
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.setState({ playing: false });
    }
  }, {
    key: 'autoPlay',
    value: function autoPlay() {
      if (this.props.isDisplayed && !_utils.utils.isMobile()) {
        this.play();
      } else if (!this.props.isDummy) {
        this.pause();
      }
    }
  }, {
    key: 'handleArrowKeys',
    value: function handleArrowKeys(e) {

      if (!_utils.utils.isAccessibilityEnabled() || !this.props.isDisplayed) {
        //the keypress events are only effective when the video is displayed
        return true;
      }

      var activeControl = null;
      var activeControlClassName = document.activeElement.className || '';
      if (activeControlClassName.indexOf('fullscreen-video-controls-progress') >= 0) {
        activeControl = 'progressBar';
      } else if (activeControlClassName.indexOf('fullscreen-video-controls-volume-bar') >= 0) {
        activeControl = 'volumeBar';
      }

      switch (e.keyCode || e.charCode) {
        case 38:
          //up
          if (activeControl === 'volumeBar') {
            e.preventDefault();
            e.stopPropagation();
            this.changeVolume(0.1);
          }
          return false;
        case 40:
          //down
          if (activeControl === 'volumeBar') {
            e.preventDefault();
            e.stopPropagation();
            this.changeVolume(-0.1);
          }
          return false;
        case 37:
          //left
          if (activeControl === 'progressBar') {
            e.preventDefault();
            e.stopPropagation();
            this.changeVideoLocation(-0.1);
          }
          return false;
        case 39:
          //right
          if (activeControl === 'progressBar') {
            e.preventDefault();
            e.stopPropagation();
            this.changeVideoLocation(0.1);
          }
          return false;
      }

      return true;
    }
  }, {
    key: 'stopPropagation',
    value: function stopPropagation(event) {
      event.stopPropagation();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.video.stopBuffering) {
        this.video.stopBuffering();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      console.log('Video Did Mount');
      this.autoPlay();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.isDisplayed != this.props.isDisplayed) {
        console.log('Video Did Update');
        this.autoPlay();
      }
    }
  }, {
    key: 'onWrapperClick',
    value: function onWrapperClick() {
      if (_utils.utils.isMobile() && !this.props.isDummy && !this.state.playedOnce) {
        this.setState({ playedOnce: true });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          playing = _state.playing,
          volume = _state.volume,
          played = _state.played,
          buffering = _state.buffering,
          mute = _state.mute,
          duration = _state.duration;
      var _props = this.props,
          item = _props.item,
          isDummy = _props.isDummy,
          isDisplayed = _props.isDisplayed,
          window = _props.window;


      var transform = 'translate3d(-50%, -50%, 0) scale(' + window.scale.min(item) + ')';
      var innerStyle = {
        'width': item.width + 'px',
        'height': item.height + 'px',
        'transform': transform,
        'WebkitTransform': transform,
        'MozTransform': transform,
        'msTransform': transform,
        'OTransform': transform
      };

      var videoControls = _react2.default.createElement(
        'div',
        { className: "fullscreen-video-controls " + (_utils.utils.isMobile() ? 'mobile' : ''), style: innerStyle },
        _react2.default.createElement(
          'div',
          { onClick: this.togglePlay.bind(this), className: 'fullscreen-video-controls-wrapper' },
          _react2.default.createElement(
            'div',
            { className: 'fullscreen-video-controls-bar', onClick: this.stopPropagation },
            _react2.default.createElement('button', {
              className: "cursor-pointer fullscreen-video-controls-play " + (buffering ? 'fa fa-circle-o-notch fa-spin' : playing ? 'progallery-svg-font-icons-pause' : 'progallery-svg-font-icons-play'),
              onClick: this.togglePlay.bind(this),
              tabIndex: isDisplayed ? _utils.utils.getTabIndex('fullscreenVideoPlay') : -1,
              'aria-label': 'Play, toggle'
            }),
            _react2.default.createElement(
              'div',
              { className: 'cursor-pointer fullscreen-video-controls-progress', onClick: this.seekTo.bind(this),
                tabIndex: isDisplayed ? _utils.utils.getTabIndex('fullscreenVideoBar') : -1,
                'aria-label': 'Video Progress Bar, (' + (Math.round(played * 10) * 10 + '%') + ')',
                'aria-live': 'polite',
                onKeyDown: this.handleArrowKeys,
                role: 'progressbar'
              },
              _react2.default.createElement('div', { className: 'fullscreen-video-controls-progress fill', style: { width: played * 100 + '%' } })
            ),
            _react2.default.createElement(
              'span',
              { className: 'fullscreen-video-controls-time' },
              this.secondsToTimeString(duration * played)
            ),
            _react2.default.createElement(
              'span',
              { className: 'fullscreen-video-controls-slash' },
              '/'
            ),
            _react2.default.createElement(
              'span',
              { className: 'fullscreen-video-controls-time' },
              this.secondsToTimeString(duration)
            ),
            _react2.default.createElement('button', { className: "cursor-pointer fullscreen-video-controls-volume-icon progallery-svg-font-icons-volume",
              onClick: function onClick() {
                _this2.setState({ mute: !mute });
              },
              tabIndex: isDisplayed ? _utils.utils.getTabIndex('fullscreenVideoMute') : -1,
              'aria-label': '' + (this.state.mute ? 'Unmute' : 'Mute')
            }),
            _react2.default.createElement(
              'div',
              { className: 'cursor-pointer fullscreen-video-controls-volume-bar', onClick: this.setVolume.bind(this),
                tabIndex: isDisplayed ? _utils.utils.getTabIndex('fullscreenVideoVolume') : -1,
                'aria-label': 'Volume Controller',
                'aria-live': 'polite',
                onKeyDown: this.handleArrowKeys,
                role: 'progressbar'
              },
              _react2.default.createElement('div', { className: 'fullscreen-video-controls-volume-bar fill', style: { width: (mute ? 0 : volume * 100) + '%' } })
            )
          )
        )
      );
      var videoOverlay = this.isPlayedExternalMobileVideo() ? _react2.default.createElement('div', { className: 'fullscreen-mobile-external-video-overlay',
        style: { height: item.height * 0.7, width: item.width },
        onTouchEnd: function onTouchEnd() {
          return _this2.togglePlay();
        } }) : '';

      var isMobileExternalVideoPlayed = item.metadata.isExternal && this.state.playedOnce && _utils.utils.isMobile();

      return !isDummy ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          {
            'data-hook': 'fullscreen-video',
            className: 'fullscreen-item fullscreen-item-video fullscreen-item-' + item.idx + (_utils.utils.isiOS() ? ' ios' : ''),
            key: 'video_container'

          },
          _react2.default.createElement(_reactPlayerFork2.default, {
            url: item.videoUrl ? item.videoUrl : item.resized_url['mp4'],
            loop: !!this.props.styleParams.videoLoop,
            width: item.width,
            height: item.height,
            className: 'fullscreen-video fullscreen-video-' + item.idx,
            style: innerStyle,
            ref: function ref(video) {
              _this2.video = video;
            },
            playing: isDisplayed && playing,
            volume: mute ? 0 : volume,
            onReady: function onReady() {
              return console.log('fullscreen video onReady itemId: ' + item.idx);
            } //checking the only the correct video is loading
            , onStart: function onStart() {
              return console.log('fullscreen video onStart itemId: ' + item.idx);
            },
            onPlay: function onPlay() {
              return _this2.setState({ playing: true });
            },
            onPause: function onPause() {
              return _this2.setState({ playing: false });
            },
            onBuffer: function onBuffer(buffering) {
              return _this2.setState({ buffering: buffering });
            },
            onEnded: function onEnded() {
              return !!_this2.props.styleParams.videoLoop || _this2.setState({ playing: false });
            },
            onError: function onError(e) {
              return console.log('onError', e);
            },
            onProgress: function onProgress(_ref2) {
              var loaded = _ref2.loaded,
                  played = _ref2.played;
              return _this2.setState({ loaded: loaded, played: played });
            },
            onDuration: function onDuration(duration) {
              return _this2.setState({ duration: duration });
            },
            poster: item.resized_url['img'],
            onWrapperClick: this.onWrapperClick.bind(this),
            mockPlayer: false,
            playbackRate: this.props.styleParams.videoSpeed || 1,
            fileConfig: {
              attributes: {
                poster: item.resized_url['img']
              }
            },
            controls: item.metadata.isExternal || _utils.utils.isiOS()
          }),
          this.isPlayedExternalMobileVideo() || playing ? '' : _react2.default.createElement(
            'div',
            { onClick: this.togglePlay.bind(this) },
            _react2.default.createElement('i', { className: "cursor-pointer fullscreen-item-video-play progallery-svg-font-icons-play-triangle  " + (item.metadata.isExternal ? ' external' : '') }),
            _react2.default.createElement('i', { className: "cursor-pointer fullscreen-item-video-play progallery-svg-font-icons-play-background " + (item.metadata.isExternal ? ' external' : '') })
          ),
          item.metadata.isExternal ? videoOverlay : videoControls
        )
      ) : //slides on the left or right
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'video',
          { preload: 'none',
            width: item.width, height: item.height,
            poster: item.resized_url['img'],
            className: 'fullscreen-item fullscreen-video-' + this.props.item.idx,
            key: 'video',
            style: innerStyle,
            ref: function ref(video) {
              _this2.video = video;
            }
          },
          _react2.default.createElement('source', { src: item.resized_url['mp4'], type: 'video/mp4' }),
          _react2.default.createElement('source', { src: item.resized_url['webm'], type: 'video/webm' })
        )
      );
    }
  }]);

  return FullscreenVideo;
}(_react2.default.Component);

exports.default = FullscreenVideo;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _fullscreenItemPreload = __webpack_require__(221);

var _fullscreenItemPreload2 = _interopRequireDefault(_fullscreenItemPreload);

var _utils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FullscreenImage = function (_React$Component) {
  _inherits(FullscreenImage, _React$Component);

  function FullscreenImage(props) {
    _classCallCheck(this, FullscreenImage);

    var _this = _possibleConstructorReturn(this, (FullscreenImage.__proto__ || Object.getPrototypeOf(FullscreenImage)).call(this, props));

    _this.retryOnError = _this.retryOnError.bind(_this);
    _this.onLoadImage = _this.onLoadImage.bind(_this);

    _this.state = {
      loaded: false,
      failed: false,
      retries: 1
    };
    return _this;
  }

  _createClass(FullscreenImage, [{
    key: 'retryOnError',
    value: function retryOnError(e) {

      if (this.state.failed) {
        return false;
      } else if (this.state.retries > 3) {
        console.error('Error (including retries) loading item #' + this.props.item, e);
        this.setState({
          failed: true
        });
      } else {
        this.setState({
          retries: this.state.retries + 1
        });
      }
    }
  }, {
    key: 'onLoadImage',
    value: function onLoadImage() {
      this.setState({
        loaded: true
      });
    }
  }, {
    key: 'retryUrl',
    value: function retryUrl() {
      var item = this.props.item;

      var url = item.resized_url['img'];

      var hasGetParam = url.indexOf('?') >= 0;

      if (!hasGetParam && !this.state.failed) {
        // url += hasGetParam ? '&' : '?';
        url += '?retry=' + this.state.retries;
      }

      return url;
    }
  }, {
    key: 'render',
    value: function render() {

      var item = this.props.item;

      var transform = 'translate3d(-50%, -50%, 0) scale(' + this.props.window.scale.min(item) + ')';
      var innerStyle = {
        'width': item.width + 'px',
        'height': item.height + 'px',
        'transform': transform,
        'WebkitTransform': transform,
        'MozTransform': transform,
        'msTransform': transform,
        'OTransform': transform
      };

      var smallScreenStyle = {
        'width': item.width + 'px',
        'height': item.height + 'px'
      };

      return !this.props.isDummy ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_fullscreenItemPreload2.default, { window: this.props.window, loaded: this.state.loaded, item: this.props.item }),
        _react2.default.createElement('img', {
          'data-hook': 'fullscreen-image',
          className: 'fullscreen-item high-res ' + (this.state.loaded ? ' loaded ' : '') + (this.state.failed ? ' error ' : ''),
          src: this.retryUrl(),
          alt: item.alt,
          onError: this.retryOnError,
          onLoad: this.onLoadImage,
          key: 'image',
          style: _utils.utils.isSmallScreen() ? smallScreenStyle : innerStyle
        })
      ) : _react2.default.createElement('div', null);
    }
  }]);

  return FullscreenImage;
}(_react2.default.Component);

exports.default = FullscreenImage;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FullscreenItemPreload = function (_React$Component) {
  _inherits(FullscreenItemPreload, _React$Component);

  function FullscreenItemPreload(props) {
    _classCallCheck(this, FullscreenItemPreload);

    return _possibleConstructorReturn(this, (FullscreenItemPreload.__proto__ || Object.getPrototypeOf(FullscreenItemPreload)).call(this, props));
  }

  _createClass(FullscreenItemPreload, [{
    key: 'render',
    value: function render() {

      var item = this.props.item;
      var idx = this.props.item.idx;

      if (item.isText) {
        return _react2.default.createElement('div', null);
      } else {
        var transform = 'translate3d(-50%, -50%, 0) scale(' + this.props.window.scale.min(item) + ')';
        var innerStyle = {
          'width': item.width + 'px',
          'height': item.height + 'px',
          'backgroundColor': item.bgColor,
          'transform': transform,
          'WebkitTransform': transform,
          'MozTransform': transform,
          'msTransform': transform,
          'OTransform': transform
        };

        return item.preload_img ? _react2.default.createElement(
          'div',
          { className: "fullscreen-preload fullscreen-preload-" + idx,
            key: 'preload_container'
          },
          _react2.default.createElement('img', { className: 'fullscreen-item fullscreen-item-preload',
            src: item.preload_img,
            style: innerStyle,
            key: 'preload'
          }),
          this.props.loaded ? false : _react2.default.createElement('div', { className: 'pro-circle-preloader' })
        ) : _react2.default.createElement('div', null);
      }
    }
  }]);

  return FullscreenItemPreload;
}(_react2.default.Component);

exports.default = FullscreenItemPreload;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FullscreenText = function (_React$Component) {
  _inherits(FullscreenText, _React$Component);

  function FullscreenText(props) {
    _classCallCheck(this, FullscreenText);

    return _possibleConstructorReturn(this, (FullscreenText.__proto__ || Object.getPrototypeOf(FullscreenText)).call(this, props));
  }

  _createClass(FullscreenText, [{
    key: 'render',
    value: function render() {

      var item = this.props.item;

      return !this.props.isDummy ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('div', { className: 'fullscreen-item-visible fullscreen-item loaded text-item',
          style: {
            width: item.maxWidth + 'px',
            height: item.maxHeight + 'px',
            WebkitTransform: 'translate(-50%, -50%) scale(' + Math.round(100 * (item.width / item.maxWidth) * this.props.window.scale.min(item)) / 100 + ')',
            background: item.bgColor
          },
          key: 'text',
          dangerouslySetInnerHTML: { __html: item.html }
        })
      ) : _react2.default.createElement('div', null);
    }
  }]);

  return FullscreenText;
}(_react2.default.Component);

exports.default = FullscreenText;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _loveButton = __webpack_require__(67);

var _loveButton2 = _interopRequireDefault(_loveButton);

var _fullscreenSocialDownload = __webpack_require__(102);

var _fullscreenSocialDownload2 = _interopRequireDefault(_fullscreenSocialDownload);

var _fullscreenShareButtons = __webpack_require__(93);

var _fullscreenShareButtons2 = _interopRequireDefault(_fullscreenShareButtons);

var _utils = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FullscreenStoreSliderBottomBar = function (_React$Component) {
  _inherits(FullscreenStoreSliderBottomBar, _React$Component);

  function FullscreenStoreSliderBottomBar(props) {
    _classCallCheck(this, FullscreenStoreSliderBottomBar);

    return _possibleConstructorReturn(this, (FullscreenStoreSliderBottomBar.__proto__ || Object.getPrototypeOf(FullscreenStoreSliderBottomBar)).call(this, props));
  }

  _createClass(FullscreenStoreSliderBottomBar, [{
    key: 'render',
    value: function render() {
      var isStoreGallery = _utils.utils.isStoreGallery();

      var _props = this.props,
          love = _props.love,
          current = _props.current,
          styleParams = _props.styleParams,
          item = _props.item,
          isSettings = _props.isSettings;

      this.props.love.showCounter = styleParams.loveCounter;
      var showDownload = styleParams.allowDownload && !current.item.isDemo;
      var shareLeftPosition = showDownload ? love.count > 0 ? 240 : 220 : love.count > 0 ? 190 : 170;
      var loveLeftPosition = showDownload ? 170 : 100;
      var shareWrapperStyle = { top: 'initial', 'left': shareLeftPosition };
      var loveButtonStyle = { top: 'initial', 'left': loveLeftPosition, marginTop: -10 };
      var loveButtonCounterStyle = { top: 'initial', 'left': loveLeftPosition + 35, marginTop: -8 };
      var downloadButtonStyle = { top: 'initial', 'left': 100 };

      var desktopLoveButton = styleParams.loveButton ? _react2.default.createElement(_loveButton2.default, _extends({
        layout: 'fullscreen',
        device: 'desktop',
        isSettings: isSettings,
        style: loveButtonStyle,
        counterStyle: loveButtonCounterStyle
      }, love)) : '';

      var fullscreenSocialDownload = _react2.default.createElement(_fullscreenSocialDownload2.default, {
        layout: 'fullscreen',
        device: 'desktop',
        current: current,
        styleParams: styleParams,
        style: downloadButtonStyle
      });

      var shareClassNames = _utils.utils.isSite() && !this.props.isSettings ? '' : '';
      var shareIcon = _react2.default.createElement('i', { style: shareWrapperStyle, className: "progallery-svg-font-icons-share-store fullscreen-social-share-store" + shareClassNames });
      var fullscreenNavbarShare = this.props.styleParams.allowSocial ? _utils.utils.isSite() && !this.props.isSettings ? _react2.default.createElement(
        'div',
        { style: shareWrapperStyle,
          className: "fullscreen-icon fullscreen-social-share-box" + (showDownload ? '' : ' pull-left') + (isStoreGallery ? ' store' : '') },
        shareIcon,
        _react2.default.createElement(_fullscreenShareButtons2.default, { item: this.props.current.item })
      ) : _react2.default.createElement(
        'div',
        { style: shareWrapperStyle,
          className: "show-tooltip fullscreen-icon fullscreen-social-share-box" + (showDownload ? '' : ' pull-left') + (isStoreGallery ? ' store' : ''),
          onMouseOver: function onMouseOver(e) {
            return _utils.itemActions.showTooltip(e, 'Gallery_Sharing_Disabled_In_Editor');
          },
          onMouseOut: function onMouseOut() {
            return _utils.itemActions.hideTooltip();
          } },
        shareIcon
      ) : '';

      var desktopSocialBar = _utils.utils.isSmallScreen() || this.props.window.expanded ? '' : _react2.default.createElement(
        'div',
        { className: "fullscreen-social" },
        _react2.default.createElement(
          'div',
          null,
          fullscreenSocialDownload,
          desktopLoveButton,
          fullscreenNavbarShare
        )
      );

      return _react2.default.createElement(
        'div',
        null,
        desktopSocialBar
      );
    }
  }]);

  return FullscreenStoreSliderBottomBar;
}(_react2.default.Component);

exports.default = FullscreenStoreSliderBottomBar;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _loveButton = __webpack_require__(67);

var _loveButton2 = _interopRequireDefault(_loveButton);

var _fullscreenSocialDownload = __webpack_require__(102);

var _fullscreenSocialDownload2 = _interopRequireDefault(_fullscreenSocialDownload);

var _fullscreenShareButtons = __webpack_require__(93);

var _fullscreenShareButtons2 = _interopRequireDefault(_fullscreenShareButtons);

var _utils = __webpack_require__(2);

var _proGalleryVersionManager = __webpack_require__(94);

var _info = __webpack_require__(225);

var _info2 = _interopRequireDefault(_info);

var _info_invert = __webpack_require__(226);

var _info_invert2 = _interopRequireDefault(_info_invert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FullscreenDesktopNavbar = function (_React$Component) {
  _inherits(FullscreenDesktopNavbar, _React$Component);

  function FullscreenDesktopNavbar(props) {
    _classCallCheck(this, FullscreenDesktopNavbar);

    var _this = _possibleConstructorReturn(this, (FullscreenDesktopNavbar.__proto__ || Object.getPrototypeOf(FullscreenDesktopNavbar)).call(this, props));

    _this.handleShareArrowNavigation = _this.handleShareArrowNavigation.bind(_this);
    _this.state = {
      shareBoxIsOpened: false,
      focusedShareIcon: 0
    };

    _this.isStoreGallery = _utils.utils.isStoreGallery();

    return _this;
  }

  _createClass(FullscreenDesktopNavbar, [{
    key: 'handleShareArrowNavigation',
    value: function handleShareArrowNavigation(e) {

      if (!_utils.utils.isAccessibilityEnabled() || !this.state.shareBoxIsOpened) {
        //the keypress events are only effective when the share box was opened via Click or Focus+Enter
        return true;
      }

      switch (e.keyCode || e.charCode) {
        case 38: //up
        case 37: //left
        case 33:
          //page up
          e.preventDefault();
          e.stopPropagation();
          this.setState({
            focusedShareIcon: Math.max(1, this.state.focusedShareIcon - 1)
          });
          return false;
        case 39: //right
        case 40: //down
        case 34:
          //page down
          e.preventDefault();
          e.stopPropagation();
          this.setState({
            focusedShareIcon: Math.min(5, this.state.focusedShareIcon + 1)
          });
          return false;
        case 9: //tab
        case 27:
          //esc
          e.preventDefault();
          e.stopPropagation();
          this.shareBoxButton.focus();
          this.setState({
            focusedShareIcon: 0,
            shareBoxIsOpened: false
          });
          return false;

      }

      return true;
    }
  }, {
    key: 'getLoveButton',
    value: function getLoveButton() {
      return _react2.default.createElement(_loveButton2.default, _extends({
        key: 'fullscreen-love-' + this.props.id,
        layout: 'fullscreen',
        device: 'desktop',
        isSettings: this.props.isSettings
      }, this.props.love, {
        showCounter: true
      }));
    }
  }, {
    key: 'getDownload',
    value: function getDownload() {
      return _react2.default.createElement(_fullscreenSocialDownload2.default, {
        key: 'fullscreen-download-' + this.props.id,
        layout: 'fullscreen',
        device: 'desktop',
        current: this.props.current,
        styleParams: this.props.styleParams
      });
    }
  }, {
    key: 'getShareComponent',
    value: function getShareComponent(showDownload, shareIcon) {
      var storeClass = this.isStoreGallery ? 'store' : '';
      var shareBoxOpenedClass = this.state.shareBoxIsOpened ? 'hovered' : '';

      return _react2.default.createElement(
        'div',
        {
          key: 'shareComponent',
          className: 'fullscreen-icon fullscreen-social-share-box ' + storeClass + ' ' + shareBoxOpenedClass,
          onKeyDown: this.handleShareArrowNavigation
        },
        shareIcon,
        _react2.default.createElement(_fullscreenShareButtons2.default, { item: this.props.current.item, focus: this.state.focusedShareIcon })
      );
    }
  }, {
    key: 'getFakeShareComponent',
    value: function getFakeShareComponent(showDownload, shareIcon) {
      var storeClass = this.isStoreGallery ? 'store' : '';

      return _react2.default.createElement(
        'div',
        {
          className: 'show-tooltip fullscreen-icon fullscreen-social-share-box ' + storeClass,
          onMouseOver: function onMouseOver(e) {
            return _utils.itemActions.showTooltip(e, 'Gallery_Sharing_Disabled_In_Editor');
          },
          onMouseOut: function onMouseOut() {
            return _utils.itemActions.hideTooltip();
          }
        },
        shareIcon
      );
    }
  }, {
    key: 'getShareIcon',
    value: function getShareIcon() {
      var _this2 = this;

      return _react2.default.createElement('button', { className: "fullscreen-social-share-icon progallery-svg-font-icons-share-store",
        tabIndex: _utils.utils.getTabIndex('fullscreenShare'),
        ref: function ref(button) {
          return _this2.shareBoxButton = button;
        },
        onClick: function onClick() {
          _this2.setState({ shareBoxIsOpened: !_this2.state.shareBoxIsOpened });
        },
        'aria-label': 'Share'
      });
    }
  }, {
    key: 'getShareButtons',
    value: function getShareButtons() {
      var showDownload = this.props.styleParams.allowDownload && !this.props.current.item.isDemo;
      var shareIcon = this.getShareIcon();

      if (!this.props.styleParams.allowSocial) {
        return false;
      }
      var isLiveSite = _utils.utils.isSite() && !this.props.isSettings;

      return isLiveSite ? this.getShareComponent(showDownload, shareIcon) : this.getFakeShareComponent(showDownload, shareIcon);
    }
  }, {
    key: 'getSocialBarContainer',
    value: function getSocialBarContainer() {
      var styleParams = this.props.styleParams;

      var loveButton = styleParams.loveButton ? this.getLoveButton() : '';
      var downloadButton = this.getDownload();
      var shareButtons = this.getShareButtons();

      return _react2.default.createElement(
        'div',
        { className: "fullscreen-social" },
        [_proGalleryVersionManager.versionManager.useFullscreenNewDesktopNavbar() ? this.getExpandButton() : '', _proGalleryVersionManager.versionManager.useFullscreenNewDesktopNavbar() ? this.getMoreInfoButton() : false, _proGalleryVersionManager.versionManager.useFullscreenNewDesktopNavbar() ? downloadButton : loveButton, _proGalleryVersionManager.versionManager.useFullscreenNewDesktopNavbar() ? loveButton : downloadButton, shareButtons]
      );
    }
  }, {
    key: 'getCloseButton',
    value: function getCloseButton() {
      var _this3 = this;

      var closeExpandIconClass = 'progallery-svg-font-icons-close-x';
      if (this.props.window.expanded && _proGalleryVersionManager.versionManager.useFullscreenNewDesktopNavbar()) {
        closeExpandIconClass = 'progallery-svg-font-icons-shrink-arrow';
      }

      var closeButton = _react2.default.createElement('button', {
        className: 'fullscreen-icon fullscreen-close ' + closeExpandIconClass,
        onClick: function onClick() {
          return _this3.props.actions.close();
        },
        tabIndex: _utils.utils.getTabIndex('fullscreenClose'),
        'aria-label': 'Exit ' + (this.props.window.expanded ? 'Full Screen' : 'Expand Mode'),
        ref: function ref(button) {
          return _this3.closeButton = button;
        }
      });

      var fakeCloseButton = _react2.default.createElement('button', {
        className: 'show-tooltip fullscreen-icon fullscreen-close progallery-svg-font-icons-close-x',
        onMouseOver: function onMouseOver(e) {
          return _utils.itemActions.showTooltip(e, 'This option is not available in editor');
        },
        onMouseOut: function onMouseOut() {
          return _utils.itemActions.hideTooltip();
        } });

      return this.props.isSettings ? fakeCloseButton : closeButton;
    }
  }, {
    key: 'getNavigationArrows',
    value: function getNavigationArrows() {
      var _this4 = this;

      return [_react2.default.createElement('button', {
        className: "fullscreen-icon fullscreen-next progallery-svg-font-icons-arrow_right " + (this.props.current.idx >= this.props.totalItems - 1 ? ' fullscreen-icon-disabled ' : ''),
        onClick: function onClick() {
          return _this4.props.actions.fadeToNextSlide(1);
        },
        tabIndex: this.props.current.idx >= this.props.totalItems - 1 ? -1 : _utils.utils.getTabIndex('fullscreenNext'),
        'aria-label': 'Next Item'
      }), _react2.default.createElement('button', {
        className: "fullscreen-icon fullscreen-prev progallery-svg-font-icons-arrow_left " + (this.props.current.idx <= 0 ? ' fullscreen-icon-disabled ' : ''),
        onClick: function onClick() {
          return _this4.props.actions.fadeToNextSlide(-1);
        },
        tabIndex: this.props.current.idx <= 0 ? -1 : _utils.utils.getTabIndex('fullscreenPrev'),
        'aria-label': 'Previous Item'
      })];
    }
  }, {
    key: 'getMoreInfoButton',
    value: function getMoreInfoButton() {
      var _props = this.props,
          styleParams = _props.styleParams,
          current = _props.current,
          actions = _props.actions,
          showInfo = _props.showInfo;

      var shouldHideMoreInfoButton = !styleParams.showInfoExpandButton || this.props.window.expanded || _utils.utils.isMobile() || !current.hasInfo;
      if (shouldHideMoreInfoButton) {
        return false;
      }
      var svgInfoWhite = _react2.default.createElement(
        'div',
        { className: 'info-white' },
        (0, _info2.default)()
      ); //<svg className="info-white" width="18" height="18" viewBox="0 0 18 18"><g fill="none" fill-rule="evenodd"><circle cx="9" cy="9" r="9" fill="none"/><path d="M9.44 3.411a.943.943 0 0 1 .329.328.866.866 0 0 1 0 .892.906.906 0 0 1-.329.328.885.885 0 0 1-.892 0 .872.872 0 0 1-.328-.328.885.885 0 0 1 0-.892.906.906 0 0 1 .776-.45c.16 0 .308.04.444.122zm.387 9.899a.6.6 0 0 0 .335.307c.152.06.36.09.625.09V14a50.765 50.765 0 0 0-1.695-.055c-.274 0-.839.019-1.696.055v-.294c.265 0 .473-.03.626-.089a.6.6 0 0 0 .335-.307c.07-.146.106-.35.106-.609V8.32c0-.433-.079-.747-.236-.943-.157-.196-.434-.294-.83-.294v-.294c.291.027.58.041.868.041.592 0 1.077-.064 1.456-.191V12.7c0 .26.035.463.106.609z"/></g></svg>
      var svgInfoBlack = _react2.default.createElement(
        'div',
        { className: 'info-black' },
        (0, _info_invert2.default)()
      ); // <svg className="info-black" width="18" height="18" viewBox="0 0 18 18"><g fill="none" fill-rule="evenodd"><circle cx="9" cy="9" r="9" fill="none"/><path d="M9.44 3.411a.943.943 0 0 1 .329.328.866.866 0 0 1 0 .892.906.906 0 0 1-.329.328.885.885 0 0 1-.892 0 .872.872 0 0 1-.328-.328.885.885 0 0 1 0-.892.906.906 0 0 1 .776-.45c.16 0 .308.04.444.122zm.387 9.899a.6.6 0 0 0 .335.307c.152.06.36.09.625.09V14a50.765 50.765 0 0 0-1.695-.055c-.274 0-.839.019-1.696.055v-.294c.265 0 .473-.03.626-.089a.6.6 0 0 0 .335-.307c.07-.146.106-.35.106-.609V8.32c0-.433-.079-.747-.236-.943-.157-.196-.434-.294-.83-.294v-.294c.291.027.58.041.868.041.592 0 1.077-.064 1.456-.191V12.7c0 .26.035.463.106.609z"/></g></svg>


      var showMoreIconClass = _proGalleryVersionManager.versionManager.useFullscreenNewDesktopNavbar() ? '' : 'progallery-svg-font-icons-plus';
      var showLessIconClass = _proGalleryVersionManager.versionManager.useFullscreenNewDesktopNavbar() ? '' : 'progallery-svg-font-icons-minus';

      return _react2.default.createElement(
        'button',
        {
          className: "fullscreen-icon fullscreen-info " + (showInfo ? showLessIconClass : showMoreIconClass),
          onClick: function onClick() {
            return actions.toggleInfo();
          },
          tabIndex: _utils.utils.getTabIndex('fullscreenInfo'),
          'aria-label': showInfo ? 'Hide Details' : 'Show More Details'
        },
        _proGalleryVersionManager.versionManager.useFullscreenNewDesktopNavbar() ? showInfo ? svgInfoBlack : svgInfoWhite : false
      );
    }
  }, {
    key: 'getExpandButton',
    value: function getExpandButton() {
      var _props2 = this.props,
          isSettings = _props2.isSettings,
          current = _props2.current,
          actions = _props2.actions;

      var shouldHideExpandButton = isSettings || this.props.window.expanded || _utils.utils.isMobile() || _utils.utils.isiOS() || _utils.utils.isEditor() || _utils.utils.isPreview();
      var expandIconClass = _proGalleryVersionManager.versionManager.useFullscreenNewDesktopNavbar() ? 'progallery-svg-font-icons-expand-arrow' : 'progallery-svg-font-icons-fullscreen';
      if (isSettings && this.isStoreGallery) {
        return false;
      } else if (isSettings) {
        return _react2.default.createElement('button', {
          className: 'show-tooltip fullscreen-icon fullscreen-expand ' + expandIconClass,
          onMouseOver: function onMouseOver(e) {
            return _utils.itemActions.showTooltip(e, 'This option is not available in editor');
          },
          onMouseOut: function onMouseOut() {
            return _utils.itemActions.hideTooltip();
          } });
      }

      var hiddenStyle = { visibility: 'hidden' };
      return _react2.default.createElement('button', {
        key: 'fullscreen-expand-' + this.props.id,
        className: 'fullscreen-icon fullscreen-expand ' + expandIconClass,
        style: this.isStoreGallery ? hiddenStyle : {},
        onClick: function onClick() {
          return actions.expandBrowser();
        },
        tabIndex: _utils.utils.getTabIndex('fullscreenExpand'),
        'aria-label': this.props.window.expanded ? 'Close full screen' : 'Open in full screen'
      });
    }
  }, {
    key: 'getNavigationContainer',
    value: function getNavigationContainer() {
      var controls = [_proGalleryVersionManager.versionManager.useFullscreenNewDesktopNavbar() ? false : this.getNavigationArrows(), _proGalleryVersionManager.versionManager.useFullscreenNewDesktopNavbar() ? false : this.getMoreInfoButton(), _proGalleryVersionManager.versionManager.useFullscreenNewDesktopNavbar() || this.props.window.expanded ? false : this.getExpandButton()];

      return _react2.default.createElement(
        'div',
        { className: 'fullscreen-nav' },
        this.getCloseButton(),
        this.isStoreGallery ? false : controls
      );
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (_utils.utils.isAccessibilityEnabled()) {
        if (this.closeButton && this.props.navigatedInto) {
          this.closeButton.focus();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (_utils.utils.isSmallScreen()) {
        return false;
      }

      var shouldHideSocialBar = this.props.window.expanded;

      var socialBarContainer = shouldHideSocialBar ? _proGalleryVersionManager.versionManager.useFullscreenNewDesktopNavbar() ? false : _react2.default.createElement('div', null) : this.getSocialBarContainer();
      var navigationContainer = this.getNavigationContainer();

      return _react2.default.createElement(
        'div',
        { className: 'fullscreen-desktop-navbar-container' },
        socialBarContainer,
        navigationContainer
      );
    }
  }]);

  return FullscreenDesktopNavbar;
}(_react2.default.Component);

exports.default = FullscreenDesktopNavbar;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Info (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#1b1b1b;}.cls-2{fill:#1b1b1b;}")),React.createElement("title",{"key":1},"info"),React.createElement("g",{"id":"Symbols","key":2},React.createElement("g",{"id":"info"},[React.createElement("path",{"id":"Oval","className":"cls-1","d":"M9,17.5A8.5,8.5,0,1,1,17.5,9,8.5,8.5,0,0,1,9,17.5Z","key":0}),React.createElement("path",{"id":"i","className":"cls-2","d":"M9.44,3.41a.94.94,0,0,1,.33.33.85.85,0,0,1,.12.44.87.87,0,0,1-.12.45A.91.91,0,0,1,9.44,5,.87.87,0,0,1,9,5.08.88.88,0,0,1,8.55,5a.87.87,0,0,1-.33-.33.88.88,0,0,1-.12-.45.87.87,0,0,1,.12-.44.91.91,0,0,1,.33-.33A.87.87,0,0,1,9,3.29.85.85,0,0,1,9.44,3.41Zm.39,9.9a.6.6,0,0,0,.33.31,1.78,1.78,0,0,0,.63.09V14l-1.7-.05L7.4,14v-.29A1.78,1.78,0,0,0,8,13.62a.6.6,0,0,0,.33-.31,1.42,1.42,0,0,0,.11-.61V8.32a1.51,1.51,0,0,0-.24-.94,1,1,0,0,0-.83-.29V6.79q.44,0,.87,0a4.64,4.64,0,0,0,1.46-.19V12.7A1.42,1.42,0,0,0,9.83,13.31Z","key":1})]))]);
}

Info.displayName = "Info";

Info.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 18 18"};

module.exports = Info;

Info.default = Info;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function InfoInvert (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#1b1b1b;}")),React.createElement("title",{"key":1},"info_invert"),React.createElement("path",{"className":"cls-1","d":"M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0ZM8.22,3.74a.91.91,0,0,1,.33-.33A.87.87,0,0,1,9,3.29a.85.85,0,0,1,.44.12.94.94,0,0,1,.33.33.85.85,0,0,1,.12.44.87.87,0,0,1-.12.45A.91.91,0,0,1,9.44,5,.87.87,0,0,1,9,5.08.88.88,0,0,1,8.55,5a.87.87,0,0,1-.33-.33.88.88,0,0,1-.12-.45A.87.87,0,0,1,8.22,3.74ZM10.79,14l-1.7-.05L7.4,14v-.29A1.78,1.78,0,0,0,8,13.62a.6.6,0,0,0,.33-.31,1.42,1.42,0,0,0,.11-.61V8.32a1.51,1.51,0,0,0-.24-.94,1,1,0,0,0-.83-.29V6.79q.44,0,.87,0a4.64,4.64,0,0,0,1.46-.19V12.7a1.42,1.42,0,0,0,.11.61.6.6,0,0,0,.33.31,1.78,1.78,0,0,0,.63.09Z","key":2})]);
}

InfoInvert.displayName = "InfoInvert";

InfoInvert.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 18 18"};

module.exports = InfoInvert;

InfoInvert.default = InfoInvert;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _loveButton = __webpack_require__(67);

var _loveButton2 = _interopRequireDefault(_loveButton);

var _fullscreenSocialDownload = __webpack_require__(102);

var _fullscreenSocialDownload2 = _interopRequireDefault(_fullscreenSocialDownload);

var _fullscreenShareButtons = __webpack_require__(93);

var _fullscreenShareButtons2 = _interopRequireDefault(_fullscreenShareButtons);

var _cartApi = __webpack_require__(26);

var _cartApi2 = _interopRequireDefault(_cartApi);

var _utils = __webpack_require__(2);

var _proGalleryVersionManager = __webpack_require__(94);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FullscreenMobileBar = function (_React$Component) {
  _inherits(FullscreenMobileBar, _React$Component);

  function FullscreenMobileBar(props) {
    _classCallCheck(this, FullscreenMobileBar);

    var _this = _possibleConstructorReturn(this, (FullscreenMobileBar.__proto__ || Object.getPrototypeOf(FullscreenMobileBar)).call(this, props));

    _this.state = {
      showShare: false
    };
    return _this;
  }

  _createClass(FullscreenMobileBar, [{
    key: 'toggleShare',
    value: function toggleShare(forceVal) {
      this.setState({
        showShare: _.isUndefined(forceVal) ? !this.state.showShare : forceVal
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var isStoreGallery = _utils.utils.isStoreGallery();
      this.props.love.showCounter = this.props.styleParams.loveCounter;
      var mobileLoveButton = this.props.styleParams.loveButton ? _react2.default.createElement(_loveButton2.default, _extends({
        layout: 'fullscreen',
        device: 'mobile'
      }, this.props.love)) : '';

      var fullscreenSocialDownload = _react2.default.createElement(_fullscreenSocialDownload2.default, {
        layout: 'fullscreen',
        device: 'mobile',
        current: this.props.current,
        styleParams: this.props.styleParams
      });

      var mobileBack = _proGalleryVersionManager.versionManager.useFullscreenNewMobileLayout() ? _react2.default.createElement(
        'div',
        { className: "fullscreen-mobile-bar fullscreen-mobile-top back" },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('div', { className: 'fullscreen-back-store',
            onClick: function onClick() {
              return _this2.props.actions.toggleShareScreen(false);
            } })
        )
      ) : _react2.default.createElement(
        'div',
        { className: "fullscreen-mobile-bar fullscreen-mobile-top" },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('i', { className: 'fullscreen-close progallery-svg-font-icons-back',
            onClick: function onClick() {
              return _this2.props.actions.toggleInfo(false);
            } })
        )
      );

      var mobileShare = function mobileShare(type) {
        var icons = type == 'top' ? mobileTopShare : mobileRightShare;
        var cls = "fullscreen-more progallery-svg-font-icons-more_actions";

        return isStoreGallery ? '' : _this2.props.styleParams.allowSocial ? _utils.utils.isSite() ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('i', { className: cls,
            onClick: function onClick() {
              return _this2.toggleShare();
            } }),
          icons
        ) : _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('i', { className: cls + ' show-tooltip ',
            onMouseOver: function onMouseOver(e) {
              return _utils.itemActions.showTooltip(e, 'Gallery_Sharing_Disabled_In_Editor');
            },
            onMouseOut: function onMouseOut() {
              return _utils.itemActions.hideTooltip();
            }
          }),
          icons
        ) : '';
      };

      var shareIcon = this.props.styleParams.allowSocial ? _react2.default.createElement('i', { className: 'progallery-svg-font-icons-share-store share-icon', onClick: function onClick() {
          return _this2.props.actions.toggleShareScreen();
        } }) : null;
      var newMobileShare = _react2.default.createElement(
        'div',
        { className: 'fullscreen-social' },
        fullscreenSocialDownload,
        mobileLoveButton,
        shareIcon
      );

      // var mobileCart = isStoreGallery ? (
      //   <div className="disabled-mobile-cart"></div>
      //   //  <div className="fullscreen-mobile-cart" onClick={() => cartApi.showCart()}></div>
      // ) : '';

      var mobileTopShare = this.props.styleParams.allowSocial && !_proGalleryVersionManager.versionManager.useFullscreenNewMobileLayout() ? _react2.default.createElement(
        'div',
        { className: "fullscreen-icon fullscreen-social-share-box" },
        _react2.default.createElement(_fullscreenShareButtons2.default, { item: this.props.current.item }),
        fullscreenSocialDownload
      ) : this.props.styleParams.allowDownload ? _react2.default.createElement(
        'div',
        { className: "fullscreen-icon fullscreen-social-share-box" },
        fullscreenSocialDownload
      ) : '';

      var mobileShareContainer = _proGalleryVersionManager.versionManager.useFullscreenNewMobileLayout() ? newMobileShare : mobileShare('top');

      var mobileTopClassNames = "fullscreen-mobile-bar fullscreen-mobile-top";
      mobileTopClassNames += this.state.showShare ? ' share' : '';
      mobileTopClassNames += _proGalleryVersionManager.versionManager.useFullscreenNewMobileLayout() ? ' store' : '';
      var mobileTop = _react2.default.createElement(
        'div',
        { className: mobileTopClassNames },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('i', { className: 'fullscreen-close progallery-svg-font-icons-back',
            onClick: function onClick() {
              return _this2.props.actions.close();
            } }),
          mobileShareContainer
        )
      );

      var mobileBottom = _react2.default.createElement(
        'div',
        { className: 'fullscreen-mobile-bar fullscreen-mobile-bottom' },
        _react2.default.createElement(
          'div',
          null,
          mobileLoveButton,
          this.props.current.hasInfo ? _react2.default.createElement('i', {
            className: "fullscreen-info progallery-svg-font-icons-" + (this.props.showInfo ? 'minus' : 'plus'),
            onClick: function onClick() {
              return _this2.props.actions.toggleInfo();
            } }) : ''
        )
      );

      var mobileRightShare = this.props.styleParams.allowSocial ? _react2.default.createElement(
        'div',
        { className: "fullscreen-icon fullscreen-social-share-box vertical" },
        _react2.default.createElement(_fullscreenShareButtons2.default, { item: this.props.current.item }),
        fullscreenSocialDownload
      ) : this.props.styleParams.allowDownload ? _react2.default.createElement(
        'div',
        { className: "fullscreen-icon fullscreen-social-share-box vertical" },
        fullscreenSocialDownload
      ) : '';

      var mobileRight = _react2.default.createElement(
        'div',
        { className: "fullscreen-mobile-bar fullscreen-mobile-right " + (this.state.showShare ? 'share' : '') },
        _react2.default.createElement(
          'div',
          null,
          mobileShare('right'),
          this.props.current.hasInfo ? _react2.default.createElement('i', {
            className: "fullscreen-info progallery-svg-font-icons-" + (this.props.showInfo ? 'minus' : 'plus'),
            onClick: function onClick() {
              return _this2.props.actions.toggleInfo();
            } }) : ''
        )
      );

      var mobileLeftClassNames = "fullscreen-mobile-bar fullscreen-mobile-left";
      mobileLeftClassNames += isStoreGallery ? ' store' : '';
      var mobileLeft = _react2.default.createElement(
        'div',
        { className: mobileLeftClassNames },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('i', { className: 'fullscreen-close progallery-svg-font-icons-back',
            onClick: function onClick() {
              return _this2.props.actions.close();
            } }),
          mobileLoveButton
        )
      );

      var mobileBars = [];
      if (_utils.utils.isSmallScreen()) {
        if (_proGalleryVersionManager.versionManager.useFullscreenNewMobileLayout() && this.props.showShareScreen) {
          //more info is shown - display only the back button
          mobileBars[0] = mobileBack;
          mobileBars[1] = false;
        } else if (_proGalleryVersionManager.versionManager.useFullscreenNewMobileLayout() || _utils.utils.isVerticalScreen()) {
          //portrait screen
          mobileBars[0] = mobileTop;
          mobileBars[1] = mobileBottom;
        } else {
          //landscape screen
          mobileBars[0] = mobileLeft;
          mobileBars[1] = mobileRight;
        }
      }

      return this.props.isFirst ? mobileBars[0] || false : mobileBars[1] || false;
    }
  }]);

  return FullscreenMobileBar;
}(_react2.default.Component);

exports.default = FullscreenMobileBar;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _fullscreenShareButtons = __webpack_require__(93);

var _fullscreenShareButtons2 = _interopRequireDefault(_fullscreenShareButtons);

var _fullscreenCartButton = __webpack_require__(153);

var _fullscreenCartButton2 = _interopRequireDefault(_fullscreenCartButton);

var _fullscreenCheckoutLink = __webpack_require__(154);

var _fullscreenCheckoutLink2 = _interopRequireDefault(_fullscreenCheckoutLink);

var _fullscreenShop = __webpack_require__(229);

var _fullscreenShop2 = _interopRequireDefault(_fullscreenShop);

var _consts = __webpack_require__(11);

var _utils = __webpack_require__(2);

var _proGalleryVersionManager = __webpack_require__(94);

var _mobileViewTypes = __webpack_require__(137);

var _mobileViewTypes2 = _interopRequireDefault(_mobileViewTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FullscreenSidebar = function (_React$Component) {
  _inherits(FullscreenSidebar, _React$Component);

  function FullscreenSidebar(props) {
    _classCallCheck(this, FullscreenSidebar);

    var _this = _possibleConstructorReturn(this, (FullscreenSidebar.__proto__ || Object.getPrototypeOf(FullscreenSidebar)).call(this, props));

    _this.state = {
      isStoreGallery: _utils.utils.isStoreGallery(),
      isSmallScreen: _utils.utils.isSmallScreen(),
      isMobile: _utils.utils.isMobile(),
      isStoreMobile: _utils.utils.isStoreGallery() && _utils.utils.isMobile(),
      isReadMoreVisible: false,
      isReadMoreOpen: false
    };
    return _this;
  }

  _createClass(FullscreenSidebar, [{
    key: 'fixTextsLineHeight',
    value: function fixTextsLineHeight(isReadMoreOpen) {
      var elem = this.itemContainer;
      var title = $(elem).find('.fullscreen-side-bar-title');
      var description = $(elem).find('.fullscreen-side-bar-description');
      var availableHeight = 150;
      var numberOfLinesRequired = 3;
      var spaceBetweenTitleAndDescription = 0;
      var originalTitleHeight = 0;
      var originalDescriptionHeight = 0;

      var titleLineHeight = parseInt(title.css('line-height')) || 0;
      var numOfTitleLines = 0;
      var numOfDescriptionLines = 0;

      // reset truncation stuff
      title.css({ height: 'initial' });
      description.css({ height: 'initial' });
      title.css({ '-webkit-line-clamp': 'initial' });
      description.css({ '-webkit-line-clamp': 'initial' });

      if (title && title[0]) {
        // originalTitleHeight = title[0].scrollHeight - 18 //substructing the title margin-bottom
        originalTitleHeight = title[0].scrollHeight;
      }
      if (description && description[0]) {
        // originalDescriptionHeight = description[0].scrollHeight - 24 //substructing the description margin-bottom
        originalDescriptionHeight = description[0].scrollHeight;
      }

      if (!isReadMoreOpen) {
        var titleText = this.props.current.item.title || this.props.fileName;
        if (this.props.styleParams.allowTitleExpand && titleText) {
          if (title && title.length != 1) {
            return;
          }

          spaceBetweenTitleAndDescription = 30;

          numOfTitleLines = this.truncateElement(availableHeight, numberOfLinesRequired, title, originalTitleHeight);
          var titleHeight = numOfTitleLines * titleLineHeight;

          if (availableHeight > titleHeight) {
            availableHeight -= titleHeight;
          } else {
            availableHeight = 0;
          }
        }

        if (this.props.styleParams.allowDescriptionExpand && this.props.current.item.description) {
          if (description && description.length != 1) {
            return;
          }

          availableHeight -= spaceBetweenTitleAndDescription;

          if (availableHeight <= 0) {
            description.hide();
            return;
          }

          numOfDescriptionLines = this.truncateElement(availableHeight, numberOfLinesRequired - numOfTitleLines, description, originalDescriptionHeight);

          if (numOfDescriptionLines == 0) {
            description.hide();
          }
        }
      } else {
        //all the title and description should be displayed
        if (this.props.current.item.isReadMoreOpen) {
          this.setState({ isReadMoreVisible: true });
        }
        title.css({ height: originalTitleHeight });
        description.css({ height: originalDescriptionHeight });
        description.show();
        title.css({ '-webkit-line-clamp': 'initial' });
        description.css({ '-webkit-line-clamp': 'initial' });
      }
    }
  }, {
    key: 'truncateElement',
    value: function truncateElement(availableHeight, numberOfLinesRequired, element, originalElementHeight) {
      var numOfElementLines = 0;

      element.css({ 'overflow': 'visible' });
      var elementHeight = originalElementHeight;
      var elementLineHeight = parseInt(element.css('line-height')) || 0;
      var originalNumberOfElementLines = Math.floor(elementHeight / elementLineHeight);
      numOfElementLines = Math.min(Math.floor(availableHeight / elementLineHeight), numberOfLinesRequired, originalNumberOfElementLines);

      if (numOfElementLines < originalNumberOfElementLines) {
        //need to truncate the element
        this.props.current.item.isReadMoreOpen = false;
        this.setState({ isReadMoreOpen: false });
        this.setState({ isReadMoreVisible: true });

        element.css({ '-webkit-line-clamp': numOfElementLines + '' });
        elementHeight = elementLineHeight * numOfElementLines;
        element.css({ 'overflow': 'hidden', 'display': '-webkit-box', '-webkit-box-orient': 'vertical', height: elementHeight });
      } else {
        //all the element can be displayed
        if (this.props.current.item.isReadMoreOpen) {
          this.setState({ isReadMoreVisible: true });
        }
        element.css({ '-webkit-line-clamp': 'initial' });
        elementHeight = elementLineHeight * originalNumberOfElementLines;
      }
      return numOfElementLines;
    }
  }, {
    key: 'toggleReadMore',
    value: function toggleReadMore() {
      this.props.current.item.isReadMoreOpen = !this.props.current.item.isReadMoreOpen;
      this.setState({ isReadMoreOpen: this.props.current.item.isReadMoreOpen });
      this.fixTextsLineHeight(this.curItem.isReadMoreOpen);
    }
  }, {
    key: 'handleSetMobileData',
    value: function handleSetMobileData(type, data) {
      var onSetMobileData = this.props.onSetMobileData;
      if (onSetMobileData) {
        onSetMobileData(type, data);
      }
    }
  }, {
    key: 'postShopRequest',
    value: function postShopRequest(type, data) {
      if (this.shopElement) {
        this.shopElement.postShopRequest(type, data);
      }
    }
  }, {
    key: 'addToCartRequest',
    value: function addToCartRequest() {
      if (this.shopElement) {
        this.shopElement.addToCartRequest();
      }
    }
  }, {
    key: 'isVisible',
    value: function isVisible() {
      return this.props.showInfo && this.props.current.hasInfo || this.state.isStoreGallery && !this.state.isSmallScreen || this.props.showMobileShopFrame === true;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      // if (!utils.isSmallScreen()) {
      //   // $(".fullscreen-side-bar-info-container").mCustomScrollbar({
      //   //   theme:"dark"
      //   // });
      // }

      if (_utils.utils.isStoreGallery()) {
        if (prevProps.current.item.id !== this.props.current.item.id) {
          // we are dealing with a new item
          if (this.state.isReadMoreVisible) {
            this.setState({ isReadMoreVisible: false });
          }
          this.setState({ isReadMoreOpen: this.props.current.item.isReadMoreOpen });
          this.fixTextsLineHeight(this.curItem.isReadMoreOpen);
        }
      }

      // if (utils.isAccessibilityEnabled()) {
      //   if (this.titleElement && this.isVisible() && !prevProps.showInfo) {
      //     this.titleElement.focus();
      //   }
      // }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (_utils.utils.isStoreGallery()) {
        this.fixTextsLineHeight(this.curItem.isReadMoreOpen);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var curItem = this.curItem = this.props.current.item;
      var isImage = curItem.type === 'image' || curItem.type === 'picture';
      var _state = this.state,
          isReadMoreVisible = _state.isReadMoreVisible,
          isStoreGallery = _state.isStoreGallery,
          isSmallScreen = _state.isSmallScreen,
          isMobile = _state.isMobile,
          isStoreMobile = _state.isStoreMobile,
          isReadMoreOpen = _state.isReadMoreOpen;


      var titleText = curItem.title || curItem.fileName || ''; //(curItem.isDemo ? curItem.demoTitle : ''); - remove default text from demo items until rewritten
      var title = titleText && this.props.styleParams.allowTitleExpand && !isStoreMobile ? _react2.default.createElement(
        'div',
        { className: 'fullscreen-side-bar-title',
          tabIndex: this.isVisible() ? _utils.utils.getTabIndex('fullscreenTitle') : -1,
          'aria-label': titleText,
          ref: function ref(title) {
            return _this2.titleElement = title;
          }
        },
        titleText
      ) : null;

      var descriptionText = curItem.description || ''; //(curItem.isDemo ? curItem.demoDescription : ''); - remove default text from demo items until rewritten
      var descriptionTextArray = descriptionText.split('\n');
      var description;
      if (descriptionText && this.props.styleParams.allowDescriptionExpand && !isStoreMobile) {
        var descriptionElementsArray = [];
        for (var i = 0; i < descriptionTextArray.length; i++) {
          descriptionElementsArray.push(_react2.default.createElement(
            'div',
            { className: 'fullscreen-side-bar-description-line', key: "description_" + i },
            descriptionTextArray[i]
          ));
        }

        var descriptionClassName = "fullscreen-side-bar-description";
        descriptionClassName += isStoreGallery ? ' store' : '';
        description = _react2.default.createElement(
          'div',
          { className: descriptionClassName,
            tabIndex: this.isVisible() ? _utils.utils.getTabIndex('fullscreenDesc') : -1,
            ref: function ref(desc) {
              return _this2.descElement = desc;
            }
          },
          descriptionElementsArray
        );
      } else {
        description = null;
      }

      var prettyExif = '';
      if (curItem.exif) {

        var camera = curItem.exif['Model'];

        //todo - place separators using join

        var focalLength = curItem.exif['FocalLength'] ? _react2.default.createElement(
          'span',
          null,
          curItem.exif['FocalLength'],
          'mm'
        ) : '';
        var fNumber = curItem.exif['FNumber'] ? _react2.default.createElement(
          'span',
          null,
          '\xA0\xA0/\xA0\xA0\u0192/',
          curItem.exif['FNumber']
        ) : '';
        var roundExposureTime = Math.round(1 / Number(curItem.exif['ExposureTime']));
        var exposureTime = roundExposureTime > 0 ? _react2.default.createElement(
          'span',
          null,
          '\xA0\xA0/\xA0\xA01/',
          roundExposureTime,
          's'
        ) : '';
        var isoSpeed = curItem.exif['IsoSpeed'] ? _react2.default.createElement(
          'span',
          null,
          '\xA0\xA0/\xA0\xA0ISO ',
          curItem.exif['IsoSpeed']
        ) : '';

        var showExif = focalLength || fNumber || exposureTime || isoSpeed;

        prettyExif = showExif && this.props.styleParams.allowExifExpand && !isStoreGallery ? _react2.default.createElement(
          'div',
          { className: 'fullscreen-side-bar-exif' },
          _react2.default.createElement(
            'div',
            { className: 'exif-camera' },
            camera
          ),
          _react2.default.createElement(
            'div',
            { className: 'exif-shot' },
            focalLength,
            fNumber,
            exposureTime,
            isoSpeed
          )
        ) : '';
      }
      /*
       var allExif = [];
       for (var field in curItem.exif) {
       if (curItem.exif.hasOwnProperty(field)) {
       allExif.push(
       <p>{field}: {curItem.exif[field]}</p>
       )
       }
       }
        <p className="exif-more">see all</p>
       <div className="exif-all">
       {allExif}
       </div>
       */

      var linkClassNames = "fullscreen-side-bar-link link";
      linkClassNames += isStoreGallery ? ' store' : '';

      var link = curItem.hasLink && this.props.styleParams.allowLinkExpand && !isStoreMobile && (isStoreGallery ? curItem.hasLink && (!isReadMoreVisible || isReadMoreOpen) : true) ? curItem.linkType === 'web' ? _react2.default.createElement(
        'a',
        { className: linkClassNames,
          href: curItem.linkUrl,
          target: curItem.linkOpenType,
          tabIndex: this.isVisible() ? _utils.utils.getTabIndex('fullscreenLink') : -1,
          'aria-label': curItem.linkText
        },
        curItem.linkText ? curItem.linkText : curItem.linkUrl
      ) : _react2.default.createElement(
        'a',
        {
          className: linkClassNames,
          onClick: function onClick() {
            return _this2.props.actions.navigateToPageByItemLink(curItem);
          },
          tabIndex: this.isVisible() ? _utils.utils.getTabIndex('fullscreenLink') : -1,
          'aria-label': curItem.linkText
        },
        curItem.linkText ? curItem.linkText : curItem.linkUrl
      ) : '';
      var readLess = _utils.TranslationUtil ? _utils.TranslationUtil.getByKey('Gallery_Read_Less') : 'read_less';
      var readMore = _utils.TranslationUtil ? _utils.TranslationUtil.getByKey('Gallery_Read_More') : 'read_more';
      var readMoreText = isReadMoreOpen ? readLess : readMore;
      var readMoreOrLess = isReadMoreVisible ? _react2.default.createElement(
        'div',
        { className: 'read-more fullscreen-side-bar-description', onClick: function onClick() {
            return _this2.toggleReadMore();
          } },
        readMoreText
      ) : null;

      var sideBarSocial = this.props.styleParams.allowSocial && !isStoreGallery ? _react2.default.createElement(
        'div',
        { className: 'fullscreen-side-bar-social',
          style: this.props.styleParams.galleryAlignExpandIcons
        },
        _react2.default.createElement(
          'div',
          { className: 'fullscreen-social-share-box open' },
          _react2.default.createElement(_fullscreenShareButtons2.default, { item: curItem })
        )
      ) : '';

      var separator = isStoreGallery ? null : _react2.default.createElement('div', { className: 'fullscreen-side-bar-separator' });

      var shopFrame = null;
      var isInSettings = _utils.utils.isInSettings();

      if (this.props.showShopFrame && isImage) {
        try {
          var galleryId = this.props.galleryId;
          shopFrame = _react2.default.createElement(_fullscreenShop2.default, {
            ref: function ref(element) {
              return _this2.shopElement = element;
            },
            item: curItem,
            styleParams: this.props.styleParams,
            additionalParams: _.merge({}, curItem.getDataForShop(), { galleryId: galleryId }),
            locale: isInSettings ? 'en' : window.siteLocale,
            actions: this.props.actions,
            deviceType: isInSettings ? 'desktop' : _utils.utils.getDeviceType(),
            viewMode: isInSettings ? 'editor' : Wix.Utils.getViewMode(),
            onSetMobileData: function onSetMobileData(type, data) {
              return _this2.handleSetMobileData(type, data);
            },
            connectedProviders: this.props.connectedProviders
          });
        } catch (error) {}
      }
      //mobileViewTypes
      //this.state.providerView
      var shopButtons = null;
      var shouldShowShopButtons = isStoreGallery && !isMobile && isImage;
      if (shouldShowShopButtons) {
        var providerView = this.props.providerView;
        var shouldShowAddToCartButton = providerView && providerView.type === _mobileViewTypes2.default.singleProduct;

        shopButtons = _react2.default.createElement(
          'div',
          null,
          shouldShowAddToCartButton ? _react2.default.createElement(_fullscreenCartButton2.default, { cartItems: this.props.cartItems, onAddToCartRequest: function onAddToCartRequest() {
              return _this2.props.onAddToCartRequest();
            }, isSettings: this.props.isSettings, styleParams: this.props.styleParams }) : null,
          _react2.default.createElement(_fullscreenCheckoutLink2.default, { cartItems: this.props.cartItems, onClick: function onClick() {
              Wix.PubSub.publish(_consts.storePubSub.checkout, {}, false);
            } })
        );
      }

      var infoContainerClassName = "fullscreen-side-bar-info-container";
      infoContainerClassName += isStoreGallery ? ' store' : '';
      // infoContainerClassName += (isSmallScreen ? '' : ' mCustomScrollbar custom-scroller');
      infoContainerClassName += isStoreGallery ? isSmallScreen ? '' : ' custom-scroller' : '';

      return _react2.default.createElement(
        'div',
        {
          className: "fullscreen-side-bar" + (this.isVisible() ? ' opened' : ' closed') + (isSmallScreen ? ' mobile' : '') + (isStoreGallery ? ' store' : ''),
          style: { textAlign: this.props.styleParams.galleryAlignExpand } },
        _react2.default.createElement(
          'div',
          { className: infoContainerClassName },
          _react2.default.createElement(
            'div',
            { ref: function ref(itemContainer) {
                _this2.itemContainer = itemContainer;
              } },
            title,
            description
          ),
          prettyExif,
          link,
          readMoreOrLess,
          _proGalleryVersionManager.versionManager.useFullscreenNewSidebar() ? false : separator,
          _proGalleryVersionManager.versionManager.useFullscreenNewSidebar() ? false : sideBarSocial,
          shopFrame
        ),
        shopButtons
      );
    }
  }]);

  return FullscreenSidebar;
}(_react2.default.Component);

exports.default = FullscreenSidebar;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _consts = __webpack_require__(11);

var _ProviderIntent = __webpack_require__(107);

var _ProviderIntent2 = _interopRequireDefault(_ProviderIntent);

var _cartApi = __webpack_require__(26);

var _cartApi2 = _interopRequireDefault(_cartApi);

var _providerEvents = __webpack_require__(65);

var _providerEvents2 = _interopRequireDefault(_providerEvents);

var _mobileViewTypes = __webpack_require__(137);

var _mobileViewTypes2 = _interopRequireDefault(_mobileViewTypes);

var _storeApi = __webpack_require__(58);

var _storeApi2 = _interopRequireDefault(_storeApi);

var _utils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FullScreenShop = function (_Component) {
  _inherits(FullScreenShop, _Component);

  function FullScreenShop(props) {
    _classCallCheck(this, FullScreenShop);

    var _this = _possibleConstructorReturn(this, (FullScreenShop.__proto__ || Object.getPrototypeOf(FullScreenShop)).call(this, props));

    _this.state = {
      height: 0

      // The cart icon may not be there.. so we need to ensure it's created in the fullscreen
    };_cartApi2.default.createCartForm();
    return _this;
  }

  _createClass(FullScreenShop, [{
    key: 'postShopRequest',
    value: function postShopRequest(type, data) {
      if (this.shopIntent) {
        this.shopIntent.postMessage(type, data);
      }
    }
  }, {
    key: 'addToCartRequest',
    value: function addToCartRequest() {
      if (this.shopIntent) {
        this.shopIntent.postMessage(_providerEvents2.default.addToCartRequest, {});
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      var item = nextProps.item;
      if (item) {
        if (this.shopIntent) {
          if (this.props.item && this.props.item.id !== item.id) {
            this.shopIntent.postMessage(_providerEvents2.default.itemChanged, item.getDataForShop());
          }
        }
      }
    }
  }, {
    key: 'messageReceived',
    value: function messageReceived(type, payload, resolve, reject, providerId) {
      var _props$additionalPara = this.props.additionalParams,
          galleryId = _props$additionalPara.galleryId,
          imageUrl = _props$additionalPara.imageUrl,
          isDemo = _props$additionalPara.isDemo;

      isDemo = !!isDemo;
      switch (type) {
        case _providerEvents2.default.addToCart:
          var uuid = payload.uuid,
              quantity = payload.quantity,
              metadata = payload.metadata;

          _cartApi2.default.addToCart(uuid, imageUrl, galleryId, providerId, quantity, isDemo, metadata).then(function () {
            resolve();
            _cartApi2.default.showCart();
          });
          break;
        case _providerEvents2.default.setHeight:
          this.setState(payload);
          break;
        case _providerEvents2.default.close:
          _utils.utils.isMobile() ? this.props.actions.toggleMobileShopFrame() : null;
          break;
        case _providerEvents2.default.setMobileProductData:
          this.props.onSetMobileData(payload.type, payload.data);
          break;
        case _providerEvents2.default.setDefaultPrice:
          var priceData = payload;
          this.props.onSetMobileData(_mobileViewTypes2.default.singleProduct, priceData);
          break;
        case _providerEvents2.default.openModal:
          var name = payload.name,
              options = payload.options;

          _storeApi2.default.openProviderModal(name, options, { galleryId: galleryId, imageUrl: imageUrl, isDemo: isDemo }).then(resolve).catch(reject);
          break;
        default:
          break;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var height = this.state.height;
      var connectedProviders = this.props.connectedProviders;


      var renderComponent = connectedProviders ? _react2.default.createElement(
        'div',
        { className: 'full-screen-shop', style: { height: height + 'px' } },
        _react2.default.createElement(_ProviderIntent2.default, _extends({
          ref: function ref(r) {
            return _this2.shopIntent = r;
          },
          intent: _consts.providerIntents.shop,
          tabIndex: _utils.utils.getTabIndex('fullscreenProvider'),
          onMessageReceived: function onMessageReceived(type, payload, resolve, reject, providerId) {
            _this2.messageReceived(type, payload, resolve, reject, providerId);
          }
        }, this.props, {
          connectedProviders: connectedProviders
        }))
      ) : null;
      return renderComponent;
    }
  }]);

  return FullScreenShop;
}(_react.Component);

exports.default = FullScreenShop;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _fullscreenProviderLicense = __webpack_require__(231);

var _fullscreenProviderLicense2 = _interopRequireDefault(_fullscreenProviderLicense);

var _fullscreenCartButton = __webpack_require__(153);

var _fullscreenCartButton2 = _interopRequireDefault(_fullscreenCartButton);

var _fullscreenCheckoutLink = __webpack_require__(154);

var _fullscreenCheckoutLink2 = _interopRequireDefault(_fullscreenCheckoutLink);

var _loveButton = __webpack_require__(67);

var _loveButton2 = _interopRequireDefault(_loveButton);

var _fullscreenSocialDownload = __webpack_require__(102);

var _fullscreenSocialDownload2 = _interopRequireDefault(_fullscreenSocialDownload);

var _fullscreenShareButtons = __webpack_require__(93);

var _fullscreenShareButtons2 = _interopRequireDefault(_fullscreenShareButtons);

var _consts = __webpack_require__(11);

var _mobileViewTypes = __webpack_require__(137);

var _mobileViewTypes2 = _interopRequireDefault(_mobileViewTypes);

var _ProductsList = __webpack_require__(234);

var _ProductsList2 = _interopRequireDefault(_ProductsList);

var _utils = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var storeComponentPosition = {
  top: 1,
  bottom: 2
};

var FullscreenStoreBottomMobileBar = function (_React$Component) {
  _inherits(FullscreenStoreBottomMobileBar, _React$Component);

  function FullscreenStoreBottomMobileBar(props) {
    _classCallCheck(this, FullscreenStoreBottomMobileBar);

    var _this = _possibleConstructorReturn(this, (FullscreenStoreBottomMobileBar.__proto__ || Object.getPrototypeOf(FullscreenStoreBottomMobileBar)).call(this, props));

    _this.state = {
      isStoreGallery: _utils.utils.isStoreGallery(),
      isSmallScreen: _utils.utils.isSmallScreen()
    };
    return _this;
  }

  _createClass(FullscreenStoreBottomMobileBar, [{
    key: 'handleProviderAction',
    value: function handleProviderAction(type, data) {
      if (this.props.onProviderAction) {
        this.props.onProviderAction(type, data);
      }
    }
  }, {
    key: 'getStoreComponent',
    value: function getStoreComponent(_ref) {
      var _this2 = this;

      var type = _ref.type,
          data = _ref.data;

      var storeComponentData = { component: null, position: storeComponentPosition.top };

      switch (type) {
        case _mobileViewTypes2.default.singleProduct:
          storeComponentData.component = _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_fullscreenProviderLicense2.default, { actions: this.props.actions, pricingData: data }),
            _react2.default.createElement(_fullscreenCartButton2.default, { cartItems: this.props.cartItems, onAddToCartRequest: function onAddToCartRequest() {
                return _this2.props.onAddToCartRequest();
              }, styleParams: this.props.styleParams })
          );
          break;
        case _mobileViewTypes2.default.productsList:
          storeComponentData.position = storeComponentPosition.bottom;
          storeComponentData.component = _react2.default.createElement(_ProductsList2.default, {
            data: data,
            onProviderAction: function onProviderAction(type, data) {
              return _this2.handleProviderAction(type, data);
            }
          });
          break;
        default:
          storeComponentData.component = _react2.default.createElement(
            'div',
            null,
            'Loading...'
          );
          break;
      }

      return storeComponentData;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var curItem = this.props.current.item;
      var isImage = curItem.type == ('image' || 'picture');
      var _state = this.state,
          isStoreGallery = _state.isStoreGallery,
          isSmallScreen = _state.isSmallScreen;
      var providerView = this.props.providerView;

      var selectedLicense = null,
          shopButtons = null;

      if (isImage) {
        selectedLicense = this.getStoreComponent(providerView || {});
        shopButtons = _react2.default.createElement(_fullscreenCheckoutLink2.default, { cartItems: this.props.cartItems, onClick: function onClick() {
            Wix.PubSub.publish(_consts.storePubSub.checkout, {}, false);
          } });
      }

      var titleText = curItem.title || curItem.fileName || ''; //(curItem.isDemo ? curItem.demoTitle : ''); - remove default text from demo items until rewritten
      var title = titleText && this.props.styleParams.allowTitleExpand ? _react2.default.createElement(
        'div',
        { className: 'fullscreen-side-bar-title' },
        titleText
      ) : '';

      var descriptionText = curItem.description || ''; //(curItem.isDemo ? curItem.demoDescription : ''); - remove default text from demo items until rewritten
      var descriptionTextArray = descriptionText.split('\n');
      var description;
      if (descriptionText && this.props.styleParams.allowDescriptionExpand) {
        var descriptionElementsArray = [];
        for (var i = 0; i < descriptionTextArray.length; i++) {
          descriptionElementsArray.push(_react2.default.createElement(
            'div',
            { className: 'fullscreen-side-bar-description-line', key: "description_" + i },
            descriptionTextArray[i]
          ));
        }

        description = _react2.default.createElement(
          'div',
          { className: 'fullscreen-side-bar-description' },
          descriptionElementsArray
        );
      } else {
        description = '';
      }

      var linkClassNames = "fullscreen-side-bar-link link" + (isStoreGallery ? ' store' : '');
      var link = curItem.linkUrl && this.props.styleParams.allowLinkExpand ? curItem.linkType === 'web' ? _react2.default.createElement(
        'a',
        { className: linkClassNames,
          href: curItem.linkUrl,
          target: curItem.linkOpenType },
        curItem.linkText ? curItem.linkText : curItem.linkUrl
      ) : _react2.default.createElement(
        'div',
        {
          className: linkClassNames,
          onClick: function onClick() {
            return _this3.props.actions.navigateToPageByItemLink(curItem);
          } },
        curItem.linkText ? curItem.linkText : curItem.linkUrl
      ) : '';

      var shouldRenderSelectedLicenseOnTop = selectedLicense && selectedLicense.position === storeComponentPosition.top;
      var shouldRenderSelectedLicenseOnBottom = selectedLicense && selectedLicense.position === storeComponentPosition.bottom;

      return _react2.default.createElement(
        'div',
        {
          className: "fullscreen-bottom-mobile-info" + (isStoreGallery ? ' store' : ''),
          style: { textAlign: this.props.styleParams.galleryAlignExpand } },
        shouldRenderSelectedLicenseOnTop ? selectedLicense.component : null,
        shopButtons,
        _react2.default.createElement(
          'div',
          { className: "fullscreen-side-bar-info-container" + (isStoreGallery ? ' store' : '') },
          _react2.default.createElement(
            'div',
            { ref: function ref(itemContainer) {
                _this3.itemContainer = itemContainer;
              } },
            title,
            description
          ),
          link
        ),
        shouldRenderSelectedLicenseOnBottom ? selectedLicense.component : null
      );
    }
  }]);

  return FullscreenStoreBottomMobileBar;
}(_react2.default.Component);

exports.default = FullscreenStoreBottomMobileBar;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _providerMessenger = __webpack_require__(232);

var providerMessenger = _interopRequireWildcard(_providerMessenger);

var _rightArrow = __webpack_require__(233);

var _rightArrow2 = _interopRequireDefault(_rightArrow);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FullscreenProviderLicense = function (_React$Component) {
  _inherits(FullscreenProviderLicense, _React$Component);

  function FullscreenProviderLicense(props) {
    _classCallCheck(this, FullscreenProviderLicense);

    var _this = _possibleConstructorReturn(this, (FullscreenProviderLicense.__proto__ || Object.getPrototypeOf(FullscreenProviderLicense)).call(this, props));

    _this.state = {
      selected: null
    };
    return _this;
  }

  _createClass(FullscreenProviderLicense, [{
    key: 'onProviderLoaded',
    value: function onProviderLoaded(loadedData) {
      this.setState(loadedData);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var selected = null;
      if (this.state.selected) {
        selected = this.state.selected;
      } else if (this.props.pricingData) {
        selected = this.props.pricingData.selected;
      }
      return selected ? _react2.default.createElement(
        'div',
        { className: 'selected-license', onClick: function onClick() {
            _this2.props.actions.toggleMobileShopFrame();
          } },
        _react2.default.createElement(
          'div',
          { className: 'license-price' },
          selected.price
        ),
        _react2.default.createElement(_rightArrow2.default, { className: 'show-shop-frame' }),
        _react2.default.createElement(
          'div',
          { className: 'license-title' },
          selected.title
        )
      ) : null;
    }
  }]);

  return FullscreenProviderLicense;
}(_react2.default.Component);

exports.default = FullscreenProviderLicense;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RightArrow;
function RightArrow(_ref) {
  var className = _ref.className;

  return React.createElement(
    "svg",
    { className: className, width: "11", height: "17", viewBox: "0 0 11 17", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M1.485 0l8.486 8.485-8.486 8.486", stroke: "currentColor", fill: "none", fillRule: "evenodd" })
  );
}

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(27);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _providerEvents = __webpack_require__(65);

var _providerEvents2 = _interopRequireDefault(_providerEvents);

var _arrow = __webpack_require__(235);

var _arrow2 = _interopRequireDefault(_arrow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductsList = function ProductsList(props) {
  var data = props.data,
      onProviderAction = props.onProviderAction;


  return _react2.default.createElement(
    'div',
    {
      onClick: function onClick(e) {
        var node = e.target;
        var attr = null;
        var i = 5;
        do {
          if (node && node.getAttribute) {
            attr = node.getAttribute('data-index');
          }
          i--; // Prevent infinit loop
          node = node.parentNode;
        } while (node && !attr && i !== 0);
        var index = parseInt(attr);
        var item = data[index];
        onProviderAction(_providerEvents2.default.mobileItemClicked, item.dataKey);
      },
      className: 'products-list-container'
    },
    _react2.default.createElement(
      'div',
      { className: 'table-column image-column' },
      data.map(function (item, index) {
        return _react2.default.createElement(
          'div',
          { 'data-index': index, className: 'table-cell table-image-container' },
          _react2.default.createElement('img', { className: 'table-image', src: item.imageSrc })
        );
      })
    ),
    _react2.default.createElement(
      'div',
      { className: 'table-column devider-column' },
      data.map(function (item, index) {
        return _react2.default.createElement('div', { 'data-index': index, className: 'table-cell' });
      })
    ),
    _react2.default.createElement(
      'div',
      { className: 'table-column title-column' },
      data.map(function (item, index) {
        return _react2.default.createElement(
          'div',
          { 'data-index': index, className: 'table-cell' },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'span',
              { className: 'title' },
              item.title
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'span',
              { className: 'description' },
              item.subTitle
            )
          )
        );
      })
    ),
    _react2.default.createElement(
      'div',
      { className: 'table-column arrow-column' },
      data.map(function (item, index) {
        return _react2.default.createElement(
          'div',
          { 'data-index': index, className: 'table-cell' },
          _react2.default.createElement(
            'div',
            { className: 'arrow-container' },
            (0, _arrow2.default)({ width: '10', height: '16', viewBox: '0 0 10 16' })
          )
        );
      })
    )
  );
};

ProductsList.propTypes = {};

exports.default = ProductsList;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","fillRule":"evenodd","stroke":"#2F2E2E","strokeWidth":"1.5","d":"M1.071 1l7.071 7.071-7.07 7.071"}));
}

Arrow.displayName = "Arrow";

Arrow.defaultProps = {"width":"10","height":"16","viewBox":"0 0 10 16"};

module.exports = Arrow;

Arrow.default = Arrow;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _fullscreenShareButtons = __webpack_require__(93);

var _fullscreenShareButtons2 = _interopRequireDefault(_fullscreenShareButtons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FullscreenShareScreen = function (_React$Component) {
  _inherits(FullscreenShareScreen, _React$Component);

  function FullscreenShareScreen(props) {
    _classCallCheck(this, FullscreenShareScreen);

    return _possibleConstructorReturn(this, (FullscreenShareScreen.__proto__ || Object.getPrototypeOf(FullscreenShareScreen)).call(this, props));
  }

  _createClass(FullscreenShareScreen, [{
    key: 'onScroll',
    value: function onScroll(e) {
      e.stopPropagation();
    }
  }, {
    key: 'preventScroll',
    value: function preventScroll(el) {
      el.addEventListener('scroll', this.onScroll.bind(this));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var curItem = this.props.current.item;
      var share = _react2.default.createElement(_fullscreenShareButtons2.default, { item: this.props.current.item });

      return _react2.default.createElement(
        'div',
        {
          ref: function ref(element) {
            if (element) {
              _this2.preventScroll(element);
            }
          },
          className: "fullscreen-share-screen" + (this.props.showShareScreen == true ? '' : ' closed'),
          style: { textAlign: this.props.styleParams.galleryAlignExpand } },
        share
      );
    }
  }]);

  return FullscreenShareScreen;
}(_react2.default.Component);

exports.default = FullscreenShareScreen;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DataItem = function () {
  function DataItem() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

    _classCallCheck(this, DataItem);

    this.data = data;
  }

  _createClass(DataItem, [{
    key: 'isActive',
    value: function isActive() {
      return true;
    }
  }, {
    key: 'export',
    value: function _export() {
      return this.data;
    }
  }]);

  return DataItem;
}();

exports.default = DataItem;

/***/ }),
/* 238 */,
/* 239 */,
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GalleryContainer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(29);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__(97);

var _redux = __webpack_require__(62);

var _galleryActions = __webpack_require__(140);

var actions = _interopRequireWildcard(_galleryActions);

var _galleryView = __webpack_require__(241);

var _galleryView2 = _interopRequireDefault(_galleryView);

var _slideshowView = __webpack_require__(255);

var _slideshowView2 = _interopRequireDefault(_slideshowView);

var _galleryLayout = __webpack_require__(174);

var _galleryLayout2 = _interopRequireDefault(_galleryLayout);

var _itemLayout = __webpack_require__(110);

var _itemLayout2 = _interopRequireDefault(_itemLayout);

var _fullscreenContainer = __webpack_require__(212);

var _fullscreenContainer2 = _interopRequireDefault(_fullscreenContainer);

var _consts = __webpack_require__(106);

var _consts2 = _interopRequireDefault(_consts);

var _watermarkApi = __webpack_require__(12);

var _watermarkApi2 = _interopRequireDefault(_watermarkApi);

var _lodash = __webpack_require__(4);

var _lodash2 = _interopRequireDefault(_lodash);

var _utils = __webpack_require__(2);

var _videoQueue = __webpack_require__(141);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var adiLoadMoreMaxHeight = 2000;
window.itemActions = _utils.itemActions; //itemActions must be saved on the window because the specific instance of each gallery's itemActions is accessed from other frames

var GalleryContainer = exports.GalleryContainer = function (_React$Component) {
  _inherits(GalleryContainer, _React$Component);

  function GalleryContainer(props, context) {
    _classCallCheck(this, GalleryContainer);

    var _this = _possibleConstructorReturn(this, (GalleryContainer.__proto__ || Object.getPrototypeOf(GalleryContainer)).call(this, props, context));

    _this.closeFullscreenCallback = _this.closeFullscreenCallback.bind(_this);
    _this.toggleInfiniteScroll = _this.toggleInfiniteScroll.bind(_this);
    _this.toggleFullscreen = _this.toggleFullscreen.bind(_this);
    _this.pauseAllVideos = _this.pauseAllVideos.bind(_this);
    _this.getGalleryScroll = _this.getGalleryScroll.bind(_this);
    _this.setWixHeight = _this.setWixHeight.bind(_this);
    _this.scrollToItem = _this.scrollToItem.bind(_this);
    _this.addItemToMultishare = _this.addItemToMultishare.bind(_this);
    _this.removeItemFromMultishare = _this.removeItemFromMultishare.bind(_this);
    _this.updateMultishareItems = _this.updateMultishareItems.bind(_this);

    _this.reRenderForHorizontalScroll = _this.reRenderForHorizontalScroll.bind(_this);
    _this.reRenderForScroll = _this.reRenderForScroll.bind(_this);
    _this.reRenderForStyles = _this.reRenderForStyles.bind(_this);
    _this.reRenderForSettings = _this.reRenderForSettings.bind(_this);
    _this.reRenderForResize = _this.reRenderForResize.bind(_this);
    _this.reRenderForOrientation = _this.reRenderForOrientation.bind(_this);
    _this.reRenderForEditMode = _this.reRenderForEditMode.bind(_this);
    _this.onResizeEvent = _this.onResizeEvent.bind(_this);

    if (_utils.utils.isDev() && !_utils.utils.isTest()) {
      try {
        switch (_utils.utils.safeLocalStorage()['scrollThrottleMode']) {
          case 'throttle250':
            _this.reRenderForScroll = _lodash2.default.throttle(_this.reRenderForScroll, 250);
            _this.reRenderForHorizontalScroll = _lodash2.default.throttle(_this.reRenderForHorizontalScroll, 250);
            break;
          case 'throttle500':
          default:
            _this.reRenderForScroll = _lodash2.default.throttle(_this.reRenderForScroll, 500);
            _this.reRenderForHorizontalScroll = _lodash2.default.throttle(_this.reRenderForHorizontalScroll, 500);
            break;
          case 'throttle1000':
            _this.reRenderForScroll = _lodash2.default.throttle(_this.reRenderForScroll, 1000);
            _this.reRenderForHorizontalScroll = _lodash2.default.throttle(_this.reRenderForHorizontalScroll, 1000);
            break;
          case 'debounce100':
            _this.reRenderForScroll = _lodash2.default.debounce(_this.reRenderForScroll, 100);
            _this.reRenderForHorizontalScroll = _lodash2.default.debounce(_this.reRenderForHorizontalScroll, 100);
            break;
          case 'debounce300':
            _this.reRenderForScroll = _lodash2.default.debounce(_this.reRenderForScroll, 300);
            _this.reRenderForHorizontalScroll = _lodash2.default.debounce(_this.reRenderForHorizontalScroll, 300);
            break;
          case 'debounce500':
            _this.reRenderForScroll = _lodash2.default.debounce(_this.reRenderForScroll, 500);
            _this.reRenderForHorizontalScroll = _lodash2.default.debounce(_this.reRenderForHorizontalScroll, 500);
            break;
          case 'none':
            break;
        }
      } catch (e) {
        //
      }
    }

    _this.renderTriggers = {
      SCROLL: 'Scroll',
      STYLES: 'Styles',
      ITEMS: 'Items',
      RESIZE: 'Resize',
      ORIENTATION: 'Orientation',
      MODE: 'Mode',
      NONE: 'None',
      LAYOUT: 'Layout',
      ALL: 'All'
    };

    _this.lastHeight = 0;
    _this.newHeight = 0;
    _this.resizeCount = 0;
    _this.orientationCount = 0;
    _this.scrollBase = 0;

    _this.thumbnailSize = _utils.utils.isMobile() ? 90 : 120;
    _this.slideshowInfoSize = 220;

    _this.init();

    _this.defaultStateStyles = {
      gotStyleParams: false,
      galleryLayout: _utils.utils.isStoreGallery() ? 2 : 0,
      selectedLayout: 0,
      isVertical: false,
      gallerySize: 320,
      minItemSize: 120,
      groupSize: 3,
      chooseBestGroup: true,
      groupTypes: '1,2h,2v,3t,3b,3l,3r',
      cubeImages: false,
      cubeType: 'fill',
      smartCrop: false,
      fullscreen: true,
      allowSocial: true,
      allowDownload: false,
      allowTitle: true,
      allowDescription: false,
      allowMultishare: false,
      loveButton: true,
      loveCounter: true,
      videoLoop: true,
      videoSpeed: 1,
      videoPlay: 'hover',
      gallerySliderImageRatio: 0,
      galleryImageRatio: 2,
      sharpParams: {
        quality: 90,
        usm: {} // do not apply usm - {usm_r: 0.66, usm_a: 1.00, usm_t: 0.01},
      },
      collageAmount: 0.8,
      collageDensity: 0.8,
      imageMargin: 5,
      viewMode: 'preview',
      galleryHorizontalAlign: 'center',
      galleryTextAlign: 'center',
      galleryVerticalAlign: 'center',
      enableInfiniteScroll: 1,
      itemClick: 'expand',
      cubeRatio: 1, //determine the ratio of the images when using grid (use 1 for squares grid)
      fixedColumns: 0, //determine the number of columns regardless of the screen size (use 0 to ignore)
      oneRow: false, //render the gallery as a single row with horizontal scroll
      showArrows: false,
      isSlideshow: false,
      hasThumbnails: false,
      galleryThumbnailsAlignment: 'bottom',
      thumbnailSpacings: 0,
      gridStyle: 0,
      useCustomButton: _utils.utils.isStoreGallery()
    };

    var galleryWidth = void 0;

    if (_utils.utils.isSemiNative()) {
      galleryWidth = _this.getGalleryWidth();
    } else {
      galleryWidth = _this.protectGalleryWidth(document.body.clientWidth);
    }

    _this.state = {
      items: _this.props.items,
      renderedItemsCount: _this.props.renderedItemsCount || _this.props.items.length,
      totalItemsCount: _this.props.totalItemsCount || _this.props.items.length,
      galleryLayout: {},
      scroll: {
        isInfinite: _this.isInfiniteScroll(),
        base: _this.scrollBase || 0,
        top: _this.currentScrollPosition || 0
      },
      container: {
        maxGalleryWidth: _this.props.maxGalleryWidth,
        galleryWidth: galleryWidth,
        galleryHeight: _this.getGalleryHeight(),
        viewMode: 'site',
        bounds: {
          visibleTop: 0,
          visibleBottom: 1000,
          renderedTop: 0,
          renderedBottom: 3000
        }
      },
      styleParams: _lodash2.default.clone(_this.defaultStateStyles),
      hashtag: {
        filter: _utils.utils.getWorkerWindow()['pro-gallery-hashtag-filter'] || '',
        items: []
      },
      multishare: {
        items: [],
        isMultisharing: _this.props.defaultSelectMode === true
      }
    };
    return _this;
  }

  _createClass(GalleryContainer, [{
    key: 'getGalleryWidth',
    value: function getGalleryWidth() {
      return _utils.utils.isSemiNative() ? this.props.layout.width : window.innerWidth;
    }
  }, {
    key: 'getGalleryHeight',
    value: function getGalleryHeight() {
      return _utils.utils.isSemiNative() ? this.props.layout.height : window.innerHeight;
    }
  }, {
    key: 'getGalleryRatio',
    value: function getGalleryRatio() {
      return _utils.utils.isSemiNative() ? this.props.layout.width / this.props.layout.height : window.innerWidth / window.innerHeight;
    }
  }, {
    key: 'initVideoQueue',
    value: function initVideoQueue() {
      window.videoQueue = window.videoQueue || new _videoQueue.VideoQueue();
    }
    //-------------------------------------------| INIT |--------------------------------------------//

  }, {
    key: 'init',
    value: function init() {
      var _this2 = this;

      this.initVideoQueue();
      this.initWatermark();
      this.currentScrollPosition = 0;
      this.compId = _utils.utils.isSemiNative() ? 'compId' : Wix.Utils.getCompId();
      this.galleryId = window.galleryId;
      this.currentWindowWidth = window.innerWidth;
      this.currentWindowHeight = window.innerHeight;

      if (!_utils.utils.isSemiNative()) {
        Wix.getCurrentPageId(function (res) {
          _this2.pageId = res;
          Wix.Styles.getStyleId(function (res) {
            _this2.styleId = res;
            Wix.Utils.getSectionUrl({ sectionId: _utils.utils.getFullscreenSectionId() }, function (res) {
              _this2.fullscreenUrl = res.url;
              _this2.setState({
                itemActionsInit: _utils.itemActions.initWidgetData({
                  compId: _this2.compId,
                  pageId: _this2.pageId,
                  styleId: _this2.styleId,
                  galleryId: _this2.galleryId,
                  fullscreenUrl: _this2.fullscreenUrl
                })
              });
            });
          });
        });

        Wix.getBoundingRectAndOffsets(function (rect) {
          _this2.scrollBase = rect.offsets.y * rect.scale;
          if (rect && rect.rect && !_lodash2.default.isUndefined(rect.rect.width)) {
            _this2.maxGalleryWidth = _lodash2.default.get(rect, 'rect.width') || 0;
          }
        });
      }

      this.initEventsFunction();
    }
  }, {
    key: 'initEventsFunction',
    value: function initEventsFunction() {
      this.windowEventsFunctions = [];
      this.wixEventsFunctions = [];
      this.pubsubFunctions = [];

      if (_utils.utils.isInWix()) {
        this.wixEventsFunctions.push([Wix.Events.STYLE_PARAMS_CHANGE, this.reRenderForStyles]);
        this.wixEventsFunctions.push([Wix.Events.SETTINGS_UPDATED, this.reRenderForSettings]);
        this.wixEventsFunctions.push([Wix.Events.EDIT_MODE_CHANGE, this.reRenderForEditMode]);
        this.wixEventsFunctions.push([Wix.Events.SCROLL, this.reRenderForScroll]);
        this.pubsubFunctions.push(['multishare2gallery', this.updateMultishareItems]);
      } else {
        this.windowEventsFunctions.push(['scroll', this.reRenderForScroll]);
      }
      //global events
      this.windowEventsFunctions.push(['resize', this.onResizeEvent]);
      this.windowEventsFunctions.push(['orientationchange', this.reRenderForOrientation]);

      // MUST be 'CustomEvent'
      if (_utils.utils.isSemiNative()) {
        this.onItemClickEvent = new window.CustomEvent('on_item_click');
      } else {
        this.onItemClickEvent = document.createEvent('CustomEvent');
        this.onItemClickEvent.initCustomEvent('on_item_click', false, false, null);
      }
    }
  }, {
    key: 'initEventListeners',
    value: function initEventListeners() {
      if (!_utils.utils.isInWix() && !_utils.utils.isSemiNative()) {
        $(window).on('beforeunload', function () {
          $(window).scrollTop(0);
        });
      }

      this.windowEventsFunctions.forEach(function (x) {
        var _window;

        return (_window = window).addEventListener.apply(_window, _toConsumableArray(x));
      });
      if (!_utils.utils.isSemiNative()) {
        this.pubsubFunctions.forEach(function (x) {
          var _Wix$PubSub;

          return (_Wix$PubSub = Wix.PubSub).subscribe.apply(_Wix$PubSub, _toConsumableArray(x));
        });
        this.wixEventsFunctions.forEach(function (x) {
          var _Wix;

          return (_Wix = Wix).addEventListener.apply(_Wix, _toConsumableArray(x));
        });
      }

      document.addEventListener('scroll', this.reRenderForHorizontalScroll, true);
    }
  }, {
    key: 'removeEventListeners',
    value: function removeEventListeners() {
      this.wixEventsFunctions.forEach(function (x) {
        var _Wix2;

        return (_Wix2 = Wix).removeEventListener.apply(_Wix2, _toConsumableArray(x));
      });
      this.windowEventsFunctions.forEach(function (x) {
        var _window2;

        return (_window2 = window).removeEventListener.apply(_window2, _toConsumableArray(x));
      });
      this.pubsubFunctions.forEach(function (x) {
        var _Wix$PubSub2;

        return (_Wix$PubSub2 = Wix.PubSub).unsubscribe.apply(_Wix$PubSub2, _toConsumableArray(x));
      });

      document.removeEventListener('scroll', this.reRenderForHorizontalScroll, true);
    }
  }, {
    key: 'initNavigationEventListeners',
    value: function initNavigationEventListeners() {
      var _this3 = this;

      if (!_utils.utils.isSemiNative()) {
        Wix.addEventListener(Wix.Events.PAGE_NAVIGATION_IN, function () {
          _this3.initEventListeners();
          _this3.props.actions.navigationIn();
          _utils.itemActions.getStats();
        });
        Wix.addEventListener(Wix.Events.PAGE_NAVIGATION_OUT, function () {
          _this3.removeEventListeners();
          _this3.pauseAllVideos();
        });
      }
    }
  }, {
    key: 'initPersistentEventListeners',
    value: function initPersistentEventListeners() {
      window.addEventListener('fullscreen_closed', this.closeFullscreenCallback);
    }
  }, {
    key: 'initCustomEvents',
    value: function initCustomEvents() {
      if (_utils.utils.isSemiNative()) {
        this.galleryScrollEvent = new window.CustomEvent('gallery_scroll'); // MUST be 'CustomEvent'
        this.pauseAllVideosEvent = new window.CustomEvent('pause_all_videos'); // MUST be 'CustomEvent'
      } else {
        this.galleryScrollEvent = document.createEvent('CustomEvent'); // MUST be 'CustomEvent'
        this.galleryScrollEvent.initCustomEvent('gallery_scroll', false, false, null);

        this.pauseAllVideosEvent = document.createEvent('CustomEvent'); // MUST be 'CustomEvent'
        this.pauseAllVideosEvent.initCustomEvent('pause_all_videos', false, false, null);
      }
    }
  }, {
    key: 'initWatermark',
    value: function initWatermark() {
      var _this4 = this;

      if (_utils.utils.isStoreGallery()) {
        _watermarkApi2.default.getWatermarkData().then(function (data) {
          _this4.setState({ watermark: data }, function () {
            _this4.reRender();
          });
        });
      }
    }
  }, {
    key: 'getStyleBySeed',
    value: function getStyleBySeed(seed) {

      if (!seed > 0) {
        seed = 999999;
      }
      seed = Math.floor(seed);

      var strToSeed = function strToSeed(str) {
        str = String(str);
        var total = 0;
        for (var s = 0; s < str.length; s++) {
          total += str.charCodeAt(s);
        }
        return total;
      };

      var mergeSeeds = function mergeSeeds(s1, s2) {
        return Math.floor((s1 / s2 - Math.floor(s1 / s2)) * 10000000);
      };

      if (_utils.utils.isSite() && _lodash2.default.get(this, 'state.styleParams.gotStyleParams') && !this.props.styleParams) {
        if (_utils.utils.isVerbose()) {
          //todo yoshi
          console.log('already got style params, not fetching again', this.state.styleParams);
        }
        return;
      }

      var numFromSeed = function numFromSeed(min, max, strSeed) {
        var seed2 = strToSeed(strSeed);
        var range = max - min + 1;
        return mergeSeeds(seed, seed2) % range + min;
      };

      var boolFromSeed = function boolFromSeed(strSeed) {
        return !!numFromSeed(0, 1, strSeed);
      };

      var style = {
        cubeImages: boolFromSeed('cubeImages'),
        cubeRatio: numFromSeed(1, 25, 'cubeRatio') / 5,
        isVertical: boolFromSeed('isVertical'),
        gallerySize: numFromSeed(300, 800, 'gallerySize'),
        collageAmount: numFromSeed(5, 10, 'collageAmount') / 10,
        collageDensity: numFromSeed(5, 10, 'collageDensity') / 100,
        groupTypes: ['1'].concat(_lodash2.default.filter('2h,2v,3t,3b,3l,3r,3h,3v'.split(','), function (type, i) {
          return boolFromSeed('groupTypes' + i);
        })),
        oneRow: boolFromSeed('oneRow'),
        imageMargin: numFromSeed(0, 5, 'imageMargin'),
        chooseBestGroup: boolFromSeed('chooseBestGroup'),
        smartCrop: boolFromSeed('smartCrop'),
        showArrows: false,
        cubeType: 'fill',
        hasThumbnails: false,
        enableScroll: true,
        isGrid: false,
        isSlideshow: false,
        isSlider: false,
        isColumns: false,
        cropOnlyFill: false,
        fixedColumns: 0,
        enableInfiniteScroll: 1
      };

      //force adjustments
      if (style.oneRow) {
        style.isVertical = false;
      }
      style.galleryType = style.isVertical ? 'Columns' : 'Strips';
      style.groupSize = parseInt(_lodash2.default.last(style.groupTypes));
      style.groupTypes = style.groupTypes.join(',');
      style.minItemSize = style.gallerySize / style.groupSize / 2;

      if (_utils.utils.isVerbose()) {
        //todo yoshi
        console.log("Created magic layout style", seed, style);
      }

      return style;
    }
  }, {
    key: 'getStyleByGalleryType',
    value: function getStyleByGalleryType(galleryType, gallerySize) {
      //legacy layouts

      var galleryTypes = {
        collage_ver: {
          cubeImages: false,
          isVertical: true,
          galleryType: 'Columns',
          groupSize: 3,
          groupTypes: '1,2h,2v,3t,3b,3l,3r',
          gallerySize: Math.round(gallerySize * 5 + 500),
          fixedColumns: 0
        },
        collage_hor: {
          cubeImages: false,
          isVertical: false,
          galleryType: 'Strips',
          groupSize: 3,
          groupTypes: '1,2h,2v,3t,3b,3l,3r',
          gallerySize: Math.round(gallerySize * 5 + 500),
          fixedColumns: 0
        },
        grid: {
          cubeImages: true,
          isVertical: true,
          galleryType: 'Columns',
          groupSize: 1,
          groupTypes: '1',
          gallerySize: Math.round(gallerySize * 8.5 + 150),
          fixedColumns: 0,
          isGrid: true
        },
        masonry_ver: {
          cubeImages: false,
          isVertical: true,
          galleryType: 'Columns',
          groupSize: 1,
          groupTypes: '1',
          gallerySize: Math.round(gallerySize * 8 + 200),
          fixedColumns: 0
        },
        masonry_hor: {
          cubeImages: false,
          isVertical: false,
          galleryType: 'Strips',
          groupSize: 1,
          groupTypes: '1',
          gallerySize: Math.round(gallerySize * 5 + 200),
          fixedColumns: 0
        },
        one_col: {
          cubeImages: false,
          isVertical: true,
          galleryType: 'Columns',
          groupSize: 1,
          groupTypes: '1',
          gallerySize: this.getGalleryWidth(),
          fixedColumns: 1
        },
        one_row: {
          cubeImages: false,
          isVertical: false,
          galleryType: 'Strips',
          groupSize: 1,
          groupTypes: '1',
          gallerySize: this.getGalleryHeight(),
          fixedColumns: 0
        },
        slideshow: {
          showArrows: true,
          cubeImages: true,
          cubeRatio: this.getGalleryRatio(),
          isVertical: true,
          gallerySize: this.getGalleryWidth(),
          galleryType: 'Columns',
          groupSize: 1,
          groupTypes: '1',
          fixedColumns: 1
        }
      };

      var styleState = void 0;

      switch (galleryType) {
        case '-1':
          //empty
          styleState = {
            gallerySize: gallerySize
          };
          break;
        case '0':
          //vertical collage
          styleState = galleryTypes['collage_ver'];
          break;
        default:
        case '1':
          //horizontal collage
          styleState = galleryTypes['collage_hor'];
          break;
        case '2':
          //grid
          styleState = galleryTypes['grid'];
          break;
        case '3':
          //vertical masonry
          styleState = galleryTypes['masonry_ver'];
          break;
        case '4':
          //horizontal masonry
          styleState = galleryTypes['masonry_hor'];
          break;
        case '5':
          //one column
          styleState = galleryTypes['one_col'];
          break;
        case '6':
          //one row
          styleState = galleryTypes['one_row'];
          break;
        case '7':
          //slideshow
          styleState = galleryTypes['slideshow'];
          break;
      }

      return styleState;
    }
  }, {
    key: 'getStyleByLayout',
    value: function getStyleByLayout(wixStyles) {
      var _this5 = this;

      //new layouts
      var galleryLayout = wixStyles.galleryLayout,
          gallerySize = wixStyles.gallerySize,
          magicLayoutSeed = wixStyles.magicLayoutSeed;


      var emptyLayout = {
        galleryType: undefined,
        groupSize: undefined,
        showArrows: undefined,
        cubeImages: undefined,
        cubeType: undefined,
        cubeRatio: undefined,
        isVertical: undefined,
        gallerySize: undefined,
        collageAmount: undefined,
        collageDensity: undefined,
        groupTypes: undefined,
        oneRow: undefined,
        imageMargin: undefined,
        chooseBestGroup: undefined,
        smartCrop: undefined,
        hasThumbnails: undefined,
        enableScroll: undefined,
        isGrid: undefined,
        isSlider: undefined,
        isColumns: undefined,
        isSlideshow: undefined,
        cropOnlyFill: undefined,
        fixedColumns: undefined,
        enableInfiniteScroll: undefined
      };

      var layouts = {
        collage: {
          showArrows: false,
          cubeImages: false,
          groupSize: 3,
          groupTypes: '1,2h,2v,3t,3b,3l,3r',
          gallerySize: Math.round(gallerySize * 5 + 500),
          fixedColumns: 0,
          hasThumbnails: false,
          enableScroll: true,
          isGrid: false,
          isSlider: false,
          isColumns: false,
          isSlideshow: false,
          cropOnlyFill: false
        },
        masonry: {
          showArrows: false,
          cubeImages: false,
          groupSize: 1,
          groupTypes: '1',
          gallerySize: gallerySize,
          fixedColumns: 0,
          hasThumbnails: false,
          enableScroll: true,
          isGrid: false,
          isSlider: false,
          isColumns: false,
          isSlideshow: false,
          cropOnlyFill: false,
          oneRow: false
        },
        grid: {
          showArrows: false,
          cubeImages: true,
          smartCrop: false,
          imageResize: false,
          galleryImageRatio: 2,
          numberOfImagesPerRow: 3,
          isVertical: true,
          galleryType: 'Columns',
          groupSize: 1,
          groupTypes: '1',
          fixedColumns: undefined,
          gallerySize: Math.round(gallerySize * 8.5 + 150),
          hasThumbnails: false,
          enableScroll: true,
          cropOnlyFill: false,
          isSlider: false,
          isColumns: false,
          isGrid: true,
          isSlideshow: false,
          minItemSize: 50
        },
        thumbnails: {
          showArrows: true,
          cubeImages: true,
          smartCrop: false,
          cubeType: 'fill',
          cubeRatio: function cubeRatio() {
            var dims = _this5.getGalleryDimensions();
            return dims.galleryWidth / dims.galleryHeight;
          },
          isVertical: false,
          galleryType: 'Strips',
          groupSize: 1,
          gallerySize: this.getGalleryWidth(),
          groupTypes: '1',
          oneRow: true,
          hasThumbnails: true,
          enableScroll: false,
          isGrid: false,
          isSlider: false,
          isColumns: false,
          isSlideshow: false,
          cropOnlyFill: false,
          imageMargin: 0
        },
        slider: {
          showArrows: true,
          cubeImages: true,
          smartCrop: false,
          isVertical: false,
          galleryType: 'Strips',
          groupSize: 1,
          gallerySliderImageRatio: 0,
          groupTypes: '1',
          gallerySize: this.getGalleryHeight(),
          oneRow: true,
          hasThumbnails: false,
          enableScroll: true,
          isGrid: false,
          isSlider: true,
          isColumns: false,
          isSlideshow: false,
          cropOnlyFill: true
        },
        slideshow: {
          showArrows: true,
          cubeImages: true,
          smartCrop: false,
          cubeRatio: function cubeRatio() {
            var dims = _this5.getGalleryDimensions();
            return dims.galleryWidth / dims.galleryHeight;
          },
          cubeType: 'fill',
          isVertical: false,
          gallerySize: 550,
          galleryType: 'Strips',
          groupSize: 1,
          groupTypes: '1',
          fixedColumns: 1,
          oneRow: true,
          hasThumbnails: false,
          enableScroll: false,
          isGrid: false,
          isColumns: false,
          isSlider: false,
          isSlideshow: true,
          cropOnlyFill: false,
          imageMargin: 0
        },
        panorama: {
          showArrows: false,
          cubeImages: false,
          isVertical: true,
          galleryType: 'Columns',
          groupSize: 1,
          groupTypes: '1',
          gallerySize: this.getGalleryWidth(),
          oneRow: false,
          fixedColumns: 1,
          hasThumbnails: false,
          enableScroll: true,
          isGrid: false,
          isColumns: false,
          isSlider: false,
          isSlideshow: false,
          cropOnlyFill: false
        },
        column: {
          showArrows: true,
          cubeImages: true,
          smartCrop: false,
          cubeType: 'fill',
          cubeRatio: 0.35,
          isVertical: false,
          galleryType: 'Strips',
          groupSize: 1,
          groupTypes: '1',
          gallerySize: this.getGalleryHeight(),
          fixedColumns: 0,
          hasThumbnails: false,
          oneRow: true,
          enableScroll: true,
          isGrid: false,
          isColumns: true,
          isSlider: false,
          isSlideshow: false,
          cropOnlyFill: false
        },
        magic: this.getStyleBySeed(magicLayoutSeed)
      };

      var specialMobileStoreConfig = {};
      var isStoreMobile = _utils.utils.isStoreGallery() && _utils.utils.isMobile();
      if (isStoreMobile) {
        galleryLayout = 2;
        specialMobileStoreConfig.forceMobileCustomButton = true;
      }

      var galleyLayoutList = ['collage', 'masonry', 'grid', 'thumbnails', 'slider', 'slideshow', 'panorama', 'column', 'magic'];

      var layoutName = galleyLayoutList[galleryLayout || 0];

      if (_utils.utils.isStoreGallery() && _lodash2.default.isUndefined(galleryLayout)) {
        layoutName = galleyLayoutList[2];
      }

      if (_utils.utils.isVerbose()) {
        //todo yoshi
        console.log('chosen layout is', layoutName);
      }

      return _lodash2.default.merge(emptyLayout, layouts[layoutName], specialMobileStoreConfig);
    }
  }, {
    key: 'getStyleParamsState',
    value: function getStyleParamsState() {
      var wixStyles = {};
      var stateStyles = {};

      function canSet(wixParam, stateParam) {
        // wixStyles    =>  Styles arrived directly from wix
        // stateStyles  =>  The result of the styles format
        // wixParam     =>  The name of the parameter in wixParams
        // stateParam   =>  The name of the parameter in the formatted styles result
        if (_lodash2.default.isUndefined(stateParam)) {
          // the wixParam and stateParam have the same names
          // check that the wixParam is not already set in the stateStyles AND wixStyles have it
          return _lodash2.default.isUndefined(stateStyles[wixParam]) && !_lodash2.default.isUndefined(wixStyles[wixParam]);
        } else {
          // the stateParam and wixParam have different names
          // check that the stateParam is not already set in the stateStyles AND wixStyles have the wixParam
          return _lodash2.default.isUndefined(stateStyles[stateParam]) && !_lodash2.default.isUndefined(wixStyles[wixParam]);
        }
      }

      if (_utils.utils.isSite() && _lodash2.default.get(this, 'state.styleParams.gotStyleParams')) {
        if (_utils.utils.isVerbose()) {
          //todo yoshi
          console.log('already got style params, not fetching again', this.state.styleParams);
        }
        return;
      }

      var gotStyleParams = !(_utils.utils.isInWix() && !_utils.utils.isDemo()); // if in Wix wait for real (not default) style params

      if (_utils.utils.isInWix() && Wix && Wix.Styles && Wix.Styles.getStyleParams()) {
        var sp = Wix.Styles.getStyleParams();
        wixStyles = {};
        _lodash2.default.merge(wixStyles, sp.booleans, sp.numbers, sp.colors, sp.fonts);
        gotStyleParams = true;
      } else if (_typeof(window.styles) == 'object') {
        wixStyles = window.styles;
      } else if (_utils.utils.parseGetParam('galleryStyle')) {
        var galleryStyle = _utils.utils.parseGetParam('galleryStyle');

        if (/^[\],:{}\s]*$/.test(galleryStyle.replace(/\\["\\\/bfnrtu]/g, '@').replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {
          //the json is ok
          wixStyles = JSON.parse(decodeURIComponent(galleryStyle));
        }
      }

      if (this.props.styleParams) {
        _lodash2.default.merge(wixStyles, this.props.styleParams);
      }

      wixStyles.gallerySize = wixStyles.gallerySize || 30;

      if (!_lodash2.default.isUndefined(wixStyles.galleryType) && _lodash2.default.isUndefined(wixStyles.galleryLayout)) {
        //legacy layouts - only if galleyrType parameter is specifically defined (i.e. layout had changed)
        if (_utils.utils.isVerbose()) {
          //todo yoshi
          console.log('Using galleryType for defaults', wixStyles);
        }

        stateStyles = this.getStyleByGalleryType(String(wixStyles.galleryType), wixStyles.gallerySize); //legacy layouts
        stateStyles.layoutsVersion = 1;
        var selectedLayoutVars = ['galleryType', 'galleryThumbnailsAlignment', 'magicLayoutSeed', 'imageResize', 'isVertical', 'scrollDirection', 'enableInfiniteScroll'];
        stateStyles.selectedLayout = selectedLayoutVars.map(function (key) {
          return String(wixStyles[key]);
        }).join('|');
      } else {
        //new layouts
        if (_utils.utils.isVerbose()) {
          //todo yoshi
          console.log('Using galleryLayout for defaults', wixStyles);
        }
        stateStyles = this.getStyleByLayout(wixStyles);
        var _selectedLayoutVars = ['galleryLayout', 'galleryThumbnailsAlignment', 'magicLayoutSeed', 'imageResize', 'isVertical', 'scrollDirection', 'enableInfiniteScroll'];
        stateStyles.selectedLayout = _selectedLayoutVars.map(function (key) {
          return String(wixStyles[key]);
        }).join('|');
        stateStyles.layoutsVersion = 2;
        stateStyles.selectedLayoutV2 = wixStyles['galleryLayout'];
        if (_utils.utils.isVerbose()) {
          //todo yoshi
          console.log('new selected layout', stateStyles.selectedLayout);
        }
      }

      //behaviour
      if (canSet('fullscreen')) {
        stateStyles.fullscreen = wixStyles.fullscreen.toString() == '0';
      } else {
        stateStyles.fullscreen = true;
      }

      if (canSet('allowSocial')) {
        stateStyles.allowSocial = wixStyles.allowSocial;
      }

      if (canSet('allowTitle')) {
        stateStyles.allowTitle = _utils.utils.isOnBoarding() ? true : wixStyles.allowTitle;
      }

      if (canSet('isInAdi')) {
        stateStyles.isInAdi = wixStyles.isInAdi;
      }

      if (canSet('useCustomButton')) {
        stateStyles.useCustomButton = wixStyles.useCustomButton;
      }

      if (canSet('allowDescription')) {
        stateStyles.allowDescription = wixStyles.allowDescription;
      }

      if (canSet('allowDownload')) {
        stateStyles.allowDownload = wixStyles.allowDownload;
      }

      if (canSet('loveButton')) {
        stateStyles.loveButton = wixStyles.loveButton;
      }

      //note: 0 is true and false is 1 - super confusing (can't change it - because of backwards compatibility)
      if (canSet('loveCounter')) {
        stateStyles.loveCounter = wixStyles.loveCounter === 0;
      }

      if (canSet('enableInfiniteScroll')) {
        stateStyles.enableInfiniteScroll = wixStyles.enableInfiniteScroll == '1';
      }

      //design
      if (canSet('isVertical')) {
        stateStyles.isVertical = String(wixStyles.isVertical) == '1';
      }
      if (canSet('imageOrientation', 'isVertical')) {
        stateStyles.isVertical = String(wixStyles.imageOrientation) == '1';
      }

      if (canSet('collageAmount')) {
        stateStyles.collageAmount = Number(wixStyles.collageAmount) / 10;
      }

      if (canSet('collageDensity')) {
        stateStyles.collageDensity = Number(wixStyles.collageDensity) / 100;
      }

      if (canSet('minItemSize')) {
        stateStyles.minItemSize = wixStyles.minItemSize;
      }

      if (canSet('gallerySize')) {
        stateStyles.gallerySize = stateStyles.gallerySize;
      }

      if (canSet('gridStyle')) {
        stateStyles.gridStyle = wixStyles.gridStyle;
      }

      if (canSet('groupSize')) {
        stateStyles.groupSize = Number(wixStyles.groupSize);
      }

      if (canSet('chooseBestGroup')) {
        stateStyles.chooseBestGroup = String(wixStyles.chooseBestGroup) == 1;
      }

      if (canSet('groupTypes')) {
        stateStyles.groupTypes = String(wixStyles.groupTypes);
      }

      if (canSet('imageMargin')) {
        stateStyles.imageMargin = Number(wixStyles.imageMargin) / 2;
      }

      if (canSet('thumbnailSpacings')) {
        stateStyles.thumbnailSpacings = Number(wixStyles.thumbnailSpacings) / 2;
      }

      if (canSet('cubeImages')) {
        stateStyles.cubeImages = String(wixStyles.cubeImages) == '1';
      }

      if (canSet('smartCrop')) {
        stateStyles.smartCrop = String(wixStyles.smartCrop) == '1';
      }

      if (canSet('cubeRatio')) {
        stateStyles.cubeRatio = Number(eval(wixStyles.cubeRatio));
      }

      if (canSet('imageResize', 'cubeType')) {
        stateStyles.cubeType = String(wixStyles.imageResize) == 1 ? 'fit' : 'fill';
        if (stateStyles.cubeType == 'fit') {
          stateStyles.cubeRatio = 1;

          if (stateStyles.cropOnlyFill === true) {
            stateStyles.cubeImages = false;
          }
        }
      }

      if (stateStyles.isSlider) {
        var val = canSet('gallerySliderImageRatio', 'cubeRatio') ? wixStyles.gallerySliderImageRatio : this.defaultStateStyles.gallerySliderImageRatio;
        stateStyles.cubeRatio = Number(eval(['16/9', '4/3', '1', '3/4', '9/16'][Number(val)]));
      } else if (stateStyles.isGrid) {
        var _val = canSet('galleryImageRatio', 'cubeRatio') ? wixStyles.galleryImageRatio : this.defaultStateStyles.galleryImageRatio;
        stateStyles.cubeRatio = Number(eval(['16/9', '4/3', '1', '3/4', '9/16'][Number(_val)]));
      }

      if (canSet('fixedColumns')) {
        stateStyles.fixedColumns = Number(wixStyles.fixedColumns);
      }

      if (canSet('scrollDirection', 'oneRow')) {
        stateStyles.oneRow = String(wixStyles.scrollDirection) == '1';

        if (stateStyles.oneRow) {
          //if oneRow is true, use horizontal layouts only
          stateStyles.isVertical = false;
        }
      }

      if (stateStyles.isGrid && !stateStyles.oneRow) {
        // if (canSet('numberOfImagesPerRow', 'fixedColumns')) {
        //If toggle is for Items per row, fill the fixedColumns with the number of items
        //If toggle is responsive, make fixedColumns to be 0 or undefined;
        //Show the new controls only on Vertical scroll (one ow is false)
        stateStyles.fixedColumns = stateStyles.gridStyle == 1 ? Number(wixStyles.numberOfImagesPerRow || stateStyles.numberOfImagesPerRow) : 0;
        stateStyles.groupTypes = '1';
        stateStyles.groupSize = 1;
        stateStyles.collageAmount = 0;
        stateStyles.collageDensity = 0;
        // }
      }

      if (canSet('numberOfImagesPerCol')) {
        if (stateStyles.isGrid && stateStyles.oneRow) {
          stateStyles.numberOfImagesPerCol = Number(wixStyles.numberOfImagesPerCol);
          stateStyles.fixedColumns = 0;
          switch (stateStyles.numberOfImagesPerCol) {
            case 1:
            default:
              stateStyles.groupTypes = '1';
              stateStyles.groupSize = 1;
              stateStyles.collageAmount = 0;
              stateStyles.collageDensity = 0;
              break;
            case 2:
              stateStyles.groupTypes = '2v';
              stateStyles.groupSize = 2;
              stateStyles.collageAmount = 1;
              stateStyles.collageDensity = 1;
              break;
            case 3:
              stateStyles.groupTypes = '3v';
              stateStyles.groupSize = 3;
              stateStyles.collageAmount = 1;
              stateStyles.collageDensity = 1;
              break;
          }
        }
      }

      if (canSet('galleryThumbnailsAlignment')) {
        stateStyles.galleryThumbnailsAlignment = ['bottom', 'left', 'top', 'right'][wixStyles.galleryThumbnailsAlignment];
      }

      if (canSet('allowMultishare')) {
        //ODEDS: changed to hardcoded false, disabling all occurences of multishare for now
        stateStyles.allowMultishare = false; // !!(wixStyles.allowMultishare) && utils.isWidgetInSite('multishare_widget'); //the widget must be present to show the multishare
      }

      //There's some kunch-ptant here so support opacity, checkout .default css className usage
      // (If this style isn't defined, we add 'default' to the className, and there we all the default params)
      if (canSet('itemOpacity')) {
        stateStyles.itemOpacity = wixStyles.itemOpacity;
      }

      if (canSet('galleryLayout')) {
        stateStyles.galleryLayout = wixStyles.galleryLayout;
      }

      if (_utils.utils.isStoreGallery()) {
        var isGrid = _lodash2.default.isUndefined(stateStyles.galleryLayout) || stateStyles.galleryLayout == 2;
        var isMasonry = stateStyles.galleryLayout == 1;
        var titleOnHover = stateStyles.titlePlacement == 1 || wixStyles.titlePlacement == 1;

        if (!isGrid && !isMasonry) {
          stateStyles.titlePlacement = _consts2.default.placements.SHOW_ON_HOVER;
        } else if (stateStyles.isVertical != 1 || stateStyles.oneRow === true) {
          stateStyles.titlePlacement = _consts2.default.placements.SHOW_ON_HOVER;
        } else if (titleOnHover) {
          stateStyles.titlePlacement = _consts2.default.placements.SHOW_ON_HOVER;
        } else {
          stateStyles.titlePlacement = _consts2.default.placements.SHOW_ALWAYS;
        }
      } else {
        stateStyles.titlePlacement = _consts2.default.placements.SHOW_ON_HOVER;
      }

      if (canSet('itemFont')) {
        stateStyles.itemFont = wixStyles.itemFont;
      }

      if (canSet('itemFontSlideshow')) {
        stateStyles.itemFontSlideshow = wixStyles.itemFontSlideshow;
      }

      if (canSet('galleryHorizontalAlign')) {
        var horizontalAlign = void 0;
        var textAlign = void 0;
        switch (wixStyles.galleryHorizontalAlign) {
          case 0:
            horizontalAlign = 'flex-start';
            textAlign = 'left';
            break;
          case 1:
          default:
            horizontalAlign = 'center';
            textAlign = 'center';
            break;
          case 2:
            horizontalAlign = 'flex-end';
            textAlign = 'right';
            break;
        }

        stateStyles.galleryHorizontalAlign = horizontalAlign;
        stateStyles.galleryTextAlign = textAlign;
      }

      if (canSet('galleryVerticalAlign')) {
        var verticalAlign = void 0;
        switch (wixStyles.galleryVerticalAlign) {
          case 0:
          default:
            verticalAlign = 'flex-start';
            break;
          case 1:
            verticalAlign = 'center';
            break;
          case 2:
            verticalAlign = 'flex-end';
            break;
        }
        stateStyles.galleryVerticalAlign = verticalAlign;
      }

      if (canSet('itemClick')) {
        switch (wixStyles.itemClick) {
          case 0:
          default:
            stateStyles.itemClick = 'expand';
            break;
          case 1:
            stateStyles.itemClick = 'link';
            break;
          case 2:
            stateStyles.itemClick = 'nothing';
            break;
        }
      }

      if (canSet('loadMoreButtonText')) {
        stateStyles.loadMoreButtonText = String(wixStyles.loadMoreButtonText);
      }

      if (canSet('customButtonText')) {
        stateStyles.customButtonText = String(wixStyles.customButtonText);
      }

      stateStyles.sharpParams = {
        quality: 90,
        usm: {}
      };

      if (canSet('imageQuality')) {
        stateStyles.sharpParams.quality = wixStyles.imageQuality;
      }

      if (canSet('usmToggle') && wixStyles.usmToggle == true) {
        if (canSet('usm_a')) {
          stateStyles.sharpParams.usm.usm_a = (wixStyles.usm_a || 0) / 100;
        }
        if (canSet('usm_r')) {
          stateStyles.sharpParams.usm.usm_r = wixStyles.usm_r;
        }
        if (canSet('usm_t')) {
          stateStyles.sharpParams.usm.usm_t = (wixStyles.usm_t || 0) / 255;
        }
      }

      if (canSet('videoPlay')) {
        switch (wixStyles.videoPlay) {
          case 0:
          default:
            stateStyles.videoPlay = 'hover';
            break;
          case 1:
            stateStyles.videoPlay = 'auto';
            break;
          case 2:
            stateStyles.videoPlay = 'onClick';
            break;
        }
      }
      if (canSet('videoSpeed')) {
        stateStyles.videoSpeed = wixStyles.videoSpeed;
      }
      if (canSet('videoLoop')) {
        stateStyles.videoLoop = wixStyles.videoLoop;
      }

      //Backwards compatibility for masonry layout
      if (stateStyles.selectedLayoutV2 == 1) {
        if (stateStyles.isVertical) {
          stateStyles.gallerySize = Math.round(stateStyles.gallerySize * 8 + 200);
        } else {
          stateStyles.gallerySize = Math.round(stateStyles.gallerySize * 5 + 200);
        }
      }

      if (stateStyles.forceMobileCustomButton) {
        stateStyles.gallerySize = Math.round(30 * 8.5 + 150);
        stateStyles.titlePlacement = _consts2.default.placements.SHOW_ALWAYS;
        stateStyles.galleryLayout = 2;
        stateStyles.fixedColumns = 1;
        stateStyles.numberOfImagesPerRow = 1;
      }

      stateStyles.gotStyleParams = gotStyleParams;

      if (_utils.utils.isVerbose()) {
        //todo yoshi
        console.log("Got styles from Wix", stateStyles);
      }

      return _lodash2.default.merge({}, this.defaultStateStyles, stateStyles);
    }

    //-----------------------------------------| REACT |--------------------------------------------//

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      var _this6 = this;

      if (_utils.utils.isVerbose()) {
        //todo yoshi
        console.log('Received new props', newProps);
      }
      try {
        if (newProps.items) {
          if (this.getHashtagFilter()) {
            this.initHashtagFilter(function () {
              _utils.utils.setStateAndLog(_this6, 'Receiving Props', {
                items: _this6.sortItemsByHashtag(newProps.items),
                totalItemsCount: newProps.totalItemsCount
              }, function () {
                _this6.reRender(_this6.renderTriggers.ALL);
              });
            });
          } else {

            var canSetItems = //replacing the gallery items is allowed when:
            newProps.items.length > this.state.items.length || //infinite scroll - adding new items to the list
            _lodash2.default.includes(['manuallySetImages', 'albumSetFromBuilder'], newProps.galleryDataSrc) || //manual set of new items (managePhotos, wixCode, photoAlbums etc.)
            _utils.utils.isPlayground(); //in the playground

            if (canSetItems) {
              if (_utils.utils.isVerbose()) {
                //todo yoshi
                console.log('Got new props with new items', newProps, this.state.items);
              }
              _utils.utils.setStateAndLog(this, 'Receiving Props', {
                items: newProps.items,
                totalItemsCount: newProps.totalItemsCount
              }, function () {
                _this6.reRender(_this6.renderTriggers.ALL);
              });
            } else if (newProps.items.length < this.state.items.length && _utils.utils.isDev()) {
              console.warn('Got new props with fewer items', newProps, this.state.items);
            }
          }
        }
      } catch (e) {
        console.error('Failed settings new props', e);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {

      this.initEventListeners();
      this.initPersistentEventListeners();
      this.initCustomEvents();
      this.initNavigationEventListeners();
      this.initHashtagFilter();

      if (!_utils.utils.isSemiNative()) {
        $('#gallery-loader').remove();
      }

      this.reRender(this.renderTriggers.ALL);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeEventListeners();
    }

    //-----------------------------------------| ITEMS |--------------------------------------------//

  }, {
    key: 'allItems',
    value: function allItems() {
      return this.state.items;
    }
  }, {
    key: 'currentItems',
    value: function currentItems() {
      if (this.state) {
        return this.allItems().slice(0, this.state.renderedItemsCount);
      } else {
        return this.allItems().slice(0, 50);
      }
    }
  }, {
    key: 'layoutItems',
    value: function layoutItems() {
      return this.state.galleryLayout.layoutItems;
    }
  }, {
    key: 'findVisibleItems',
    value: function findVisibleItems(styleParams, galleryWidth) {

      if (this.getHashtagFilter()) {
        return this.state.totalItemsCount;
      }

      if (!this.state.galleryLayout.ready) {
        return this.state.renderedItemsCount;
      }

      var toGroup = this.state.galleryLayout.lastGroup;
      var galleryHeight = this.state.galleryLayout.height * _utils.utils.getViewportScaleRatio();

      var addAfter = this.state.gotScrollEvent && galleryHeight - this.state.container.galleryHeight < 10 && (!toGroup || toGroup.rendered); //if the last item is already rendered - get more items

      var to = toGroup ? _lodash2.default.last(toGroup.items).idx + 1 : 0;

      if (addAfter) {
        //find the number of extra images to bring - according to the number of images that fit in the screen
        var averageItemHeight = galleryHeight > 0 && to > 0 ? galleryHeight / to : styleParams.gallerySize / styleParams.groupSize / (galleryWidth / styleParams.gallerySize); //calc the average item height according to the real gallery or using an estimate
        var itemsOnScreen = Math.ceil(_utils.utils.getScreenHeight() / averageItemHeight);

        var itemsToAdd = itemsOnScreen * 10; //bring 10 screens at a time
        if (itemsToAdd > 100) {
          //round to 100 or 500 items per fetch
          itemsToAdd = 500;
        } else {
          itemsToAdd = 100;
        }

        to += itemsToAdd;
      }

      return to;
    }
  }, {
    key: 'concatNewItems',
    value: function concatNewItems(newItems) {

      //add new items to the gallery - make sure there are no overlapping items and the order is correct
      var curItems = this.currentItems();

      if (!newItems || !newItems.length > 0) {
        return curItems;
      }

      curItems = curItems.concat(newItems);
      // curItems = _.uniqBy(curItems, (item) => item.itemId || item.photoId || item.url);
      // curItems = _.sortBy(curItems, (item) => item.orderIndex);
      // curItems = curItems.slice(0, this.state.totalItemsCount);

      return curItems;
    }
  }, {
    key: 'getRequiredItemsFromDbIfNeeded',
    value: function getRequiredItemsFromDbIfNeeded(toItem, callback) {
      var _this7 = this;

      toItem = Math.min(this.state.totalItemsCount, toItem);

      //check which items are missing
      var curTo = this.state.renderedItemsCount || 0;
      var propsTo = this.allItems().length || 0;

      var defaultRes = {
        items: [],
        totalItemsCount: this.state.totalItemsCount
      };

      var counts = '( current items count: ' + curTo + ' | new items count: ' + toItem + ' | items in memory: ' + propsTo + ' total items: ' + this.state.totalItemsCount + ')';

      if (this.alreadyGettingItems === true) {
        if (typeof callback == 'function') {
          callback(defaultRes);
        }
        return false;
      } else if (Math.min(propsTo, toItem) > curTo) {

        if (_utils.utils.isVerbose()) {
          //todo yoshi
          console.log('Infinite Scroll - Fetching items from MEMORY ' + counts);
        }
        if (typeof callback == 'function') {
          callback({
            items: this.allItems().slice(curTo, toItem),
            totalItemsCount: this.state.totalItemsCount
          });
        }
      } else if (toItem > curTo) {
        if (_utils.utils.isVerbose()) {
          //todo yoshi
          console.log('Infinite Scroll - Fetching items from DB ' + counts);
          console.time('Fetching items from DB');
        }
        this.alreadyGettingItems = true;

        var storeParameter = '';
        if (_utils.utils.isStoreGallery()) {
          storeParameter = '&isStore=true';
        }

        $.ajax({
          url: window.infiniteScrollUrl + 'from/' + curTo + '/to/' + (toItem + 1) + '?instance=' + window.instance + storeParameter,
          xhrFields: {
            withCredentials: true
          },
          success: function success(res) {
            if (_utils.utils.isVerbose()) {
              //todo yoshi
              console.timeEnd('Fetching items from DB');
              console.log('Fetched items from DB', res);
            }
            if (typeof callback == 'function') {
              callback(res || defaultRes);
            }
            _this7.alreadyGettingItems = false;
          }
        });
      } else {
        //console.log('Infinite Scroll - Not fetching items ' + counts );
        if (typeof callback == 'function') {
          callback(defaultRes);
        }
      }
    }
  }, {
    key: 'scrollToItemIfNeeded',
    value: function scrollToItemIfNeeded() {
      var _this8 = this;

      //after height is changed - scroll to an item if needed
      if (this.shouldScrollTo >= 0) {
        setTimeout(function () {
          var scrolled = _this8.scrollToItem(_this8.shouldScrollTo);
          if (scrolled) {
            _this8.shouldScrollTo = -1;
          }
        }, 10);
      }
    }
  }, {
    key: 'scrollToItem',
    value: function scrollToItem(itemIdx, fixedScroll, isManual) {
      var _this9 = this;

      var pos = void 0;
      var horizontalElement = $('.gallery-horizontal-scroll');

      if (fixedScroll === true) {
        //scroll by half the container size

        if (this.state.styleParams.oneRow) {
          pos = horizontalElement.scrollLeft() + itemIdx * this.state.container.galleryWidth / 2;
        } else {
          pos = this.state.scroll.top + itemIdx * this.state.container.galleryHeight / 2;
        }
      } else {

        //scroll to specific item
        if (_utils.utils.isVerbose()) {
          //todo yoshi
          console.log("Scrolling to items #" + itemIdx);
        }

        var items = _lodash2.default.flattenDeep(this.state.galleryLayout.columns.map(function (column, c) {
          return column.map(function (group, g) {
            return group.items;
          });
        }));

        var item = _lodash2.default.find(items, function (item) {
          return item.idx == itemIdx;
        });
        pos = this.state.styleParams.oneRow ? _lodash2.default.get(item, 'offset.left') : _lodash2.default.get(item, 'offset.top');

        if (_utils.utils.isVerbose()) {
          //todo yoshi
          console.log("Scrolling to position " + pos, item);
        }

        if (!(pos >= 0)) {
          console.warn("Position not found, not scrolling");
          return false;
        }

        if (this.state.styleParams.oneRow) {

          if (isManual && _lodash2.default.isFunction(_lodash2.default.get(window, 'galleryWixCodeApi.onItemChanged'))) {
            window.galleryWixCodeApi.onItemChanged(item);
          }

          //set scroll to place the item in the middle of the component
          var diff = (this.state.container.galleryWidth - item.width) / 2;
          if (diff > 0) {
            pos -= diff;
          }
          pos = Math.max(0, pos) / _utils.utils.getViewportScaleRatio();
          if (_utils.utils.isVerbose()) {
            //todo yoshi
            console.log("Scrolling to new position " + pos, this);
          }
        }
      }

      //pos -= item.height; //don't scroll too much so that the item is not too close to the edge of the container

      _utils.utils.setStateAndLog(this, 'Scroll To Item', {
        scrollTop: pos
      }, function () {
        if (_this9.state.styleParams.oneRow) {
          if (_utils.utils.isVerbose()) {
            //todo yoshi
            console.log("Scrolling horiontally", pos, horizontalElement);
          }
          horizontalElement.animate({ scrollLeft: Math.round(pos * _utils.utils.getViewportScaleRatio()) }, 400); //todo - make sure this triggers the infinite scroll!!!
        } else if (_utils.utils.isInWix()) {
          if (_utils.utils.isVerbose()) {
            //todo yoshi
            console.log("Scrolling vertically (in wix)");
          }
          if (_utils.utils.getViewModeFromCache() !== 'editor') {
            Wix.scrollTo(0, Math.round(_this9.scrollBase + pos * _utils.utils.getViewportScaleRatio()));
          }
        } else {
          if (_utils.utils.isVerbose()) {
            //todo yoshi
            console.log("Scrolling vertically (not in wix)");
          }
          //$(window).animate({scrollTop: pos + 'px'});
          $(window).scrollTop(Math.round(pos * _utils.utils.getViewportScaleRatio()));
        }
      });

      return true;
    }
  }, {
    key: 'resetItems',
    value: function resetItems(items) {
      for (var item, i = 0; item = items[i]; i++) {
        item.width = item.maxWidth;
        item.height = item.maxHeight;
      }

      return items;
    }

    //-----------------------------------------| UTILS |--------------------------------------------//

  }, {
    key: 'getVisibleBounds',
    value: function getVisibleBounds(scrollTop, pageScale) {

      if (this.debugScroll) console.time('SCROLL - getVisibleBounds time');

      if (typeof scrollTop == 'undefined') {
        scrollTop = 0;
      }
      if (typeof pageScale == 'undefined') {
        pageScale = 1;
      }

      var screenSize = _utils.utils.getScreenHeight() / pageScale;
      var renderedPadding = _utils.utils.parseGetParam('renderedPadding') || screenSize * 5;
      var visiblePadding = _utils.utils.parseGetParam('displayPadding') || screenSize * 1.5;

      if (this.state.styleParams.oneRow) {
        screenSize = _utils.utils.getScreenWidth() / pageScale; //horizontal layouts will use the same infinite scroll mechanism for horizonal scroll (left => top, right => bottom)
        renderedPadding = _utils.utils.parseGetParam('renderedPadding') || screenSize * 10;
        visiblePadding = _utils.utils.parseGetParam('displayPadding') || screenSize * 5;
        //slideshows required more padding (it usually has larger images and one image per row)
      }

      var docViewTop = scrollTop;
      var docViewBottom = docViewTop + screenSize; //cannot get the real document height - using the screen as default

      if (!this.isInfiniteScroll() && !this.state.styleParams.oneRow) {
        docViewTop = 0;
        docViewBottom = this.getGalleryHeight() / pageScale;
      }

      // viewport window on both sides
      var visibleTop = docViewTop - visiblePadding;
      var visibleBottom = docViewBottom + visiblePadding;

      var renderedTop = docViewTop - renderedPadding;
      var renderedBottom = docViewBottom + renderedPadding;

      var bounds = {
        docViewTop: docViewTop,
        docViewBottom: docViewBottom,
        visibleTop: visibleTop,
        visibleBottom: visibleBottom,
        renderedTop: renderedTop,
        renderedBottom: renderedBottom
      };

      if (this.debugScroll) console.timeEnd('SCROLL - getVisibleBounds time');

      return {
        bounds: bounds
      };
    }
  }, {
    key: 'getGalleryScroll',
    value: function getGalleryScroll(params) {
      if (this.state.styleParams.oneRow) {
        this.currentScrollPosition = $('.gallery-horizontal-scroll').scrollLeft();
      } else if (params && _lodash2.default.isNumber(params.customScrollTop)) {
        this.currentScrollPosition = params.customScrollTop;
        return this.currentScrollPosition;
      } else if (_utils.utils.isInWix()) {
        if (params && _lodash2.default.isNumber(params.scrollTop) && _lodash2.default.isNumber(params.y)) {
          var scrollBase = params.y;
          var scrollTop = params.scrollTop;
          this.pageScale = params.scale || 1;
          if (this.scrollBase !== scrollBase) {
            if (_utils.utils.isDev()) {
              console.log('gallery ' + this.compId + ' scroll base has changed from ' + this.scrollBase + ' to ' + scrollBase);
            }
            this.scrollBase = scrollBase * this.pageScale;
          }
          this.currentScrollPosition = (scrollTop - this.scrollBase) / _utils.utils.getViewportScaleRatio() * this.pageScale;
        }
        return this.currentScrollPosition;
      } else {
        this.currentScrollPosition = $(window).scrollTop();
        return this.currentScrollPosition;
      }
    }
  }, {
    key: 'getGalleryDimensions',
    value: function getGalleryDimensions(styleParams) {

      if (_lodash2.default.isUndefined(styleParams)) {
        styleParams = this.state.styleParams;
      }

      var res = {
        galleryWidth: this.protectGalleryWidth(_utils.utils.isSemiNative() ? this.props.layout.width : document.body.clientWidth),
        galleryHeight: this.getGalleryHeight()
      };

      var thumbnailSize = this.thumbnailSize;

      if (styleParams.hasThumbnails) {
        switch (styleParams.galleryThumbnailsAlignment) {
          case 'top':
          case 'bottom':
            res.galleryHeight -= thumbnailSize;
            break;
          case 'left':
          case 'right':
            res.galleryWidth -= thumbnailSize;
            break;
        }
      } else if (styleParams.isSlideshow) {
        // res.galleryHeight = 550; //if the height of the image is constant
        res.galleryHeight -= this.slideshowInfoSize; //if the height of the text is constant
      }
      return res;
    }
  }, {
    key: 'protectGalleryWidth',
    value: function protectGalleryWidth(width) {

      var maxGalleryWidth = void 0;
      if (_utils.utils.isSite()) {
        maxGalleryWidth = Number(_utils.utils.parseGetParam('width'));
      }

      if (_utils.utils.browserIs('chromeIos')) {
        // This can be the width calc for all galleries, but in chromeIos it must be used otherwise there is a gap on the left of the gallery.
        // Currently there is a bug with Mitzi that the width parmeter is not updating fast enough once it is fixed, use this code always.
        maxGalleryWidth = maxGalleryWidth || document.body.clientWidth;
      } else {
        maxGalleryWidth = document.body.clientWidth;
      }

      if (_utils.utils.isMobile()) {
        maxGalleryWidth = Math.floor(maxGalleryWidth / _utils.utils.getViewportScaleRatio());
      }
      return Math.min(Math.floor(width), maxGalleryWidth) - 1;
    }
  }, {
    key: 'setWixHeight',
    value: function setWixHeight(height, lastHeight, trigger) {
      var _this10 = this;

      this.lastHeight = Math.round(lastHeight);
      this.newHeight = Math.round(height);

      //resize wix tpa window if needed
      var getNeededHeight = function getNeededHeight(height, trigger) {

        var getMaxRowHeight = function getMaxRowHeight() {
          var maxByScreen = window.screen.height * 0.6; //make sure that the gallery is not heigher than the screen
          var maxByFirstGroup = _this10.state.container.galleryWidth / _this10.state.galleryLayout.firstGroup.ratio * 0.8; //make sure more than 1 group is visible
          var maxBySlideshow = _this10.state.container.galleryWidth * 9 / 16 + _this10.slideshowInfoSize; //in slideshow and thumbnails, the group ratio is calculated by the height so we need a fixed value

          if (_this10.state.styleParams.isSlideshow || _this10.state.styleParams.hasThumbnails) {
            return maxBySlideshow;
          } else if (_this10.state.styleParams.oneRow) {
            return Math.min(maxByScreen, maxByFirstGroup);
          } else if (!_this10.state.styleParams.enableInfiniteScroll == '1') {
            //vertical with show more
            return maxByScreen;
          } else {
            return false;
          }
        };

        var newHeight = Math.round(height * _utils.utils.getViewportScaleRatio());
        var should = true;

        if (!_this10.isInfiniteScroll() || _lodash2.default.get(_this10, 'state.styleParams.oneRow')) {
          should = false;
        }

        if (_this10.state.styleParams.hasThumbnails && ['top', 'bottom'].indexOf(_this10.state.styleParams.galleryThumbnailsAlignment) >= 0) {
          newHeight += _this10.thumbnailSize;
        }

        var maxRowHeight = getMaxRowHeight();
        if (_utils.utils.isEditor() && maxRowHeight) {
          if (trigger === _this10.renderTriggers.LAYOUT) {
            if (_lodash2.default.get(_this10, 'state.styleParams.oneRow') || !_lodash2.default.get(_this10, 'state.styleParams.enableInfiniteScroll')) {
              //when the layout changes, if the new layout is horizontal or with the show more button, adjust the height
              should = false;
              if (newHeight > maxRowHeight) {
                //only reduce the size of the gallery
                newHeight = maxRowHeight;
                should = true;
              } else if (_this10.state.styleParams.isSlideshow) {
                newHeight = maxRowHeight;
                should = true;
              }
            }
          } else if (_this10.state.styleParams.isInAdi && !_this10.state.styleParams.enableInfiniteScroll) {
            newHeight = Math.min(newHeight, adiLoadMoreMaxHeight);
            should = true;
          }
        }

        return should && newHeight;
      };

      var neededHeight = getNeededHeight(this.newHeight, trigger);
      if (neededHeight) {
        if (_utils.utils.isVerbose()) {
          //todo yoshi
          console.log('updating height', neededHeight);
        }

        if (Math.abs(lastHeight - neededHeight) < 2 || neededHeight == 0) {
          if (_utils.utils.isVerbose()) {
            //todo yoshi
            console.log("Skipping Wix height change: was " + this.lastHeight + ", now it's " + neededHeight);
          }
        } else {

          _utils.utils.setStateAndLog(this, 'setWixHeight', _lodash2.default.merge(this.state.container, {
            galleryHeight: neededHeight
          }));

          if (_utils.utils.isInWix()) {
            if (_utils.utils.isVerbose()) {
              //todo yoshi
              console.warn('Changing wix height from: ' + lastHeight + '  to: ' + neededHeight + ' inner gallery height is: ' + this.newHeight);
            }
            Wix.setHeight(neededHeight);
          }
        }
      }

      this.scrollToItemIfNeeded();
    }
  }, {
    key: 'isInfiniteScroll',
    value: function isInfiniteScroll() {

      var styleParamsInfiniteScroll = _lodash2.default.get(this, 'state.styleParams.enableInfiniteScroll'); //if undefined -> enable infinite scroll
      var stateInfiniteScroll = _lodash2.default.get(this, 'state.scroll.isInfinite'); //if defined -> override style params
      var gotStylesParams = _lodash2.default.get(this, 'state.styleParams.gotStyleParams'); //if false -> do not allow infinite scroll yet

      if (!gotStylesParams) {
        return false;
      } else {
        //DO NOT allow infinite scroll only if both styleParams and state are FALSE
        return styleParamsInfiniteScroll || stateInfiniteScroll;
      }
    }

    //----------------------------------------| ACTIONS |-------------------------------------------//

  }, {
    key: 'onResizeEvent',
    value: function onResizeEvent(e) {

      //workaround for safari issue - calling resize on style change
      if (this.currentWindowWidth !== window.innerWidth || this.currentWindowHeight !== window.innerHeight) {
        if (!_utils.utils.isiPhone() || this.currentWindowWidth !== window.innerWidth || Math.abs(this.currentWindowHeight - window.innerHeight) > 25) {
          this.currentWindowWidth = window.innerWidth;
          this.currentWindowHeight = window.innerHeight;
          this.reRenderForResize(e);
        }
      }
    }
  }, {
    key: 'toggleInfiniteScroll',
    value: function toggleInfiniteScroll(forceVal) {
      var _this11 = this;

      _utils.utils.setStateAndLog(this, 'Toggle Infinite Scroll', {
        scroll: _lodash2.default.merge(this.state.scroll, {
          isInfinite: true
        })
      }, function () {
        _this11.reRenderForResize();
      });
    }
  }, {
    key: 'getConnectedProviders',
    value: function getConnectedProviders() {
      var connectedProviders = window['connectedProviders'];
      try {
        if (!connectedProviders && window.prerenderedGallery && prerenderedGallery.gallerySettings) {
          var gallerySettings = prerenderedGallery.gallerySettings;
          if (typeof gallerySettings === 'string') {
            gallerySettings = JSON.parse(_utils.utils.stripSlashes(gallerySettings));
          }
          if (gallerySettings && (typeof gallerySettings === 'undefined' ? 'undefined' : _typeof(gallerySettings)) === 'object' && gallerySettings.connectedProviders) {
            connectedProviders = gallerySettings.connectedProviders;
          }
        }
      } catch (error) {
        console.error('Error getting connected providers', error);
      }

      if (!connectedProviders) {
        console.error('No connected providers');
      }

      return connectedProviders;
    }
  }, {
    key: 'toggleFullscreen',
    value: function toggleFullscreen(itemIdx) {
      var _this12 = this;

      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!this.state.styleParams.fullscreen) return;

      if (this.state.styleParams.itemClick == 'nothing') {
        return;
      }

      if (typeof itemIdx != 'undefined' && itemIdx !== false) {

        if (this.state.totalItemsCount > 0) {
          itemIdx = (itemIdx + this.state.totalItemsCount) % this.state.totalItemsCount;
        }

        var itemDto = this.allItems()[itemIdx];
        var item = new _itemLayout2.default({
          dto: itemDto.dto || itemDto,
          createdBy: 'toggleFullscreen'
        });

        if (this.state.styleParams.itemClick == 'link') {
          if (item.linkType && item.linkType !== 'none') {
            if (item.linkType === 'web') {
              window.open(item.linkUrl, item.linkOpenType);
            } else if (item.linkType === 'wix') {
              Wix.navigateTo(item.linkData);
            } else {
              Wix.navigateToPage(item.linkUrl, { noTransition: true });
            }
          }
        } else {

          if (_utils.utils.isVerbose()) {
            //todo yoshi
            console.log('Time to Fullscreen VM - START');
          }

          var prefix = '//' + (window.staticsVersion == 'debug' ? 'local.wix.com:9001' : 'progallery.wix.com') + '/';

          window.currentGalleryItems = this.allItems();
          window.totalItemsCount = this.state.totalItemsCount;
          if (_utils.utils.isInWix()) {

            //data to be read by the fullscreen iframe
            window.onunload = function () {
              if (_utils.utils.isVerbose()) {
                //todo yoshi
                console.log('Fullscreen iFrame unloaded');
              }
            };

            var connectedProviders = null;
            var watermarkData = null;

            if (_utils.utils.isStoreGallery()) {
              watermarkData = this.state.watermark;
              connectedProviders = this.getConnectedProviders();
            }

            Wix.Styles.getStyleId(function (styleId) {
              _utils.utils.getWorkerWindow()['pro-gallery-data-' + _this12.compId] = {
                info: {
                  config: config,
                  itemIdx: itemIdx,
                  itemId: item.id,
                  compId: _this12.compId,
                  pageId: _this12.pageId,
                  galleryId: _this12.galleryId,
                  styleId: styleId,
                  watermarkData: watermarkData,
                  connectedProviders: connectedProviders
                },
                items: {
                  galleryLayout: _this12.state.galleryLayout,
                  totalItemsCount: _this12.state.totalItemsCount,
                  currentGalleryItems: _this12.allItems()
                },
                window: {
                  infiniteScrollUrl: window.infiniteScrollUrl,
                  instance: window.instance
                }
              };

              //always open the default fullscreen - then read the window date and use replace state to change the url
              //this prevents the iframe from being refreshed

              _utils.utils.getWorkerWindow()['pro-gallery-fullscreen-comp-id'] = _this12.compId;
              Wix.Utils.navigateToSection({
                sectionId: _utils.utils.getFullscreenSectionId(),
                noTransition: true
              }, '');
            });
          } else {
            var fullscreen = document.getElementById('gallery-fullscreen');
            if (fullscreen) {
              this.fullscreenElem = _react2.default.createElement(_fullscreenContainer2.default, {
                demoModeParams: {
                  items: this.allItems(),
                  galleryLayout: this.state.galleryLayout,
                  item: itemIdx,
                  closeFullscreenCallback: this.closeFullscreenCallback
                },
                store: this.props.store
              });
              _reactDom2.default.render(this.fullscreenElem, fullscreen);
              window.history.pushState({}, '', _utils.utils.addItemHashParam(window.location.href, this.props.items[itemIdx].photoId));
            }

            if (!_utils.utils.isSemiNative()) {
              $('#fullscreen, #gallery-fullscreen').show();
              $('#content').hide();
            }
          }
        }
        logger.track('expand', { selection: 'expand' });
      }
    }
  }, {
    key: 'pauseAllVideos',
    value: function pauseAllVideos() {
      window.dispatchEvent(this.pauseAllVideosEvent);
    }
  }, {
    key: 'closeFullscreenCallback',
    value: function closeFullscreenCallback() {

      if (_utils.utils.isDev()) {
        console.log('Fullscreen closed callback');
      }

      var fullscreenData = (_utils.utils.getWorkerWindow()['pro-gallery-data-' + this.compId] || {}).fullscreenData;

      if (!fullscreenData) {
        console.warn('Closed fullscreen without data');
        return;
      }

      var items = this.resetItems(fullscreenData.currentGalleryItems);

      if (!_utils.utils.isSemiNative()) {
        $('#content').show();
      }

      //get current items from window - it was placed there by the fullscreen
      _utils.utils.setStateAndLog(this, 'Fullscreen Callback', {
        items: items
      });

      this.shouldScrollTo = fullscreenData.currentGalleryItemIdx;

      this.scrollToItemIfNeeded();

      //state might not be changed but the gallery must be rerendred (for loves counts)
      //this.forceUpdate();
    }

    //---------------------------------------| MULTISHARE |-----------------------------------------//

  }, {
    key: 'initHashtagFilter',
    value: function initHashtagFilter(callback) {
      var _this13 = this;

      var hashtagFilter = this.getHashtagFilter();

      var hashtag = {
        filter: hashtagFilter
      };

      //get the items for the hashtag
      if (hashtagFilter) {
        if (!_utils.utils.isSemiNative()) {
          $.get(_utils.utils.getApiUrlPrefix() + 'gallery/' + this.galleryId + '/hashtags/' + hashtagFilter + '/items?instance=' + window.instance, function (res) {
            if (res && res.items && res.items.length > 0) {
              hashtag.items = res.items;
              if (_utils.utils.isVerbose()) {
                //todo yoshi
                console.log('Got hashtag items', hashtag);
              }
              _utils.utils.setStateAndLog(_this13, 'Get Hashtag Items', {
                hashtag: hashtag
              }, function () {
                if (callback && _lodash2.default.isFunction(callback)) {
                  callback();
                }
              });
            }
          });
        }
      }
    }
  }, {
    key: 'getHashtagFilter',
    value: function getHashtagFilter() {
      var hashtag = this.state.hashtagFilter || _utils.utils.getWorkerWindow()['pro-gallery-hashtag-filter'] || _utils.utils.parseGetParam('ht', _utils.itemActions.getSiteUrl());
      return hashtag;
    }
  }, {
    key: 'sortItemsByHashtag',
    value: function sortItemsByHashtag(curItems) {

      var hashtagItems = _lodash2.default.get(this, 'state.hashtag.items');

      if (!hashtagItems) {
        return curItems;
      }

      /*
          const taggedItems = [], otherItems = [];
          for (const itemDto, i = 0; itemDto = curItems[i]; i++) {
            const isInHashtag = _.findIndex(hashtagItems, (item) => (item.itemId == itemDto.itemId)) >= 0;
            if (isInHashtag) {
              taggedItems.push(itemDto);
            } else {
              otherItems.push(itemDto);
            }
          }
           curItems = _.concat(_.sortBy(taggedItems, (item) => item.orderIndex), otherItems);
       */

      try {
        var otherItems = _lodash2.default.differenceBy(curItems, hashtagItems, 'itemId');
        return _lodash2.default.concat(hashtagItems, otherItems);
      } catch (e) {
        console.warn('Could not sort hashtag items', e, hashtagItems, curItems);
        return curItems;
      }
    }
  }, {
    key: 'updateMultishareItems',
    value: function updateMultishareItems(event) {
      if (_utils.utils.isVerbose()) {
        //todo yoshi
        console.log('multishare pubsub', event);
      }
      var data = event.data;
      if (_lodash2.default.isBoolean(data.update) && data.update === true && _lodash2.default.isArray(data.items)) {
        _utils.utils.setStateAndLog(this, 'updateMultishareItems', {
          multishare: {
            items: data.items,
            isMultisharing: this.props.defaultSelectMode === true || !!data.items.length
          }
        });
      }
    }
  }, {
    key: 'addItemToMultishare',
    value: function addItemToMultishare(itemDto) {
      if (_utils.utils.isInWix()) {
        itemDto.compId = this.compId; //add a refernce to the gallery that started this share
        Wix.PubSub.publish("gallery2multishare", { call: "addItemToMultishare", data: itemDto }, true);
      } else {
        this.onItemClickEvent.itemId = itemDto.id;
        window.dispatchEvent(this.onItemClickEvent);

        _utils.utils.setStateAndLog(this, 'updateMultishareItems', {
          multishare: {
            items: this.state.multishare.items.concat([itemDto]),
            isMultisharing: true
          }
        });
      }
    }
  }, {
    key: 'removeItemFromMultishare',
    value: function removeItemFromMultishare(itemProps) {
      if (_utils.utils.isInWix()) {
        Wix.PubSub.publish("gallery2multishare", { call: "removeItemFromMultishare", data: itemProps }, true);
      } else {
        var multishareItems = this.state.multishare.items;
        multishareItems = _lodash2.default.filter(multishareItems, function (item) {
          return (item.itemId || item.photoId) != (itemProps.itemId || itemProps.photoId);
        });
        _utils.utils.setStateAndLog(this, 'updateMultishareItems', {
          multishare: {
            items: multishareItems,
            isMultisharing: true
          }
        });
      }
    }

    //-----------------------------------------| RENDER |--------------------------------------------//

  }, {
    key: 'createGallery',
    value: function createGallery(newState) {

      if (_utils.utils.isVerbose()) {
        //todo yoshi
        console.count("galleryContainer createGallery");
      }

      //either create a new gallery or rerender the existing (if a substential change happend) or just set visibilities (on scroll)

      var layoutParams = {
        items: newState.items.slice(0, newState.renderedItemsCount),
        container: newState.container,
        styleParams: newState.styleParams,
        watermark: newState.watermark,
        gotScrollEvent: newState.gotScrollEvent
      };

      var galleryLayout = this.state.galleryLayout;

      if (!this.state.galleryLayout.ready) {

        if (_utils.utils.isVerbose()) {
          //todo yoshi
          console.time('Recalculating Gallery - new');
        }
        galleryLayout = new _galleryLayout2.default(layoutParams);
        if (_utils.utils.isVerbose()) {
          //todo yoshi
          console.timeEnd('Recalculating Gallery - new');
        }
      } else if (this.renderTrigger == this.renderTriggers.SCROLL) {

        if (_utils.utils.isVerbose()) {
          //todo yoshi
          console.time('Recalculating Gallery - visibilities');
        }
        galleryLayout.calcVisibilities(newState.container.bounds);
        if (_utils.utils.isVerbose()) {
          //todo yoshi
          console.timeEnd('Recalculating Gallery - visibilities');
        }
      } else {

        //recalculate gallery only if a crucial field has change
        //when only scrolling, and items don't change - do not recalculate the gallery object

        if (_utils.utils.isVerbose()) {
          //todo yoshi
          console.time('Recalculating Gallery - prepare');
        }
        galleryLayout.updateParams(layoutParams);
        galleryLayout.prepareGallery();
        galleryLayout.calcVisibilities(newState.container.bounds);
        if (_utils.utils.isVerbose()) {
          //todo yoshi
          console.timeEnd('Recalculating Gallery - prepare');
        }
      }

      window['galleryLayout'] = galleryLayout; //save on window for fullscreen access

      return galleryLayout;
    }
  }, {
    key: 'reRenderForEditMode',
    value: function reRenderForEditMode() {

      if (_utils.utils.isDev()) console.count("galleryContainer reRenderForEditMode");

      _utils.utils.updateViewMode();
      this.reRender(this.renderTriggers.MODE);
    }
  }, {
    key: 'reRenderForSettings',
    value: function reRenderForSettings() {
      if (_utils.utils.isDev()) console.count("galleryContainer reRenderForSettings");

      this.reRender(this.renderTriggers.STYLES);
    }
  }, {
    key: 'reRenderForStyles',
    value: function reRenderForStyles() {

      if (_utils.utils.isDev()) console.count("galleryContainer reRenderForStyles");

      Wix.Styles.getStyleParams(function (style) {
        window.postMessage({
          type: Wix.Events.STYLE_PARAMS_CHANGE,
          payload: style
        }, _utils.utils.getUrlPrefix());
      });
      this.reRender(this.renderTriggers.STYLES);
    }
  }, {
    key: 'reRenderForScroll',
    value: function reRenderForScroll(params) {
      if (this.state.styleParams.oneRow) {
        return true;
      }

      if (_utils.utils.isVerbose()) {
        //todo yoshi
        console.count("galleryContainer reRenderForScroll");
        console.log("SCROLL - got vertical scroll event", params);
      }

      this._reRenderForScroll(params);
    }
  }, {
    key: 'reRenderForHorizontalScroll',
    value: function reRenderForHorizontalScroll(event) {

      var isScrollingHorizontalGallery = this.state.styleParams.oneRow && event.target.className.indexOf('gallery-horizontal-scroll') >= 0;

      if (isScrollingHorizontalGallery) {

        if (_utils.utils.isVerbose()) {
          //todo yoshi
          console.count("galleryContainer reRenderForHorizontalScroll");
          console.log("SCROLL - got horizontal scroll event");
        }

        this._reRenderForScroll();
      }

      return true; //continue with native scroll event
    }
  }, {
    key: '_reRenderForScroll',
    value: function _reRenderForScroll(params) {
      var _this14 = this;

      this.scrollTiming = function () {
        var str = '(' + (Date.now() - _this14.debugScroll) + 'ms) ';
        _this14.debugScroll = Date.now();
        return str;
      };

      if (_utils.utils.shouldDebug('ph_log_scroll')) {
        this.debugScroll = Date.now();
        console.log(this.scrollTiming() + "SCROLL - full cycle time");
        console.time("SCROLL - full cycle time");
        console.time("SCROLL - js logic time");
      }

      window.dispatchEvent(this.galleryScrollEvent);

      if (_utils.utils.isVerbose()) {
        //todo yoshi
        console.log(this.scrollTiming() + "SCROLL - dispatch galleryScrollEvent");
      }

      this.reRender(this.renderTriggers.SCROLL, params);
    }
  }, {
    key: 'reRenderForResize',
    value: function reRenderForResize(e) {
      if (_utils.utils.isVerbose()) {
        //todo yoshi
        if (!_utils.utils.isSemiNative()) {
          console.log('Got resize event (' + this.lastWindowHeight + ' > ' + window.innerHeight + ')', e);
        }
        console.count("galleryContainer reRenderForResize");
      }

      this.lastWindowHeight = this.getGalleryHeight();

      this.resizeCount = this.resizeCount + 1;
      this.reRender(this.renderTriggers.RESIZE);
    }
  }, {
    key: 'reRenderForOrientation',
    value: function reRenderForOrientation() {
      var _this15 = this;

      if (_utils.utils.isVerbose()) {
        //todo yoshi
        console.count("galleryContainer reRenderForOrientation");
      }

      var reRenderForOrientationInternal = function reRenderForOrientationInternal() {
        _this15.orientationCount = _this15.orientationCount + 1;
        _utils.utils.fixViewport('Gallery orientation');
        _this15.reRender(_this15.renderTriggers.ORIENTATION);
        if (_utils.utils.getViewModeFromCache() !== 'editor') {
          Wix.scrollBy(0, 1); //patch to get the right scroll position
        }
      };

      reRenderForOrientationInternal();
    }
  }, {
    key: 'reRender',
    value: function reRender(trigger, params) {
      var _this16 = this;

      if (this.debugScroll) console.log(this.scrollTiming() + 'SCROLL - reRendering');

      if (_utils.utils.isVerbose()) {
        //todo yoshi
        console.count("galleryContainer reRender");
        console.count('reRendering (trigger: ' + trigger + ')');
        console.log('reRendering', trigger, params);
      }

      var triggerIs = function triggerIs(triggerTypes) {
        if (!_lodash2.default.isArray(triggerTypes)) {
          triggerTypes = [triggerTypes];
        }
        return trigger == _this16.renderTriggers.ALL || _lodash2.default.indexOf(triggerTypes, trigger) >= 0;
      };

      var scrollState = {};
      if (this.debugScroll) console.time('SCROLL - getGalleryScroll time');
      this.getGalleryScroll(params);
      if (this.debugScroll) console.timeEnd('SCROLL - getGalleryScroll time');
      scrollState = {
        scroll: _lodash2.default.merge(this.state.scroll, { top: this.currentScrollPosition, base: this.scrollBase }),
        container: _lodash2.default.merge(this.state.container, this.getVisibleBounds(this.currentScrollPosition, this.pageScale))
      };

      if (this.debugScroll) console.log(this.scrollTiming() + 'SCROLL - calculated scrollState', scrollState);

      var stylesState = { styleParams: triggerIs(this.renderTriggers.STYLES) ? this.getStyleParamsState() : this.state.styleParams };

      var resizeState = triggerIs([this.renderTriggers.STYLES, this.renderTriggers.RESIZE, this.renderTriggers.ORIENTATION, this.renderTriggers.LAYOUT]) ? { container: this.getGalleryDimensions(stylesState.styleParams) } : { container: this.state.container }; // / utils.getViewportScaleRatio()
      var viewState = {};

      if (triggerIs(this.renderTriggers.MODE)) {
        viewState = { container: { viewMode: _utils.utils.isInWix() ? _utils.utils.getViewModeFromCache() : 'view' } };
      }

      var totalItems = triggerIs([this.renderTriggers.MODE, this.renderTriggers.SCROLL, this.renderTriggers.RESIZE, this.renderTriggers.ORIENTATION, this.renderTriggers.STYLES, this.renderTriggers.LAYOUT]) ? this.findVisibleItems(stylesState.styleParams, resizeState.container.galleryWidth) : this.state.items;

      if (this.debugScroll) console.log(this.scrollTiming() + 'SCROLL - calculated totalItems', totalItems);
      if (this.debugScroll) console.time('SCROLL - time of getRequiredItemsFromDbIfNeeded');

      this.getRequiredItemsFromDbIfNeeded(totalItems, function (res) {

        if (_this16.debugScroll) console.timeEnd('SCROLL - time of getRequiredItemsFromDbIfNeeded');

        var itemsState = {};
        if (res.items.length > 0) {
          var allItems = _this16.concatNewItems(res.items);
          // allItems = this.sortItemsByHashtag(allItems); //assuming all hashtag items are fetched with prerenderedItems - better perfomance

          itemsState = {
            items: allItems,
            renderedItemsCount: allItems.length,
            totalItemsCount: res.totalItemsCount
          };

          //if the items where changed - change the trigger
          if (allItems.length != _this16.state.renderedItemsCount) {
            trigger = _this16.renderTriggers.ITEMS;
          }
        }

        // if (this.debugScroll) console.log(this.scrollTiming() + 'SCROLL - calculated itemsState', itemsState); todo yoshi

        _this16.renderTrigger = trigger;

        if (_this16.debugScroll) console.time('SCROLL - merging newState');
        var newState = _lodash2.default.cloneDeep(_this16.state);
        switch (trigger) {
          case _this16.renderTriggers.ALL:
          case _this16.renderTriggers.ITEMS:
          default:
            newState = _utils.utils.mergeDeep(newState, stylesState, scrollState, viewState, resizeState, itemsState);
            break;
          case _this16.renderTriggers.NONE:
            break;
          case _this16.renderTriggers.MODE:
            newState = _utils.utils.mergeDeep(newState, scrollState, viewState);
            break;
          case _this16.renderTriggers.STYLES:
            newState = _utils.utils.mergeDeep(newState, scrollState, stylesState, resizeState);
            break;
          case _this16.renderTriggers.RESIZE:
          case _this16.renderTriggers.ORIENTATION:
          case _this16.renderTriggers.LAYOUT:
            newState = _utils.utils.mergeDeep(newState, scrollState, resizeState);
            break;
          case _this16.renderTriggers.SCROLL:
            newState = _utils.utils.mergeDeep(newState, scrollState, { gotScrollEvent: true });
            break;
        }

        // if (this.debugScroll) console.timeEnd('SCROLL - merging newState'); todo yoshi

        // if (this.debugScroll) console.log(this.scrollTiming() + 'SCROLL - calculated newState', newState); todo yoshi

        newState.galleryLayout = _this16.createGallery(newState);

        if (_this16.debugScroll) console.log(_this16.scrollTiming() + 'SCROLL - calculated galleryLayout', newState.galleryLayout);
        if (_this16.debugScroll) console.time('SCROLL - time of setting new state for gallery');

        var isNewLayout = newState.styleParams.selectedLayout !== _this16.state.styleParams.selectedLayout;

        var isLayoutDefined = function isLayoutDefined(layout) {
          return !(layout && layout.replace(/(undefined)[|]?/g, '') === '');
        };
        var isChangedLayout = isLayoutDefined(newState.styleParams.selectedLayout) && isLayoutDefined(_this16.state.styleParams.selectedLayout) && isNewLayout; //used to prevent setting height on first layout reRender

        _utils.utils.setStateAndLog(_this16, 'Gallery ReRender', newState, function () {
          if (_this16.debugScroll) console.timeEnd('SCROLL - time of setting new state for gallery');
          if (_this16.debugScroll) console.timeEnd("SCROLL - full cycle time");
          if (isNewLayout) {
            //when changing layout, the container must rerender again with all the new styleParams already set
            if (_utils.utils.isDev()) console.warn('Changed layout - re-rendering');
            if (_utils.utils.isEditor()) _this16.scrollToItem(0); //in the editor, the layout change can be triggered by the settings, so we need to scroll to the first item. In sites, this is triggered once on load and the scroll is unneccessary (could cause problem with anchors_
            _this16.isChangedLayout = isChangedLayout;
            _this16.reRender(_this16.renderTriggers.LAYOUT);
          } else if (_this16.isInfiniteScroll() && !_this16.state.styleParams.oneRow || trigger !== _this16.renderTriggers.LAYOUT || _this16.isChangedLayout) {
            // auto change height when:
            //  - Vertical gallery with infinite scroll
            //  - Changed layout in the editor
            //  - The trigger is not a new layout
            // (this is used to prevent auto change of height when the editor loads)
            _this16.isChangedLayout = false;
            _this16.setWixHeight(_this16.state.galleryLayout.height, Math.round(_this16.getGalleryHeight()), trigger);
          }
        });

        var actions = _this16.props.actions;

        switch (trigger) {
          case _this16.renderTriggers.SCROLL:
            if (params && actions.galleryWindowLayoutChanged) {
              actions.galleryWindowLayoutChanged(params);
            }
            break;
          case _this16.renderTriggers.MODE:
            actions.editorModeChanged();
            break;
          case _this16.renderTriggers.STYLES:
            actions.videoPlayModeChanged(newState.styleParams.videoPlay);
            break;
        }
      });

      this.scrollToItemIfNeeded();
    }
  }, {
    key: 'shouldRender',
    value: function shouldRender(newState) {

      if (_utils.utils.isVerbose()) {
        //todo yoshi
        console.count("galleryContainer shouldRender");
      }

      var state = newState || this.state;

      if (_lodash2.default.get(state, 'styleParams.gotStyleParams') === false) {
        if (_utils.utils.isVerbose()) {
          //todo yoshi
          console.log('Could not render gallery - did not get style params', state.styleParams);
        }
        return false;
      }

      if (state.container.galleryWidth <= 0) {
        if (_utils.utils.isVerbose()) {
          //todo yoshi
          console.log('Could not render gallery - width is 0');
        }
        return false;
      }

      if (!state.galleryLayout.ready) {
        if (_utils.utils.isVerbose()) {
          //todo yoshi
          console.log('Could not render gallery - preparation failed', state.galleryLayout.reason);
        }
        return false;
      }

      return true;
    }
  }, {
    key: 'render',
    value: function render() {

      if (!this.shouldRender()) {
        return false;
      }

      if (_utils.utils.isVerbose()) {
        //todo yoshi
        console.count("galleryContainer render");
        console.timeEnd("SCROLL - js logic time");
      }

      return this.shouldRender() && (this.state.styleParams.oneRow ? _react2.default.createElement(_slideshowView2.default, _extends({
        totalItemsCount: this.state.totalItemsCount,
        renderedItemsCount: this.state.renderedItemsCount,
        items: this.currentItems(),
        galleryLayout: this.state.galleryLayout,
        styleParams: this.state.styleParams,
        container: this.state.container,
        scroll: _lodash2.default.merge({}, this.state.scroll, { isInfinite: this.isInfiniteScroll() }),
        thumbnailSize: this.thumbnailSize,
        multishare: this.state.multishare,
        watermark: this.state.watermark,
        gotScrollEvent: this.state.gotScrollEvent,
        actions: _lodash2.default.merge(this.props.actions, {
          toggleInfiniteScroll: this.toggleInfiniteScroll,
          toggleFullscreen: this.toggleFullscreen,
          pauseAllVideos: this.pauseAllVideos,
          setWixHeight: this.setWixHeight,
          scrollToItem: this.scrollToItem,
          addItemToMultishare: this.addItemToMultishare,
          removeItemFromMultishare: this.removeItemFromMultishare
        }),
        debug: {
          lastHeight: this.lastHeight,
          newHeight: this.newHeight,
          resizeCount: this.resizeCount,
          orientationCount: this.orientationCount,
          maxGalleryWidth: this.props.maxGalleryWidth
        },
        store: this.props.store
      }, this.props.gallery)) : _react2.default.createElement(_galleryView2.default, _extends({
        totalItemsCount: this.state.totalItemsCount,
        renderedItemsCount: this.state.renderedItemsCount,
        items: this.currentItems(),
        galleryLayout: this.state.galleryLayout,
        styleParams: this.state.styleParams,
        container: this.state.container,
        scroll: _lodash2.default.merge({}, this.state.scroll, { isInfinite: this.isInfiniteScroll() }),
        multishare: this.state.multishare,
        watermark: this.state.watermark,
        gotScrollEvent: this.state.gotScrollEvent,
        actions: _lodash2.default.merge(this.props.actions, {
          toggleInfiniteScroll: this.toggleInfiniteScroll,
          toggleFullscreen: this.toggleFullscreen,
          pauseAllVideos: this.pauseAllVideos,
          setWixHeight: this.setWixHeight,
          scrollToItem: this.scrollToItem,
          addItemToMultishare: this.addItemToMultishare,
          removeItemFromMultishare: this.removeItemFromMultishare
        }),
        debug: {
          lastHeight: this.lastHeight,
          newHeight: this.newHeight,
          resizeCount: this.resizeCount,
          orientationCount: this.orientationCount,
          maxGalleryWidth: this.props.maxGalleryWidth
        },
        store: this.props.store
      }, this.props.gallery)));
    }
  }]);

  return GalleryContainer;
}(_react2.default.Component);

function mapStateToProps(state) {
  return state.gallery;
}

function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actions, dispatch)
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GalleryContainer);

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _groupView = __webpack_require__(169);

var _groupView2 = _interopRequireDefault(_groupView);

var _galleryEmpty = __webpack_require__(172);

var _galleryEmpty2 = _interopRequireDefault(_galleryEmpty);

var _galleryDebugMessage = __webpack_require__(173);

var _galleryDebugMessage2 = _interopRequireDefault(_galleryDebugMessage);

var _lodash = __webpack_require__(4);

var _lodash2 = _interopRequireDefault(_lodash);

var _index = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_index.utils.fixViewport('Gallery');

var GalleryView = function (_React$Component) {
  _inherits(GalleryView, _React$Component);

  function GalleryView(props) {
    _classCallCheck(this, GalleryView);

    var _this = _possibleConstructorReturn(this, (GalleryView.__proto__ || Object.getPrototypeOf(GalleryView)).call(this, props));

    _this.handleArrowKeys = _this.handleArrowKeys.bind(_this);
    _this.showMoreItems = _this.showMoreItems.bind(_this);

    _this.state = {
      currentIdx: 0
    };
    return _this;
  }

  _createClass(GalleryView, [{
    key: 'handleArrowKeys',
    value: function handleArrowKeys(e) {

      if (!_index.utils.isAccessibilityEnabled()) {
        return true;
      }

      var activeItemIdx = document.activeElement.getAttribute('data-idx');

      if (!!activeItemIdx) {

        var findNeighborItem = this.props.galleryLayout.findNeighborItem;
        var idx = Number(activeItemIdx);

        var newIdx = -1;

        switch (e.keyCode || e.charCode) {
          case 38:
            //up
            newIdx = findNeighborItem(idx, 'up');
            break;
          case 37:
            //left
            newIdx = findNeighborItem(idx, 'left');
            break;
          case 40:
            //down
            newIdx = findNeighborItem(idx, 'down');
            break;
          case 39:
            //right
            newIdx = findNeighborItem(idx, 'right');
            break;
        }

        if (newIdx >= 0) {
          e.preventDefault();
          e.stopPropagation();
          _index.utils.setStateAndLog(this, 'Set Gallery Current Item', {
            currentIdx: newIdx
          });
          return false;
        }
      }

      return true;
    }
  }, {
    key: 'showMoreItems',
    value: function showMoreItems() {
      var _this2 = this;

      if (_index.utils.isAccessibilityEnabled()) {
        //find the last visible item and focus on it
        try {
          var lastItemIdx = this.props.galleryLayout.lastVisibleItemIdx();
          _index.utils.setStateAndLog(this, 'Focus on Last Gallery Item', {
            currentIdx: lastItemIdx + 1
          }, function () {
            _this2.props.actions.toggleInfiniteScroll();
          });
        } catch (e) {
          console.warn('Cannot find item to focus', e);
        }
      } else {
        this.props.actions.toggleInfiniteScroll();
      }
    }
  }, {
    key: 'createShowMoreButton',
    value: function createShowMoreButton() {
      var showMoreButton = false;
      var shouldShowButton = !this.props.scroll.isInfinite && this.props.galleryLayout.height > $(window).height();

      if (shouldShowButton) {

        var buttonText = this.props.styleParams.loadMoreButtonText || 'Load More';

        showMoreButton = _react2.default.createElement(
          'div',
          { className: 'show-more-container' },
          _react2.default.createElement(
            'button',
            {
              tabIndex: _index.utils.getTabIndex('loadMoreButton'),
              className: 'show-more',
              onClick: this.showMoreItems,
              'data-hook': 'show-more',
              'aria-label': buttonText
            },
            buttonText
          )
        );
      }

      return showMoreButton;
    }
  }, {
    key: 'createNavArrows',
    value: function createNavArrows() {
      var _this3 = this;

      return this.props.styleParams.showArrows ? [_react2.default.createElement('i', {
        className: "nav-arrows prev progallery-svg-font-icons-arrow_left " + (this.isFirstItem() ? ' inactive ' : ''),
        onClick: function onClick() {
          return _this3.nextItem(-1);
        },
        key: 'nav-arrow-back',
        'data-hook': 'nav-arrow-back'
      }), _react2.default.createElement('i', {
        className: "nav-arrows next progallery-svg-font-icons-arrow_right " + (this.isLastItem() ? ' inactive ' : ''),
        onClick: function onClick() {
          return _this3.nextItem(1);
        },
        key: 'nav-arrow-next',
        'data-hook': 'nav-arrow-next'
      })] : false;
    }

    //-----------------------------------------| RENDER |--------------------------------------------//

  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      if (_index.utils.isDev()) {
        console.count("galleryView render");
      }

      //this.gallery = this.prepareGallery(this.state.images);
      if (_index.utils.isDev()) {
        console.count('Rendering Gallery count');
        console.time('Rendering Gallery took ');
      }

      var loader = this.totalItemsCount > this.props.renderedItemsCount ? _react2.default.createElement(
        'div',
        { className: 'more-items-loader' },
        _react2.default.createElement('i', { className: 'pro-circle-preloader' })
      ) : false;

      var showMore = this.createShowMoreButton();

      var navArrows = this.createNavArrows();

      var galleryHeight = showMore ? window.innerHeight - 138 + 'px' : navArrows ? window.innerHeight : '100%';

      var debugMsg = _react2.default.createElement(_galleryDebugMessage2.default, this.props.debug);

      var galleryConfig = {
        scroll: this.props.scroll,
        styleParams: this.props.styleParams,
        multishare: this.props.multishare,
        watermark: this.props.watermark,
        currentIdx: this.state.currentIdx,
        actions: {
          toggleFullscreen: this.props.actions.toggleFullscreen,
          pauseAllVideos: this.props.actions.pauseAllVideos,
          addItemToMultishare: this.props.actions.addItemToMultishare,
          removeItemFromMultishare: this.props.actions.removeItemFromMultishare
        }
      };

      var layout = _lodash2.default.map(this.props.galleryLayout.columns, function (column, c) {

        var paddingTop = 0;
        if (_this4.props.gotScrollEvent) {
          var firstGroup = _lodash2.default.find(column, function (group) {
            return group.rendered;
          }) || {};
          paddingTop = firstGroup.top || 0;
        }

        return _react2.default.createElement(
          'div',
          { 'data-hook': 'gallery-column', className: 'gallery-column', key: 'column' + c,
            style: { width: _this4.props.galleryLayout.colWidth, paddingTop: paddingTop } },
          column.map(function (group) {
            return group.rendered ? _react2.default.createElement(_groupView2.default, _lodash2.default.merge(group.getViewProps(galleryConfig), { store: _this4.props.store })) : false;
          })
        );
      });

      var gallery = _react2.default.createElement(
        'div',
        { id: 'pro-gallery-container', className: "pro-gallery inline-styles " + (this.props.styleParams.oneRow ? ' one-row slider hide-scrollbars ' : '') + (_index.utils.isAccessibilityEnabled() ? ' accessible ' : ''),
          style: {
            height: galleryHeight
          },
          onKeyDown: this.handleArrowKeys
        },
        debugMsg,
        layout,
        loader,
        navArrows
      );

      var emptyState = !(this.props.renderedItemsCount > 0) && _index.utils.isEditor() ? _react2.default.createElement(_galleryEmpty2.default, {
        actions: {
          setWixHeight: this.props.actions.setWixHeight
        }
      }) : '';

      if (_index.utils.isDev()) {
        console.timeEnd('Rendering Gallery took ');
      }

      var screenLogs = _index.utils.shouldDebug('screenLogs') ? _react2.default.createElement(
        'div',
        { className: 'screen-logs' },
        'URL width: ',
        _index.utils.parseGetParam('width'),
        ', Container: ',
        JSON.stringify(this.props.container.galleryWidth),
        ', document.body.clientWidth ',
        document.body.clientWidth,
        ', window.innerWidth ',
        window.innerWidth,
        ', window.screen.width: ',
        window.screen.width
      ) : '';

      return _react2.default.createElement(
        'div',
        { className: "pro-gallery-parent-container" },
        screenLogs,
        emptyState,
        gallery,
        showMore
      );
    }
  }]);

  return GalleryView;
}(_react2.default.Component);

exports.default = GalleryView;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _itemView = __webpack_require__(243);

var _itemView2 = _interopRequireDefault(_itemView);

var _commonItemContainer = __webpack_require__(159);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ItemContainer = function (_React$Component) {
  _inherits(ItemContainer, _React$Component);

  function ItemContainer(props, context) {
    _classCallCheck(this, ItemContainer);

    var _this = _possibleConstructorReturn(this, (ItemContainer.__proto__ || Object.getPrototypeOf(ItemContainer)).call(this, props, context));

    _this.displayName = 'ItemContainer';

    return _this;
  }

  _createClass(ItemContainer, [{
    key: 'isSmallItem',
    value: function isSmallItem() {
      var maxWidth = 90;
      var maxHeight = 90;

      if (this.props.styleParams.cubeImages && this.props.styleParams.cubeType == 'fit') {
        if (this.props.style.orientation == 'landscape') {
          //wide image
          return this.props.style.width / this.props.style.ratio <= maxHeight;
        } else {
          //tall image
          return this.props.style.height * this.props.style.ratio <= maxWidth;
        }
      } else {
        return this.props.style.width <= maxWidth || this.props.style.height <= maxHeight;
      }
    }
  }, {
    key: 'isNarrow',
    value: function isNarrow() {
      return this.props.style.width < 200;
    }
  }, {
    key: 'isShort',
    value: function isShort() {
      return this.props.style.height < 150;
    }
  }, {
    key: 'render',
    value: function render() {
      this.props.love.showCounter = this.props.styleParams.loveCounter && !this.isSmallItem() && !this.isNarrow();
      return _react2.default.createElement(_itemView2.default, _extends({
        layout: 'galleryItem',
        className: 'image',
        isSmallItem: this.isSmallItem(),
        isNarrow: this.isNarrow(),
        isShort: this.isShort()
      }, this.props));
    }
  }]);

  return ItemContainer;
}(_react2.default.Component);

;

exports.default = (0, _commonItemContainer.CommonItemContainer)(ItemContainer);

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(29);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _loveButton = __webpack_require__(67);

var _loveButton2 = _interopRequireDefault(_loveButton);

var _imageItem = __webpack_require__(244);

var _imageItem2 = _interopRequireDefault(_imageItem);

var _videoItem = __webpack_require__(245);

var _videoItem2 = _interopRequireDefault(_videoItem);

var _textItem = __webpack_require__(246);

var _textItem2 = _interopRequireDefault(_textItem);

var _videoItemPlaceholder = __webpack_require__(247);

var _videoItemPlaceholder2 = _interopRequireDefault(_videoItemPlaceholder);

var _itemHover = __webpack_require__(248);

var _itemHover2 = _interopRequireDefault(_itemHover);

var _texts = __webpack_require__(249);

var _texts2 = _interopRequireDefault(_texts);

var _social = __webpack_require__(253);

var _social2 = _interopRequireDefault(_social);

var _share = __webpack_require__(254);

var _share2 = _interopRequireDefault(_share);

var _customButton = __webpack_require__(170);

var _customButton2 = _interopRequireDefault(_customButton);

var _itemTitle = __webpack_require__(171);

var _itemTitle2 = _interopRequireDefault(_itemTitle);

var _consts = __webpack_require__(106);

var _consts2 = _interopRequireDefault(_consts);

var _cartApi = __webpack_require__(26);

var _cartApi2 = _interopRequireDefault(_cartApi);

var _classnames = __webpack_require__(158);

var _classnames2 = _interopRequireDefault(_classnames);

var _index = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /// <reference path="../../reference.ts" />

var ItemView = function (_React$Component) {
  _inherits(ItemView, _React$Component);

  function ItemView(props) {
    _classCallCheck(this, ItemView);

    _index.utils.itemLoadStart();

    var _this = _possibleConstructorReturn(this, (ItemView.__proto__ || Object.getPrototypeOf(ItemView)).call(this, props));

    _this.init();

    _this.state = {
      failed: false,
      loaded: false,
      retries: 0,
      showShare: false,
      showHover: false
    };

    _this.videoQueue = window.videoQueue;

    return _this;
  }

  //-------------------------------------------| INIT |--------------------------------------------//

  _createClass(ItemView, [{
    key: 'init',
    value: function init() {
      var _this2 = this;

      this.onItemClick = this.onItemClick.bind(this);
      this.onKeyPress = this.onKeyPress.bind(this);
      this.toggleFullscreenIfNeeded = this.toggleFullscreenIfNeeded.bind(this);
      this.toggleMultishareSelection = this.toggleMultishareSelection.bind(this);
      this.handleItemMouseDown = this.handleItemMouseDown.bind(this);
      this.handleItemMouseUp = this.handleItemMouseUp.bind(this);
      this.setItemLoaded = this.setItemLoaded.bind(this);
      this.setItemError = this.setItemError.bind(this);
      this.isMultishared = this.isMultishared.bind(this);
      this.isMultisharing = this.isMultisharing.bind(this);
      this.isVerticalContainer = this.isVerticalContainer.bind(this);
      this.toggleShare = this.toggleShare.bind(this);
      this.getShare = this.getShare.bind(this);
      this.getItemHover = this.getItemHover.bind(this);
      this.getImageItem = this.getImageItem.bind(this);
      this.getVideoItem = this.getVideoItem.bind(this);
      this.getTextItem = this.getTextItem.bind(this);
      this.getItemInner = this.getItemInner.bind(this);

      if (_index.utils.isEditor()) {
        Wix.addEventListener(Wix.Events.SETTINGS_UPDATED, function (data) {
          setTimeout(function () {
            _this2.setState({
              showHover: data.detail == 2
            });
          }, 50);
        });
      }

      if (_index.utils.isSemiNative()) {
        this.onMouseOverEvent = new window.CustomEvent('on_mouse_over'); // MUST be 'CustomEvent'
      } else {
        this.onMouseOverEvent = document.createEvent('CustomEvent'); // MUST be 'CustomEvent'
        this.onMouseOverEvent.initCustomEvent('on_mouse_over', false, false, null);
      }
    }

    //----------------------------------------| ACTIONS |-------------------------------------------//

  }, {
    key: 'setItemError',
    value: function setItemError() {
      this.setState({
        retries: this.state.retries + 1
      });

      if (this.state.retries > 3) {
        console.error('Error (including retries) loading item #' + this.props.idx);
        this.setState({
          failed: true
        });
      }
    }
  }, {
    key: 'setItemLoaded',
    value: function setItemLoaded(e) {
      _index.utils.itemLoaded();
      this.setState({
        failed: false,
        loaded: true
      });
    }
  }, {
    key: 'toggleShare',
    value: function toggleShare(event, forceVal) {
      event.stopPropagation();
      var isIconTag = function isIconTag(tagName) {
        return ['button', 'i', 'a'].indexOf(tagName.toLowerCase()) >= 0;
      };
      if (event.type == "mouseout" && (isIconTag(event.target.tagName) || event.relatedTarget && isIconTag(event.relatedTarget.tagName))) {
        //mouseout event should not be fired if hovering over icons (tag name == I)
        return;
      }

      this.setState({
        showShare: _.isUndefined(forceVal) ? !this.state.showShare : !!forceVal
      });
    }
  }, {
    key: 'toggleHoverOnMobile',
    value: function toggleHoverOnMobile() {
      this.setState({
        showHover: !this.state.showHover
      });
    }
  }, {
    key: 'onMouseOver',
    value: function onMouseOver(imageUrl) {
      this.onMouseOverEvent.itemIdx = this.props.idx;
      window.dispatchEvent(this.onMouseOverEvent);
      if (this.props.type == 'video') {
        this.onVideoHover();
      }
    }
  }, {
    key: 'onVideoHover',
    value: function onVideoHover() {
      var _props$styleParams = this.props.styleParams,
          videoPlay = _props$styleParams.videoPlay,
          itemClick = _props$styleParams.itemClick;

      var canVideoPlayInGallery = _index.utils.isMobile() ? itemClick !== 'expend' : !(itemClick == 'expend' && videoPlay == 'onClick');

      if (this.props.styleParams.videoPlay == 'hover' && !_index.utils.isMobile()) {
        this.props.playVideo(this.props.idx);
      }
    }
  }, {
    key: 'onKeyPress',
    value: function onKeyPress(e) {
      switch (e.keyCode || e.charCode) {
        case 32: //space
        case 13:
          //enter
          e.preventDefault();
          e.stopPropagation();
          this.onItemClick(e, false); //pressing enter or space always behaves as click on main image, even if the click is on a thumbnail
          return false;
      }
    }
  }, {
    key: 'onItemClick',
    value: function onItemClick(e, isThumbnail) {

      e.preventDefault();

      var _props$styleParams2 = this.props.styleParams,
          itemClick = _props$styleParams2.itemClick,
          videoPlay = _props$styleParams2.videoPlay;


      if (!_.isBoolean(isThumbnail)) isThumbnail = !!this.props.thumbnailHighlightId;

      if (!isThumbnail && _.isFunction(_.get(window, 'galleryWixCodeApi.onItemClicked'))) {
        window.galleryWixCodeApi.onItemClicked(this.props);
      }

      if (isThumbnail === true && _.isFunction(this.props.actions.scrollToItem)) {
        //the click is on a thumbnail
        this.props.actions.scrollToItem(this.props.idx);
      } else {
        if (itemClick == "expand" || itemClick == 'link') {
          // fedopsLogger.interactionStarted('expendModeOpen')
          this.props.actions.toggleFullscreen(this.props.idx);
        } else if (itemClick === 'nothing' && _index.utils.isMobile()) {
          this.toggleHoverOnMobile();
        } else if (this.props.type == 'video') {
          var shouldTogglePlay = itemClick !== 'expend' && (videoPlay == 'onClick' || _index.utils.isMobile());
          if (shouldTogglePlay) {
            this.props.playing ? this.props.pauseVideo(this.props.idx) : this.props.playVideo(this.props.idx);
          }
        }
      }
    }
  }, {
    key: 'toggleFullscreenIfNeeded',
    value: function toggleFullscreenIfNeeded(e) {
      var targetClass = _.get(e, 'target.className');
      if (_.isObject(targetClass)) {
        targetClass = _.valuesIn(targetClass);
      }

      if (_.isFunction(targetClass.indexOf) && targetClass.indexOf('block-fullscreen') >= 0) {
        console.warn("Blocked fullscreen!", e);
        return;
      } else if (this.props.styleParams.fullscreen) {
        this.props.actions.toggleFullscreen(this.props.idx);
      }
    }
  }, {
    key: 'toggleMultishareSelection',
    value: function toggleMultishareSelection(e) {
      if (e && e.stopPropagation) {
        e.stopPropagation();
      }
      var itemContainer = $(this.itemContainer);
      itemContainer.css({
        transform: 'scale(' + (this.props.style.width - 8) / this.props.style.width + ')'
      });
      setTimeout(function () {
        itemContainer.css({
          transform: 'scale(1)'
        });
      }, 80);

      if (this.isMultishared()) {
        this.props.actions.removeItemFromMultishare(this.props);
      } else {
        this.props.actions.addItemToMultishare(this.props);
      }
    }
  }, {
    key: 'handleItemMouseDown',
    value: function handleItemMouseDown(e) {
      var _this3 = this;

      if (_index.utils.isMobile() && this.props.styleParams.allowMultishare) {
        clearTimeout(this.longPressTimer);
        this.longPressTimer = setTimeout(function () {
          e.preventDefault(); //prevent default only after a long press (so that scroll will not break)
          _this3.toggleMultishareSelection(e);
        }, 500);
      }
      return true; //make sure the default event behaviour continues
    }
  }, {
    key: 'handleItemMouseUp',
    value: function handleItemMouseUp(e) {
      if (_index.utils.isMobile() && this.longPressTimer) {
        clearTimeout(this.longPressTimer);
      }
      return true; //make sure the default event behaviour continues
    }

    //-----------------------------------------| UTILS |--------------------------------------------//

  }, {
    key: 'isSmallItem',
    value: function isSmallItem() {
      return this.props.isSmallItem && !this.props.styleParams.isSlideshow;
    }
  }, {
    key: 'isVerticalContainer',
    value: function isVerticalContainer() {
      return this.props.style.width < this.props.style.height + 1;
    }
  }, {
    key: 'shouldShowHoverOnMobile',
    value: function shouldShowHoverOnMobile() {
      return _index.utils.isMobile() && this.props.styleParams.itemClick == 'nothing';
    }
  }, {
    key: 'shouldHover',
    value: function shouldHover() {
      if (this.isMultisharing()) {
        return true;
      } else if (this.props.styleParams.isSlideshow) {
        return false;
      } else if (_index.utils.isMobile()) {
        return this.shouldShowHoverOnMobile();
      } else if (_index.utils.isEditor()) {
        return this.state.showHover;
      } else {
        return true;
      }
    }
  }, {
    key: 'isMultishared',
    value: function isMultishared() {
      var _this4 = this;

      var items = _.get(this, 'props.multishare.items');
      return items && !!_.find(items, function (itemProps) {
        return itemProps.id == _this4.props.id;
      });
    }
  }, {
    key: 'isMultisharing',
    value: function isMultisharing() {
      return _.get(this, 'props.multishare.isMultisharing');
    }

    //---------------------------------------| COMPONENTS |-----------------------------------------//


  }, {
    key: 'getImageDimensions',
    value: function getImageDimensions() {
      //image dimensions are for images in grif fit - placing the image with positive margins to show it within the square
      var imageIsWider = this.props.style.ratio >= this.props.cubeRatio;
      var imageMarginLeft = Math.round((this.props.style.height * this.props.style.ratio - this.props.style.width) / -2);
      var imageMarginTop = Math.round((this.props.style.width / this.props.style.ratio - this.props.style.height) / -2);

      return !(this.props.styleParams.cubeImages && this.props.styleParams.cubeType == 'fit') ? {} : !imageIsWider ? {
        width: 'calc(100% - 2 * ' + Math.round(imageMarginLeft - this.props.styleParams.imageMargin / 2) + 'px)',
        marginLeft: Math.round(imageMarginLeft - this.props.styleParams.imageMargin / 2)
      } : {
        height: 'calc(100% - 2 * ' + Math.round(imageMarginTop - this.props.styleParams.imageMargin / 2) + 'px)',
        marginTop: Math.round(imageMarginTop - this.props.styleParams.imageMargin / 2)
      };
    }
  }, {
    key: 'isVisible',
    value: function isVisible(elment) {
      if (_index.utils.isDev()) {
        console.time('Video isVisible');
        console.count('Video isVisible');
      }
      var domElment = _reactDom2.default.findDOMNode(elment.video);
      if (!domElment) {
        return false;
      }
      var windowHeight = this.props.documentHeight;
      var scrollPosition = this.props.scroll.top;

      var _domElment$getBoundin = domElment.getBoundingClientRect(),
          top = _domElment$getBoundin.top,
          bottom = _domElment$getBoundin.bottom;

      var videoHeight = bottom - top;
      var tolerance = videoHeight / 2;
      var res = top + tolerance > scrollPosition && bottom - tolerance < scrollPosition + windowHeight;

      if (_index.utils.isDev()) {
        console.timeEnd('Video isVisible');
      }

      return res;
    }
  }, {
    key: 'getButtonPlacement',
    value: function getButtonPlacement() {
      return _index.utils.isStoreGallery() ? this.props.styleParams.titlePlacement : _consts2.default.placements.DONT_SHOW;
    }
  }, {
    key: 'videoOnMount',
    value: function videoOnMount(videoElment) {
      var _this5 = this;

      window.videoQueue.addItem({ idx: this.props.idx, isVisible: function isVisible() {
          return _this5.isVisible(videoElment);
        } });
      this.props.videoAdded(window.videoQueue.current());
    }
  }, {
    key: 'videoOnUnmount',
    value: function videoOnUnmount() {
      window.videoQueue.removeItem(this.props.idx);
    }
  }, {
    key: 'getItemTextsDetails',
    value: function getItemTextsDetails() {
      var props = _.pick(this.props, ['title', 'description', 'fileName', 'id', 'styleParams', 'style', 'isNarrow']);
      var isButtonPlacementOnHover = this.getButtonPlacement() == _consts2.default.placements.SHOW_ON_HOVER;
      var isImage = this.props.type == 'image' || this.props.type == 'picture';
      var useCustomButton = this.props.styleParams.useCustomButton == true;
      var shouldShowButton = isButtonPlacementOnHover && isImage && useCustomButton;

      return _react2.default.createElement(_texts2.default, _extends({}, props, {
        key: 'item-texts-' + props.id,
        showShare: this.state.showShare,
        isSmallItem: this.isSmallItem(),
        titlePlacement: this.props.styleParams.titlePlacement,
        shouldShowButton: shouldShowButton }));
    }
  }, {
    key: 'getSocial',
    value: function getSocial() {
      var props = _.pick(this.props, ['id', 'styleParams', 'style', 'love', 'isDemo', 'type', 'download_url', 'originalsUrl', 'isNarrow', 'isShort']);
      return _react2.default.createElement(_social2.default, _extends({}, props, {
        allProps: this.props,
        showShare: this.state.showShare,
        isSmallItem: this.isSmallItem(),
        isVerticalContainer: this.isVerticalContainer(),
        key: 'item-social-' + props.id,
        actions: {
          openItemShopInFullScreen: this.openItemShopInFullScreen,
          toggleMultishareSelection: this.toggleMultishareSelection,
          toggleShare: this.toggleShare,
          getShare: this.getShare,
          showTooltip: itemActions.showTooltip,
          hideTooltip: itemActions.hideTooltip
        }
      }));
    }
  }, {
    key: 'getShare',
    value: function getShare() {
      var props = _.pick(this.props, ['styleParams', 'id', 'type', 'style', 'currentIdx', 'idx']);
      return _react2.default.createElement(_share2.default, _extends({}, props, {
        allProps: this.props,
        key: 'item-share-' + props.id,
        showShare: this.state.showShare,
        isVerticalContainer: this.isVerticalContainer(),
        actions: {
          toggleShare: this.toggleShare
        }
      }));
    }
  }, {
    key: 'getItemHover',
    value: function getItemHover(children, imageDimensions) {
      var props = _.pick(this.props, ['styleParams', 'type', 'idx', 'type']);
      return _react2.default.createElement(
        _itemHover2.default,
        _extends({}, props, {
          forceShowHover: this.state.showHover,
          isMultisharing: this.isMultisharing(),
          isMultishared: this.isMultishared(),
          shouldHover: this.shouldHover(),
          imageDimensions: imageDimensions,
          key: 'hover',
          actions: {
            handleItemMouseDown: this.handleItemMouseDown,
            handleItemMouseUp: this.handleItemMouseUp,
            toggleMultishareSelection: this.toggleMultishareSelection
          }
        }),
        children
      );
    }
  }, {
    key: 'getImageItem',
    value: function getImageItem(imageDimensions) {
      var props = _.pick(this.props, ['alt', 'title', 'description', 'visible', 'id', 'styleParams', 'resized_url']);
      return _react2.default.createElement(_imageItem2.default, _extends({}, props, {
        key: 'imageItem',
        loaded: this.state.loaded,
        imageDimensions: imageDimensions,
        isThumbnail: !!this.props.thumbnailHighlightId,
        actions: {
          handleItemMouseDown: this.handleItemMouseDown,
          handleItemMouseUp: this.handleItemMouseUp,
          setItemLoaded: this.setItemLoaded,
          setItemError: this.setItemError
        }
      }));
    }
  }, {
    key: 'getVideoItem',
    value: function getVideoItem(imageDimensions, itemHover) {
      var props = _.pick(this.props, []);
      return _react2.default.createElement(_videoItem2.default, _extends({}, this.props, {
        onMount: this.videoOnMount.bind(this),
        onUnmount: this.videoOnUnmount.bind(this),
        onEnd: this.props.videoEnded.bind(this),
        key: 'video' + this.props.idx,
        hover: itemHover,
        imageDimensions: imageDimensions,
        loadingStatus: {
          failed: this.state.failed,
          loaded: this.state.loaded
        },
        onClick: this.handleVideoClick,
        actions: _.merge({}, this.props.actions, {
          setItemLoaded: this.setItemLoaded,
          setItemError: this.setItemError,
          handleItemMouseDown: this.handleItemMouseDown,
          handleItemMouseUp: this.handleItemMouseUp,
          toggleMultishareSelection: this.toggleMultishareSelection,
          isMultishared: this.isMultishared,
          isMultisharing: this.isMultisharing
        })
      }));
    }
  }, {
    key: 'getTextItem',
    value: function getTextItem() {
      var props = _.pick(this.props, ['visible', 'id', 'styleParams', 'style', 'html', 'cubeRatio']);

      return _react2.default.createElement(_textItem2.default, _extends({}, props, {
        key: 'textItem',
        actions: {
          handleItemMouseDown: this.handleItemMouseDown,
          handleItemMouseUp: this.handleItemMouseUp
        }
      }));
    }
  }, {
    key: 'getItemInner',
    value: function getItemInner() {
      var _props = this.props,
          styleParams = _props.styleParams,
          id = _props.id,
          title = _props.title;

      var itemInner;

      var imageDimensions = this.getImageDimensions();
      var itemTexts = this.getItemTextsDetails();
      var social = this.getSocial();
      var share = this.getShare();

      var itemHover = this.getItemHover([itemTexts, social, share], imageDimensions);

      switch (this.props.type) {
        case 'dummy':
          itemInner = _react2.default.createElement('div', null);
          break;
        case 'video':
          if (!this.props.visible) {
            itemInner = _react2.default.createElement(_videoItemPlaceholder2.default, { id: this.props.idx, resized_url: this.props.resized_url, hover: itemHover });
          } else {
            itemInner = this.getVideoItem(imageDimensions, itemHover);
          }

          break;
        case 'text':
          itemInner = [this.getTextItem(), itemHover];
          break;
        case 'image':
        case 'picture':
        default:
          itemInner = [this.getImageItem(imageDimensions), itemHover];
      }

      if (styleParams.isSlideshow) {
        itemInner = _react2.default.createElement(
          'div',
          null,
          itemInner,
          this.props.currentIdx === this.props.idx ? _react2.default.createElement(
            'div',
            { className: 'gallery-item-info gallery-item-bottom-info' },
            _react2.default.createElement(
              'div',
              null,
              itemTexts,
              social,
              share
            )
          ) : false
        );
      }

      return itemInner;
    }
  }, {
    key: 'openItemShopInFullScreen',
    value: function openItemShopInFullScreen(e) {
      e.preventDefault();
      e.stopPropagation();
      this.toggleFullscreenIfNeeded(e, { openShop: true });
    }
  }, {
    key: 'mouseOver',
    value: function mouseOver(imageUrl) {
      this.onMouseOverEvent.itemIdx = this.props.idx;
      window.dispatchEvent(this.onMouseOverEvent);
    }
  }, {
    key: 'getBottomInfoElement',
    value: function getBottomInfoElement() {
      var _this6 = this;

      var _props2 = this.props,
          styleParams = _props2.styleParams,
          style = _props2.style,
          title = _props2.title,
          fileName = _props2.fileName,
          type = _props2.type,
          actions = _props2.actions;

      var displayTitle = title || fileName;
      var placements = _consts2.default.placements;

      var buttonPlacement = this.getButtonPlacement();
      var bottomInfo = null;

      if (styleParams.titlePlacement == placements.SHOW_ALWAYS) {
        var buttonElem = null;
        var isImage = type == "image" || type == "picture";
        if (isImage) {
          var shouldShowButton = buttonPlacement == placements.SHOW_ALWAYS && styleParams.useCustomButton === true;
          buttonElem = shouldShowButton ? _react2.default.createElement(_customButton2.default, { styleParams: styleParams }) : null;
        }
        var isTitleAvailable = styleParams.allowTitle && displayTitle;
        var titleElem = isTitleAvailable ? _react2.default.createElement(_itemTitle2.default, { title: displayTitle }) : null;
        if (titleElem || buttonElem) {
          bottomInfo = _react2.default.createElement(
            'div',
            { style: { height: style.bottomInfoHeight, textAlign: styleParams.galleryTextAlign },
              className: 'gallery-item-bottom-info',
              onMouseOver: function onMouseOver() {
                _this6.setState({ showHover: true });
              },
              onMouseOut: function onMouseOut() {
                _this6.setState({ showHover: false });
              } },
            titleElem,
            buttonElem
          );
        }
      }
      return bottomInfo;
    }
    //-----------------------------------------| REACT |--------------------------------------------//

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (_index.utils.isMobile()) {
        try {
          _react2.default.initializeTouchEvents(true);
        } catch (e) {}
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      //
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (_index.utils.isSite() && _index.utils.isAccessibilityEnabled()) {
        //check if thumbnailId has changed to the current item
        var isAnotherItemInFocus = document.activeElement.className.indexOf('gallery-item-container') >= 0;
        var isShowMoreInFocus = document.activeElement.className.indexOf('show-more') >= 0;
        if (isAnotherItemInFocus || isShowMoreInFocus) {
          if (this.props.thumbnailHighlightId != prevProps.thumbnailHighlightId && this.props.thumbnailHighlightId === this.props.id) {
            this.itemContainer.focus();
          }
          //check if currentIdx has changed to the current item
          else if (this.props.currentIdx != prevProps.currentIdx && this.props.currentIdx === this.props.idx) {
              this.itemContainer.focus();
            }
        }
      }
    }

    //-----------------------------------------| RENDER |--------------------------------------------//

  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      var _props3 = this.props,
          styleParams = _props3.styleParams,
          photoId = _props3.photoId,
          id = _props3.id,
          style = _props3.style,
          hash = _props3.hash,
          idx = _props3.idx,
          title = _props3.title,
          type = _props3.type;

      var itemInner = this.getItemInner();

      var isHighlight = this.props.thumbnailHighlightId && this.props.thumbnailHighlightId == this.props.id;
      var tabIndex = isHighlight ? _index.utils.getTabIndex('currentThumbnail') : this.props.currentIdx == this.props.idx ? _index.utils.getTabIndex('currentGalleryItem') : -1;

      var bottomInfo = this.getBottomInfoElement();
      var bottomInfoHeight = this.props.bottomInfoHeight || 0;
      var height = style.height - styleParams.imageMargin * 2;
      var wrapperWidth = style.width - styleParams.imageMargin * 2;
      var itemStyle = {};
      itemStyle.backgroundColor = styleParams.cubeType !== 'fit' ? style.bgColor : 'inherit';
      itemStyle.height = height + "px";

      var typeName = 'Graphic';
      switch (type) {
        case 'dummy':
          typeName = '';
          break;
        case 'text':
          typeName = 'Text Box';
          break;
        case 'video':
          typeName = 'Video';
          break;
      }

      var className = (0, _classnames2.default)('gallery-item-container', 'visible', {
        highlight: isHighlight,
        clickable: styleParams.itemClick !== 'nothing'
      });

      return _react2.default.createElement(
        'div',
        { className: className,
          href: itemActions.getShareUrl(this.props),
          ref: function ref(e) {
            return _this7.itemContainer = e;
          },
          onMouseOver: function onMouseOver() {
            return _this7.onMouseOver();
          },
          onClick: this.onItemClick,
          onKeyDown: this.onKeyPress,
          tabIndex: tabIndex,
          'data-hash': hash,
          'data-id': photoId,
          'data-idx': idx,
          'aria-label': typeName + ', ' + title + (_index.utils.isStoreGallery() ? ', Buy Now' : ''),
          role: 'link',
          'aria-level': '0',
          'data-hook': 'item-container',
          key: 'item-container-' + id,
          style: {
            'margin': styleParams.imageMargin + 'px',
            width: wrapperWidth,
            height: height + bottomInfoHeight,
            'position': style.position,
            'top': style.top,
            'left': style.left,
            'right': style.right,
            'bottom': style.bottom,
            'overflowY': styleParams.isSlideshow ? 'visible' : 'inherit'
          } },
        _react2.default.createElement(
          'div',
          { 'data-hook': 'item-wrapper', className: "gallery-item-wrapper visible " + (styleParams.cubeImages ? "cube-type-" + styleParams.cubeType : ""),
            key: 'item-wrapper-' + id,
            style: itemStyle
          },
          itemInner
        ),
        bottomInfo
      );
    }
  }]);

  return ItemView;
}(_react2.default.Component);

/*
 <img onLoad={() => this.setItemLoaded()} className={'image' + (this.state.loaded ? '' : '-preload')}
 src={this.props.resized_url}/>
 */

exports.default = ItemView;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(2);

var _loveButton = __webpack_require__(67);

var _loveButton2 = _interopRequireDefault(_loveButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ImageItem = function (_React$Component) {
  _inherits(ImageItem, _React$Component);

  function ImageItem(props) {
    _classCallCheck(this, ImageItem);

    return _possibleConstructorReturn(this, (ImageItem.__proto__ || Object.getPrototypeOf(ImageItem)).call(this, props));
  }

  _createClass(ImageItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isThumbnail = _props.isThumbnail,
          alt = _props.alt,
          visible = _props.visible,
          loaded = _props.loaded,
          styleParams = _props.styleParams,
          imageDimensions = _props.imageDimensions,
          resized_url = _props.resized_url,
          id = _props.id,
          actions = _props.actions;

      if (visible) {
        return _react2.default.createElement(
          'div',
          {
            className: 'gallery-item-visible gallery-item gallery-item-preloaded ' + (styleParams.cubeImages && styleParams.cubeType == 'fit' ? ' grid-fit ' : '') + (loaded ? 'loaded' : ''),
            onTouchStart: actions.handleItemMouseDown,
            onTouchEnd: actions.handleItemMouseUp,
            key: 'image_container-' + id,
            style: loaded || _index.utils.deviceHasMemoryIssues() ? {} : { backgroundImage: 'url(' + resized_url['thumb'] + ')' }
          },
          _react2.default.createElement('img', { onLoad: actions.setItemLoaded,
            key: (styleParams.cubeImages && styleParams.cubeType == 'fill' ? 'cubed-' : '') + 'image',
            className: 'gallery-item-visible gallery-item ' + (loaded ? 'loaded' : 'gallery-item-hidden'),
            src: resized_url['img'],
            alt: isThumbnail ? '' : alt,
            onError: actions.setItemError,
            style: imageDimensions
          }),
          isThumbnail ? false : _react2.default.createElement('div', { className: 'pro-circle-preloader', key: 'image-preloader-' + id })
        );
      } else {
        return _react2.default.createElement(
          'div',
          {
            className: 'gallery-item-visible gallery-item gallery-item-preloaded ' + (styleParams.cubeImages && styleParams.cubeType == 'fit' ? ' grid-fit ' : '') + (loaded ? 'loaded' : ''),
            key: 'image_container-' + id,
            style: _index.utils.deviceHasMemoryIssues() ? {} : { backgroundImage: 'url(' + resized_url['thumb'] + ')' }
          },
          _react2.default.createElement('img', { key: 'image-' + id,
            className: 'gallery-item-hidden gallery-item',
            style: imageDimensions,
            alt: isThumbnail ? '' : alt,
            src: ''
          })
        );
      }
    }
  }]);

  return ImageItem;
}(_react2.default.Component);

exports.default = ImageItem;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactPlayerFork = __webpack_require__(156);

var _reactPlayerFork2 = _interopRequireDefault(_reactPlayerFork);

var _utils = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//import ReactPlayer from '../../../../../react-player';

var VideoItem = function (_React$Component) {
  _inherits(VideoItem, _React$Component);

  function VideoItem(props) {
    _classCallCheck(this, VideoItem);

    var _this = _possibleConstructorReturn(this, (VideoItem.__proto__ || Object.getPrototypeOf(VideoItem)).call(this, props));

    _this.pause = _this.pause.bind(_this);
    _this.play = _this.play.bind(_this);
    _this.state = {
      playedOnce: false
    };
    return _this;
  }

  _createClass(VideoItem, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.playing) {
        this.setState({ playedOnce: true });
      }
    }
  }, {
    key: 'play',
    value: function play() {
      this.props.playVideo(this.props.idx);
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.props.pauseVideo();
    }

    // if we use this function again we need to see if jquery still exists in the project
    //
    // drawFrame(video, canvas) {
    //   const vWidth = video.videoWidth;
    //   const vHeight = video.videoHeight;
    //   const cWidth = $(video).width();
    //   const cHeight = $(video).height();
    //   let w = cWidth;
    //   let h = cHeight;
    //   if (vWidth > w || vHeight > h) {
    //     if (vWidth / w > vHeight / h) {
    //       h = (w / vWidth) * vHeight;
    //     }
    //     else {
    //       w = (h / vHeight) * vWidth;
    //     }
    //   }
    //
    //   $(canvas).width(cWidth);
    //   $(canvas).height(cHeight);
    //   canvas.width = cWidth;
    //   canvas.height = cHeight;
    //
    //   const context = canvas.getContext('2d');
    //   context.drawImage(video, (cWidth - w) / 2, (cHeight - h) / 2, w, h);
    //   $(canvas).css($(video).css('transform'));
    //   $(canvas).show();
    // }

    //-----------------------------------------| UTILS |--------------------------------------------//


  }, {
    key: 'createPlayerElement',
    value: function createPlayerElement() {
      var _this2 = this;

      //video dimensions are for videos in grid fill - placing the video with negative margins to crop into a square
      var isWiderThenContainer = this.props.style.ratio >= this.props.cubeRatio;

      var videoDimensionsCss = {
        width: isWiderThenContainer ? '100%' : 'auto',
        height: isWiderThenContainer ? 'auto' : '100%'
      };

      if (this.props.styleParams.cubeImages && this.props.styleParams.cubeType == 'fill') {
        var _ref = [videoDimensionsCss.height, videoDimensionsCss.width]; //grid crop mode

        videoDimensionsCss.width = _ref[0];
        videoDimensionsCss.height = _ref[1];

        if (isWiderThenContainer) {
          videoDimensionsCss['marginLeft'] = Math.round((this.props.style.height * this.props.style.ratio - this.props.style.width) / -2);
        } else {
          videoDimensionsCss['marginTop'] = Math.round((this.props.style.width / this.props.style.ratio - this.props.style.height) / -2);
        }
      }
      return _react2.default.createElement(_reactPlayerFork2.default, {
        className: 'gallery-item-visible video gallery-item',
        width: '100%',
        height: '100%',

        url: this.props.videoUrl ? this.props.videoUrl : this.props.resized_url['mp4'],
        loop: !!this.props.styleParams.videoLoop,

        ref: function ref(player) {
          return _this2.video = player;
        },
        volume: 0,

        playing: this.props.playing,
        poster: this.props.resized_url['img'],
        mockPlayer: !this.state.playedOnce && (this.props.isExternalVideo || _utils.utils.isMobile()),
        onEnded: function onEnded() {
          return _this2.props.onEnd();
        },
        playbackRate: this.props.styleParams.videoSpeed || 1,
        fileConfig: {
          attributes: {
            preload: "metadata",
            poster: this.props.resized_url['img'],
            style: videoDimensionsCss
          }
        },
        key: 'video-' + this.props.id
      });
    }
  }, {
    key: 'createImageElement',
    value: function createImageElement() {
      return _react2.default.createElement('img', { onLoad: this.props.actions.setItemLoaded,
        onError: this.props.actions.setItemError,
        key: 'image-' + this.props.id,
        className: 'gallery-item-hidden gallery-item-visible gallery-item ' + (this.props.loadingStatus.loaded ? ' loaded ' : '') + (this.props.loadingStatus.failed ? ' failed ' : ''),
        src: this.props.resized_url['img'],
        style: this.props.imageDimensions });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.onMount(this);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.onUnmount();
    }

    //-----------------------------------------| RENDER |--------------------------------------------//

  }, {
    key: 'render',
    value: function render() {
      var baseClassName = 'gallery-item-visible gallery-item-preloaded gallery-item-video gallery-item' + (_utils.utils.isiPhone() ? ' ios' : '') + (this.props.loaded ? 'loaded' : '');
      if (this.props.playing) {
        baseClassName += ' playing';
      }
      var videoControls = this.props.hidePlay ? false : [_react2.default.createElement('i', { key: 'play-triangle', className: "gallery-item-video-play-triangle progallery-svg-font-icons-play-triangle " }), _react2.default.createElement('i', { key: 'play-bg', className: "gallery-item-video-play-background progallery-svg-font-icons-play-background " })];

      var videoPreloader = _react2.default.createElement('div', { className: 'pro-circle-preloader', key: 'video-preloader-' + this.props.idx });

      var _props$styleParams = this.props.styleParams,
          videoPlay = _props$styleParams.videoPlay,
          itemClick = _props$styleParams.itemClick;

      var canVideoPlayInGallery = _utils.utils.isMobile() ? itemClick !== 'expend' : !(itemClick == 'expend' && videoPlay == 'onClick');
      var video = canVideoPlayInGallery ? _react2.default.createElement(
        'div',
        {
          className: baseClassName + ' animated fadeIn ',
          key: 'video_container-' + this.props.id,
          style: _.merge(this.props.loaded || _utils.utils.deviceHasMemoryIssues() ? {} : { backgroundImage: 'url(' + this.props.resized_url['thumb'] + ')' }, this.props.imageDimensions)
        },
        this.createPlayerElement(),
        videoControls,
        videoPreloader
      ) : _react2.default.createElement(
        'div',
        {
          className: baseClassName,
          key: 'video_container-' + this.props.id,
          style: this.props.loaded || _utils.utils.deviceHasMemoryIssues() ? {} : { backgroundImage: 'url(' + this.props.resized_url['thumb'] + ')' }
        },
        this.createImageElement(),
        videoControls,
        videoPreloader
      );

      var hover = this.props.hover;

      return _react2.default.createElement(
        'div',
        { key: 'video-and-hover-container' + this.props.idx
        },
        [video, hover]
      );
    }
  }]);

  return VideoItem;
}(_react2.default.Component);

exports.default = VideoItem;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextItem = function (_React$Component) {
  _inherits(TextItem, _React$Component);

  function TextItem(props) {
    _classCallCheck(this, TextItem);

    return _possibleConstructorReturn(this, (TextItem.__proto__ || Object.getPrototypeOf(TextItem)).call(this, props));
  }

  _createClass(TextItem, [{
    key: 'getTextDimensions',
    value: function getTextDimensions() {
      var _props = this.props,
          style = _props.style,
          styleParams = _props.styleParams,
          cubeRatio = _props.cubeRatio;

      var isVerticalItem = style.ratio < cubeRatio - 0.01;
      //text dimensions include scaling
      var transform = 'translate(0, 0) scale(' + (isVerticalItem ? (style.height - styleParams.imageMargin * 2) / style.maxHeight : (style.width - styleParams.imageMargin * 2) / style.maxWidth) + ')';
      return {
        margin: Math.floor((style.maxHeight - style.height) / -2) - styleParams.imageMargin + 'px ' + (Math.floor((style.maxWidth - style.width) / -2) - this.props.styleParams.imageMargin) + 'px',
        width: style.maxWidth + 'px',
        height: style.maxHeight + 'px',
        WebkitTransform: transform,
        MsTransform: transform,
        OTransform: transform,
        transform: transform
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          visible = _props2.visible,
          id = _props2.id,
          styleParams = _props2.styleParams,
          html = _props2.html,
          style = _props2.style,
          actions = _props2.actions;

      var dimensions = this.getTextDimensions();

      return visible || styleParams.hasThumbnails ? _react2.default.createElement('div', { className: 'gallery-item-visible gallery-item loaded text-item',
        key: 'item-text-' + id,
        style: Object.assign(dimensions, styleParams.cubeType == 'fit' ? { 'backgroundColor': style.bgColor } : {}),
        onTouchStart: actions.handleItemMouseDown,
        onTouchEnd: actions.handleItemMouseUp,
        dangerouslySetInnerHTML: { __html: html } }) : _react2.default.createElement('div', { className: 'gallery-item-visible gallery-item loaded text-item',
        key: 'item-text-' + id,
        onTouchStart: actions.handleItemMouseDown,
        onTouchEnd: actions.handleItemMouseUp,
        style: dimensions });
    }
  }]);

  return TextItem;
}(_react2.default.Component);

exports.default = TextItem;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VideoItemPlaceholder = function (_React$Component) {
  _inherits(VideoItemPlaceholder, _React$Component);

  function VideoItemPlaceholder(props) {
    _classCallCheck(this, VideoItemPlaceholder);

    return _possibleConstructorReturn(this, (VideoItemPlaceholder.__proto__ || Object.getPrototypeOf(VideoItemPlaceholder)).call(this, props));
  }

  _createClass(VideoItemPlaceholder, [{
    key: 'render',
    value: function render() {
      var baseClassName = 'gallery-item-visible gallery-item-preloaded gallery-item-video gallery-item';
      return _react2.default.createElement(
        'div',
        { key: 'video-and-hover-container' + this.props.id },
        _react2.default.createElement(
          'div',
          { className: baseClassName, key: 'video-placeholder-container-' + this.props.id,
            style: _utils.utils.deviceHasMemoryIssues() ? {} : { backgroundImage: 'url(' + this.props.resized_url['thumb'] + ')' } },
          this.props.hover,
          _react2.default.createElement('div', { className: 'gallery--placeholder-item', key: 'video-' + this.props.id })
        )
      );
    }
  }]);

  return VideoItemPlaceholder;
}(_react2.default.Component);

exports.default = VideoItemPlaceholder;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ItemHover = function (_React$Component) {
  _inherits(ItemHover, _React$Component);

  function ItemHover(props) {
    _classCallCheck(this, ItemHover);

    return _possibleConstructorReturn(this, (ItemHover.__proto__ || Object.getPrototypeOf(ItemHover)).call(this, props));
  }

  _createClass(ItemHover, [{
    key: 'getHoverClass',
    value: function getHoverClass() {
      var _props = this.props,
          styleParams = _props.styleParams,
          forceShowHover = _props.forceShowHover,
          isMultisharing = _props.isMultisharing,
          itemType = _props.itemType;

      var hoverClass = itemType == 'video' ? ["gallery-item-hover-video"] : ["gallery-item-hover"];

      if (styleParams.isSlider || styleParams.isSlideshow || styleParams.hasThumbnails) {
        hoverClass.push(styleParams.galleryVerticalAlign);
      }

      hoverClass.push("fullscreen-" + (styleParams.fullscreen ? 'enabled' : 'disabled'));

      if (_.isUndefined(styleParams.itemOpacity)) {
        hoverClass.push('default');
      }

      // if (forceShowHover && utils.isEditor()) {
      if (forceShowHover) {
        hoverClass.push('hovered');
      } else if (_index.utils.isMobile()) {
        hoverClass.push('hide-hover');
      }

      if (isMultisharing) {
        hoverClass.push('hovered no-hover-bg');
      }
      return hoverClass.join(' ');
    }
  }, {
    key: 'getMultishareHover',
    value: function getMultishareHover() {
      var _props2 = this.props,
          isVideo = _props2.isVideo,
          isMultishared = _props2.isMultishared;

      return _react2.default.createElement(
        'div',
        { className: "gallery-item-social" + (isVideo ? ' gradient-top' : '') },
        _react2.default.createElement(
          'div',
          { className: 'gallery-item-social-button gallery-item-social-multishare visible ' + (_index.utils.isMobile() ? 'mobile' : '') },
          !isMultishared ? _react2.default.createElement(
            'svg',
            { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 18 18' },
            _react2.default.createElement('path', { className: 'gallery-item-svg-foreground',
              d: 'M9,1A8,8,0,1,1,1,9,8,8,0,0,1,9,1M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0Z' })
          ) : _react2.default.createElement(
            'svg',
            { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 18 18' },
            _react2.default.createElement('path', { className: 'gallery-item-svg-foreground',
              d: 'M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0ZM8.59,13.46l-4-4,.71-.71,3.16,3.16,4.44-6.67.83.55Z' }),
            _react2.default.createElement('polygon', { className: 'gallery-item-svg-background',
              points: '8.43 11.89 5.27 8.74 4.57 9.44 8.59 13.46 13.71 5.78 12.87 5.22 8.43 11.89' })
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          shouldHover = _props3.shouldHover,
          isMultisharing = _props3.isMultisharing,
          imageDimensions = _props3.imageDimensions,
          actions = _props3.actions,
          idx = _props3.idx;

      if (!shouldHover) {
        return null;
      }
      var hoverClass = this.getHoverClass();

      return _react2.default.createElement(
        'div',
        {
          className: hoverClass,
          key: 'item-hover-' + idx,
          'data-hook': 'item-hover-' + idx,
          style: imageDimensions,
          onClick: isMultisharing && actions.toggleMultishareSelection,
          onTouchStart: actions.handleItemMouseDown,
          onTouchEnd: actions.handleItemMouseUp
        },
        isMultisharing ? this.getMultishareHover() : this.props.children
      );
    }
  }]);

  return ItemHover;
}(_react2.default.Component);

exports.default = ItemHover;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _customButton = __webpack_require__(170);

var _customButton2 = _interopRequireDefault(_customButton);

var _itemTitle = __webpack_require__(171);

var _itemTitle2 = _interopRequireDefault(_itemTitle);

var _itemDescription = __webpack_require__(251);

var _itemDescription2 = _interopRequireDefault(_itemDescription);

var _lineHeightFixer = __webpack_require__(252);

var _lineHeightFixer2 = _interopRequireDefault(_lineHeightFixer);

var _consts = __webpack_require__(106);

var _consts2 = _interopRequireDefault(_consts);

var _index = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Texts = function (_React$Component) {
  _inherits(Texts, _React$Component);

  function Texts(props) {
    _classCallCheck(this, Texts);

    return _possibleConstructorReturn(this, (Texts.__proto__ || Object.getPrototypeOf(Texts)).call(this, props));
  }

  _createClass(Texts, [{
    key: 'getElementClassNames',
    value: function getElementClassNames() {
      var _props = this.props,
          showShare = _props.showShare,
          styleParams = _props.styleParams,
          isNarrow = _props.isNarrow;

      var classNames = ['gallery-item-text'];
      if (showShare) {
        classNames.push('hidden');
      }
      if (styleParams.showArrows) {
        classNames.push('padded-horizontal');
      }
      if (styleParams.allowMultishare) {
        classNames.push('push-down');
      }
      if (isNarrow) {
        classNames.push('narrow-item');
      }

      return classNames.join(' ');
    }
  }, {
    key: 'allowAnyAction',
    value: function allowAnyAction() {
      var styleParams = this.props.styleParams;

      return styleParams.loveButton || styleParams.allowSocial || styleParams.allowDownload;
    }
  }, {
    key: 'getElementStyle',
    value: function getElementStyle() {
      var _props2 = this.props,
          styleParams = _props2.styleParams,
          style = _props2.style;

      var textsDisplayOnHover = !styleParams.isSlideshow && !styleParams.isSlider && !styleParams.hasThumbnails;
      var isCentered = style.justifyContent == 'center';

      var elementStyle = {
        justifyContent: styleParams.galleryVerticalAlign,
        alignItems: styleParams.galleryHorizontalAlign,
        textAlign: styleParams.galleryTextAlign
      };

      //Set the texts fixed height considering the height of the love and share buttons which is about 100px;
      if (textsDisplayOnHover && this.allowAnyAction()) {
        elementStyle.paddingBottom = 45;
      }

      if (isCentered) {
        elementStyle.marginTop = style.height / 15;
      }

      return elementStyle;
    }
  }, {
    key: 'getItemTexts',
    value: function getItemTexts() {
      var _this2 = this;

      var titleElem = null;
      var descriptionElem = null;
      var buttonElem = null;

      var _props3 = this.props,
          title = _props3.title,
          description = _props3.description,
          fileName = _props3.fileName,
          id = _props3.id,
          styleParams = _props3.styleParams,
          style = _props3.style,
          isSmallItem = _props3.isSmallItem,
          isNarrow = _props3.isNarrow,
          shouldShowButton = _props3.shouldShowButton;

      var displayTitle = title || fileName;
      var shouldShowTitle = displayTitle && !isSmallItem && styleParams.allowTitle && styleParams.titlePlacement == _consts2.default.placements.SHOW_ON_HOVER;
      var shouldShowDescription = !isSmallItem && styleParams.allowDescription && description;
      var shouldHaveBottomSpaceInTitle = shouldShowDescription || this.allowAnyAction();

      if (shouldShowTitle) {
        titleElem = _react2.default.createElement(_itemTitle2.default, { key: 'item-title-' + id, title: displayTitle, style: shouldHaveBottomSpaceInTitle ? {} : { marginBottom: 0 } });
      }

      if (shouldShowDescription) {
        descriptionElem = _react2.default.createElement(_itemDescription2.default, { description: description, key: 'item-description-' + id });
      }

      if (shouldShowButton) {
        buttonElem = _react2.default.createElement(_customButton2.default, { type: 'button', styleParams: styleParams, style: style, small: isNarrow });
      }

      var shouldHideElement = !titleElem && !descriptionElem && !buttonElem;
      if (shouldHideElement) {
        return null;
      }

      var elementStyle = this.getElementStyle();
      var classNames = this.getElementClassNames();

      return _react2.default.createElement(
        'div',
        { style: elementStyle, ref: function ref(x) {
            _this2.container = x;
          }, className: classNames },
        titleElem,
        descriptionElem,
        buttonElem
      );
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      _lineHeightFixer2.default.fix(this.props, this.container);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      _lineHeightFixer2.default.fix(this.props, this.container);
    }
  }, {
    key: 'render',
    value: function render() {
      return this.getItemTexts();
    }
  }]);

  return Texts;
}(_react2.default.Component);

exports.default = Texts;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CustomButtonIcon;
function CustomButtonIcon() {
  return React.createElement(
    "svg",
    { className: "buy-icon", xmlns: "http://www.w3.org/2000/svg", width: "38", height: "34", viewBox: "0 0 38 34" },
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("path", { stroke: "currentColor", d: "M.7870039 2.59301758h6.9136797l3.7205137 22.89656932 22.3489443.012", strokeLinecap: "round", strokeLinejoin: "round" }),
      React.createElement("path", { stroke: "currentColor", d: "M28.0140389 4.49572754h9.017334L34.1188973 19.4727783H11.0089119", strokeLinecap: "round", strokeLinejoin: "round" }),
      React.createElement("path", { stroke: "currentColor", d: "M15.002193 28.5c1.3971616 0 2.502193 1.1042242 2.502193 2.5s-1.1050314 2.5-2.502193 2.5S12.5 32.3957758 12.5 31s1.1050314-2.5 2.502193-2.5zM27.5 31c0-1.3957758 1.1050314-2.5 2.502193-2.5s2.502193 1.1042242 2.502193 2.5-1.1050314 2.5-2.502193 2.5S27.5 32.3957758 27.5 31z" }),
      React.createElement("path", { fill: "currentColor", d: "M23 .50625185V11.4270815c0 .2795952-.2319336.5062518-.5.5062518-.2761424 0-.5-.2261351-.5-.5062518V.50625185C22 .22665667 22.2319336 0 22.5 0c.2761424 0 .5.2261351.5.50625185zM8 4h9v1H8z" }),
      React.createElement("path", { fill: "currentColor", d: "M25.53553353 8.0000001l.7071068.7071068-3.53553392 3.5355339-.70710676-.7071068z" }),
      React.createElement("path", { fill: "currentColor", d: "M19.0000001 8.70710647l.7071068-.7071068 3.5355339 3.53553392-.7071068.70710676z" })
    )
  );
}

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ItemDescription = function (_React$Component) {
  _inherits(ItemDescription, _React$Component);

  function ItemDescription(props) {
    _classCallCheck(this, ItemDescription);

    return _possibleConstructorReturn(this, (ItemDescription.__proto__ || Object.getPrototypeOf(ItemDescription)).call(this, props));
  }

  _createClass(ItemDescription, [{
    key: "render",
    value: function render() {
      var description = this.props.description;

      return _react2.default.createElement(
        "div",
        { className: "gallery-item-description", "data-hook": "item-description" },
        description
      );
    }
  }]);

  return ItemDescription;
}(_react2.default.Component);

exports.default = ItemDescription;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var spaceBetweenElements = 20;
var minWidthToShowContent = 135;
var minWithForNormalSizedItem = 190;

var LineHeightFixer = function () {
  function LineHeightFixer() {
    _classCallCheck(this, LineHeightFixer);
  }

  _createClass(LineHeightFixer, [{
    key: 'getElementHeight',
    value: function getElementHeight(element) {
      return parseInt($(element).height());
    }
  }, {
    key: 'getElementWidth',
    value: function getElementWidth(element) {
      return parseInt($(element).width());
    }
  }, {
    key: 'getDimension',
    value: function getDimension(element) {
      return {
        height: this.getElementHeight(element),
        width: this.getElementWidth(element)
      };
    }
  }, {
    key: 'fix',
    value: function fix(options, container) {
      var styleParams = options.styleParams,
          fileName = options.fileName,
          title = options.title,
          description = options.description,
          isSmallItem = options.isSmallItem;


      if (!container || styleParams.isSlideshow) {
        return;
      }
      var dimensions = this.getDimension(container);
      var availableHeight = dimensions.height;

      var customButtonElement = $(container).find('.custom-button-wrapper');
      var customButtonExists = customButtonElement.length > 0;
      var titleElement = $(container).find('.gallery-item-title');
      var descriptionElement = $(container).find('.gallery-item-description');

      var isItemWidthToSmall = dimensions.width < minWidthToShowContent;
      titleElement.hide();
      descriptionElement.hide();
      customButtonElement.hide();

      if (customButtonExists) {
        customButtonElement.show();
        var buttonHeight = this.getElementHeight(customButtonElement);
        var isNotEnoughSpaceForButton = availableHeight < buttonHeight;
        if (isNotEnoughSpaceForButton) {
          var hoverTextAreaPaddings = 30;
          var _isNotEnoughSpaceForButton = availableHeight + hoverTextAreaPaddings < buttonHeight;
        }
        if (isNotEnoughSpaceForButton) {
          customButtonElement.hide();
        } else if (isItemWidthToSmall) {
          customButtonElement.find('button').css({ 'min-width': 0 + 'px', 'max-width': minWidthToShowContent + 'px' });
        } else if (dimensions.width < minWithForNormalSizedItem) {
          customButtonElement.find('button').css({ 'min-width': minWidthToShowContent + 'px', 'max-width': dimensions.width + 'px' });
        }

        var isButtonHeightAvailable = !_.isNaN(buttonHeight);
        if (isButtonHeightAvailable) {
          availableHeight -= buttonHeight;
          availableHeight -= spaceBetweenElements;
          if (availableHeight < 0) {
            availableHeight = 0;
            // customButtonElement.hide();
          }
        }
      } else {
        availableHeight -= spaceBetweenElements;
      }

      var shouldDisplayTitle = (title || fileName) && !isSmallItem && styleParams.allowTitle;
      if (shouldDisplayTitle) {
        titleElement.show();
        titleElement.css({ 'overflow': 'visible' });
        if (titleElement.length == 1) {
          var titleHeight = parseInt(titleElement.height());
          var titleLineHeight = parseInt(titleElement.css('line-height'));
          var numOfTitleLines = Math.floor(titleHeight / titleLineHeight);
          var numOfAvailableLines = Math.floor(availableHeight / titleLineHeight);
          if (numOfAvailableLines == 0) {
            titleElement.hide();
          } else {
            var isTitleFitInAvailableHeight = numOfAvailableLines <= numOfTitleLines;
            if (isTitleFitInAvailableHeight) {
              titleElement.css({ '-webkit-line-clamp': numOfAvailableLines + '' });
              titleHeight = titleLineHeight * numOfAvailableLines;
              titleElement.css({ 'overflow': 'hidden', height: titleHeight });
            } else {
              titleElement.css({ '-webkit-line-clamp': 'none' });
              titleHeight = titleLineHeight * numOfTitleLines;
            }

            var isThereAnyAvailableHeightLeft = availableHeight > titleHeight;
            if (isThereAnyAvailableHeightLeft) {
              availableHeight -= titleHeight;
            } else {
              availableHeight = 0;
            }
          }
        }
      }

      var shouldDisplayDescription = descriptionElement.length == 1 && !isSmallItem && styleParams.allowDescription && description && availableHeight > 0;
      if (shouldDisplayDescription) {
        descriptionElement.show();
        availableHeight -= spaceBetweenElements * 2;
        if (availableHeight < 0) {
          availableHeight = 0;
        }
        var lineHeight = parseInt(descriptionElement.css('line-height'));
        var numOfLines = Math.floor(availableHeight / lineHeight);
        if (numOfLines == 0) {
          descriptionElement.hide();
        } else {
          var descriptionOptimisticHeight = parseInt(descriptionElement.css('height'));
          var descriptionAvailableHeight = lineHeight * numOfLines;
          var isDescriptionHeightBiggerThanAvailableHeight = descriptionOptimisticHeight > descriptionAvailableHeight;
          availableHeight -= isDescriptionHeightBiggerThanAvailableHeight ? descriptionAvailableHeight : descriptionOptimisticHeight;
          //title.height(numOfLines * lineHeight);
          descriptionElement.css({ 'overflow': 'hidden', '-webkit-line-clamp': numOfLines + '' });
        }
      }
    }
  }]);

  return LineHeightFixer;
}();

exports.default = new LineHeightFixer();

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(2);

var _loveButton = __webpack_require__(67);

var _loveButton2 = _interopRequireDefault(_loveButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Social = function (_React$Component) {
  _inherits(Social, _React$Component);

  function Social(props) {
    _classCallCheck(this, Social);

    return _possibleConstructorReturn(this, (Social.__proto__ || Object.getPrototypeOf(Social)).call(this, props));
  }

  _createClass(Social, [{
    key: 'getSocialShare',
    value: function getSocialShare() {
      var _props = this.props,
          styleParams = _props.styleParams,
          id = _props.id,
          actions = _props.actions;

      if (styleParams.allowSocial) {
        var slideshowShareButton = _react2.default.createElement('i', { className: "block-fullscreen progallery-svg-font-icons-share-store " + (_index.utils.isSite() ? '' : ' inactive ') });
        var slideshowShare = styleParams.isSlideshow ? actions.getShare() : '';

        if (_index.utils.isSite()) {
          return _react2.default.createElement(
            'div',
            { className: "block-fullscreen gallery-item-social-share gallery-item-social-button",
              key: 'item-social-share-' + id,
              onClick: function onClick(e) {
                return actions.toggleShare(e, true);
              } },
            slideshowShareButton,
            slideshowShare
          );
        } else {
          return _react2.default.createElement(
            'div',
            { className: "show-tooltip block-fullscreen gallery-item-social-share gallery-item-social-button",
              key: 'item-social-share-' + id,
              onMouseOver: function onMouseOver(e) {
                return itemActions.showTooltip(e, 'Gallery_Sharing_Disabled_In_Editor');
              },
              onMouseOut: function onMouseOut() {
                return itemActions.hideTooltip();
              }
            },
            slideshowShareButton
          );
        }
      }
      return '';
    }
  }, {
    key: 'getMultishare',
    value: function getMultishare() {
      var _props2 = this.props,
          styleParams = _props2.styleParams,
          id = _props2.id,
          actions = _props2.actions;

      if (styleParams.allowMultishare) {
        if (_index.utils.isSite()) {
          return _react2.default.createElement(
            'div',
            { className: "block-fullscreen gallery-item-social-multishare gallery-item-social-button",
              key: 'item-social-multishare-' + id,
              onClick: actions.toggleMultishareSelection },
            _react2.default.createElement(
              'svg',
              { className: "block-fullscreen", xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 18 18' },
              _react2.default.createElement('path', { className: 'gallery-item-svg-foreground',
                d: 'M9,1A8,8,0,1,1,1,9,8,8,0,0,1,9,1M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0Z' })
            )
          );
        } else {
          return _react2.default.createElement(
            'div',
            { className: "show-tooltip block-fullscreen gallery-item-social-multishare gallery-item-social-button ",
              onMouseOver: function onMouseOver(e) {
                return itemActions.showTooltip(e, 'Gallery_Sharing_Disabled_In_Editor');
              },
              onMouseOut: function onMouseOut() {
                return itemActions.hideTooltip();
              },
              key: 'item-social-multishare-' + id
            },
            _react2.default.createElement(
              'svg',
              { className: "block-fullscreen inactive", xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 18 18' },
              _react2.default.createElement('path', { className: 'gallery-item-svg-foreground',
                d: 'M9,1A8,8,0,1,1,1,9,8,8,0,0,1,9,1M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0Z' })
            )
          );
        }
      }
      return false;
    }
  }, {
    key: 'getLoveButton',
    value: function getLoveButton() {
      var _props3 = this.props,
          styleParams = _props3.styleParams,
          love = _props3.love,
          isNarrow = _props3.isNarrow;

      return styleParams.loveButton ? _react2.default.createElement(_loveButton2.default, _extends({
        layout: styleParams.isSlideshow ? "slideshow" : "gallery"
      }, love, {
        showCounter: !isNarrow
      })) : '';
    }
  }, {
    key: 'getDownload',
    value: function getDownload() {
      var _props4 = this.props,
          styleParams = _props4.styleParams,
          isDemo = _props4.isDemo,
          type = _props4.type,
          allProps = _props4.allProps,
          download_url = _props4.download_url;

      if (styleParams.allowDownload && !_index.utils.isiOS() && !(_index.utils.isSite() && isDemo)) {
        var className = "block-fullscreen gallery-item-social-download " + (styleParams.allowSocial ? '' : ' pull-right ') + " gallery-item-social-button";
        var downloadIcon = _react2.default.createElement('i', { className: "block-fullscreen progallery-svg-font-icons-download" + (isDemo ? ' inactive' : '') });

        var genralProps = {
          className: className,
          'data-hook': "item-download"
        };

        var itemProps = {
          download: "download",
          target: "_blank",
          href: download_url['mp4'] || download_url['webm'] || download_url['img'],
          onClick: function onClick(e) {
            e.stopPropagation();
            logger.track(logger.biEvents.download, { origin: 'gallery' });
          }
        };
        if (type === 'text') {
          return _react2.default.createElement(
            'a',
            _extends({}, genralProps, {
              onClick: function onClick(e) {
                e.stopPropagation();
                itemActions.downloadTextItem(allProps, 'gallery');
              } }),
            downloadIcon
          );
        } else {
          var props = isDemo ? {
            onMouseOver: function onMouseOver(e) {
              return itemActions.showTooltip(e, 'Gallery_Hover_Download_FreeImages_Text');
            },
            onMouseOut: function onMouseOut() {
              return itemActions.hideTooltip();
            }
          } : {
            target: "_blank",
            href: download_url['mp4'] || download_url['webm'] || download_url['img'],
            onClick: function onClick(e) {
              e.stopPropagation();
              logger.track(logger.biEvents.download, { origin: 'gallery' });
            }
          };
          return _react2.default.createElement(
            'a',
            _extends({}, genralProps, {
              download: 'download',
              role: 'button'
            }, props),
            downloadIcon
          );
        }
      }
      return '';
    }
  }, {
    key: 'render',
    value: function render() {
      var _props5 = this.props,
          styleParams = _props5.styleParams,
          id = _props5.id,
          showShare = _props5.showShare,
          actions = _props5.actions,
          isSmallItem = _props5.isSmallItem,
          isNarrow = _props5.isNarrow,
          isShort = _props5.isShort,
          isVerticalContainer = _props5.isVerticalContainer;

      var socialShare = this.getSocialShare();
      var multishare = this.getMultishare();
      var loveButton = this.getLoveButton();
      var download = this.getDownload();
      //var shopIcons = this.getShopIcons();
      var isShowArrows = styleParams.hasThumbnails;

      var classes = [[showShare, 'hidden'], [isSmallItem, 'small-item'], [isShort, 'short-item'], [isNarrow, 'narrow-item'], [isVerticalContainer, 'vertical-item'], [isShowArrows, 'with-arrows']].filter(function (x) {
        return x[0];
      }).map(function (x) {
        return x[1];
      }).join(' ');

      return _react2.default.createElement(
        'div',
        {
          className: "gallery-item-social gallery-item-direction-" + styleParams.galleryTextAlign + " " + classes,
          key: 'item-social-' + id,
          'data-hook': 'item-social'
        },
        multishare,
        loveButton,
        download,
        socialShare
      );
    }
  }]);

  return Social;
}(_react2.default.Component);

exports.default = Social;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(4);

var _lodash2 = _interopRequireDefault(_lodash);

var _index = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Share = function (_React$Component) {
  _inherits(Share, _React$Component);

  function Share(props) {
    _classCallCheck(this, Share);

    var _this = _possibleConstructorReturn(this, (Share.__proto__ || Object.getPrototypeOf(Share)).call(this, props));

    _this.handleShareArrowNavigation = _this.handleShareArrowNavigation.bind(_this);
    _this.buttons = [];
    _this.shareArr = ['facebook', 'twitter', 'pinterest', 'tumblr', 'email'];

    _this.state = {
      showShare: false,
      focusedShareIcon: 0
    };

    return _this;
  }

  _createClass(Share, [{
    key: 'handleShareArrowNavigation',
    value: function handleShareArrowNavigation(e) {

      if (!_index.utils.isAccessibilityEnabled()) {
        //the keypress events are only effective when the share box was opened via Click or Focus+Enter
        return true;
      }

      if (this.state.showShare) {
        switch (e.keyCode || e.charCode) {
          case 38: //up
          case 37: //left
          case 33:
            //page up
            e.preventDefault();
            e.stopPropagation();
            _index.utils.setStateAndLog(this, 'Share Keypress', {
              focusedShareIcon: Math.max(1, this.state.focusedShareIcon - 1)
            });
            return false;
          case 39: //right
          case 40: //down
          case 34:
            //page down
            e.preventDefault();
            e.stopPropagation();
            _index.utils.setStateAndLog(this, 'Share Keypress', {
              focusedShareIcon: Math.min(5, this.state.focusedShareIcon + 1)
            });
            return false;
          case 9: //tab
          case 27:
            //esc
            e.preventDefault();
            e.stopPropagation();
            _index.utils.setStateAndLog(this, 'Share Keypress', {
              showShare: false,
              focusedShareIcon: 0
            });
            return false;

        }
      }

      switch (e.keyCode || e.charCode) {
        case 32: //space
        case 13:
          //enter
          e.preventDefault();
          e.stopPropagation();
          if (this.state.showShare) {
            itemActions.share(this.shareArr[this.state.focusedShareIcon - 1], this.props, 'gallery');
            this.props.actions.toggleShare(e, false);
            _index.utils.setStateAndLog(this, 'Share Keypress', {
              showShare: false,
              focusedShareIcon: 0
            });
          } else {
            this.props.actions.toggleShare(e, true);
            _index.utils.setStateAndLog(this, 'Share Keypress', {
              showShare: true,
              focusedShareIcon: 1
            });
          }

          return false;
      }

      return true;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {

      if (!_index.utils.isAccessibilityEnabled()) {
        return;
      }

      try {
        var focusedButton = this.state.focusedShareIcon;
        if (focusedButton > 0) {
          this.buttons[focusedButton - 1].focus();
        }
      } catch (e) {
        console.warn('Cannot focus on share icon', this.props.focus, e);
      }
    }
  }, {
    key: 'getShareItem',
    value: function getShareItem(network, idx) {
      var _this2 = this;

      var allProps = this.props.allProps;


      return _react2.default.createElement('button', {
        className: "block-fullscreen " + network + "-share progallery-svg-font-icons-" + network + (_index.utils.isSite() ? '' : ' inactive '),
        onClick: function onClick(e) {
          e.preventDefault();
          e.stopPropagation();
          itemActions.share(network, allProps, 'gallery');
        },
        ref: function ref(button) {
          return _this2.buttons[idx] = button;
        },
        title: 'Share on ' + network,
        'aria-label': 'Share on ' + network + ', ' + idx + ' of 5',
        'aria-live': 'assertive',
        role: 'button',
        tabIndex: -1,
        key: network + "-share-icon" });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          styleParams = _props.styleParams,
          type = _props.type,
          id = _props.id,
          isVerticalContainer = _props.isVerticalContainer,
          actions = _props.actions,
          style = _props.style;

      var share = false;
      if (styleParams.allowSocial) {
        var minDimension = 200;
        if (type == 'text') {
          this.shareArr.splice(2, 1);
        }

        return _react2.default.createElement(
          'div',
          {
            className: "block-fullscreen gallery-item-social-share-box " + (this.props.showShare ? '' : ' hidden ') + (this.state.showShare ? ' hovered ' : '') + (isVerticalContainer ? ' vertical-item ' : ''),
            onClick: function onClick(e) {
              return actions.toggleShare(e, false);
            },
            onMouseOut: function onMouseOut(e) {
              return actions.toggleShare(e, false);
            },
            style: {
              transform: isVerticalContainer ? 'translateY(-50%) ' + (style.height > minDimension ? '' : 'scale(' + style.height / minDimension + ')') : 'translateX(-50%) ' + (style.width > minDimension ? '' : 'scale(' + style.width / minDimension + ')')
            },
            tabIndex: this.props.currentIdx === this.props.idx ? _index.utils.getTabIndex('slideshowShare') : -1,
            onKeyDown: this.handleShareArrowNavigation,
            'aria-label': "Share",
            role: 'button',
            key: 'item-social-share-container-' + id
          },
          _lodash2.default.map(this.shareArr, function (network, i) {
            return _this3.getShareItem(network, i);
          })
        );
      }

      return false;
    }
  }]);

  return Share;
}(_react2.default.Component);

exports.default = Share;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__(2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _groupView = __webpack_require__(169);

var _groupView2 = _interopRequireDefault(_groupView);

var _galleryEmpty = __webpack_require__(172);

var _galleryEmpty2 = _interopRequireDefault(_galleryEmpty);

var _galleryLayout = __webpack_require__(174);

var _galleryLayout2 = _interopRequireDefault(_galleryLayout);

var _galleryDebugMessage = __webpack_require__(173);

var _galleryDebugMessage2 = _interopRequireDefault(_galleryDebugMessage);

var _lodash = __webpack_require__(4);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_index.utils.fixViewport('Gallery');

var SlideshowView = function (_React$Component) {
  _inherits(SlideshowView, _React$Component);

  function SlideshowView(props) {
    _classCallCheck(this, SlideshowView);

    var _this = _possibleConstructorReturn(this, (SlideshowView.__proto__ || Object.getPrototypeOf(SlideshowView)).call(this, props));

    _this.scrollToItem = _this.scrollToItem.bind(_this);
    _this.handleKeypress = _this.handleKeypress.bind(_this);
    _this._setCurrentItemByScroll = _lodash2.default.throttle(_this.setCurrentItemByScroll, 600, { 'leading': false, 'trailing': true }).bind(_this);

    _this.state = {
      flatItems: [],
      currentIdx: 0
    };

    return _this;
  }

  _createClass(SlideshowView, [{
    key: 'isFirstItem',
    value: function isFirstItem() {
      if (!_lodash2.default.isUndefined(this.state.currentIdx)) {
        return this.state.currentIdx == 0;
      }

      return 0 == this.props.scroll.top;
    }
  }, {
    key: 'isLastItem',
    value: function isLastItem() {

      return this.state.currentIdx >= this.props.totalItemsCount - 1;
    }
  }, {
    key: 'nextItem',
    value: function nextItem(dir) {

      this.isAutoScrolling = true;

      var currentIdx = this.state.currentIdx;

      if (this.props.styleParams.showArrows) {
        this.props.actions.scrollToItem(currentIdx + dir, false, true);
      } else {
        this.props.actions.scrollToItem(dir, true, true);
      }

      _index.utils.setStateAndLog(this, 'Next Item', {
        currentIdx: currentIdx + dir
      });
    }
  }, {
    key: 'scrollToItem',
    value: function scrollToItem(itemIdx) {

      this.isAutoScrolling = true;

      itemIdx += this.firstItemIdx;

      _index.utils.setStateAndLog(this, 'Scroll to Item', {
        currentIdx: itemIdx
      });

      this.props.actions.scrollToItem(itemIdx, false, true);
    }
  }, {
    key: 'handleKeypress',
    value: function handleKeypress(e) {
      switch (e.charCode || e.keyCode) {
        case 38: //up
        case 37: //left
        case 33:
          //page up
          e.preventDefault();
          this.nextItem(-1);
          return false;
        case 39: //right
        case 40: //down
        case 32: //space
        case 34:
          //page down
          e.preventDefault();
          this.nextItem(1);
          return false;
      }

      return true; //continue handling the original keyboard event
    }
  }, {
    key: 'createThumbnails',
    value: function createThumbnails(thumbnailPosition) {
      var currentIdx = this.state.currentIdx; // zero based (3)
      console.log('creating thumbnails for idx', currentIdx);

      var width = this.props.thumbnailSize;
      var height = this.props.thumbnailSize;

      var oneRow;
      var numOfThumbnails; //1 based (5)

      switch (thumbnailPosition) {
        case 'top':
        case 'bottom':
          width = window.innerWidth / _index.utils.getViewportScaleRatio();
          oneRow = true;
          numOfThumbnails = Math.ceil(width / this.props.thumbnailSize);
          break;
        case 'left':
        case 'right':
          height = window.innerHeight * _index.utils.getViewportScaleRatio();
          oneRow = false;
          numOfThumbnails = Math.ceil(height / this.props.thumbnailSize);
          break;
      }

      this.firstItemIdx = currentIdx - Math.floor(numOfThumbnails / 2); // (1)
      this.lastItemIdx = this.firstItemIdx + numOfThumbnails - 1; // (5)

      if (this.firstItemIdx < 0) {
        this.lastItemIdx -= this.firstItemIdx;
        this.firstItemIdx = 0;
      }

      if (this.lastItemIdx > this.props.items.length - 1) {
        this.firstItemIdx -= this.lastItemIdx - (this.props.items.length - 1);
        if (this.firstItemIdx < 0) {
          this.firstItemIdx = 0;
        }
        this.lastItemIdx = this.props.items.length - 1;
      }

      numOfThumbnails = this.lastItemIdx - this.firstItemIdx + 1;
      if (numOfThumbnails % 2 == 0) {
        // keep an odd number of thumbnails
        numOfThumbnails += 1;
        this.lastItemIdx += 1;
      }
      var thumbnailsContainerSize = numOfThumbnails * this.props.thumbnailSize;
      var thumbnailsStyle = { width: width, height: height };

      if (currentIdx > numOfThumbnails / 2 - 1 && currentIdx < this.props.items.length - numOfThumbnails / 2) {
        //set selected to center only if neeeded
        switch (thumbnailPosition) {
          case 'top':
          case 'bottom':
            thumbnailsStyle.width = thumbnailsContainerSize + 'px';
            thumbnailsStyle.left = 0;
            break;
          case 'left':
          case 'right':
            thumbnailsStyle.height = thumbnailsContainerSize + 'px';
            thumbnailsStyle.marginTop = (height - thumbnailsContainerSize) / 2 + 'px';
            break;
        }
      } else if (currentIdx < numOfThumbnails / 2 - 1) {
        //one of the first thumbnails
        switch (thumbnailPosition) {
          case 'top':
          case 'bottom':
            thumbnailsStyle.width = thumbnailsContainerSize + 'px';
            thumbnailsStyle.left = 0;
            break;
          case 'left':
          case 'right':
            thumbnailsStyle.height = thumbnailsContainerSize + 'px';
            thumbnailsStyle.marginTop = 0;
            break;
        }
      } else if (this.lastItemIdx > numOfThumbnails && currentIdx >= this.lastItemIdx - 3) {
        //scroll to the left/top if the chosen thumbnail is one of the last three
        var entireThumbnailsSize = thumbnailsContainerSize - this.props.styleParams.thumbnailSpacings;
        switch (thumbnailPosition) {
          case 'top':
          case 'bottom':
            thumbnailsStyle.left = width - entireThumbnailsSize + 'px';
            thumbnailsStyle['overflow'] = 'visible';
            break;
          case 'left':
          case 'right':
            thumbnailsStyle.top = height - entireThumbnailsSize + 'px';
            thumbnailsStyle['overflow'] = 'visible';
            break;
        }
      }

      var thumbnailsLayout = new _galleryLayout2.default({
        items: this.props.items.slice(this.firstItemIdx, this.lastItemIdx + 1),
        container: _lodash2.default.merge({}, this.props.container, {
          galleryWidth: width,
          galleryHeight: height
        }),
        watermark: this.props.watermark,
        styleParams: {
          gotStyleParams: false,
          isVertical: false,
          gallerySize: this.props.thumbnailSize,
          minItemSize: this.props.thumbnailSize,
          groupSize: 1,
          chooseBestGroup: false,
          groupTypes: '1',
          cubeImages: true,
          smartCrop: false,
          collageAmount: 0,
          collageDensity: 0,
          cubeRatio: 1,
          fixedColumns: 0,
          oneRow: oneRow
        },
        gotScrollEvent: true,
        showAllItems: true
      });

      var thumbnailsConfig = {
        scroll: _lodash2.default.merge({}, this.props.scroll, {}),
        thumbnailHighlightId: _lodash2.default.get(this, 'props.items.' + currentIdx + '.itemId'),
        watermark: this.props.watermark,
        styleParams: _lodash2.default.merge({}, this.props.styleParams, {
          allowSocial: false,
          allowDownload: false,
          allowTitle: false,
          allowMultishare: false,
          loveButton: false,
          loveCounter: false,
          videoLoop: false,
          videoSpeed: 1,
          videoPlay: 'onClick',
          sharpParams: {
            quality: 90,
            usm: {}
          },
          imageMargin: this.props.styleParams.thumbnailSpacings,
          enableInfiniteScroll: 0,
          showArrows: false,
          itemClick: 'expand'
        }),
        actions: {
          scrollToItem: this.scrollToItem,
          toggleFullscreen: this.props.actions.toggleFullscreen,
          pauseAllVideos: this.props.actions.pauseAllVideos
        },
        hidePlay: true
      };

      var thumbnailsMargin;
      var mrg = this.props.styleParams.thumbnailSpacings;
      switch (this.props.styleParams.galleryThumbnailsAlignment) {
        case 'bottom':
          thumbnailsMargin = mrg + 'px -' + mrg + 'px -' + mrg + 'px -' + mrg + 'px';
          break;
        case 'left':
          thumbnailsMargin = '-' + mrg + 'px ' + mrg + 'px -' + mrg + 'px -' + mrg + 'px';
          break;
        case 'top':
          thumbnailsMargin = '-' + mrg + 'px -' + mrg + 'px ' + mrg + 'px -' + mrg + 'px';
          break;
        case 'right':
          thumbnailsMargin = '-' + mrg + 'px -' + mrg + 'px -' + mrg + 'px ' + mrg + 'px';
          break;
      }

      var thumbnails = _react2.default.createElement(
        'div',
        { className: "pro-gallery inline-styles thumbnails-gallery " + (oneRow ? " one-row hide-scrollbars " : "") + (_index.utils.isAccessibilityEnabled() ? ' accessible ' : ''),
          style: {
            width: width,
            height: height,
            margin: thumbnailsMargin
          },
          'data-hook': 'gallery-thumbnails' },
        thumbnailsLayout.columns.map(function (column, c) {
          return _react2.default.createElement(
            'div',
            { 'data-hook': 'gallery-column', className: 'gallery-column', key: 'thumbnails-column' + c,
              style: thumbnailsStyle },
            column.map(function (group) {
              return _react2.default.createElement(_groupView2.default, group.getViewProps(thumbnailsConfig));
            })
          );
        })
      );

      return thumbnails;
    }
  }, {
    key: 'setFlattenItems',
    value: function setFlattenItems(galleryLayout) {
      var flatItems = _lodash2.default.flattenDeep(galleryLayout.columns.map(function (column, c) {
        return column.map(function (group, g) {
          return group.items;
        });
      }));

      this.setState({
        flatItems: flatItems
      });
    }
  }, {
    key: 'setCurrentItemByScroll',
    value: function setCurrentItemByScroll() {

      console.log('Setting current Idx by scroll', this.isAutoScrolling);

      if (this.isAutoScrolling) {
        //avoid this function if the scroll was originated by us (arrows or thumbnails)
        this.isAutoScrolling = false;
        return;
      }

      var scrollLeft = this.container.scrollLeft();

      var items = this.state.flatItems;

      var currentIdx;

      for (var item, i = 0; item = items[i]; i++) {
        if (item.offset.left >= scrollLeft + (this.props.container.galleryWidth - item.width) / 2) {
          currentIdx = i - 1;
          break;
        }
      }

      if (!_lodash2.default.isUndefined(currentIdx)) {
        _index.utils.setStateAndLog(this, 'Set Current Item', {
          currentIdx: currentIdx
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (props.items) {
        this.setFlattenItems(props.galleryLayout);
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {

      if (!(this.props.renderedItemsCount > 0) && _index.utils.isEditor()) {
        return _react2.default.createElement(_galleryEmpty2.default, {
          actions: {
            setWixHeight: this.props.actions.setWixHeight
          }
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.galleryLayout) {
        this.setFlattenItems(this.props.galleryLayout);
      }

      window.addEventListener('keydown', this.handleKeypress);

      this.container = $('.gallery-horizontal-scroll');
      if (this.container[0]) {
        this.container[0].addEventListener('scroll', this._setCurrentItemByScroll);
      }
      this.setCurrentItemByScroll();

      // if (utils.isSite() && this.props.styleParams.selectedLayoutV2 == 4 && this.props.renderedItemsCount > 2) {
      //   this.nextItem(1);
      // }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.container[0].removeEventListener('scroll', this._setCurrentItemByScroll);
    }

    //-----------------------------------------| RENDER |--------------------------------------------//

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (_index.utils.isDev()) {
        console.count("galleryView render");

        //this.gallery = this.prepareGallery(this.state.images);
        console.count('Rendering Gallery count');
        console.time('Rendering Gallery took ');
      }

      var loader = this.totalItemsCount > this.props.renderedItemsCount ? _react2.default.createElement(
        'div',
        { className: 'more-items-loader' },
        _react2.default.createElement('i', { className: 'pro-circle-preloader' })
      ) : false;

      var navArrows = [this.isFirstItem() ? '' : _react2.default.createElement(
        'button',
        {
          className: "nav-arrows-container prev ",
          onClick: function onClick() {
            return _this2.nextItem(-1);
          },
          'aria-label': 'Previous Item',
          tabIndex: _index.utils.getTabIndex('slideshowPrev'),
          key: 'nav-arrow-back',
          'data-hook': 'nav-arrow-back'
        },
        _react2.default.createElement('img', { src: window.staticsUrl + 'assets/images/arrows/arrow-left.svg' })
      ), this.isLastItem() ? '' : _react2.default.createElement(
        'button',
        {
          className: "nav-arrows-container next",
          onClick: function onClick() {
            return _this2.nextItem(1);
          },
          'aria-label': 'Next Item',
          tabIndex: _index.utils.getTabIndex('slideshowNext'),
          key: 'nav-arrow-next',
          'data-hook': 'nav-arrow-next'
        },
        _react2.default.createElement('img', { src: window.staticsUrl + 'assets/images/arrows/arrow-right.svg' })
      )];

      var debugMsg = _react2.default.createElement(_galleryDebugMessage2.default, this.props.debug);

      var galleryConfig = {
        scroll: this.props.scroll,
        styleParams: this.props.styleParams,
        multishare: this.props.multishare,
        watermark: this.props.watermark,
        currentIdx: this.state.currentIdx,
        actions: {
          toggleFullscreen: this.props.actions.toggleFullscreen,
          pauseAllVideos: this.props.actions.pauseAllVideos,
          addItemToMultishare: this.props.actions.addItemToMultishare,
          removeItemFromMultishare: this.props.actions.removeItemFromMultishare
        }
      };

      var layout = this.props.galleryLayout.columns.map(function (column, c) {

        var marginLeft = 0;
        var firstGroup = _lodash2.default.find(column, function (group) {
          return group.rendered;
        }) || {};
        if (_this2.props.gotScrollEvent) {
          marginLeft = firstGroup.left || 0;
        }

        //remove navBars if no scroll is needed and is column layout
        var allRenderedGroups = _lodash2.default.filter(column, function (group) {
          return group.rendered;
        }) || [];
        var allGroupsWidth = allRenderedGroups.reduce(function (sum, group) {
          return sum + group.width;
        }, 0);
        var isAllItemsFitsGalleryWidth = _this2.props.styleParams.oneRow && _this2.props.container.galleryWidth >= allGroupsWidth;
        if (isAllItemsFitsGalleryWidth) {
          navArrows = false;
        }

        return _react2.default.createElement(
          'div',
          { 'data-hook': 'gallery-column', className: 'gallery-horizontal-scroll gallery-column hide-scrollbars', key: 'column' + c,
            style: { width: _this2.props.galleryLayout.colWidth } },
          _react2.default.createElement('div', { className: 'gallery-left-padding', style: { width: marginLeft } }),
          column.map(function (group) {
            return group.rendered ? _react2.default.createElement(_groupView2.default, _lodash2.default.merge(group.getViewProps(galleryConfig), { store: _this2.props.store })) : false;
          })
        );
      });

      var hasThumbnails = this.props.styleParams.hasThumbnails;
      var thumbnailsPosition = this.props.styleParams.galleryThumbnailsAlignment;

      var thumbnailsGallery = hasThumbnails ? this.createThumbnails(thumbnailsPosition) : false;

      var galleryStyle = {
        height: this.props.container.galleryHeight,
        width: this.props.container.galleryWidth
      };

      var thumbnails = [];
      switch (thumbnailsPosition) {
        case 'top':
        case 'left':
          thumbnails[0] = thumbnailsGallery;
          thumbnails[1] = false;
          break;
        case 'right':
        case 'bottom':
          thumbnails[0] = false;
          thumbnails[1] = thumbnailsGallery;
          break;
      }

      var gallery = _react2.default.createElement(
        'div',
        { id: 'pro-gallery-container', className: "pro-gallery inline-styles one-row hide-scrollbars " + (this.props.styleParams.enableScroll ? " slider " : "") + (_index.utils.isAccessibilityEnabled() ? ' accessible ' : ''),
          style: galleryStyle
        },
        debugMsg,
        layout,
        loader,
        navArrows
      );

      if (_index.utils.isDev()) {
        console.timeEnd('Rendering Gallery took ');
      }

      var classNames = '';
      if (this.props.styleParams.isSlideshow) {
        classNames = ' gallery-slideshow';
      } else if (this.props.styleParams.isSlider) {
        classNames = ' gallery-slider';
      } else if (this.props.styleParams.hasThumbnails) {
        classNames = ' gallery-thumbnails';
      } else if (this.props.styleParams.isColumns) {
        classNames = ' gallery-columns';
      }

      if (this.props.container.galleryWidth >= $(window).width() - 10) {
        classNames += ' streched';
      }

      return _react2.default.createElement(
        'div',
        { className: classNames },
        thumbnails[0],
        gallery,
        thumbnails[1]
      );
    }
  }]);

  return SlideshowView;
}(_react2.default.Component);

exports.default = SlideshowView;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /// <reference path='../../reference.ts' />


var _consts = __webpack_require__(106);

var _consts2 = _interopRequireDefault(_consts);

var _utils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GroupLayout = function () {
  function GroupLayout(config) {
    _classCallCheck(this, GroupLayout);

    this.idx = config.idx;
    this.stripIdx = config.stripIdx;
    this.inStripIdx = config.inStripIdx;
    this.items = config.items;
    this.cubeImages = config.cubeImages;
    this.cubeType = config.cubeType;
    this.top = config.top;
    this.isVertical = config.isVertical;
    this.minItemSize = config.minItemSize;
    this.gallerySize = config.gallerySize;
    this.collageAmount = config.collageAmount;
    this.collageDensity = config.collageDensity;
    this.groupTypes = config.groupTypes;
    this.chooseBestGroup = config.chooseBestGroup;
    this.layoutsVersion = config.layoutsVersion;
    this.titlePlacement = config.titlePlacement;
    this.galleryLayout = config.galleryLayout;
    this.allowTitle = config.allowTitle;
    this.itemFont = config.itemFont;
    this.itemFontSlideshow = config.itemFontSlideshow;

    this.visible = true;
    this.rendered = true;
    this.required = true;

    //prepare the group
    var forcedGroupSize = this.items.length;

    //todo - check if minItem size is really working
    while (!this.isWithinMinItemSize && forcedGroupSize > 0) {
      this.placeItems(forcedGroupSize);
      this.resize();
      forcedGroupSize--;
    }
  }

  _createClass(GroupLayout, [{
    key: 'getViewProps',
    value: function getViewProps(galleryConfig) {

      return {
        className: 'group',
        id: this.id,
        idx: this.idx,
        key: this.key,
        type: this.type,
        top: this.top,
        width: this.width,
        height: this.height,
        bottomInfoHeight: this.bottomInfoHeight,
        totalHeight: this.totalHeight,
        items: this.items,
        visible: this.visible,
        rendered: this.rendered,
        required: this.required,
        galleryConfig: galleryConfig
      };
    }
  }, {
    key: 'getBottomInfoHeight',
    value: function getBottomInfoHeight() {
      if (this.titlePlacement != _consts2.default.placements.SHOW_ALWAYS) {
        return 0;
      }

      var paddingTopAndBottom = 30;
      var spaceBetweenElements = 16;
      var defaultButtonHeight = 33;
      var defaultItemFontSize = 22;

      var isGrid = this.galleryLayout == 2;
      var item = this.items ? this.items[0] : null;
      var title = item ? item.title : null;
      var fontSize = 0;
      var isLayoutSupportsNoTitle = isGrid && !_utils.utils.isMobile();
      var shouldSaveSpaceForTitle = this.allowTitle && title || isLayoutSupportsNoTitle;
      if (shouldSaveSpaceForTitle) {
        fontSize = this.itemFontSlideshow ? this.itemFontSlideshow.size : defaultItemFontSize;
      } else {
        spaceBetweenElements = 0;
      }

      return fontSize + paddingTopAndBottom + spaceBetweenElements + defaultButtonHeight;
    }
  }, {
    key: 'resize',
    value: function resize() {
      if (this.isVertical) {
        this.resizeByWidth(this.gallerySize);
      } else {
        this.resizeByHeight(this.gallerySize);
      }
    }
  }, {
    key: 'safeGetItem',
    value: function safeGetItem(idx) {
      if (this.items[idx]) {
        return this.items[idx];
      } else {
        var item = _.cloneDeep(_.last(this.items));
        item.id += 'dummy';
        item.idx = this.idx * (idx + 1) + 1;
        item.type = 'dummy';
        if (_utils.utils.isSemiNative()) {
          item.resize = function () {};
        }
        return item;
      }
    }
  }, {
    key: 'round',
    value: function round() {

      //round all sizes to full pixels

      if (this.isLastGroup) {
        this.width = this.stripWidth - this.left;
      } else {
        this.width = Math.round(this.width);
      }
      this.height = Math.round(this.height);

      for (var item, i = 0; item = this.items[i]; i++) {
        item.width = Math.round(item.width);
        item.height = Math.round(item.height);
        item.group = {
          width: this.width,
          height: this.height
        };
      }

      switch (this.type) {
        case '1':
          this.safeGetItem(0).width = this.width;
          this.safeGetItem(0).height = this.height;
          break;
        case '2v':
          this.safeGetItem(0).width = this.safeGetItem(1).width = this.width;
          this.safeGetItem(0).height = this.height - this.safeGetItem(1).height;
          break;
        case '2h':
          this.safeGetItem(0).height = this.safeGetItem(1).height = this.height;
          this.safeGetItem(0).width = this.width - this.safeGetItem(1).width;
          break;
        case '3t':
          this.safeGetItem(0).width = this.width;
          this.safeGetItem(0).height = this.height - this.safeGetItem(1).height;
          this.safeGetItem(1).width = this.width - this.safeGetItem(2).width;
          this.safeGetItem(2).height = this.safeGetItem(1).height;
          break;
        case '3b':
          this.safeGetItem(0).width = this.width - this.safeGetItem(1).width;
          this.safeGetItem(1).height = this.safeGetItem(0).height;
          this.safeGetItem(2).height = this.height - this.safeGetItem(1).height;
          this.safeGetItem(2).width = this.width;
          break;
        case '3l':
          this.safeGetItem(1).height = this.height - this.safeGetItem(2).height;
          this.safeGetItem(2).width = this.safeGetItem(1).width;
          this.safeGetItem(0).width = this.width - this.safeGetItem(1).width;
          this.safeGetItem(0).height = this.height;
          break;
        case '3r':
          this.safeGetItem(0).height = this.height - this.safeGetItem(1).height;
          this.safeGetItem(1).width = this.safeGetItem(0).width;
          this.safeGetItem(2).width = this.width - this.safeGetItem(1).width;
          this.safeGetItem(2).height = this.height;
          break;
        case '3v':
          this.safeGetItem(0).width = this.width;
          this.safeGetItem(1).width = this.width;
          this.safeGetItem(2).width = this.width;
          this.safeGetItem(2).height = this.height - this.safeGetItem(0).height - this.safeGetItem(1).height;
          break;
        case '3h':
          this.safeGetItem(0).height = this.height;
          this.safeGetItem(1).height = this.height;
          this.safeGetItem(2).height = this.height;
          this.safeGetItem(2).width = this.width - this.safeGetItem(0).width - this.safeGetItem(1).width;
          break;
      }
    }
  }, {
    key: 'placeItems',
    value: function placeItems(forcedGroupSize) {

      //isVertical - is the gallery vertical (pinterest style) or horizontal (flickr style)

      //map the group to l=landscape and p=portrait
      //create a string to state the images group's type
      this.ratios = this.items.map(function (item) {
        return item.orientation.slice(0, 1);
      }).join('');

      //---------| Find the best groupType for each ratios case
      //optional types:
      //  1   => single photo
      //  2v  => 2 photos one above the other
      //  2h  => 2 photos one alongside the other
      //  3b  => 3 photos - one large at the bottom and two small on top, one alongside the other
      //  3t  => 3 photos - one large on top and two small at the bottom, one alongside the other
      //  3l  => 3 photos - one large on the left and two small on the right, one above the other
      //  3r  => 3 photos - one large on the right and two small on the left, one above the other

      //define optional ratios for each type:
      //  1   => all
      //  2v  => lll,llp,ppp     (horizontal only)
      //  2h  => ppp,ppl,lll     (vertical only)
      //  3b  => lll,lpl,pll,ppl (horizontal only)
      //  3t  => lll,lpl,llp,lpp (horizontal only)
      //  3l  => ppp,plp,ppl,pll (vertical only)
      //  3r  => ppp,plp,lpp,llp (vertical only)

      var isV = this.isVertical;
      var optionalTypes; //optional groupTypes (separated by ,). 1 is always optional

      if (this.chooseBestGroup) {
        switch (this.ratios) {
          case 'lll':
            optionalTypes = isV ? '1,2h' : '1,2v,3t,3b,3v';
            break;
          case 'llp':
            optionalTypes = isV ? '1,3r' : '1,2v,3t,3v';
            break;
          case 'lpl':
            optionalTypes = isV ? '1,2h' : '1,2v,3t,3b,3v';
            break;
          case 'pll':
            optionalTypes = isV ? '1,2h,3l' : '1,2v,3b,3v';
            break;

          case 'lpp':
            optionalTypes = isV ? '1,2h,3r,3h' : '1,2v,3t';
            break;
          case 'plp':
            optionalTypes = isV ? '1,2h,3l,3r,3h' : '1,2v';
            break;
          case 'ppl':
            optionalTypes = isV ? '1,2h,3l,3h' : '1,3b';
            break;
          case 'ppp':
            optionalTypes = isV ? '1,2h,3l,3r,3h' : '1,2h';
            break;
        }
      } else {
        if (this.items.length == 3 || forcedGroupSize == 3) {
          optionalTypes = isV ? '1,2h,3l,3r,3h' : '1,2v,3t,3b,3v';
        }
      }

      if (this.items.length == 2 || forcedGroupSize == 2) {
        optionalTypes = isV ? '1,2h' : '1,2v';
      }
      if (this.items.length == 1 || forcedGroupSize == 1) {
        optionalTypes = '1';
      }

      var groupTypes = optionalTypes.length > 0 ? optionalTypes.split(',') : [];

      //---------| Override with specifically defined group types
      if (this.groupTypes) {

        var groupTypesArr = this.groupTypes.split(',');

        if (groupTypesArr.length > 1) {
          _.remove(groupTypes, function (gt) {
            return groupTypesArr.indexOf(gt) < 0;
          });

          if (groupTypes.length == 0) {
            //there is no match between required group types and the optional ones - use
            groupTypes = ['1'];
          }
        } else {
          groupTypes = groupTypesArr;
        }
      }

      //---------| Calc collage density
      if (this.layoutsVersion > 1 && this.collageDensity) {
        //th new calculation of the collage amount

        var collageDensity = this.collageDensity;

        //use the collage amount to determine the optional groupsize
        var maxGroupType = parseInt(_.last(groupTypes));
        var optionalGroupSizes;
        if (maxGroupType == 3) optionalGroupSizes = [[1], [1, 2], [1, 2, 3], [2, 3], [3]];else if (maxGroupType == 2) {
          optionalGroupSizes = [[1], [1, 2], [2]];
        } else {
          optionalGroupSizes = [[1]];
        }
        var targetGroupsizes = optionalGroupSizes[Math.floor(collageDensity * (optionalGroupSizes.length - 1))];
        // seed += ((collageDensity * 1.5) - 0.75) * numOfOptions;

        _.remove(groupTypes, function (groupType) {
          return targetGroupsizes.indexOf(parseInt(groupType)) < 0;
        });

        if (groupTypes.length == 0) {
          groupTypes = ['1'];
        }
      }

      //---------| Calculate a random seed for the collage group type
      var numOfOptions = groupTypes.length;
      var seed;
      if (this.isVertical) {
        //vertical galleries random is not relevant (previous group is in another column)
        seed = _utils.utils.hashToInt(this.items[0].url) % numOfOptions;
        //console.log('Seed is: ' + seed + '. Found using hash: ' + this.items[0].hash);
      } else {
        seed = (this.inStripIdx + this.stripIdx) % numOfOptions;
      }

      if (this.layoutsVersion == 1 && this.collageAmount) {
        //backwards compatibility
        seed += (this.collageAmount - 0.5) * numOfOptions;
      }
      seed = Math.min(Math.max(0, seed), numOfOptions - 1);
      seed = Math.round(seed);

      //---------| Final group type to render according to:
      // - the number of options
      // - the collageAmount (if 0 - always renders 1 image, if 1 always renders the max amount)
      // - random seed (determined by the hash)
      this.type = groupTypes[seed] || '1';

      //---------| Render the images by the groupType
      var items = [];
      var item;
      var w = 0;
      var h = 0;

      switch (this.type) {
        case '1':

          item = this.safeGetItem(0);
          if (item) {
            item.pinToCorner('top-left');
            items.push(item);
            w = item.width;
            h = item.height;
          }

          break;

        case '2v':

          item = this.safeGetItem(0);
          if (item) {
            item.pinToCorner('top-left');
            items.push(item);
            w = item.width;
            h = item.height;
          }

          item = this.safeGetItem(1);
          if (item) {
            item.pinToCorner('bottom-left');
            item.resize(w / item.width);
            h += item.height;
            items.push(item);
          }

          break;

        case '2h':

          item = this.safeGetItem(0);
          if (item) {
            item.pinToCorner('top-left');
            item.innerOffset = [0, 0];
            items.push(item);
            w = item.width;
            h = item.height;
          }

          item = this.safeGetItem(1);
          if (item) {
            item.pinToCorner('top-right');
            item.innerOffset = [0, 0];
            item.resize(h / item.height);
            w += item.width;
            items.push(item);
          }

          break;

        case '3b':

          item = this.safeGetItem(0);
          if (item) {
            item.pinToCorner('top-left');
            items.push(item);
            w = item.width;
            h = item.height;
          }

          item = this.safeGetItem(1);
          if (item) {
            item.pinToCorner('top-right');
            item.resize(h / item.height);
            w += item.width;
            items.push(item);
          }

          item = this.safeGetItem(2);
          if (item) {
            item.pinToCorner('bottom-left');
            item.resize(w / item.width);
            h += item.height;
            items.push(item);
          }

          break;

        case '3t':

          item = this.safeGetItem(1);
          if (item) {
            item.pinToCorner('bottom-left');
            items.push(item);
            w = item.width;
            h = item.height;
          }

          item = this.safeGetItem(2);
          if (item) {
            item.pinToCorner('bottom-right');
            item.resize(h / item.height);
            w += item.width;
            items.push(item);
          }

          item = this.safeGetItem(0);
          if (item) {
            item.pinToCorner('top-left');
            item.resize(w / item.width);
            h += item.height;
            items = [item].concat(items);
          }

          break;

        case '3r':

          item = this.safeGetItem(0);
          if (item) {
            item.pinToCorner('top-left');
            items.push(item);
            w = item.width;
            h = item.height;
          }

          item = this.safeGetItem(1);
          if (item) {
            item.pinToCorner('bottom-left');
            item.resize(w / item.width);
            h += item.height;
            items.push(item);
          }

          item = this.safeGetItem(2);
          if (item) {
            item.pinToCorner('top-right');
            item.resize(h / item.height);
            w += item.width;
            items.push(item);
          }

          break;

        case '3l':

          item = this.safeGetItem(1);
          if (item) {
            item.pinToCorner('top-right');
            items.push(item);
            w = item.width;
            h = item.height;
          }

          item = this.safeGetItem(2);
          if (item) {
            item.pinToCorner('bottom-right');
            item.resize(w / item.width);
            h += item.height;
            items.push(item);
          }

          item = this.safeGetItem(0);
          if (item) {
            item.pinToCorner('top-left');
            item.resize(h / item.height);
            w += item.width;
            items = [item].concat(items);
          }

          break;

        case '3v':

          item = this.safeGetItem(0);
          if (item) {
            item.setPosition('relative');
            items.push(item);
            w = item.width;
            h = item.height;
          }

          item = this.safeGetItem(1);
          if (item) {
            item.setPosition('relative');
            item.resize(w / item.width);
            h += item.height;
            items.push(item);
          }

          item = this.safeGetItem(2);
          if (item) {
            item.setPosition('relative');
            item.resize(w / item.width);
            h += item.height;
            items.push(item);
          }

          break;

        case '3h':

          item = this.safeGetItem(0);
          if (item) {
            item.setPosition('relative');
            items.push(item);
            w = item.width;
            h = item.height;
          }

          item = this.safeGetItem(1);
          if (item) {
            item.setPosition('relative');
            item.resize(h / item.height);
            w += item.width;
            items.push(item);
          }

          item = this.safeGetItem(2);
          if (item) {
            item.setPosition('relative');
            item.resize(h / item.height);
            w += item.width;
            items.push(item);
          }

          break;
      }

      this.width = w;
      this.height = h;
      this.items = items;
      this.placed = true;
    }
  }, {
    key: 'resizeByHeight',
    value: function resizeByHeight(height) {
      var scale = height / this.height;
      this.width = this.ratio * height;
      this.height = height;
      for (var item, i = 0; item = this.items[i]; i++) {
        item.group = {
          top: this.top,
          left: this.left,
          width: this.width,
          height: this.height
        };
        item.offset = {
          bottom: item.offset.top + this.height,
          right: item.offset.left + this.width
        };
        item.resize(scale);
      }
    }
  }, {
    key: 'resizeByWidth',
    value: function resizeByWidth(width) {
      var scale = width / this.width;
      this.height = width / this.ratio;
      this.width = width;
      for (var item, i = 0; item = this.items[i]; i++) {
        item.group = {
          top: this.top,
          left: this.left,
          width: this.width,
          height: this.height
        };
        item.offset = {
          bottom: item.offset.top + this.height,
          right: item.offset.left + this.width
        };
        item.resize(scale);
      }
    }
  }, {
    key: 'setTop',
    value: function setTop(top) {
      this.top = top || 0;
      for (var item, i = 0; item = this.items[i]; i++) {
        item.offset = {
          top: top,
          bottom: top + this.height
        };
      }
    }
  }, {
    key: 'setLeft',
    value: function setLeft(left) {
      this.left = left || 0;
      this.right = left + this.width;
      for (var item, i = 0; item = this.items[i]; i++) {
        item.offset = {
          left: left,
          right: left + this.width
        };
      }
    }
  }, {
    key: 'isWithinMinItemSize',
    get: function get() {
      var _this = this;

      if (this.items.length == 0 || !this.placed) {
        return false;
      }
      if (this.items.length == 1) {
        return true;
      } else {
        return this.items.reduce(function (i, item) {
          var isInSize = Math.min(item.width, item.height) >= _this.minItemSize;
          return i && isInSize;
        }, true);
      }
    }
  }, {
    key: 'id',
    get: function get() {
      return 'g' + (this.items[0] || {}).id || this.idx;
    }
  }, {
    key: 'key',
    get: function get() {
      return 'group_' + this.id;
    }
  }, {
    key: 'totalHeight',
    get: function get() {
      return this.height + this.bottomInfoHeight;
    }
  }, {
    key: 'bottomInfoHeight',
    get: function get() {
      return this.getBottomInfoHeight();
    }
  }, {
    key: 'ratio',
    get: function get() {
      return this.width / this.height;
    }
  }, {
    key: 'bottom',
    get: function get() {
      return this.top + this.height;
    }
  }]);

  return GroupLayout;
}();

/*
 <img onLoad={() => this.setItemLoaded()} className={'image' + (this.state.loaded ? '' : '-preload')}
 src={this.props.resized_url}/>
 */

exports.default = GroupLayout;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Converts object to query string
 *
 * @param   {Object} data   a map to convert
 * @returns {String}        query string
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
function mapToQuery(data) {
  var res = [];

  for (var key in data) {
    if (data.hasOwnProperty(key)) {
      // eslint-disable-line
      res.push(key + '=' + encodeURIComponent(data[key]));
    }
  }

  return res.join('&');
}

/**
 * Generates a valid GUID
 *
 * @returns {String}  GUID
 */
function generateGuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
        v = c === 'x' ? r : r & 0x3 | 0x8; // eslint-disable-line
    return v.toString(16);
  });
}

exports.default = {
  mapToQuery: mapToQuery,
  generateGuid: generateGuid
};

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dataSource = __webpack_require__(279);

var _dataSource2 = _interopRequireDefault(_dataSource);

var _biAppVersionItem = __webpack_require__(280);

var _biAppVersionItem2 = _interopRequireDefault(_biAppVersionItem);

var _biLoadPhaseItem = __webpack_require__(281);

var _biLoadPhaseItem2 = _interopRequireDefault(_biLoadPhaseItem);

var _durationItem = __webpack_require__(259);

var _durationItem2 = _interopRequireDefault(_durationItem);

var _biErrorItem = __webpack_require__(263);

var _biErrorItem2 = _interopRequireDefault(_biErrorItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Base Logger
 *
 * Before adding new parameters to the reported events, please make sure the BI schema supports them:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72
 */
var BaseLogger = function () {
  function BaseLogger(appName, appVersion, reporter, _ref) {
    var sessionId = _ref.sessionId,
        errorHandlerToggle = _ref.errorHandlerToggle,
        disableAutoLoadFinish = _ref.disableAutoLoadFinish;

    _classCallCheck(this, BaseLogger);

    this.appName = appName;
    this.appVersion = appVersion;
    this.reporter = reporter;
    this.params = { sessionId: sessionId };
    this.errorHandlerToggle = errorHandlerToggle;
    this.disableAutoLoadFinish = disableAutoLoadFinish;

    this.dataSource = new _dataSource2.default({ appName: appName });

    if (errorHandlerToggle) {
      window.fedopsLoggerErrorHandler.subscribeListener(appName, this.reportError.bind(this));
    }
  }

  _createClass(BaseLogger, [{
    key: 'reportAppMetadata',
    value: function reportAppMetadata() {
      var dataSource = this.dataSource.clone().addItem({ v: this.appVersion }).addItem(new _biAppVersionItem2.default(this.sessionId));

      this._report(dataSource);
    }
  }, {
    key: 'reportError',
    value: function reportError(error, errorType, errorInfo) {
      var interactionName = void 0;

      if (!this._appLoadedCalled) {
        interactionName = '[APP LOAD]';
      } else {
        interactionName = Object.keys(this._outgoingInteractions)[0];
      }

      var dataSource = this.dataSource.clone().addItem({ interactionName: interactionName }).addItem({ errorType: errorType }).addItem({ errorInfo: errorInfo }).addItem(new _biErrorItem2.default(this.sessionId));

      // const stackTrace = error.stack;

      if (interactionName) {
        this._report(dataSource);
      }
    }
  }, {
    key: '_report',
    value: function _report(dataSource) {
      return this.reporter.report(dataSource.mergeItems());
    }
  }, {
    key: 'getAppName',
    value: function getAppName() {
      return this.appName;
    }
  }, {
    key: 'getAppVersion',
    value: function getAppVersion() {
      return this.appVersion;
    }
  }, {
    key: 'getReporter',
    value: function getReporter() {
      return this.reporter;
    }
  }, {
    key: 'getParam',
    value: function getParam(paramName) {
      return this.params[paramName];
    }
  }, {
    key: '_isDisableAutoLoadFinish',
    value: function _isDisableAutoLoadFinish() {
      return this.disableAutoLoadFinish;
    }
  }, {
    key: 'appLoadingPhase',


    /**
     * Custom phase (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/13)
     * Call this method to report custom phases during initial application load.
     *
     * @param {String} phaseName  phase name
     */
    value: function appLoadingPhase(phaseName) {
      var dataSource = this.dataSource.clone().addItem({ name: phaseName }).addItem(new _biLoadPhaseItem2.default(this.sessionId)).addItem(new _durationItem2.default());

      return this._report(dataSource);
    }
  }, {
    key: 'sessionId',
    get: function get() {
      return this.getParam('sessionId');
    }
  }]);

  return BaseLogger;
}();

exports.default = BaseLogger;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _time = __webpack_require__(260);

var _time2 = _interopRequireDefault(_time);

var _dataItem = __webpack_require__(237);

var _dataItem2 = _interopRequireDefault(_dataItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DurationDataItem = function (_DataItem) {
  _inherits(DurationDataItem, _DataItem);

  function DurationDataItem(appName) {
    _classCallCheck(this, DurationDataItem);

    var _this = _possibleConstructorReturn(this, (DurationDataItem.__proto__ || Object.getPrototypeOf(DurationDataItem)).call(this, {
      duration: Math.floor(_time2.default.appLoadTime(appName))
    }));

    _this.appName = appName;
    return _this;
  }

  _createClass(DurationDataItem, [{
    key: 'setFirstRequestDuration',
    value: function setFirstRequestDuration() {
      this.data.frd = Math.floor(_time2.default.firstRequestDuration(this.appName));
      return this;
    }
  }]);

  return DurationDataItem;
}(_dataItem2.default);

exports.default = DurationDataItem;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _appData = __webpack_require__(261);

var _appData2 = _interopRequireDefault(_appData);

var _performance = __webpack_require__(262);

var _performance2 = _interopRequireDefault(_performance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function startLoadTime(appName) {
  return _appData2.default.getStartLoadTime(appName) || 0;
}

function endLoadTime() {
  return _performance2.default.now();
}

/**
 * calculates the app load time
 */
exports.default = {
  appLoadTime: function appLoadTime(appName) {
    return endLoadTime() - startLoadTime(appName);
  },
  loadStarted: function loadStarted(appName) {
    _appData2.default.setStartLoadTime(appName, _performance2.default.now());
  },
  firstRequestDuration: function firstRequestDuration(appName) {
    return startLoadTime(appName);
  }
};

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * window.fedops.apps wrapper (for tests mainly)
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
function getAppData(appName) {
  return window.fedops.apps[appName];
}

exports.default = {
  init: function init(appName) {
    window.fedops.apps[appName] = window.fedops.apps[appName] || {};
  },
  getStartLoadTime: function getStartLoadTime(appName) {
    var appData = getAppData(appName);
    if (!appData) {
      return null;
    }
    return appData.startLoadTime;
  },
  setStartLoadTime: function setStartLoadTime(appName, startLoadTime) {
    return getAppData(appName).startLoadTime = startLoadTime;
  }
};

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * window.performance wrappers (for tests mainly)
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  getNavigation: function getNavigation() {
    return window && window.performance ? window.performance.navigation : {};
  },
  getTiming: function getTiming() {
    return window && window.performance ? window.performance.timing : {};
  },


  /**
   * Duration relative to navigation start (window.performance.timing.navigationStart)
   */
  now: function now() {
    return window && window.performance && window.performance.now ? window.performance.now() : new Date().getTime();
  },


  /**
   * Create a performance timestamp
   */
  mark: function mark(name) {
    window && window.performance && window.performance.mark && window.performance.mark(name);
  },


  /**
   * Record a performance measurement
   */
  measure: function measure(name, startMark, endMark) {
    window && window.performance && window.performance.measure && window.performance.measure(name, startMark, endMark);
  }
};

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EVID = undefined;

var _biBaseItem = __webpack_require__(138);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EVID = exports.EVID = 17;
/**
 * Represents the "load finished" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/11
 *
 * It should be used to monitor the initial application load.
 */

var BiErrorItem = function (_BiBaseDataItem) {
  _inherits(BiErrorItem, _BiBaseDataItem);

  function BiErrorItem(sessionId) {
    _classCallCheck(this, BiErrorItem);

    return _possibleConstructorReturn(this, (BiErrorItem.__proto__ || Object.getPrototypeOf(BiErrorItem)).call(this, EVID, sessionId));
  }

  return BiErrorItem;
}(_biBaseItem2.default);

exports.default = BiErrorItem;

/***/ }),
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = create;

var _loggerBuilder = __webpack_require__(274);

var _loggerBuilder2 = _interopRequireDefault(_loggerBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a logger instance, initialized with application name.
 *
 * @param {String} appName application name (will be used as an application identifier in the monitoring tool, e.g. Grafana)
 * @param {Boolean} isWidgetLogger
 */
function create(appName) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$baseUrl = _ref.baseUrl,
      baseUrl = _ref$baseUrl === undefined ? null : _ref$baseUrl,
      _ref$appId = _ref.appId,
      appId = _ref$appId === undefined ? null : _ref$appId,
      _ref$isWidgetLogger = _ref.isWidgetLogger,
      isWidgetLogger = _ref$isWidgetLogger === undefined ? false : _ref$isWidgetLogger,
      _ref$errorHandlerTogg = _ref.errorHandlerToggle,
      errorHandlerToggle = _ref$errorHandlerTogg === undefined ? false : _ref$errorHandlerTogg,
      _ref$disableAutoLoadF = _ref.disableAutoLoadFinish,
      disableAutoLoadFinish = _ref$disableAutoLoadF === undefined ? false : _ref$disableAutoLoadF,
      _ref$swallowException = _ref.swallowExceptions,
      swallowExceptions = _ref$swallowException === undefined ? false : _ref$swallowException,
      _ref$interactionTimeo = _ref.interactionTimeout,
      interactionTimeout = _ref$interactionTimeo === undefined ? null : _ref$interactionTimeo,
      _ref$timeoutHook = _ref.timeoutHook,
      timeoutHook = _ref$timeoutHook === undefined ? null : _ref$timeoutHook,
      _ref$startHook = _ref.startHook,
      startHook = _ref$startHook === undefined ? null : _ref$startHook,
      _ref$endHook = _ref.endHook,
      endHook = _ref$endHook === undefined ? null : _ref$endHook;

  var appVersion = typeof window !== 'undefined' ? "2.15.0-SNAPSHOT" : null;

  return new _loggerBuilder2.default().setAppName(appName).setAppVersion(appVersion).setBaseUrl(baseUrl).setAppId(appId).setErrorHandlerToggle(errorHandlerToggle).setSwallowExceptions(swallowExceptions).setWidgetLogger(isWidgetLogger).setInteractionTimeout(interactionTimeout).setTimeoutHook(timeoutHook).setStartHook(startHook).setEndHook(endHook).setDisableAutoLoadFinish(disableAutoLoadFinish).build();
}

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.setFactory = setFactory;

var _tools = __webpack_require__(257);

var _tools2 = _interopRequireDefault(_tools);

var _storage = __webpack_require__(275);

var _storage2 = _interopRequireDefault(_storage);

var _reporter = __webpack_require__(276);

var _reporter2 = _interopRequireDefault(_reporter);

var _loggerInstance = __webpack_require__(278);

var _loggerInstance2 = _interopRequireDefault(_loggerInstance);

var _widgetLoggerInstance = __webpack_require__(285);

var _widgetLoggerInstance2 = _interopRequireDefault(_widgetLoggerInstance);

var _errorHandler = __webpack_require__(287);

var _errorHandler2 = _interopRequireDefault(_errorHandler);

var _conf = __webpack_require__(288);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getSessionId() {
  var res = typeof window !== 'undefined' && window.fedops && window.fedops.sessionId;
  res = res || _storage2.default.getItem(_conf.SESSION_ID_STORAGE_KEY);
  res = res || _tools2.default.generateGuid();

  _storage2.default.setItem(_conf.SESSION_ID_STORAGE_KEY, res);

  return res;
}

var ReporterFactory = _reporter2.default; // good for tests

function setFactory(factory) {
  ReporterFactory = factory;
}
/**
 * Builds a logger instance.
 */

var LoggerBuilder = function () {
  function LoggerBuilder() {
    _classCallCheck(this, LoggerBuilder);
  }

  _createClass(LoggerBuilder, [{
    key: 'setAppName',
    value: function setAppName(name) {
      this.appName = name;
      return this;
    }
  }, {
    key: 'setAppVersion',
    value: function setAppVersion(version) {
      this.appVersion = version;
      return this;
    }
  }, {
    key: 'setErrorHandlerToggle',
    value: function setErrorHandlerToggle(toggle) {
      this.errorHandlerToggle = toggle;
      return this;
    }
  }, {
    key: 'setSwallowExceptions',
    value: function setSwallowExceptions(swallow) {
      this.swallowExceptions = swallow;
      return this;
    }
  }, {
    key: 'setAppId',
    value: function setAppId(appId) {
      this.appId = appId;
      return this;
    }
  }, {
    key: 'setBaseUrl',
    value: function setBaseUrl(url) {
      this.baseUrl = url;
      return this;
    }
  }, {
    key: 'setWidgetLogger',
    value: function setWidgetLogger(isWidgetLogger) {
      this.isWidgetLogger = isWidgetLogger;
      return this;
    }
  }, {
    key: 'setInteractionTimeout',
    value: function setInteractionTimeout(interactionTimeout) {
      this.interactionTimeout = interactionTimeout;
      return this;
    }
  }, {
    key: 'setTimeoutHook',
    value: function setTimeoutHook(timeoutHook) {
      this.timeoutHook = timeoutHook;
      return this;
    }
  }, {
    key: 'setStartHook',
    value: function setStartHook(startHook) {
      this.startHook = startHook;
      return this;
    }
  }, {
    key: 'setEndHook',
    value: function setEndHook(endHook) {
      this.endHook = endHook;
      return this;
    }
  }, {
    key: 'setDisableAutoLoadFinish',
    value: function setDisableAutoLoadFinish(disableAutoLoadFinish) {
      this.disableAutoLoadFinish = disableAutoLoadFinish;
      return this;
    }
  }, {
    key: 'build',
    value: function build() {
      if (!this.appName) {
        return null;
      }

      if (!this.appVersion) {
        this.appVersion = _conf.DEFAULT_APP_VERSION;
      }

      var reporter = new ReporterFactory(this.baseUrl || _conf.BI_BASE_URL);
      var errorHandlerToggle = this.errorHandlerToggle;
      var swallowExceptions = this.swallowExceptions;
      var interactionTimeout = this.interactionTimeout;
      var timeoutHook = this.timeoutHook;
      var startHook = this.startHook;
      var endHook = this.endHook;
      var disableAutoLoadFinish = this.disableAutoLoadFinish;

      if (errorHandlerToggle) {
        window.fedopsLoggerErrorHandler = window.fedopsLoggerErrorHandler || new _errorHandler2.default({ swallowExceptions: swallowExceptions });
      }

      var logger = null;

      if (this.isWidgetLogger) {
        logger = new _widgetLoggerInstance2.default(this.appName, this.appVersion, reporter, { sessionId: getSessionId(), errorHandlerToggle: errorHandlerToggle, swallowExceptions: swallowExceptions, disableAutoLoadFinish: disableAutoLoadFinish });
      } else {
        logger = new _loggerInstance2.default(this.appName, this.appVersion, reporter, { sessionId: getSessionId(), errorHandlerToggle: errorHandlerToggle, swallowExceptions: swallowExceptions, disableAutoLoadFinish: disableAutoLoadFinish, interactionTimeout: interactionTimeout, timeoutHook: timeoutHook, startHook: startHook, endHook: endHook });
      }

      return logger;
    }
  }]);

  return LoggerBuilder;
}();

exports.default = LoggerBuilder;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Local storage wrapper (for tests mainly)
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  getItem: function getItem(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {}
  },
  setItem: function setItem(key, value) {
    try {
      return window.localStorage.setItem(key, value);
    } catch (e) {}
  }
};

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _pixel = __webpack_require__(277);

var _pixel2 = _interopRequireDefault(_pixel);

var _tools = __webpack_require__(257);

var _tools2 = _interopRequireDefault(_tools);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Reporter = function () {
  function Reporter(baseUrl) {
    _classCallCheck(this, Reporter);

    this.baseUrl = baseUrl;
  }

  _createClass(Reporter, [{
    key: 'getBaseUrl',
    value: function getBaseUrl() {
      return this.baseUrl;
    }
  }, {
    key: 'report',
    value: function report(data) {
      if (!data) {
        return null;
      }

      return _pixel2.default.fetch(this.baseUrl + '?' + _tools2.default.mapToQuery(data));
    }
  }]);

  return Reporter;
}();

exports.default = Reporter;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Simple GET request wrapper (for tests mainly)
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  fetch: function fetch(url) {
    return new window.Image().src = url;
  }
};

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _baseLogger = __webpack_require__(258);

var _baseLogger2 = _interopRequireDefault(_baseLogger);

var _biLoadFinishItem = __webpack_require__(282);

var _biLoadFinishItem2 = _interopRequireDefault(_biLoadFinishItem);

var _durationItem = __webpack_require__(259);

var _durationItem2 = _interopRequireDefault(_durationItem);

var _biInteractionStartItem = __webpack_require__(283);

var _biInteractionStartItem2 = _interopRequireDefault(_biInteractionStartItem);

var _biInteractionEndItem = __webpack_require__(284);

var _biInteractionEndItem2 = _interopRequireDefault(_biInteractionEndItem);

var _biErrorItem = __webpack_require__(263);

var _biErrorItem2 = _interopRequireDefault(_biErrorItem);

var _performance = __webpack_require__(262);

var _performance2 = _interopRequireDefault(_performance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var callHook = function callHook(hook, hookArgs) {
  if (hook) {
    return hook(hookArgs);
  }
};

/**
 * Logs application load phases.
 *
 * Before adding new parameters to the reported events, please make sure the BI schema supports them:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72
 */

var LoggerInstance = function (_BaseLogger) {
  _inherits(LoggerInstance, _BaseLogger);

  function LoggerInstance(appName, appVersion, reporter, _ref) {
    var sessionId = _ref.sessionId,
        errorHandlerToggle = _ref.errorHandlerToggle,
        disableAutoLoadFinish = _ref.disableAutoLoadFinish,
        interactionTimeout = _ref.interactionTimeout,
        timeoutHook = _ref.timeoutHook,
        startHook = _ref.startHook,
        endHook = _ref.endHook;

    _classCallCheck(this, LoggerInstance);

    var _this = _possibleConstructorReturn(this, (LoggerInstance.__proto__ || Object.getPrototypeOf(LoggerInstance)).call(this, appName, appVersion, reporter, { sessionId: sessionId, errorHandlerToggle: errorHandlerToggle, disableAutoLoadFinish: disableAutoLoadFinish }));

    _this._outgoingInteractions = {};
    _this.interactionTimeout = interactionTimeout;
    _this.timeoutHook = timeoutHook;
    _this.startHook = startHook;
    _this.endHook = endHook;
    return _this;
  }

  /**
   * Final phase (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/11)
   * Call this method when your application finishes loading and after all custom phases.
   */


  _createClass(LoggerInstance, [{
    key: 'appLoaded',
    value: function appLoaded() {
      if (this._appLoadedCalled) {
        return;
      }

      if (window && window.fedops && typeof window.fedops.clearLoadTimeout === 'function') {
        window.fedops.clearLoadTimeout();
      }

      var dataSource = this.dataSource.clone().addItem(new _biLoadFinishItem2.default(this.sessionId)).addItem(new _durationItem2.default(this.appName).setFirstRequestDuration());

      this._appLoadedCalled = true;
      _performance2.default.mark('[fedops] app-loaded');
      return this._report(dataSource);
    }

    /**
     * Custom interaction start (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/15)
     *
     * @param {String} interactionName  interaction name
     */

  }, {
    key: 'interactionStarted',
    value: function interactionStarted(interactionName) {
      var _this2 = this;

      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          interactionTimeout = _ref2.interactionTimeout,
          startHook = _ref2.startHook,
          timeoutHook = _ref2.timeoutHook;

      _performance2.default.mark(interactionName + ' started');
      var scheduleTimeoutEvent = function scheduleTimeoutEvent() {
        if (interactionTimeout || _this2.interactionTimeout) {
          return setTimeout(function () {
            var dataSource = _this2.dataSource.clone().addItem({ interactionName: interactionName }).addItem({ errorType: 'timeout' }).addItem(new _biErrorItem2.default(_this2.sessionId));

            _this2._report(dataSource);
            callHook(timeoutHook || _this2.timeoutHook, { name: interactionName, timeout: interactionTimeout || _this2.interactionTimeout });
          }, interactionTimeout || _this2.interactionTimeout);
        }
      };
      var dataSource = this.dataSource.clone().addItem({ name: interactionName }).addItem(new _biInteractionStartItem2.default(this.sessionId));

      this._outgoingInteractions[interactionName] = {
        timestamp: _performance2.default.now(),
        timeout: interactionTimeout || this.interactionTimeout
      };
      this._report(dataSource);
      callHook(startHook || this.startHook, { name: interactionName });

      var timeoutId = scheduleTimeoutEvent();
      return {
        timeoutId: timeoutId
      };
    }

    /**
     * Custom interaction end (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/16)
     *
     * @param {String} interactionName  interaction name
     */

  }, {
    key: 'interactionEnded',
    value: function interactionEnded(interactionName) {
      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          timeoutId = _ref3.timeoutId,
          endHook = _ref3.endHook;

      _performance2.default.mark(interactionName + ' ended');
      _performance2.default.measure(interactionName + ' duration', interactionName + ' started', interactionName + ' ended');

      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      var duration = this._outgoingInteractions[interactionName] ? Math.floor(_performance2.default.now() - this._outgoingInteractions[interactionName].timestamp) : '';

      callHook(endHook || this.endHook, {
        name: interactionName,
        duration: duration,
        timeout: this._outgoingInteractions[interactionName] && this._outgoingInteractions[interactionName].timeout
      });

      var dataSource = this.dataSource.clone().addItem({ name: interactionName }).addItem({ duration: duration }).addItem(new _biInteractionEndItem2.default(this.sessionId));

      delete this._outgoingInteractions[interactionName];

      this._report(dataSource);
    }
  }, {
    key: 'isDisableAutoLoadFinish',
    value: function isDisableAutoLoadFinish() {
      return this._isDisableAutoLoadFinish();
    }
  }]);

  return LoggerInstance;
}(_baseLogger2.default);

// vim: set ts=2 sw=2 tw=80 et :


exports.default = LoggerInstance;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dataItem = __webpack_require__(237);

var _dataItem2 = _interopRequireDefault(_dataItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Data accumulator
 */
var DataSource = function () {
  function DataSource() {
    var _this = this;

    var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    _classCallCheck(this, DataSource);

    this.items = [];

    if (item) {
      (typeof item.length === 'undefined' ? [item] : item).forEach(function (item) {
        return _this.addItem(item);
      });
    }
  }

  /**
   * Creates a new DataSource instance and clones internal state.
   *
   * @returns {DataSource}
   */


  _createClass(DataSource, [{
    key: 'clone',
    value: function clone() {
      return new DataSource(this.items.slice());
    }

    /**
     * Adds a new item.
     *
     * @param {Object | DataItem} item
     *
     * @return {DataSource} self
     */

  }, {
    key: 'addItem',
    value: function addItem(item) {
      this.items.push(item instanceof _dataItem2.default ? item : new _dataItem2.default(item));

      return this;
    }

    /**
     * Merges all added items into one plain object.
     *
     * @returns {Object}
     */

  }, {
    key: 'mergeItems',
    value: function mergeItems() {
      var res = {};

      for (var i = 0; i < this.items.length; i++) {
        var item = this.items[i];

        if (!item.isActive()) {
          res = null;
          break;
        }

        var data = item.export();

        for (var key in data) {
          if (data.hasOwnProperty(key)) {
            // eslint-disable-line
            res[key] = data[key];
          }
        }
      }

      return res;
    }
  }]);

  return DataSource;
}();

exports.default = DataSource;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _biBaseItem = __webpack_require__(138);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Represents the "app version" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/18
 *
 * It should indicate an app of a certain version has run
 */
var BiAppVersionDataItem = function (_BiBaseDataItem) {
  _inherits(BiAppVersionDataItem, _BiBaseDataItem);

  function BiAppVersionDataItem(sessionId) {
    _classCallCheck(this, BiAppVersionDataItem);

    return _possibleConstructorReturn(this, (BiAppVersionDataItem.__proto__ || Object.getPrototypeOf(BiAppVersionDataItem)).call(this, 18, sessionId));
  }

  return BiAppVersionDataItem;
}(_biBaseItem2.default);

exports.default = BiAppVersionDataItem;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _biBaseItem = __webpack_require__(138);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Represents the "load phase" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/13
 *
 * It should be used to monitor custom application load phases.
 */
var BiLoadPhaseDataItem = function (_BiBaseDataItem) {
  _inherits(BiLoadPhaseDataItem, _BiBaseDataItem);

  function BiLoadPhaseDataItem(sessionId) {
    _classCallCheck(this, BiLoadPhaseDataItem);

    return _possibleConstructorReturn(this, (BiLoadPhaseDataItem.__proto__ || Object.getPrototypeOf(BiLoadPhaseDataItem)).call(this, 13, sessionId));
  }

  return BiLoadPhaseDataItem;
}(_biBaseItem2.default);

exports.default = BiLoadPhaseDataItem;

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _biBaseItem = __webpack_require__(138);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Represents the "load finished" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/11
 *
 * It should be used to monitor the initial application load.
 */
var BiLoadFinishDataItem = function (_BiBaseDataItem) {
  _inherits(BiLoadFinishDataItem, _BiBaseDataItem);

  function BiLoadFinishDataItem(sessionId) {
    _classCallCheck(this, BiLoadFinishDataItem);

    return _possibleConstructorReturn(this, (BiLoadFinishDataItem.__proto__ || Object.getPrototypeOf(BiLoadFinishDataItem)).call(this, 11, sessionId));
  }

  return BiLoadFinishDataItem;
}(_biBaseItem2.default);

exports.default = BiLoadFinishDataItem;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INTERACTION_START_EVID = undefined;

var _biBaseItem = __webpack_require__(138);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var INTERACTION_START_EVID = exports.INTERACTION_START_EVID = 15;
/**
 * Represents the "load finished" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/11
 *
 * It should be used to monitor the initial application load.
 */

var BiInteractionStartDataItem = function (_BiBaseDataItem) {
  _inherits(BiInteractionStartDataItem, _BiBaseDataItem);

  function BiInteractionStartDataItem(sessionId) {
    _classCallCheck(this, BiInteractionStartDataItem);

    return _possibleConstructorReturn(this, (BiInteractionStartDataItem.__proto__ || Object.getPrototypeOf(BiInteractionStartDataItem)).call(this, INTERACTION_START_EVID, sessionId));
  }

  return BiInteractionStartDataItem;
}(_biBaseItem2.default);

exports.default = BiInteractionStartDataItem;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INTERACTION_END_EVID = undefined;

var _biBaseItem = __webpack_require__(138);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var INTERACTION_END_EVID = exports.INTERACTION_END_EVID = 16;

/**
 * Represents the "load finished" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/11
 *
 * It should be used to monitor the initial application load.
 */

var BiInteractionEndDataItem = function (_BiBaseDataItem) {
  _inherits(BiInteractionEndDataItem, _BiBaseDataItem);

  function BiInteractionEndDataItem(sessionId) {
    _classCallCheck(this, BiInteractionEndDataItem);

    return _possibleConstructorReturn(this, (BiInteractionEndDataItem.__proto__ || Object.getPrototypeOf(BiInteractionEndDataItem)).call(this, INTERACTION_END_EVID, sessionId));
  }

  return BiInteractionEndDataItem;
}(_biBaseItem2.default);

exports.default = BiInteractionEndDataItem;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _baseLogger = __webpack_require__(258);

var _baseLogger2 = _interopRequireDefault(_baseLogger);

var _biLoadStartItem = __webpack_require__(286);

var _biLoadStartItem2 = _interopRequireDefault(_biLoadStartItem);

var _time = __webpack_require__(260);

var _time2 = _interopRequireDefault(_time);

var _appData = __webpack_require__(261);

var _appData2 = _interopRequireDefault(_appData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Logs application load phases.
 *
 * Before adding new parameters to the reported events, please make sure the BI schema supports them:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72
 */
var WidgetLoggerInstance = function (_BaseLogger) {
  _inherits(WidgetLoggerInstance, _BaseLogger);

  function WidgetLoggerInstance(appName, appVersion, reporter, _ref) {
    var sessionId = _ref.sessionId,
        disableAutoLoadFinish = _ref.disableAutoLoadFinish;

    _classCallCheck(this, WidgetLoggerInstance);

    var _this = _possibleConstructorReturn(this, (WidgetLoggerInstance.__proto__ || Object.getPrototypeOf(WidgetLoggerInstance)).call(this, appName, appVersion, reporter, { sessionId: sessionId, disableAutoLoadFinish: disableAutoLoadFinish }));

    _appData2.default.init(_this.appName);
    return _this;
  }

  /**
   * Manual report for widget load start (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/14)
   * Call this method at the earliest point possible when your widget starts loading
   */


  _createClass(WidgetLoggerInstance, [{
    key: 'appLoadStarted',
    value: function appLoadStarted() {

      _time2.default.loadStarted(this.appName);

      var dataSource = this.dataSource.clone().addItem(new _biLoadStartItem2.default(this.sessionId));

      return this._report(dataSource);
    }
  }, {
    key: 'isDisableAutoLoadFinish',
    value: function isDisableAutoLoadFinish() {
      return this._isDisableAutoLoadFinish();
    }
  }]);

  return WidgetLoggerInstance;
}(_baseLogger2.default);

exports.default = WidgetLoggerInstance;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _biBaseItem = __webpack_require__(138);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Represents the "load started" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/14
 *
 * It should be used to monitor the initial application load.
 */
var BiLoadStartDataItem = function (_BiBaseDataItem) {
  _inherits(BiLoadStartDataItem, _BiBaseDataItem);

  function BiLoadStartDataItem(sessionId) {
    _classCallCheck(this, BiLoadStartDataItem);

    return _possibleConstructorReturn(this, (BiLoadStartDataItem.__proto__ || Object.getPrototypeOf(BiLoadStartDataItem)).call(this, 14, sessionId));
  }

  return BiLoadStartDataItem;
}(_biBaseItem2.default);

exports.default = BiLoadStartDataItem;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*eslint-disable camelcase*/

var _window = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var ErrorHandler = function () {
  function ErrorHandler(_ref) {
    var swallowExceptions = _ref.swallowExceptions;

    _classCallCheck(this, ErrorHandler);

    this.swallowExceptions = swallowExceptions;
    this.listeners = {};

    //*************************************************************************
    // We are wrapping the browser's native methods with try/catch for several
    // reasons:
    //
    // 1. It provides us with a more elaborate stack trace.
    //    Currently we ignore the stack trace due to BI limitations, but it can
    //    be very useful for future support.
    //
    // 2. Makes it easier to classify the error types.
    //
    // 3. Some browsers don't support a global error handler.
    //*************************************************************************

    this.instrumentAjax();
    this.instrumentSetTimeout();
    this.instrumentSetInterval();
    this.instrumentAddEventListener();
    this.instrumentFetch();
    this.instrumentPromise();

    //Sometimes catches one of the instruments above? Need to verify...
    this.instrumentGloballyUnhandledError();
  }

  _createClass(ErrorHandler, [{
    key: 'subscribeListener',
    value: function subscribeListener(appName, cb) {
      this.listeners[appName] = cb;
    }
  }, {
    key: 'removeListener',
    value: function removeListener(appName) {
      delete this.listeners[appName];
    }
  }, {
    key: 'instrumentAjax',
    value: function instrumentAjax() {
      var self = this;

      if ('XMLHttpRequest' in _window) {
        var xhrproto = XMLHttpRequest.prototype;

        this._wrap(xhrproto, 'open', function (orig) {
          return function (method, url) {
            this.__fedops_xhr = {
              method: method,
              url: url,
              status_code: null
            };

            return orig.apply(this, arguments);
          };
        }, 'xhr');

        this._wrap(xhrproto, 'send', function (orig) {
          return function () {
            var xhr = this;

            function saveStatusCode() {
              if (xhr.readyState === 1 || xhr.readyState === 4) {
                try {
                  xhr.__fedops_xhr.status_code = xhr.status;
                } catch (e) {}

                if (self._isErrorStatusCode(xhr.__fedops_xhr.status_code)) {
                  self._reportError(xhr.__fedops_xhr, 'xhr', xhr.__fedops_xhr.status_code);
                }
              }
            }

            self._wrap(this, 'onload', function (orig) {
              return function () {
                orig && orig.apply(this, arguments);
              };
            }, 'xhr');

            self._wrap(this, 'onerror', function (orig) {
              return function () {
                orig && orig.apply(this, arguments);
              };
            }, 'xhr');

            self._wrap(this, 'onprogress', function (orig) {
              return function () {
                orig && orig.apply(this, arguments);
              };
            }, 'xhr');

            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
              self._wrap(xhr, 'onreadystatechange', function (orig) {
                return function () {
                  saveStatusCode();
                  return orig.apply(this, arguments);
                };
              });
            } else {
              xhr.onreadystatechange = saveStatusCode;
            }

            return orig.apply(this, arguments);
          };
        }, 'xhr');
      }
    }
  }, {
    key: 'instrumentSetTimeout',
    value: function instrumentSetTimeout() {
      var self = this;

      this._wrap(_window, 'setTimeout', function (globalSetTimeout) {
        return function (fn) {
          for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            rest[_key - 1] = arguments[_key];
          }

          return globalSetTimeout.call.apply(globalSetTimeout, [this, self._wrapCallback(fn, 'setTimeout')].concat(rest));
        };
      });
    }
  }, {
    key: 'instrumentSetInterval',
    value: function instrumentSetInterval() {
      var self = this;

      this._wrap(_window, 'setInterval', function (globalSetInterval) {
        return function (fn) {
          for (var _len2 = arguments.length, rest = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            rest[_key2 - 1] = arguments[_key2];
          }

          return globalSetInterval.call.apply(globalSetInterval, [this, self._wrapCallback(fn, 'setInterval')].concat(rest));
        };
      });
    }
  }, {
    key: 'instrumentAddEventListener',
    value: function instrumentAddEventListener() {
      var self = this;

      function instrumentEventTarget(name) {
        var origTarget = _window[name] && _window[name].prototype;

        if (origTarget && Object.prototype.hasOwnProperty.call(origTarget, 'addEventListener')) {
          self._wrap(origTarget, 'addEventListener', function (orig) {
            return function (eventName, fn, capture, secure) {
              var wrapped = self._wrapCallback(fn, 'addEventListener');

              if (fn) {
                fn.__fedopsWrapper__ = wrapped;
              }

              return orig.call(this, eventName, wrapped, capture, secure);
            };
          });

          self._wrap(origTarget, 'removeEventListener', function (orig) {
            return function (eventName, fn, capture, secure) {
              fn = fn && (fn.__fedopsWrapper__ || fn);
              return orig.call(this, eventName, fn, capture, secure);
            };
          });
        }
      }

      var eventTargets = ['EventTarget', 'Window', 'Node', 'ApplicationCache', 'AudioTrackList', 'ChannelMergerNode', 'CryptoOperation', 'EventSource', 'FileReader', 'HTMLUnknownElement', 'IDBDatabase', 'IDBRequest', 'IDBTransaction', 'KeyOperation', 'MediaController', 'MessagePort', 'ModalWindow', 'Notification', 'SVGElementInstance', 'Screen', 'TextTrack', 'TextTrackCue', 'TextTrackList', 'WebSocket', 'WebSocketWorker', 'Worker', 'XMLHttpRequest', 'XMLHttpRequestEventTarget', 'XMLHttpRequestUpload'];
      eventTargets.forEach(function (name) {
        return instrumentEventTarget(name);
      });
    }
  }, {
    key: 'instrumentRequestAnimationFrame',
    value: function instrumentRequestAnimationFrame() {}
  }, {
    key: 'instrumentFetch',
    value: function instrumentFetch() {
      var self = this;

      this._wrap(_window, 'fetch', function (globalFetch) {
        return function (url, fetchOptions) {
          return globalFetch.apply(this, arguments).then(function (response) {
            var statusCode = response.status;

            if (self._isErrorStatusCode(statusCode)) {
              var requestInfo = {
                url: url,
                method: fetchOptions ? fetchOptions.method : 'GET',
                status_code: statusCode
              };

              self._reportError(requestInfo, 'fetch', statusCode);
            }

            return response;
          });
        };
      });
    }
  }, {
    key: 'instrumentPromise',
    value: function instrumentPromise() {
      var self = this;

      _window.addEventListener('unhandledrejection', function (err) {
        self._reportError(err, 'promise');
      });
    }
  }, {
    key: 'instrumentGloballyUnhandledError',
    value: function instrumentGloballyUnhandledError() {
      var _this = this;

      _window.addEventListener('error', function (err) {
        _this._reportError(err, 'windowOnError');
      });
    }
  }, {
    key: 'instrumentHistory',
    value: function instrumentHistory() {}
  }, {
    key: '_wrap',
    value: function _wrap(obj, fnName, replaced, errorType) {
      var self = this;
      var orig = obj[fnName];
      var r = replaced(orig);

      var wrapped = function wrapped() {
        try {
          return r.apply(this, arguments);
        } catch (err) {
          self._reportError(err, errorType);

          if (!self.swallowExceptions) {
            throw err;
          }
        }
      };

      obj[fnName] = wrapped;
    }
  }, {
    key: '_wrapCallback',
    value: function _wrapCallback(fn, errorType) {
      var self = this;

      return function () {
        try {
          return fn.apply(this, arguments);
        } catch (err) {
          self._reportError(err, errorType);

          if (!self.swallowExceptions) {
            throw err;
          }
        }
      };
    }
  }, {
    key: '_reportError',
    value: function _reportError(err, errorType, errorInfo) {
      var self = this;

      var actualError = err && (err.error || err);

      if (!actualError.__fedopsHandledError__) {
        var appNames = Object.keys(this.listeners);

        appNames.forEach(function (appName) {
          self.listeners[appName](actualError, errorType, errorInfo);
        });

        actualError.__fedopsHandledError__ = true;
      }
    }
  }, {
    key: '_isErrorStatusCode',
    value: function _isErrorStatusCode(statusCode) {
      return statusCode >= 400 || statusCode === 0;
    }
  }]);

  return ErrorHandler;
}();

/*eslint-enable camelcase*/


exports.default = ErrorHandler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BI_BASE_URL = exports.BI_BASE_URL = 'https://frog.wix.com/fed';
var SESSION_ID_STORAGE_KEY = exports.SESSION_ID_STORAGE_KEY = 'fedops.logger.sessionId';
var DEFAULT_APP_VERSION = exports.DEFAULT_APP_VERSION = '0.0.0';

/***/ }),
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(29);

var _reactRedux = __webpack_require__(97);

var _redux = __webpack_require__(62);

var _reduxThunk = __webpack_require__(160);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reduxLogger = __webpack_require__(161);

var _reduxLogger2 = _interopRequireDefault(_reduxLogger);

var _index = __webpack_require__(146);

var _index2 = _interopRequireDefault(_index);

var _galleryContainer = __webpack_require__(240);

var _galleryContainer2 = _interopRequireDefault(_galleryContainer);

var _itemLayout = __webpack_require__(110);

var _itemLayout2 = _interopRequireDefault(_itemLayout);

var _utils = __webpack_require__(2);

var _fedopsLogger = __webpack_require__(273);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

_utils.logger.initBiLoadedEventListener('gallery');

var ProGalleryServices = function () {
  function ProGalleryServices() {
    var _this = this;

    _classCallCheck(this, ProGalleryServices);

    _utils.utils.timingMeasure('ProGallery start', 'navigationStart');
    try {
      window.fedopsLogger = (0, _fedopsLogger.create)('pro-gallery-statics');
      fedopsLogger.appLoaded();
    } catch (e) {
      console.error('fedopsLogger: apploaded failed', e);
    }
    this.gallerySrcTypes = { //gallery source types
      sampleImages: 'sampleImages',
      itemsFromWixCode: 'itemsFromWixCode',
      prerenderedGallery: 'prerenderedGallery',
      albumSetFromBuilder: 'albumSetFromBuilder',
      manuallySetImages: 'manuallySetImages'
    };

    var middlewares = [_reduxThunk2.default];

    var shouldLogRedux = false;
    if (_utils.utils.isDev() && shouldLogRedux) {
      var loggerMiddleware = (0, _reduxLogger2.default)({ diff: true });
      middlewares.push(loggerMiddleware);
    }

    this.store = (0, _redux.createStore)(_index2.default, _redux.applyMiddleware.apply(undefined, middlewares));

    if (_utils.utils.isDev()) {
      console.log('initial store state', this.store.getState());
    }

    var unsubscribe = this.store.subscribe(function () {
      if (_utils.utils.isDev()) {
        console.log('store update', _this.store.getState());
      }
    });

    $(document).ready(function () {
      _this.content = document.getElementById('content');

      //this.galleryScrollEvent = document.createEvent('CustomEvent');  // MUST be 'CustomEvent'
      //this.galleryScrollEvent.initCustomEvent('images_changed', false, false, null);
      _this.populateGalleryData();

      _this.renderGallery();
    });
  }

  _createClass(ProGalleryServices, [{
    key: 'updateServerMappingIfNeeded',
    value: function updateServerMappingIfNeeded(setId, isDuringPublish, callback) {
      if (!isDuringPublish) {
        callback();
        return;
      }
      if (setId === 'fake_set') {
        callback();
        return;
      }

      // if (window.petri['specs.NewProvisionFlow'] === 'true') {
      //   return;
      // }

      if (this.mappingUpdatedInstanceId !== Wix.Utils.getInstanceId() && (_utils.utils.getViewModeFromCache() === 'editor' || _utils.utils.getViewModeFromCache() === 'preview') && Wix.Utils.getDemoMode() === false) {

        this.mappingUpdatedInstanceId = Wix.Utils.getInstanceId();
        //URL - http://progallery.wix.com/api/v1/albums/map-set-id
        //Body (json) {"instanceId" : "8e3502cb-25ee-4d7f-b8c3-96034fe36911", "compId" : "compId2", "setId": "75cda6bb-c060-4381-930a-beb9a22c027a"}
        var mappingData = { instanceId: Wix.Utils.getInstanceId(), compId: Wix.Utils.getCompId(), setId: setId };
        $.ajax({
          type: 'POST',
          url: '/api/v1/albums/map-set-id',
          data: JSON.stringify(mappingData),
          success: function success(res) {
            console.log('Success in mapping gallery to set', mappingData);
            callback();
          },
          error: function error(err) {
            console.error('Failed to map gallery to set', err);
            callback();
          },
          contentType: 'application/json'
        });
      }
    }
  }, {
    key: 'getImagesFromBuilder',
    value: function getImagesFromBuilder() {
      if (_utils.utils.isDev()) {
        console.log('Gallery Services - getImagesFromBuilder');
      }

      if (window.document.domain != 'wix.com') {
        try {
          //noinspection JSAnnotator
          window.document.domain = 'wix.com';
        } catch (e) {
          console.warn('Failed to set wix.com domain');
        }
      }

      //replace the current set of images on the window
      try {
        var activeAlbum = window.parent.parent['activeAlbum'];
        var isDuringPublish = _.get(activeAlbum, 'serverStatus.duringUpdate');
        var albumSet = activeAlbum.getSetByGalleryId(Wix.Utils.getCompId()); //getSetByGalleryId is in albums code
        if (albumSet.id) {
          this.updateServerMappingIfNeeded(albumSet.id, isDuringPublish, function () {

            try {
              albumSet.mapSetIdCallback();
            } catch (e) {
              console.log("couldn't call mapSetIdCallback", e);
            }
          });
          return albumSet.getSetJson(); ////getSetJson is in albums code
        } else {
          return false;
        }
      } catch (e) {
        return false;
      }
    }
  }, {
    key: 'populateGalleryData',
    value: function populateGalleryData() {
      try {
        //replace the current set of images on the window

        var galleryData = void 0;
        var galleryDataSrcName = void 0;

        var albumSetFromBuilder = this.getImagesFromBuilder();
        if (window.manuallySetImages) {
          galleryData = window.manuallySetImages;
          this.galleryDataSrc = this.gallerySrcTypes.manuallySetImages;
          galleryDataSrcName = 'manuallySetImages';
        } else if (window['itemsFromWixCode']) {
          galleryData = { photos: window['itemsFromWixCode'] };
          this.galleryDataSrc = this.gallerySrcTypes.albumSetFromBuilder;
          galleryDataSrcName = 'itemsFromWixCode';
        } else if (albumSetFromBuilder) {
          galleryData = albumSetFromBuilder;
          this.galleryDataSrc = this.gallerySrcTypes.albumSetFromBuilder;
          galleryDataSrcName = 'albumSetFromBuilder';
        } else if (window['prerenderedGallery']) {
          galleryData = { photos: window['prerenderedGallery']['items'] };
          this.galleryDataSrc = this.gallerySrcTypes.prerenderedGallery;
          galleryDataSrcName = 'prerenderedGallery';
        } else {
          //no prerender gallery
          if (_utils.utils.isSite() && !_utils.utils.isDev()) {
            console.error('prerendered gallery is missing');
            _utils.logger.trackBi(_utils.logger.biEvents.pro_gallery_error, { errorType: 'prerenderedGalleryMissing' });
          }
          galleryData = _utils.utils.isDev() ? window['sampleImages'] : window['emptyImages'];
          this.galleryDataSrc = this.gallerySrcTypes.sampleImages;
          galleryDataSrcName = 'sampleImages/emptyImages';
        }

        if (_utils.utils.isDev()) {
          console.log('Populating gallery data from: ' + galleryDataSrcName);
        }

        var _galleryData = window['galleryData'] = galleryData;
        var _itemsCount = this.galleryDataSrc == this.gallerySrcTypes.prerenderedGallery ? window['prerenderedGallery']['totalItemsCount'] : this.galleryData && this.galleryData.photos.length;

        if (this.galleryData) {} else {
          this.galleryData = _galleryData;
          this.itemsCount = _itemsCount;
        }
      } catch (e) {
        console.error('Could not populate gallery data', e);
      }
    }
  }, {
    key: 'itemsToDto',
    value: function itemsToDto(items) {
      return _.map(items, function (item) {
        item.createdBy = 'itemsToDto';
        return new _itemLayout2.default({ dto: item }).dto;
      });
    }
  }, {
    key: 'getItemsDto',
    value: function getItemsDto() {
      var items = this.galleryData && this.galleryData.photos;
      items = items || [];
      return this.itemsToDto(items);
    }
  }, {
    key: 'getAllItemsDto',
    value: function getAllItemsDto(callback) {
      this.getAllItemsFromServer(callback);
      return this.itemsToDto(this.galleryData && this.galleryData.photos);
    }
  }, {
    key: 'getAllItemsFromServer',
    value: function getAllItemsFromServer(callback) {
      var _this2 = this;

      var fetchedItems = this.galleryData && this.galleryData.photos;

      if (_.isUndefined(this.itemsCountToFetch) || this.itemsCountToFetch === false) {
        this.itemsCountToFetch = this.itemsCountToFetch || this.itemsCount;
      }

      var fetchCount = Math.min(1000, this.itemsCountToFetch - fetchedItems.length);
      if (fetchCount <= 0) {
        //end
        this.itemsCountToFetch = false;
        callback(this.itemsToDto(this.galleryData.photos));
      } else {
        this.getItemsFromServer(fetchedItems.length, fetchedItems.length + fetchCount).done(function (res) {
          _this2.addImages(res.items);
          _this2.getAllItemsFromServer(callback);
        }).fail(function (err) {
          console.error('failed to get items from server', err && err.message);
        });
      }
    }
  }, {
    key: 'getItemsFromServer',
    value: function getItemsFromServer(from, to) {
      var storeParameter = '';
      if (_utils.utils.isStoreGallery()) {
        storeParameter = '&isStore=true';
      }
      return $.ajax({
        url: window.infiniteScrollUrl + 'from/' + from + '/to/' + to + '?instance=' + window.instance + storeParameter,
        xhrFields: {
          withCredentials: true
        } });
    }
  }, {
    key: 'isDisplayingDefaultImages',
    value: function isDisplayingDefaultImages() {

      try {
        var manuallySetImages = window.manuallySetImages;
        var albumSetFromBuilder = this.getImagesFromBuilder();
        var galleryFromVm = window['prerenderedGallery'] ? { photos: window['prerenderedGallery']['items'] } : false;

        return !(manuallySetImages || galleryFromVm || albumSetFromBuilder);
      } catch (e) {
        console.error('Error checking if displaying default images', e);
        return false;
      }
    }
  }, {
    key: 'setImages',
    value: function setImages(images) {

      if (_utils.utils.isDev()) {
        console.log('Gallery Services - setImages', images);
      }

      //update selected images in the current set of images on the window
      if ((typeof images === 'undefined' ? 'undefined' : _typeof(images)) != 'object') {
        console.error('Trying to use addImages with illegal images', images);
      }
      if (!(images.length > 0)) {
        images = [images];
      }
      if (!this.galleryData) {
        this.populateGalleryData();
      }

      try {
        this.galleryData.photos = window.manuallySetImages = images;
        this.itemsCount = this.galleryData.photos.length;
        this.galleryDataSrc = this.gallerySrcTypes.manuallySetImages;
        window.infiniteScrollUrl = ''; //diasble infinite scroll when setting images manually
      } catch (e) {
        console.error("Cannot set new images", e, images, window);
      }

      // if (this.galleryView) {
      //   this.galleryView.renderTrigger = this.galleryView.renderTriggers.ITEMS; //this is a patch, we need to find a better way to control setState without predefined data
      //   this.galleryView.setState({items: this.galleryData.photos});
      // }
      this.renderGallery();
    }
  }, {
    key: 'setAllImagesRemoved',
    value: function setAllImagesRemoved() {

      if (_utils.utils.isDev()) {
        console.log('Gallery Services - setAllImagesRemoved');
      }

      try {
        this.galleryData.photos = window.manuallySetImages = [];
        this.itemsCount = 0;
        this.galleryDataSrc = this.gallerySrcTypes.manuallySetImages;
      } catch (e) {
        console.error("Cannot set new images", e, window);
      }
      // if (this.galleryView) {
      //   this.galleryView.renderTrigger = this.galleryView.renderTriggers.ITEMS; //this is a patch, we need to find a better way to control setState without predefined data
      //   this.galleryView.totalItemsCount = this.itemsCount;
      //   this.galleryView.setState({items: this.galleryData.photos});
      // }
      this.renderGallery();
    }
  }, {
    key: 'addImages',
    value: function addImages(images, shouldAddToStart) {
      //update selected images in the current set of images on the window

      if (_utils.utils.isDev()) {
        console.log('Gallery Services - addImages', images, shouldAddToStart);
      }

      if ((typeof images === 'undefined' ? 'undefined' : _typeof(images)) != 'object') {
        console.error('Trying to use addImages with illegal images', images);
      }
      if (!this.galleryData) {
        this.populateGalleryData();
      }
      if (!(images.length > 0)) {
        images = [images];
      }

      var firstArray = this.galleryData.photos;
      var secondArray = images;

      if (shouldAddToStart) {
        firstArray = images;
        secondArray = this.galleryData.photos;
      }

      try {
        this.setImages(firstArray.concat(secondArray));
      } catch (e) {
        console.error("Cannot add new images", e, images, window);
      }
    }
  }, {
    key: 'reRenderGalleryForAlbums',
    value: function reRenderGalleryForAlbums() {

      if (_utils.utils.isDev()) {
        console.log('Gallery Services - reRenderGalleryForAlbums');
      }

      this.populateGalleryData();
      // if (this.galleryView) {
      //   this.galleryView.renderTrigger = this.galleryView.renderTriggers.ITEMS; //this is a patch, we need to find a better way to control setState without predefined data
      //   this.galleryView.setState({items: this.galleryData.photos});
      // }
      this.renderGallery();
      //window.dispatchEvent(this.galleryScrollEvent);
    }
  }, {
    key: 'renderGallery',
    value: function renderGallery() {
      if (this.content) {
        if (_utils.utils.isDev()) {
          console.log('gallery Services renderGallery called', this.galleryData, this.itemsCount, this.store);
        }

        var layout = {
          width: window.innerWidth,
          height: window.innerHeight
        };

        (0, _reactDom.render)(_react2.default.createElement(
          _reactRedux.Provider,
          { store: this.store },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_galleryContainer2.default, {
              at: Date.now() //forces the galleryContainer to reRender even if the itemsCount did not chage
              , items: this.galleryData['photos'],
              galleryDataSrc: this.galleryDataSrc,
              totalItemsCount: this.itemsCount,
              store: this.store,
              layout: layout
            })
          )
        ), this.content);
      } else {
        //in karma, this file is loaded but there is no document
        //console.error('Missing content element for react');
      }
    }
  }]);

  return ProGalleryServices;
}();

//this should not be accessed by anyone from the outside - everything should be done via post message


var proGalleryServices = window['proGalleryServices'] = new ProGalleryServices();

window.addEventListener('message', function (e) {
  if (e && e.data === 'albumSetImagesUpdated') {

    console.log('message albumSetImagesUpdated arrived for gallery ', e);
    proGalleryServices.reRenderGalleryForAlbums();
  }
});

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// gallery.bundle.min.js